webpackJsonp([0],Array(22).concat([
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveCategory = exports.resolveNestedCategories = exports.resolveCategoriesEvents = exports.resolveCategories = undefined;

var _lodash = __webpack_require__(2);

var resolveCategories = exports.resolveCategories = function resolveCategories() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return ['categoriesService', function (categoriesService) {
    return categoriesService.findAll(page, perpage, deleted).then(function (list) {
      return list;
    });
  }];
};

var resolveCategoriesEvents = exports.resolveCategoriesEvents = function resolveCategoriesEvents() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return ['categoriesService', function (categoriesService) {
    return categoriesService.findRelated().then(function (list) {
      return list;
    });
  }];
};

var resolveNestedCategories = exports.resolveNestedCategories = function resolveNestedCategories() {
  var flatten = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  return ['categoriesService', function (categoriesService) {
    return categoriesService.hierarchyFind(flatten).then(function (list) {
      return list;
    });
  }];
};

var resolveCategory = exports.resolveCategory = function resolveCategory() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'category';

  return ['$stateParams', 'categoriesService', function ($stateParams, categoriesService) {
    return $stateParams[param] && $stateParams[param] > 0 ? categoriesService.findById($stateParams[param]) : {};
  }];
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _externalScript = __webpack_require__(452);

var _externalScript2 = _interopRequireDefault(_externalScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coreModule = angular.module('journey-ui.shared.core', []).factory('externalScriptService', _externalScript2.default);

exports.default = coreModule.name;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyDetailsController = function () {
    function PropertyDetailsController($state, integrationApiService, propertiesService, messageService, access) {
        _classCallCheck(this, PropertyDetailsController);

        this.$state = $state;
        this.integrationApiService = integrationApiService;
        this.propertiesService = propertiesService;
        this.messageService = messageService;
        this.access = access;
    }

    _createClass(PropertyDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.details = this.property[this.type] || {};

            this.formatDate('expected_go_live');
            this.formatDate('go_live');

            if (this.property.integration && this.property.integration.import_run && !this.logs) {
                var type = void 0;
                switch (this.property.property_type) {
                    case 'premier':
                        type = 'Core';
                        break;

                    case 'concept':
                        type = 'Concept';
                        break;
                }

                this.integrationApiService.getImportLogs(this.property.id, type).then(function (response) {
                    _this.logs = response;
                });
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this2 = this;

            this.formatDate('expected_go_live');
            this.formatDate('go_live');

            var preSubmission = (0, _lodash.cloneDeep)(this.details);

            return this.propertiesService.updateDetails(this.details, this.property.id, this.type).then(function () {
                _this2.messageService.success('The ' + _this2.type + ' details for <strong>' + _this2.property.name + '</strong> were successfully updated!');
                _this2.formTab = 'property';
                _this2.property[_this2.type] = preSubmission;
                _this2.messageService.push();
                _this2.messageService.autoClear();
            }).catch(function (error) {
                _this2.messageService.failure('The ' + _this2.type + ' details for <strong>' + _this2.property.name + '</strong> could not be successfully updated: ' + error.statusText);
                _this2.messageService.push();
            });
        }
    }, {
        key: 'formatDate',
        value: function formatDate(detailsField) {
            if (this.details[detailsField]) {
                if (!_moment2.default.isMoment(this.details[detailsField])) {
                    this.details[detailsField] = (0, _moment2.default)(this.details[detailsField]);
                    return;
                }

                this.details[detailsField] = this.details[detailsField].format('YYYY-MM-DD');
                return;
            }

            this.details[detailsField] = '';
        }
    }]);

    return PropertyDetailsController;
}();

PropertyDetailsController.$inject = ['$state', 'integrationApiService', 'propertiesService', 'messageService', 'access'];

exports.default = PropertyDetailsController;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveTreatments = exports.resolveTreatments = function resolveTreatments() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    return ['$stateParams', 'treatmentsService', function ($stateParams, treatmentsService) {
        if (!$stateParams.filtertext) {
            return treatmentsService.findAll(page, perpage, deleted).then(function (list) {
                return list;
            });
        }

        return treatmentsService.search('name', $stateParams.filtertext, page).then(function (list) {
            return list;
        });
    }];
};

var resolveTreatment = exports.resolveTreatment = function resolveTreatment() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'treatment';

    return ['$stateParams', 'treatmentsService', function ($stateParams, treatmentsService) {
        return $stateParams[param] && $stateParams[param] > 0 ? treatmentsService.findById($stateParams[param]) : {};
    }];
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveDays = exports.resolveDays = function resolveDays() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    return ['$stateParams', 'dayService', function ($stateParams, dayService) {
        if (!$stateParams.filtertext) {
            return dayService.findAll(page, perpage, deleted).then(function (list) {
                return list;
            });
        }

        return dayService.search('name', $stateParams.filtertext, page).then(function (list) {
            return list;
        });
    }];
};

var resolveDay = exports.resolveDay = function resolveDay() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'day';

    return ['$stateParams', 'dayService', function ($stateParams, dayService) {
        return $stateParams[param] && $stateParams[param] > 0 ? dayService.findById($stateParams[param]) : {};
    }];
};

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(342);

var _app = __webpack_require__(343);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.element(document).ready(function () {
    angular.bootstrap(document, [_app2.default.name], {
        strictDi: true
    });
});

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vendor = __webpack_require__(344);

var _modules = __webpack_require__(391);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var app = angular.module('spabooker', [].concat(_toConsumableArray(_vendor.vendor), _toConsumableArray(_modules.modules))).config(['$locationProvider', '$urlRouterProvider', function ($locationProvider, $urlRouterProvider) {
  $locationProvider.html5Mode(true);
  $urlRouterProvider.otherwise(function ($injector) {
    var $state = $injector.get('$state');
    $state.go('404', {}, { location: false });
  });
}]).config(['uiSelectConfig', function (uiSelectConfig) {
  uiSelectConfig.theme = 'select2';
}]).factory('$exceptionHandler', ['$window', '$log', function ($window, $log) {
  return function sentryException(exception, cause) {
    if ($window.Sentry && (typeof exception === 'string' || typeof exception === 'array') && !(exception.includes('Unauthenticated') || exception.includes('Unauthorized'))) {
      $window.Sentry.captureException(exception);
    }

    $log.warn(exception, cause);
  };
}]).config(['momentPickerProvider', function (momentPickerProvider) {
  momentPickerProvider.options({
    minutesStep: 30,
    minutesFormat: 'HH:mm:[00]'
  });
}]).run(['$rootScope', '$location', function ($rootScope, $location) {
  if (typeof FS !== 'undefined') {
    var profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      FS.identify(profile.sub, {
        displayName: profile.name,
        role: profile['https://www.lobby.travel/role']
      });
    }
  }

  $rootScope.$on('$locationChangeSuccess', function () {
    if (typeof analytics !== 'undefined') {
      analytics.page();
    }

    var Url = $location.url();
    var urlParts = Url.split('/').splice(1);
    var titleParts = [];

    if (Url.includes('#')) {
      titleParts = [];
    } else if (urlParts[0] === '') {
      titleParts.push('Dashboard');
    } else {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = urlParts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var titlePart = _step.value;

          titleParts.push(titlePart.charAt(0).toUpperCase() + titlePart.slice(1));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    $rootScope.$watch('currentProperty', function () {
      $rootScope.pageTitle = titleParts.join(' > ');
      if ($rootScope.currentProperty) {
        $rootScope.pageTitle += ' (' + $rootScope.currentProperty.name + ')';
      }
    });
  });
}]);

exports.default = app;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendor = undefined;

__webpack_require__(47);

__webpack_require__(346);

__webpack_require__(348);

__webpack_require__(350);

__webpack_require__(352);

__webpack_require__(373);

__webpack_require__(374);

__webpack_require__(74);

__webpack_require__(376);

__webpack_require__(381);

__webpack_require__(383);

__webpack_require__(385);

__webpack_require__(386);

__webpack_require__(388);

__webpack_require__(389);

var vendor = exports.vendor = ['ui.router', 'ngAnimate', 'ngSanitize', 'ngMessages', 'mm.foundation', 'ngFileUpload', 'angular-jwt', 'auth0.auth0', 'ui.select', 'ngPassword', 'moment-picker', 'uiSwitch'];

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modules = undefined;

var _availability = __webpack_require__(392);

var _availability2 = _interopRequireDefault(_availability);

var _base = __webpack_require__(405);

var _base2 = _interopRequireDefault(_base);

var _guest = __webpack_require__(434);

var _guest2 = _interopRequireDefault(_guest);

var _item = __webpack_require__(437);

var _item2 = _interopRequireDefault(_item);

var _checkout = __webpack_require__(440);

var _checkout2 = _interopRequireDefault(_checkout);

var _core = __webpack_require__(324);

var _core2 = _interopRequireDefault(_core);

var _payment = __webpack_require__(454);

var _payment2 = _interopRequireDefault(_payment);

var _base3 = __webpack_require__(477);

var _base4 = _interopRequireDefault(_base3);

var _dashboard = __webpack_require__(560);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _auth = __webpack_require__(579);

var _auth2 = _interopRequireDefault(_auth);

var _user = __webpack_require__(589);

var _user2 = _interopRequireDefault(_user);

var _property = __webpack_require__(609);

var _property2 = _interopRequireDefault(_property);

var _treatment = __webpack_require__(673);

var _treatment2 = _interopRequireDefault(_treatment);

var _days = __webpack_require__(691);

var _days2 = _interopRequireDefault(_days);

var _event = __webpack_require__(709);

var _event2 = _interopRequireDefault(_event);

var _integration = __webpack_require__(771);

var _integration2 = _interopRequireDefault(_integration);

var _period = __webpack_require__(779);

var _period2 = _interopRequireDefault(_period);

var _pageContent = __webpack_require__(795);

var _pageContent2 = _interopRequireDefault(_pageContent);

var _upgrade = __webpack_require__(828);

var _upgrade2 = _interopRequireDefault(_upgrade);

var _availability3 = __webpack_require__(833);

var _availability4 = _interopRequireDefault(_availability3);

var _offer = __webpack_require__(857);

var _offer2 = _interopRequireDefault(_offer);

var _order = __webpack_require__(873);

var _order2 = _interopRequireDefault(_order);

var _reports = __webpack_require__(913);

var _reports2 = _interopRequireDefault(_reports);

var _discounts = __webpack_require__(919);

var _discounts2 = _interopRequireDefault(_discounts);

var _basket = __webpack_require__(938);

var _basket2 = _interopRequireDefault(_basket);

var _orderCreation = __webpack_require__(971);

var _orderCreation2 = _interopRequireDefault(_orderCreation);

var _guests = __webpack_require__(978);

var _guests2 = _interopRequireDefault(_guests);

var _checkout3 = __webpack_require__(986);

var _checkout4 = _interopRequireDefault(_checkout3);

var _activity = __webpack_require__(989);

var _activity2 = _interopRequireDefault(_activity);

var _auth3 = __webpack_require__(1002);

var _auth4 = _interopRequireDefault(_auth3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modules = exports.modules = [_availability2.default, _base2.default, _guest2.default, _item2.default, _checkout2.default, _core2.default, _payment2.default, _base4.default, _dashboard2.default, _auth2.default, _user2.default, _property2.default, _treatment2.default, _days2.default, _event2.default, _period2.default, _pageContent2.default, _upgrade2.default, _availability4.default, _offer2.default, _order2.default, _reports2.default, _discounts2.default, _integration2.default, _basket2.default, _orderCreation2.default, _checkout4.default, _guests2.default, _activity2.default, _auth4.default];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _preferredTime = __webpack_require__(393);

var _preferredTime2 = _interopRequireDefault(_preferredTime);

var _staffPicker = __webpack_require__(394);

var _staffPicker2 = _interopRequireDefault(_staffPicker);

var _preferredTime3 = __webpack_require__(395);

var _preferredTime4 = _interopRequireDefault(_preferredTime3);

var _staffPicker3 = __webpack_require__(397);

var _staffPicker4 = _interopRequireDefault(_staffPicker3);

var _availability = __webpack_require__(399);

var _availability2 = _interopRequireDefault(_availability);

var _availabilityCache = __webpack_require__(400);

var _availabilityCache2 = _interopRequireDefault(_availabilityCache);

var _startTime = __webpack_require__(402);

var _startTime2 = _interopRequireDefault(_startTime);

var _quantity = __webpack_require__(403);

var _quantity2 = _interopRequireDefault(_quantity);

var _suggestions = __webpack_require__(404);

var _suggestions2 = _interopRequireDefault(_suggestions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedAvailabilityModule = angular.module('spabooker.shared.availability', []).component('preferredTime', _preferredTime4.default).component('staffPicker', _staffPicker4.default).controller('preferredTimeController', _preferredTime2.default).controller('staffPickerController', _staffPicker2.default).factory('availabilityService', _availability2.default).factory('availabilityCacheService', _availabilityCache2.default).factory('startTimeService', _startTime2.default).factory('quantityService', _quantity2.default).factory('suggestionsService', _suggestions2.default);

exports.default = sharedAvailabilityModule.name;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PreferredTimeController = function () {
  function PreferredTimeController(basket, availabilityService, itemService, loadingService, configService) {
    _classCallCheck(this, PreferredTimeController);

    this.basket = basket;
    this.availabilityService = availabilityService;
    this.itemService = itemService;
    this.loadingService = loadingService;
    this.configService = configService;
  }

  _createClass(PreferredTimeController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.item = this.itemService.getItem();

      var integration = this.configService.get('integration');

      if (integration) {
        this.requestAttendees = this.configService.get('integration').type === 'concept';

        if (this.requestAttendees) {
          var minimum_guests = this.item.minimum_guests || 1;
          this.guestArray = [1 * minimum_guests, 2 * minimum_guests, 3 * minimum_guests];
        }
      }

      return this.basket.promise.then(function () {
        _this.isSuggestedEvent();
      });
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      return this.loadingService.isLoading('times') || !this.loadingService.isLoading('times') && !this.hasTimes();
    }
  }, {
    key: 'hasTimes',
    value: function hasTimes() {
      if (this.availabilityService.hasSingleTimes()) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isDisabled',
    value: function isDisabled() {
      var times = this.availabilityService.getSingleTimes();
      return !times || times && times.length < 2;
    }
  }, {
    key: 'displayTime',
    value: function displayTime() {
      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!startTime) {
        return null;
      }

      return startTime.substring(0, 5);
    }
  }, {
    key: 'isSuggestedEvent',
    value: function isSuggestedEvent() {
      if (this.basket.contents.suggested_event && this.item.type === this.basket.contents.suggested_event.type && this.item.id === parseInt(this.basket.contents.suggested_event.id)) {
        this.item.suggested = true;
        return true;
      }
    }
  }, {
    key: 'selectTime',
    value: function selectTime(selectedTime) {
      var numberOfGuests = this.numberOfGuests || undefined;

      if (selectedTime.price) {
        this.item.price = selectedTime.price;
        this.item.original = selectedTime.original_price;
        this.item.end_time = selectedTime.end;
        this.itemService.setItem(this.item);
      }
      this.resetStaff();
      this.getQuantity({ numberOfGuests: numberOfGuests });
    }
  }, {
    key: 'updateTimes',
    value: function updateTimes(numberOfGuests) {
      if (this.item && this.item.price && this.numberOfGuests) {
        this.resetStaff();
        this.getQuantity({ numberOfGuests: this.numberOfGuests });
      }
    }
  }]);

  return PreferredTimeController;
}();

PreferredTimeController.$inject = ['basket', 'availabilityService', 'itemService', 'loadingService', 'configService'];

exports.default = PreferredTimeController;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StaffPickerController = function () {
  function StaffPickerController() {
    _classCallCheck(this, StaffPickerController);
  }

  _createClass(StaffPickerController, [{
    key: "displayStaff",
    value: function displayStaff() {
      if (this.staff.length > 0) {

        if (!this.guest.staff) {
          this.guest.staff = this.staff.find(function (staff) {
            return !staff.disabled;
          });
          this.guest.staff.disabled = true;
        }
      }

      return this.staff;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.canDisable && this.staff.length <= 1;
    }
  }, {
    key: "updateStaff",
    value: function updateStaff(oldStaff, newStaff) {
      if (oldStaff) {
        var staff = this.staff.find(function (staff) {
          return staff.id === oldStaff.id;
        });
        if (staff) {
          delete staff.disabled;
        }
      }

      if (newStaff.id) {
        newStaff.disabled = true;
      }
    }
  }]);

  return StaffPickerController;
}();

StaffPickerController.$inject = [];

exports.default = StaffPickerController;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'availability': '<',
        'item': '<',
        'getQuantity': '&',
        'resetStaff': '&'
    },
    controller: 'preferredTimeController',
    template: __webpack_require__(396)
};

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = "<section class=\"c-guest-count / grid-x\" ng-if=$ctrl.requestAttendees> <div class=\"c-guest-counter / cell medium-auto\" ng-repeat=\"guestNumber in $ctrl.guestArray\"> <input type=radio id=\"guests-{{ guestNumber }}\" name=numberOfGuests value=\"{{ guestNumber }}\" ng-model=$ctrl.numberOfGuests ng-change=$ctrl.updateTimes() /> <label for=\"guests-{{ guestNumber }}\"> {{ guestNumber }} {{ guestNumber === 1 ? 'Guest' : 'Guests' }} </label> </div> </section> <div ng-if=!$ctrl.isSuggestedEvent() ng-show=\"!$ctrl.requestAttendees || $ctrl.numberOfGuests\"> <div class=\"c-form__field c-form__field--select / c-time-picker__container\"> <div ng-show=!$ctrl.isLoading()> <ui-select class=\"c-form__select / c-time-picker\" ng-model=$ctrl.item.preferred_time ng-disabled=$ctrl.isDisabled() input-id=preferredTime on-select=$ctrl.selectTime($item)> <ui-select-match placeholder=\"- Please select a time -\"> <div class=\"c-time-picker__values c-time-picker__values--selected\"> <div class=c-time-picker__time ng-bind-html=$ctrl.displayTime($ctrl.item.preferred_time)></div> <span> <s ng-if=\"$ctrl.item.original !== $ctrl.item.price\"> <money class=c-time-picker__price amount=\"$ctrl.item.original * $ctrl.item.minimum_guests\" decorate=true></money> </s> <money class=c-time-picker__price amount=\"$ctrl.item.price * $ctrl.item.minimum_guests\" decorate=true></money> </span> </div> </ui-select-match> <ui-select-choices repeat=\"time.time as time in $ctrl.availabilityService.getSingleTimes() track by $index\"> <div class=c-time-picker__values> <div class=c-time-picker__time ng-bind-html=$ctrl.displayTime(time.time)></div> <span> <s ng-if=\"time.original_price !== time.price\"> <money class=c-time-picker__price amount=\"time.original_price * $ctrl.item.minimum_guests\" decorate=true></money> </s> <money class=c-time-picker__price amount=\"time.price * $ctrl.item.minimum_guests\" decorate=true></money> </span> </div> </ui-select-choices> </ui-select> <label class=\"c-form__label t-text--secondary\" for=preferredTime ng-if=$ctrl.isDisabled()> Your arrival time will be... </label> <label class=\"c-form__label t-text--secondary\" for=preferredTime ng-if=!$ctrl.isDisabled()> Select your arrival time... </label> </div> <spinner ng-if=$ctrl.isLoading() class=c-time-picker__spinner></spinner>  </div> </div>";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guest: '=',
        staff: '<',
        appendToBody: '<',
        canDisable: '<'
    },
    controller: 'staffPickerController',
    template: __webpack_require__(398)
};

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-staff-select__container / c-form__field c-form__field--select\"> <ui-select class=\"c-form__select c-staff-select\" ng-model=$ctrl.guest.staff ng-change=\"$ctrl.updateStaff({{$ctrl.guest.staff || 0}}, $ctrl.guest.staff)\" ng-disabled=$ctrl.isDisabled() append-to-body=$ctrl.appendToBody> <ui-select-match> {{ $select.selected.label }} </ui-select-match> <ui-select-choices repeat=\"staff in $ctrl.displayStaff() | filter: { label: $select.search } track by staff.id\" ui-disable-choice=staff.disabled> <span ng-bind=staff.label></span> </ui-select-choices> </ui-select> <label class=\"c-form__label t-text--secondary\">With...</label> </div> ";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [function () {
    var _this = this;

    this.availability = [];
    this.singleDays = [];
    this.singleTimes = [];

    return {
        resetAvailability: function resetAvailability() {
            _this.availability = [];
        },
        getAvailability: function getAvailability() {
            return _this.availability;
        },
        setAvailability: function setAvailability(availability) {
            _this.availability = availability;
        },
        hasAvailability: function hasAvailability() {
            return !!_this.availability.length;
        },
        resetSingleDays: function resetSingleDays() {
            _this.singleDays = [];
        },
        getSingleDays: function getSingleDays() {
            return _this.singleDays;
        },
        setSingleDays: function setSingleDays(days) {
            _this.singleDays = days;
        },
        hasSingleDays: function hasSingleDays() {
            return !!_this.singleDays.length;
        },
        resetSingleTimes: function resetSingleTimes() {
            _this.singleTimes = [];
        },
        getSingleTimes: function getSingleTimes() {
            if (_this.singleTimes === false) {
                return [];
            }
            return _this.singleTimes;
        },
        setSingleTimes: function setSingleTimes(times) {
            _this.singleTimes = times;
        },
        hasSingleTimes: function hasSingleTimes() {
            if (_this.singleTimes === false) {
                return true;
            }
            return !!_this.singleTimes.length;
        }
    };
}];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [function () {
    var cachedAvailability = {};

    var datesCached = function datesCached(eventType, eventId, fromDate, toDate) {
        var cache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

        var cached = checkCache(eventType, eventId, fromDate);

        if (!cached) {
            return [];
        }

        cache.push(cached);

        if (fromDate === toDate) {
            return cache;
        }

        fromDate = (0, _moment2.default)(fromDate).add(1, 'day').format('YYYY-MM-DD');

        return datesCached(eventType, eventId, fromDate, toDate, cache);
    };

    var updateCache = function updateCache(eventType, eventId, response) {
        response.forEach(function (availability) {
            cachedAvailability[eventType] = cachedAvailability[eventType] || {};
            cachedAvailability[eventType][eventId] = cachedAvailability[eventType][eventId] || {};

            cachedAvailability[eventType][eventId][availability.date] = availability;
        });

        return cachedAvailability;
    };

    var uncacheDate = function uncacheDate(eventType, eventId, date) {
        if (cachedAvailability[eventType] && cachedAvailability[eventType][eventId]) {
            delete cachedAvailability[eventType][eventId][date];
            return cachedAvailability[eventType][eventId];
        }
    };

    var checkCache = function checkCache(eventType, eventId, date) {
        if (cachedAvailability[eventType] && cachedAvailability[eventType][eventId] && cachedAvailability[eventType][eventId][date]) {
            return cachedAvailability[eventType][eventId][date];
        }
    };

    return {
        updateCache: updateCache,
        datesCached: datesCached,
        uncacheDate: uncacheDate
    };
}];

/***/ }),
/* 401 */,
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

exports.default = ['startTimeApiService', 'availabilityService', 'loadingService', function (startTimeApiService, availabilityService, loadingService) {
  var getStartTimes = function getStartTimes(item) {
    return startTimeApiService.find(item.date, item.type || item.type_name, item.id).then(function (response) {
      availabilityService.setSingleTimes(response);

      loadingService.stopLoading('times');
      return response;
    });
  };

  var getStartTimesSetPreferred = function getStartTimesSetPreferred(item) {
    return getStartTimes(item).then(function () {
      return setPreferred(item);
    });
  };

  var standardiseTime = function standardiseTime(time) {
    if (time.split(':').length === 2) {
      return time + ':00';
    }

    return time;
  };

  var displayTime = function displayTime(time) {
    return time.substring(0, 5);
  };

  var setPreferred = function setPreferred(item) {
    if (!availabilityService.hasSingleTimes()) {
      item.preferred_time = undefined;
      return item;
    }

    var times = availabilityService.getSingleTimes();
    if (times.length === 1) {
      var startTime = (0, _lodash.head)(times);
      item.preferred_time = '' + startTime.time;
      item.end_time = '' + startTime.end;
      item.original = startTime.original_price || item.original;
      item.price = startTime.price || item.price;

      return item;
    }

    if (item.preferred_time && !times.some(function (startTime) {
      if (standardiseTime(item.preferred_time) === startTime.time) {
        item.original = startTime.original_price || item.original;
        item.price = startTime.price || item.price;
        return true;
      }
    })) {
      item.preferred_time = undefined;
    }

    return item;
  };

  return {
    getStartTimes: getStartTimes,
    getStartTimesSetPreferred: getStartTimesSetPreferred,
    standardiseTime: standardiseTime,
    displayTime: displayTime
  };
}];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = ['quantityApiService', 'availabilityApiService', 'configService', function (quantityApiService, availabilityApiService, configService) {
  var getQuantity = function getQuantity(item) {
    var numberOfGuests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    return quantityApiService.find(item.date, item.type || item.type_name, item.id, item.preferred_time, numberOfGuests).then(function (response) {
      return response;
    });
  };

  var getContentsQuantity = function getContentsQuantity(date, startTime, endTime, packageContents) {
    var promises = [];
    var dateFrom = date + 'T' + startTime;
    var dateTo = date + 'T' + endTime;

    var _loop = function _loop(group) {
      var groupPromises = [];
      var numberOfSuccesses = 1;

      var _loop2 = function _loop2(item) {
        item.isAvailable = false;

        if (item.number_required) {
          numberOfSuccesses = item.number_required;
        }

        switch (item.type) {
          case 'activity':
            if (configService.get('integration').preventActivityAvailability) {
              item.isAvailable = true;
              groupPromises.push(Promise.resolve(true));
            }
            break;
          case 'extra':
          case 'facility':
            // Temporary
            item.isAvailable = true;
            groupPromises.push(Promise.resolve(true));
            break;
        }

        if (item.isAvailable) {
          return 'break';
        }

        groupPromises.push(availabilityApiService.requestExternalAvailability(item.type, dateFrom, dateTo, item.integration_identity).then(function (response) {
          if (response && response.length > 0) {
            item.isAvailable = true;

            switch (item.type) {
              case 'activity':
                item.numberAvailable = Math.min.apply(Math, _toConsumableArray(response.map(function (activity) {
                  return activity.quantity;
                })));
                break;
              default:
                item.numberAvailable = response.length;
                break;
            }
          }
        }).catch(function () {
          //
        }));
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = group[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          var _ret2 = _loop2(item);

          if (_ret2 === 'break') break;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      promises.push(new Promise(function (resolve) {
        return Promise.all(groupPromises).then(function () {
          if (numberOfSuccesses <= group.filter(function (item) {
            return item.isAvailable;
          }).length) {
            var quantities = group.map(function (item) {
              return item.numberAvailable || null;
            }).filter(function (number) {
              return number;
            });

            if (quantities && quantities.length) {
              resolve(Math.min.apply(Math, _toConsumableArray(quantities)));
            }

            resolve(true);
          }

          resolve(false);
        });
      }));
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = packageContents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var group = _step.value;

        _loop(group);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Promise.all(promises).then(function (response) {
      if (response.length === response.filter(function (group) {
        return group;
      }).length) {
        var quantities = response.filter(function (quantity) {
          return Number.isInteger(quantity);
        });

        if (quantities && quantities.length) {
          return Math.min.apply(Math, _toConsumableArray(quantities));
        }

        return true;
      }

      return false;
    });
  };

  return {
    getQuantity: getQuantity,
    getContentsQuantity: getContentsQuantity
  };
}];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ['basket', 'suggestionsApiService', 'availabilityApiService', 'startTimeApiService', 'startTimeService', 'quantityApiService', 'propertyService', function (basket, suggestionsApiService, availabilityApiService, startTimeApiService, startTimeService, quantityApiService, propertyService) {
  var _this = this;

  this.suggestions = null;
  this.availableUpgrades = {};
  this.availableRelated = {};
  this.startTimes = {};

  var getSuggestions = function getSuggestions() {
    if (!_this.gettingSuggestions) {
      _this.gettingSuggestions = true;

      return suggestionsApiService.find(basket.contents.identity_code).then(function (response) {
        _this.gettingSuggestions = false;
        _this.suggestions = response;

        var subRequests = [];

        if (response.upgrades) {
          subRequests.push(getUpgradeAvailability(response.upgrades));
        }

        if (response.events) {
          _this.availableRelated = response.events;
        }

        return Promise.all(subRequests);
      });
    }

    return Promise.resolve();
  };

  var hasRelated = function hasRelated() {
    for (var type in _this.availableRelated) {
      if (_this.availableRelated[type].length > 0) {
        return true;
      }
    }

    return false;
  };

  var getAvailableUpgrade = function getAvailableUpgrade(date, type, upgradeId, startTime) {
    var upgradeQuantity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    if (_this.availableUpgrades[type] && _this.availableUpgrades[type][date]) {
      var upgrade = _this.availableUpgrades[type][date].find(function (upgrade) {
        return upgrade.id === upgradeId;
      });
      if (upgrade && upgrade.availability && upgrade.availability.available) {
        if (startTime && noStartTime(date, type, upgrade.id, startTime)) {
          return false;
        }

        if (upgradeQuantity >= 1 && noAvailableQuantity(date, type, upgrade.id, startTime, upgradeQuantity)) {
          return false;
        }

        return upgrade;
      }
    }
  };

  // Private functions
  var getUpgradeAvailability = function getUpgradeAvailability(responseUpgrades) {
    _this.availableUpgrades = {};
    _this.startTimes = {};
    var upgradeRequests = [];

    Object.keys(responseUpgrades).forEach(function (type) {
      if (type === 'OptionGroupOption') {
        return;
      }

      if (Object.keys(responseUpgrades[type]).length) {
        Object.keys(responseUpgrades[type]).forEach(function (date) {
          upgradeRequests.push(new Promise(function (resolve) {
            return availabilityApiService.requestAvailabilityList(date, type.toLowerCase(), Object.values(responseUpgrades[type][date]), 'upsell').then(function (response) {
              assignUpgradeResponse(date, type, response);

              return startTimePromises(date, type, response).then(function () {
                resolve();
              });
            });
          }));
        });
      }
    });

    return Promise.all(upgradeRequests).then(function () {
      return assignBasketUpgrades();
    });
  };

  var assignUpgradeResponse = function assignUpgradeResponse(date, type, response) {
    if (!_this.availableUpgrades[type]) {
      _this.availableUpgrades[type] = {};
    }
    _this.availableUpgrades[type][date] = response;
  };

  var startTimePromises = function startTimePromises(date, type, events) {
    var startTimeRequests = [];

    events.forEach(function (event) {
      if (event.availability && event.availability.available) {
        startTimeRequests.push(new Promise(function (resolve) {
          return startTimeApiService.find(date, type.toLowerCase(), event.id).then(function (timeResponse) {
            assignStartTimeResponse(date, type, event.id, timeResponse);

            resolve();
          });
        }));
      }
    });

    return Promise.all(startTimeRequests);
  };

  var assignStartTimeResponse = function assignStartTimeResponse(date, type, eventId, response) {
    if (!_this.startTimes[type]) {
      _this.startTimes[type] = {};
    }

    if (!_this.startTimes[type][date]) {
      _this.startTimes[type][date] = {};
    }

    if (!_this.startTimes[type][date][eventId]) {
      _this.startTimes[type][date][eventId] = {};
    }

    if (response) {
      response.forEach(function (startTime) {
        startTime = startTimeService.standardiseTime(startTime.time);
        _this.startTimes[type][date][eventId][startTime] = null;
      });
    }
  };

  var assignBasketUpgrades = function assignBasketUpgrades() {
    var upgradePromises = [];

    basket.contents.guest_details.forEach(function (guest) {
      guest.item_details.forEach(function (basketItem) {
        upgradePromises.push(new Promise(function (resolve) {
          return findItemUpgrade(basketItem).then(function () {
            if (basketItem.item_children) {
              basketItem.item_children.forEach(function (child) {
                return findItemUpgrade(child);
              });
            }

            resolve();
          });
        }));
      });
    });

    return Promise.all(upgradePromises);
  };

  var findItemUpgrade = function findItemUpgrade(basketItem) {
    var date = (0, _moment2.default)(basketItem.date).format('YYYY-MM-DD');

    return new Promise(function (resolve) {
      if (!basketItem.upgraded && basketItem.item_summary) {
        if (basketItem.item_summary.type_name === 'OptionGroupOption') {
          setOptionUpgrade(basketItem, date);
          return resolve();
        }

        setEventUpgrade(basketItem, date);

        if (basketItem.canUpgradeTo && propertyService.get('hasIntegration')) {
          return getUpgradeQuantity(basketItem, date).then(function () {
            resolve();
          });
        }
      }

      resolve();
    });
  };

  var setOptionUpgrade = function setOptionUpgrade(basketItem, date) {
    if (basketItem.item.option_id > 0 && canUpgrade(date, 'Treatment', basketItem.item.option_id)) {
      basketItem.canUpgradeTo = _this.suggestions.upgrades['Treatment'][date][basketItem.item.option_id];
      return;
    }

    if (canUpgrade(date, basketItem.item_summary.type_name, basketItem.item_summary.id)) {
      basketItem.canUpgradeTo = true;
    }
  };

  var setEventUpgrade = function setEventUpgrade(basketItem, date) {
    if (canUpgrade(date, basketItem.item_summary.type_name, basketItem.item_summary.id)) {
      basketItem.canUpgradeTo = _this.suggestions.upgrades[basketItem.item_summary.type_name][date][basketItem.item_summary.id];
    }
  };

  var canUpgrade = function canUpgrade(date, type, eventId) {
    if (_this.suggestions.upgrades && _this.suggestions.upgrades[type] && _this.suggestions.upgrades[type][date]) {

      if (type === 'OptionGroupOption') {
        return _this.suggestions.upgrades[type][date].indexOf(eventId) > -1;
      }

      return !!_this.suggestions.upgrades[type][date][eventId];
    }
  };

  var containerHasAvailability = function containerHasAvailability(container) {
    var checkDates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return typeHasAvailability(container.Treatment, checkDates) || typeHasAvailability(container.SpaDay, checkDates) || typeHasAvailability(container.OptionGroupOption, checkDates);
  };

  var typeHasAvailability = function typeHasAvailability(type, checkDates) {
    return !!(type && Object.keys(type).length && findAvailableEvents(type, checkDates));
  };

  var findAvailableEvents = function findAvailableEvents(events, byDate) {
    if (byDate) {
      Object.keys(events).some(function (date) {
        return findAvailable(events[date]);
      });
    }

    return findAvailable(events);
  };

  var findAvailable = function findAvailable(events) {
    return !!events.find(function (event) {
      return event.availability && event.availability.available === true;
    });
  };

  var noStartTime = function noStartTime(date, type, eventId, eventStartTime) {
    if (_this.startTimes[type] && _this.startTimes[type][date] && _this.startTimes[type][date][eventId]) {
      return !Object.keys(_this.startTimes[type][date][eventId]).find(function (startTime) {
        return startTime === startTimeService.standardiseTime(eventStartTime);
      });
    }

    eventStartTime = startTimeService.standardiseTime(eventStartTime);

    return _this.startTimes[type] && _this.startTimes[type][date] && _this.startTimes[type][date][eventId] && _this.startTimes[type][date][eventId][eventStartTime] === undefined;
  };

  var noAvailableQuantity = function noAvailableQuantity(date, type, eventId, eventStartTime, quantity) {
    eventStartTime = startTimeService.standardiseTime(eventStartTime);

    if (propertyService.get('hasIntegration')) {
      if (_this.startTimes[type] && _this.startTimes[type][date] && _this.startTimes[type][date][eventId] && _this.startTimes[type][date][eventId][eventStartTime]) {
        if (_this.startTimes[type][date][eventId][eventStartTime] !== null) {
          return _this.startTimes[type][date][eventId][eventStartTime] < quantity;
        } else if (_this.startTimes[type][date][eventId][eventStartTime] === null && quantity === 1) {
          return false;
        }
      }

      return true;
    }

    return false;
  };

  var getUpgradeQuantity = function getUpgradeQuantity(basketItem, date) {
    return new Promise(function (resolve) {
      var type = basketItem.item_summary.type_name;
      var eventId = basketItem.canUpgradeTo;
      var time = startTimeService.standardiseTime(basketItem.preferred_time);

      if (!type || !date || !eventId || !time) {
        resolve();
      }

      buildStartTimesStructure(type, date, eventId);

      if (_this.startTimes[type][date][eventId][time] !== null) {
        resolve();
      }

      if (basketItem.item_summary.minimum_guests === 1) {
        _this.startTimes[type][date][eventId][time] = 1;
        resolve();
      }

      return quantityApiService.find(date, type.toLowerCase(), eventId, time).then(function (response) {
        _this.startTimes[type][date][eventId][time] = response.quantity;
        resolve();
      });
    });
  };

  var buildStartTimesStructure = function buildStartTimesStructure(type, date, eventId) {
    if (!_this.startTimes[type]) {
      _this.startTimes[type] = {};
    }

    if (!_this.startTimes[type][date]) {
      _this.startTimes[type][date] = {};
    }

    if (!_this.startTimes[type][date][eventId]) {
      _this.startTimes[type][date][eventId] = {};
    }
  };

  return {
    getSuggestions: getSuggestions,
    hasRelated: hasRelated,
    getAvailableUpgrade: getAvailableUpgrade,
    getRelated: function getRelated() {
      return _this.availableRelated;
    }
  };
}];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moneyInput = __webpack_require__(406);

var _moneyInput2 = _interopRequireDefault(_moneyInput);

var _money = __webpack_require__(408);

var _money2 = _interopRequireDefault(_money);

var _moneyInput3 = __webpack_require__(410);

var _moneyInput4 = _interopRequireDefault(_moneyInput3);

var _money3 = __webpack_require__(411);

var _money4 = _interopRequireDefault(_money3);

var _imgixSrc = __webpack_require__(412);

var _imgixSrc2 = _interopRequireDefault(_imgixSrc);

var _imgixRefresh = __webpack_require__(413);

var _imgixRefresh2 = _interopRequireDefault(_imgixRefresh);

var _config = __webpack_require__(414);

var _config2 = _interopRequireDefault(_config);

var _store = __webpack_require__(415);

var _store2 = _interopRequireDefault(_store);

var _imgix = __webpack_require__(426);

var _imgix2 = _interopRequireDefault(_imgix);

var _time = __webpack_require__(428);

var _time2 = _interopRequireDefault(_time);

var _money5 = __webpack_require__(431);

var _money6 = _interopRequireDefault(_money5);

var _date = __webpack_require__(432);

var _date2 = _interopRequireDefault(_date);

var _loading = __webpack_require__(433);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedBaseModule = angular.module('spabooker.shared.base', []).component('moneyInput', _moneyInput2.default).component('money', _money2.default).controller('moneyInputController', _moneyInput4.default).controller('moneyController', _money4.default).directive('imgixSrc', _imgixSrc2.default).directive('imgixRefresh', _imgixRefresh2.default).factory('configService', _config2.default).factory('storeService', _store2.default).factory('imgix', _imgix2.default).factory('time', _time2.default).factory('moneyService', _money6.default).factory('dateService', _date2.default).factory('loadingService', _loading2.default);

exports.default = sharedBaseModule.name;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    require: {
        ngModel: 'ngModel'
    },
    bindings: {
        disabled: '<',
        decorate: '@',
        currencyCode: '<'
    },
    controller: 'moneyInputController',
    template: __webpack_require__(407)
};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-group input-group__money\"> <span class=input-group-label--currency ng-if=\"$ctrl.shouldDecorate('currency')\" ng-bind-html=$ctrl.currency.symbol></span> <input type=text ng-model=$ctrl.value class=input-group-field ng-change=$ctrl.onChange() ng-focus=$ctrl.onFocus() ng-blur=$ctrl.onBlur() ng-disabled=$ctrl.disabled> <span class=input-group-label--percentage ng-if=\"$ctrl.shouldDecorate('percentage')\"> % </span> </div> ";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        amount: '<',
        round: '<',
        decorate: '@',
        currencyCode: '<'
    },
    controller: 'moneyController',
    template: __webpack_require__(409)
};

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<span>{{ $ctrl.formatAmount() }}</span>";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MoneyInputController = function () {
    function MoneyInputController($element, moneyService) {
        _classCallCheck(this, MoneyInputController);

        this.$element = $element;
        this.moneyService = moneyService;
    }

    _createClass(MoneyInputController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.currency = this.moneyService.getCurrencyDetails(this.currencyCode || null);

            this.ngModel.$render = function () {
                if (!isNaN(_this.ngModel.$viewValue) && _this.ngModel.$viewValue !== null) {
                    _this.value = (_this.ngModel.$viewValue / _this.currency.magnitude).toFixed(_this.currency.decimals);
                } else {
                    _this.value = undefined;
                }
            };
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            if (this.value) {
                return this.ngModel.$setViewValue(Math.round(this.value * this.currency.magnitude).toFixed(this.currency.decimals));
            }
            return this.ngModel.$setViewValue(undefined);
        }
    }, {
        key: 'onFocus',
        value: function onFocus() {
            this.$element.addClass('focus');
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            this.$element.removeClass('focus');

            this.ngModel.$setTouched();

            if (this.$element.find('input')[0].value) {
                this.ngModel.$setDirty();
            } else {
                this.ngModel.$setPristine();
            }
        }
    }, {
        key: 'shouldDecorate',
        value: function shouldDecorate(type) {
            if (!this.decorate && type === 'currency' || this.decorate === type) {
                return true;
            }
            return false;
        }
    }]);

    return MoneyInputController;
}();

MoneyInputController.$inject = ['$element', 'moneyService'];

exports.default = MoneyInputController;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MoneyController = function () {
    function MoneyController(moneyService, configService) {
        _classCallCheck(this, MoneyController);

        this.moneyService = moneyService;
        this.configService = configService;
    }

    _createClass(MoneyController, [{
        key: 'formatAmount',
        value: function formatAmount() {
            if (this.decorate) {
                this.decorate = this.decorate.toUpperCase();
                switch (this.decorate) {
                    case 'GBP':
                    case 'EUR':
                    case 'USD':
                    case 'JPY':
                        this.currencyCode = this.decorate;
                        break;

                    default:
                        this.currencyCode = this.configService.get('currency') || 'GBP';
                        break;
                }
            }

            if (!isNaN(this.amount)) {
                this.currency = this.moneyService.getCurrencyDetails(this.currencyCode || null);
                var amount = (this.amount / this.currency.magnitude).toFixed(this.currency.decimals);

                if (this.round) {
                    amount = parseInt(amount);
                }

                if (this.decorate) {
                    amount = this.decorateValue(amount);
                }

                return amount;
            }
        }
    }, {
        key: 'decorateValue',
        value: function decorateValue(amount) {
            switch (this.decorate) {
                default:
                case 'true':
                case 'currency':
                case '#':
                case '=':
                    amount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    amount = this.currency.symbol + amount;
                    break;

                case '%':
                case 'percent':
                case 'percentage':
                    amount = amount.toString().replace('.00', '');
                    amount = amount + '%';
                    break;
            }

            return amount;
        }
    }]);

    return MoneyController;
}();

MoneyController.$inject = ['moneyService', 'configService'];

exports.default = MoneyController;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['imgix', 'configService', function (imgix, configService) {
    return {
        restrict: 'A',
        scope: {
            url: '@imgixSrc'
        },
        link: function link($scope, element, attrs) {
            var imgixBaseUrl = configService.get('imgix.source');
            var uploadBaseUrl = configService.get('uploadsBaseUrl');

            var fit = '';
            switch (attrs.fit) {
                case 'fit':
                    fit = 'fit=clip';
                    break;

                case 'crop':
                    fit = 'fit=crop';
                    break;

                default:
                case 'auto':
                    fit = 'fit=crop&crop=faces,edges';
                    break;
            }
            var imgixQuery = '?auto=format&ch=DPR,Width&q=65&' + fit;
            var dataSrc = '';

            if (uploadBaseUrl && imgixBaseUrl) {
                if (attrs.imgixSrc.indexOf('//') === 0) {
                    dataSrc = 'https:';
                } else if (uploadBaseUrl.indexOf('http') === 0 && attrs.imgixSrc.indexOf('//') !== 0) {
                    dataSrc = 'https://';
                }
                dataSrc += attrs.imgixSrc.replace(uploadBaseUrl, imgixBaseUrl) + imgixQuery;
                element.attr('data-src', dataSrc).addClass('imgix-fluid');
            } else {
                dataSrc += attrs.imgixSrc;
                if (element[0].tagName === 'IMG') {
                    element.attr('src', dataSrc);
                } else {
                    element.attr('style', 'background-image: url("' + dataSrc + '")').addClass('no-imgix');
                }
            }
        }
    };
}];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var imgixRefresh = function imgixRefresh($timeout, imgix) {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            if (scope.$last === true) {
                imgix.reload();
                element[0].classList.add('has-loaded');
            } else {
                $timeout(function () {
                    imgix.reload();
                    element[0].classList.add('has-loaded');
                });
            }
        }
    };
};

imgixRefresh.$inject = ['$timeout', 'imgix'];

exports.default = imgixRefresh;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

var configService = function configService($window) {
    return {
        load: function load() {
            return Promise.resolve();
        },
        get: function get(key) {
            return (0, _lodash.get)($window.config, key);
        }
    };
};

configService.$inject = ['$window'];

exports.default = configService;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _store = __webpack_require__(322);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [function () {
    var storeService = { functions: {} };

    storeService.functions.get = function (key) {
        return _store2.default.get(key);
    };

    storeService.functions.set = function (key, value) {
        return _store2.default.set(key, value);
    };

    storeService.functions.remove = function (key) {
        return _store2.default.remove(key);
    };

    return storeService.functions;
}];

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imgix = __webpack_require__(427);

var _imgix2 = _interopRequireDefault(_imgix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ['$rootScope', '$timeout', function ($rootScope, $timeout) {

    function closestNum(num, arr) {
        var curr = arr[0];
        var key = 0;
        var diff = Math.abs(num - curr);
        for (var val = 0; val < arr.length; val++) {
            var newdiff = Math.abs(num - arr[val]);
            if (newdiff < diff) {
                diff = newdiff;
                curr = arr[val];
                key = val;
            }
        }
        if (num >= curr && key !== arr.length - 1) {
            return arr[key + 1];
        }
        return curr;
    }

    var acceptable_sizes = {
        widths: [100, 150, 250, 300, 500, 640, 800, 1000, 1500, 2000, 2560],
        heights: [100, 150, 250, 300, 500, 640, 800, 1000, 1500]
    };

    var imgixFluid = _imgix2.default.fluid({
        lazyLoad: true,
        lazyLoadOffsetVertical: 150,
        pixelStep: 50,
        lazyLoadColor: false,
        onChangeParamOverride: function onChangeParamOverride(w, h, params, elem) {
            switch (elem.getAttribute('data-fit')) {
                case 'fit':
                    params.fit = 'clip';
                    break;

                case 'crop':
                    params.fit = 'crop';
                    break;

                default:
                case 'auto':
                    params.fit = 'crop';
                    params.crop = 'faces,edges';
            }

            params.auto = 'format';
            params.ch = 'DPR,Width';
            params.q = 65;
            params.w = closestNum(w, acceptable_sizes.widths).toString();
            params.h = closestNum(h, acceptable_sizes.heights).toString();

            return params;
        },
        onLoad: function onLoad(elem) {
            if (!elem.className.match('has-loaded')) {
                elem.classList.add('has-loaded');
            }
        }
    });

    function reload() {
        $timeout(function () {
            return imgixFluid.reload();
        });
    }

    $rootScope.$watch('image', function (newVal, oldVal) {
        if (oldVal && oldVal !== newVal) {
            imgixFluid.reload();
        }
    });

    $rootScope.$on("$locationChangeSuccess", function () {
        imgixFluid.reload();
    });

    angular.element(window).on('imgixRefresh', function () {
        imgixFluid.reload();
    });

    return {
        imgixFluid: imgixFluid,
        reload: reload
    };
}];

/***/ }),
/* 427 */,
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(0);

__webpack_require__(323);

exports.default = ['currentPropertyService', function (currentPropertyService) {
    var timeCheck = function timeCheck(time) {
        if (!(0, _moment.isMoment)(time)) {
            time = moment.utc(time);
        }
        return time.tz(currentPropertyService.get().timezone);
    };

    var readableTime = function readableTime(input) {
        return timeCheck(input).format('MMMM Do YYYY, h:mm:ss A');
    };
    var readableDate = function readableDate(input) {
        return timeCheck(input).format('MMMM Do YYYY');
    };
    var shortTime = function shortTime(input) {
        return timeCheck(input).format('D/M/Y HH:mm');
    };
    var shortDate = function shortDate(input) {
        return timeCheck(input).format('D/M/Y');
    };
    var readable = function readable(input, format) {
        return timeCheck(input).format(format);
    };

    return {
        readableTime: readableTime,
        readableDate: readableDate,
        shortTime: shortTime,
        shortDate: shortDate,
        readable: readable
    };
}];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var moneyService = function moneyService($rootScope, $window) {
    var getCurrencyDetails = function getCurrencyDetails() {
        var currencyCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (currencyCode) {
            return determineCurrency(currencyCode);
        }

        if ($window.config && $window.config.currency) {
            return determineCurrency($window.config.currency);
        }

        return determineCurrency($rootScope.currentProperty.currency_code);
    };

    var determineCurrency = function determineCurrency(currencyCode) {
        switch (currencyCode) {
            case 'EUR':
                return {
                    symbol: '€',
                    magnitude: 100,
                    decimals: 2
                };
            case 'JPY':
                return {
                    symbol: '¥',
                    magnitude: 1,
                    decimals: 0
                };
            case 'USD':
                return {
                    symbol: '$',
                    magnitude: 100,
                    decimals: 2
                };
            default:
            case 'GBP':
                return {
                    symbol: '£',
                    magnitude: 100,
                    decimals: 2
                };
        }
    };

    var reduce = function reduce(amount) {
        var decorate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var currency = getCurrencyDetails(decorate);
        var decoration = '';
        if (decorate) {
            decoration = currency.symbol;
        }
        return '' + decoration + (amount / currency.magnitude).toFixed(currency.decimals);
    };

    var magnify = function magnify(amount) {
        var currency = getCurrencyDetails();
        return amount * currency.magnitude;
    };

    return {
        getCurrencyDetails: getCurrencyDetails,
        reduce: reduce,
        magnify: magnify
    };
};

moneyService.$inject = ['$rootScope', '$window'];

exports.default = moneyService;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(323);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateService = function dateService($window, $timeout, storeService, propertyService) {
  var propertyTimezone = undefined;

  var checkMaxDate = function checkMaxDate(momentDate) {
    var isStartDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!_moment2.default.isMoment(momentDate)) {
      momentDate = convertToMoment(momentDate);
    }

    if (momentDate.diff((0, _moment2.default)(), "days") > 357) {
      momentDate = (0, _moment2.default)().add(1, "years");

      if (isStartDate) {
        momentDate.subtract(6, "days");
      }
    }

    return momentDate;
  };

  var verifyDateGteToday = function verifyDateGteToday(momentDate) {
    var minDate = getMinDate();
    if (momentDate && momentDate.isSameOrAfter(minDate, "day")) {
      return momentDate;
    }

    return minDate;
  };

  var checkStoredDate = function checkStoredDate() {
    var setDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var returnAsMoment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var incomingDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    var timezone = getTimezone();

    var momentDate = void 0;
    var searchDate = storeService.get("searchDate");

    if (searchDate || !searchDate && incomingDate) {
      if (!incomingDate) {
        momentDate = buildMomentDate(searchDate);
      } else {
        momentDate = incomingDate;
      }

      if (momentDate.isBefore((0, _moment2.default)(), "day")) {
        storeService.remove("searchDate");
      }
    }

    if (!momentDate || !momentDate.isValid()) {
      momentDate = (0, _moment2.default)();
    }
    momentDate = withinRestrictedDates(momentDate);
    momentDate = verifyDateGteToday(momentDate);
    momentDate = momentDate.tz(timezone);

    if (setDates) {
      storeService.set("searchDate", momentDate.format("YYYY-MM-DD"));
    }

    if (returnAsMoment) {
      return momentDate;
    }

    return momentDate.format("YYYY-MM-DD");
  };

  var convertToMoment = function convertToMoment(date) {
    var timezone = getTimezone();

    return (0, _moment2.default)(date).tz(timezone);
  };

  var checkDate = function checkDate(date) {
    var returnAsMoment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!_moment2.default.isMoment(date)) {
      date = convertToMoment(date);
    }

    return checkStoredDate(true, returnAsMoment, date);
  };

  var getTimezone = function getTimezone() {
    if (!propertyTimezone) {
      propertyTimezone = propertyService.get("timezone");
    }

    return propertyTimezone;
  };

  var displayFromToDate = function displayFromToDate(fromDate, toDate) {
    if (!fromDate || !toDate) {
      return false;
    }

    var startDate = buildMomentDate(fromDate);
    var endDate = buildMomentDate(toDate);

    if (startDate.isSame(endDate, "day")) {
      return "on " + startDate.format("Do MMMM YYYY");
    }

    if (startDate.isSame(endDate, "month")) {
      return "from " + startDate.format("Do") + " to " + endDate.format("Do MMMM YYYY");
    }

    if (startDate.isSame(endDate, "year")) {
      return "from " + startDate.format("Do MMMM") + " to " + endDate.format("Do MMMM YYYY");
    }

    return "from " + startDate.format("Do MMMM YYYY") + " to " + endDate.format("Do MMMM YYYY");
  };

  var buildMomentDate = function buildMomentDate(date) {
    if (date.length === 10) {
      date += " 00:00:00";
    }

    return (0, _moment2.default)(date.replace("T", " ") + "+00:00");
  };

  var getMinDate = function getMinDate() {
    var minDate = (0, _moment2.default)();

    var closeDays = propertyService.get("stopDays");
    var minSearchDays = propertyService.get("minSearchDays");
    var closeTime = propertyService.get("stopTime");

    if (closeDays && (!minSearchDays || closeDays > minSearchDays)) {
      var date = minDate.add(closeDays, "day");
      setCalendarParameter('minDate', date);
      return date;
    }

    if (minSearchDays) {
      return minDate.add(minSearchDays, "days");
    }

    if (closeTime && minDate.diff((0, _moment2.default)(closeTime, "HH:mm:ss")) > 0) {
      var _date = minDate.add(1, "day");
      setCalendarParameter('minDate', _date);
      return _date;
    }

    return minDate;
  };

  var setCalendarParameter = function setCalendarParameter(param, value) {
    $timeout(function () {
      if ($window.fpInput && _typeof($window.fpInput) === "object" && typeof $window.fpInput.set === "function") {
        if (value && (0, _moment2.default)().isValid(value)) {
          value = value.format('YYYY-MM-DD');
        }
        $window.fpInput.set(param, value);
      }
    }, 1000);
  };

  var withinRestrictedDates = function withinRestrictedDates(date) {
    if (date && (0, _moment2.default)().isValid(date)) {
      var startEditBooking = storeService.get("start_date");
      var endEditBooking = storeService.get("end_date");
      var maxSearchDays = propertyService.get('maxActivitySearchDays');

      if (startEditBooking && endEditBooking) {
        startEditBooking = (0, _moment2.default)(startEditBooking);
        endEditBooking = (0, _moment2.default)(endEditBooking);

        if (date.diff(startEditBooking, "days") < 0 || date.diff(endEditBooking, "days") > 0) {
          date = startEditBooking;
          return date;
        }
      }

      if ($window.location.pathname.includes('/classes') && maxSearchDays && maxSearchDays > 0) {
        if (date.diff((0, _moment2.default)().add(maxSearchDays, 'days'), 'hours') > 0) {
          date = (0, _moment2.default)();
        }
      }
    }

    return date;
  };

  return {
    checkMaxDate: checkMaxDate,
    verifyDateGteToday: verifyDateGteToday,
    checkStoredDate: checkStoredDate,
    convertToMoment: convertToMoment,
    checkDate: checkDate,
    displayFromToDate: displayFromToDate,
    setCalendarParameter: setCalendarParameter
  };
};

dateService.$inject = ["$window", "$timeout", "storeService", "propertyService"];

exports.default = dateService;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadingService = function loadingService() {
    var _this = this;

    this.loading = [];

    var startLoading = function startLoading(param) {
        if (Array.isArray(param)) {
            var returns = param.map(function (value) {
                return startLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }

        return startLoadingSingle(param);
    };

    var stopLoading = function stopLoading(param) {
        if (Array.isArray(param)) {
            var returns = param.map(function (value) {
                return stopLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }

        return stopLoadingSingle(param);
    };

    var isLoading = function isLoading(param) {
        if (Array.isArray(param)) {
            var returns = param.map(function (value) {
                return isLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }
        return isLoadingSingle(param);
    };

    var clearLoading = function clearLoading() {
        _this.loading = [];
    };

    var startLoadingSingle = function startLoadingSingle(param) {
        if (_this.loading.indexOf(param) === -1) {
            _this.loading.push(param);
            return true;
        }

        return false;
    };

    var stopLoadingSingle = function stopLoadingSingle(param) {
        var index = _this.loading.indexOf(param);

        if (index > -1) {
            _this.loading.splice(index, 1);
            return true;
        }

        return false;
    };

    var isLoadingSingle = function isLoadingSingle(param) {
        if (param) {
            return _this.loading.indexOf(param) > -1;
        }

        return _this.loading.length > 0;
    };

    return {
        startLoading: startLoading,
        stopLoading: stopLoading,
        isLoading: isLoading,
        clearLoading: clearLoading
    };
};

loadingService.$inject = [];

exports.default = loadingService;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _guestAdd = __webpack_require__(435);

var _guestAdd2 = _interopRequireDefault(_guestAdd);

var _guestName = __webpack_require__(436);

var _guestName2 = _interopRequireDefault(_guestName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedGuestModule = angular.module('spabooker.shared.guest', []).factory('addGuestService', _guestAdd2.default).factory('guestnameService', _guestName2.default);

exports.default = sharedGuestModule.name;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

exports.default = ['basket', 'propertyService', 'messageService', 'guestnameService', 'storeService', function (basket, propertyService, messageService, guestnameService, storeService) {
  var state = {
    existingGuests: null,
    gender: null,
    guests: [],
    maximumGuests: null,
    minimumGuests: null,
    staff: null,
    titles: []
  };

  var setState = function setState(stateToSet) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (param) {
      state[param] = stateToSet;
      return;
    }

    state = Object.assign({}, state, stateToSet);
  };

  var getState = function getState() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (param) {
      return state[param];
    }

    return state;
  };

  var getGuests = function getGuests() {
    return state.guests;
  };

  var buildTitlesList = function buildTitlesList() {
    var male = ['Mr.'];
    var female = ['Miss', 'Mrs.', 'Ms.'];
    var output = ['Dr.', 'Rev.'];

    switch (state.gender) {
      case 'M':
        output = male.concat(output);
        break;

      case 'F':
        output = female.concat(output);
        break;

      default:
        output = female.concat(male).concat(output);
        break;
    }

    state.titles = output;
    return output;
  };

  var setInitialGuests = function setInitialGuests() {
    var guests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    state.guests = guests;

    if (state.guests.length) {
      state.guests = filterGuestsByGender(state.guests, true);
    }

    if (state.guests.length < state.minimumGuests && notEditing()) {
      addEmptyGuests(state.guests.length);
      return state.guests;
    }

    if (state.guests.length > state.maximumGuests) {
      state.guests.splice(state.maximumGuests);
    }

    return state.guests;
  };

  var canAddGuest = function canAddGuest() {
    return parseInt(state.guests.length) + parseInt(state.minimumGuests) <= parseInt(state.maximumGuests);
  };

  var addEmptyGuests = function addEmptyGuests() {
    var startingIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!reference) {
      reference = basket.referenceGenerator();
    }

    for (var index = startingIndex; index < state.minimumGuests; index++) {
      pushGuest(reference);
    }
  };

  var pushGuest = function pushGuest(reference) {
    var attributes = {
      reference: reference,
      item_children: []
    };

    if (state.gender) {
      attributes.gender = state.gender;
    }

    if (state.staff && state.staff.length === 1) {
      attributes.staff = state.staff[0];
    }

    state.guests.push(attributes);
  };

  var hasMaxGuests = function hasMaxGuests() {
    return parseInt(state.guests.length) === parseInt(state.maximumGuests);
  };

  var maxGuestsAdded = function maxGuestsAdded() {
    return hasMaxGuests() && firstEmptyGuest() === -1;
  };

  var firstEmptyGuest = function firstEmptyGuest() {
    return state.guests.findIndex(function (guest) {
      return !guest.title && !guest.first_name && !guest.last_name;
    });
  };

  var filterGuestsByGender = function filterGuestsByGender(guests) {
    var ignoreTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return guests.filter(function (guest) {
      if (state.gender && guest.gender) {
        return state.gender.toLowerCase() === guest.gender.toLowerCase();
      }

      if (guest.integration_reference) {
        return !!state.existingGuests.find(function (existing) {
          return guest.integration_reference === existing.integration_reference;
        });
      }

      if (ignoreTitle) {
        return true;
      }

      return state.titles.indexOf(guest.title) > -1;
    });
  };

  var filterExistingGuests = function filterExistingGuests() {
    setInitialGuests(getGuests());

    state.existingGuests.forEach(function (guest) {
      if (!guest.disabled) {
        if (state.gender && guest.gender && state.gender.toLowerCase() !== guest.gender.toLowerCase()) {
          guest.disabled = true;
        }

        return;
      }

      if (guest.disabled && !state.guests.find(function (newGuest) {
        return guest.id && guest.id === newGuest.id;
      })) {
        if (!state.gender || state.gender && guest.gender && state.gender.toLowerCase() === guest.gender.toLowerCase()) {
          delete guest.disabled;
        }
      }
    });

    return state.existingGuests;
  };

  var addExistingGuest = function addExistingGuest(existingGuestId) {
    if (maxGuestsAdded()) {
      return;
    }

    var existingGuest = {};

    if (existingGuestId) {
      existingGuest = state.existingGuests.find(function (guest) {
        return guest.id === existingGuestId;
      });
      existingGuest.disabled = true;

      if (!state.guests.find(function (guest) {
        return guest.id === existingGuest.id;
      })) {
        var emptyGuest = firstEmptyGuest();
        var cloneGuest = (0, _lodash.clone)(existingGuest);
        cloneGuest.item_children = [];

        if (state.guests[emptyGuest] && state.guests[emptyGuest].staff) {
          delete state.guests[emptyGuest].staff.disabled;
        }

        if (state.staff && state.staff.length === 1) {
          cloneGuest.staff = state.staff[0];
        }

        if (emptyGuest !== -1) {
          cloneGuest.reference = state.guests[emptyGuest].reference;
          state.guests[emptyGuest] = cloneGuest;
          return;
        }

        var reference = basket.referenceGenerator();
        cloneGuest.reference = reference;

        state.guests.push(cloneGuest);

        if (state.minimumGuests > 1) {
          addEmptyGuests(1, reference);
        }
      }
    }
  };

  var removeGuest = function removeGuest(selectedGuest) {
    var reference = selectedGuest.reference;

    var _loop = function _loop(index) {
      var guest = state.guests[index];

      if (guest.reference === reference) {
        if (guest.staff) {
          delete guest.staff.disabled;
        }

        var existingGuest = guest.id && state.existingGuests.find(function (existingGuest) {
          return existingGuest.id === guest.id;
        });
        if (existingGuest) {
          delete existingGuest.disabled;
        }

        state.guests.splice(index, 1);
      }
    };

    for (var index = state.guests.length - 1; index >= 0; index--) {
      _loop(index);
    }
  };

  var guestNameOrPlaceholder = function guestNameOrPlaceholder(guest) {
    if (guest.title || guest.first_name || guest.last_name) {
      return guestnameService.format(guest);
    }

    return 'New Guest';
  };

  var showTitle = function showTitle(guest) {
    if (!guest.id) {
      return true;
    }

    return state.titles.indexOf(guest.title) !== -1;
  };

  var showGenderSelection = function showGenderSelection(guest) {
    return propertyService.get('hasIntegration') && !state.gender && !guest.id;
  };

  var guessGender = function guessGender(guest) {
    var female = ['Miss', 'Mrs.', 'Ms.'];

    if (guest.title) {
      if (guest.title === 'Mr.') {
        guest.gender = 'M';
        return;
      }

      if (female.find(function (title) {
        return title === guest.title;
      })) {
        guest.gender = 'F';
      }
    }
  };

  var digitToWord = function digitToWord(digit) {
    switch (parseInt(digit)) {
      case 1:
        return 'one';
      case 2:
        return 'two';
      case 3:
        return 'three';
      case 4:
        return 'four';
      case 5:
        return 'five';
      case 6:
        return 'six';
      case 7:
        return 'seven';
      case 8:
        return 'eight';
      case 9:
        return 'nine';
    }

    return digit;
  };

  var displayGuestQuantity = function displayGuestQuantity(type, minGuests, quantity) {
    var eventGender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var maxGuests = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    if (!!type && quantity > 0) {
      var string = 'This ' + type + ' can be booked for ' + numberOfGuests(minGuests, quantity, maxGuests) + '.';

      if (eventGender && eventGender !== 'false') {
        var gender = eventGender === 'M' ? 'male' : 'female';
        string += ' It is only available to ' + gender + ' guests.';
      }

      return string;
    }
  };

  var numberOfGuests = function numberOfGuests(minGuests, quantity, maxGuests) {
    if (!propertyService.get('hasIntegration') && !!maxGuests) {
      quantity = maxGuests;
    }

    if (parseInt(minGuests) !== parseInt(quantity)) {
      return minGuests + ' to ' + quantity + ' guests';
    }

    if (quantity > 1) {
      return quantity + ' guests';
    }

    return quantity + ' guest';
  };

  var notEditing = function notEditing() {
    return !storeService.get('reservation');
  };

  return {
    setState: setState,
    getState: getState,
    getGuests: getGuests,
    buildTitlesList: buildTitlesList,
    setInitialGuests: setInitialGuests,
    canAddGuest: canAddGuest,
    addEmptyGuests: addEmptyGuests,
    maxGuestsAdded: maxGuestsAdded,
    filterGuestsByGender: filterGuestsByGender,
    filterExistingGuests: filterExistingGuests,
    addExistingGuest: addExistingGuest,
    removeGuest: removeGuest,
    guestNameOrPlaceholder: guestNameOrPlaceholder,
    showTitle: showTitle,
    showGenderSelection: showGenderSelection,
    guessGender: guessGender,
    digitToWord: digitToWord,
    displayGuestQuantity: displayGuestQuantity
  };
}];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [function () {
    var addPossessive = function addPossessive(string) {
        if (string.substr(-1, 1) === 's') {
            string += "'";
            return string;
        }

        string += "'s";

        return string;
    };

    var addSuffix = function addSuffix(string, suffix, pluralCount, suffixPlural) {
        string += " " + suffix;
        if (pluralCount > 1 && string.substr(-1, 1) !== 's') {
            string += suffixPlural;
        }

        return string;
    };

    return {
        format: function format(guest) {
            var possessive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var pluralCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var suffixPlural = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 's';

            var formatted = ((guest.title || '') + " " + (guest.first_name || '') + " " + (guest.last_name || '')).trim();

            if (possessive) {
                formatted = addPossessive(formatted);
            }
            if (suffix) {
                formatted = addSuffix(formatted, suffix, pluralCount, suffixPlural);
            }

            return formatted;
        }
    };
}];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _item = __webpack_require__(438);

var _item2 = _interopRequireDefault(_item);

var _validate = __webpack_require__(439);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedItemModule = angular.module('spabooker.shared.item', []).factory('itemService', _item2.default).factory('validateService', _validate2.default);

exports.default = sharedItemModule.name;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(2);

exports.default = ['$window', 'offerService', 'startTimeService', 'availabilityService', function ($window, offerService, startTimeService, availabilityService) {
  var _this = this;

  this.item = null;

  var setItem = function setItem(item) {
    _this.item = item;
  };

  var getItem = function getItem() {
    return _this.item;
  };

  var hasItem = function hasItem() {
    return !!(_this.item && Object.keys(_this.item).length > 0);
  };

  var updateAvailability = function updateAvailability(availableDay) {
    return new Promise(function (resolve) {
      if (!availableDay) {
        return resolve();
      }

      _this.item.date = availableDay.date;
      _this.item.available = availableDay.available;

      if (!_this.item.available) {
        return resolve();
      }

      _this.item.price = availableDay.price;
      _this.item.original = availableDay.original_price;
      _this.item.phone_only = availableDay.phone_only;

      if (_this.item.phone_only) {
        _this.item.available = false;
      }

      availabilityService.resetSingleTimes();

      var apiRequests = [];

      if (_this.item.available) {
        apiRequests.push(new Promise(function (resolves) {
          return startTimeService.getStartTimesSetPreferred(_this.item).then(function (itemWithTimes) {
            setItem(itemWithTimes);
            resolves();
          });
        }));
      }

      if (availableDay.offer) {
        if (!_this.item.offer || _this.item.offer && _this.item.offer.id !== availableDay.offer.id) {
          _this.item.offer = {};

          apiRequests.push(new Promise(function (resolves) {
            return offerService.getDetails(availableDay.offer.id).then(function (offerDetails) {
              _this.item.offer = offerDetails;
              resolves();
            });
          }));
        }
      } else {
        _this.item.offer = null;
      }

      if ($window.fpInput && _typeof($window.fpInput) === 'object' && typeof $window.fpInput.setDate === 'function') {
        $window.fpInput.setDate(_this.item.date, false, 'Y-m-d');
      }

      return Promise.all(apiRequests).then(function () {
        resolve();
      });
    });
  };

  var setupItemAvailability = function setupItemAvailability(availability, date) {
    return updateAvailability(availability.find(function (event) {
      return event.date === date && event.available === true;
    }) || availability.find(function (event) {
      return event.available === true;
    }) || (0, _lodash.head)(availability));
  };

  return {
    getItem: getItem,
    setItem: setItem,
    hasItem: hasItem,
    updateAvailability: updateAvailability,
    setupItemAvailability: setupItemAvailability
  };
}];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

exports.default = ['propertyService', function (propertyService) {

    var invalidItemOrGuests = function invalidItemOrGuests(item, guests) {
        var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

        var error = itemError(item, status);

        if (!error) {
            error = guestInputError(guests, item);
        }

        if (error) {
            return error;
        }

        return false;
    };

    var itemError = function itemError(item, status) {
        if (item.available === false) {
            return 'Sorry, this event is not currently available.';
        }

        if (!item.preferred_time && !item.suggested) {
            return 'Please select your arrival time.';
        }

        if (item.phone_only || status === 1) {
            return 'Please call us to book this event.';
        }
    };

    var optionError = function optionError(item) {
        var error = 'Please choose included options for all events';

        if (!item.requiredOptions || item.requiredOptions === 0) {
            return false;
        }

        if (item.item_children.length < item.requiredOptions) {
            return error;
        }

        if (item.item_children.filter(function (child) {
            return child.item_type === 'App\\OptionGroupOption' || child.type_name === 'OptionGroupOption';
        }).length !== item.requiredOptions) {
            return error;
        }
    };

    var guestLoop = function guestLoop(guests, item) {
        var errors = {
            errorFields: [],
            guestCounter: []
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = guests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var guest = _step.value;

                if (!guest.integration_reference && !guest.title || !guest.integration_reference && !guest.first_name || !guest.last_name || propertyService.get('hasIntegration') && !guest.gender) {
                    errors.errorFields.push('required');
                    continue;
                }

                if (item.gender && item.gender !== guest.gender) {
                    errors.errorFields.push('gender');
                    continue;
                }

                errors.guestCounter.push(guest.title + guest.first_name + guest.last_name);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return errors;
    };

    var guestInputError = function guestInputError(guests, item) {
        var errors = guestLoop(guests, item);

        if (errors.errorFields.length) {
            return setGuestInputError(errors.errorFields, item);
        }

        if ((0, _lodash.uniq)(errors.guestCounter).length !== guests.length && errors.guestCounter.length <= item.quantity && errors.guestCounter.length >= item.minimum_guests) {
            return 'You\'ve entered the same guest details more than once.';
        }

        if (errors.guestCounter.length < item.minimum_guests) {
            return 'Too few guests added.';
        }

        if (item.quantity + item.minimum_guests < errors.guestCounter.length) {
            return 'Not enough available quantity to add that many guests. You can add up to a total of ' + (item.quantity + item.minimum_guests) + ' guests.';
        }
    };

    var setGuestInputError = function setGuestInputError(errorFields, item) {
        var genderErrors = errorFields.filter(function (error) {
            return error === 'gender';
        });
        var requiredErrors = errorFields.filter(function (error) {
            return error === 'required';
        });

        if (genderErrors.length === 1) {
            return 'A guest has the wrong gender for this ' + (item.type || item.type_display) + '.';
        }

        if (genderErrors.length > 1) {
            return 'Several guests have the wrong gender for this ' + (item.type || item.type_display) + '.';
        }

        if (requiredErrors.length === 1) {
            return 'A guest is missing required fields.';
        }

        if (requiredErrors.length > 1) {
            return 'Several guests are missing required fields.';
        }
    };

    var guestInputCustomiseError = function guestInputCustomiseError(guests, item) {
        var error = guestInputError(guests, item);

        if (error) {
            return error;
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = guests[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var guest = _step2.value;

                error = optionError(guest);
                if (error) {
                    return error;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    };

    return {
        invalidItemOrGuests: invalidItemOrGuests,
        itemError: itemError,
        guestInputCustomiseError: guestInputCustomiseError,
        optionError: optionError
    };
}];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _displaySuggestions = __webpack_require__(441);

var _displaySuggestions2 = _interopRequireDefault(_displaySuggestions);

var _displaySuggestionsUpgrade = __webpack_require__(443);

var _displaySuggestionsUpgrade2 = _interopRequireDefault(_displaySuggestionsUpgrade);

var _upgradeEvent = __webpack_require__(445);

var _upgradeEvent2 = _interopRequireDefault(_upgradeEvent);

var _upgradeOption = __webpack_require__(447);

var _upgradeOption2 = _interopRequireDefault(_upgradeOption);

var _displaySuggestions3 = __webpack_require__(449);

var _displaySuggestions4 = _interopRequireDefault(_displaySuggestions3);

var _displaySuggestionsUpgrade3 = __webpack_require__(450);

var _displaySuggestionsUpgrade4 = _interopRequireDefault(_displaySuggestionsUpgrade3);

var _upgradeEvent3 = __webpack_require__(451);

var _upgradeEvent4 = _interopRequireDefault(_upgradeEvent3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedCheckoutModule = angular.module('spabooker.shared.checkout', ['spabooker.basket', 'spabooker.shared.availability']).component('displaySuggestions', _displaySuggestions2.default).component('displaySuggestionsUpgrade', _displaySuggestionsUpgrade2.default).component('upgradeEvent', _upgradeEvent2.default).component('upgradeOption', _upgradeOption2.default).controller('displaySuggestionsController', _displaySuggestions4.default).controller('displaySuggestionsUpgradeController', _displaySuggestionsUpgrade4.default).controller('upgradeEventController', _upgradeEvent4.default);

exports.default = sharedCheckoutModule.name;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        isAdmin: '<',
        canLoadStaff: '<',
        selectEvent: '&'
    },
    controller: 'displaySuggestionsController',
    template: __webpack_require__(442)
};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "<div class=c-checkout__spinner ng-if=\"$ctrl.loadingService.isLoading('suggestions')\"> <spinner></spinner> </div> <div class=c-upsell__container ng-if=\"!$ctrl.loadingService.isLoading('suggestions')\"> <div class=c-upsell__upgrades ng-if=$ctrl.canShowUpgrades()> <hr> <div ng-if=$ctrl.content.settings.load_staff> <p><em>When upgrading an event, please be aware that you may not get the same member of staff.</em></p> <hr> </div> <h3>Upgrade your experience</h3> <div ng-repeat=\"upgrade in $ctrl.multiGuestUpgrades\" ng-if=$ctrl.multiGuestUpgrades.length> <h4>{{ upgrade.guests.join(', ') }} upgrades</h4> <display-suggestions-upgrade get-suggestions=$ctrl.getSuggestions() items=upgrade.items upgrade=\"$ctrl.findAvailableUpgrade(upgrade.items[0], upgrade.items.length)\" guests=upgrade.guests></display-suggestions-upgrade> </div> <div ng-repeat=\"guest in $ctrl.basket.contents.guest_details\" ng-if=$ctrl.guestCanUpgrade(guest)> <h4>{{ $ctrl.guestName(guest, 'upgrades') }}</h4> <div ng-repeat=\"item in guest.item_details\" ng-if=$ctrl.itemOrChildrenCanUpgrade(item)> <div ng-if=\"item.canUpgradeTo || item.upgraded\"> <display-suggestions-upgrade get-suggestions=$ctrl.getSuggestions() item=item upgrade=$ctrl.findAvailableUpgrade(item) guest=guest></display-suggestions-upgrade> </div> <div ng-if=item.item_children ng-repeat=\"child in item.item_children\"> <div ng-if=\"child.canUpgradeTo || child.upgraded\"> <display-suggestions-upgrade get-suggestions=$ctrl.getSuggestions() parent=item item=child upgrade=$ctrl.findAvailableUpgrade(child) guest=guest></display-suggestions-upgrade> </div> </div> </div> </div> </div> <div class=\"c-upsell__events c-upsell__events--treatment\" ng-if=\"$ctrl.canShowRelated('Treatment')\"> <hr> <h3>Add another Treatment</h3> <event-tile ng-if=!$ctrl.isAdmin type=Treatment event=event class=c-upsell__event add-class=c-tile--thin ng-repeat=\"event in $ctrl.getRelated('Treatment')\"></event-tile> <div ng-if=$ctrl.isAdmin> <ul> <li ng-repeat=\"event in $ctrl.getRelated('Treatment')\"> <a ng-click=\"$ctrl.selectEvent({ type: 'Treatment', eventId: event.id })\">{{ event.name }}</a> </li> </ul> </div> </div> <div class=\"c-upsell__events c-upsell__events--spaday\" ng-if=\"$ctrl.canShowRelated('SpaDay')\"> <hr> <h3>Add another Spa Day</h3> <event-tile ng-if=!$ctrl.isAdmin type=\"Spa Day\" event=event class=c-upsell__event add-class=c-tile--thin ng-repeat=\"event in $ctrl.getRelated('SpaDay')\"></event-tile> <div ng-if=$ctrl.isAdmin> <ul> <li ng-repeat=\"event in $ctrl.getRelated('SpaDay')\"> <a ng-click=\"$ctrl.selectEvent({ type: 'SpaDay', eventId: event.id })\">{{ event.name }}</a> </li> </ul> </div> </div> <div class=c-upsell__empty ng-if=$ctrl.hasNoSuggestions()> <div class=c-checkout__empty> <span>We couldn't find any suggestions for you.<span ng-if=!$ctrl.isAdmin> Please proceed to the next step.</span></span> </div> </div> </div> ";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        getSuggestions: '&',
        items: '=?',
        item: '=?',
        upgrade: '<',
        parent: '<',
        guests: '<?',
        guest: '<?'
    },
    controller: 'displaySuggestionsUpgradeController',
    template: __webpack_require__(444)
};

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<div class=c-upsell__upgrades--treatment ng-if=\"$ctrl.itemIs('Treatment') && $ctrl.showUpgrade()\"> <div class=c-upsell__upgrade> <upgrade-event get-suggestions=$ctrl.getSuggestions() events=$ctrl.items event=$ctrl.item upgrade=$ctrl.upgrade parent=$ctrl.parent type=Treatment guest=$ctrl.guest></upgrade-event> </div> </div> <div class=c-upsell__upgrades--spaday ng-if=\"$ctrl.itemIs('SpaDay')\"> <div class=c-upsell__upgrade> <upgrade-event get-suggestions=$ctrl.getSuggestions() events=$ctrl.items event=$ctrl.item upgrade=$ctrl.upgrade parent=$ctrl.parent type=SpaDay guest=$ctrl.guest></upgrade-event> </div> </div> <div class=c-upsell__upgrades--options ng-if=\"$ctrl.itemIs('OptionGroupOption')\"> <div class=c-upsell__upgrade> <upgrade-option get-suggestions=$ctrl.getSuggestions() event=$ctrl.item parent=$ctrl.parent></upgrade-option> </div> </div> <div ng-if=$ctrl.unavailable class=\"c-empty c-empty--box\"> <p class=\"c-empty__message text-center\"> Sorry, not enough availability to upgrade. </p> </div> ";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        getSuggestions: '&',
        events: '<',
        event: '<',
        upgrade: '<',
        parent: '<',
        type: '@',
        guest: '<'
    },
    controller: 'upgradeEventController',
    template: __webpack_require__(446)
};

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "<div class=c-upgrade__success ng-show=$ctrl.event.upgraded> <icon icon=tick></icon><span>{{ $ctrl.eventOriginalName() }} upgraded to {{ $ctrl.eventUpgradedName() }}</span> </div> <div ng-show=!$ctrl.event.upgraded> <div class=grid-x> <div class=\"cell small-12 / c-upgrade__container\"> <div class=grid-x> <div class=\"cell small-12 medium-auto\"> <div class=\"c-upgrade__image c-upgrade__image--original\" ng-if=$ctrl.event.item.image_url imgix-src=\"{{ $ctrl.event.item.override_image_url || $ctrl.event.item.image_url }}\"></div> <div class=\"c-upgrade__event c-upgrade__event--original\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.event.item.name }}</h4> </div> </div> <div class=c-upgrade__chevron> <div class=c-upgrade__chevron__text> Upgrade to </div> <icon icon=chevron-right class=\"c-upgrade__right c-upgrade__icon\"></icon> <icon icon=chevron-down class=\"c-upgrade__down c-upgrade__icon\"></icon> </div> <div class=\"cell small-12 medium-auto\"> <div class=c-upgrade__image ng-if=$ctrl.upgrade.image imgix-src=\"{{ $ctrl.upgrade.image }}\" imgix-refresh> <div class=\"c-upgrade__event__price / c-tile__price\" ng-class=\"{' / t-text--secondary--background': $ctrl.upgrade.availability.offer }\"> Upgrade for <s ng-if=\"$ctrl.upgrade.availability.offer && $ctrl.originalPrice() > 0\"> <money amount=$ctrl.originalPrice() decorate=true></money> </s> <money amount=$ctrl.upgradePrice() decorate=true ng-if=\"$ctrl.upgradePrice() > 0\"></money> <span ng-if=\"$ctrl.upgradePrice() <= 0\"> FREE </span> </div> </div> <div class=\"c-upgrade__event c-upgrade__event--upgrade\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.upgrade.name }}</h4> </div> </div> </div> </div> </div> <div class=grid-x> <div class=\"cell auto\"></div> <div class=\"cell shrink\"> <button class=c-button ng-click=$ctrl.upgradeEvent() ng-disabled=$ctrl.basket.saving> <span ng-if=!$ctrl.events>Upgrade this {{ $ctrl.eventTypeDisplayName() }}</span> <span ng-if=$ctrl.events>Upgrade {{ $ctrl.events.length }} {{ $ctrl.eventTypeDisplayName() }}s</span> </button> </div> <div class=\"cell auto\"></div> </div> </div> ";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        getSuggestions: '&',
        event: '=',
        parent: '<'
    },
    controller: 'upgradeEventController',
    template: __webpack_require__(448)
};

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div class=c-upgrade__success ng-if=$ctrl.event.upgraded> <icon icon=tick></icon><span>{{ $ctrl.eventOriginalName() }} upgraded to {{ $ctrl.eventUpgradedName() }}</span> </div> <div ng-if=!$ctrl.event.upgraded> <div class=grid-x> <div class=\"cell small-12 / c-upgrade__container c-upgrade__container--option\"> <div class=grid-x> <div class=\"cell small-12 medium-auto\"> <div class=c-upgrade__image ng-if=\"$ctrl.event.item.override_image_url && $ctrl.event.item.upgrade_image_url\" imgix-src=\"{{ $ctrl.event.item.override_image_url }}\" imgix-refresh></div> <div class=\"c-upgrade__event c-upgrade__event--original\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.event.item_summary.name }}</h4> </div> </div> <div class=c-upgrade__chevron ng-class=\"{ 'c-upgrade__chevron--short' : !$ctrl.event.item.override_image_url || !$ctrl.event.item.upgrade_image_url }\"> <div class=c-upgrade__chevron__text> Upgrade to </div> <icon icon=chevron-right class=\"c-upgrade__right c-upgrade__icon\"></icon> <icon icon=chevron-down class=\"c-upgrade__down c-upgrade__icon\"></icon> </div> <div class=\"cell small-12 medium-auto\"> <div class=c-upgrade__image ng-if=\"$ctrl.event.item.override_image_url && $ctrl.event.item.upgrade_image_url\" imgix-src=\"{{ $ctrl.event.item.upgrade_image_url }}\" imgix-refresh> <div class=\"c-upgrade__event__price / c-tile__price\"> Upgrade for <span ng-if=\"$ctrl.event.item.upgrade_value > 0\"> <money amount=$ctrl.event.item.upgrade_value decorate=true> </money></span> <span ng-if=\"!$ctrl.event.item.upgrade_value || $ctrl.event.item.upgrade_value <= 0\"> FREE </span> </div> </div> <div class=\"c-upgrade__event c-upgrade__event--upgrade\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.event.item.upgrade_name }}</h4> </div> <div class=c-upgrade__option-price ng-if=\"!$ctrl.event.item.override_image_url || !$ctrl.event.item.upgrade_image_url\"> <div class=\"c-upgrade__event__price / c-tile__price\"> Upgrade for <span ng-if=\"$ctrl.event.item.upgrade_value > 0\"> <money amount=$ctrl.event.item.upgrade_value decorate=true> </money></span> <span ng-if=\"!$ctrl.event.item.upgrade_value || $ctrl.event.item.upgrade_value <= 0\"> FREE </span> </div> </div> </div> </div> </div> </div> <div class=grid-x> <div class=\"cell auto\"></div> <div class=\"cell shrink\"> <button class=c-button ng-disabled=$ctrl.basket.saving ng-click=$ctrl.upgradeEvent()>Upgrade this experience</button> </div> <div class=\"cell auto\"></div> </div> </div> ";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplaySuggestionsController = function () {
    function DisplaySuggestionsController(basket, checkout, suggestionsService, guestnameService, loadingService) {
        _classCallCheck(this, DisplaySuggestionsController);

        this.basket = basket;
        this.checkout = checkout;
        this.suggestionsService = suggestionsService;
        this.guestname = guestnameService;
        this.loadingService = loadingService;
    }

    _createClass(DisplaySuggestionsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.basket.contents.has_suggestions) {
                return this.loadSuggestions().then(function () {
                    if (!_this.isAdmin) {
                        _this.checkout.setStepByName('suggestions');
                    }
                });
            }
        }
    }, {
        key: 'loadSuggestions',
        value: function loadSuggestions() {
            var _this2 = this;

            this.loadingService.startLoading('suggestions');
            return this.requestSuggestions().then(function () {
                _this2.loadingService.stopLoading('suggestions');
            });
        }
    }, {
        key: 'getSuggestions',
        value: function getSuggestions() {
            var _this3 = this;

            this.loadingService.startLoading('suggestions');
            return this.basket.submit('delete_orders').then(function () {
                return _this3.requestSuggestions();
            }).then(function () {
                _this3.loadingService.stopLoading('suggestions');
            });
        }
    }, {
        key: 'requestSuggestions',
        value: function requestSuggestions() {
            var _this4 = this;

            return this.basket.promise.then(function () {
                return _this4.suggestionsService.getSuggestions().then(function () {
                    _this4.setMultiGuestUpgrades();
                    return;
                });
            });
        }
    }, {
        key: 'findAvailableUpgrade',
        value: function findAvailableUpgrade(item) {
            var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var type = item.item_summary.type_name;
            var date = (0, _moment2.default)(item.date).format('YYYY-MM-DD');

            if (item.item_summary.type_name === 'OptionGroupOption') {
                if (item.item.option_type === 'Custom') {
                    return true;
                }

                type = 'Treatment';
            }

            if (item.canUpgradeTo) {
                return this.getUpgradeOrUnset(date, type, item, quantity);
            }
        }
    }, {
        key: 'getUpgradeOrUnset',
        value: function getUpgradeOrUnset(date, type, item, quantity) {
            var upgrade = this.suggestionsService.getAvailableUpgrade(date, type, item.canUpgradeTo, item.preferred_time, quantity);
            if (upgrade) {
                return upgrade;
            }

            item.canUpgradeTo = false;
            return false;
        }
    }, {
        key: 'itemOrChildrenCanUpgrade',
        value: function itemOrChildrenCanUpgrade(item) {
            if (this.canUpgradeSingleItem(item)) {
                return true;
            }

            if (item.item_children) {
                return !!item.item_children.find(function (child) {
                    return child.canUpgradeTo || child.upgraded;
                });
            }

            return false;
        }
    }, {
        key: 'upgradeAvailable',
        value: function upgradeAvailable() {
            var _this5 = this;

            return !!this.basket.contents.guest_details.find(function (guest) {
                return _this5.guestCanUpgrade(guest);
            });
        }
    }, {
        key: 'guestCanUpgrade',
        value: function guestCanUpgrade(guest) {
            var _this6 = this;

            return !!guest.item_details.find(function (item) {
                return _this6.itemOrChildrenCanUpgrade(item);
            });
        }
    }, {
        key: 'canShowUpgrades',
        value: function canShowUpgrades() {
            return !this.loadingService.isLoading('suggestions') && (this.upgradeAvailable() || !!(this.multiGuestUpgrades && this.multiGuestUpgrades.length > 0));
        }
    }, {
        key: 'canShowRelated',
        value: function canShowRelated(type) {
            if (this.loadingService.isLoading('suggestions')) {
                return false;
            }

            this.related = this.related || this.suggestionsService.getRelated();

            return !!(this.related[type] && Object.keys(this.related[type]).length > 0);
        }
    }, {
        key: 'getRelated',
        value: function getRelated(type) {
            return this.related[type];
        }
    }, {
        key: 'guestName',
        value: function guestName(guest, suffix) {
            return this.guestname.format(guest, true, suffix);
        }
    }, {
        key: 'hasNoSuggestions',
        value: function hasNoSuggestions() {
            return !this.loadingService.isLoading('suggestions') && !this.upgradeAvailable() && !this.suggestionsService.hasRelated();
        }
    }, {
        key: 'canUpgradeSingleItem',
        value: function canUpgradeSingleItem(item) {
            return item.item_summary && item.item_summary.minimum_guests === 1 && (!!item.canUpgradeTo || item.upgraded === 1);
        }
    }, {
        key: 'setMultiGuestUpgrades',
        value: function setMultiGuestUpgrades() {
            var _this7 = this;

            this.multiGuestUpgrades = [];
            this.basket.contents.guest_details.forEach(function (guest) {
                guest.item_details.forEach(function (item) {
                    if (item.item_summary.minimum_guests > 1 && (item.canUpgradeTo || item.upgraded === 1)) {

                        var guestName = _this7.guestname.format(guest, true);

                        if (_this7.multiGuestUpgrades.length > 0) {
                            var foundUpgrade = _this7.multiGuestUpgrades.find(function (upgrade) {
                                return upgrade.reference === item.reference;
                            });

                            if (foundUpgrade) {
                                foundUpgrade.guests.push(guestName);
                                foundUpgrade.items.push(item);
                                return;
                            }
                        }

                        _this7.multiGuestUpgrades.push({
                            guests: [guestName],
                            items: [item],
                            reference: item.reference
                        });
                    }
                });
            });
        }
    }]);

    return DisplaySuggestionsController;
}();

DisplaySuggestionsController.$inject = ['basket', 'checkout', 'suggestionsService', 'guestnameService', 'loadingService'];

exports.default = DisplaySuggestionsController;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplaySuggestionsUpgradeController = function () {
    function DisplaySuggestionsUpgradeController() {
        _classCallCheck(this, DisplaySuggestionsUpgradeController);
    }

    _createClass(DisplaySuggestionsUpgradeController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.items && !this.item) {
                this.item = this.items[0];
            }

            this.unavailable = false;
        }
    }, {
        key: 'itemIs',
        value: function itemIs(type) {
            if (!this.item || !this.item.upgraded && !this.upgrade) {
                this.unavailable = true;
                return false;
            }

            if (this.upgrade && this.upgrade.availability && !this.upgrade.availability.available) {
                this.unavailable = true;
                return false;
            }

            if (type === 'Treatment' && this.item.item.type_name === 'OptionGroupOption') {
                return this.item.item.option_id > 0;
            }

            if (type === 'OptionGroupOption' && this.item.item.option_id > 0) {
                return false;
            }

            return this.item && this.item.item && this.item.item.type_name === type;
        }
    }, {
        key: 'showUpgrade',
        value: function showUpgrade() {
            // Don't show upgrades to linked integrated treatments
            return !!(this.item && !this.item.item.option_is_integrated);
        }
    }]);

    return DisplaySuggestionsUpgradeController;
}();

exports.default = DisplaySuggestionsUpgradeController;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UpgradeEventController = function () {
    function UpgradeEventController(upgradeService, basket, messageService) {
        _classCallCheck(this, UpgradeEventController);

        this.upgradeService = upgradeService;
        this.basket = basket;
        this.messageService = messageService;
    }

    _createClass(UpgradeEventController, [{
        key: 'originalPrice',
        value: function originalPrice() {
            var price = this.upgrade.availability.original_price - this.event.item_summary.price.original_price;
            if (this.events) {
                price = price * this.events.length;
            }
            return price;
        }
    }, {
        key: 'upgradePrice',
        value: function upgradePrice() {
            if (this.event.item.type_name === 'OptionGroupOption') {
                return this.upgrade.availability.price - this.event.item_summary.price.original_price;
            }

            var price = this.upgrade.availability.price - this.event.item_summary.price.price;
            if (this.events) {
                price = price * this.events.length;
            }
            return price;
        }
    }, {
        key: 'eventTypeDisplayName',
        value: function eventTypeDisplayName() {
            var eventType = this.event.item.type_name;

            switch (eventType) {
                case 'SpaDay':
                    return 'Spa Day';
                case 'OptionGroupOption':
                    return 'Treatment';
                default:
                    return eventType;
            }
        }
    }, {
        key: 'upgradeEvent',
        value: function upgradeEvent() {
            var _this = this;

            if (this.events || this.event) {
                if (!this.events) {
                    this.events = [this.event];
                }
                return this.upgradeService.upgrade(this.events).then(function () {
                    _this.getSuggestions();
                }).catch(function () {
                    var string = 'one or more events could not be upgraded';
                    if (_this.events.length === 1) {
                        string = 'we could not upgrade ' + ((0, _lodash.head)(_this.events).item.override_name || (0, _lodash.head)(_this.events).item_summary.name);
                    }
                    _this.messageService.failure('Sorry, ' + string + '. Please try again or contact us for help.');
                    _this.messageService.push();
                });
            }
        }
    }, {
        key: 'eventOriginalName',
        value: function eventOriginalName() {
            if (this.event.item_summary.type_name === 'OptionGroupOption') {
                return this.event.item.override_name || this.event.item.name;
            }

            return this.event.upgrade_from_name;
        }
    }, {
        key: 'eventUpgradedName',
        value: function eventUpgradedName() {
            if (this.event.item_summary.type_name === 'OptionGroupOption') {
                return this.event.item.upgrade_name || this.event.item_summary.name;
            }

            return this.event.item.name;
        }
    }, {
        key: 'displayDate',
        value: function displayDate() {
            var date = (0, _moment2.default)(this.event.date).format('dddd, Do MMMM, YYYY');
            if (this.event.preferred_time) {
                date = date + ' at ' + this.event.preferred_time.substring(0, 5);
            }
            return date;
        }
    }]);

    return UpgradeEventController;
}();

UpgradeEventController.$inject = ['upgradeService', 'basket', 'messageService'];

exports.default = UpgradeEventController;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scriptjs = __webpack_require__(453);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var externalScriptService = function externalScriptService() {
  return {
    load: function load(url) {
      return new Promise(function (resolve) {
        return (0, _scriptjs2.default)(url, resolve);
      });
    }
  };
};

externalScriptService.$inject = [];

exports.default = externalScriptService;

/***/ }),
/* 453 */,
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _billingDetails = __webpack_require__(455);

var _billingDetails2 = _interopRequireDefault(_billingDetails);

var _customerDetails = __webpack_require__(457);

var _customerDetails2 = _interopRequireDefault(_customerDetails);

var _paymentDetails = __webpack_require__(459);

var _paymentDetails2 = _interopRequireDefault(_paymentDetails);

var _countrySelector = __webpack_require__(461);

var _countrySelector2 = _interopRequireDefault(_countrySelector);

var _paymentRequestButton = __webpack_require__(463);

var _paymentRequestButton2 = _interopRequireDefault(_paymentRequestButton);

var _countrySelector3 = __webpack_require__(465);

var _countrySelector4 = _interopRequireDefault(_countrySelector3);

var _paymentDetails3 = __webpack_require__(466);

var _paymentDetails4 = _interopRequireDefault(_paymentDetails3);

var _customerDetails3 = __webpack_require__(467);

var _customerDetails4 = _interopRequireDefault(_customerDetails3);

var _paymentRequestButton3 = __webpack_require__(468);

var _paymentRequestButton4 = _interopRequireDefault(_paymentRequestButton3);

var _paymentToken = __webpack_require__(469);

var _paymentToken2 = _interopRequireDefault(_paymentToken);

var _cardAction = __webpack_require__(470);

var _cardAction2 = _interopRequireDefault(_cardAction);

var _paysafeError = __webpack_require__(471);

var _paysafeError2 = _interopRequireDefault(_paysafeError);

var _paymentGateway = __webpack_require__(472);

var _paymentGateway2 = _interopRequireDefault(_paymentGateway);

var _paysafeGateway = __webpack_require__(473);

var _paysafeGateway2 = _interopRequireDefault(_paysafeGateway);

var _paymentError = __webpack_require__(474);

var _paymentError2 = _interopRequireDefault(_paymentError);

var _stripeGateway = __webpack_require__(475);

var _stripeGateway2 = _interopRequireDefault(_stripeGateway);

var _paymentConnect = __webpack_require__(476);

var _paymentConnect2 = _interopRequireDefault(_paymentConnect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentModule = angular.module('journey-ui.shared.payment', ['journey-ui.shared.core']).component('billingDetails', _billingDetails2.default).component('countrySelector', _countrySelector2.default).component('customerDetails', _customerDetails2.default).component('paymentDetails', _paymentDetails2.default).component('paymentRequestButton', _paymentRequestButton2.default).controller('countrySelectorController', _countrySelector4.default).controller('paymentDetailsController', _paymentDetails4.default).controller('customerDetailsController', _customerDetails4.default).controller('paymentRequestButtonController', _paymentRequestButton4.default).factory('paymentTokenService', _paymentToken2.default).factory('cardActionService', _cardAction2.default).factory('paymentGatewayService', _paymentGateway2.default).factory('paymentConnectService', _paymentConnect2.default).factory('paymentErrorService', _paymentError2.default).factory('paysafeGatewayService', _paysafeGateway2.default).factory('stripeGatewayService', _stripeGateway2.default).factory('paysafeErrorService', _paysafeError2.default);

exports.default = paymentModule.name;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    model: '='
  },
  template: __webpack_require__(456)
};

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "<div class=\"grid-x grid-padding-x\"> <div class=\"cell small-12\"> <h5 class=c-payment__subheading>Payment billing address</h5> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input name=bill-address autocomplete=\"billing street-address\" class=\"field c-payment__input\" type=text placeholder=Street ng-model=$ctrl.model.avs_street required form-field-errors/> <span class=c-payment__label__label><span>Street</span></span> </label> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input name=bill-city autocomplete=\"billing address-level2\" class=\"field c-payment__input\" type=text placeholder=City ng-model=$ctrl.model.avs_city required form-field-errors/> <span class=c-payment__label__label><span>City</span></span> </label> </div> <div class=\"cell medium-6 large-4\"> <label class=c-payment__label> <input name=bill-state autocomplete=\"billing address-level1\" class=\"field c-payment__input\" type=text placeholder=State/County ng-model=$ctrl.model.avs_state required form-field-errors/> <span class=c-payment__label__label><span>State/County</span></span> </label> </div> <div class=\"cell medium-6 large-4\"> <label class=c-payment__label> <input name=bill-postal autocomplete=\"billing postal-code\" class=\"field c-payment__input\" type=text placeholder=\"Post Code\" ng-model=$ctrl.model.avs_zip required form-field-errors/> <span class=c-payment__label__label><span>Post Code</span></span> </label> </div> <div class=\"cell large-4\"> <label class=c-payment__label> <country-selector model=$ctrl.model.avs_country></country-selector> <span class=\"c-payment__label__label c-payment__label--up\"><span>Country</span></span> </label> </div> </div>";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    model: '=',
    propertyName: '<',
    existingDetails: '<'
  },
  controller: 'customerDetailsController',
  template: __webpack_require__(458)
};

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "<div class=\"grid-x grid-padding-x\"> <div class=\"cell medium-12\"> <h5 class=c-payment__subheading>Your details</h5> </div> <div class=\"cell medium-12\" ng-if=$ctrl.existingDetails.length> <div class=c-payment__guest-select> <p>Use an existing guest or enter new details:</p> <div class=grid-x ng-if=\"$ctrl.existingDetails.length < 3\"> <button ng-repeat=\"guest in $ctrl.existingDetails\" class=\"cell medium-auto / c-payment__guest-select__button\" ng-class=\"{'c-payment__guest-select__button--selected': $ctrl.isGuestSelected(guest)}\" type=button ng-click=$ctrl.useDetails(guest)> {{ guest.fullName }} </button> <button class=\"cell medium-auto / c-payment__guest-select__button c-payment__guest-select__button--manual\" ng-class=\"{'c-payment__guest-select__button--selected': $ctrl.model.selectedGuest === ''}\" type=button ng-click=$ctrl.manualDetails()> Enter new details </button> </div> <div class=\"grid-x grid-margin-x medium-up-2\" ng-if=\"$ctrl.existingDetails.length >= 3\"> <select ng-model=$ctrl.model.selectedGuest class=\"cell / c-payment__guest-select__select\" ng-change=$ctrl.useDetails()> <option value=\"\" disabled=disabled>-- Choose an existing guest --</option> <option ng-repeat=\"guest in $ctrl.existingDetails\" ng-value=guest> {{ guest.fullName }} </option> </select> <button class=\"cell / c-payment__guest-select__button c-payment__guest-select__button--manual\" type=button ng-click=$ctrl.manualDetails()> Enter new details </button> </div> </div> </div> <div class=\"cell medium-6\" ng-show=$ctrl.showManualDetails()> <label class=c-payment__label> <input id=firstName name=firstname type=text class=\"field c-payment__input\" autocomplete=fname ng-model=$ctrl.model.first_name required form-field-errors/> <span class=c-payment__label__label><span>First Name</span></span> </label> </div> <div class=\"cell medium-6\" ng-show=$ctrl.showManualDetails()> <label class=c-payment__label> <input id=lastName name=lastname type=text class=\"field c-payment__input\" autocomplete=lname ng-model=$ctrl.model.last_name required form-field-errors/> <span class=c-payment__label__label><span>Last Name</span></span> </label> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input name=tel class=\"field c-payment__input\" type=tel autocomplete=tel maxlength=20 ng-model=$ctrl.model.phone required form-field-errors/> <span class=c-payment__label__label><span>Phone number</span></span> </label> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input id=emailAddress class=\"field c-payment__input\" type=email autocomplete=email ng-model=$ctrl.model.email required form-field-errors/> <span class=c-payment__label__label><span>Email</span></span> </label> </div> <div class=\"cell medium-12\" ng-show=$ctrl.notLoggedInDetails()> <label class=c-payment__marketing> <input type=checkbox ng-model=$ctrl.model.marketing /> <span> By ticking this box I consent to receive email marketing from {{$ctrl.propertyName}}. </span> </label> </div> </div> ";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    gateway: '<',
    errorCallback: '&',
    totalAmount: '<'
  },
  controller: 'paymentDetailsController',
  template: __webpack_require__(460)
};

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "<div id=payment-details class=\"grid-x grid-padding-x / c-payment-details c-payment-details--paysafe\" ng-if=$ctrl.gateway.paysafe> <div class=\"cell small-12\"> <h5 class=c-payment__subheading>Payment card details</h5> </div> <div class=\"cell medium-6\"> <div id=card-number class=\"paysafe-field / t-border-bottom--primary\"></div> </div> <div class=\"cell medium-3\"> <div id=card-cvv class=\"paysafe-field / t-border-bottom--primary\"></div> </div> <div class=\"cell medium-3\"> <div id=card-expiry class=\"paysafe-field / t-border-bottom--primary\"></div> </div> </div> <div class=\"grid-x grid-padding-x\" ng-if=$ctrl.gateway.stripe> <div class=\"cell small-12\"> <h5 class=c-payment__subheading>Payment card details</h5> </div> <div id=payment-details class=\"c-payment-details c-payment-details--stripe\"></div> </div> <div id=totalPaymentAmount style=display:none>{{ $ctrl.totalAmount }}</div> ";

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    model: '='
  },
  controller: 'countrySelectorController',
  template: __webpack_require__(462)
};

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "<ui-select ng-model=$ctrl.model name=bill-country autocomplete=\"billing country\" required form-field-errors> <ui-select-match placeholder=Country> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.key as item in $ctrl.countries | filter: $select.search track by item.key\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select>";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    gateway: '<',
    errorCallback: '&',
    successCallback: '&',
    paymentConfig: '<'
  },
  controller: 'paymentRequestButtonController',
  template: __webpack_require__(464)
};

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "<div class=c-payment__request> <div id=payment-request-button></div> <p class=c-payment__request__text><span>Or enter your payment details below</span></p> </div> ";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CountrySelectorController = function () {
  function CountrySelectorController() {
    _classCallCheck(this, CountrySelectorController);
  }

  _createClass(CountrySelectorController, [{
    key: '$onInit',
    value: function $onInit() {
      this.setCountries();
    }
  }, {
    key: 'setCountries',
    value: function setCountries() {
      this.countries = [{
        'key': 'GB',
        'name': 'Great Britain',
        'search': 'United Kingdom, UK, England, Wales, Scotland, Northern Ireland'
      }, {
        'key': 'US',
        'name': 'United States of America',
        'search': 'USA'
      }, {
        'key': 'AF',
        'name': 'Afghanistan'
      }, {
        'key': 'AX',
        'name': 'Åland Islands'
      }, {
        'key': 'AL',
        'name': 'Albania'
      }, {
        'key': 'DZ',
        'name': 'Algeria'
      }, {
        'key': 'AS',
        'name': 'American Samoa'
      }, {
        'key': 'AD',
        'name': 'Andorra'
      }, {
        'key': 'AO',
        'name': 'Angola'
      }, {
        'key': 'AI',
        'name': 'Anguilla'
      }, {
        'key': 'AQ',
        'name': 'Antarctica'
      }, {
        'key': 'AG',
        'name': 'Antigua and Barbuda'
      }, {
        'key': 'AR',
        'name': 'Argentina'
      }, {
        'key': 'AM',
        'name': 'Armenia'
      }, {
        'key': 'AW',
        'name': 'Aruba'
      }, {
        'key': 'AU',
        'name': 'Australia'
      }, {
        'key': 'AT',
        'name': 'Austria'
      }, {
        'key': 'AZ',
        'name': 'Azerbaijan'
      }, {
        'key': 'BS',
        'name': 'Bahamas'
      }, {
        'key': 'BH',
        'name': 'Bahrain'
      }, {
        'key': 'BD',
        'name': 'Bangladesh'
      }, {
        'key': 'BB',
        'name': 'Barbados'
      }, {
        'key': 'BY',
        'name': 'Belarus'
      }, {
        'key': 'BE',
        'name': 'Belgium'
      }, {
        'key': 'BZ',
        'name': 'Belize'
      }, {
        'key': 'BJ',
        'name': 'Benin'
      }, {
        'key': 'BM',
        'name': 'Bermuda'
      }, {
        'key': 'BT',
        'name': 'Bhutan'
      }, {
        'key': 'BO',
        'name': 'Bolivia, Plurinational State of'
      }, {
        'key': 'BQ',
        'name': 'Bonaire, Sint Eustatius and Saba'
      }, {
        'key': 'BA',
        'name': 'Bosnia and Herzegovina'
      }, {
        'key': 'BW',
        'name': 'Botswana'
      }, {
        'key': 'BV',
        'name': 'Bouvet Island'
      }, {
        'key': 'BR',
        'name': 'Brazil'
      }, {
        'key': 'IO',
        'name': 'British Indian Ocean Territory'
      }, {
        'key': 'BN',
        'name': 'Brunei Darussalam'
      }, {
        'key': 'BG',
        'name': 'Bulgaria'
      }, {
        'key': 'BF',
        'name': 'Burkina Faso'
      }, {
        'key': 'BI',
        'name': 'Burundi'
      }, {
        'key': 'KH',
        'name': 'Cambodia'
      }, {
        'key': 'CM',
        'name': 'Cameroon'
      }, {
        'key': 'CA',
        'name': 'Canada'
      }, {
        'key': 'CV',
        'name': 'Cape Verde'
      }, {
        'key': 'KY',
        'name': 'Cayman Islands'
      }, {
        'key': 'CF',
        'name': 'Central African Republic'
      }, {
        'key': 'TD',
        'name': 'Chad'
      }, {
        'key': 'CL',
        'name': 'Chile'
      }, {
        'key': 'CN',
        'name': 'China'
      }, {
        'key': 'CX',
        'name': 'Christmas Island'
      }, {
        'key': 'CC',
        'name': 'Cocos (Keeling) Islands'
      }, {
        'key': 'CO',
        'name': 'Colombia'
      }, {
        'key': 'KM',
        'name': 'Comoros'
      }, {
        'key': 'CG',
        'name': 'Congo'
      }, {
        'key': 'CD',
        'name': 'Congo, the Democratic Republic of the'
      }, {
        'key': 'CK',
        'name': 'Cook Islands'
      }, {
        'key': 'CR',
        'name': 'Costa Rica'
      }, {
        'key': 'CI',
        'name': 'Côte d\'Ivoire'
      }, {
        'key': 'HR',
        'name': 'Croatia'
      }, {
        'key': 'CU',
        'name': 'Cuba'
      }, {
        'key': 'CW',
        'name': 'Curaçao'
      }, {
        'key': 'CY',
        'name': 'Cyprus'
      }, {
        'key': 'CZ',
        'name': 'Czech Republic'
      }, {
        'key': 'DK',
        'name': 'Denmark'
      }, {
        'key': 'DJ',
        'name': 'Djibouti'
      }, {
        'key': 'DM',
        'name': 'Dominica'
      }, {
        'key': 'DO',
        'name': 'Dominican Republic'
      }, {
        'key': 'EC',
        'name': 'Ecuador'
      }, {
        'key': 'EG',
        'name': 'Egypt'
      }, {
        'key': 'SV',
        'name': 'El Salvador'
      }, {
        'key': 'GQ',
        'name': 'Equatorial Guinea'
      }, {
        'key': 'ER',
        'name': 'Eritrea'
      }, {
        'key': 'EE',
        'name': 'Estonia'
      }, {
        'key': 'ET',
        'name': 'Ethiopia'
      }, {
        'key': 'FK',
        'name': 'Falkland Islands (Malvinas)'
      }, {
        'key': 'FO',
        'name': 'Faroe Islands'
      }, {
        'key': 'FJ',
        'name': 'Fiji'
      }, {
        'key': 'FI',
        'name': 'Finland'
      }, {
        'key': 'FR',
        'name': 'France'
      }, {
        'key': 'GF',
        'name': 'French Guiana'
      }, {
        'key': 'PF',
        'name': 'French Polynesia'
      }, {
        'key': 'TF',
        'name': 'French Southern Territories'
      }, {
        'key': 'GA',
        'name': 'Gabon'
      }, {
        'key': 'GM',
        'name': 'Gambia'
      }, {
        'key': 'GE',
        'name': 'Georgia'
      }, {
        'key': 'DE',
        'name': 'Germany'
      }, {
        'key': 'GH',
        'name': 'Ghana'
      }, {
        'key': 'GI',
        'name': 'Gibraltar'
      }, {
        'key': 'GR',
        'name': 'Greece'
      }, {
        'key': 'GL',
        'name': 'Greenland'
      }, {
        'key': 'GD',
        'name': 'Grenada'
      }, {
        'key': 'GP',
        'name': 'Guadeloupe'
      }, {
        'key': 'GU',
        'name': 'Guam'
      }, {
        'key': 'GT',
        'name': 'Guatemala'
      }, {
        'key': 'GG',
        'name': 'Guernsey'
      }, {
        'key': 'GN',
        'name': 'Guinea'
      }, {
        'key': 'GW',
        'name': 'Guinea-Bissau'
      }, {
        'key': 'GY',
        'name': 'Guyana'
      }, {
        'key': 'HT',
        'name': 'Haiti'
      }, {
        'key': 'HM',
        'name': 'Heard Island and McDonald Islands'
      }, {
        'key': 'VA',
        'name': 'Holy See (Vatican City State)'
      }, {
        'key': 'HN',
        'name': 'Honduras'
      }, {
        'key': 'HK',
        'name': 'Hong Kong'
      }, {
        'key': 'HU',
        'name': 'Hungary'
      }, {
        'key': 'IS',
        'name': 'Iceland'
      }, {
        'key': 'IN',
        'name': 'India'
      }, {
        'key': 'ID',
        'name': 'Indonesia'
      }, {
        'key': 'IR',
        'name': 'Iran, Islamic Republic of'
      }, {
        'key': 'IQ',
        'name': 'Iraq'
      }, {
        'key': 'IE',
        'name': 'Ireland'
      }, {
        'key': 'IM',
        'name': 'Isle of Man'
      }, {
        'key': 'IL',
        'name': 'Israel'
      }, {
        'key': 'IT',
        'name': 'Italy'
      }, {
        'key': 'JM',
        'name': 'Jamaica'
      }, {
        'key': 'JP',
        'name': 'Japan'
      }, {
        'key': 'JE',
        'name': 'Jersey'
      }, {
        'key': 'JO',
        'name': 'Jordan'
      }, {
        'key': 'KZ',
        'name': 'Kazakhstan'
      }, {
        'key': 'KE',
        'name': 'Kenya'
      }, {
        'key': 'KI',
        'name': 'Kiribati'
      }, {
        'key': 'KP',
        'name': 'Korea, Democratic People\'s Republic of'
      }, {
        'key': 'KR',
        'name': 'Korea, Republic of'
      }, {
        'key': 'KW',
        'name': 'Kuwait'
      }, {
        'key': 'KG',
        'name': 'Kyrgyzstan'
      }, {
        'key': 'LA',
        'name': 'Lao People\'s Democratic Republic'
      }, {
        'key': 'LV',
        'name': 'Latvia'
      }, {
        'key': 'LB',
        'name': 'Lebanon'
      }, {
        'key': 'LS',
        'name': 'Lesotho'
      }, {
        'key': 'LR',
        'name': 'Liberia'
      }, {
        'key': 'LY',
        'name': 'Libya'
      }, {
        'key': 'LI',
        'name': 'Liechtenstein'
      }, {
        'key': 'LT',
        'name': 'Lithuania'
      }, {
        'key': 'LU',
        'name': 'Luxembourg'
      }, {
        'key': 'MO',
        'name': 'Macao'
      }, {
        'key': 'MK',
        'name': 'Macedonia, the Former Yugoslav Republic of'
      }, {
        'key': 'MG',
        'name': 'Madagascar'
      }, {
        'key': 'MW',
        'name': 'Malawi'
      }, {
        'key': 'MY',
        'name': 'Malaysia'
      }, {
        'key': 'MV',
        'name': 'Maldives'
      }, {
        'key': 'ML',
        'name': 'Mali'
      }, {
        'key': 'MT',
        'name': 'Malta'
      }, {
        'key': 'MH',
        'name': 'Marshall Islands'
      }, {
        'key': 'MQ',
        'name': 'Martinique'
      }, {
        'key': 'MR',
        'name': 'Mauritania'
      }, {
        'key': 'MU',
        'name': 'Mauritius'
      }, {
        'key': 'YT',
        'name': 'Mayotte'
      }, {
        'key': 'MX',
        'name': 'Mexico'
      }, {
        'key': 'FM',
        'name': 'Micronesia, Federated States of'
      }, {
        'key': 'MD',
        'name': 'Moldova, Republic of'
      }, {
        'key': 'MC',
        'name': 'Monaco'
      }, {
        'key': 'MN',
        'name': 'Mongolia'
      }, {
        'key': 'ME',
        'name': 'Montenegro'
      }, {
        'key': 'MS',
        'name': 'Montserrat'
      }, {
        'key': 'MA',
        'name': 'Morocco'
      }, {
        'key': 'MZ',
        'name': 'Mozambique'
      }, {
        'key': 'MM',
        'name': 'Myanmar'
      }, {
        'key': 'NA',
        'name': 'Namibia'
      }, {
        'key': 'NR',
        'name': 'Nauru'
      }, {
        'key': 'NP',
        'name': 'Nepal'
      }, {
        'key': 'NL',
        'name': 'Netherlands'
      }, {
        'key': 'NC',
        'name': 'New Caledonia'
      }, {
        'key': 'NZ',
        'name': 'New Zealand'
      }, {
        'key': 'NI',
        'name': 'Nicaragua'
      }, {
        'key': 'NE',
        'name': 'Niger'
      }, {
        'key': 'NG',
        'name': 'Nigeria'
      }, {
        'key': 'NU',
        'name': 'Niue'
      }, {
        'key': 'NF',
        'name': 'Norfolk Island'
      }, {
        'key': 'MP',
        'name': 'Northern Mariana Islands'
      }, {
        'key': 'NO',
        'name': 'Norway'
      }, {
        'key': 'OM',
        'name': 'Oman'
      }, {
        'key': 'PK',
        'name': 'Pakistan'
      }, {
        'key': 'PW',
        'name': 'Palau'
      }, {
        'key': 'PS',
        'name': 'Palestine, State of'
      }, {
        'key': 'PA',
        'name': 'Panama'
      }, {
        'key': 'PG',
        'name': 'Papua New Guinea'
      }, {
        'key': 'PY',
        'name': 'Paraguay'
      }, {
        'key': 'PE',
        'name': 'Peru'
      }, {
        'key': 'PH',
        'name': 'Philippines'
      }, {
        'key': 'PN',
        'name': 'Pitcairn'
      }, {
        'key': 'PL',
        'name': 'Poland'
      }, {
        'key': 'PT',
        'name': 'Portugal'
      }, {
        'key': 'PR',
        'name': 'Puerto Rico'
      }, {
        'key': 'QA',
        'name': 'Qatar'
      }, {
        'key': 'RE',
        'name': 'Réunion'
      }, {
        'key': 'RO',
        'name': 'Romania'
      }, {
        'key': 'RU',
        'name': 'Russian Federation'
      }, {
        'key': 'RW',
        'name': 'Rwanda'
      }, {
        'key': 'BL',
        'name': 'Saint Barthélemy'
      }, {
        'key': 'SH',
        'name': 'Saint Helena, Ascension and Tristan da Cunha'
      }, {
        'key': 'KN',
        'name': 'Saint Kitts and Nevis'
      }, {
        'key': 'LC',
        'name': 'Saint Lucia'
      }, {
        'key': 'MF',
        'name': 'Saint Martin (French part)'
      }, {
        'key': 'PM',
        'name': 'Saint Pierre and Miquelon'
      }, {
        'key': 'VC',
        'name': 'Saint Vincent and the Grenadines'
      }, {
        'key': 'WS',
        'name': 'Samoa'
      }, {
        'key': 'SM',
        'name': 'San Marino'
      }, {
        'key': 'ST',
        'name': 'Sao Tome and Principe'
      }, {
        'key': 'SA',
        'name': 'Saudi Arabia'
      }, {
        'key': 'SN',
        'name': 'Senegal'
      }, {
        'key': 'RS',
        'name': 'Serbia'
      }, {
        'key': 'SC',
        'name': 'Seychelles'
      }, {
        'key': 'SL',
        'name': 'Sierra Leone'
      }, {
        'key': 'SG',
        'name': 'Singapore'
      }, {
        'key': 'SX',
        'name': 'Sint Maarten (Dutch part)'
      }, {
        'key': 'SK',
        'name': 'Slovakia'
      }, {
        'key': 'SI',
        'name': 'Slovenia'
      }, {
        'key': 'SB',
        'name': 'Solomon Islands'
      }, {
        'key': 'SO',
        'name': 'Somalia'
      }, {
        'key': 'ZA',
        'name': 'South Africa'
      }, {
        'key': 'GS',
        'name': 'South Georgia and the South Sandwich Islands'
      }, {
        'key': 'SS',
        'name': 'South Sudan'
      }, {
        'key': 'ES',
        'name': 'Spain'
      }, {
        'key': 'LK',
        'name': 'Sri Lanka'
      }, {
        'key': 'SD',
        'name': 'Sudan'
      }, {
        'key': 'SR',
        'name': 'Suriname'
      }, {
        'key': 'SJ',
        'name': 'Svalbard and Jan Mayen'
      }, {
        'key': 'SZ',
        'name': 'Swaziland'
      }, {
        'key': 'SE',
        'name': 'Sweden'
      }, {
        'key': 'CH',
        'name': 'Switzerland'
      }, {
        'key': 'SY',
        'name': 'Syrian Arab Republic'
      }, {
        'key': 'TW',
        'name': 'Taiwan, Province of China'
      }, {
        'key': 'TJ',
        'name': 'Tajikistan'
      }, {
        'key': 'TZ',
        'name': 'Tanzania, United Republic of'
      }, {
        'key': 'TH',
        'name': 'Thailand'
      }, {
        'key': 'TL',
        'name': 'Timor-Leste'
      }, {
        'key': 'TG',
        'name': 'Togo'
      }, {
        'key': 'TK',
        'name': 'Tokelau'
      }, {
        'key': 'TO',
        'name': 'Tonga'
      }, {
        'key': 'TT',
        'name': 'Trinidad and Tobago'
      }, {
        'key': 'TN',
        'name': 'Tunisia'
      }, {
        'key': 'TR',
        'name': 'Turkey'
      }, {
        'key': 'TM',
        'name': 'Turkmenistan'
      }, {
        'key': 'TC',
        'name': 'Turks and Caicos Islands'
      }, {
        'key': 'TV',
        'name': 'Tuvalu'
      }, {
        'key': 'UG',
        'name': 'Uganda'
      }, {
        'key': 'UA',
        'name': 'Ukraine'
      }, {
        'key': 'AE',
        'name': 'United Arab Emirates'
      }, {
        'key': 'UM',
        'name': 'United States Minor Outlying Islands'
      }, {
        'key': 'UY',
        'name': 'Uruguay'
      }, {
        'key': 'UZ',
        'name': 'Uzbekistan'
      }, {
        'key': 'VU',
        'name': 'Vanuatu'
      }, {
        'key': 'VE',
        'name': 'Venezuela, Bolivarian Republic of'
      }, {
        'key': 'VN',
        'name': 'Viet Nam'
      }, {
        'key': 'VG',
        'name': 'Virgin Islands, British'
      }, {
        'key': 'VI',
        'name': 'Virgin Islands, U.S.'
      }, {
        'key': 'WF',
        'name': 'Wallis and Futuna'
      }, {
        'key': 'EH',
        'name': 'Western Sahara'
      }, {
        'key': 'YE',
        'name': 'Yemen'
      }, {
        'key': 'ZM',
        'name': 'Zambia'
      }, {
        'key': 'ZW',
        'name': 'Zimbabwe'
      }];
    }
  }]);

  return CountrySelectorController;
}();

CountrySelectorController.$inject = [];

exports.default = CountrySelectorController;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentDetailsController = function () {
  function PaymentDetailsController(paymentGatewayService, paymentTokenService, cardActionService) {
    _classCallCheck(this, PaymentDetailsController);

    this.paymentGatewayService = paymentGatewayService;
    this.paymentTokenService = paymentTokenService;
    this.cardActionService = cardActionService;
  }

  _createClass(PaymentDetailsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (!this.gateway) {
        return this.handleError(['Please contact us for help.'], true, 'No gateway set up.');
      }

      return this.paymentGatewayService.mount(this.gateway).then(function (response) {
        if (response) {
          _this.paymentTokenService.setCreateToken(response.createToken);
          _this.cardActionService.setHandleCardAction(response.createAction);
        }
      }).catch(function () {
        return _this.handleError(['Please contact us for help.'], true, 'Fail setting up gateway');
      });
    }
  }, {
    key: 'handleError',
    value: function handleError(error, report, text) {
      this.errorCallback({ error: error, report: report, text: text });
    }
  }]);

  return PaymentDetailsController;
}();

PaymentDetailsController.$inject = ['paymentGatewayService', 'paymentTokenService', 'cardActionService'];

exports.default = PaymentDetailsController;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomerDetailsController = function () {
  function CustomerDetailsController() {
    _classCallCheck(this, CustomerDetailsController);
  }

  _createClass(CustomerDetailsController, [{
    key: '$onInit',
    value: function $onInit() {
      this.initModel();
      this.model.selectedGuest = '';
    }
  }, {
    key: 'initModel',
    value: function initModel() {
      this.model = this.model || {};
    }
  }, {
    key: 'useDetails',
    value: function useDetails(guest) {
      this.initModel();
      if (guest) {
        this.model.selectedGuest = guest;
      }

      if (this.model.selectedGuest) {
        this.model.first_name = this.model.selectedGuest.firstName || '';
        this.model.last_name = this.model.selectedGuest.lastName || '';
        this.model.email = this.model.selectedGuest.email || '';
        this.model.phone = this.model.selectedGuest.phone || '';
      }
    }
  }, {
    key: 'isGuestSelected',
    value: function isGuestSelected(guest) {
      this.initModel();
      return !!(this.model.integration_reference && this.model.integration_reference === guest.integrationReference || this.model.selectedGuest && this.model.selectedGuest.integrationReference === guest.integrationReference);
    }
  }, {
    key: 'manualDetails',
    value: function manualDetails() {
      this.initModel();
      this.model.selectedGuest = '';
      this.model.first_name = '';
      this.model.last_name = '';
      this.model.email = '';
      this.model.phone = '';
      this.model.integration_reference = null;
    }
  }, {
    key: 'showManualDetails',
    value: function showManualDetails() {
      this.initModel();
      return !this.model.integration_reference && !this.model.selectedGuest;
    }
  }, {
    key: 'notLoggedInDetails',
    value: function notLoggedInDetails() {
      this.initModel();
      return !!(!this.model.selectedGuest || this.model.selectedGuest && !this.model.selectedGuest.loggedIn);
    }
  }]);

  return CustomerDetailsController;
}();

CustomerDetailsController.$inject = [];

exports.default = CustomerDetailsController;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentRequestButtonController = function () {
  function PaymentRequestButtonController(paymentGatewayService, paymentTokenService) {
    _classCallCheck(this, PaymentRequestButtonController);

    this.paymentGatewayService = paymentGatewayService;
    this.paymentTokenService = paymentTokenService;
  }

  _createClass(PaymentRequestButtonController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (!this.gateway) {
        return this.handleError(['Please contact us for help.'], 'No gateway set up.');
      }

      return this.paymentGatewayService.mount(this.gateway).then(function (response) {
        return _this.paymentTokenService.generatePaymentButtonToken(response.createPaymentRequestButton, _this.paymentConfig).then(function (token) {
          return _this.handleSuccess(token);
        });
      }).catch(function () {
        _this.handleError(['Please contact us for help.'], 'Fail setting up payment request button');
      });
    }
  }, {
    key: 'handleError',
    value: function handleError(error, report) {
      this.errorCallback({ error: error, report: report });
    }
  }, {
    key: 'handleSuccess',
    value: function handleSuccess(token) {
      if (token) {
        if (token.paymentMethod) {
          var response = {
            timestamp: this.paymentTokenService.getExpiryTimestamp(5),
            token: token.paymentMethod.id,
            customer: {
              first_name: '',
              last_name: '',
              phone: token.payerPhone || '',
              email: token.payerEmail || ''
            },
            card: token.paymentMethod.card || {}
          };

          if (token.payerName) {
            var customerName = token.payerName.split(' ');
            response.customer.first_name = customerName.shift();
            if (customerName.length > 0) {
              response.customer.last_name = customerName.join(' ');
            } else {
              response.customer.last_name = response.customer.first_name;
            }
          }

          return this.successCallback({ response: response });
        }

        this.handleError(['Sorry, there was a problem, please try again.']);
      }
    }
  }]);

  return PaymentRequestButtonController;
}();

PaymentRequestButtonController.$inject = ['paymentGatewayService', 'paymentTokenService'];

exports.default = PaymentRequestButtonController;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentTokenService = function paymentTokenService(paymentErrorService) {
  var createToken = void 0;

  var setCreateToken = function setCreateToken(tokenCreator) {
    return createToken = tokenCreator;
  };

  var getExpiryTimestamp = function getExpiryTimestamp() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

    return (0, _moment2.default)().add(duration, 'minutes').unix();
  };

  var generateToken = function generateToken() {
    if (createToken) {
      return createToken().then(function (token) {
        if (!token.id) {
          throw { message: paymentErrorService.formatError(null) };
        }

        return {
          timestamp: getExpiryTimestamp(5),
          token: token.id,
          card: token.card || {}
        };
      }).catch(function (error) {
        throw [error.message];
      });
    }

    return Promise.reject(['No valid gateway found']);
  };

  var generatePaymentButtonToken = function generatePaymentButtonToken(createPaymentRequestButton, requestConfig) {
    if (createPaymentRequestButton) {
      return createPaymentRequestButton(requestConfig).then(function (paymentRequest) {
        if (paymentRequest) {
          return new Promise(function (resolve, reject) {
            paymentRequest.on('paymentmethod', function (response) {
              if (response.error || !response.paymentMethod) {
                response.complete('fail');
                reject({ message: paymentErrorService.formatError(null) });
              }

              if (response.paymentMethod) {
                response.complete('success');
                resolve(response);
              }
            });
          });
        }
      }).catch(function (error) {
        throw [error.message];
      });
    }

    return Promise.reject(['No valid gateway found']);
  };

  return {
    setCreateToken: setCreateToken,
    generateToken: generateToken,
    generatePaymentButtonToken: generatePaymentButtonToken,
    getExpiryTimestamp: getExpiryTimestamp
  };
};

paymentTokenService.$inject = ['paymentErrorService'];

exports.default = paymentTokenService;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cardActionService = function cardActionService(paymentErrorService) {
  var handleCardActionGateway = void 0;

  var setHandleCardAction = function setHandleCardAction(actionCreator) {
    return handleCardActionGateway = actionCreator;
  };

  var handleCardAction = function handleCardAction(clientSecret) {
    if (handleCardActionGateway) {
      return handleCardActionGateway(clientSecret).then(function (response) {
        if (!response.paymentIntent || response.paymentIntent && !response.paymentIntent.id) {
          throw { message: paymentErrorService.formatError('Sorry, your card could not be authorised.') };
        }

        return true;
      }).catch(function (error) {
        throw [error.message];
      });
    }

    return Promise.reject(['No valid gateway found']);
  };

  return {
    setHandleCardAction: setHandleCardAction,
    handleCardAction: handleCardAction
  };
};

cardActionService.$inject = ['paymentErrorService'];

exports.default = cardActionService;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Converts a Paysafe error code into a Stripe error code (our standard)
 *
 * Currently the Stripe error handling has not been implemented so this service actually
 * just converts to human-readable strings.
 */
var paymentErrorService = function paymentErrorService() {
  var formatError = function formatError(error) {
    var message = '';
    var defaultMessage = 'Please check your card details and try again or contact us for help.';

    if (!error || !error.code) {
      return defaultMessage;
    }

    switch (error.code) {
      case 'neverload':
        message = 'There is a problem with the payment gateway please contact us to complete your order.';
        break;
      case '3002':
      case '3005':
      case '3006':
      case '5068':
        message = 'The card details provided may not be correct, please try again.';
        break;
      case '3009':
      case '3011':
      case '3012':
      case '3013':
      case '3014':
      case '3016':
      case '3022':
      case '3023':
      case '3024':
      case '3032':
      case '3035':
        message = 'The issuing bank has declined your transaction.';
        break;
      case '3036':
      case '3037':
      case '3038':
      case '3039':
      case '3046':
      case '3047':
      case '3048':
      case '3054':
      case '5021':
        message = 'Your transaction was denied.';
        break;
      case '9003':
      default:
        message = defaultMessage;
        break;
    }

    return message;
  };

  return {
    formatError: formatError
  };
};

paymentErrorService.$inject = [];

exports.default = paymentErrorService;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var paymentGatewayService = function paymentGatewayService(paysafeGatewayService, stripeGatewayService) {

  var isLoaded = void 0;

  /*
            * Automatically gets called by mount() but can optionally
            * be called globally on every page (recommended for Stripe for fraud
            * tracking). load() will only ever load a script once.
            */
  var load = function load(options) {
    if (isLoaded) {
      return Promise.resolve();
    }

    var promise = void 0;

    if (options.none) {
      promise = Promise.resolve();
    }

    if (options.paysafe) {
      promise = paysafeGatewayService.load();
    }

    if (options.stripe) {
      promise = stripeGatewayService.load();
    }

    if (promise) {
      return promise.then(function () {
        return isLoaded = true;
      });
    }

    return Promise.reject();
  };

  var mount = function mount(options) {
    return load(options).then(function () {
      if (options.paysafe) {
        return paysafeGatewayService.mount(options.paysafe);
      }

      if (options.stripe) {
        return stripeGatewayService.mount(options.stripe);
      }
    });
  };

  return {
    load: load,
    mount: mount
  };
};

paymentGatewayService.$inject = ['paysafeGatewayService', 'stripeGatewayService'];

exports.default = paymentGatewayService;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var paysafeGatewayService = function paysafeGatewayService($window, externalScriptService, paysafeErrorService) {

  var load = function load() {
    return externalScriptService.load('https://hosted.paysafe.com/js/v1/latest/paysafe.min.js');
  };

  var mount = function mount(gatewayDetails) {
    return setup(gatewayDetails).then(function (instance) {
      return {
        createToken: function createToken() {
          var options = {
            threeDS: {
              amount: parseInt($window.document.getElementById('totalPaymentAmount').innerText),
              currency: '' + $window.config.currency,
              accountId: parseInt('' + $window.config.gateways.paysafe.accountId),
              useThreeDSecureVersion2: true
            },
            vault: {
              holderName: $window.document.getElementById('firstName').value + ' ' + $window.document.getElementById('lastName').value
            }
          };
          return new Promise(function (resolve, reject) {
            instance.tokenize(options, function (instance, error, result) {
              if (error) {
                reject({ message: paysafeErrorService.formatError(error) });
              }

              resolve({ id: result ? result.token : undefined });
            });
          });
        },
        createAction: function createAction() {
          return Promise.resolve();
        },
        createPaymentRequestbutton: function createPaymentRequestbutton() {
          return Promise.resolve();
        }
      };
    });
  };

  var setup = function setup(gatewayDetails) {
    var options = getOptions(gatewayDetails);

    return new Promise(function (resolve, reject) {
      $window.paysafe.fields.setup(gatewayDetails.key, options, function (instance, error) {
        if (error && error !== 'true') {
          reject(error);
        }

        resolve(instance);
      });
    });
  };

  var getOptions = function getOptions(gatewayDetails) {
    return {
      environment: gatewayDetails.env,
      fields: {
        cardNumber: {
          selector: '#card-number',
          placeholder: 'Card Number'
        },
        expiryDate: {
          selector: '#card-expiry',
          placeholder: 'Expiry'
        },
        cvv: {
          selector: '#card-cvv',
          placeholder: 'CVV'
        }
      }
    };
  };

  return {
    load: load,
    mount: mount
  };
};

paysafeGatewayService.$inject = ['$window', 'externalScriptService', 'paysafeErrorService'];

exports.default = paysafeGatewayService;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Converts a Stripe error code into a human readable string
 *
 * Currently the Stripe error handling has not been implemented so this service actually
 * just passes through all messages except for the default.
 */
var paymentErrorService = function paymentErrorService() {
  var defaultMessage = 'Please check your card details and try again or contact us for help.';

  return {
    formatError: function formatError(error) {
      return error ? error : defaultMessage;
    }
  };
};

paymentErrorService.$inject = [];

exports.default = paymentErrorService;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var stripeGatewayService = function stripeGatewayService($window, externalScriptService) {

  var options = {
    style: {
      base: {
        fontSize: '16px'
      }
    }
  };

  var isMounted = false;
  var createToken = void 0;
  var createAction = void 0;
  var createPaymentRequestButton = void 0;

  var load = function load() {
    return externalScriptService.load('https://js.stripe.com/v3/');
  };

  var mount = function mount(gatewayDetails) {
    if (!isMounted) {
      isMounted = true;
      var stripe = $window.Stripe(gatewayDetails.key);
      var element = stripe.elements();

      var cardInput = element.create('card', options);
      cardInput.mount('#payment-details');

      createToken = function createToken() {
        var billingName = $window.document.getElementById('firstName').value + ' ' + $window.document.getElementById('lastName').value;
        var billingEmail = $window.document.getElementById('emailAddress').value;

        return stripe.createPaymentMethod('card', cardInput, {
          billing_details: {
            name: billingName,
            email: billingEmail
          }
        }).then(function (response) {
          if (response.error) {
            throw response.error;
          }

          return response.paymentMethod;
        });
      };

      createAction = function createAction(clientSecret) {
        return stripe.handleCardAction(clientSecret).then(function (response) {
          if (response.error) {
            throw response.error;
          }

          return response;
        });
      };

      createPaymentRequestButton = function createPaymentRequestButton(requestConfig) {
        var paymentRequest = stripe.paymentRequest({
          country: requestConfig.country,
          currency: requestConfig.currency,
          total: {
            label: 'Order total',
            amount: requestConfig.amount
          },
          requestPayerName: true,
          requestPayerEmail: true,
          requestPayerPhone: true
        });

        var prButton = element.getElement('paymentRequestButton');
        if (!prButton) {
          prButton = element.create('paymentRequestButton', {
            paymentRequest: paymentRequest
          });
        }

        return paymentRequest.canMakePayment().then(function (result) {
          if (result) {
            prButton.mount('#payment-request-button');
            $window.document.getElementsByClassName('c-payment__request')[0].style.display = 'block';
            return paymentRequest;
          }
        });
      };
    }

    return Promise.resolve({
      createToken: createToken,
      createAction: createAction,
      createPaymentRequestButton: createPaymentRequestButton
    });
  };

  return {
    load: load,
    mount: mount
  };
};

stripeGatewayService.$inject = ['$window', 'externalScriptService'];

exports.default = stripeGatewayService;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['api', function (api) {
  return {
    connect: function connect(authCode, modelId, endpoint) {
      return api.post('' + endpoint, { code: authCode, modelId: modelId }).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = __webpack_require__(478);

var _base2 = _interopRequireDefault(_base);

var _errorBroadcast = __webpack_require__(480);

var _errorBroadcast2 = _interopRequireDefault(_errorBroadcast);

var _apiForm = __webpack_require__(481);

var _apiForm2 = _interopRequireDefault(_apiForm);

var _app = __webpack_require__(484);

var _app2 = _interopRequireDefault(_app);

var _fileUploadInput = __webpack_require__(485);

var _fileUploadInput2 = _interopRequireDefault(_fileUploadInput);

var _adminMenu = __webpack_require__(486);

var _adminMenu2 = _interopRequireDefault(_adminMenu);

var _message = __webpack_require__(487);

var _message2 = _interopRequireDefault(_message);

var _audit = __webpack_require__(488);

var _audit2 = _interopRequireDefault(_audit);

var _apiForm3 = __webpack_require__(489);

var _apiForm4 = _interopRequireDefault(_apiForm3);

var _fileUploadInput3 = __webpack_require__(490);

var _fileUploadInput4 = _interopRequireDefault(_fileUploadInput3);

var _app3 = __webpack_require__(492);

var _app4 = _interopRequireDefault(_app3);

var _spinner = __webpack_require__(494);

var _spinner2 = _interopRequireDefault(_spinner);

var _adminMenu3 = __webpack_require__(496);

var _adminMenu4 = _interopRequireDefault(_adminMenu3);

var _message3 = __webpack_require__(498);

var _message4 = _interopRequireDefault(_message3);

var _audits = __webpack_require__(500);

var _audits2 = _interopRequireDefault(_audits);

var _helpArea = __webpack_require__(502);

var _helpArea2 = _interopRequireDefault(_helpArea);

var _textCheatsheet = __webpack_require__(504);

var _textCheatsheet2 = _interopRequireDefault(_textCheatsheet);

var _periodCheatsheet = __webpack_require__(506);

var _periodCheatsheet2 = _interopRequireDefault(_periodCheatsheet);

var _logoWords = __webpack_require__(508);

var _logoWords2 = _interopRequireDefault(_logoWords);

var _logoIcon = __webpack_require__(510);

var _logoIcon2 = _interopRequireDefault(_logoIcon);

var _icon = __webpack_require__(512);

var _icon2 = _interopRequireDefault(_icon);

var _brandingBanner = __webpack_require__(546);

var _brandingBanner2 = _interopRequireDefault(_brandingBanner);

var _formFieldErrors = __webpack_require__(548);

var _formFieldErrors2 = _interopRequireDefault(_formFieldErrors);

var _required = __webpack_require__(549);

var _required2 = _interopRequireDefault(_required);

var _confirm = __webpack_require__(550);

var _confirm2 = _interopRequireDefault(_confirm);

var _markdown = __webpack_require__(551);

var _markdown2 = _interopRequireDefault(_markdown);

var _markdown3 = __webpack_require__(552);

var _markdown4 = _interopRequireDefault(_markdown3);

var _api = __webpack_require__(554);

var _api2 = _interopRequireDefault(_api);

var _message5 = __webpack_require__(555);

var _message6 = _interopRequireDefault(_message5);

var _access = __webpack_require__(556);

var _access2 = _interopRequireDefault(_access);

var _readability = __webpack_require__(557);

var _readability2 = _interopRequireDefault(_readability);

var _audit3 = __webpack_require__(558);

var _audit4 = _interopRequireDefault(_audit3);

var _currentProperty = __webpack_require__(559);

var _currentProperty2 = _interopRequireDefault(_currentProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseModule = angular.module('spabooker.base', []).config(_base2.default).config(_errorBroadcast2.default).controller('appController', _app2.default).controller('apiFormController', _apiForm2.default).controller('fileUploadController', _fileUploadInput2.default).controller('adminMenuController', _adminMenu2.default).controller('messageController', _message2.default).controller('auditController', _audit2.default).component('apiForm', _apiForm4.default).component('fileUpload', _fileUploadInput4.default).component('app', _app4.default).component('spinner', _spinner2.default).component('adminMenu', _adminMenu4.default).component('message', _message4.default).component('audits', _audits2.default).component('helpArea', _helpArea2.default).component('textCheatsheet', _textCheatsheet2.default).component('periodCheatsheet', _periodCheatsheet2.default).component('logoWords', _logoWords2.default).component('logoIcon', _logoIcon2.default).component('icon', _icon2.default).component('branding', _brandingBanner2.default).directive('formFieldErrors', _formFieldErrors2.default).directive('required', _required2.default).directive('ngRequired', _required2.default).directive('confirm', _confirm2.default).directive('markdown', _markdown2.default).factory('markdownService', _markdown4.default).factory('readabilityService', _readability2.default).factory('messageService', _message6.default).factory('access', _access2.default).factory('api', _api2.default).factory('auditService', _audit4.default).factory('currentPropertyService', _currentProperty2.default);

exports.default = baseModule.name;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__(479);

exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app', {
    abstract: true,
    url: '',
    component: 'app',
    resolve: {
      state: (0, _base.resolveBaseState)()
    },
    roles: []
  }).state('app.admin', {
    abstract: true,
    url: '/admin',
    template: '<div ui-view></div>',
    roles: []
  });
}];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveBaseState = exports.resolveBaseState = function resolveBaseState() {
    return ['$state', 'properties', function ($state, properties) {
        return properties.find().catch(function (error) {
            return $state.transitionTo(error);
        });
    }];
};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$httpProvider', function ($httpProvider) {
  var isBasketResponse = function isBasketResponse(response) {
    return response.data === 'not_found' || response.data === 'expired';
  };

  $httpProvider.interceptors.push(['$rootScope', '$q', '$state', '$window', 'authService', function ($rootScope, $q, $state, $window, authService) {
    return {
      'responseError': function responseError(response) {
        if (response.status === 500) {
          $state.go('500', {}, { location: false });
        }

        if (response.status === 404) {
          if (!isBasketResponse(response)) {
            $state.go('404', {}, { location: false });
          }
        }

        if (response.status === 403) {
          $state.go('403', {}, { location: false });
        }

        if (response.status === 401) {
          authService.logout();
        }

        return $q.reject(response);
      }
    };
  }]);
}];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _flat = __webpack_require__(482);

var _flat2 = _interopRequireDefault(_flat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var distributeErrors = function distributeErrors(form, errors) {
    if (typeof errors === 'string') {
        errors = [errors];
    }
    if (errors.message) {
        return [errors.message];
    }

    var unmappedErrors = [];

    errors = _flat2.default.flatten(errors, { safe: true });

    (0, _lodash.forEach)(errors, function (error, field) {
        if (form[field]) {
            form[field].$registerApiError(error);
        } else {
            unmappedErrors.push(error);
        }
    });

    return unmappedErrors;
};

var ApiFormController = function () {
    function ApiFormController() {
        _classCallCheck(this, ApiFormController);
    }

    _createClass(ApiFormController, [{
        key: 'handleSave',
        value: function handleSave() {
            var _this = this;

            this.form.$api = {
                reset: function reset() {
                    _this.form.$api.$error = null;
                    _this.form.$api.$invalid = false;
                    _this.form.$api.$valid = true;
                },

                setErrors: function setErrors(errors) {
                    var unmappedErrors = distributeErrors(_this.form, errors);
                    _this.form.$api.$error = unmappedErrors.length ? (0, _lodash.flatten)(unmappedErrors) : null;
                    _this.form.$api.$valid = false;
                    _this.form.$api.$invalid = true;
                }
            };

            if (this.form.$valid && this.onSave) {
                this.saving = true;

                return this.onSave().then(function (result) {
                    _this.saving = false;

                    if (_this.onSuccess) {
                        return _this.onSuccess({ result: result });
                    }
                }).catch(function (errors) {
                    _this.saving = false;
                    if (errors.data) {
                        _this.form.$api.setErrors(errors.data);
                    }
                    if (_this.onError) {
                        return _this.onError({ errors: errors });
                    }
                });
            }
        }
    }]);

    return ApiFormController;
}();

ApiFormController.$inject = [];

exports.default = ApiFormController;

/***/ }),
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(322);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppController = function () {
    function AppController($rootScope, $state, permissionsService) {
        _classCallCheck(this, AppController);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.user = permissionsService.user;
    }

    _createClass(AppController, [{
        key: 'getOffcanvasCollapsed',
        value: function getOffcanvasCollapsed() {
            return _store2.default.get('offcanvasCollapsed');
        }
    }, {
        key: 'setOffcanvasCollapsed',
        value: function setOffcanvasCollapsed() {
            var current = _store2.default.get('offcanvasCollapsed');
            _store2.default.set('offcanvasCollapsed', !current);
        }
    }]);

    return AppController;
}();

AppController.$inject = ['$rootScope', '$state', 'permissionsService'];

exports.default = AppController;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileUploadController = function () {
    function FileUploadController() {
        _classCallCheck(this, FileUploadController);
    }

    _createClass(FileUploadController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.ngModel.$render = function () {
                return _this.file = _this.ngModel.$viewValue;
            };
            this.type = this.type || 'Image';
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            this.currentUrl = undefined;
            this.ngModel.$setViewValue(this.file);
        }
    }, {
        key: 'isFile',
        value: function isFile(file) {
            return (typeof file === 'undefined' ? 'undefined' : _typeof(file)) === 'object';
        }
    }]);

    return FileUploadController;
}();

FileUploadController.$inject = [];

exports.default = FileUploadController;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminMenuController = function () {
    function AdminMenuController($rootScope, permissionsService, access, integrationService) {
        _classCallCheck(this, AdminMenuController);

        this.$rootScope = $rootScope;
        this.user = permissionsService.user;
        this.access = access;
        this.integrationService = integrationService;
    }

    _createClass(AdminMenuController, [{
        key: 'hasIntegration',
        value: function hasIntegration() {
            return this.integrationService.hasIntegration();
        }
    }, {
        key: 'hasLinkedIntegration',
        value: function hasLinkedIntegration() {
            return this.integrationService.hasLinkedIntegration();
        }
    }, {
        key: 'isNonRevspa',
        value: function isNonRevspa() {
            return this.integrationService.isNonRevspa();
        }
    }]);

    return AdminMenuController;
}();

AdminMenuController.$inject = ['$rootScope', 'permissionsService', 'access', 'integrationService'];

exports.default = AdminMenuController;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageController = function MessageController(messageService) {
  _classCallCheck(this, MessageController);

  this.messageService = messageService;
};

MessageController.$inject = ['messageService'];

exports.default = MessageController;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuditController = function () {
    function AuditController($rootScope, $state, authService, auditService) {
        _classCallCheck(this, AuditController);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.authService = authService;
        this.auditService = auditService;
        // $ngRedux.connect(function(state){ return {user: state.user} })(this);
    }

    _createClass(AuditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.auditService.find(this.class, this.id).then(function (response) {
                _this.audits = response;
            });
        }
    }]);

    return AuditController;
}();

AuditController.$inject = ['$rootScope', '$state', 'authService', 'auditService'];

exports.default = AuditController;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    onSave: '&',
    onSuccess: '&',
    onError: '&',
    saving: '=?',
    form: '=?'
  },
  transclude: {
    buttons: '?formButtons'
  },
  controller: 'apiFormController',
  template: '\n    <form name="$ctrl.form" ng-submit="$ctrl.handleSave()" novalidate>\n      <div class="alert alert--fail" ng-if="$ctrl.form.$api.$error">\n        <span ng-repeat="error in $ctrl.form.$api.$error">\n          {{ error }}\n        </span>\n      </div>\n\n      <ng-transclude></ng-transclude>\n\n      <div class="c-form__actions" ng-transclude ng-transclude-slot="buttons">\n        <button class="button round" type="submit" ng-disabled="$ctrl.saving || $ctrl.form.$invalid">\n          Submit <spinner ng-if="$ctrl.saving" />\n        </button>\n      </div>\n    </form>\n  '
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        accept: '@',
        currentUrl: '=',
        noPreview: '<',
        darkBackground: '<',
        type: '@'
    },
    require: {
        ngModel: 'ngModel'
    },
    controller: 'fileUploadController',
    template: __webpack_require__(491)
};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "<div class=c-file-upload> <div> <div ngf-drop ngf-select ng-model=$ctrl.file ngf-max-size=15MB ngf-accept=$ctrl.accept class=c-file-upload__drop-box ngf-change=$ctrl.onChange()> <span class=c-file-upload__instructions>Drag file here or <span class=c-file-upload__browse>browse</span></span> </div> </div> <div class=c-preview ng-if=\"$ctrl.file && $ctrl.isFile($ctrl.file) && !$ctrl.noPreview\"> <img class=c-preview__thumbnail ng-class=\"{ 'c-preview__thumbnail--dark': $ctrl.darkBackground }\" ngf-thumbnail=$ctrl.file ngf-size=\"{ height: 80, quality: 0.9 }\"> <div class=c-preview__name> {{ $ctrl.file.name }} </div> <a class=c-file-upload__remove ng-click=\"e.preventDefault();$ctrl.file=undefined;$ctrl.currentUrl=undefined;$ctrl.onChange();\"> <icon icon=cross></icon> Remove {{ $ctrl.type }} </a> </div> <div ng-if=!$ctrl.noPreview> <div class=c-preview ng-if=\"$ctrl.file && !$ctrl.isFile($ctrl.file)\"> <div class=c-preview__thumbnail-imgix> <div class=\"imgix-fluid has-loaded\" imgix-src=\"{{ $ctrl.file }}\" data-fit=fit></div> </div> <a class=c-file-upload__remove ng-click=\"e.preventDefault();$ctrl.file=undefined;$ctrl.currentUrl=undefined;$ctrl.onChange();\"> <icon icon=cross></icon> Remove {{ $ctrl.type }} </a> </div> <div class=c-preview ng-if=\"!$ctrl.file && $ctrl.currentUrl\"> <img class=c-preview__thumbnail ng-class=\"{ 'c-preview__thumbnail--dark': $ctrl.darkBackground }\" ng-src=\"{{ $ctrl.currentUrl }}\"> <a class=c-file-upload__remove ng-click=\"e.preventDefault();$ctrl.file=undefined;$ctrl.currentUrl=undefined;$ctrl.onChange();\"> <icon icon=cross></icon> Remove {{ $ctrl.type }} </a> </div> </div> </div> ";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    currentProperty: '<',
    properties: '<'
  },
  controller: 'appController',
  template: __webpack_require__(493)
};

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "<div class=off-canvas-wrapper ng-class=\"{'off-canvas--collapsed': $ctrl.getOffcanvasCollapsed()}\"> <div class=\"off-canvas position-left reveal-for-large\" id=left-menu data-off-canvas> <a ui-sref=app.dashboard class=off-canvas-title> <logo-words></logo-words> </a> <div class=side-styling> <admin-menu class=side-styling></admin-menu> </div> </div> <div class=off-canvas-content data-off-canvas-content> <div class=top-bar> <div class=\"top-bar-left / u-fade-in\"> <a class=\"left-off-canvas-toggle / off-canvas__menu-icon\" ng-click=$ctrl.setOffcanvasCollapsed()> <icon icon=menu></icon> <span class=show-for-sr>Menu</span> </a> <property-selector current-property=$ctrl.currentProperty properties=$ctrl.properties></property-selector> </div> <div class=\"top-bar-right / u-fade-in\"> <user-menu></user-menu> </div> </div> <div class=u-ng-fade> <div class=\"s-content {{$ctrl.$state.current.name}}\" ui-view></div> </div> </div> </div> ";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'large': '<',
        'tiny': '<'
    },
    template: __webpack_require__(495)
};

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"c-spinner u-spin\" ng-class=\"{ 'c-spinner--large' : $ctrl.large, 'c-spinner--tiny' : $ctrl.tiny }\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 90 90\"><style>.c-spinner-2{opacity:.9}.c-spinner-3{opacity:.8}.c-spinner-4{opacity:.7}.c-spinner-5{opacity:.6}.c-spinner-6{opacity:.5}.c-spinner-7{opacity:.4}.c-spinner-8{opacity:.3}.c-spinner-9{opacity:.2}.c-spinner-10{opacity:.15}.c-spinner-11{opacity:.1}.c-spinner-12{opacity:5e-2}</style><circle class=c-spinner-1 cx=45 cy=6.8 r=6.8 /><ellipse transform=\"rotate(-30 25.91 11.937)\" class=c-spinner-2 cx=25.9 cy=11.9 rx=6.8 ry=6.8 /><ellipse transform=\"rotate(-60 11.935 25.911)\" class=c-spinner-3 cx=11.9 cy=25.9 rx=6.8 ry=6.8 /><circle class=c-spinner-4 cx=6.8 cy=45 r=6.8 /><ellipse transform=\"rotate(-30 11.933 64.09)\" class=c-spinner-5 cx=11.9 cy=64.1 rx=6.8 ry=6.8 /><ellipse transform=\"rotate(-60 25.91 78.066)\" class=c-spinner-6 cx=25.9 cy=78.1 rx=6.8 ry=6.8 /><circle class=c-spinner-7 cx=45 cy=83.2 r=6.8 /><ellipse transform=\"rotate(-30 64.083 78.065)\" class=c-spinner-8 cx=64.1 cy=78.1 rx=6.8 ry=6.8 /><ellipse transform=\"rotate(-60 78.064 64.092)\" class=c-spinner-9 cx=78.1 cy=64.1 rx=6.8 ry=6.8 /><circle class=c-spinner-10 cx=83.2 cy=45 r=6.8 /><ellipse transform=\"rotate(-30 78.062 25.914)\" class=c-spinner-11 cx=78.1 cy=25.9 rx=6.8 ry=6.8 /><ellipse transform=\"rotate(-60 64.09 11.937)\" class=c-spinner-12 cx=64.1 cy=11.9 rx=6.8 ry=6.8 /></svg>";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  controller: 'adminMenuController',
  template: __webpack_require__(497)
};

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "<ul class=off-canvas-menu> <li ui-sref-active=active> <a ui-sref=app.dashboard> <icon icon=dashboard></icon> <span>Dashboard</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.dashboard><span>Dashboard</span></a></li> </ul> </li> <li ui-sref-active=active class=c-menu__parent ng-class=\"showPropertyMenu ? 'c-menu__parent--open' : ''\" ng-if=\"$ctrl.access.check('admin')\"> <a ng-click=\"showPropertyMenu = !showPropertyMenu\"> <icon icon=property></icon> <span>Properties</span> <span class=off-canvas-menu__toggle> <icon icon=chevron-down ng-if=!showPropertyMenu></icon> <icon icon=chevron-up ng-if=showPropertyMenu></icon> </span> </a> <ul class=submenu> <li ui-sref-active=active ng-if=\"$ctrl.access.check('admin')\"> <a ui-sref=app.admin.groups> <icon icon=hierarchy></icon><span>Groups</span> </a> </li> <li ui-sref-active=active> <a ui-sref=app.admin.properties> <icon icon=property></icon> <span>Property</span> </a> </li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('manager') && !$ctrl.access.check('admin')\"> <a ui-sref=app.admin.properties> <icon icon=property></icon> <span>Property</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.properties><span>Property</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check(['orders', 'stock'])\"> <a ui-sref=app.admin.orders> <icon icon=archive></icon><span>Orders</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.orders><span>Orders</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('reporting')\"><a ui-sref=app.admin.reports> <icon icon=reports></icon><span>Reports</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.reports><span>Reports</span></a></li> </ul> </li> <li ui-sref-active=active class=c-menu__parent ng-class=\"showEventMenu ? 'c-menu__parent--open' : ''\" ng-if=\"$ctrl.access.check('manager')\"><a ng-click=\"showEventMenu = !showEventMenu\"> <icon icon=flip-flops></icon> <span>Events</span> <span class=off-canvas-menu__toggle> <icon icon=chevron-down ng-if=!showEventMenu></icon> <icon icon=chevron-up ng-if=showEventMenu></icon> </span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.categories><span>Categories</span></a></li> <li ui-sref-active=active><a ui-sref=app.admin.treatments><span>Treatments</span></a></li> <li ui-sref-active=active><a ui-sref=app.admin.days><span>Spa Days</span></a></li> <li ui-sref-active=active><a ui-sref=app.admin.classes><span>Classes</span></a></li> <li ui-sref-active=active><a ui-sref=app.admin.options><span>Mandatory Options</span></a></li> <li ui-sref-active=active><a ui-sref=app.admin.extras><span>Extras / Add ons</span></a></li> <li ui-sref-active=active><a ui-sref=app.admin.upgrades><span>Upgrades</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('manager') && !$ctrl.hasIntegration()\"><a ui-sref=app.admin.periods> <icon icon=calendar></icon><span>Pricing Periods</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.periods><span>Pricing Periods</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('stock')\"><a ui-sref=app.admin.availability> <icon icon=calendar-cross></icon><span>Availability</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.availability><span>Availability</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('manager')\"><a ui-sref=app.admin.offers> <icon icon=medal></icon><span>Special Offers</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.offers><span>Special Offers</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('manager')\"><a ui-sref=app.admin.discounts> <icon icon=discount></icon><span>Promo Codes</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.discounts><span>Promo Codes</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('manager') && $ctrl.isNonRevspa()\"><a ui-sref=app.admin.membershipDiscount> <icon icon=membership></icon><span>Membership Discount</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.membershipDiscount><span>Membership Discount</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('stock') && !$ctrl.hasIntegration()\"><a ui-sref=app.admin.stock> <icon icon=tick></icon><span>Event Stock</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.stock><span>Event Stock</span></a></li> </ul> </li> <li ui-sref-active=active class=c-menu__parent ng-class=\"showContentMenu ? 'c-menu__parent--open' : ''\" ng-if=\"$ctrl.access.check('manager')\"><a ng-click=\"showContentMenu = !showContentMenu\"> <icon icon=edit></icon> <span>Content</span> <span class=off-canvas-menu__toggle> <icon icon=chevron-down ng-if=!showContentMenu></icon> <icon icon=chevron-up ng-if=showContentMenu></icon> </span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.pageContent><span>Page Content</span></a></li> <li ui-sref-active=active><a ui-sref=app.admin.emailPageContent><span>Email Content</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('admin') && $ctrl.hasLinkedIntegration()\"><a ui-sref=app.admin.integration_status> <icon icon=eye></icon><span>Integration Status</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.integration_status><span>Integration Status</span></a></li> </ul> </li> <li class=menu-text ng-if=\"$ctrl.access.check('admin')\">Admin</li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('admin')\"><a ui-sref=app.admin.users> <icon icon=user></icon><span>Users</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.users><span>Users</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('admin')\"><a ui-sref=app.admin.globalPageContent> <icon icon=edit></icon><span>Global Content</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.globalPageContent><span>Global Content</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('investor')\"><a ui-sref=app.admin.revenueDashboard> <icon icon=graph></icon><span>Revenue Dashboard</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.revenueDashboard><span>Revenue Dashboard</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('investor')\"><a ui-sref=app.admin.statisticsDashboard> <icon icon=dashboard></icon><span>Statistics Dashboard</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.statisticsDashboard><span>Statistics Dashboard</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('premier_admin')\"><a ui-sref=app.admin.premierDashboard> <icon icon=reports></icon><span>Premier Dashboard</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.premierDashboard><span>Premier Dashboard</span></a></li> </ul> </li> <li ui-sref-active=active ng-if=\"$ctrl.access.check('admin')\"><a ui-sref=app.admin.setPasswordEmails> <icon icon=user></icon><span>Set Password Email</span> </a> <ul class=submenu> <li ui-sref-active=active><a ui-sref=app.admin.setPasswordEmails><span>Set Password Email</span></a></li> </ul> </li> </ul> ";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	bindings: {
		closable: '<'
	},
	controller: 'messageController',
	template: __webpack_require__(499)
};

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "<div class=\"alert {{ $ctrl.messageService.alerttype }} {{ $ctrl.messageService.class }}\" ng-if=$ctrl.messageService.display> <p ng-bind-html=$ctrl.messageService.display></p> <a class=c-message__link ng-if=$ctrl.messageService.displaylink ui-sref={{$ctrl.messageService.displaylink}}> {{$ctrl.messageService.displaylinktext}} </a> <button ng-if=$ctrl.closable type=button class=close data-ng-click=$ctrl.messageService.clear()>×</button> </div>";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    class: '@',
    id: '<'
  },
  controller: 'auditController',
  template: __webpack_require__(501)
};

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "<div class=c-audits> <h2>History</h2> <spinner class=c-audits__loading ng-if=!$ctrl.audits.length></spinner> <table class=c-audit> <thead> <tr> <th>Date</th> <th>Field</th> <th>Old value</th> <th>New value</th> <th>User</th> </tr> </thead> <tbody ng-repeat=\"audit in $ctrl.audits\"> <tr ng-repeat=\"(key, value) in audit.new_values\"> <td> {{ audit.created_at }} </td> <td> {{ key }} </td> <td class=c-audit__old> {{ audit.old_values[key] || '' }} </td> <td class=c-audit__new> {{ value }} </td> <td> <span ng-bind-html=\"audit.user_id || '<em>RevSpa</em>'\"></span> </td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    helptype: '@'
  },
  template: __webpack_require__(503)
};

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help> <text-cheatsheet ng-if=\"$ctrl.helptype === 'markdown'\"></text-cheatsheet> <period-cheatsheet ng-if=\"$ctrl.helptype === 'period'\"></period-cheatsheet> </div>";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  template: __webpack_require__(505)
};

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = "<div class=c-markdown-key> <table> <tr> <th class=c-markdown-key__header colspan=3> Markdown Codes </th> </tr> <tr> <th> Purpose </th> <th colspan=2> Code </th> </tr> <tr> <td> H3-H6 </td> <td colspan=2> {### - ######} </td> </tr> <tr> <td> Italic </td> <td colspan=2> _word_ </td> </tr> <tr> <td> Strong </td> <td colspan=2> __word__ </td> </tr> <tr> <td> Italic + Strong </td> <td colspan=2> ___word___ </td> </tr> <tr> <td> Strikethrough </td> <td colspan=2> ~~word~~ </td> </tr> <tr> <td> Numbered List </td> <td colspan=2> 1. 2. etc </td> </tr> <tr> <td> Unordered List </td> <td colspan=2> * </td> </tr> <tr> <td> Inline Link </td> <td colspan=2> [link text here](www.examplelink.com) </td> </tr> <tr> <td> Inline link with title </td> <td colspan=2> [link text here](www.examplelink.com \"Example Link\") </td> </tr> <tr> <td> Image </td> <td colspan=2> ![alt text](www.imagelinks.com/image.png) </td> </tr> <tr> <td> Tables </td> <td colspan=2>Markdown | Column | Headers <br> --- | :---: | ---: <br> left-aligned | centre-aligned (use colons) | right-aligned <br> 1 | 2 | 3</td> </tr> </table> </div>";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  template: __webpack_require__(507)
};

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "<div class=c-markdown-key> <h2>Pricing</h2> <p>Each individual pricing rule can have a global pricing change set, which overrides any individual values set on events below. This allows you to create a single group for multiple events with one pricing rule.</p> <p>If only the pricing type global is selected, the values can be set individually by event below.</p> <p>If neither global values are set you can create custom pricing rules per event on that rule for this period.</p> </div>";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  template: __webpack_require__(509)
};

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = "<div class=c-logo-words> <svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 88.31 23.28\"><path d=\"M2.82 11.92v6.21H0V.7h6.62q5.9 0 5.9 5.55 0 3.72-2.85 5l2.87 6.84h-3.1l-2.52-6.17zm6.8-5.64q0-3.13-3-3.13h-3.8v6.33h3.85a2.72 2.72 0 0 0 2.24-.88 3.59 3.59 0 0 0 .71-2.32zM24.25 15.84l.71-.07.04 2.06a26.31 26.31 0 0 1-5.14.58 4.88 4.88 0 0 1-4.06-1.55c-.82-1-1.23-2.69-1.23-5q0-6.76 5.52-6.77 5.34 0 5.34 5.83l-.17 2h-7.88a3.42 3.42 0 0 0 .69 2.32 3.24 3.24 0 0 0 2.46.74c1.21.02 2.47.02 3.72-.14zm-1.53-5a4.34 4.34 0 0 0-.6-2.64 2.44 2.44 0 0 0-2-.75 2.51 2.51 0 0 0-2.12.76 4.18 4.18 0 0 0-.68 2.6zM26.74 5.41h2.9l2.45 10.36h.81l2.54-10.36h2.83L35 18.13h-5zM46 3.58c-1.85 0-2.77.61-2.77 1.83a1.4 1.4 0 0 0 .69 1.25 17.47 17.47 0 0 0 3.16 1.24 8.86 8.86 0 0 1 3.55 1.85 4.34 4.34 0 0 1 1 3.17A5.1 5.1 0 0 1 50 17a6.51 6.51 0 0 1-4.33 1.4 23.91 23.91 0 0 1-4.86-.61l-.91-.18.35-2.72a43.62 43.62 0 0 0 5.22.46c1.8 0 2.7-.75 2.7-2.24a1.5 1.5 0 0 0-.63-1.28 9 9 0 0 0-2.48-1 10 10 0 0 1-4.16-2 4.25 4.25 0 0 1-1.21-3.21 4.69 4.69 0 0 1 1.58-3.82A6.69 6.69 0 0 1 45.6.53a29.59 29.59 0 0 1 4.78.5l.92.18L51 4c-2.38-.28-4.06-.42-5-.42zM54.17 23.48V5.41h3.38v.69a5.88 5.88 0 0 1 2.91-1 4.54 4.54 0 0 1 3.79 1.54q1.22 1.53 1.22 5.22T64.12 17c-.9 1-2.38 1.44-4.43 1.44a11.69 11.69 0 0 1-1.8-.15l-.31-.05v5.24zm5.62-15.32a5.23 5.23 0 0 0-1.9.38l-.31.13v6.66a13.41 13.41 0 0 0 1.86.16 2.19 2.19 0 0 0 2-.87 5.85 5.85 0 0 0 .56-2.95q0-3.51-2.21-3.51zM77.76 9.38v5.29a2.07 2.07 0 0 0 .2.86 1 1 0 0 0 .64.34l-.11 2.57a9.55 9.55 0 0 1-2.07-.18 4.71 4.71 0 0 1-1.56-.71 8.55 8.55 0 0 1-3.74.89q-3.95 0-4-4.17a3.45 3.45 0 0 1 1.1-2.89 6.07 6.07 0 0 1 3.35-1l2.73-.2v-.8A1.32 1.32 0 0 0 74 8.3a1.77 1.77 0 0 0-1.15-.3l-4.79.2L68 5.84a19.89 19.89 0 0 1 5.18-.73 5.13 5.13 0 0 1 3.54 1 4.31 4.31 0 0 1 1.04 3.27zM72 12.74a1.37 1.37 0 0 0-1.42 1.53c0 .93.41 1.4 1.24 1.4a8.49 8.49 0 0 0 2.18-.31l.38-.1v-2.72zM80.7 1.19V.2h3v1h-.77v3.54h-1.1V1.19zm3.38 3.56V.2h1.32l.77 2.67L87 .2h1.31v4.55h-1V1.84l-.71 2.64h-.74l-.76-2.64v2.91z\" transform=\"translate(0 -.2)\"/></svg> </div>";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  template: __webpack_require__(511)
};

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "<div class=c-logo-icon> <svg version=1.1 xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 90 75\" style=\"enable-background:new 0 0 90 75\" xml:space=preserve> <style type=text/css>.icon-path{fill:#fff}</style> <g> <g transform=\"translate(-599.000000, -495.000000)\"> <g transform=\"translate(599.000000, 495.000000)\"> <path class=icon-path d=\"M45,5.1L34.5,15.6c-12,12.1-12,31.8,0,43.9L45,69.9l10.5-10.4c12-12.1,12-31.8,0-43.9L45,5.1z M45,73.5 c-0.4,0-0.8-0.1-1.1-0.4L32.4,61.6c-13.2-13.3-13.2-34.8,0-48.1L43.9,1.9c0.6-0.6,1.5-0.6,2.1,0l11.5,11.5c0,0,0,0,0,0 c13.2,13.3,13.2,34.8,0,48.1L46.1,73.1C45.8,73.4,45.4,73.5,45,73.5L45,73.5z\"/> <path class=icon-path d=\"M55.5,73.5L55.5,73.5H45v-3l10.5,0h0c8.3,0,16.2-3.3,22.2-9.3c6-6,9.3-13.9,9.3-22.2l0-10.4l-10.5,0h0 c-3.8,0-7.5,0.7-11,2.1c-0.8,0.3-1.6-0.1-2-0.8c-0.3-0.8,0.1-1.6,0.8-2c3.8-1.6,7.9-2.3,12.1-2.3h0l12,0c0.8,0,1.5,0.7,1.5,1.5 l0,11.9c0,9.1-3.6,17.8-10.2,24.3C73.2,69.9,64.6,73.5,55.5,73.5\"/> <path class=icon-path d=\"M34.5,73.5c-9.1,0-17.7-3.6-24.3-10.2C3.6,56.7,0,48.1,0,38.9L0,27c0-0.8,0.7-1.5,1.5-1.5l12,0h0 c4.2,0,8.3,0.8,12.1,2.3c0.8,0.3,1.1,1.2,0.8,2c-0.3,0.8-1.2,1.1-2,0.8c-3.5-1.4-7.2-2.1-11-2.1h0L3,28.5l0,10.4 c0,8.3,3.3,16.2,9.3,22.2c6,6,13.9,9.3,22.2,9.3h0H45c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H34.5L34.5,73.5z\"/> <path class=icon-path d=\"M75.7,28.5c-0.8,0-1.4-0.6-1.5-1.3c-0.1-1-0.2-1.9-0.4-2.8l-1.6-10.6l-10.6,2.3c-1.2,0.2-2.4,0.5-3.6,0.9 c-0.8,0.3-1.6-0.2-1.9-1c-0.3-0.8,0.2-1.6,1-1.9c1.3-0.4,2.7-0.8,3.9-1l12.2-2.7c0.4-0.1,0.8,0,1.2,0.2c0.3,0.2,0.6,0.6,0.6,1 l1.8,12.1c0.2,0.9,0.3,1.9,0.4,3c0.1,0.8-0.5,1.6-1.3,1.6C75.8,28.5,75.8,28.5,75.7,28.5\"/> <path class=icon-path d=\"M14.3,28.5c-0.1,0-0.1,0-0.2,0c-0.8-0.1-1.4-0.8-1.3-1.6c0.1-1,0.3-2.1,0.4-3L15,11.8c0.1-0.4,0.3-0.8,0.6-1 c0.3-0.2,0.8-0.3,1.2-0.2L29,13.2c1.3,0.2,2.5,0.6,3.9,1c0.8,0.3,1.2,1.1,1,1.9c-0.3,0.8-1.1,1.2-1.9,1c-1.2-0.4-2.4-0.7-3.6-0.9 l-10.7-2.3l-1.5,10.5c-0.2,1-0.3,1.9-0.4,2.8C15.7,28,15.1,28.5,14.3,28.5\"/> </g> </g> </g> </svg> </div>";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    icon: '@',
    large: '<'
  },
  template: __webpack_require__(513)
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'chevron-down'\"> " + __webpack_require__(514) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'chevron-up'\"> " + __webpack_require__(515) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'chevron-left'\"> " + __webpack_require__(516) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'chevron-right'\"> " + __webpack_require__(517) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'cross'\"> " + __webpack_require__(518) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'bin'\"> " + __webpack_require__(519) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'files'\"> " + __webpack_require__(520) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'property'\"> " + __webpack_require__(521) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'dashboard'\"> " + __webpack_require__(522) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'menu'\"> " + __webpack_require__(523) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'user'\"> " + __webpack_require__(524) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'tick'\"> " + __webpack_require__(525) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'resize'\"> " + __webpack_require__(526) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'journey-arrow'\"> " + __webpack_require__(527) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'eye'\"> " + __webpack_require__(528) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'closedeye'\"> " + __webpack_require__(529) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'hierarchy'\"> " + __webpack_require__(530) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'edit'\"> " + __webpack_require__(531) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'flip-flops'\"> " + __webpack_require__(532) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'calendar'\"> " + __webpack_require__(533) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'calendar-cross'\"> " + __webpack_require__(534) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'medal'\"> " + __webpack_require__(535) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'reports'\"> " + __webpack_require__(536) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'reports-down'\"> " + __webpack_require__(537) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'discount'\"> " + __webpack_require__(538) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'archive'\"> " + __webpack_require__(539) + " </i> <i class=\"c-icon c-icon--info\" ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'info'\"> i </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'graph'\"> " + __webpack_require__(540) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'refund'\"> " + __webpack_require__(541) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'filter'\"> " + __webpack_require__(542) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'datepicker'\"> " + __webpack_require__(543) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'upload'\"> " + __webpack_require__(544) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'membership'\"> " + __webpack_require__(545) + " </i> ";

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\" style=\"enable-background:new 0 0 64 64;\" xml:space=\"preserve\"><path d=\"M56.5,19c-0.5-0.5-1.3-0.5-1.6,0L31.9,42.4L9.1,19.2c-0.5-0.5-1.2-0.5-1.6,0c-0.5,0.5-0.5,1.2,0,1.6l23.6,24.1 c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.2,0.9-0.4l23.8-24.3C57,20.3,57,19.5,56.5,19z\"></path></svg>"

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\" style=\"enable-background:new 0 0 64 64;\" xml:space=\"preserve\"><path d=\"M7.5,44.9c0.5,0.5,1.3,0.5,1.6,0l23-23.4l22.8,23.2c0.5,0.5,1.2,0.5,1.6,0c0.5-0.5,0.5-1.2,0-1.6L32.9,19 c-0.2-0.2-0.5-0.4-0.9-0.4c-0.3,0-0.6,0.2-0.9,0.4L7.3,43.3C7,43.6,7,44.4,7.5,44.9z\"></path></svg>"

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M14 20c0.128 0 0.256-0.049 0.354-0.146 0.195-0.195 0.195-0.512 0-0.707l-8.646-8.646 8.646-8.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-9 9c-0.195 0.195-0.195 0.512 0 0.707l9 9c0.098 0.098 0.226 0.146 0.354 0.146z\"></path></svg>"

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z\"></path></svg>"

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><g id=\"icomoon-ignore\"></g><path fill=\"#000\" d=\"M342.627 336l276.686-276.687c6.249-6.248 6.249-16.379 0-22.627s-16.379-6.249-22.627 0l-276.686 276.687-276.687-276.686c-6.248-6.249-16.379-6.249-22.627 0s-6.249 16.379 0 22.627l276.687 276.686-276.686 276.687c-6.249 6.248-6.249 16.379 0 22.627 3.124 3.124 7.218 4.686 11.313 4.686s8.189-1.562 11.313-4.687l276.687-276.686 276.687 276.687c3.124 3.124 7.218 4.686 11.313 4.686s8.189-1.562 11.313-4.687c6.249-6.248 6.249-16.379 0-22.627l-276.686-276.686z\"></path></svg>"

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M15.5 2h-3.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-2c-0.827 0-1.5 0.673-1.5 1.5v0.5h-3.5c-0.827 0-1.5 0.673-1.5 1.5v1c0 0.652 0.418 1.208 1 1.414v12.586c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-12.586c0.582-0.206 1-0.762 1-1.414v-1c0-0.827-0.673-1.5-1.5-1.5zM8 1.5c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v0.5h-3v-0.5zM14.5 19h-10c-0.276 0-0.5-0.224-0.5-0.5v-12.5h11v12.5c0 0.276-0.224 0.5-0.5 0.5zM16 4.5c0 0.276-0.224 0.5-0.5 0.5h-12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5h12c0.276 0 0.5 0.224 0.5 0.5v1z\"></path><path d=\"M12.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z\"></path><path d=\"M9.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z\"></path><path d=\"M6.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z\"></path></svg>"

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M16.5 4h-0.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-0.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-7.5c-0.133 0-0.26 0.053-0.354 0.146l-3.5 3.5c-0.094 0.094-0.146 0.221-0.146 0.354v10.5c0 0.827 0.673 1.5 1.5 1.5h0.5v0.5c0 0.827 0.673 1.5 1.5 1.5h0.5v0.5c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-13c0-0.827-0.673-1.5-1.5-1.5zM5 1.207v2.293c0 0.276-0.224 0.5-0.5 0.5h-2.293l2.793-2.793zM2 14.5v-9.5h2.5c0.827 0 1.5-0.673 1.5-1.5v-2.5h6.5c0.276 0 0.5 0.224 0.5 0.5v13c0 0.276-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5-0.224-0.5-0.5zM4 16.5v-0.5h8.5c0.827 0 1.5-0.673 1.5-1.5v-11.5h0.5c0.276 0 0.5 0.224 0.5 0.5v13c0 0.276-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5-0.224-0.5-0.5zM17 18.5c0 0.276-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5-0.224-0.5-0.5v-0.5h8.5c0.827 0 1.5-0.673 1.5-1.5v-11.5h0.5c0.276 0 0.5 0.224 0.5 0.5v13z\"></path></svg>"

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><g id=\"icomoon-ignore\"></g><path fill=\"#000\" d=\"M448 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M592 608h-16v-432c0-24.411-18.14-49.579-41.298-57.298l-150.702-50.234v-52.468c0-5.058-2.392-9.818-6.449-12.837-4.058-3.018-9.305-3.941-14.148-2.488l-289.35 86.804c-23.581 7.075-42.053 31.902-42.053 56.521v464h-16c-8.836 0-16 7.163-16 16s7.164 16 16 16h576c8.837 0 16-7.163 16-16s-7.163-16-16-16zM524.583 149.060c10.162 3.387 19.417 16.228 19.417 26.94v432h-160v-505.801l140.583 46.861zM64 144c0-10.517 9.174-22.848 19.248-25.87l268.752-80.626v570.496h-288v-464z\"></path></svg>"

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3000.628 -2795.628 17.257 17.257\"><path d=\"M3.922,13.073H.261A.262.262,0,0,0,0,13.335V17a.262.262,0,0,0,.261.261H3.922A.262.262,0,0,0,4.183,17V13.335A.262.262,0,0,0,3.922,13.073Zm-.261,3.661H.523V13.6H3.661Zm6.8-3.661H6.8a.262.262,0,0,0-.261.261V17a.262.262,0,0,0,.261.261h3.661A.262.262,0,0,0,10.72,17V13.335A.262.262,0,0,0,10.459,13.073ZM10.2,16.734H7.06V13.6H10.2ZM17,13.073H13.335a.262.262,0,0,0-.261.261V17a.262.262,0,0,0,.261.261H17A.262.262,0,0,0,17.257,17V13.335A.262.262,0,0,0,17,13.073Zm-.261,3.661H13.6V13.6h3.138ZM3.922,6.537H.261A.262.262,0,0,0,0,6.8v3.661a.262.262,0,0,0,.261.261H3.922a.262.262,0,0,0,.261-.261V6.8A.262.262,0,0,0,3.922,6.537ZM3.661,10.2H.523V7.06H3.661Zm6.8-3.661H6.8a.262.262,0,0,0-.261.261v3.661a.262.262,0,0,0,.261.261h3.661a.262.262,0,0,0,.261-.261V6.8A.262.262,0,0,0,10.459,6.537ZM10.2,10.2H7.06V7.06H10.2ZM17,6.537H13.335a.262.262,0,0,0-.261.261v3.661a.262.262,0,0,0,.261.261H17a.262.262,0,0,0,.261-.261V6.8A.262.262,0,0,0,17,6.537ZM16.734,10.2H13.6V7.06h3.138ZM3.922,0H.261A.262.262,0,0,0,0,.261V3.922a.262.262,0,0,0,.261.261H3.922a.262.262,0,0,0,.261-.261V.261A.262.262,0,0,0,3.922,0ZM3.661,3.661H.523V.523H3.661ZM10.459,0H6.8a.262.262,0,0,0-.261.261V3.922a.262.262,0,0,0,.261.261h3.661a.262.262,0,0,0,.261-.261V.261A.262.262,0,0,0,10.459,0ZM10.2,3.661H7.06V.523H10.2ZM17,0H13.335a.262.262,0,0,0-.261.261V3.922a.262.262,0,0,0,.261.261H17a.262.262,0,0,0,.261-.261V.261A.262.262,0,0,0,17,0Zm-.261,3.661H13.6V.523h3.138Z\" transform=\"translate(-3000.628 -2795.628)\"></path></svg>"

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-2839.5 -2866 21.098 13.41\"><g transform=\"translate(-2870 -2900)\"><line id=\"Line_1\" data-name=\"Line 1\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 34.5)\"></line><line id=\"Line_2\" data-name=\"Line 2\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 40.705)\"></line><line id=\"Line_3\" data-name=\"Line 3\" class=\"icon-menu\" x2=\"15.513\" transform=\"translate(30.5 46.91)\"></line><line id=\"Line_4\" data-name=\"Line 4\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 34.5)\"></line><line id=\"Line_5\" data-name=\"Line 5\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 40.705)\"></line><line id=\"Line_6\" data-name=\"Line 6\" class=\"icon-menu\" x2=\"15.513\" transform=\"translate(30.5 46.91)\"></line><line id=\"Line_7\" data-name=\"Line 7\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 34.5)\"></line><line id=\"Line_8\" data-name=\"Line 8\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 40.705)\"></line><line id=\"Line_9\" data-name=\"Line 9\" class=\"icon-menu\" x2=\"15.513\" transform=\"translate(30.5 46.91)\"></line></g></svg>"

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><g id=\"icomoon-ignore\"></g><path fill=\"#000\" d=\"M304 352c-97.047 0-176-78.953-176-176s78.953-176 176-176 176 78.953 176 176-78.953 176-176 176zM304 32c-79.402 0-144 64.598-144 144s64.598 144 144 144c79.401 0 144-64.598 144-144s-64.599-144-144-144z\"></path><path fill=\"#000\" d=\"M560 640h-512c-26.467 0-48-21.532-48-48 0-2.178 0.445-53.928 39.2-105.6 22.559-30.079 53.446-53.975 91.802-71.021 46.848-20.821 105.053-31.379 172.998-31.379 67.944 0 126.149 10.558 172.998 31.379 38.356 17.047 69.243 40.942 91.802 71.021 38.755 51.672 39.2 103.422 39.2 105.6 0 26.468-21.532 48-48 48zM304 416c-111.575 0-193.917 30.493-238.125 88.183-33.132 43.234-33.872 87.44-33.875 87.881 0 8.758 7.178 15.936 16 15.936h512c8.822 0 16-7.178 16-16-0.004-0.377-0.743-44.583-33.874-87.817-44.209-57.69-126.552-88.183-238.126-88.183z\"></path></svg>"

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><path d=\"M176 560c-4.095 0-8.189-1.562-11.314-4.687l-160-160c-6.248-6.248-6.248-16.379 0-22.627s16.379-6.248 22.628 0l148.686 148.686 436.687-436.686c6.248-6.248 16.379-6.248 22.627 0s6.249 16.379 0 22.628l-448 448c-3.125 3.124-7.219 4.686-11.314 4.686z\"></path></svg>"

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path fill=\"#000\" d=\"M15.5 7.5c-0.128 0-0.256-0.049-0.354-0.146l-5.646-5.646-5.646 5.646c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l6-6c0.195-0.195 0.512-0.195 0.707 0l6 6c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z\"></path><path fill=\"#000\" d=\"M9.5 19.5c-0.128 0-0.256-0.049-0.354-0.146l-6-6c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l5.646 5.646 5.646-5.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-6 6c-0.098 0.098-0.226 0.146-0.354 0.146z\"></path></svg>"

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3001.006 -2559.417 17.634 17.842\"><path d=\"M17.528.083a.319.319,0,0,0-.36-.06l-17,5.892a.312.312,0,0,0-.18.33.3.3,0,0,0,.27.27L8.833,8.883l2.354,8.68a.335.335,0,0,0,.27.27H11.5a.307.307,0,0,0,.285-.195L17.588.458A.343.343,0,0,0,17.528.083ZM11.651,16.424,9.432,8.554a.355.355,0,0,0-.27-.27L1.382,6.065,16.643.983Z\" transform=\"translate(-3000.991 -2559.409)\"></path></svg>"

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M19.872 10.166c-0.047-0.053-1.182-1.305-2.956-2.572-1.047-0.748-2.1-1.344-3.13-1.773-1.305-0.544-2.579-0.82-3.786-0.82s-2.481 0.276-3.786 0.82c-1.030 0.429-2.083 1.026-3.13 1.773-1.774 1.267-2.909 2.52-2.956 2.572-0.171 0.19-0.171 0.479 0 0.669 0.047 0.053 1.182 1.305 2.956 2.572 1.047 0.748 2.1 1.344 3.13 1.773 1.305 0.544 2.579 0.82 3.786 0.82s2.481-0.276 3.786-0.82c1.030-0.429 2.083-1.026 3.13-1.773 1.774-1.267 2.909-2.52 2.956-2.572 0.171-0.19 0.171-0.479 0-0.669zM12.574 6.438c0.907 0.763 1.426 1.873 1.426 3.062 0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.188 0.519-2.299 1.426-3.062 0.822-0.268 1.691-0.438 2.574-0.438s1.752 0.17 2.574 0.438zM16.317 12.606c-1.533 1.092-3.873 2.394-6.317 2.394s-4.784-1.302-6.317-2.394c-1.157-0.824-2.042-1.658-2.489-2.106 0.447-0.448 1.332-1.281 2.489-2.106 0.53-0.378 1.156-0.78 1.85-1.145-0.347 0.688-0.533 1.455-0.533 2.251 0 2.757 2.243 5 5 5s5-2.243 5-5c0-0.796-0.186-1.563-0.533-2.251 0.694 0.365 1.32 0.768 1.85 1.145 1.157 0.824 2.042 1.658 2.489 2.106-0.447 0.448-1.332 1.281-2.489 2.106z\"></path></svg>"

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M19.872 10.166c-0.047-0.053-1.182-1.305-2.956-2.572-0.6-0.429-1.202-0.807-1.801-1.134l1.725-1.592c0.203-0.187 0.216-0.504 0.028-0.707s-0.504-0.216-0.707-0.028l-2.003 1.849c-0.124-0.056-0.248-0.11-0.372-0.162-1.305-0.544-2.579-0.82-3.786-0.82s-2.481 0.276-3.786 0.82c-1.030 0.429-2.083 1.026-3.13 1.773-1.774 1.267-2.909 2.52-2.956 2.572-0.171 0.19-0.171 0.479 0 0.669 0.047 0.053 1.182 1.305 2.956 2.572 0.6 0.429 1.202 0.807 1.801 1.134l-1.725 1.592c-0.203 0.187-0.216 0.504-0.028 0.707 0.099 0.107 0.233 0.161 0.368 0.161 0.121 0 0.243-0.044 0.339-0.133l2.003-1.849c0.124 0.056 0.248 0.11 0.372 0.162 1.305 0.544 2.579 0.82 3.786 0.82s2.481-0.276 3.786-0.82c1.030-0.429 2.083-1.026 3.13-1.773 1.774-1.267 2.909-2.52 2.956-2.572 0.171-0.19 0.171-0.479 0-0.669zM14 9.5c0 2.206-1.794 4-4 4-0.711 0-1.378-0.187-1.957-0.513l5.592-5.162c0.238 0.517 0.366 1.086 0.366 1.674zM12.574 6.438c0.191 0.161 0.364 0.337 0.52 0.525l-5.867 5.416c-0.756-0.728-1.227-1.75-1.227-2.88 0-1.188 0.519-2.298 1.426-3.062 0.822-0.268 1.691-0.438 2.574-0.438s1.752 0.17 2.574 0.438zM3.683 12.606c-1.157-0.824-2.042-1.658-2.489-2.106 0.447-0.448 1.332-1.281 2.489-2.106 0.53-0.378 1.156-0.78 1.85-1.145-0.347 0.688-0.533 1.455-0.533 2.251 0 1.391 0.571 2.651 1.491 3.558l-0.825 0.762c-0.747-0.383-1.419-0.813-1.983-1.214zM16.317 12.606c-1.533 1.092-3.873 2.394-6.317 2.394-1.166 0-2.309-0.297-3.352-0.726l0.63-0.582c0.784 0.51 1.718 0.808 2.721 0.808 2.757 0 5-2.243 5-5 0-0.796-0.186-1.563-0.533-2.251 0.694 0.365 1.32 0.768 1.85 1.145 1.157 0.824 2.042 1.658 2.489 2.106-0.447 0.448-1.332 1.281-2.489 2.106z\"></path></svg>"

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3002.5 -2716.615 20.999 17.23\"><path d=\"M18.576,11.859V8.682a.27.27,0,0,0-.269-.269H10.769V5.371a2.692,2.692,0,1,0-.538,0V8.413H2.692a.27.27,0,0,0-.269.269v3.177a2.692,2.692,0,1,0,.538,0V8.952H10.23v2.908a2.692,2.692,0,1,0,.538,0V8.952h7.269v2.908a2.692,2.692,0,1,0,.538,0ZM8.346,2.692A2.154,2.154,0,1,1,10.5,4.846,2.16,2.16,0,0,1,8.346,2.692Zm-3.5,11.846a2.154,2.154,0,1,1-2.154-2.154A2.16,2.16,0,0,1,4.846,14.538Zm7.807,0A2.154,2.154,0,1,1,10.5,12.384,2.16,2.16,0,0,1,12.653,14.538Zm5.654,2.154a2.154,2.154,0,1,1,2.154-2.154A2.16,2.16,0,0,1,18.307,16.692Z\" transform=\"translate(-3002.5 -2716.615)\"></path></svg>"

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path fill=\"#000\" d=\"M19.572 0.428c-0.28-0.28-0.655-0.421-1.117-0.421-0.753 0-1.765 0.394-3.021 1.174-0.402-0.425-1.167-1.077-2.131-1.155-0.769-0.062-1.495 0.241-2.157 0.903-1.405 1.405-2.097 3.121-2.555 4.256-0.156 0.386-0.349 0.866-0.445 0.965-0.033 0.033-0.132 0.132-0.304-0.013-0.196-0.185-0.505-0.181-0.696 0.010-0.195 0.195-0.195 0.512 0 0.707 0.082 0.082 0.293 0.241 0.562 0.316 0.108 0.030 0.216 0.045 0.322 0.045 0.127 0 0.251-0.022 0.369-0.065-0.137 0.141-0.274 0.282-0.411 0.425-3.517 3.673-7.46 8.713-7.982 11.842-0.027 0.159 0.025 0.322 0.14 0.436 0.095 0.095 0.222 0.146 0.354 0.146 0.027 0 0.055-0.002 0.082-0.007 1.308-0.218 3.032-1.046 5.125-2.46 1.852-1.251 3.906-2.908 5.94-4.791 1.984-1.837 3.794-3.742 5.235-5.511 1.076-1.321 2.458-3.208 2.934-4.692 0.301-0.939 0.219-1.649-0.244-2.112zM11.854 1.635c0.45-0.45 0.896-0.651 1.365-0.614 0.561 0.044 1.053 0.418 1.365 0.72-0.247 0.172-0.501 0.355-0.763 0.552-1.424 1.069-3.040 2.488-4.65 4.081 0.107-0.218 0.216-0.488 0.349-0.816 0.427-1.060 1.073-2.662 2.334-3.923zM3.036 15.243l1.722 1.722c-1.365 0.892-2.584 1.526-3.57 1.847 0.322-0.987 0.958-2.206 1.848-3.569zM10.969 12.009c-1.876 1.736-3.71 3.228-5.367 4.386l-1.995-1.995c1.321-1.892 3.071-4.008 5.105-6.132 2.362-2.467 4.695-4.505 6.562-5.787l2.244 2.244c-1.431 2.086-3.786 4.726-6.549 7.284zM18.864 2.235c-0.148 0.462-0.418 1.013-0.791 1.631l-1.941-1.941c0.978-0.591 1.78-0.918 2.324-0.918 0.281 0 0.378 0.097 0.41 0.128 0.232 0.232 0.099 0.789-0.001 1.1z\"></path></svg>"

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M19.704 8.76c0.157-0.906 0.296-1.933 0.296-3.26 0-2.194-1.133-3.502-2.083-4.213-1.077-0.806-2.542-1.287-3.917-1.287-0.785 0-1.853 0.313-2.481 1.806-0.344 0.818-0.519 1.893-0.519 3.194 0 1.092 0.184 2.005 0.37 2.783-0.226 0.55-0.37 1.131-0.37 1.717 0 1.286 0.472 2.325 0.98 3.070-0.011 0.319-0.024 0.637-0.037 0.946-0.096 2.232-0.187 4.341 0.949 5.527 0.597 0.623 1.45 0.926 2.608 0.926 0.812 0 1.495-0.199 2.030-0.592 0.467-0.343 0.824-0.836 1.062-1.466 0.407-1.078 0.407-2.372 0.407-3.412 0-0.594 0.022-1.157 0.068-1.714 0.462-0.597 0.932-1.517 0.932-2.786 0-0.394-0.099-0.808-0.296-1.24zM14 1c1.933 0 5 1.222 5 4.5 0 0.749-0.047 1.399-0.117 1.985-0.409-0.499-0.928-1.017-1.559-1.553-0.952-0.809-1.893-1.435-2.324-1.709v-0.722c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.773c-0.362 0.325-1.191 1.119-1.886 2.147-0.068-0.437-0.114-0.91-0.114-1.42 0-1.494 0.26-4 2-4zM15.5 18.97c-0.871 0-1.488-0.202-1.886-0.618-0.824-0.861-0.762-2.705-0.677-4.675 0.147 0.134 0.246 0.209 0.264 0.223 0.22 0.165 0.533 0.121 0.699-0.099s0.122-0.533-0.098-0.7c-0.018-0.014-1.801-1.392-1.801-3.601 0-1.818 1.849-3.719 2.553-4.376 0.44 0.284 1.284 0.856 2.123 1.569 1.499 1.274 2.324 2.448 2.324 3.307 0 0.897-0.285 1.679-0.848 2.326-0.431 0.496-0.873 0.725-0.876 0.727-0.247 0.123-0.347 0.424-0.224 0.671 0.088 0.175 0.264 0.277 0.448 0.277 0.075-0 0.151-0.017 0.223-0.053 0.010-0.005 0.121-0.061 0.288-0.173-0.007 0.238-0.011 0.479-0.011 0.726 0 2.446-0.188 4.47-2.5 4.47z\"></path><path fill=\"#000\" d=\"M8.63 7.753c0.186-0.777 0.37-1.69 0.37-2.783 0-1.301-0.175-2.376-0.519-3.194-0.628-1.493-1.696-1.806-2.481-1.806-1.376 0-2.84 0.481-3.917 1.287-0.95 0.711-2.083 2.019-2.083 4.213 0 1.327 0.139 2.353 0.296 3.259-0.197 0.432-0.296 0.846-0.296 1.241 0 1.269 0.47 2.188 0.932 2.786 0.045 0.558 0.068 1.12 0.068 1.714 0 1.040 0 2.334 0.407 3.412 0.238 0.63 0.596 1.123 1.062 1.466 0.535 0.393 1.218 0.592 2.030 0.592 1.158 0 2.011-0.303 2.608-0.926 1.136-1.186 1.045-3.295 0.949-5.527-0.013-0.309-0.027-0.628-0.037-0.946 0.507-0.745 0.98-1.784 0.98-3.070 0-0.587-0.144-1.167-0.37-1.717zM6.1 13.77c0.166 0.221 0.479 0.266 0.7 0.1 0.018-0.013 0.117-0.089 0.264-0.223 0.084 1.969 0.147 3.814-0.677 4.675-0.398 0.416-1.015 0.618-1.886 0.618-2.312 0-2.5-2.024-2.5-4.47 0-0.247-0.004-0.488-0.011-0.726 0.167 0.112 0.277 0.168 0.288 0.173 0.072 0.036 0.148 0.053 0.223 0.053 0.183-0 0.36-0.101 0.448-0.277 0.123-0.247 0.023-0.547-0.224-0.671-0.017-0.009-1.724-0.887-1.724-3.053 0-0.857 0.822-2.028 2.314-3.298 0.84-0.715 1.691-1.292 2.133-1.577 0.704 0.658 2.553 2.558 2.553 4.376 0 2.209-1.783 3.587-1.801 3.601-0.22 0.166-0.264 0.479-0.099 0.699zM7.886 6.39c-0.695-1.028-1.524-1.822-1.886-2.147v-0.773c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.722c-0.431 0.274-1.372 0.9-2.324 1.709-0.631 0.536-1.15 1.054-1.559 1.553-0.070-0.586-0.117-1.236-0.117-1.985 0-3.278 3.067-4.5 5-4.5 1.74 0 2 2.506 2 4 0 0.511-0.046 0.983-0.114 1.42z\"></path></svg>"

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-9972 4945.259 20 19.782\"><g id=\"Group_621\" data-name=\"Group 621\" transform=\"translate(-10004 4308)\"><path id=\"Path_3112\" data-name=\"Path 3112\" class=\"cls-1\" d=\"M21.056,64.69h3.077a.257.257,0,0,0,.256-.256V61.356a.257.257,0,0,0-.256-.256H21.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,21.056,64.69Zm.256-3.077h2.564v2.564H21.313Z\" transform=\"translate(13.866 583.992)\"></path><path id=\"Path_3113\" data-name=\"Path 3113\" class=\"cls-1\" d=\"M64.056,64.69h3.077a.257.257,0,0,0,.256-.256V61.356a.257.257,0,0,0-.256-.256H64.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,64.056,64.69Zm.256-3.077h2.564v2.564H64.313Z\" transform=\"translate(-23.62 583.992)\"></path><path id=\"Path_3114\" data-name=\"Path 3114\" class=\"cls-1\" d=\"M107.056,64.69h3.077a.257.257,0,0,0,.256-.256V61.356a.257.257,0,0,0-.256-.256h-3.077a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,107.056,64.69Zm.256-3.077h2.564v2.564h-2.564Z\" transform=\"translate(-61.107 583.992)\"></path><path id=\"Path_3115\" data-name=\"Path 3115\" class=\"cls-1\" d=\"M21.056,107.69h3.077a.257.257,0,0,0,.256-.256v-3.077a.257.257,0,0,0-.256-.256H21.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,21.056,107.69Zm.256-3.077h2.564v2.564H21.313Z\" transform=\"translate(13.866 546.505)\"></path><path id=\"Path_3116\" data-name=\"Path 3116\" class=\"cls-1\" d=\"M64.056,107.69h3.077a.257.257,0,0,0,.256-.256v-3.077a.257.257,0,0,0-.256-.256H64.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,64.056,107.69Zm.256-3.077h2.564v2.564H64.313Z\" transform=\"translate(-23.62 546.505)\"></path><path id=\"Path_3117\" data-name=\"Path 3117\" class=\"cls-1\" d=\"M107.056,107.69h3.077a.257.257,0,0,0,.256-.256v-3.077a.257.257,0,0,0-.256-.256h-3.077a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,107.056,107.69Zm.256-3.077h2.564v2.564h-2.564Z\" transform=\"translate(-61.107 546.505)\"></path><path id=\"Path_3118\" data-name=\"Path 3118\" class=\"cls-1\" d=\"M17.821,1.321H15.5V.256a.256.256,0,1,0-.513,0V1.321H4.949V.256a.256.256,0,0,0-.513,0V1.321H2.179A2.178,2.178,0,0,0,0,3.5V17.6a2.178,2.178,0,0,0,2.179,2.179H17.821A2.178,2.178,0,0,0,20,17.6V3.5A2.186,2.186,0,0,0,17.821,1.321ZM19.487,17.6a1.663,1.663,0,0,1-1.667,1.667H2.179A1.663,1.663,0,0,1,.513,17.6V5.679H19.487Zm0-12.436H.513V3.5A1.663,1.663,0,0,1,2.179,1.833H4.436V3.359a.256.256,0,0,0,.513,0V1.833H14.974V3.359a.256.256,0,1,0,.513,0V1.833h2.333A1.663,1.663,0,0,1,19.487,3.5Z\" transform=\"translate(32 637.259)\"></path></g></svg>"

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M18.5 2h-2.5v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-10v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-2.5c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-14c0-0.827-0.673-1.5-1.5-1.5zM1.5 3h2.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h10v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h2.5c0.276 0 0.5 0.224 0.5 0.5v2.5h-18v-2.5c0-0.276 0.224-0.5 0.5-0.5zM18.5 18h-17c-0.276 0-0.5-0.224-0.5-0.5v-10.5h18v10.5c0 0.276-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.707 12.5l2.646-2.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-2.646 2.646-2.646-2.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2.646 2.646-2.646 2.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2.646-2.646 2.646 2.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-2.646-2.646z\"></path></svg>"

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M14.795 4.779l-1.464-1.063-0.559-1.721h-1.809l-1.464-1.063-1.464 1.063h-1.809l-0.559 1.721-1.464 1.063 0.559 1.721-0.559 1.721 1.464 1.063 0.332 1.021v9.195c0 0.184 0.102 0.354 0.264 0.441s0.36 0.077 0.513-0.025l2.723-1.815 2.723 1.815c0.084 0.056 0.18 0.084 0.277 0.084 0.081 0 0.162-0.020 0.236-0.059 0.163-0.087 0.264-0.256 0.264-0.441v-9.195l0.332-1.021 1.464-1.063-0.559-1.721 0.559-1.721zM9.777 17.084c-0.168-0.112-0.387-0.112-0.555 0l-2.223 1.482v-7.561h1.036l1.464 1.063 1.464-1.063h1.036v7.561l-2.223-1.482zM13.62 7.839l-1.139 0.827-0.433 1.334h-0.048v0.004h-1.361l-1.139 0.827-1.139-0.827h-1.407l-0.435-1.339-1.139-0.827 0.435-1.339-0.435-1.339 1.139-0.827 0.435-1.339h1.407l1.139-0.827 1.139 0.827h1.407l0.435 1.339 1.139 0.827-0.435 1.339 0.435 1.339z\"></path></svg>"

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path fill=\"#000\" d=\"M16.5 20h-14c-0.827 0-1.5-0.673-1.5-1.5v-14c0-0.827 0.673-1.5 1.5-1.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5 0.224-0.5 0.5v14c0 0.276 0.224 0.5 0.5 0.5h14c0.276 0 0.5-0.224 0.5-0.5v-14c0-0.276-0.224-0.5-0.5-0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.827 0 1.5 0.673 1.5 1.5v14c0 0.827-0.673 1.5-1.5 1.5z\"></path><path fill=\"#000\" d=\"M13.501 5c-0 0-0 0-0.001 0h-8c-0.276 0-0.5-0.224-0.5-0.5 0-1.005 0.453-1.786 1.276-2.197 0.275-0.138 0.547-0.213 0.764-0.254 0.213-1.164 1.235-2.049 2.459-2.049s2.246 0.885 2.459 2.049c0.218 0.041 0.489 0.116 0.764 0.254 0.816 0.408 1.268 1.178 1.276 2.17 0.001 0.009 0.001 0.018 0.001 0.027 0 0.276-0.224 0.5-0.5 0.5zM6.060 4h6.88c-0.096-0.356-0.307-0.617-0.638-0.79-0.389-0.203-0.8-0.21-0.805-0.21-0.276 0-0.497-0.224-0.497-0.5 0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5c0 0.276-0.224 0.5-0.5 0.5-0.001 0-0.413 0.007-0.802 0.21-0.331 0.173-0.542 0.433-0.638 0.79z\"></path><path fill=\"#000\" d=\"M9.5 3c-0.132 0-0.261-0.053-0.353-0.147s-0.147-0.222-0.147-0.353 0.053-0.261 0.147-0.353c0.093-0.093 0.222-0.147 0.353-0.147s0.261 0.053 0.353 0.147c0.093 0.093 0.147 0.222 0.147 0.353s-0.053 0.26-0.147 0.353c-0.093 0.093-0.222 0.147-0.353 0.147z\"></path><path fill=\"#000\" d=\"M8 14c-0.128 0-0.256-0.049-0.354-0.146l-1.5-1.5c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1.146 1.146 4.146-4.146c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-4.5 4.5c-0.098 0.098-0.226 0.146-0.354 0.146z\"></path></svg>"

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path fill=\"#000\" d=\"M16.5 20h-14c-0.827 0-1.5-0.673-1.5-1.5v-14c0-0.827 0.673-1.5 1.5-1.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5 0.224-0.5 0.5v14c0 0.276 0.224 0.5 0.5 0.5h14c0.276 0 0.5-0.224 0.5-0.5v-14c0-0.276-0.224-0.5-0.5-0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.827 0 1.5 0.673 1.5 1.5v14c0 0.827-0.673 1.5-1.5 1.5z\"></path><path fill=\"#000\" d=\"M13.501 5c-0 0-0 0-0.001 0h-8c-0.276 0-0.5-0.224-0.5-0.5 0-1.005 0.453-1.786 1.276-2.197 0.275-0.138 0.547-0.213 0.764-0.254 0.213-1.164 1.235-2.049 2.459-2.049s2.246 0.885 2.459 2.049c0.218 0.041 0.489 0.116 0.764 0.254 0.816 0.408 1.268 1.178 1.276 2.17 0.001 0.009 0.001 0.018 0.001 0.027 0 0.276-0.224 0.5-0.5 0.5zM6.060 4h6.88c-0.096-0.356-0.307-0.617-0.638-0.79-0.389-0.203-0.8-0.21-0.805-0.21-0.276 0-0.497-0.224-0.497-0.5 0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5c0 0.276-0.224 0.5-0.5 0.5-0.001 0-0.413 0.007-0.802 0.21-0.331 0.173-0.542 0.433-0.638 0.79z\"></path><path fill=\"#000\" d=\"M9.5 3c-0.132 0-0.261-0.053-0.353-0.147s-0.147-0.222-0.147-0.353 0.053-0.261 0.147-0.353c0.093-0.093 0.222-0.147 0.353-0.147s0.261 0.053 0.353 0.147c0.093 0.093 0.147 0.222 0.147 0.353s-0.053 0.26-0.147 0.353c-0.093 0.093-0.222 0.147-0.353 0.147z\"></path><path fill=\"#000\" d=\"M11.854 12.646c-0.195-0.195-0.512-0.195-0.707 0l-1.146 1.146v-5.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v5.293l-1.146-1.146c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2 2c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2-2c0.195-0.195 0.195-0.512-0-0.707z\"></path></svg>"

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path fill=\"#000\" d=\"M15.5 19c-0.082 0-0.164-0.020-0.239-0.061l-5.261-2.869-5.261 2.869c-0.168 0.092-0.373 0.079-0.529-0.032s-0.235-0.301-0.203-0.49l0.958-5.746-3.818-3.818c-0.132-0.132-0.18-0.328-0.123-0.506s0.209-0.31 0.394-0.341l5.749-0.958 2.386-4.772c0.085-0.169 0.258-0.276 0.447-0.276s0.363 0.107 0.447 0.276l2.386 4.772 5.749 0.958c0.185 0.031 0.337 0.162 0.394 0.341s0.010 0.374-0.123 0.506l-3.818 3.818 0.958 5.746c0.031 0.189-0.048 0.379-0.203 0.49-0.086 0.061-0.188 0.093-0.29 0.093zM10 15c0.082 0 0.165 0.020 0.239 0.061l4.599 2.508-0.831-4.987c-0.027-0.159 0.025-0.322 0.14-0.436l3.313-3.313-5.042-0.84c-0.158-0.026-0.293-0.127-0.365-0.27l-2.053-4.106-2.053 4.106c-0.072 0.143-0.207 0.243-0.365 0.27l-5.042 0.84 3.313 3.313c0.114 0.114 0.166 0.276 0.14 0.436l-0.831 4.987 4.599-2.508c0.075-0.041 0.157-0.061 0.239-0.061z\"></path></svg>"

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M11.5 16h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 11h-13c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h13c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M19.557 11.383l-2.698-6.168c-0.159-0.364-0.475-0.699-0.859-0.925l0-3.791c0-0.133-0.053-0.26-0.146-0.354s-0.221-0.146-0.354-0.146h-11c-0.133 0-0.26 0.053-0.354 0.146s-0.146 0.221-0.146 0.354l0 3.791c-0.384 0.226-0.699 0.56-0.859 0.925l-2.698 6.168c-0.248 0.568-0.443 1.497-0.443 2.117v4c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-4c0-0.619-0.194-1.549-0.443-2.117zM15 1l-0 7h-10l-0-7h10zM4 5.747v2.753c0 0.276 0.224 0.5 0.5 0.5h11c0.276 0 0.5-0.224 0.5-0.5l0-2.752 2.641 6.037c0.030 0.069 0.060 0.148 0.089 0.233-0.075-0.012-0.152-0.018-0.23-0.018h-17c-0.078 0-0.155 0.006-0.23 0.018 0.029-0.085 0.058-0.164 0.089-0.233l2.641-6.037zM19 17.5c0 0.276-0.224 0.5-0.5 0.5h-17c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5h17c0.276 0 0.5 0.224 0.5 0.5v4z\"></path><path d=\"M13.5 7h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 5h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 3h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path></svg>"

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M19.5 20h-19c-0.276 0-0.5-0.224-0.5-0.5v-19c0-0.232 0.159-0.433 0.385-0.487s0.458 0.056 0.562 0.263l1 2c0.123 0.247 0.023 0.547-0.224 0.671s-0.547 0.023-0.671-0.224l-0.053-0.106v16.382h16.382l-0.106-0.053c-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224l2 1c0.207 0.104 0.316 0.336 0.263 0.562s-0.255 0.385-0.487 0.385z\"></path><path d=\"M17 4.5c0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5c0 0.48 0.227 0.908 0.579 1.182l-2.106 6.318c-0.28 0.005-0.541 0.087-0.764 0.226l-2.792-2.234c0.054-0.154 0.084-0.32 0.084-0.493 0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5c0 0.404 0.161 0.77 0.421 1.040l-1.736 3.472c-0.061-0.008-0.122-0.012-0.185-0.012-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5c0-0.404-0.161-0.77-0.421-1.040l1.736-3.472c0.061 0.008 0.122 0.012 0.185 0.012 0.29 0 0.562-0.083 0.791-0.227l2.792 2.234c-0.054 0.154-0.084 0.32-0.084 0.493 0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5c0-0.48-0.227-0.908-0.579-1.183l2.106-6.318c0.814-0.015 1.473-0.681 1.473-1.499zM15.5 4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM7.5 9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM4.5 16c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM12.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5z\"></path></svg>"

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" xml:space=\"preserve\"><path d=\"M23.5,6.1L4.4,25.1c-1.2,1.2-1.9,2.9-1.9,4.7c0,1.7,0.7,3.4,1.9,4.7l19.1,19.1c2.6,2.6,6.7,2.6,9.3,0 c2.6-2.6,2.6-6.7,0-9.3L25,36.3h44.6c8.2,0,14.8,6.6,14.8,14.8v16.8c0,8.2-6.6,14.8-14.8,14.8H9.1c-3.6,0-6.6,2.9-6.6,6.6 c0,3.6,2.9,6.6,6.6,6.6h60.5c15.4,0,27.9-12.5,27.9-27.9V51.1c0-15.4-12.5-27.9-27.9-27.9H25l7.8-7.8c1.3-1.3,1.9-3,1.9-4.7 c0-1.7-0.6-3.4-1.9-4.7C30.2,3.5,26.1,3.5,23.5,6.1z\"></path></svg>"

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M16.23 3.307c-0.396-0.268-0.949-0.504-1.643-0.702-1.366-0.39-3.172-0.605-5.087-0.605s-3.722 0.215-5.087 0.605c-0.694 0.198-1.246 0.434-1.643 0.702-0.637 0.43-0.77 0.886-0.77 1.193v0.5c0 0.428 0.321 1.133 0.639 1.609l4.891 7.336c0.251 0.376 0.471 1.103 0.471 1.555v3c0 0.173 0.090 0.334 0.237 0.425 0.080 0.050 0.171 0.075 0.263 0.075 0.076 0 0.153-0.018 0.224-0.053l2-1c0.169-0.085 0.276-0.258 0.276-0.447v-2c0-0.452 0.22-1.179 0.471-1.555l4.891-7.336c0.317-0.476 0.639-1.182 0.639-1.609v-0.5c0-0.307-0.134-0.763-0.77-1.193zM4.688 3.567c1.279-0.365 2.988-0.567 4.812-0.567s3.534 0.201 4.812 0.567c1.378 0.394 1.688 0.816 1.688 0.933s-0.31 0.54-1.688 0.933c-1.279 0.365-2.988 0.567-4.812 0.567s-3.534-0.201-4.812-0.567c-1.378-0.394-1.688-0.816-1.688-0.933s0.31-0.54 1.688-0.933zM10.639 13.391c-0.358 0.537-0.639 1.464-0.639 2.109v1.691l-1 0.5v-2.191c0-0.646-0.281-1.572-0.639-2.109l-4.88-7.32c0.274 0.117 0.585 0.226 0.932 0.324 1.366 0.39 3.172 0.605 5.087 0.605s3.722-0.215 5.087-0.605c0.346-0.099 0.658-0.207 0.932-0.325l-4.88 7.32z\"></path></svg>"

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M18.5 2h-2.5v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-10v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-2.5c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-14c0-0.827-0.673-1.5-1.5-1.5zM1.5 3h2.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h10v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h2.5c0.276 0 0.5 0.224 0.5 0.5v2.5h-18v-2.5c0-0.276 0.224-0.5 0.5-0.5zM18.5 18h-17c-0.276 0-0.5-0.224-0.5-0.5v-10.5h18v10.5c0 0.276-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M4.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M4.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M4.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path></svg>"

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M12.853 11.647l-2-2c-0.195-0.195-0.512-0.195-0.707 0l-2 2c-0.195 0.195-0.195 0.512 0 0.707s0.512 0.195 0.707 0l1.146-1.146v4.293c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-4.293l1.147 1.146c0.098 0.098 0.226 0.146 0.353 0.146s0.256-0.049 0.353-0.147c0.195-0.195 0.195-0.512 0-0.707z\"></path><path d=\"M16.006 16h-3.506c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3.506c1.651 0 2.994-1.343 2.994-2.994s-1.343-2.994-2.994-2.994c-0.354 0-0.699 0.061-1.026 0.18-0.218 0.080-0.462-0.001-0.59-0.195s-0.104-0.45 0.056-0.619c0.357-0.376 0.554-0.865 0.554-1.379 0-1.103-0.897-2-2-2-0.642 0-1.229 0.297-1.61 0.814-0.23 0.312-0.365 0.678-0.388 1.057-0.013 0.212-0.159 0.392-0.363 0.45s-0.423-0.020-0.545-0.193c-0.11-0.156-0.229-0.307-0.354-0.447-0.949-1.068-2.312-1.681-3.74-1.681-2.757 0-5 2.243-5 5s2.243 5 5 5h2.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.5c-3.308 0-6-2.692-6-6s2.692-6 6-6c1.602 0 3.137 0.643 4.26 1.775 0.088-0.194 0.196-0.38 0.325-0.555 0.564-0.764 1.467-1.22 2.415-1.22 1.654 0 3 1.346 3 3 0 0.351-0.061 0.694-0.178 1.017 0.061-0.003 0.122-0.004 0.184-0.004 2.202 0 3.994 1.792 3.994 3.994s-1.792 3.994-3.994 3.994z\"></path></svg>"

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M18.5 20h-17c-0.827 0-1.5-0.673-1.5-1.5v-17c0-0.827 0.673-1.5 1.5-1.5h17c0.827 0 1.5 0.673 1.5 1.5v17c0 0.827-0.673 1.5-1.5 1.5zM1.5 1c-0.276 0-0.5 0.224-0.5 0.5v17c0 0.276 0.224 0.5 0.5 0.5h17c0.276 0 0.5-0.224 0.5-0.5v-17c0-0.276-0.224-0.5-0.5-0.5h-17z\"></path><path d=\"M17.5 2h-15c-0.276 0-0.5 0.224-0.5 0.5v12c0 0.276 0.224 0.5 0.5 0.5h10.794c0.001 0 0.002 0 0.003 0s0.002-0 0.003-0h4.2c0.276 0 0.5-0.224 0.5-0.5v-12c0-0.276-0.224-0.5-0.5-0.5zM7.536 14c0.506-0.664 1.331-1 2.464-1s1.959 0.336 2.464 1h-4.928zM17 14h-3.373c-0.418-0.864-1.393-2-3.627-2s-3.209 1.136-3.627 2h-3.373v-11h14v11z\"></path><path d=\"M10 11c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 6c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2z\"></path><path d=\"M17.5 18h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path></svg>"

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(547)
};

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-branding c-branding--journey\"> <div class=c-branding__headings> <h2 class=c-branding__heading>Welcome to the Hotel Lobby</h2> <p class=c-branding__subheading>Where everything comes together</p> <div class=c-branding__logo> <img src=https://s3-eu-west-1.amazonaws.com/lobby-live-uploads/public/branding-media/journey-logo.svg alt=\"Journey - Hotel Digital Marketing\"/> </div> </div> </div>";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var formFieldErrorsDirective = function formFieldErrorsDirective($compile) {
  return {
    require: ['ngModel', '^form'],
    restrict: 'A',
    link: function link(scope, element, attrs, ctrls) {
      // Can't use a real isolate scope as it clashes with other directives that
      // require one on the same element
      var isolateScope = scope.$new();
      isolateScope.model = ctrls[0];
      isolateScope.form = ctrls[1];
      isolateScope.errors = [];

      isolateScope.model.$registerApiError = function (code) {
        code = 'api.' + code;
        isolateScope.errors.push(code);

        isolateScope.model.$setValidity(code, false);
      };

      isolateScope.model.$validators.apiValidate = function () {
        (0, _lodash.forEach)(isolateScope.errors, function (value, key) {
          isolateScope.model.$setValidity(value, true);
          delete isolateScope.errors[key];
        });
        return true;
      };
      element.after($compile('\n        <div class="c-help-text" ng-if="model.$touched || form.$submitted" ng-messages="model.$error">\n          <div ng-message="email" class="c-form__field__error">Please enter a valid email address</div>\n          <div ng-message="url" class="c-form__field__error">Please enter a valid URL</div>\n          <div ng-message="required" class="c-form__field__error">Please enter a value</div>\n          <div ng-message="api.required" class="c-form__field__error">Please enter a value</div>\n          <div ng-message="passwordMatch" class="c-form__field__error">Password and confirmation do not match</div>\n          <div ng-message="api.validation.mimetypes" class="c-form__field__error">Please select a valid file type</div>\n          <div ng-message="pattern" class="c-form__field__error">Please enter a valid pattern</div>\n          <div ng-message="slug" class="c-form__field__error">That URL has already been taken, please enter a unique value.</div>\n          <div ng-message="api.unique" class="c-form__field__error">That value has already been taken, please enter a unique value.</div>\n        </div>\n      ')(isolateScope));
    }
  };
};

formFieldErrorsDirective.$inject = ['$compile'];

exports.default = formFieldErrorsDirective;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$compile', function ($compile) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var requiredElement = $compile('<span ng-if="required" class="c-form__required"></span>')(scope);

      if (!element.parent()[0].querySelector('.c-form__required')) {
        element.parent()[0].insertBefore(requiredElement[0], element[0]);
      }

      attrs.$observe('required', function () {
        scope.required = attrs.required;
      });
    }
  };
}];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var confirmDirective = function confirmDirective($modal) {
    return {
        priority: -99,
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.title = attrs.title || 'Confirm';
            scope.message = attrs.confirm || 'Are you sure?';
            scope.yes = attrs.yes || 'Yes';
            scope.no = attrs.no || 'No';

            element.bind('click', function (event) {
                if (attrs.disabled) {
                    return;
                }

                event.stopImmediatePropagation();
                event.preventDefault();

                var confirm = $modal.open({
                    scope: scope,
                    template: '\n            <h3>{{ title }}</h3>\n\n            <p>{{ message }}</p>\n\n            <button type="button" class="button" ng-click="$dismiss()">{{ no }}</button>\n            <button type="button" class="button" ng-click="$close()">{{ yes }}</button>\n          ',
                    windowClass: 'c-modal__reveal'
                });

                confirm.result.then(function () {
                    return attrs.ngClick ? scope.$eval(attrs.ngClick) : null;
                }).catch(function () {});
            });
        }
    };
};

confirmDirective.$inject = ['$modal'];

exports.default = confirmDirective;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var markdown = function markdown(markdownService) {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            element.innerHTML = markdownService.translate(element.innerHTML);
        }
    };
};

markdown.$inject = ['markdownService'];

exports.default = markdown;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _marked = __webpack_require__(553);

var marked = _interopRequireWildcard(_marked);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = [function () {

  var translateText = function translateText(text, removeP) {
    var returnText = marked.parse(text);

    if (removeP) {
      returnText = returnText.replace(new RegExp('<\/?p>', 'g'), '');
    }
    return returnText;
  };

  return {
    translate: function translate(text) {
      var removeP = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return translateText(text, removeP);
    },
    translatePure: function translatePure(text) {
      return marked.parse(text);
    }
  };
}];

/***/ }),
/* 553 */,
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

exports.default = ['$http', '$rootScope', '$location', 'Upload', function ($http, $rootScope, $location, Upload) {
    var defaultConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    };

    var buildUrl = function buildUrl(url) {
        return '//' + $location.host() + url;
    };

    var makeRequest = function makeRequest(method, url, data) {
        var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultConfig;

        config = Object.assign({}, defaultConfig, config);

        url = buildUrl(url);

        data = data ? (0, _lodash.omit)(data, ['uuid', 'id', '_embedded', '_links']) : data;

        return data ? method(url, data, config) : method(url, config);
    };

    var _upload = function _upload(url, data) {
        if (data.id || data.user_id) {
            data._method = 'PUT';
        }

        var request = {
            url: buildUrl(url),
            data: data,
            method: 'POST'
        };

        return Upload.upload(request);
    };

    return {
        property: function property() {
            return $rootScope.currentProperty ? $rootScope.currentProperty.id : 0;
        },
        get: function get(url, config) {
            return makeRequest($http.get, url, null, config);
        },
        post: function post(url, data) {
            return makeRequest($http.post, url, data);
        },
        upload: function upload(url, data) {
            return _upload(url, data);
        },
        put: function put(url, data) {
            return makeRequest($http.put, url, data);
        },
        patch: function patch(url, data) {
            return makeRequest($http.patch, url, data);
        },
        delete: function _delete(url) {
            return makeRequest($http.delete, url);
        },
        buildUrl: buildUrl
    };
}];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$rootScope', '$timeout', '$window', function ($rootScope, $timeout, $window) {
    var messageService = {};
    messageService.display = undefined;
    messageService.link = undefined;
    messageService.displaylink = undefined;
    messageService.linktext = undefined;
    messageService.displaylinktext = undefined;
    messageService.text = undefined;
    messageService.counter = undefined;
    messageService.class = undefined;
    messageService.timeout = undefined;

    $rootScope.$on("$locationChangeSuccess", function () {
        if (messageService.counter === 1) {
            messageService.push();
        } else {
            messageService.counter--;
        }
    });

    messageService.success = function (text) {
        var linkparams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var counter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

        messageService.alerttype = 'alert--success';
        messageService.updateText(text, counter);
        if (linkparams) messageService.updateLink(linkparams[0], linkparams[1]);
    };

    messageService.failure = function (text) {
        var linkparams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var counter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

        messageService.alerttype = 'alert--fail';
        messageService.updateText(text, counter);
        if (linkparams) messageService.updateLink(linkparams[0], linkparams[1]);
    };

    messageService.updateText = function (text, counter) {
        messageService.class = undefined;
        messageService.text = text;
        messageService.counter = counter;
        $window.scrollTo(0, 0);
    };

    messageService.updateLink = function (link, linktext) {
        messageService.link = link;
        messageService.linktext = '[ Edit this ' + linktext + ' ]';
    };

    messageService.push = function () {
        messageService.class = undefined;
        messageService.display = messageService.text ? messageService.text : undefined;
        messageService.displaylink = messageService.link ? messageService.link : undefined;
        messageService.displaylinktext = messageService.linktext ? messageService.linktext : undefined;
        messageService.reset();
    };

    messageService.reset = function () {
        messageService.text = undefined;
        messageService.link = undefined;
        messageService.linktext = undefined;
    };

    messageService.clear = function () {
        messageService.display = undefined;
        messageService.displaylink = undefined;
        messageService.displaylinktext = undefined;
    };

    messageService.autoClear = function () {
        if (messageService.timeout) {
            $timeout.cancel(messageService.timeout);
        }
        messageService.timeout = $timeout(function () {
            messageService.class = 'alert--remove';
            $timeout(function () {
                messageService.clear();
            }, 500);
        }, 3000);
    };

    messageService.formatError = function (field, error) {
        var message = '';

        switch (field) {
            case 'slug':
                message = 'The URL';
                break;
            default:
                message = 'The ' + field + ' field';
        }

        if (Array.isArray(error)) {
            var messages = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = error[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var err = _step.value;

                    messages.push(messageService.switchError(err));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            message += messages.join(',') + '.';
        } else {
            message += messageService.switchError(error) + '.';
        }

        return message;
    };

    messageService.switchError = function (error) {
        var message = '';

        switch (error) {
            case 'required':
                message = ' is required';
                break;

            case 'conflict':
                message = ' is conflicting with another existing resource';
                break;

            case 'unique':
                message = ' needs to be unique; that value already exists';
                break;

            default:
                message = error;
        }

        return message;
    };

    return messageService;
}];

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['permissionsService', function (permissionsService) {
    var accessService = {};

    accessService.check = function (input) {
        if (Array.isArray(input)) {
            return input.some(function (permission) {
                return accessService.matchPermission(permission);
            });
        }

        return accessService.matchPermission(input);
    };

    accessService.matchPermission = function (permission) {
        switch (permission) {
            case 'admin':
                return permissionsService.user.indexOf('admin') > -1;

            case 'manager':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1;

            case 'only_investor':
                return permissionsService.user.indexOf('investor') > -1;

            case 'only_premier':
                return permissionsService.user.indexOf('premier_admin') > -1;

            case 'investor':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('investor') > -1;

            case 'premier_admin':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('premier_admin') > -1 || permissionsService.user.indexOf('investor') > -1;

            case 'orders':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1 || permissionsService.user.indexOf('orders') > -1;

            case 'stock':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1 || permissionsService.user.indexOf('stock') > -1;

            case 'reporting':
                return permissionsService.user.indexOf('admin') > -1 || permissionsService.user.indexOf('manager') > -1 || permissionsService.user.indexOf('reporting') > -1;
        }
    };

    return accessService;
}];

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [function () {

  var readableSlug = function readableSlug() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!text) {
      return;
    }
    return text.replace(new RegExp('_', 'g'), ' ').replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  var caps = function caps() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!text) {
      return;
    }
    return text.toUpperCase();
  };

  return {
    deslug: function deslug() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return readableSlug(text);
    },
    uppercase: function uppercase() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return caps(text);
    }
  };
}];

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property, appClass, id) {
    return '/api/' + property + '/audits/' + appClass + '/' + id;
};

exports.default = ['api', function (api) {
    return {
        find: function find(appClass, id) {
            return api.get('' + endpoint(api.property(), appClass, id)).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$rootScope', function ($rootScope) {
    return {
        get: function get() {
            return $rootScope.currentProperty;
        }
    };
}];

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboard = __webpack_require__(561);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dashboard3 = __webpack_require__(562);

var _dashboard4 = _interopRequireDefault(_dashboard3);

var _premierDashboard = __webpack_require__(563);

var _premierDashboard2 = _interopRequireDefault(_premierDashboard);

var _modal = __webpack_require__(564);

var _modal2 = _interopRequireDefault(_modal);

var _uploadContracts = __webpack_require__(565);

var _uploadContracts2 = _interopRequireDefault(_uploadContracts);

var _dashboard5 = __webpack_require__(566);

var _dashboard6 = _interopRequireDefault(_dashboard5);

var _revenueDashboard = __webpack_require__(568);

var _revenueDashboard2 = _interopRequireDefault(_revenueDashboard);

var _statisticsDashboard = __webpack_require__(570);

var _statisticsDashboard2 = _interopRequireDefault(_statisticsDashboard);

var _premierDashboard3 = __webpack_require__(572);

var _premierDashboard4 = _interopRequireDefault(_premierDashboard3);

var _uploadContracts3 = __webpack_require__(574);

var _uploadContracts4 = _interopRequireDefault(_uploadContracts3);

var _bestSellersDashboard = __webpack_require__(576);

var _bestSellersDashboard2 = _interopRequireDefault(_bestSellersDashboard);

var _dataApi = __webpack_require__(578);

var _dataApi2 = _interopRequireDefault(_dataApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dashboardModule = angular.module('spabooker.dashboard', []).config(_dashboard2.default).controller('dashboardController', _dashboard4.default).controller('premierDashboardController', _premierDashboard2.default).controller('modalController', _modal2.default).controller('uploadContractsController', _uploadContracts2.default).component('dashboard', _dashboard6.default).component('revenueDashboard', _revenueDashboard2.default).component('statisticsDashboard', _statisticsDashboard2.default).component('premierDashboard', _premierDashboard4.default).component('uploadContracts', _uploadContracts4.default).component('bestSellersDashboard', _bestSellersDashboard2.default).factory('dataApiService', _dataApi2.default);

exports.default = dashboardModule.name;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.dashboard', {
        url: '/',
        component: 'dashboard',
        roles: []
    }).state('app.admin.revenueDashboard', {
        url: '/revenue-dashboard',
        component: 'revenueDashboard',
        resolve: {
            isGlobal: function isGlobal() {
                return true;
            },
            isRevenue: function isRevenue() {
                return true;
            }
        },
        roles: ['admin', 'investor']
    }).state('app.admin.statisticsDashboard', {
        url: '/statistics-dashboard',
        component: 'statisticsDashboard',
        resolve: {
            isGlobal: function isGlobal() {
                return true;
            },
            isStatistics: function isStatistics() {
                return true;
            }
        },
        roles: ['admin', 'investor']
    }).state('app.admin.bestSellersDashboard', {
        url: '/best-sellers',
        component: 'bestSellersDashboard',
        resolve: {
            isBestSellers: function isBestSellers() {
                return true;
            }
        }
    }).state('app.admin.premierDashboard', {
        url: '/premier-dashboard',
        component: 'premierDashboard',
        roles: ['admin', 'investor', 'premier_admin']
    }).state('app.admin.uploadContractCSV', {
        url: '/upload-contracts',
        component: 'uploadContracts',
        roles: ['admin']
    });
}];

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardController = function () {
    function DashboardController($rootScope, $scope, $state, access, authService, dataApiService, $modal, storeService, propertiesService, propertyGroupService, loadingService) {
        _classCallCheck(this, DashboardController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.access = access;
        this.userData = authService.getProfile();
        this.dataApiService = dataApiService;
        this.$modal = $modal;
        this.storeService = storeService;
        this.propertiesService = propertiesService;
        this.propertyGroupService = propertyGroupService;
        this.loadingService = loadingService;
    }

    _createClass(DashboardController, [{
        key: '$onInit',
        value: function $onInit() {
            this.relativeTimes = this.relativeTimeScale();

            if (this.access.check('only_investor') && this.$state.current.name === 'app.dashboard') {
                this.$state.go('app.admin.revenueDashboard');
            }

            if (this.access.check('only_premier') && this.$state.current.name === 'app.dashboard') {
                this.$state.go('app.admin.premierDashboard');
            }

            if (this.access.check('reporting') || this.access.check('investor')) {
                this.timeFrame = this.isGlobal ? 'This month' : 'This week';

                this.showGroupData = this.storeService.get('group_dashboard') || false;

                this.getReportData(true);

                if (this.isGlobal) {
                    this.getProperties();
                }
                if (this.isRevenue) {
                    this.getAccountSummaryData();
                }
            }
        }
    }, {
        key: 'getReportData',
        value: function getReportData(setTimeFrame) {
            if (this.isDataLoading()) {
                return;
            }

            if (setTimeFrame && !this.setTimeFrame()) {
                return false;
            };

            if (this.isGlobal) {
                return this.getGlobalData();
            }

            if (this.isBestSellers) {
                return this.getBestSellersDetails();
            }

            this.getClientData();
        }
    }, {
        key: 'getGlobalData',
        value: function getGlobalData() {
            this.setProperty();

            this.getRevenueByTypeData();

            if (this.isRevenue) {
                this.getOrdersData();
                this.getAccountStatsData();
                this.getCommissionData();
                this.getOrdersRCData();
                this.getUpgradesData();
                this.getAverageSpendData();
                this.getPaidExtrasData();

                return;
            }

            this.getSalesByTypeData();
            this.getMetricsData();
            this.getPopularOfferData();
            this.getPopularOptionsData();
            this.getPopularDurationData();
            this.getBestSellersData();
            this.getLeaderboardData();
            this.getTreatmentsData();
            this.getOrderInsightsData();
        }
    }, {
        key: 'getClientData',
        value: function getClientData() {
            this.getRevenueByTypeData();
            this.getSalesByTypeData();
            this.getAverageSpendData();
            this.getUpgradesData();
            this.getOrdersData();
            this.getBestSellersData();
            this.getPaidExtrasData();
            this.getTreatmentsData();
        }
    }, {
        key: 'getSalesByTypeData',
        value: function getSalesByTypeData() {
            var _this = this;

            this.loadingService.startLoading('salesByType');
            return this.dataApiService.getData('salesByType', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this.loadingService.stopLoading('salesByType');
                _this.salesByType = response;
                _this.salesByType.total = (_this.salesByType.Treatment || 0) + (_this.salesByType.SpaDay || 0) + (_this.salesByType.EventExtra || 0);
            });
        }
    }, {
        key: 'getRevenueByTypeData',
        value: function getRevenueByTypeData() {
            var _this2 = this;

            this.loadingService.startLoading('revenueByType');
            return this.dataApiService.getData('revenueByType', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this2.loadingService.stopLoading('revenueByType');
                _this2.revenueByType = response;

                _this2.transformRevenueByType();
            });
        }
    }, {
        key: 'getAverageSpendData',
        value: function getAverageSpendData() {
            var _this3 = this;

            this.loadingService.startLoading('averageSpend');
            return this.dataApiService.getData('averageSpend', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this3.loadingService.stopLoading('averageSpend');
                _this3.averageSpend = response;
            });
        }
    }, {
        key: 'getBestSellersData',
        value: function getBestSellersData() {
            var _this4 = this;

            this.loadingService.startLoading('bestSellers');
            return this.dataApiService.getData('bestSellers', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties, 5).then(function (response) {
                _this4.loadingService.stopLoading('bestSellers');
                _this4.bestSellers = response;
            });
        }
    }, {
        key: 'getUpgradesData',
        value: function getUpgradesData() {
            var _this5 = this;

            this.loadingService.startLoading('upgrades');
            return this.dataApiService.getData('upgrades', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this5.loadingService.stopLoading('upgrades');
                _this5.upgrades = null;
                if (Object.keys(response).length > 0) {
                    _this5.upgrades = response;
                }
            });
        }
    }, {
        key: 'getOrdersData',
        value: function getOrdersData() {
            var _this6 = this;

            this.loadingService.startLoading('orders');
            return this.dataApiService.getData('orders', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this6.loadingService.stopLoading('orders');
                _this6.orders = response;
            });
        }
    }, {
        key: 'getOrdersRCData',
        value: function getOrdersRCData() {
            var _this7 = this;

            this.loadingService.startLoading('ordersRC');
            return this.dataApiService.getData('ordersRC', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this7.loadingService.stopLoading('ordersRC');
                _this7.ordersRC = response;
            });
        }
    }, {
        key: 'getPaidExtrasData',
        value: function getPaidExtrasData() {
            var _this8 = this;

            this.loadingService.startLoading('paidExtras');
            return this.dataApiService.getData('paidExtras', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this8.loadingService.stopLoading('paidExtras');
                _this8.paidExtras = response;
            });
        }
    }, {
        key: 'getTreatmentsData',
        value: function getTreatmentsData() {
            var _this9 = this;

            this.loadingService.startLoading('treatments');
            return this.dataApiService.getData('treatments', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this9.loadingService.stopLoading('treatments');
                _this9.treatments = response;
            });
        }
    }, {
        key: 'getMetricsData',
        value: function getMetricsData() {
            var _this10 = this;

            this.loadingService.startLoading('metrics');
            return this.dataApiService.getData('metrics', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this10.loadingService.stopLoading('metrics');
                _this10.metrics = response;
            });
        }
    }, {
        key: 'getPopularOptionsData',
        value: function getPopularOptionsData() {
            var _this11 = this;

            this.loadingService.startLoading('popularOptions');
            return this.dataApiService.getData('popularOptions', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties, 5).then(function (response) {
                _this11.loadingService.stopLoading('popularOptions');
                _this11.popularOptions = response;
            });
        }
    }, {
        key: 'getPopularDurationData',
        value: function getPopularDurationData() {
            var _this12 = this;

            this.loadingService.startLoading('popularDuration');
            return this.dataApiService.getData('popularDuration', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties, 5).then(function (response) {
                _this12.loadingService.stopLoading('popularDuration');
                _this12.popularDuration = response;
            });
        }
    }, {
        key: 'getPopularOfferData',
        value: function getPopularOfferData() {
            var _this13 = this;

            this.loadingService.startLoading('popularOffer');
            return this.dataApiService.getData('popularOffer', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this13.loadingService.stopLoading('popularOffer');
                _this13.popularOffer = response;
            });
        }
    }, {
        key: 'getCommissionData',
        value: function getCommissionData() {
            var _this14 = this;

            this.loadingService.startLoading('commission');
            return this.dataApiService.getData('commission', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this14.loadingService.stopLoading('commission');
                _this14.commission = _this14.orderByCurrency(response);
            });
        }
    }, {
        key: 'getAccountStatsData',
        value: function getAccountStatsData() {
            var _this15 = this;

            this.loadingService.startLoading('accountStats');
            return this.dataApiService.getData('accountStats', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this15.loadingService.stopLoading('accountStats');
                _this15.accountStats = response;

                for (var status in _this15.accountStats) {
                    _this15.orderByCurrency(_this15.accountStats[status]);
                }
            });
        }
    }, {
        key: 'getAccountSummaryData',
        value: function getAccountSummaryData() {
            var _this16 = this;

            this.loadingService.startLoading('accountSummary');
            return this.dataApiService.getData('accountSummary', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this16.loadingService.stopLoading('accountSummary');
                _this16.accountSummary = response;

                _this16.transformAccountSummary();
            });
        }
    }, {
        key: 'getLeaderboardData',
        value: function getLeaderboardData() {
            var _this17 = this;

            this.loadingService.startLoading('leaderboard');
            return Promise.all([this.dataApiService.getData('revenueLeaderboard', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this17.revenueLeaderboard = response;
            }), this.dataApiService.getData('orderLeaderboard', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this17.orderLeaderboard = response;
            })]).then(function () {
                _this17.loadingService.stopLoading('leaderboard');
                _this17.$scope.$digest();
            });
        }
    }, {
        key: 'getOrderInsightsData',
        value: function getOrderInsightsData() {
            var _this18 = this;

            this.loadingService.startLoading('orderInsights');
            return this.dataApiService.getData('orderInsights', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(function (response) {
                _this18.loadingService.stopLoading('orderInsights');
                _this18.orderInsights = response;
            });
        }
    }, {
        key: 'setTimeFrame',
        value: function setTimeFrame() {
            this.dateFrom = (0, _moment2.default)();
            this.dateTo = (0, _moment2.default)();

            switch (this.timeFrame) {
                case 'This week':
                    this.dateFrom.startOf('week').add(1, 'day');
                    this.dateTo.endOf('week').add(1, 'day');
                    break;
                case 'Last week':
                    this.dateFrom = this.dateFrom.subtract(1, 'week').startOf('week').add(1, 'day');
                    this.dateTo = this.dateTo.subtract(1, 'week').endOf('week').add(1, 'day');
                    break;
                case 'This month':
                    this.dateFrom.startOf('month');
                    this.dateTo.endOf('month');
                    break;
                case 'Last month':
                    this.dateFrom.subtract(1, 'month').startOf('month');
                    this.dateTo.subtract(1, 'month').endOf('month');
                    break;
                case 'This year':
                    this.dateFrom.startOf('year');
                    this.dateTo.endOf('year');
                    break;
                case 'Last year':
                    this.dateFrom.subtract(1, 'year').startOf('year');
                    this.dateTo.subtract(1, 'year').endOf('year');
                    break;
                case 'Custom':
                    if (!this.customDateFrom && !this.customDateTo) {
                        return false;
                    }
                    this.dateFrom = this.customDateFrom;
                    this.dateTo = this.customDateTo;
                    break;
            }

            this.setDateFromTo(this.dateFrom, this.dateTo);
            return true;
        }
    }, {
        key: 'setDateFromTo',
        value: function setDateFromTo(dateFrom, dateTo) {
            this.timeFrameString = dateFrom.format('Do MMMM, YYYY') + '&ndash;' + dateTo.format('Do MMMM, YYYY');
            this.dateFrom = dateFrom.format('YYYY-MM-DD');
            this.dateTo = dateTo.format('YYYY-MM-DD');
        }
    }, {
        key: 'welcome',
        value: function welcome() {
            var string = 'Good morning';
            var hour = (0, _moment2.default)().hour();
            if (hour >= 12) {
                string = 'Good afternoon';
            }
            if (hour >= 18) {
                string = 'Good evening';
            }
            string += ', ' + this.userData.nickname[0].toUpperCase() + this.userData.nickname.substring(1);

            return string;
        }
    }, {
        key: 'thisMonth',
        value: function thisMonth() {
            return (0, _moment2.default)().format('MMMM YYYY');
        }
    }, {
        key: 'lastMonth',
        value: function lastMonth() {
            return (0, _moment2.default)().subtract(1, 'month').format('MMMM YYYY');
        }
    }, {
        key: 'thisYear',
        value: function thisYear() {
            return (0, _moment2.default)().format('YYYY');
        }
    }, {
        key: 'lastYear',
        value: function lastYear() {
            return (0, _moment2.default)().subtract(1, 'year').format('YYYY');
        }
    }, {
        key: 'findOrder',
        value: function findOrder() {
            var modalInstance = this.$modal.open({
                template: '\n<form class="row c-list__search c-list__search--user">\n    <div class="columns medium-5">\n        <select ng-model="$ctrl.filtertype" ng-init="$ctrl.filtertype = $ctrl.filtertype || \'id\'">\n            <option value="id">Order ID</option>\n            <option value="customer.name">Customer Name</option>\n            <option value="customer.email">Customer Email</option>\n            <option value="order_status_id">Order Status</option>\n            <option value="payment_status_id">Payment Status</option>\n            <option value="created_at">Date created</option>\n            <option value="reference">External Reference</option>\n        </select>\n    </div>\n    <div class="columns medium-7">\n        <div class="c-list__search__fields">\n            <input class="c-list__search__input" type="text" ng-model="$ctrl.filtertext" ng-show="$ctrl.canFilterText()" placeholder="Filter by {{ $ctrl.displayFiltertype() }}..." autofocus />\n\n            <order-statuses link="$ctrl.filtertext" ng-show="$ctrl.filtertype === \'order_status_id\'"></order-statuses>\n\n            <payment-statuses link="$ctrl.filtertext" ng-show="$ctrl.filtertype === \'payment_status_id\'"></payment-statuses>\n\n            <div class="c-form__field" ng-show="$ctrl.filtertype === \'created_at\'">\n                <input name="start_time" type="text" class="c-form__input c-form__input--date" readonly form-field-errors ng-model="$ctrl.filtertext" moment-picker="$ctrl.filtertext" keyboard="true" format="YYYY-MM-DD" min-view="month" max-view="minute" set-on-select="true" autocomplete="off" validate="true">\n                <label class="c-form__label" for="start_time">Date</label>\n            </div>\n            <spinner ng-if="$ctrl.loading" />\n        </div>\n    </div>\n    <div class="columns medium-12">\n        <button class="c-list__search__button button round" ng-click="$ctrl.filterOrder()">Search</button>\n    </div>\n</form>\n',
                windowClass: 'c-modal__reveal',
                controller: 'modalController as $ctrl'
            });

            modalInstance.result.catch(function () {});
        }
    }, {
        key: 'findEvent',
        value: function findEvent() {
            var modalInstance = this.$modal.open({
                template: '\n<form class="row c-list__search c-list__search--user">\n    <div class="columns medium-5">\n        <select ng-model="$ctrl.filtertype" ng-init="$ctrl.filtertype = $ctrl.filtertype || \'treatment\'">\n            <option value="treatment">Treatment</option>\n            <option value="spaday">Spa Day</option>\n            <option value="option">Mandatory Option</option>\n            <option value="extra">Extra / Add on</option>\n        </select>\n    </div>\n    <div class="columns medium-7">\n        <div class="c-list__search__fields">\n            <input class="c-list__search__input" type="text" ng-model="$ctrl.filtertext" placeholder="Filter by {{ $ctrl.displayFiltertype() }}..." autofocus />\n            <spinner ng-if="$ctrl.loading" />\n        </div>\n    </div>\n    <div class="columns medium-12">\n        <button class="c-list__search__button button round" ng-click="$ctrl.filterEvent()">Search</button>\n    </div>\n</form>\n',
                windowClass: 'c-modal__reveal',
                controller: 'modalController as $ctrl'
            });

            modalInstance.result.catch(function () {});
        }
    }, {
        key: 'hasPropertyGroup',
        value: function hasPropertyGroup() {
            return !!this.$rootScope.currentProperty.group_property;
        }
    }, {
        key: 'isDataLoading',
        value: function isDataLoading() {
            return this.loadingService.isLoading();
        }
    }, {
        key: 'groupReportData',
        value: function groupReportData() {
            this.storeService.set('group_dashboard', this.showGroupData);
            this.getReportData(true);
        }
    }, {
        key: 'getProperties',
        value: function getProperties() {
            var _this19 = this;

            this.showGlobalData = true;
            this.propertyId = '*';
            this.properties = [];
            this.propertyGroups = [];
            return Promise.all([this.propertiesService.findAll(-1).then(function (response) {
                _this19.properties = response;
            }), this.propertyGroupService.findAll(-1).then(function (response) {
                _this19.propertyGroups = response;
            })]);
        }
    }, {
        key: 'setProperty',
        value: function setProperty() {
            this.scopeProperties = false;

            if (!this.propertyId || this.propertyId === '*' || this.propertyId === 'integrated' || this.propertyId === 'commission') {
                this.showGroupData = false;
                this.showGlobalData = true;

                if (this.propertyId === 'integrated') {
                    this.scopeProperties = 'partnerOnly';
                    this.transformAccountSummary();
                    return;
                }

                if (this.propertyId === 'commission') {
                    this.scopeProperties = 'commissionOnly';
                }
                this.transformAccountSummary();
                return;
            }

            if (this.propertyId[0] === 'p') {
                this.showGroupData = false;
                this.showGlobalData = false;
            }

            if (this.propertyId[0] === 'g') {
                this.showGroupData = true;
                this.showGlobalData = false;
            }

            this.dataApiService.setPropertyId(this.propertyId.substring(1));
            this.transformAccountSummary();
        }
    }, {
        key: 'metricsPercent',
        value: function metricsPercent(param) {
            if (!this.loadingService.isLoading('metrics') && this.metrics && Object.values(this.metrics).length > 0) {
                var percent = 0;
                if (this.metrics[param] > 0) {
                    percent = (this.metrics[param] / this.metrics.interactedBaskets * 100).toFixed(1);
                }

                return percent + '%';
            }
        }
    }, {
        key: 'orderInsightPercent',
        value: function orderInsightPercent(param) {
            if (!this.loadingService.isLoading('orderInsights') && this.orderInsights && this.orderInsights.time && Object.values(this.orderInsights.time).length > 0) {
                var percent = 0;
                if (this.orderInsights.time[param] > 0) {
                    percent = (this.orderInsights.time[param] / this.orderInsights.totalOrders * 100).toFixed(1);
                }
                if (this.orderInsights[param] > 0) {
                    percent = (this.orderInsights[param] / this.orderInsights.totalOrders * 100).toFixed(1);
                }

                return percent + '%';
            }
        }
    }, {
        key: 'percentageOfTotalOrders',
        value: function percentageOfTotalOrders(numberOfOrders, currency) {
            if (!this.loadingService.isLoading('orders') && this.orders.length && numberOfOrders > 0) {
                var orderSummary = this.orders.find(function (orderSummary) {
                    return orderSummary.currency === currency;
                });
                return numberOfOrders / orderSummary.count * 100;
            }
            return 0;
        }
    }, {
        key: 'sendCommissionReport',
        value: function sendCommissionReport(type) {
            this.dataApiService.sendCommissionReport(type);
        }
    }, {
        key: 'setCustomDateRange',
        value: function setCustomDateRange() {
            if (this.customDateFrom && this.customDateTo) {
                this.setDateFromTo(this.customDateFrom, this.customDateTo);
                this.getReportData(false);
            }
        }
    }, {
        key: 'transformAccountSummary',
        value: function transformAccountSummary() {
            var _this20 = this;

            if (this.accountSummary) {
                this.filteredAccounts = [];

                if (!this.propertyId || this.propertyId === '*') {
                    this.filteredAccounts = this.accountSummary.map(function (account) {
                        account.filtered = false;
                        return account;
                    });

                    return;
                }

                if (this.propertyId === 'integrated') {
                    this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(function (account) {
                        account.filtered = !account.integrated;
                        return account;
                    }));

                    return;
                }

                if (this.propertyId === 'commission') {
                    this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(function (account) {
                        account.filtered = account.gateway === 'stripe' ? false : true;
                        return account;
                    }));

                    return;
                }

                if (this.propertyId[0] === 'p') {
                    var property = this.properties.find(function (property) {
                        return property.id === parseInt(_this20.propertyId.slice(1));
                    });
                    this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(function (account) {
                        account.filtered = account.name === property.name ? false : true;
                        return account;
                    }));

                    return;
                }

                if (this.propertyId[0] === 'g') {
                    var group = this.propertyGroups.find(function (group) {
                        return group.properties.indexOf(parseInt(_this20.propertyId.slice(1))) > -1;
                    });
                    this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(function (account) {
                        account.filtered = account.propertyGroup === group.name ? false : true;
                        return account;
                    }));

                    return;
                }
            }
        }
    }, {
        key: 'transformRevenueByType',
        value: function transformRevenueByType() {
            var _this21 = this;

            Object.values(this.revenueByType).forEach(function (type) {
                _this21.revenueByType.total = _this21.revenueByType.total || [];

                var _loop = function _loop(currency) {
                    var totalCurrency = _this21.revenueByType.total.find(function (existing) {
                        return existing.currency === currency;
                    });
                    if (totalCurrency) {
                        totalCurrency.value += type[currency];
                        return 'continue';
                    }
                    _this21.revenueByType.total.push({
                        currency: currency,
                        value: type[currency]
                    });
                };

                for (var currency in type) {
                    var _ret = _loop(currency);

                    if (_ret === 'continue') continue;
                }
            });
            if (this.revenueByType.total) {
                this.revenueByType.total = this.orderByCurrency(this.revenueByType.total);
            }
        }
    }, {
        key: 'orderByCurrency',
        value: function orderByCurrency(array) {
            return array.sort(function (a, b) {
                if (a.currency < b.currency) {
                    return -1;
                }
                if (a.currency > b.currency) {
                    return 1;
                }
                return 0;
            });
        }
    }, {
        key: 'orderByFiltered',
        value: function orderByFiltered(array) {
            return array.sort(function (a, b) {
                return a.filtered - b.filtered;
            });
        }
    }, {
        key: 'hasData',
        value: function hasData(type) {
            if (_typeof(this[type]) === 'object') {
                return Object.keys(this[type]).length > 0;
            }
            return !!this[type];
        }
    }, {
        key: 'relativeTimeScale',
        value: function relativeTimeScale() {
            return ['Midnight—1 AM', '1 AM—2 AM', '2 AM—3 AM', '3 AM—4 AM', '4 AM—5 AM', '5 AM—6 AM', '6 AM—7 AM', '7 AM—8 AM', '8 AM—9 AM', '9 AM—10 AM', '10 AM—11 AM', '11 AM—Midday', 'Midday—1 PM', '1 PM—2 PM', '2 PM—3 PM', '3 PM—4 PM', '4 PM—5 PM', '5 PM—6 PM', '6 PM—7 PM', '7 PM—8 PM', '8 PM—9 PM', '9 PM—10 PM', '10 PM—11 PM', '11 PM—Midnight'];
        }
    }, {
        key: 'getBestSellersDetails',
        value: function getBestSellersDetails() {
            var _this22 = this;

            this.loadingService.startLoading('bestSellers');
            return this.dataApiService.getData('bestSellersDetails', this.dateFrom, this.dateTo).then(function (response) {
                _this22.categories = response.categories;
                _this22.bestSellers = response.items;
                _this22.filterBestSellers();
            }).catch(function () {}).then(function () {
                _this22.loadingService.stopLoading('bestSellers');
            });
        }
    }, {
        key: 'displayType',
        value: function displayType(type) {
            switch (type) {
                case 'Activity':
                    return 'Class';
                case 'EventExtra':
                    return 'Extra';
                case 'SpaDay':
                    return 'Spa Day';
                default:
                    return type;
            }
        }
    }, {
        key: 'filterBestSellers',
        value: function filterBestSellers() {
            var _this23 = this;

            this.hiddenCount = 0;
            this.isFiltered = false;

            this.bestSellers.forEach(function (items) {
                items.hidden = false;
                items.hiddenCount = 0;
                items.forEach(function (item) {
                    item.hidden = false;
                });

                if (_this23.categoryFilter === '*' && _this23.typeFilter === '*') {
                    return;
                }

                _this23.isFiltered = true;

                if (_this23.categoryFilter !== '*' && _this23.categoryFilter !== items[0].category) {
                    ++_this23.hiddenCount;
                    items.hidden = true;
                    return;
                }

                if (_this23.typeFilter !== '*') {
                    items.forEach(function (item) {
                        if (_this23.typeFilter !== item.type) {
                            ++items.hiddenCount;
                            item.hidden = true;
                        }
                    });

                    if (items.hiddenCount === items.length) {
                        ++_this23.hiddenCount;
                        items.hidden = true;
                    }
                }
            });
        }
    }, {
        key: 'clearFilter',
        value: function clearFilter() {
            this.categoryFilter = '*';
            this.typeFilter = '*';
            this.filterBestSellers();
        }
    }, {
        key: 'sumParameter',
        value: function sumParameter(items, parameter) {
            var total = 0;
            if (items && items.length) {
                items.forEach(function (item) {
                    if (!item.hidden) {
                        total += parseFloat(item[parameter] || 0);
                    }
                });
            }
            return total;
        }
    }, {
        key: 'sumLeadTime',
        value: function sumLeadTime(items) {
            if (items && items.length) {
                return (this.sumParameter(items, 'lead_days') / items.length).toFixed(1);
            }
            return 0;
        }
    }, {
        key: 'sumSoldItems',
        value: function sumSoldItems(items) {
            var total = 0;
            if (items && items.length) {
                items.forEach(function (item) {
                    if (!item.hidden) {
                        total += parseFloat(item.count / (item.minimum_guests || 1));
                    }
                });
            }
            return total;
        }
    }]);

    return DashboardController;
}();

DashboardController.$inject = ['$rootScope', '$scope', '$state', 'access', 'authService', 'dataApiService', '$modal', 'storeService', 'propertiesService', 'propertyGroupService', 'loadingService'];

exports.default = DashboardController;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PremierDashboardController = function () {
    function PremierDashboardController(access, authService, dataApiService, reportsService, messageService, loadingService) {
        _classCallCheck(this, PremierDashboardController);

        this.access = access;
        this.userData = authService.getProfile();
        this.dataApiService = dataApiService;
        this.reportsService = reportsService;
        this.messageService = messageService;
        this.loadingService = loadingService;
    }

    _createClass(PremierDashboardController, [{
        key: '$onInit',
        value: function $onInit() {
            this.currentMoment = (0, _moment2.default)();

            this.loading = [];
            this.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            this.years = [];
            for (var index = 2019; index <= this.currentMoment.format('YYYY'); index++) {
                this.years.push(index);
            }
            this.years = this.years.reverse();

            this.year = '' + this.years[0];
            this.month = this.setLastMonth();

            this.getReportData();
        }
    }, {
        key: 'setLastMonth',
        value: function setLastMonth() {
            var previousMonth = this.currentMoment.format('M') - 2;
            if (previousMonth < 0) {
                previousMonth = 12 + previousMonth;
                this.year = '' + this.years[1];
            }
            return '' + previousMonth;
        }
    }, {
        key: 'welcome',
        value: function welcome() {
            var string = 'Good morning';
            var hour = this.currentMoment.hour();
            if (hour >= 12) {
                string = 'Good afternoon';
            }
            if (hour >= 18) {
                string = 'Good evening';
            }
            string += ', ' + this.userData.nickname[0].toUpperCase() + this.userData.nickname.substring(1);

            return string;
        }
    }, {
        key: 'getReportData',
        value: function getReportData() {
            if (this.isDataLoading()) {
                return;
            }

            if (this.access.check('premier_admin')) {
                return this.getPremierData();
            }
        }
    }, {
        key: 'isDataLoading',
        value: function isDataLoading() {
            return this.loadingService.isLoading();
        }
    }, {
        key: 'setDates',
        value: function setDates() {
            var date = (0, _moment2.default)(this.year + '-' + (parseInt(this.month, 10) + 1) + '-01', 'YYYY-M-DD');

            this.dateFrom = date.format('YYYY-MM-DD');
            this.dateTo = date.add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD');
        }
    }, {
        key: 'getPremierData',
        value: function getPremierData() {
            var _this = this;

            this.loadingService.startLoading(['premierStatistics', 'premierInvoiced', 'properties', 'contracts']);

            return Promise.all([this.dataApiService.getIntegrationData('premier_statistics').then(function (response) {
                _this.premierStatistics = response;
                _this.loadingService.stopLoading('premierStatistics');
            }), this.dataApiService.getIntegrationData('invoiced_amounts').then(function (response) {
                _this.premierInvoiced = response;
                _this.loadingService.stopLoading('premierInvoiced');
            }), this.dataApiService.getIntegrationData('properties').then(function (response) {
                _this.properties = _this.setStatuses(response);
                _this.loadingService.stopLoading('properties');
            }), this.dataApiService.getIntegrationData('contracts').then(function (response) {
                _this.contracts = response;
                if (_this.contracts.length) {
                    _this.contractsDate = _this.formatDate((0, _lodash.head)(_this.contracts).created_at);
                }
                _this.loadingService.stopLoading('contracts');
            })]);
        }
    }, {
        key: 'generateIntegrationReport',
        value: function generateIntegrationReport() {
            var _this2 = this;

            this.generating = true;

            if (this.hasReportFields()) {
                this.setDates();

                return this.reportsService.generateIntegration({
                    'datefrom': this.dateFrom,
                    'dateto': this.dateTo
                }).then(function (response) {
                    _this2.download = response.link;
                    _this2.filename = response.name;
                }).catch(function () {
                    _this2.messageService.failure('Unfortunately that report could not be generated, please try again.');
                    _this2.messageService.push();
                    _this2.messageService.autoClear();
                }).then(function () {
                    _this2.generating = false;
                });
            }

            this.generating = false;
        }
    }, {
        key: 'hasReportFields',
        value: function hasReportFields() {
            return !!this.month && !!this.year;
        }
    }, {
        key: 'setStatuses',
        value: function setStatuses(properties) {
            var _this3 = this;

            properties.forEach(function (property) {
                _this3.setStatus(property);
            });
            return properties;
        }
    }, {
        key: 'setStatus',
        value: function setStatus(account) {
            if (account.go_live) {
                account.status = 'Integration Live';
                account.slug = 'live';
                return;
            }

            if (account.expected_go_live) {
                account.status = 'Awaiting Client Sign-off';
                account.slug = 'client-sign-off';
                return;
            }

            if (account.import_run) {
                account.status = 'Setup in Progress';
                account.slug = 'setup';
                return;
            }

            if (account.integration_created) {
                account.status = 'API Keys Supplied';
                account.slug = 'keys-supplied';
                return;
            }

            account.status = 'Awaiting API Keys';
            account.slug = 'awaiting-keys';
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            if (date) {
                return (0, _moment2.default)(date, 'YYYY-MM-DD').format('Do MMMM, YYYY');
            }

            return '-';
        }
    }, {
        key: 'filterProperties',
        value: function filterProperties() {
            var _this4 = this;

            this.hiddenCount = 0;

            this.properties.forEach(function (property) {
                property.hidden = false;
                if (!_this4.propertyFilter) {
                    return;
                }

                if (_this4.propertyFilter !== property.slug) {
                    ++_this4.hiddenCount;
                    property.hidden = true;
                }
            });
        }
    }, {
        key: 'clearFilter',
        value: function clearFilter() {
            this.propertyFilter = null;
            this.filterProperties();
        }
    }]);

    return PremierDashboardController;
}();

PremierDashboardController.$inject = ['access', 'authService', 'dataApiService', 'reportsService', 'messageService', 'loadingService'];

exports.default = PremierDashboardController;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalController = function () {
    function ModalController($state, $modalInstance) {
        _classCallCheck(this, ModalController);

        this.$state = $state;
        this.$modalInstance = $modalInstance;
    }

    _createClass(ModalController, [{
        key: 'filterOrder',
        value: function filterOrder() {
            var _this = this;

            if (this.filtertext) {
                this.loading = true;
                return this.$state.go('app.admin.orders', { filtertype: this.filtertype, filtertext: this.filtertext }).then(function () {
                    _this.$modalInstance.close();
                });
            }
        }
    }, {
        key: 'filterEvent',
        value: function filterEvent() {
            var _this2 = this;

            var state = 'app.admin';
            switch (this.filtertype) {
                case 'treatment':
                    state = state + '.treatments';
                    break;
                case 'spaday':
                    state = state + '.days';
                    break;
                case 'option':
                    state = state + '.options';
                    break;
                case 'extra':
                    state = state + '.extras';
                    break;
            }

            return this.$state.go(state, { filtertext: this.filtertext }).then(function () {
                _this2.$modalInstance.close();
            });
        }
    }, {
        key: 'canFilterText',
        value: function canFilterText() {
            var _this3 = this;

            return ['id', 'customer.name', 'customer.email', 'reference'].some(function (allowed) {
                return allowed === _this3.filtertype;
            });
        }
    }, {
        key: 'displayFiltertype',
        value: function displayFiltertype() {
            switch (this.filtertype) {
                case 'id':
                    return 'Order ID';
                case 'customer.name':
                    return 'Customer Name';
                case 'customer.email':
                    return 'Customer Email';
                case 'order_status_id':
                    return 'Order Status';
                case 'payment_status_id':
                    return 'Payment Status';
                case 'created_at':
                    return 'Date created';
                case 'reference':
                    return 'External Reference';
                case 'treatment':
                    return 'Treatment';
                case 'spaday':
                    return 'Spa Day';
                case 'option':
                    return 'Mandatory Option';
                case 'extra':
                    return 'Extra / Add on';
            }

            return '';
        }
    }]);

    return ModalController;
}();

ModalController.$inject = ['$state', '$modalInstance'];

exports.default = ModalController;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UploadContractsController = function () {
    function UploadContractsController(integrationApiService, messageService) {
        _classCallCheck(this, UploadContractsController);

        this.integrationApiService = integrationApiService;
        this.messageService = messageService;
    }

    _createClass(UploadContractsController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            this.messageService.clear();

            return this.integrationApiService.uploadContracts({ file: this.csv }).then(function (response) {
                _this.csv = undefined;
                _this.messageService.success('Success, contract details replaced');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure(error);
                _this.messageService.push();
            });
        }
    }]);

    return UploadContractsController;
}();

UploadContractsController.$inject = ['integrationApiService', 'messageService'];

exports.default = UploadContractsController;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'dashboardController',
    template: __webpack_require__(567)
};

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = "<message></message> <div class=c-dashboard> <header class=c-page-head> <div class=c-dashboard__welcome> <h2 ng-bind-html=$ctrl.welcome()></h2> </div> <div class=\"c-page-head__actions / c-dashboard__actions\"> <button class=c-button--action ng-if=\"$ctrl.access.check('stock')\" ng-click=$ctrl.findOrder()> <icon icon=archive></icon> Find an Order </button> <button class=c-button--action ng-if=\"$ctrl.access.check('manager')\" ng-click=$ctrl.findEvent()> <icon icon=flip-flops></icon> Find an Event </button> <a ui-sref=app.admin.arrivals class=c-button--action ng-if=\"$ctrl.access.check('manager')\"> <icon icon=reports></icon> Arrivals </a> </div> </header> <main ng-if=\"$ctrl.access.check('reporting')\"> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns medium-2 large-4\"></div> <div class=\"columns medium-8 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.timeFrame ng-change=$ctrl.getReportData(true) ng-disabled=$ctrl.isDataLoading()> <optgroup label=Week> <option selected=selected>This week</option> <option>Last week</option> </optgroup> <optgroup label=Month> <option value=\"This month\" ng-bind-html=$ctrl.thisMonth()></option> <option value=\"Last month\" ng-bind-html=$ctrl.lastMonth()></option> </optgroup> <optgroup label=Year> <option value=\"This year\" ng-bind-html=$ctrl.thisYear()></option> <option value=\"Last year\" ng-bind-html=$ctrl.lastYear()></option> </optgroup> <optgroup label=Custom> <option value=Custom>Custom date range</option> </optgroup> </select> </div> <div class=\"columns medium-2 large-4\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe\" ng-if=\"$ctrl.timeFrame === 'Custom'\"> <div class=\"columns medium-0 large-2\"></div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=startDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateFrom moment-picker=$ctrl.customDateFrom keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off change=$ctrl.setCustomDateRange() ng-disabled=$ctrl.isDataLoading()> <label class=c-form__label for=startDate>Start Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateFrom = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=endDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateTo moment-picker=$ctrl.customDateTo keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off min-date=$ctrl.customDateFrom ng-disabled=\"!$ctrl.customDateFrom || $ctrl.isDataLoading()\" change=$ctrl.setCustomDateRange()> <label class=c-form__label for=endDate>End Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateTo = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-0 large-2\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns c-dashboard__group-container\"> <p class=c-dashboard__timeframe__string ng-bind-html=$ctrl.timeFrameString></p> <div class=c-dashboard__group ng-if=\"$ctrl.access.check('manager') && $ctrl.hasPropertyGroup()\" tooltip=\"Show combined data from all properties within your group\"> <span>Group data:</span> <switch id=showGroup name=showGroup ng-model=$ctrl.showGroupData class=green ng-change=$ctrl.groupReportData() disabled=$ctrl.isDataLoading()></switch> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__headlines> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Treatments sold within the selected period. This includes both standalone Treatments and attached Treatments\"></span> <dt class=c-dashboard__headline__heading>Treatments</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.revenueByType.Treatment ng-repeat=\"(currency, value) in $ctrl.revenueByType.Treatment\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.Treatment>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Spa Days sold within the selected period. This does not include Treatments, Options or Extras that are not included within the original price\"></span> <dt class=c-dashboard__headline__heading>Spa Days</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.revenueByType.SpaDay ng-repeat=\"(currency, value) in $ctrl.revenueByType.SpaDay\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.SpaDay>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Extras/Add Ons sold within the selected period. This is combined across both Treatments and Spa Days sold\"></span> <dt class=c-dashboard__headline__heading>Extras / Add Ons</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.revenueByType.EventExtra ng-repeat=\"(currency, value) in $ctrl.revenueByType.EventExtra\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.EventExtra>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Treatment, Spa Day and Extra sales within the selected period, this value may differ from Order value\"></span> <dt class=c-dashboard__headline__heading>Total</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"total in $ctrl.revenueByType.total\" decorate=\"{{ total.currency }}\" amount=\"total.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.total>N/A</span> </span> </dd> </dl> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panel> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Treatments sold within the selected period. This consists of {{ $ctrl.treatments.standalone || 0 }} standalone and {{ $ctrl.treatments.attached || 0 }} attached Treatments\"></span> <dt class=c-dashboard__headline__heading>Treatments Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=\"$ctrl.salesByType.Treatment || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Spa Days sold within the selected period\"></span> <dt class=c-dashboard__headline__heading>Spa Days Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=\"$ctrl.salesByType.SpaDay || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Extras/Add Ons sold within the selected period. This is combined across both Treatments and Spa Days sold\"></span> <dt class=c-dashboard__headline__heading>Extras / Add Ons Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=\"$ctrl.salesByType.EventExtra || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Treatments, Spa Days and Extras/Add Ons sold within the selected period\"></span> <dt class=c-dashboard__headline__heading>Total Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=$ctrl.salesByType.total></span> </dd> </dl> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panels> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Orders</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Orders within the selected period including offers, vouchers and promo codes\"></span> <dt class=c-dashboard__data__key>Total Order Sales</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\">{{ currency.count }} <small ng-if=$ctrl.showGroupData>({{currency.currency}})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Orders within the selected period including offers, vouchers and promo codes\"></span> <dt class=c-dashboard__data__key>Total Order Sales Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\" decorate=\"{{ currency.currency }}\" amount=\"currency.salesValue || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Orders within the selected period including offers but without any vouchers or promo codes applied\"></span> <dt class=c-dashboard__data__key>Total Order Face Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\" decorate=\"{{ currency.currency }}\" amount=\"currency.faceValue || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average value of Orders within the selected period\"></span> <dt class=c-dashboard__data__key>Average Order Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\" decorate=\"{{ currency.currency }}\" amount=\"currency.salesAverage || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average Order value divided by number of Guests within the selected period\"></span> <dt class=c-dashboard__data__key>Average Guest Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('averageSpend')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('averageSpend')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"average in $ctrl.averageSpend\" decorate=\"{{ average.currency }}\" amount=\"average.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('averageSpend')\">N/A</span> </span> </dd> </dl> </li> </ul> </div> </div> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Upgrades</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Upgrades sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Upgrades</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('upgrades')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('upgrades')\"> <span class=c-dashboard__headline__data__value ng-if=$ctrl.upgrades ng-repeat=\"currency in $ctrl.upgrades\">{{ currency.count }} <small ng-if=$ctrl.showGroupData>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.upgrades>N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Upgrades sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Upgrade Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('upgrades')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('upgrades')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.upgrades ng-repeat=\"currency in $ctrl.upgrades\" decorate=\"{{ currency.currency }}\" amount=\"currency.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.upgrades>N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average value of Upgrades sold within the selected period\"></span> <dt class=c-dashboard__data__key>Average Upgrade Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('upgrades')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('upgrades')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.upgrades ng-repeat=\"currency in $ctrl.upgrades\" decorate=\"{{ currency.currency }}\" amount=\"currency.average || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.upgrades>N/A</span> </span> </dd> </dl> </li> </ul> </div> </div> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Extras / Add Ons</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of paid Extras / Add Ons sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Extras</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\">{{ currency.count }} <small ng-if=$ctrl.showGroupData>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of paid Extras / Add Ons sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Extras Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\" decorate=\"{{ currency.currency }}\" amount=\"currency.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average value of paid Extras / Add Ons sold within the selected period\"></span> <dt class=c-dashboard__data__key>Average Extra Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\" decorate=\"{{ currency.currency }}\" amount=\"currency.average || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Percentage of orders with at least one paid Extra / Add On within the selected period\"></span> <dt class=c-dashboard__data__key>Orders with an Extra</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\">{{ (currency.percentOfOrders.toFixed(1) || 0) }}% <small ng-if=$ctrl.showGroupData>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> </ul> </div> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panel> <h2 class=c-dashboard__panel__heading>Best Sellers</h2> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Treatments</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('bestSellers')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('bestSellers')\"> <li ng-repeat=\"(event, count) in $ctrl.bestSellers.Treatment\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ event }}</div> <div class=c-dashboard__data__value>{{ count }}</div> </div> </li> </ol> </div> </div> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Spa Days</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('bestSellers')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('bestSellers')\"> <li ng-repeat=\"(event, count) in $ctrl.bestSellers.SpaDay\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ event }}</div> <div class=c-dashboard__data__value>{{ count }}</div> </div> </li> </ol> </div> </div> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Extras</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('bestSellers')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('bestSellers')\"> <li ng-repeat=\"(event, count) in $ctrl.bestSellers.EventExtra\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ event }}</div> <div class=c-dashboard__data__value>{{ count }}</div> </div> </li> </ol> </div> </div> </div> </div> </div> </div> <div class=text-center> <a ui-sref=app.admin.bestSellersDashboard class=\"button round\">See full Best Seller details</a> </div> </main> </div> ";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        isGlobal: '<',
        isRevenue: '<'
    },
    controller: 'dashboardController',
    template: __webpack_require__(569)
};

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = "<message></message> <div class=c-dashboard ng-if=\"$ctrl.access.check('investor')\"> <header class=c-page-head> <div class=c-dashboard__welcome> <h2 ng-bind-html=$ctrl.welcome()></h2> </div> </header> <main> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns medium-0 large-2\"></div> <div class=\"columns medium-6 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.propertyId ng-change=$ctrl.getReportData(true) ng-disabled=$ctrl.isDataLoading()> <optgroup label=Global> <option value=* selected=selected>All properties</option> <option value=commission selected=selected>Commission properties</option> <option value=integrated selected=selected>Integrated properties</option> </optgroup> <optgroup label=Property> <option ng-repeat=\"property in $ctrl.properties\" value=\"{{ 'p' + property.id }}\">{{ property.name }}</option> </optgroup> <optgroup label=\"Property Group\"> <option ng-repeat=\"group in $ctrl.propertyGroups\" value=\"{{ 'g' + group.properties[0] }}\">{{ group.name }}</option> </optgroup> </select> </div> <div class=\"columns medium-6 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.timeFrame ng-change=$ctrl.getReportData(true) ng-disabled=$ctrl.isDataLoading()> <optgroup label=Month> <option value=\"This month\" selected=selected>Month to Date</option> <option value=\"Last month\" ng-bind-html=$ctrl.lastMonth()></option> </optgroup> <optgroup label=Year> <option value=\"This year\">Year to Date</option> <option value=\"Last year\" ng-bind-html=$ctrl.lastYear()></option> </optgroup> <optgroup label=Custom> <option value=Custom>Custom date range</option> </optgroup> </select> </div> <div class=\"columns medium-0 large-2\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe\" ng-if=\"$ctrl.timeFrame === 'Custom'\"> <div class=\"columns medium-0 large-2\"></div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=startDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateFrom moment-picker=$ctrl.customDateFrom keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off change=$ctrl.setCustomDateRange() ng-disabled=$ctrl.isDataLoading()> <label class=c-form__label for=startDate>Start Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateFrom = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=endDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateTo moment-picker=$ctrl.customDateTo keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off min-date=$ctrl.customDateFrom ng-disabled=\"!$ctrl.customDateFrom || $ctrl.isDataLoading()\" change=$ctrl.setCustomDateRange()> <label class=c-form__label for=endDate>End Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateTo = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-0 large-2\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns c-dashboard__group-container\"> <p class=c-dashboard__timeframe__string ng-bind-html=$ctrl.timeFrameString></p> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__headlines> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total revenue through the platform within the selected period\"></span> <dt class=c-dashboard__headline__heading>Total Revenue</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\" decorate=\"{{ currency.currency }}\" amount=\"currency.salesValue || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of orders through the platform within the selected period\"></span> <dt class=c-dashboard__headline__heading>Total Orders</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\">{{ currency.count }} <small>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of accounts active in the year of the start date\"></span> <dt class=c-dashboard__headline__heading>Total Active Accounts</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=$ctrl.accountStatsLoading></spinner> <span ng-if=!$ctrl.accountStatsLoading> <span class=c-dashboard__headline__data__value ng-repeat=\"status in $ctrl.accountStats.active\">{{ status.count }} <small>({{ status.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.accountStats.active>N/A</span> </span> </dd> </dl> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of commision on Orders created within the selected period\"></span> <dt class=c-dashboard__headline__heading>Total Commission</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('commission')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('commission')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.commission\" decorate=\"{{ currency.currency }}\" amount=\"(currency.commission || 0) + (currency.partnerCommission || 0)\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('commission')\">N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Journey's commision on Orders created within the selected period\"></span> <dt class=c-dashboard__headline__heading>Journey Commission</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('commission')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('commission')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.commission\" decorate=\"{{ currency.currency }}\" amount=\"currency.commission || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('commission')\">N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of partner's commision on Orders created within the selected period\"></span> <dt class=c-dashboard__headline__heading>Partner Commission</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('commission')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('commission')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.commission\" decorate=\"{{ currency.currency }}\" amount=\"currency.partnerCommission || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('commission')\">N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of gateway fees on Orders created within the selected period\"></span> <dt class=c-dashboard__headline__heading>Gateway Fees</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('commission')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('commission')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.commission\" decorate=\"{{ currency.currency }}\" amount=\"currency.gatewayFees || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('commission')\">N/A</span> </span> </dd> </dl> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Treatments sold within the selected period. This includes both standalone Treatments and attached Treatments\"></span> <dt class=c-dashboard__headline__heading>Treatments</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.revenueByType.Treatment ng-repeat=\"(currency, value) in $ctrl.revenueByType.Treatment\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.Treatment>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Spa Days sold within the selected period. This does not include Treatments, Options or Extras that are not included within the original price\"></span> <dt class=c-dashboard__headline__heading>Spa Days</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.revenueByType.SpaDay ng-repeat=\"(currency, value) in $ctrl.revenueByType.SpaDay\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.SpaDay>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Extras/Add Ons sold within the selected period. This is combined across both Treatments and Spa Days sold\"></span> <dt class=c-dashboard__headline__heading>Extras / Add Ons</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.revenueByType.EventExtra ng-repeat=\"(currency, value) in $ctrl.revenueByType.EventExtra\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.EventExtra>N/A</span> </span> </dd> </dl> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panels> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Orders</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Orders within the selected period including offers, vouchers and promo codes\"></span> <dt class=c-dashboard__data__key>Total Order Sales Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\" decorate=\"{{ currency.currency }}\" amount=\"currency.salesValue || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Orders within the selected period including offers but without any vouchers or promo codes applied\"></span> <dt class=c-dashboard__data__key>Total Order Face Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\" decorate=\"{{ currency.currency }}\" amount=\"currency.faceValue || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average value of Orders within the selected period\"></span> <dt class=c-dashboard__data__key>Average Order Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orders')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orders')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.orders\" decorate=\"{{ currency.currency }}\" amount=\"currency.salesAverage || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('orders')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average Order value divided by number of Guests within the selected period\"></span> <dt class=c-dashboard__data__key>Average Guest Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('averageSpend')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('averageSpend')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"average in $ctrl.averageSpend\" decorate=\"{{ average.currency }}\" amount=\"average.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('averageSpend')\">N/A</span> </span> </dd> </dl> </li> </ul> </div> </div> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Cancelled and Refunded Orders</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of refunded Orders within the selected period. This is the amount refunded to the customer and does not take into account retained fees\"></span> <dt class=c-dashboard__data__key>Total Order Value Refunded</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('ordersRC')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('ordersRC')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.ordersRC\" decorate=\"{{ currency.currency }}\" amount=\"currency.amountRefunded || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('ordersRC')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Orders refunded within the selected period\"></span> <dt class=c-dashboard__data__key>Total Refunded Orders</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('ordersRC')\"></spinner> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.loadingService.isLoading('ordersRC')\" ng-repeat=\"currency in $ctrl.ordersRC\">{{ currency.refunded || 0 }} <small>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.loadingService.isLoading('ordersRC') && !$ctrl.hasData('ordersRC')\">N/A</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Orders cancelled within the selected period. This number does not indicate the customer being refunded\"></span> <dt class=c-dashboard__data__key>Total Cancelled Orders</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('ordersRC')\"></spinner> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.loadingService.isLoading('ordersRC')\" ng-repeat=\"currency in $ctrl.ordersRC\">{{ currency.cancelled || 0 }} <small>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.loadingService.isLoading('ordersRC') && !$ctrl.hasData('ordersRC')\">N/A</span> </dd> </dl> </li> </ul> </div> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panels> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Upgrades</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Upgrades sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Upgrades</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('upgrades')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('upgrades')\"> <span class=c-dashboard__headline__data__value ng-if=$ctrl.upgrades ng-repeat=\"currency in $ctrl.upgrades\">{{ currency.count }} <small>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.upgrades>N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Upgrades sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Upgrade Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('upgrades')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('upgrades')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.upgrades ng-repeat=\"currency in $ctrl.upgrades\" decorate=\"{{ currency.currency }}\" amount=\"currency.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.upgrades>N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average value of Upgrades sold within the selected period\"></span> <dt class=c-dashboard__data__key>Average Upgrade Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('upgrades')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('upgrades')\"> <money class=c-dashboard__headline__data__value ng-if=$ctrl.upgrades ng-repeat=\"currency in $ctrl.upgrades\" decorate=\"{{ currency.currency }}\" amount=\"currency.average || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.upgrades>N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Percentage of orders with at least one upgrade within the selected period\"></span> <dt class=c-dashboard__data__key>Orders with an Upgrade</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('upgrades')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('upgrades')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.upgrades\">{{ ($ctrl.percentageOfTotalOrders(currency.count, currency.currency).toFixed(1) || 0) }}% <small>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.upgrades>N/A</span> </span> </dd> </dl> </li> </ul> </div> </div> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Paid Extras / Add Ons</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of paid Extras / Add Ons sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Extras</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\">{{ currency.count }} <small>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of paid Extras / Add Ons sold within the selected period\"></span> <dt class=c-dashboard__data__key>Total Extras Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\" decorate=\"{{ currency.currency }}\" amount=\"currency.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Average value of paid Extras / Add Ons sold within the selected period\"></span> <dt class=c-dashboard__data__key>Average Extra Value</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\" decorate=\"{{ currency.currency }}\" amount=\"currency.average || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Percentage of orders with at least one paid Extra / Add On within the selected period\"></span> <dt class=c-dashboard__data__key>Orders with an Extra</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('paidExtras')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('paidExtras')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"currency in $ctrl.paidExtras\">{{ (currency.percentOfOrders.toFixed(1) || 0) }}% <small>({{ currency.currency }})</small></span> <span class=c-dashboard__headline__data__value ng-if=\"!$ctrl.hasData('paidExtras')\">N/A</span> </span> </dd> </dl> </li> </ul> </div> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <p class=c-description>This table contains <b>all</b> historic data <b>up to the beginning of the current month</b></p> <div class=c-dashboard__panel> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted c-dashboard__headlines--year\"> <dl class=c-dashboard__headline> <dt class=c-dashboard__headline__heading>Account</dt> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('accountSummary')\"></spinner> <dd class=c-dashboard__headline__data ng-if=\"!$ctrl.loadingService.isLoading('accountSummary')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"account in $ctrl.filteredAccounts\"> <span class=c-dashboard__tooltip-trigger tooltip=\"{{ account.name }}\"></span> <strong class=c-dashboard__nowrap ng-class=\"{ 'c-dashboard__headline__data--filtered': account.filtered }\">{{ account.name }}</strong> </span> </dd> </dl> <dl class=c-dashboard__headline> <dt class=c-dashboard__headline__heading>Average Monthly Revenue</dt> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('accountSummary')\"></spinner> <dd class=c-dashboard__headline__data ng-if=\"!$ctrl.loadingService.isLoading('accountSummary')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"account in $ctrl.filteredAccounts\"> <span ng-class=\"{ 'c-dashboard__headline__data--filtered': account.filtered }\"> <money decorate=\"{{ account.currency }}\" amount=\"account.monthAverage || 0\"></money> </span> <div class=c-dashboard__tooltip-trigger> <ul class=c-dashboard__tooltip> <li class=c-dashboard__tip ng-repeat=\"(year, values) in account.breakdown\">{{ year }}: <money decorate=\"{{ account.currency }}\" amount=values.monthAverage></money> </li> </ul> </div> </span> </dd> </dl> <dl class=c-dashboard__headline> <dt class=c-dashboard__headline__heading>Total Revenue</dt> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('accountSummary')\"></spinner> <dd class=c-dashboard__headline__data ng-if=\"!$ctrl.loadingService.isLoading('accountSummary')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"account in $ctrl.filteredAccounts\"> <span ng-class=\"{ 'c-dashboard__headline__data--filtered': account.filtered }\"> <money decorate=\"{{ account.currency }}\" amount=account.value></money> </span> <div class=c-dashboard__tooltip-trigger> <ul class=c-dashboard__tooltip> <li class=c-dashboard__tip ng-repeat=\"(year, values) in account.breakdown\">{{ year }}: <money decorate=\"{{ account.currency }}\" amount=values.value></money> </li> </ul> </div> </span> </dd> </dl> <dl class=c-dashboard__headline> <dt class=c-dashboard__headline__heading>Total Orders</dt> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('accountSummary')\"></spinner> <dd class=c-dashboard__headline__data ng-if=\"!$ctrl.loadingService.isLoading('accountSummary')\"> <span class=c-dashboard__headline__data__value ng-repeat=\"account in $ctrl.filteredAccounts\"> <span ng-class=\"{ 'c-dashboard__headline__data--filtered': account.filtered }\">{{ account.count }}</span> <div class=c-dashboard__tooltip-trigger> <ul class=c-dashboard__tooltip> <li class=c-dashboard__tip ng-repeat=\"(year, values) in account.breakdown\">{{ year }}: {{ values.count }} Orders</li> </ul> </div> </span> </dd> </dl> </div> </div> </div> </div> <hr> <div class=\"c-page-head__actions / c-dashboard__actions / text-center\"> <button class=c-button--action ng-if=\"$ctrl.access.check('stock')\" ng-click=\"$ctrl.sendCommissionReport('month')\"> <icon icon=discount></icon> Send Monthly Commission Report </button> <button class=c-button--action ng-if=\"$ctrl.access.check('manager')\" ng-click=\"$ctrl.sendCommissionReport('year')\"> <icon icon=dashboard></icon> Send Yearly Commission Report </button> </div> </main> </div> ";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        isGlobal: '<',
        isStatistics: '<'
    },
    controller: 'dashboardController',
    template: __webpack_require__(571)
};

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = "<message></message> <div class=c-dashboard ng-if=\"$ctrl.access.check('investor')\"> <header class=c-page-head> <div class=c-dashboard__welcome> <h2 ng-bind-html=$ctrl.welcome()></h2> </div> </header> <main> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns medium-0 large-2\"></div> <div class=\"columns medium-6 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.propertyId ng-change=$ctrl.getReportData(true) ng-disabled=$ctrl.isDataLoading()> <optgroup label=Global> <option value=* selected=selected>All properties</option> <option value=commission selected=selected>Commission properties</option> <option value=integrated selected=selected>Integrated properties</option> </optgroup> <optgroup label=Property> <option ng-repeat=\"property in $ctrl.properties\" value=\"{{ 'p' + property.id }}\">{{ property.name }}</option> </optgroup> <optgroup label=\"Property Group\"> <option ng-repeat=\"group in $ctrl.propertyGroups\" value=\"{{ 'g' + group.properties[0] }}\">{{ group.name }}</option> </optgroup> </select> </div> <div class=\"columns medium-6 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.timeFrame ng-change=$ctrl.getReportData(true) ng-disabled=$ctrl.isDataLoading()> <optgroup label=Month> <option value=\"This month\" selected=selected>Month to Date</option> <option value=\"Last month\" ng-bind-html=$ctrl.lastMonth()></option> </optgroup> <optgroup label=Year> <option value=\"This year\">Year to Date</option> <option value=\"Last year\" ng-bind-html=$ctrl.lastYear()></option> </optgroup> <optgroup label=Custom> <option value=Custom>Custom date range</option> </optgroup> </select> </div> <div class=\"columns medium-0 large-2\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe\" ng-if=\"$ctrl.timeFrame === 'Custom'\"> <div class=\"columns medium-0 large-2\"></div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=startDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateFrom moment-picker=$ctrl.customDateFrom keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off change=$ctrl.setCustomDateRange() ng-disabled=$ctrl.isDataLoading()> <label class=c-form__label for=startDate>Start Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateFrom = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=endDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateTo moment-picker=$ctrl.customDateTo keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off min-date=$ctrl.customDateFrom ng-disabled=\"!$ctrl.customDateFrom || $ctrl.isDataLoading()\" change=$ctrl.setCustomDateRange()> <label class=c-form__label for=endDate>End Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateTo = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-0 large-2\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns c-dashboard__group-container\"> <p class=c-dashboard__timeframe__string ng-bind-html=$ctrl.timeFrameString></p> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__headlines> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Treatments sold within the selected period. This includes both standalone Treatments and attached Treatments\"></span> <dt class=c-dashboard__headline__heading>Treatments</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"(currency, value) in $ctrl.revenueByType.Treatment\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.Treatment>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Spa Days sold within the selected period. This does not include Treatments, Options or Extras that are not included within the original price\"></span> <dt class=c-dashboard__headline__heading>Spa Days</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"(currency, value) in $ctrl.revenueByType.SpaDay\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.SpaDay>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Extras/Add Ons sold within the selected period. This is combined across both Treatments and Spa Days sold\"></span> <dt class=c-dashboard__headline__heading>Extras / Add Ons</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"(currency, value) in $ctrl.revenueByType.EventExtra\" decorate=\"{{ currency }}\" amount=\"value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.EventExtra>N/A</span> </span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total value of Treatment, Spa Day and Extra sales within the selected period, this value may differ from Order value\"></span> <dt class=c-dashboard__headline__heading>Total</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('revenueByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('revenueByType')\"> <money class=c-dashboard__headline__data__value ng-repeat=\"total in $ctrl.revenueByType.total\" decorate=\"{{ total.currency }}\" amount=\"total.value || 0\"></money> <span class=c-dashboard__headline__data__value ng-if=!$ctrl.revenueByType.total>N/A</span> </span> </dd> </dl> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panel> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Treatments sold within the selected period. This consists of {{ $ctrl.treatments.standalone || 0 }} standalone and {{ $ctrl.treatments.attached || 0 }} attached Treatments\"></span> <dt class=c-dashboard__headline__heading>Treatments Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=\"$ctrl.salesByType.Treatment || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Spa Days sold within the selected period\"></span> <dt class=c-dashboard__headline__heading>Spa Days Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=\"$ctrl.salesByType.SpaDay || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Extras/Add Ons sold within the selected period. This is combined across both Treatments and Spa Days sold\"></span> <dt class=c-dashboard__headline__heading>Extras / Add Ons Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=\"$ctrl.salesByType.EventExtra || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Treatments, Spa Days and Extras/Add Ons sold within the selected period\"></span> <dt class=c-dashboard__headline__heading>Total Sold</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('salesByType')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('salesByType')\" ng-bind-html=$ctrl.salesByType.total></span> </dd> </dl> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panels> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Order Value Leaderboard</h3> <div class=c-dashboard__data> <spinner class=\"c-spinner c-spinner--centre\" ng-if=\"$ctrl.loadingService.isLoading('leaderboard')\"></spinner> <ul ng-if=\"!$ctrl.loadingService.isLoading('leaderboard')\"> <li ng-repeat=\"property in $ctrl.revenueLeaderboard.top\" class=c-dashboard__leaderboard__top> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>{{ property.name }}</dt> <dd class=c-dashboard__data__value> <money decorate=\"{{ property.currency }}\" amount=property.value></money> <icon icon=chevron-up></icon> </dd> </dl> </li> <li ng-if=$ctrl.revenueLeaderboard.bottom.length> <div class=c-dashboard__data__pair>&hellip;</div> </li> <li ng-repeat=\"property in $ctrl.revenueLeaderboard.bottom\" class=c-dashboard__leaderboard__bottom> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>{{ property.name }}</dt> <dd class=c-dashboard__data__value> <money decorate=\"{{ property.currency }}\" amount=property.value></money> <icon icon=chevron-down></icon> </dd> </dl> </li> </ul> </div> </div> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Total Orders Leaderboard</h3> <div class=c-dashboard__data> <spinner class=\"c-spinner c-spinner--centre\" ng-if=\"$ctrl.loadingService.isLoading('leaderboard')\"></spinner> <ul ng-if=\"!$ctrl.loadingService.isLoading('leaderboard')\"> <li ng-repeat=\"property in $ctrl.orderLeaderboard.top\" class=c-dashboard__leaderboard__top> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>{{ property.name }}</dt> <dd class=c-dashboard__data__value> {{ property.count.toLocaleString() }} Orders <icon icon=chevron-up></icon> </dd> </dl> </li> <li ng-if=$ctrl.revenueLeaderboard.bottom.length> <div class=c-dashboard__data__pair>&hellip;</div> </li> <li ng-repeat=\"property in $ctrl.orderLeaderboard.bottom\" class=c-dashboard__leaderboard__bottom> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>{{ property.name }}</dt> <dd class=c-dashboard__data__value> {{ property.count.toLocaleString() }} Orders <icon icon=chevron-down></icon> </dd> </dl> </li> </ul> </div> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panel> <h2 class=c-dashboard__panel__heading>Best Sellers</h2> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Treatments</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('bestSellers')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('bestSellers')\"> <li ng-repeat=\"(event, count) in $ctrl.bestSellers.Treatment\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ event }}</div> <div class=c-dashboard__data__value>{{ count }}</div> </div> </li> </ol> </div> </div> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Spa Days</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('bestSellers')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('bestSellers')\"> <li ng-repeat=\"(event, count) in $ctrl.bestSellers.SpaDay\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ event }}</div> <div class=c-dashboard__data__value>{{ count }}</div> </div> </li> </ol> </div> </div> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Extras</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('bestSellers')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('bestSellers')\"> <li ng-repeat=\"(event, count) in $ctrl.bestSellers.EventExtra\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ event }}</div> <div class=c-dashboard__data__value>{{ count }}</div> </div> </li> </ol> </div> </div> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panels> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Basket / Checkout Metrics</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets created within the selected period\"></span> <dt class=c-dashboard__data__key>Total Baskets</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\" ng-bind-html=\"$ctrl.metrics.allBaskets || 0\"></span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets created within the selected period that had at least one guest that was not removed\"></span> <dt class=c-dashboard__data__key>Total Used Baskets</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\" ng-bind-html=\"$ctrl.metrics.interactedBaskets || 0\"></span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of used Baskets that were abandoned on the storefront\"></span> <dt class=c-dashboard__data__key>Baskets abandoned before checkout</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\">{{ $ctrl.metrics.totalBasketPreCheckout }} ({{ $ctrl.metricsPercent('totalBasketPreCheckout') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets that were abandoned on the credit step of the checkout within the selected period\"></span> <dt class=c-dashboard__data__key>Baskets abandoned at: Credit</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\">{{ $ctrl.metrics.totalBasketCredit }} ({{ $ctrl.metricsPercent('totalBasketCredit') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets that were abandoned on the customise step of the checkout within the selected period\"></span> <dt class=c-dashboard__data__key>Baskets abandoned at: Customise</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\">{{ $ctrl.metrics.totalBasketOptions }} ({{ $ctrl.metricsPercent('totalBasketOptions') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets that were abandoned on the suggestions step of the checkout within the selected period\"></span> <dt class=c-dashboard__data__key>Baskets abandoned at: Suggestions</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\">{{ $ctrl.metrics.totalBasketSuggestions }} ({{ $ctrl.metricsPercent('totalBasketSuggestions') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets that were abandoned on the payment step of the checkout within the selected period\"></span> <dt class=c-dashboard__data__key>Baskets abandoned at: Payment</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\">{{ $ctrl.metrics.totalBasketPayment }} ({{ $ctrl.metricsPercent('totalBasketPayment') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets that were abandoned on the review step of the checkout within the selected period\"></span> <dt class=c-dashboard__data__key>Baskets abandoned at: Review</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\">{{ $ctrl.metrics.totalBasketReview }} ({{ $ctrl.metricsPercent('totalBasketReview') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Baskets that were abandoned on the review step of the checkout within the selected period\"></span> <dt class=c-dashboard__data__key>Baskets successfully ordered</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\">{{ $ctrl.metrics.totalBasketOrdered }} ({{ $ctrl.metricsPercent('totalBasketOrdered') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of upsell offers that were selected on the Suggestion step within the selected period\"></span> <dt class=c-dashboard__data__key>Suggestion Upsell Offers selected</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('metrics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('metrics')\" ng-bind-html=$ctrl.metrics.totalUpsellOffersClicked></span> </dd> </dl> </li> </ul> </div> </div> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Popular Offers</h3> <div class=c-dashboard__data> <spinner class=\"c-spinner c-spinner--centre\" ng-if=\"$ctrl.loadingService.isLoading('popularOffer')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('popularOffer')\"> <li ng-repeat=\"offer in $ctrl.popularOffer\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ offer.offer_name }}</div> <div class=c-dashboard__data__value>{{ offer.count }}</div> </div> </li> </ol> </div> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panels> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Lead Times</h3> <div class=c-dashboard__data> <ul> <li> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>2 days or less</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orderInsights')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orderInsights')\">{{ $ctrl.orderInsights.leadTime0to2 || 0 }} ({{ $ctrl.orderInsightPercent('leadTime0to2') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>3&mdash;7 days</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orderInsights')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orderInsights')\">{{ $ctrl.orderInsights.leadTime3to7 || 0 }} ({{ $ctrl.orderInsightPercent('leadTime3to7') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>8&mdash;14 days</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orderInsights')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orderInsights')\">{{ $ctrl.orderInsights.leadTime8to14 || 0 }} ({{ $ctrl.orderInsightPercent('leadTime8to14') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>15&mdash;30 days</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orderInsights')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orderInsights')\">{{ $ctrl.orderInsights.leadTime15to30 || 0 }} ({{ $ctrl.orderInsightPercent('leadTime15to30') }})</span> </dd> </dl> </li> <li> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key>Over 30 days</dt> <dd class=c-dashboard__data__value> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('orderInsights')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('orderInsights')\">{{ $ctrl.orderInsights.leadTimeOver30 || 0 }} ({{ $ctrl.orderInsightPercent('leadTimeOver30') }})</span> </dd> </dl> </li> </ul> </div> </div> <div class=c-dashboard__panel> <h3 class=c-dashboard__panel__heading>Booking Times (UTC)</h3> <div class=c-dashboard__data> <spinner class=\"c-spinner c-spinner--centre\" ng-if=\"$ctrl.loadingService.isLoading('orderInsights')\"></spinner> <ul ng-if=\"!$ctrl.loadingService.isLoading('orderInsights')\"> <li ng-repeat=\"relativeTime in $ctrl.relativeTimes\"> <dl class=c-dashboard__data__pair> <dt class=c-dashboard__data__key> {{ relativeTime }} </dt> <dd class=c-dashboard__data__value> <span>{{ $ctrl.orderInsights.time[$index] || 0 }} ({{ $ctrl.orderInsightPercent($index) }})</span> </dd> </dl> </li> </ul> </div> </div> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__panel> <h2 class=c-dashboard__panel__heading>Popular</h2> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Options</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('popularOptions')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('popularOptions')\"> <li ng-repeat=\"option in $ctrl.popularOptions\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ option.name }}</div> <div class=c-dashboard__data__value>{{ option.count }}</div> </div> </li> </ol> </div> </div> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Durations - Treatments</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('popularDuration')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('popularDuration')\"> <li ng-repeat=\"details in $ctrl.popularDuration.Treatment\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ details.duration }} minutes</div> <div class=c-dashboard__data__value>{{ details.count }}</div> </div> </li> </ol> </div> </div> <div class=c-dashboard__headline> <div class=c-dashboard__headline__heading>Durations - Spa Days</div> <div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('popularDuration')\"></spinner> <ol ng-if=\"!$ctrl.loadingService.isLoading('popularDuration')\"> <li ng-repeat=\"details in $ctrl.popularDuration.SpaDay\"> <div class=c-dashboard__data__pair> <div class=c-dashboard__data__key>{{ details.duration[0].toUpperCase() + details.duration.substring(1) }} day</div> <div class=c-dashboard__data__value>{{ details.count }}</div> </div> </li> </ol> </div> </div> </div> </div> </div> </div> </main> </div> ";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {},
    controller: 'premierDashboardController',
    template: __webpack_require__(573)
};

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "<message></message> <div class=c-dashboard> <header class=c-page-head> <div class=c-dashboard__welcome> <h2 ng-bind-html=$ctrl.welcome()></h2> </div> </header> <main ng-if=\"$ctrl.access.check('premier_admin')\"> <div class=\"row row--clean\"> <div class=columns> <div class=c-dashboard__headlines> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total invoiced amount for the previous month\"></span> <dt class=c-dashboard__headline__heading>Total Invoiced Last Month</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('premierInvoiced')\"></spinner> <money ng-if=\"!$ctrl.loadingService.isLoading('premierInvoiced')\" class=c-dashboard__headline__data__value decorate=GBP amount=\"$ctrl.premierInvoiced.last_month || 0\"></money> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total amount of commission for this month to date\"></span> <dt class=c-dashboard__headline__heading>Total to Invoice, Month to Date</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('premierInvoiced')\"></spinner> <money ng-if=\"!$ctrl.loadingService.isLoading('premierInvoiced')\" class=c-dashboard__headline__data__value decorate=GBP amount=\"$ctrl.premierInvoiced.current_month || 0\"></money> </dd> </dl> </div> </div> </div> <div class=\"row row--clean\"> <div class=columns> <div class=\"c-dashboard__headlines c-dashboard__headlines--muted\"> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Premier properties created with no API details provided\"></span> <dt class=c-dashboard__headline__heading>Awaiting API Keys</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('premierStatistics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('premierStatistics')\" ng-bind-html=\"$ctrl.premierStatistics.awaiting_keys || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Premier properties with API details provided that have not had data imported yet\"></span> <dt class=c-dashboard__headline__heading>API Keys Supplied</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('premierStatistics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('premierStatistics')\" ng-bind-html=\"$ctrl.premierStatistics.api_keys_supplied || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Premier properties that have had data imported, but do not have an expected go live\"></span> <dt class=c-dashboard__headline__heading>Setup in Progress</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('premierStatistics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('premierStatistics')\" ng-bind-html=\"$ctrl.premierStatistics.setup_in_progress || 0\"></span> </dd> </dl> <dl class=c-dashboard__headline> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Premier properties that have an expected go live date\"></span> <dt class=c-dashboard__headline__heading>Client Sign-off</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('premierStatistics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('premierStatistics')\" ng-bind-html=\"$ctrl.premierStatistics.client_sign_off || 0\"></span> </dd> </dl> <dl class=\"c-dashboard__headline / c-dashboard__headline--highlight\"> <span class=c-dashboard__tooltip-trigger tooltip=\"Total number of Premier properties that have gone live\"></span> <dt class=c-dashboard__headline__heading>Live Properties</dt> <dd class=c-dashboard__headline__data> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('premierStatistics')\"></spinner> <span ng-if=\"!$ctrl.loadingService.isLoading('premierStatistics')\" ng-bind-html=\"$ctrl.premierStatistics.live_integration || 0\"></span> </dd> </dl> </div> </div> </div> <div class=\"row row--clean\"> <div class=\"columns medium-4\"></div> <div class=\"columns medium-4\"> <select name=filter class=c-dashboard__nomargin ng-model=$ctrl.propertyFilter ng-change=$ctrl.filterProperties()> <option value=\"\">- No Status Filter -</option> <option value=awaiting-keys>Awaiting API Keys</option> <option value=keys-supplied>API Keys Supplied</option> <option value=setup>Setup in Progress</option> <option value=client-sign-off>Awaiting Client Sign-off</option> <option value=live>Live Properties</option> </select> </div> <div class=\"columns medium-4\"></div> <div class=columns> <table class=\"c-table c-table--zebra\"> <thead> <th>Property</th> <th>Current Status</th> <th>Property Created</th> <th>API Keys Provided</th> <th>Expected Live Date</th> <th class=c-table__highlight>Live Date</th> </thead> <tr ng-if=\"!$ctrl.loadingService.isLoading('properties') && !account.hidden\" ng-repeat=\"account in $ctrl.properties\"> <td> <span class=c-dashboard__headline__data__value> <span class=c-dashboard__tooltip-trigger tooltip=\"{{ account.name }}\"></span> <strong class=\"c-dashboard__nowrap / c-dashboard__nomargin\">{{ account.name }}</strong> </span> </td> <td> <span class=\"c-dashboard__status c-dashboard__status--{{ account.slug }}\"> {{ account.status }} </span> </td> <td> {{ $ctrl.formatDate(account.property_created) }} </td> <td> {{ $ctrl.formatDate(account.integration_created) }} </td> <td> {{ $ctrl.formatDate(account.expected_go_live) }} </td> <td class=c-table__highlight> {{ $ctrl.formatDate(account.go_live) }} </td> </tr> </table> <div ng-if=\"!$ctrl.loadingService.isLoading('properties') && $ctrl.properties.length === $ctrl.hiddenCount\" class=\"c-empty c-empty--white c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text>No properties match that filter.</p> <div class=c-empty__filter> <button class=\"button round\" ng-click=$ctrl.clearFilter()>Clear filter</button> </div> </div> </div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('properties')\"></spinner> </div> </div> <hr> <div class=\"row row--clean\"> <div class=\"columns / text-center\"> <h3>Contracts</h3> <span ng-cloak ng-if=\"$ctrl.contracts.length > 0\">Last updated: {{ $ctrl.contractsDate }}</span> </div> </div> <div class=text-center ng-if=\"$ctrl.access.check('admin')\"> <a ui-sref=app.admin.uploadContractCSV class=\"button round\">Upload new spreadsheet</a> </div> <div class=\"row row--clean\"> <div class=columns> <table> <thead> <th>Company Name</th> <th>Contact name</th> <th>Status</th> <th>Title</th> <th>Due</th> <th>Contact email</th> </thead> <tr ng-if=\"!$ctrl.loadingService.isLoading('contracts')\" ng-repeat=\"contract in $ctrl.contracts\"> <td> <span class=c-dashboard__headline__data__value> <span class=c-dashboard__tooltip-trigger tooltip=\"{{ contract.company_name }}\"></span> <strong class=\"c-dashboard__nowrap / c-dashboard__nomargin\">{{ contract.company_name }}</strong> </span> </td> <td> {{ contract.contact_name }} </td> <td> {{ contract.status }} </td> <td> <span class=c-dashboard__headline__data__value> <span class=c-dashboard__tooltip-trigger tooltip=\"{{ contract.title }}\"></span> <strong class=\"c-dashboard__nowrap / c-dashboard__nomargin\">{{ contract.title }}</strong> </span> </td> <td> {{ $ctrl.formatDate(contract.due) }} </td> <td> {{ contract.email }} </td> </tr> </table> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('contracts')\"></spinner> </div> </div> <hr> <div class=\"row row--clean\"> <div class=columns> <h3 class=text-center>Download monthly report</h3> </div> </div> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns large-2\"></div> <div class=\"columns medium-6 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.month ng-disabled=$ctrl.isDataLoading()> <option ng-repeat=\"(month, monthName) in $ctrl.months\" value=\"{{ month }}\">{{ monthName }}</option> </select> </div> <div class=\"columns medium-6 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.year ng-disabled=$ctrl.isDataLoading()> <option ng-repeat=\"year in $ctrl.years\" value=\"{{ year }}\">{{ year }}</option> </select> </div> <div class=\"columns large-2\"></div> </div> <div class=text-center> <div class=c-dashboard__actions> <div ng-show=$ctrl.generating class=c-page-head__actions__overlay> <spinner large=true /> </div> <a ng-click=$ctrl.generateIntegrationReport() class=c-button--action> <icon icon=reports></icon> Generate report </a> <a ng-href={{$ctrl.download}} target=_blank class=c-button--action ng-class=\"{'disabled' : !$ctrl.download}\" ng-disabled=\"!$ctrl.download || $ctrl.generating\"> <icon icon=reports-down></icon> Download report </a> </div> <br><br> <p class=\"c-description c-description--large\" ng-if=$ctrl.download> Report generated: {{$ctrl.filename}} </p> </div> </main> </div> ";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'uploadContractsController',
    template: __webpack_require__(575)
};

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Upload Premier Contracts</h1> </header> <main> <div class=row> <div class=\"small-12 columns\"> <message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving> <div class=row> <div class=\"column medium-12\"> <label class=\"c-label c-label--large\">Contracts CSV</label> <p class=c-description>CSV must contain the following columns, in order: <pre>'Company Name', 'Contact Name', 'Status', 'Title', 'Due', 'Email'</pre> </p> <file-upload name=csv ng-model=$ctrl.csv accept=text/csv type=CSV required form-field-errors></file-upload> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Upload new contract details <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> </div> </div> </main> ";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        isBestSellers: '<'
    },
    controller: 'dashboardController',
    template: __webpack_require__(577)
};

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = "<message></message> <div class=c-dashboard> <header class=c-page-head> <div class=c-dashboard__welcome> <h2>Best Sellers</h2> </div> </header> <main ng-if=\"$ctrl.access.check('reporting')\"> <div class=\"row row--clean / c-dashboard__timeframe\"> <div class=\"columns medium-2 large-4\"></div> <div class=\"columns medium-8 large-4\"> <select class=c-dashboard__timeframe__select ng-model=$ctrl.timeFrame ng-disabled=$ctrl.isDataLoading()> <optgroup label=Week> <option selected=selected>This week</option> <option>Last week</option> </optgroup> <optgroup label=Month> <option value=\"This month\" ng-bind-html=$ctrl.thisMonth()></option> <option value=\"Last month\" ng-bind-html=$ctrl.lastMonth()></option> </optgroup> <optgroup label=Year> <option value=\"This year\" ng-bind-html=$ctrl.thisYear()></option> <option value=\"Last year\" ng-bind-html=$ctrl.lastYear()></option> </optgroup> <optgroup label=Custom> <option value=Custom>Custom date range</option> </optgroup> </select> </div> <div class=\"columns medium-2 large-4\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe\" ng-if=\"$ctrl.timeFrame === 'Custom'\"> <div class=\"columns medium-0 large-2\"></div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=startDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateFrom moment-picker=$ctrl.customDateFrom keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off ng-disabled=$ctrl.isDataLoading()> <label class=c-form__label for=startDate>Start Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateFrom = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-6 large-4\"> <div class=c-form__field> <input name=endDate type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly ng-model=$ctrl.customDateTo moment-picker=$ctrl.customDateTo keyboard=true format=YYYY-MM-DD min-view=month max-view=month validate=true set-on-select=true autocomplete=off min-date=$ctrl.customDateFrom ng-disabled=\"!$ctrl.customDateFrom || $ctrl.isDataLoading()\"> <label class=c-form__label for=endDate>End Date</label> <i class=\"c-icon c-icon--clear-small\" ng-if=!$ctrl.isDataLoading() ng-click=\"$ctrl.customDateTo = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-0 large-2\"></div> </div> <div class=\"row row--clean / c-dashboard__timeframe / text-center\"> <div class=columns> <button type=button class=\"button round\" ng-click=$ctrl.getReportData(true) ng-disabled=$ctrl.isDataLoading()>Apply</button> </div> <div class=columns> <p class=c-dashboard__timeframe__string ng-bind-html=$ctrl.timeFrameString></p> </div> </div> <div class=\"row row--clean\" ng-init=\"$ctrl.categoryFilter = '*'; $ctrl.typeFilter = '*';\"> <div class=\"columns medium-2\"></div> <div class=\"columns medium-4\"> <select name=filter class=c-dashboard__nomargin ng-model=$ctrl.categoryFilter ng-change=$ctrl.filterBestSellers()> <option value=*>- No Category Filter -</option> <option ng-repeat=\"category in $ctrl.categories\" value=\"{{ category }}\">{{ category || 'No Category' }}</option> </select> </div> <div class=\"columns medium-4\"> <select name=filter class=c-dashboard__nomargin ng-model=$ctrl.typeFilter ng-change=$ctrl.filterBestSellers()> <option value=*>- No Item Type Filter -</option> <option value=Treatment>Treatments</option> <option value=SpaDay>Spa Days</option> <option value=Activity>Classes</option> <option value=EventExtra>Extras</option> </select> </div> <div class=\"columns medium-2\"></div> <div class=columns> <div class=c-dashboard__data__table ng-if=\"!$ctrl.loadingService.isLoading('bestSellers') && !items.hidden\" ng-repeat=\"items in $ctrl.bestSellers\"> <h3>{{ items[0].category || 'No Category' }}</h3> <table class=\"c-table c-table--zebra\"> <thead> <th>Item Name</th> <th>Item Type</th> <th class=text-right>Total Amount</th> <th class=text-right>Total Sold (Items)</th> <th class=text-right>Average Lead Time (days)</th> </thead> <tr ng-if=!item.hidden ng-repeat=\"item in items\"> <td> <span class=c-dashboard__headline__data__value> <span class=c-dashboard__tooltip-trigger tooltip=\"{{ item.name }}\"></span> <strong class=\"c-dashboard__nowrap / c-dashboard__nomargin\">{{ item.name }}</strong> </span> </td> <td> {{ $ctrl.displayType(item.type) }} </td> <td class=text-right> <money decorate=true amount=\"item.amount || 0\"></money> </td> <td class=text-right> {{ item.count / (item.minimum_guests || 1) }} </td> <td class=text-right> {{ item.lead_days }} </td> </tr> <tr class=\"c-table__row c-table__row--highlight\" ng-if=\"!$ctrl.loadingService.isLoading('bestSellers')\"> <td> <span class=c-dashboard__headline__data__value> <span class=c-dashboard__tooltip-trigger tooltip=\"{{ item.category }}\"></span> <strong class=\"c-dashboard__nowrap / c-dashboard__nomargin\">{{ items[0].category || 'No Category' }} Total</strong> </span> </td> <td></td> <td class=text-right> <money decorate=true amount=\"$ctrl.sumParameter(items, 'amount')\"></money> </td> <td class=text-right> {{ $ctrl.sumSoldItems(items) }} </td> <td class=text-right> {{ $ctrl.sumLeadTime(items) }} </td> </tr> </table> </div> <div ng-if=\"!$ctrl.loadingService.isLoading('bestSellers') && $ctrl.bestSellers.length === $ctrl.hiddenCount\" class=\"c-empty c-empty--white c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>Nothing was sold in that date range.</p> <p class=c-empty__text ng-if=$ctrl.isFiltered>No item details match those filters.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <button class=\"button round\" ng-click=$ctrl.clearFilter()>Clear filters</button> </div> </div> </div> <spinner class=c-spinner ng-if=\"$ctrl.loadingService.isLoading('bestSellers')\"></spinner> </div> </div> </main> </div> ";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$rootScope', 'api', function ($rootScope, api) {
    var _this = this;

    var buildUrl = function buildUrl(report, dateFrom, dateTo, showGroup, showGlobal, scopeProperties, number) {
        if (!_this.propertyId) {
            _this.propertyId = $rootScope.currentProperty.id;
        }
        var url = '/api/' + _this.propertyId + '/data?report=' + report + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&group=' + showGroup;
        if (showGlobal) {
            url = url + '&global=true';
        }
        if (scopeProperties) {
            url = url + '&' + scopeProperties + '=true';
        }
        if (number) {
            url = url + '&number=' + number;
        }

        return url;
    };

    return {
        setPropertyId: function setPropertyId(propertyId) {
            _this.propertyId = propertyId;
        },
        getData: function getData(report, dateFrom, dateTo) {
            var showGroup = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var showGlobal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            var scopeProperties = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
            var number = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

            return api.get(buildUrl(report, dateFrom, dateTo, showGroup, showGlobal, scopeProperties, number)).then(function (response) {
                return response.data;
            });
        },
        getIntegrationData: function getIntegrationData(report) {
            if (!_this.propertyId) {
                _this.propertyId = $rootScope.currentProperty.id;
            }
            return api.get('/api/' + _this.propertyId + '/integrationData?report=' + report).then(function (response) {
                return response.data;
            });
        },
        sendCommissionReport: function sendCommissionReport(type) {
            return api.get('/api/tasks/commissionReport?range=' + type);
        }
    };
}];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = __webpack_require__(580);

var _auth2 = _interopRequireDefault(_auth);

var _userMenu = __webpack_require__(581);

var _userMenu2 = _interopRequireDefault(_userMenu);

var _loading = __webpack_require__(583);

var _loading2 = _interopRequireDefault(_loading);

var _userMenu3 = __webpack_require__(585);

var _userMenu4 = _interopRequireDefault(_userMenu3);

var _loading3 = __webpack_require__(586);

var _loading4 = _interopRequireDefault(_loading3);

var _encrypt = __webpack_require__(587);

var _encrypt2 = _interopRequireDefault(_encrypt);

var _permissions = __webpack_require__(588);

var _permissions2 = _interopRequireDefault(_permissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authModule = angular.module('spabooker.auth', ['spabooker.property']).config(_auth2.default).component('userMenu', _userMenu2.default).component('loading', _loading2.default).controller('userMenuController', _userMenu4.default).controller('loadingController', _loading4.default).factory('encryptService', _encrypt2.default).factory('permissionsService', _permissions2.default).run(['$transitions', '$state', 'authService', 'permissionsService', function ($transitions, $state, authService, permissionsService) {
    $transitions.onStart({}, function (transition) {
        return authService.checkLoggedIn().then(function () {
            return permissionsService.retrievePermissions();
        }).then(function () {
            if (!permissionsService.hasPermission(transition.$to())) {
                $state.go('403');
            }
        }).catch(function () {});
    });

    // Silence transition errors (and any other $state error...)
    $state.defaultErrorHandler(function (error) {
        console.log(error);
    });
}]);

exports.default = authModule.name;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('loading', {
        url: '/loading',
        component: 'loading'
    });
}];

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'userMenuController',
    template: __webpack_require__(582)
};

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "<div class=c-user-menu> <dropdown-toggle close-on-click=true pane-align=right class=c-dropdown> <toggle> <a class=dropdown-toggle> <span class=c-user-menu__hello><span>Hello, </span>{{ $ctrl.user.nickname }}</span> <icon icon=chevron-down></icon> </a> </toggle> <pane> <ul class=\"c-menu vertical\"> <li> <a href ng-click=$ctrl.logout()>Logout</a> </li> </ul> </pane> </dropdown-toggle> <div ng-if=$ctrl.user.user_metadata.picture class=\"c-avatar-imgix c-avatar__user-menu\"> <div class=imgix-fluid imgix-src=\"{{ $ctrl.user.user_metadata.picture }}\" data-fit=crop></div> </div> <img ng-if=!$ctrl.user.user_metadata.picture ng-src=\"{{ $ctrl.user.picture }}\" class=c-avatar> </div> ";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'loadingController',
    template: __webpack_require__(584)
};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-auth c-auth--error\"> <div class=c-auth__inner> <div class=c-auth__content> <div class=\"c-auth__header u-fade-in\"> <logo-words></logo-words> </div> <div class=c-auth__message> <spinner large=true></spinner> <h2>Loading...</h2> </div> </div> </div> </div> ";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserMenuController = function () {
    function UserMenuController(authService) {
        _classCallCheck(this, UserMenuController);

        this.authService = authService;
    }

    _createClass(UserMenuController, [{
        key: '$onInit',
        value: function $onInit() {
            this.user = this.authService.getProfile();
        }
    }, {
        key: 'logout',
        value: function logout() {
            this.authService.logout();
        }
    }]);

    return UserMenuController;
}();

UserMenuController.$inject = ['authService'];

exports.default = UserMenuController;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingController = function () {
    function LoadingController($window, $state, $location, auth0Service, configService, authStorageService) {
        _classCallCheck(this, LoadingController);

        this.$window = $window;
        this.$state = $state;
        this.$location = $location;
        this.auth0Service = auth0Service;
        this.configService = configService;
        this.authStorageService = authStorageService;
    }

    _createClass(LoadingController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.redirectUrl = this.configService.get('appUrl');

            return this.auth0Service.parseHash({ hash: this.$location.hash() }).then(function (result) {
                if (!result || !result.accessToken) {
                    _this.$window.location = _this.redirectUrl;
                    return;
                }

                _this.authStorageService.setAccessToken(result.accessToken);

                var role = result.idTokenPayload['https://www.lobby.travel/role'];

                result.idTokenPayload.role = role;

                _this.authStorageService.setProfile(result.idTokenPayload);

                return _this.$state.go('app.dashboard');
            }).catch(function (error) {
                _this.error = error.error;
                _this.errorDescription = error.errorDescription;
            });
        }
    }]);

    return LoadingController;
}();

LoadingController.$inject = ['$window', '$state', '$location', 'auth0Service', 'configService', 'authStorageService'];

exports.default = LoadingController;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = '/profile';

exports.default = ['api', function (api) {
    return {
        encrypt: function encrypt(profile) {
            return api.post('' + endpoint, profile).then(function (response) {
                return response;
            });
        },
        decrypt: function decrypt(profile) {
            return api.post('' + endpoint, { 'profile': profile }).then(function (response) {
                return response;
            });
        }
    };
}];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

var permissionsService = function permissionsService(api) {
    var permission = {};
    permission.user = undefined;

    permission.retrievePermissions = function () {
        return new Promise(function (resolve, reject) {
            if (!permission.user) {
                return api.get('/api/users/permissions').then(function (response) {
                    if (response) {
                        permission.user = response.data;
                        resolve();
                    } else {
                        reject(401);
                    }
                });
            }
            resolve();
        });
    };

    permission.hasPermission = function (state) {
        return !state || !state.roles || !state.roles.length || !!state.roles && permission.user && ((0, _lodash.intersection)(state.roles, permission.user).length || permission.user.indexOf('admin') > -1);
    };

    return permission;
};

permissionsService.$inject = ['api'];

exports.default = permissionsService;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user = __webpack_require__(590);

var _user2 = _interopRequireDefault(_user);

var _userList = __webpack_require__(592);

var _userList2 = _interopRequireDefault(_userList);

var _userSave = __webpack_require__(594);

var _userSave2 = _interopRequireDefault(_userSave);

var _userForm = __webpack_require__(596);

var _userForm2 = _interopRequireDefault(_userForm);

var _roleSelect = __webpack_require__(598);

var _roleSelect2 = _interopRequireDefault(_roleSelect);

var _emailSetPassword = __webpack_require__(600);

var _emailSetPassword2 = _interopRequireDefault(_emailSetPassword);

var _users = __webpack_require__(602);

var _users2 = _interopRequireDefault(_users);

var _roles = __webpack_require__(603);

var _roles2 = _interopRequireDefault(_roles);

var _userSave3 = __webpack_require__(604);

var _userSave4 = _interopRequireDefault(_userSave3);

var _userForm3 = __webpack_require__(605);

var _userForm4 = _interopRequireDefault(_userForm3);

var _userList3 = __webpack_require__(606);

var _userList4 = _interopRequireDefault(_userList3);

var _roleSelect3 = __webpack_require__(607);

var _roleSelect4 = _interopRequireDefault(_roleSelect3);

var _emailSetPassword3 = __webpack_require__(608);

var _emailSetPassword4 = _interopRequireDefault(_emailSetPassword3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userModule = angular.module('spabooker.user', []).config(_user2.default).controller('userSaveController', _userSave4.default).controller('userFormController', _userForm4.default).controller('userListController', _userList4.default).controller('roleSelectController', _roleSelect4.default).controller('setPasswordEmailController', _emailSetPassword4.default).component('userList', _userList2.default).component('userSave', _userSave2.default).component('userForm', _userForm2.default).component('roleSelect', _roleSelect2.default).component('setPasswordEmail', _emailSetPassword2.default).factory('usersService', _users2.default).factory('rolesService', _roles2.default);

exports.default = userModule.name;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _users = __webpack_require__(591);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.users', {
        url: '/users',
        component: 'userList',
        resolve: {
            users: (0, _users.resolveUsers)()
        },
        roles: ['admin']
    }).state('app.admin.user-add', {
        url: '/users/create',
        component: 'userSave',
        resolve: {
            title: function title() {
                return 'Create a User';
            }
        },
        roles: ['admin']
    }).state('app.admin.user-edit', {
        url: '/users/:targetuser/update',
        component: 'userSave',
        resolve: {
            title: function title() {
                return 'Update a User';
            },
            targetuser: (0, _users.resolveUser)()
        },
        roles: ['admin']
    }).state('app.admin.user-password', {
        url: '/users/:targetuser/change-password',
        component: 'userPassword',
        resolve: {
            title: function title() {
                return 'Change password';
            },
            targetuser: (0, _users.resolveUser)()
        },
        roles: ['admin', 'superadmin']
    }).state('app.password', {
        url: '/password',
        component: 'userSelfpassword',
        resolve: {
            title: function title() {
                return 'Change Your Password';
            }
        }
    }).state('app.profile', {
        url: '/profile',
        component: 'userProfile',
        resolve: {
            title: function title() {
                return 'Edit Your Details';
            },
            targetuser: (0, _users.resolveUser)()
        }
    }).state('app.admin.setPasswordEmails', {
        url: '/set-password-emails',
        component: 'setPasswordEmail',
        roles: ['admin']
    });
}];

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveUsers = exports.resolveUsers = function resolveUsers() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  return ['usersService', function (usersService) {
    return usersService.findAll(page, perpage).then(function (list) {
      return list;
    });
  }];
};

var resolveUser = exports.resolveUser = function resolveUser() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'targetuser';

  return ['$stateParams', 'usersService', function ($stateParams, usersService) {
    return $stateParams[param] ? usersService.find($stateParams[param]) : undefined;
  }];
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    users: '<'
  },
  controller: 'userListController',
  template: __webpack_require__(593)
};

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Users</h1> </header> <main> <form class=\"row c-list__search c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'email'\" ng-change=$ctrl.filtertypeChange()> <option value=first_name>User First Name</option> <option value=last_name>User Last Name</option> <option value=email>User Email</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=\"row expanded\"> <div class=\"small-12 columns\"> <p ng-if=\"$ctrl.users.data.length === 0\">No users yet</p> <div class=u-table-container ng-if=\"$ctrl.users.data.length > 0\"> <table> <thead> <tr> <th></th> <th>Name</th> <th>Email</th> <th>Role</th> <th>Created</th> <th>Last Log In</th> <th>Edit</th> </tr> </thead> <tbody> <tr ng-repeat=\"user in $ctrl.users.data\" class=c-list> <td style=text-align:center> <div ng-if=\"!user.image.includes('gravatar')\" class=c-avatar-imgix> <div class=imgix-fluid imgix-src=\"{{ user.image }}\" data-fit=crop></div> </div> <img ng-if=\"user.image.includes('gravatar')\" ng-src=\"{{ user.image }}\" class=c-avatar> </td> <td>{{ user.first_name }} {{ user.last_name }}</td> <td>{{ user.email }}</td> <td>{{ user.role }}</td> <td><span title=\"{{ user.created_at.replace(' ', 'T') | date:'medium' }}\">{{ user.created_at.replace(' ', 'T') | date:'dd.MM.y' }}</span></td> <td> <span ng-if=user.last_login title=\"{{ user.updated_at.replace(' ', 'T') | date:'medium' }}\">{{ user.human_login }}</span> <span ng-if=!user.last_login>Never</span> </td> <td class=c-list__action> <a ui-sref=\"app.admin.user-edit({ targetuser: user.id })\">Edit</a> </td> </tr> </tbody> </table> </div> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    targetuser: '=',
    hotels: '<',
    access: '<',
    accessroles: '<',
    accessuserroles: '<',
    accessuserrules: '<',
    rules: '<',
    actions: '<',
    sections: '<',
    items: '<',
    title: '@'
  },
  controller: 'userSaveController',
  template: __webpack_require__(595)
};

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p>{{ $ctrl.targetuser.profile.first_name }} {{ $ctrl.targetuser.profile.last_name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'profile' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'profile'\"> Profile </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'profile'\"> <div class=\"small-12 columns\"> <user-form targetuser=$ctrl.targetuser hotels=$ctrl.hotels> </user-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    targetuser: '=',
    hotels: '<'
  },
  controller: 'userFormController',
  template: __webpack_require__(597)
};

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving> <div class=row> <div class=\"column medium-12\"> <h2>RevSpa details</h2> <properties-select name=hotels ng-model=$ctrl.targetuser.local.properties form-field-errors> </properties-select> </div> <div class=\"column medium-12\" ng-if=!$ctrl.editingSelf> <role-select name=role ng-model=$ctrl.targetuser.local.permissions> </role-select> </div> </div> <div class=row ng-if=$ctrl.targetuser.profile.hotel_names.length> <div class=\"column medium-12\"> <hr> <h3>Lobby Hotels</h3> <div class=c-pills> <div class=c-pill ng-repeat=\"hotel in $ctrl.targetuser.profile.hotel_names\"> {{hotel}} </div> </div> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Profile <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    ngDisabled: '<'
  },
  require: {
    ngModel: 'ngModel'
  },
  controller: 'roleSelectController',
  template: __webpack_require__(599)
};

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "<ui-select multiple=multiple ng-model=$ctrl.value uis-open-close=$ctrl.updateViewValue(isOpen) required on-remove=\"$ctrl.setValue($item, $model)\"> <ui-select-match placeholder=Role> {{ $item.name }} </ui-select-match> <ui-select-choices repeat=\"item in $ctrl.roles | filter: { name: $select.search } track by item.value\"> <div ng-bind-html=\"item.name | highlight: $select.search\"></div> <small>{{ item.description }}</small> </ui-select-choices> </ui-select> ";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'setPasswordEmailController',
    template: __webpack_require__(601)
};

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Send Set Password Emails</h1> </header> <main> <div class=row> <div class=\"small-12 columns\"> <message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving> <div class=row> <div class=\"column medium-12\"> <label class=\"c-label c-label--large\">User CSV</label> <p class=c-description>CSV must contain the following columns, in order: <pre>'Premier Core ID', 'Email', 'First Name', 'Last Name'</pre> </p> <file-upload name=csv ng-model=$ctrl.csv accept=text/csv type=CSV required form-field-errors></file-upload> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Send email to users <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> </div> </div> </main> ";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var usersEndpoint = '/api/users';
var userEndpoint = function userEndpoint(id) {
  return usersEndpoint + '/' + id;
};

exports.default = ['api', function (api) {
  return {
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      return api.get(usersEndpoint + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '')).then(function (response) {
        return response.data;
      });
    },
    find: function find(id) {
      return api.get(userEndpoint(id)).then(function (response) {
        return response.data;
      });
    },
    save: function save(user) {
      return api.upload(userEndpoint(user.id), user).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(usersEndpoint + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var roles = [{ value: 'stock', name: 'Stock', description: 'Can see stock relevant to their properties', superadmin: false }, { value: 'orders', name: 'Order Control', description: 'Can see and edit orders relevant to their properties, but not refund', superadmin: false }, { value: 'reporting', name: 'Reporting', description: 'Can see reports relevant to their properties', superadmin: false }, { value: 'manager', name: 'Manager', description: 'Property manager, can see and control aspects of their properties', superadmin: false }, { value: 'investor', name: 'Investor', description: 'Can see global dashboards', superadmin: true }, { value: 'premier_admin', name: 'Premier Software Admin', description: 'Can see Integration dashboard and reports', superadmin: true }, { value: 'admin', name: 'Admin', description: 'Can see information for and administer all hotels and their users', superadmin: true }, { value: 'superadmin', name: 'Superadmin', description: 'Controls ability to create Admins', superadmin: true }];

exports.default = ['permissionsService', function (permissionsService) {
  return {
    getRoles: function getRoles() {
      if (permissionsService.user.indexOf('superadmin') > -1) {
        return roles;
      }
      if (permissionsService.user.indexOf('admin') > -1) {
        return (0, _lodash.filter)(roles, { superadmin: false });
      }
    }
  };
}];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSaveController = function () {
    function UserSaveController(authService) {
        _classCallCheck(this, UserSaveController);

        this.authService = authService;
    }

    _createClass(UserSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = 'profile';
        }
    }]);

    return UserSaveController;
}();

UserSaveController.$inject = ['authService'];

exports.default = UserSaveController;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserFormController = function () {
    function UserFormController($state, usersService, messageService, permissionsService) {
        _classCallCheck(this, UserFormController);

        this.$state = $state;
        this.usersService = usersService;
        this.messageService = messageService;
        this.user = permissionsService.user;
    }

    _createClass(UserFormController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.targetuser.local) {
                this.targetuser.local = { properties: [], permissions: [] };
            }

            this.editingSelf = JSON.parse(localStorage.getItem('profile')).sub === this.targetuser.local.id;
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            if (!this.targetuser) {
                this.targetuser = this.user;
            }

            if (this.targetuser.profile) this.targetuser.local.id = this.targetuser.profile.id;

            return this.usersService.save(this.targetuser.local).then(function () {
                _this.messageService.success('The user <strong>' + _this.targetuser.profile.email + '</strong> was successfully updated!', ['app.admin.user-edit({ \'targetuser\' : \'' + _this.targetuser.profile.id + '\'})', 'User']);

                _this.$state.go('app.admin.users');
            }).catch(function () {
                // var sourceElement = Object.keys(error['data'])[0];
                // this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
            });
        }
    }]);

    return UserFormController;
}();

UserFormController.$inject = ['$state', 'usersService', 'messageService', 'permissionsService'];

exports.default = UserFormController;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserListController = function () {
  function UserListController($scope, messageService, usersService, permissionsService) {
    _classCallCheck(this, UserListController);

    this.usersService = usersService;
    this.messageService = messageService;
    this.$scope = $scope;
    this.user = permissionsService.user;
  }

  _createClass(UserListController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updatePaging();
      this.$scope.$watch(function (scope) {
        return scope.current_page;
      }, function (newVal, oldVal, scope) {
        if (newVal !== oldVal) {
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
            scope.$ctrl.users = undefined;
            scope.$ctrl.usersService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
              scope.$ctrl.users = response;
              scope.$ctrl.loading = false;
            });
          } else {
            scope.$ctrl.usersService.findAll(newVal, scope.per_page).then(function (list) {
              return scope.$ctrl.users = list;
            });
          }
        }
      });
    }
  }, {
    key: 'updatePaging',
    value: function updatePaging() {
      this.$scope.per_page = this.users.per_page;
      this.$scope.current_page = this.users.current_page;
      this.$scope.total = this.users.total;
    }
  }, {
    key: 'onDelete',
    value: function onDelete(user) {
      var _this = this;

      var returnPage = this.users.data.length > 1 ? this.$scope.current_page : this.$scope.current_page - 1;
      this.usersService.delete(user).then(function () {
        return _this.usersService.findAll(returnPage);
      }).then(function (list) {
        _this.$scope.total = list.total;
        _this.$scope.current_page = list.current_page;
        _this.users = list;
      }).then(function () {
        _this.messageService.success('User <strong>' + user.user_metadata.first_name + ' ' + user.user_metadata.last_name + '</strong> was successfully deleted.');
        _this.messageService.push();
      }).catch(function (error) {
        _this.messageService.failure('User <strong>' + user.user_metadata.first_name + ' ' + user.user_metadata.last_name + '</strong> could not be successfully deleted: ' + error.statusText);
        _this.messageService.push();
      });
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this2 = this;

      if (!this.loading && this.filtertext) {
        this.startFilter();
        this.usersService.search(this.filtertype, this.filtertext).then(function (response) {
          _this2.isFiltered = true;
          _this2.endFilter(response);
        });
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      var _this3 = this;

      if (this.isFiltered) {
        this.startFilter();
        this.usersService.findAll(1, 20).then(function (response) {
          _this3.isFiltered = false;
          _this3.endFilter(response);
        });
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        case 'role':
          this.filtertext = 'admin';
          break;
        default:
          this.filtertext = '';
          break;
      }
    }
  }, {
    key: 'startFilter',
    value: function startFilter() {
      this.loading = true;
      this.users = undefined;
    }
  }, {
    key: 'endFilter',
    value: function endFilter(response) {
      this.users = response;
      this.updatePaging();
      this.loading = false;
    }
  }]);

  return UserListController;
}();

UserListController.$inject = ['$scope', 'messageService', 'usersService', 'permissionsService'];

exports.default = UserListController;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RolesSelectController = function () {
    function RolesSelectController(rolesService) {
        _classCallCheck(this, RolesSelectController);

        this.rolesService = rolesService;
    }

    _createClass(RolesSelectController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.ngModel.$render = function () {
                if (_this.roles && _this.ngModel.$viewValue) {
                    _this.value = _this.ngModel.$viewValue.map(function (value) {
                        return (0, _lodash.find)(_this.roles, { value: value });
                    });
                }
            };

            this.roles = this.rolesService.getRoles();
            this.ngModel.$render();
        }
    }, {
        key: 'updateViewValue',
        value: function updateViewValue() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!isOpen) {
                this.setValue();
                this.ngModel.$setTouched();
            }
        }
    }, {
        key: 'setValue',
        value: function setValue() {
            this.ngModel.$setViewValue(this.value.map(function (role) {
                return role.value;
            }));
        }
    }]);

    return RolesSelectController;
}();

RolesSelectController.$inject = ['rolesService'];

exports.default = RolesSelectController;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SetPasswordEmailController = function () {
    function SetPasswordEmailController(integrationApiService, messageService) {
        _classCallCheck(this, SetPasswordEmailController);

        this.integrationApiService = integrationApiService;
        this.messageService = messageService;
    }

    _createClass(SetPasswordEmailController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            this.messageService.clear();

            return this.integrationApiService.setEmailPasswords({ file: this.csv }).then(function (response) {
                _this.csv = undefined;
                _this.messageService.success('Emails successfully queued');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure(error);
                _this.messageService.push();
            });
        }
    }]);

    return SetPasswordEmailController;
}();

SetPasswordEmailController.$inject = ['integrationApiService', 'messageService'];

exports.default = SetPasswordEmailController;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(610);

var _property = __webpack_require__(611);

var _property2 = _interopRequireDefault(_property);

var _propertySave = __webpack_require__(614);

var _propertySave2 = _interopRequireDefault(_propertySave);

var _propertyGroupSave = __webpack_require__(615);

var _propertyGroupSave2 = _interopRequireDefault(_propertyGroupSave);

var _propertyForm = __webpack_require__(616);

var _propertyForm2 = _interopRequireDefault(_propertyForm);

var _propertyBrandForm = __webpack_require__(617);

var _propertyBrandForm2 = _interopRequireDefault(_propertyBrandForm);

var _propertyGroupForm = __webpack_require__(618);

var _propertyGroupForm2 = _interopRequireDefault(_propertyGroupForm);

var _propertyList = __webpack_require__(619);

var _propertyList2 = _interopRequireDefault(_propertyList);

var _propertyGroupList = __webpack_require__(620);

var _propertyGroupList2 = _interopRequireDefault(_propertyGroupList);

var _propertyIntegrationForm = __webpack_require__(621);

var _propertyIntegrationForm2 = _interopRequireDefault(_propertyIntegrationForm);

var _propertyDetails = __webpack_require__(325);

var _propertyDetails2 = _interopRequireDefault(_propertyDetails);

var _propertySelector = __webpack_require__(622);

var _propertySelector2 = _interopRequireDefault(_propertySelector);

var _propertiesSelect = __webpack_require__(623);

var _propertiesSelect2 = _interopRequireDefault(_propertiesSelect);

var _propertySingleSelect = __webpack_require__(624);

var _propertySingleSelect2 = _interopRequireDefault(_propertySingleSelect);

var _propertySelect = __webpack_require__(625);

var _propertySelect2 = _interopRequireDefault(_propertySelect);

var _propertyFinance = __webpack_require__(626);

var _propertyFinance2 = _interopRequireDefault(_propertyFinance);

var _paymentConnect = __webpack_require__(627);

var _paymentConnect2 = _interopRequireDefault(_paymentConnect);

var _propertyList3 = __webpack_require__(628);

var _propertyList4 = _interopRequireDefault(_propertyList3);

var _propertyGroupList3 = __webpack_require__(630);

var _propertyGroupList4 = _interopRequireDefault(_propertyGroupList3);

var _propertyForm3 = __webpack_require__(632);

var _propertyForm4 = _interopRequireDefault(_propertyForm3);

var _propertySettings = __webpack_require__(634);

var _propertySettings2 = _interopRequireDefault(_propertySettings);

var _propertyStyle = __webpack_require__(636);

var _propertyStyle2 = _interopRequireDefault(_propertyStyle);

var _propertyBrandForm3 = __webpack_require__(638);

var _propertyBrandForm4 = _interopRequireDefault(_propertyBrandForm3);

var _propertyFinanceForm = __webpack_require__(640);

var _propertyFinanceForm2 = _interopRequireDefault(_propertyFinanceForm);

var _propertyIntegrationForm3 = __webpack_require__(642);

var _propertyIntegrationForm4 = _interopRequireDefault(_propertyIntegrationForm3);

var _propertyGroupForm3 = __webpack_require__(644);

var _propertyGroupForm4 = _interopRequireDefault(_propertyGroupForm3);

var _propertyBusiness = __webpack_require__(646);

var _propertyBusiness2 = _interopRequireDefault(_propertyBusiness);

var _propertySocial = __webpack_require__(648);

var _propertySocial2 = _interopRequireDefault(_propertySocial);

var _propertyContact = __webpack_require__(650);

var _propertyContact2 = _interopRequireDefault(_propertyContact);

var _propertySave3 = __webpack_require__(652);

var _propertySave4 = _interopRequireDefault(_propertySave3);

var _propertyGroupSave3 = __webpack_require__(654);

var _propertyGroupSave4 = _interopRequireDefault(_propertyGroupSave3);

var _propertySelector3 = __webpack_require__(656);

var _propertySelector4 = _interopRequireDefault(_propertySelector3);

var _propertiesSelect3 = __webpack_require__(658);

var _propertiesSelect4 = _interopRequireDefault(_propertiesSelect3);

var _propertySingleSelect3 = __webpack_require__(660);

var _propertySingleSelect4 = _interopRequireDefault(_propertySingleSelect3);

var _propertySelect3 = __webpack_require__(662);

var _propertySelect4 = _interopRequireDefault(_propertySelect3);

var _paymentConnect3 = __webpack_require__(664);

var _paymentConnect4 = _interopRequireDefault(_paymentConnect3);

var _properties = __webpack_require__(666);

var _properties2 = _interopRequireDefault(_properties);

var _integrationApi = __webpack_require__(667);

var _integrationApi2 = _interopRequireDefault(_integrationApi);

var _integration = __webpack_require__(668);

var _integration2 = _interopRequireDefault(_integration);

var _propertiesFinance = __webpack_require__(669);

var _propertiesFinance2 = _interopRequireDefault(_propertiesFinance);

var _propertyGroup = __webpack_require__(670);

var _propertyGroup2 = _interopRequireDefault(_propertyGroup);

var _propertyLoad = __webpack_require__(671);

var _propertyLoad2 = _interopRequireDefault(_propertyLoad);

var _property3 = __webpack_require__(672);

var _property4 = _interopRequireDefault(_property3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propertyModule = angular.module('spabooker.property', ['spabooker.base', 'colorpicker.module']).config(_property2.default).controller('propertySaveController', _propertySave2.default).controller('propertyGroupSaveController', _propertyGroupSave2.default).controller('propertyFormController', _propertyForm2.default).controller('propertyBrandFormController', _propertyBrandForm2.default).controller('propertyGroupFormController', _propertyGroupForm2.default).controller('propertyDetailsController', _propertyDetails2.default).controller('propertyListController', _propertyList2.default).controller('propertyGroupListController', _propertyGroupList2.default).controller('propertyIntegrationFormController', _propertyIntegrationForm2.default).controller('propertySelectorController', _propertySelector2.default).controller('propertiesSelectController', _propertiesSelect2.default).controller('propertySingleSelectController', _propertySingleSelect2.default).controller('propertySelectController', _propertySelect2.default).controller('propertyFinanceController', _propertyFinance2.default).controller('paymentConnectController', _paymentConnect2.default).component('propertyList', _propertyList4.default).component('propertyGroupList', _propertyGroupList4.default).component('propertyForm', _propertyForm4.default).component('propertySettings', _propertySettings2.default).component('propertyStyle', _propertyStyle2.default).component('propertyBrandForm', _propertyBrandForm4.default).component('propertyIntegrationForm', _propertyIntegrationForm4.default).component('propertyBusiness', _propertyBusiness2.default).component('propertySocial', _propertySocial2.default).component('propertyContact', _propertyContact2.default).component('propertyFinanceForm', _propertyFinanceForm2.default).component('propertyGroupForm', _propertyGroupForm4.default).component('propertySave', _propertySave4.default).component('propertyGroupSave', _propertyGroupSave4.default).component('propertySelector', _propertySelector4.default).component('propertiesSelect', _propertiesSelect4.default).component('propertySingleSelect', _propertySingleSelect4.default).component('propertySelect', _propertySelect4.default).component('paymentConnect', _paymentConnect4.default).factory('propertiesService', _properties2.default).factory('integrationApiService', _integrationApi2.default).factory('integrationService', _integration2.default).factory('propertiesFinanceService', _propertiesFinance2.default).factory('propertyGroupService', _propertyGroup2.default).factory('properties', _propertyLoad2.default).factory('propertyService', _property4.default);

exports.default = propertyModule.name;

/***/ }),
/* 610 */,
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _properties = __webpack_require__(612);

var _propertyGroup = __webpack_require__(613);

exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin.properties', {
    url: '/properties',
    component: 'propertyList',
    resolve: {
      properties: (0, _properties.resolveProperties)()
    },
    roles: ['manager']
  }).state('app.admin.deletedproperties', {
    url: '/properties/deleted',
    component: 'propertyList',
    resolve: {
      properties: (0, _properties.resolveProperties)(1, 20, 'deleted')
    },
    roles: ['admin']
  }).state('app.admin.property-add', {
    url: '/properties/create',
    component: 'propertySave',
    resolve: {
      title: function title() {
        return 'Create a Property';
      },
      property: (0, _properties.resolveProperty)()
    },
    roles: ['admin']
  }).state('app.admin.property-edit', {
    url: '/properties/:property/update',
    component: 'propertySave',
    resolve: {
      title: function title() {
        return 'Update a Property';
      },
      property: (0, _properties.resolveProperty)()
    },
    roles: ['manager']
  }).state('app.admin.groups', {
    url: '/groups',
    component: 'propertyGroupList',
    resolve: {
      propertyGroups: (0, _propertyGroup.resolvePropertyGroups)()
    },
    roles: ['admin']
  }).state('app.admin.deletedgroups', {
    url: '/groups/deleted',
    component: 'propertyGroupList',
    resolve: {
      propertyGroups: (0, _propertyGroup.resolvePropertyGroups)(1, 20, 'deleted')
    },
    roles: ['admin']
  }).state('app.admin.group-add', {
    url: '/groups/create',
    component: 'propertyGroupSave',
    resolve: {
      title: function title() {
        return 'Create a Property';
      },
      properties: (0, _properties.resolveProperties)(-1)
    },
    roles: ['admin']
  }).state('app.admin.group-edit', {
    url: '/groups/:propertyGroup/update',
    component: 'propertyGroupSave',
    resolve: {
      title: function title() {
        return 'Update a Property';
      },
      propertyGroup: (0, _propertyGroup.resolvePropertyGroup)(),
      properties: (0, _properties.resolveProperties)(-1)
    },
    roles: ['admin']
  }).state('app.admin.connect', {
    url: '/connect?:code&:state',
    component: 'paymentConnect',
    resolve: {
      code: ['$stateParams', function ($stateParams) {
        return $stateParams.code;
      }],
      id: ['$stateParams', function ($stateParams) {
        return $stateParams.state;
      }]
    }
  });
}];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveProperty = exports.resolveProperties = undefined;

var _lodash = __webpack_require__(2);

var resolveProperties = exports.resolveProperties = function resolveProperties() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return ['propertiesService', function (propertiesService) {
    return propertiesService.findAll(page, perpage, deleted).then(function (list) {
      return list;
    });
  }];
};

var resolveProperty = exports.resolveProperty = function resolveProperty() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'property';

  return ['$stateParams', 'propertiesService', function ($stateParams, propertiesService) {
    return $stateParams[param] && $stateParams[param] > 0 ? propertiesService.findById($stateParams[param]) : {};
  }];
};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvePropertyGroup = exports.resolvePropertyGroups = undefined;

var _lodash = __webpack_require__(2);

var resolvePropertyGroups = exports.resolvePropertyGroups = function resolvePropertyGroups() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return ['propertyGroupService', function (propertyGroupService) {
    return propertyGroupService.findAll(page, perpage, deleted).then(function (list) {
      return list;
    });
  }];
};

var resolvePropertyGroup = exports.resolvePropertyGroup = function resolvePropertyGroup() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'propertyGroup';

  return ['$stateParams', 'propertyGroupService', function ($stateParams, propertyGroupService) {
    return $stateParams[param] && $stateParams[param] > 0 ? propertyGroupService.findById($stateParams[param]) : {};
  }];
};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertySaveController = function () {
    function PropertySaveController($rootScope, $state, access, eventsService) {
        _classCallCheck(this, PropertySaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.access = access;
        this.eventsService = eventsService;
    }

    _createClass(PropertySaveController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.activeTab = 'property';

            this.eventsService.collectCategories().then(function (response) {
                _this.categories = response;
            });
        }
    }]);

    return PropertySaveController;
}();

PropertySaveController.$inject = ['$rootScope', '$state', 'access', 'eventsService'];

exports.default = PropertySaveController;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyGroupSaveController = function () {
    function PropertyGroupSaveController($rootScope, $state) {
        _classCallCheck(this, PropertyGroupSaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
    }

    _createClass(PropertyGroupSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = 'profile';
            this.propertyGroup = this.propertyGroup || {
                group_properties: []
            };
        }
    }]);

    return PropertyGroupSaveController;
}();

PropertyGroupSaveController.$inject = ['$rootScope', '$state'];

exports.default = PropertyGroupSaveController;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyFormController = function () {
  function PropertyFormController($scope, $state, propertiesService, messageService, access) {
    _classCallCheck(this, PropertyFormController);

    this.$scope = $scope;
    this.$state = $state;
    this.propertiesService = propertiesService;
    this.messageService = messageService;
    this.access = access;
  }

  _createClass(PropertyFormController, [{
    key: '$onInit',
    value: function $onInit() {
      this.property.currency_symbol = this.property.currency_symbol || "£";
      this.property.close_out = this.property.close_out || '';
      this.property.timezone = this.property.timezone || 'Europe/London';
    }
  }, {
    key: 'timeRange',
    value: function timeRange() {
      var starttime = this.property.property_day_start && this.property.property_day_start.includes(':') ? this.property.property_day_start.split(':')[0] : 9;
      var endtime = this.property.property_day_end && this.property.property_day_end.includes(':') ? this.property.property_day_end.split(':')[0] : 18;

      var timeRange = [];

      for (var i = starttime; i <= endtime; i++) {
        var time = i.toString().padStart(2, '0');
        timeRange.push(time);
      }
      return timeRange;
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this = this;

      var dispatch = (0, _lodash.clone)(this.property);

      return this.propertiesService.save(dispatch).then(function (response) {
        if (_this.property.id) {
          _this.messageService.success('The Property <strong>' + _this.property.name + '</strong> was successfully updated!');
        } else {
          _this.messageService.success('The Property <strong>' + _this.property.name + '</strong> was successfully created!', ['app.admin.property-edit({ \'property\' : ' + _this.property.id + '})', 'Property']);
        }
        _this.$state.go('app.admin.properties');
        _this.messageService.push();
      }).catch(function (error) {
        error.data = error.data.original || error.data;
        _this.form.$api.setErrors(error.data);

        var sourceElement = Object.keys(error.data);
        var verb = 'created';
        if (_this.property.id) {
          verb = 'updated';
        }
        if (sourceElement.length > 0) {
          var errors = '';
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var element = _step.value;

              errors += '<li>' + _this.messageService.formatError(element, error.data[element]) + '</li>';
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.messageService.failure('The property <strong>' + _this.property.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
        } else {
          _this.messageService.failure('The property <strong>' + _this.property.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
        }
        _this.messageService.push();
      });
    }
  }]);

  return PropertyFormController;
}();

PropertyFormController.$inject = ['$scope', '$state', 'propertiesService', 'messageService', 'access'];

exports.default = PropertyFormController;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyBrandFormController = function () {
  function PropertyBrandFormController($scope, $state, propertiesService, messageService) {
    _classCallCheck(this, PropertyBrandFormController);

    this.$scope = $scope;
    this.$state = $state;
    this.propertiesService = propertiesService;
    this.messageService = messageService;
  }

  _createClass(PropertyBrandFormController, [{
    key: '$onInit',
    value: function $onInit() {
      this.messageService.clear();
      if (!this.property.brand) {
        this.property.brand = {
          'primary': '',
          'secondary': '',
          'tertiary': ''
        };
      }

      if (this.property.brand.header_font_type !== 'custom') {
        this.property.brand.header_font_path = this.property.brand.header_font_url || this.property.brand.header_font_path;
      }
      if (this.property.brand.body_font_type !== 'custom') {
        this.property.brand.body_font_path = this.property.brand.body_font_url || this.property.brand.body_font_path;
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this = this;

      return this.propertiesService.saveBrand(this.property).then(function () {
        _this.messageService.success('The brand for <strong>' + _this.property.name + '</strong> was successfully updated!');
        _this.formTab = 'property';
        _this.messageService.push();
        _this.messageService.autoClear();
      }).catch(function (error) {
        _this.messageService.failure('The brand for <strong>' + _this.property.name + '</strong> could not be successfully updated: ' + error.statusText);
        _this.messageService.push();
      });
    }
  }, {
    key: 'wipeFontFields',
    value: function wipeFontFields(type) {
      this.property.brand[type + '_font_family'] = undefined;
      this.property.brand[type + '_font_path'] = undefined;
      this.property.brand[type + '_font'] = undefined;
      this.property.brand[type + '_font_settings'] = undefined;
      this.property.brand[type + '_font_url'] = undefined;
    }
  }]);

  return PropertyBrandFormController;
}();

PropertyBrandFormController.$inject = ['$scope', '$state', 'propertiesService', 'messageService'];

exports.default = PropertyBrandFormController;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyGroupFormController = function () {
    function PropertyGroupFormController($scope, $state, propertyGroupService, messageService) {
        _classCallCheck(this, PropertyGroupFormController);

        this.$scope = $scope;
        this.$state = $state;
        this.propertyGroupService = propertyGroupService;
        this.messageService = messageService;
    }

    _createClass(PropertyGroupFormController, [{
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            return this.propertyGroupService.save(this.propertyGroup).then(function (response) {
                if (_this.propertyGroup.updated_at) {
                    _this.messageService.success('The Property Group <strong>' + _this.propertyGroup.name + '</strong> was successfully updated!');
                } else {
                    _this.messageService.success('The Property Group <strong>' + _this.propertyGroup.name + '</strong> was successfully created.');
                }
                _this.$state.go('app.admin.groups');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure('The property <strong>' + _this.propertyGroup.name + '</strong> could not be successfully created: ' + error.statusText);
                _this.messageService.push();
                var sourceElement = Object.keys(error.data)[0];
                if (sourceElement > 0) {
                    _this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
                } else {
                    _this.$scope.$ctrl.form.$setValidity(sourceElement, false);
                }
            });
        }
    }]);

    return PropertyGroupFormController;
}();

PropertyGroupFormController.$inject = ['$scope', '$state', 'propertyGroupService', 'messageService'];

exports.default = PropertyGroupFormController;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyListController = function () {
  function PropertyListController($scope, $state, propertiesService, messageService, access, permissionsService, configService) {
    _classCallCheck(this, PropertyListController);

    this.$scope = $scope;
    this.$state = $state;
    this.propertiesService = propertiesService;
    this.messageService = messageService;
    this.access = access;
    this.user = permissionsService.user;
    this.configService = configService;
  }

  _createClass(PropertyListController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updatePaging();
      this.$scope.$watch(function (scope) {
        return scope.current_page;
      }, function (newVal, oldVal, scope) {
        if (newVal !== oldVal) {
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
            scope.$ctrl.properties = undefined;
            scope.$ctrl.propertiesService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
              scope.$ctrl.properties = response;
              scope.$ctrl.loading = false;
            });
          } else {
            scope.$ctrl.propertiesService.findAll(newVal, scope.per_page).then(function (list) {
              return scope.$ctrl.properties = list;
            });
          }
        }
      });
    }
  }, {
    key: 'updatePaging',
    value: function updatePaging() {
      this.$scope.per_page = this.properties.per_page;
      this.$scope.current_page = this.properties.current_page;
      this.$scope.total = this.properties.total;
    }
  }, {
    key: 'onDelete',
    value: function onDelete(property) {
      var _this = this;

      if (this.access.check('admin')) {
        this.propertiesService.delete(property.id).then(function (list) {
          _this.messageService.success('The property <strong>' + property.name + '</strong> was successfully deleted.');
          _this.messageService.push();
        }).catch(function (error) {
          _this.messageService.failure('The property <strong>' + property.name + '</strong> could not be successfully deleted: ' + error.statusText);
          _this.messageService.push();
        }).then(function () {
          var page = _this.properties.current_page;
          _this.properties = [];
          _this.loading = true;
          return _this.propertiesService.findAll(page).then(function (response) {
            _this.properties = response;
            _this.loading = false;
          });
        });
      }
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this2 = this;

      if (!this.loading && this.filtertext) {
        this.startFilter();
        this.propertiesService.search(this.filtertype, this.filtertext).then(function (response) {
          _this2.isFiltered = true;
          _this2.endFilter(response);
        });
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      var _this3 = this;

      if (this.isFiltered) {
        this.startFilter();
        this.propertiesService.findAll(1, 20).then(function (response) {
          _this3.isFiltered = false;
          _this3.endFilter(response);
        });
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        default:
          this.filtertext = '';
          break;
      }
    }
  }, {
    key: 'startFilter',
    value: function startFilter() {
      this.loading = true;
      this.properties = undefined;
    }
  }, {
    key: 'endFilter',
    value: function endFilter(response) {
      this.properties = response;
      this.updatePaging();
      this.loading = false;
    }
  }, {
    key: 'fireImport',
    value: function fireImport() {
      var _this4 = this;

      if (this.importFile && this.importFile.type === 'text/csv') {
        this.properties = undefined;
        this.propertiesService.import(this.importFile).then(function () {
          _this4.messageService.success('The import was received successfully');
          _this4.messageService.push();

          _this4.propertiesService.findAll(_this4.$scope.current_page, _this4.$scope.per_page).then(function (list) {
            return _this4.properties = list;
          });
        }).catch(function () {
          _this4.messageService.failure('The import was not received successfully');
          _this4.messageService.push();
        });
      }
    }
  }]);

  return PropertyListController;
}();

PropertyListController.$inject = ['$scope', '$state', 'propertiesService', 'messageService', 'access', 'permissionsService', 'configService'];

exports.default = PropertyListController;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyListController = function () {
  function PropertyListController($scope, $state, propertyGroupService, messageService, permissionsService) {
    _classCallCheck(this, PropertyListController);

    this.$scope = $scope;
    this.$state = $state;
    this.propertyGroupService = propertyGroupService;
    this.messageService = messageService;
    this.user = permissionsService.user;
  }

  _createClass(PropertyListController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updatePaging();
      this.$scope.$watch(function (scope) {
        return scope.current_page;
      }, function (newVal, oldVal, scope) {
        if (newVal !== oldVal) {
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
            scope.$ctrl.propertyGroups = undefined;
            scope.$ctrl.propertyGroupService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
              scope.$ctrl.propertyGroups = response;
              scope.$ctrl.loading = false;
            });
          } else {
            scope.$ctrl.propertyGroupService.findAll(newVal, scope.per_page).then(function (list) {
              return scope.$ctrl.propertyGroups = list;
            });
          }
        }
      });
    }
  }, {
    key: 'updatePaging',
    value: function updatePaging() {
      this.$scope.per_page = this.propertyGroups.per_page;
      this.$scope.current_page = this.propertyGroups.current_page;
      this.$scope.total = this.propertyGroups.total;
    }
  }, {
    key: 'onDelete',
    value: function onDelete(propertyGroup) {
      var _this = this;

      this.propertyGroupService.delete(propertyGroup.id).then(function () {
        _this.messageService.success('The property group <strong>' + propertyGroup.name + '</strong> was successfully deleted.');
        _this.messageService.push();
      }).catch(function (error) {
        _this.messageService.failure('The property group <strong>' + propertyGroup.name + '</strong> could not be successfully deleted: ' + error.statusText);
        _this.messageService.push();
      }).then(function () {
        var page = _this.propertyGroups.current_page;
        _this.propertyGroups = [];
        _this.loading = true;
        return _this.propertyGroupService.findAll(page).then(function (response) {
          _this.propertyGroups = response;
          _this.loading = false;
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this2 = this;

      if (!this.loading && this.filtertext) {
        this.startFilter();
        this.propertyGroupService.search(this.filtertype, this.filtertext).then(function (response) {
          _this2.isFiltered = true;
          _this2.endFilter(response);
        });
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      var _this3 = this;

      if (this.isFiltered) {
        this.startFilter();
        this.propertyGroupService.findAll(1, 20).then(function (response) {
          _this3.isFiltered = false;
          _this3.endFilter(response);
        });
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        default:
          this.filtertext = '';
          break;
      }
    }
  }, {
    key: 'startFilter',
    value: function startFilter() {
      this.propertyGroups = undefined;
      this.loading = true;
    }
  }, {
    key: 'endFilter',
    value: function endFilter(response) {
      this.propertyGroups = response;
      this.updatePaging();
      this.loading = false;
    }
  }]);

  return PropertyListController;
}();

PropertyListController.$inject = ['$scope', '$state', 'propertyGroupService', 'messageService', 'permissionsService'];

exports.default = PropertyListController;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propertyDetailsController = __webpack_require__(325);

var _propertyDetailsController2 = _interopRequireDefault(_propertyDetailsController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropertyIntegrationController = function (_PropertyDetailsContr) {
    _inherits(PropertyIntegrationController, _PropertyDetailsContr);

    function PropertyIntegrationController() {
        _classCallCheck(this, PropertyIntegrationController);

        return _possibleConstructorReturn(this, (PropertyIntegrationController.__proto__ || Object.getPrototypeOf(PropertyIntegrationController)).apply(this, arguments));
    }

    _createClass(PropertyIntegrationController, [{
        key: 'testIntegration',
        value: function testIntegration() {
            var _this2 = this;

            this.saving = true;
            return this.integrationApiService.testIntegration(this.property.id).then(function () {
                _this2.messageService.success('Your Core Integration is working as expected!');
                _this2.messageService.push();
                _this2.messageService.autoClear();
            }).catch(function () {
                _this2.messageService.failure('An issue has occurred with your Core Integration, please contact Journey.');
                _this2.messageService.push();
                _this2.messageService.autoClear();
            }).then(function () {
                _this2.saving = false;
            });
        }
    }, {
        key: 'getVersion',
        value: function getVersion() {
            var _this3 = this;

            this.saving = true;
            return this.integrationApiService.getVersion(this.property.id).then(function (response) {
                _this3.messageService.success('Your Core Integration is on version ' + response + '!');
                _this3.messageService.push();
            }).catch(function () {
                _this3.messageService.failure('An issue has occurred with your Core Integration, please contact Journey.');
                _this3.messageService.push();
                _this3.messageService.autoClear();
            }).then(function () {
                _this3.saving = false;
            });
        }
    }, {
        key: 'runImport',
        value: function runImport() {
            var _this4 = this;

            this.saving = false;
            return this.integrationApiService.getVersion(this.property.id).then(function () {
                return _this4.integrationApiService.integrationImport(_this4.property.id).then(function () {
                    _this4.details.import_run = 1;
                    _this4.messageService.success('The Core import has been queued!');
                    _this4.messageService.push();
                }).catch(function () {
                    _this4.messageService.failure('The import has run into an issue, please check with the RevSpa team.');
                    _this4.messageService.push();
                }).then(function () {
                    _this4.saving = false;
                });
            });
        }
    }]);

    return PropertyIntegrationController;
}(_propertyDetailsController2.default);

exports.default = PropertyIntegrationController;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertySelectorController = function () {
    function PropertySelectorController($rootScope, $window, $location, encryptService, propertiesService, properties, configService, storeService, access, currentPropertyService) {
        _classCallCheck(this, PropertySelectorController);

        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$location = $location;
        this.propertiesService = propertiesService;
        this.encryptService = encryptService;
        this.configService = configService;
        this.propertylist = properties.list;
        this.storeService = storeService;
        this.access = access;
        this.currentPropertyService = currentPropertyService;
    }

    _createClass(PropertySelectorController, [{
        key: '$onInit',
        value: function $onInit() {
            this.saving = false;
            this.property = this.currentPropertyService.get();
        }
    }, {
        key: 'onSelect',
        value: function onSelect(property) {
            var _this = this;

            this.saving = true;
            return this.encryptService.encrypt(property.id.toString()).then(function (encrypted) {
                _this.storeService.set('property', encrypted.data);

                return _this.propertiesService.findById(property.id).then(function (response) {
                    _this.$rootScope.currentProperty = response;

                    _this.storeService.remove('basket');

                    var path = _this.$location.path().split('/');
                    if (path.length > 2 && parseInt(path[path.length - 2]) > 0) {
                        path.splice(-2);
                        _this.$window.location.href = path.join('/');
                    } else if (path.includes('page-content') && path.length > 3) {
                        path.splice(-1);
                        _this.$window.location.href = path.join('/');
                    } else {
                        _this.$window.location.reload();
                    }
                });
            });
        }
    }]);

    return PropertySelectorController;
}();

PropertySelectorController.$inject = ['$rootScope', '$window', '$location', 'encryptService', 'propertiesService', 'properties', 'configService', 'storeService', 'access', 'currentPropertyService'];

exports.default = PropertySelectorController;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertiesSelectController = function () {
    function PropertiesSelectController(propertiesService, messageService) {
        _classCallCheck(this, PropertiesSelectController);

        this.propertiesService = propertiesService;
        this.messageService = messageService;
    }

    _createClass(PropertiesSelectController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.ngModel.$render = function () {
                if (_this.properties && _this.ngModel.$viewValue) {
                    _this.value = _this.ngModel.$viewValue.map(function (slug) {
                        return (0, _lodash.find)(_this.properties, { slug: slug });
                    });
                }
            };

            this.propertiesService.findAll(-1).then(function (properties) {
                return _this.properties = properties;
            }).then(function () {
                return _this.ngModel.$render();
            }).catch(function (errors) {
                _this.messageService.failure(errors);
                _this.messageService.push();
            });
        }
    }, {
        key: 'updateViewValue',
        value: function updateViewValue() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!isOpen) {
                this.setValue();
                this.ngModel.$setTouched();
            }
        }
    }, {
        key: 'setValue',
        value: function setValue() {
            this.ngModel.$setViewValue(this.value.map(function (property) {
                return property.slug;
            }));
        }
    }]);

    return PropertiesSelectController;
}();

PropertiesSelectController.$inject = ['propertiesService', 'messageService'];

exports.default = PropertiesSelectController;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertySingleSelectController = function () {
  function PropertySingleSelectController(propertiesService) {
    _classCallCheck(this, PropertySingleSelectController);

    this.propertiesService = propertiesService;
  }

  _createClass(PropertySingleSelectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.propertiesService.findAll(-1).then(function (result) {
        _this.properties = result;
        _this.properties.unshift({ id: '', name: 'None', pod: { name: 'Select no property' } });
        _this.property = _this.ngModel.$viewValue ? _this.ngModel.$viewValue : '';
      });
    }
  }, {
    key: 'updateValue',
    value: function updateValue() {
      var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!isOpen) {
        this.ngModel.$setViewValue(this.property);
        this.ngModel.$setTouched();
      }
    }
  }]);

  return PropertySingleSelectController;
}();

PropertySingleSelectController.$inject = ['propertiesService'];

exports.default = PropertySingleSelectController;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertySelectController = function () {
  function PropertySelectController(propertiesService) {
    _classCallCheck(this, PropertySelectController);

    this.propertiesService = propertiesService;
  }

  _createClass(PropertySelectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.propertiesService.findAll(-1).then(function (result) {
        _this.propertylist = result;
        _this.properties = _this.ngModel.$viewValue && Object.keys(_this.ngModel.$viewValue).length ? _this.ngModel.$viewValue : [];
      });
    }
  }, {
    key: 'updateValue',
    value: function updateValue() {
      var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!isOpen) {
        this.ngModel.$setViewValue(this.properties);
        this.ngModel.$setTouched();
      }
    }
  }, {
    key: 'delete',
    value: function _delete(key) {
      if (Object.keys(this.properties).length === 1) {
        this.properties = [];
      } else {
        this.properties.splice(key, 1);
      }
      this.updateValue();
    }
  }, {
    key: 'disableProperty',
    value: function disableProperty(id) {
      return (0, _lodash.find)(this.properties, { 'property_id': id });
    }
  }]);

  return PropertySelectController;
}();

PropertySelectController.$inject = ['propertiesService'];

exports.default = PropertySelectController;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyFinanceController = function () {
    function PropertyFinanceController(propertiesService, messageService, access, configService) {
        _classCallCheck(this, PropertyFinanceController);

        this.propertiesService = propertiesService;
        this.messageService = messageService;
        this.access = access;
        this.configService = configService;
    }

    _createClass(PropertyFinanceController, [{
        key: '$onInit',
        value: function $onInit() {
            this.stripeTestEnv = this.configService.get('gateways')['stripe']['account'] || false;
            this.details = this.property[this.type] || {};
            this.connectRedirectUrl = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + this.configService.get('gateways.stripe.clientId') + '&scope=read_write&redirect_uri=' + this.configService.get('appUrl') + '/admin/connect&state=' + this.property.id;
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            return this.propertiesService.updateDetails(this.details, this.property.id, this.type).then(function () {
                _this.messageService.success('The ' + _this.type + ' details for <strong>' + _this.property.name + '</strong> were successfully updated!');
                _this.formTab = 'property';
                _this.property[_this.type] = _this.details;
                _this.messageService.push();
                _this.messageService.autoClear();
            }).catch(function (error) {
                _this.messageService.failure('The ' + _this.type + ' details for <strong>' + _this.property.name + '</strong> could not be successfully updated: ' + error.statusText);
                _this.messageService.push();
            }).then(function () {
                _this.updating = false;
            });
        }
    }, {
        key: 'disconnectFromGateway',
        value: function disconnectFromGateway(gateway) {
            switch (gateway) {
                case 'stripe':
                    this.details.stripe_user_id = undefined;
                    break;

                default:
                    return false;
            }

            this.updating = true;
            return this.onSave();
        }
    }, {
        key: 'isConnected',
        value: function isConnected(gateway) {
            switch (gateway) {
                case 'stripe':
                    return !!this.details.stripe_user_id;
            }
            return false;
        }
    }, {
        key: 'displayPaymentGatewayName',
        value: function displayPaymentGatewayName() {
            switch (this.details.payment_gateway) {
                case 'stripe':
                    return 'Stripe';
                case 'paysafe':
                    return 'Paysafe';
                default:
                case 'none':
                    return 'No payment gateway';
            }
        }
    }, {
        key: 'setDummyStripe',
        value: function setDummyStripe() {
            this.details.stripe_user_id = this.stripeTestEnv;
            this.notSaved = true;
        }
    }]);

    return PropertyFinanceController;
}();

PropertyFinanceController.$inject = ['propertiesService', 'messageService', 'access', 'configService'];

exports.default = PropertyFinanceController;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentConnectController = function () {
  function PaymentConnectController(paymentConnectService) {
    _classCallCheck(this, PaymentConnectController);

    this.paymentConnectService = paymentConnectService;
    this.endpoint = '/api/payment/connect';
  }

  _createClass(PaymentConnectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      return this.paymentConnectService.connect(this.code, this.id, this.endpoint).then(function () {
        _this.response = 'Your account has been successfully connected';
      }).catch(function () {
        _this.error = true;
        _this.response = 'Your account could not be connected, please try again';
      });
    }
  }]);

  return PaymentConnectController;
}();

PaymentConnectController.$inject = ['paymentConnectService'];

exports.default = PaymentConnectController;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    properties: '<'
  },
  controller: 'propertyListController',
  template: __webpack_require__(629)
};

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Properties</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('admin')\"> <a ui-sref=app.admin.property-add class=c-button--action> <icon icon=property></icon> Create a Property </a> <a class=c-button--action ngf-drop ngf-select ng-model=$ctrl.importFile ngf-change=$ctrl.fireImport() ngf-accept=text/csv ngf-max-size=15MB> <icon icon=chevron-up></icon> Import a Property </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.properties class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedproperties class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <form class=\"row c-list__search c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.properties.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No properties have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No properties match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.properties.data.length > 0\"> <thead> <tr> <th class=c-table__lights></th> <th>Name</th> <th ng-if=\"$ctrl.access.check('manager')\"></th> <th ng-if=\"$ctrl.access.check('admin')\"></th> <th ng-if=\"$ctrl.access.check('admin')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"property in $ctrl.properties.data\" class=\"c-list {{ property.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-table__lights> <span ng-class=\"(property.active)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (property.active)? 'This property is active' : 'This property is not active' }}\"></span> </td> <td>{{ property.name }}</td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.property-edit({ property: property.id })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('admin')\"> <a target=_blank href=\"//{{property.slug}}.{{ $ctrl.configService.get('domain') }}\"><span class=c-property-select__property>View</span></a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('admin')\"> <a ng-click=$ctrl.onDelete(property) confirm=\"Are you sure you want to delete {{ property.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> <file-upload style=display:none id=importProperty ng-model=importFile accept=text/csv></file-upload>";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    propertyGroups: '<'
  },
  controller: 'propertyGroupListController',
  template: __webpack_require__(631)
};

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Property Groups</h1> <div class=c-page-head__actions> <a ui-sref=app.admin.group-add class=c-button--action> <icon icon=hierarchy></icon> Create a Property Group </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.groups class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedgroups class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <form class=\"row c-list__search c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.propertyGroups.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No property groups have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No property groups match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.propertyGroups.data.length > 0\"> <thead> <tr> <th>Name</th> <th></th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"group in $ctrl.propertyGroups.data\" class=\"c-list {{ group.deleted_at ? 'c-list__deleted' : ''}}\"> <td>{{ group.name }}</td> <td class=c-list__action> <a ui-sref=\"app.admin.group-edit({ propertyGroup: group.id })\">Edit</a> </td> <td class=c-list__action> <a ng-click=$ctrl.onDelete(group) confirm=\"Are you sure you want to delete {{ group.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    property: '='
  },
  controller: 'propertyFormController',
  template: __webpack_require__(633)
};

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-disabled=\"!$ctrl.access.check('admin')\" ng-model=$ctrl.property.name form-field-errors required> <label class=c-form__label for=name>Property Name</label> </div> <div class=row> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=slug type=text class=c-form__input autocomplete=off ng-disabled=\"!$ctrl.access.check('admin')\" ng-model=$ctrl.property.slug form-field-errors required ng-pattern=/^[0-9a-z_-]+$/ > <label class=c-form__label for=slug>Property Identifier</label> <i class=\"c-icon c-icon--help\" tooltip=\"This field can only contain numbers (0-9), lowercase letters (a-z), underscores (_) and hyphens (-)\" tooltip-placement=left>?</i> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=slug type=text class=c-form__input autocomplete=off ng-disabled=\"!$ctrl.access.check('admin')\" ng-model=$ctrl.property.order_reference form-field-errors required ng-pattern=/^[A-Z]{3}$/ > <label class=c-form__label for=slug>Order Reference</label> <i class=\"c-icon c-icon--help\" tooltip=\"This field can only contain uppercase letters (A-Z). It must be 3 characters in length.\" tooltip-placement=left>?</i> </div> </div> <div class=\"columns medium-4\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=currency_code ng-model=$ctrl.property.currency_code ng-disabled=\"!$ctrl.access.check('admin')\"> <option value=\"\" disabled=disabled>Select...</option> <option>GBP</option> <option>EUR</option> <option>USD</option> <option>JPY</option> </select> <label class=c-form__label for=currency_code>Currency Code <span ng-if=\"$ctrl.property.finance.payment_gateway === 'stripe'\">(same as Stripe account)</span></label> </div> </div> </div> <hr style=margin-top:0> <div class=row> <div class=\"column medium-4\"> <div class=c-form__field> <input name=start_time type=text class=\"c-form__input c-form__input--date\" maxlength=8 form-field-errors required ng-model=$ctrl.property.property_day_start ng-pattern=/[0-9:]/ ng-disabled=\"!$ctrl.access.check('admin')\"> <label class=c-form__label for=start_time>Property Open Time</label> <i class=\"c-icon c-icon--help\" tooltip=\"Times are 24H and should be written in the format (HH:MM)\" tooltip-placement=left>?</i> </div> </div> <div class=\"column medium-4\"> <div class=c-form__field> <input name=end_time type=text class=\"c-form__input c-form__input--date\" maxlength=8 form-field-errors required ng-model=$ctrl.property.property_day_end ng-pattern=/[0-9:]/ ng-disabled=\"!$ctrl.access.check('admin')\"> <label class=c-form__label for=end_time>Property Close Time</label> <i class=\"c-icon c-icon--help\" tooltip=\"Times are 24H and should be written in the format (HH:MM)\" tooltip-placement=left>?</i> </div> </div> <div class=\"columns medium-4\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=timezone ng-model=$ctrl.property.timezone required> <option>Europe/London</option> </select> <label class=c-form__label for=timezone>Timezone for Availability</label> </div> </div> </div> <div class=row> <div class=\"columns medium-3\" ng-show=\"!$ctrl.property.integration || $ctrl.property.integration.allow_time_constraining\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=start_times ng-model=$ctrl.property.start_time_interval ng-disabled=$ctrl.property.integration> <option value=\"\" disabled=disabled>Select...</option> <option value=10>10 Minutes</option> <option value=15>15 Minutes</option> <option value=30>30 Minutes</option> </select> <label class=c-form__label for=start_times>Event Start Time Interval</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=close_out ng-model=$ctrl.property.close_out> <option value=\"\">None - Today is bookable</option> <option value=00:00:00>Beginning of day - Today is not bookable</option> <option ng-repeat=\"time in $ctrl.timeRange()\" value=\"{{ time }}:00:00\">{{ time }}:00</option> </select> <label class=c-form__label for=close_out>Same Day Bookings Close Out Time</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=close_out_day ng-model=$ctrl.property.close_out_day> <option value=\"\">None</option> <option ng-repeat=\"num in [1,2,3,4,5,6,7]\">{{ num }}</option> </select> <label class=c-form__label for=close_out_day>Close Out Days From Present</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=min_search_days ng-model=$ctrl.property.min_search_days> <option value=\"\">None</option> <option ng-repeat=\"num in [1,2,3,4,5,6,7]\">{{ num }}</option> </select> <label class=c-form__label for=min_search_days>Minimum Search Days</label> </div> </div> </div> <hr style=margin-top:0> <label class=c-label for=terms>Default Terms &amp; Conditions</label> <p class=c-description>These terms will appear on the Terms and Conditions page. To set terms for events, please fill in the category terms or set them on a single event.</p> <div class=c-form__field> <textarea name=terms class=c-form__textarea type=text ng-model=$ctrl.property.terms form-field-errors required></textarea> </div> <div ng-if=\"$ctrl.access.check('admin')\"> <hr> <section class=row> <div class=\"column medium-6\"> <label for=active class=c-label>Active</label> <p class=c-description>If enabled, this property can be accessed publicly via the domain.</p> <switch id=active name=active ng-model=$ctrl.property.active class=green></switch> </div> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=property_type ng-model=$ctrl.property.property_type> <option value=\"\">RevSpa</option> <option value=premier>Premier Core</option> <option value=concept>Concept</option> </select> <label class=c-form__label for=property_type>Property Type</label> </div> </div> </section> <div class=row ng-show=!$ctrl.property.integration> <div class=\"column medium-6\"> <p class=c-description>If a value is set here, individual quantity will be ignored when tracked, instead using this value. The value is <strong>per day</strong> but is <strong>date and event type independent</strong> and will affect all sold events, on all dates.</p> </div> <div class=\"column medium-6\"> <div class=c-form__field> <input name=global_quantity type=text class=c-form__input form-field-errors ng-model=$ctrl.property.global_quantity ng-pattern=/[0-9]/ > <label class=c-form__label for=global_quantity>Global Quantity</label> </div> </div> </div> <section ng-if=\"(!$ctrl.property.property_type || $ctrl.property.property_type === '') && !$ctrl.property.integration\"> <label for=track_quantity class=c-label>Default Track Quantity Setting</label> <p class=c-description>Determines the default state of the Track Quantity setting when creating new events. This can still be updated on individual events.</p> <switch id=track_quantity name=track_quantity ng-model=$ctrl.property.track_quantity class=green></switch> </section> <section ng-if=\"(!$ctrl.property.property_type || $ctrl.property.property_type === '') && !$ctrl.property.integration\"> <label for=credit_spa_days class=c-label>Spa Days with Credit</label> <p class=c-description>If enabled, allows Spa Days to be created with unassigned Treatment credit and provides a list of Treatments to choose from. <br><small>This will not disable the storefront functionality for existing Spa Days that already have credit and Treatments assigned to them.</small></p> <switch id=credit_spa_days name=credit_spa_days ng-model=$ctrl.property.credit_spa_days class=green></switch> </section> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Property <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        property: '<',
        formTab: '=',
        categories: '<',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: __webpack_require__(635)
};

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=\"c-form c-form--settings\"> <section ng-if=\"$ctrl.access.check('admin')\"> <label class=\"c-label c-label--large\">Availability</label> <hr/> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Global advanced booking limitation (in days) for <strong>Activities</strong>. Guests will not be able to be book an <strong>Activity</strong> unless the date on which it occurs is within this many days, not including today. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input ng-model=$ctrl.details.availability.activity_pre_book type=number /> </div> </div> </div> </section> <section ng-if=\"$ctrl.access.check('manager') && $ctrl.property.property_type === 'premier'\"> <label class=\"c-label c-label--large\">Core Integration</label> <hr/> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Allow staff selection for top-level, integrated treatments on orders. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=load_staff class=c-label>Staff Selection</label> <switch id=load_staff name=load_staff ng-model=$ctrl.details.core.load_staff class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Allow new Core customers to register an account. This allows both a registration page for new clients (/register), and updating an existing Core client with a password after completing an order. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=create_account class=c-label> Show Core Registration Forms </label> <switch id=create_account name=create_account ng-model=$ctrl.details.core.create_account class=green /> </div> </div> </div> </section> <section ng-if=\"$ctrl.access.check('manager') && $ctrl.property.property_type === 'premier'\"> <label class=\"c-label c-label--large\">Display Options</label> <hr/> <div class=row> <div class=\"columns medium-12\"> <h3>Homepage</h3> </div> <div class=\"columns medium-12\"> <div class=row> <div class=\"medium-6 columns\"> <p class=c-description> Don't show prices for any events on the homepage </p> </div> <div class=\"medium-6 columns\"> <div class=c-form__field> <label for=home_prices class=c-label> Hide Prices On Tiles </label> <switch id=home_prices name=home_prices ng-model=$ctrl.details.display.home_hide_prices class=green /> </div> </div> </div> </div> </div> </section> <section ng-if=\"$ctrl.access.check('manager')\"> <label class=\"c-label c-label--large\">Emails</label> <hr/> <div class=row> <div class=\"columns medium-12\"> <h4>Booking Confirmations</h4> <p> With both settings below disabled: <br/> A customer will get a booking confirmation email when an order enters \"Confirmation\" status. <br/> A property administrator will get a confirmation email when payment is taken in RevSpa (no matter the status of the order) </p> <br/> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> No booking confirmation email will be sent by RevSpa to the property administrator email. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=no_admin_email class=c-label> Disable Admin Confirmation Email </label> <switch id=no_admin_email name=no_admin_email ng-model=$ctrl.details.email.no_admin_email class=green /> </div> </div> </div> <div class=row ng-if=$ctrl.property.property_type> <div class=\"columns medium-6\"> <p class=c-description> No booking confirmation email will be sent by RevSpa to the customer. <span ng-if=$ctrl.property.property_type> This should only be turned on if your integration is sending emails <strong>instead</strong> </span>. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=no_guest_email class=c-label> Disable Guest Confirmation Email </label> <switch id=no_guest_email name=no_guest_email ng-model=$ctrl.details.email.no_guest_email class=green /> </div> </div> </div> </section> <section ng-if=\"$ctrl.access.check('manager')\"> <label class=\"c-label c-label--large\">Orders</label> <hr/> <div class=row ng-if=!$ctrl.property.property_type> <div class=\"columns medium-6\"> <p class=c-description> Orders will automatically be \"Confirmed\", skipping the \"Awaiting Confirmation\" step. An \"Awaiting Confirmation\" e-mail will not be sent. You will have to manually move orders from \"Awaiting Confirmation\" to \"Confirmed\". </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=autoconfirm class=c-label> Skip \"Awaiting Confirmation\" Step for new Orders </label> <switch id=autoconfirm name=autoconfirm ng-model=$ctrl.details.order.autoconfirm class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Orders will display a notes field during the Checkout Review step for customers to fill out. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=notes class=c-label> Show Order Notes Input </label> <switch id=notes name=notes ng-model=$ctrl.details.order.notes class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> The review step will display a cancellation agreement checkbox which must be checked in order to proceed. This agreement confirms that bookings <strong>within</strong> the specified duration of the time being booked are not eligible for a refund if cancelled. The text and duration are configurable. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=cancellation_agreement class=c-label> Show Cancellation Agreement Checkbox </label> <switch id=cancellation_agreement name=cancellation_agreement ng-model=$ctrl.details.order.cancellation_agreement class=green /> </div> </div> </div> <div class=row ng-if=$ctrl.details.order.cancellation_agreement> <div class=\"columns medium-6\"> <p class=c-description> If the number of hours between the customer booking and arriving is <strong>less</strong> than this number then they will have to explicity agree before being able to book. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=cancellation_agreement_duration class=c-label> Cancellation Agreement Duration </label> <input ng-model=$ctrl.details.order.cancellation_agreement_duration ng-disabled=!$ctrl.details.order.cancellation_agreement type=number required/> </div> </div> </div> <div class=row ng-if=$ctrl.details.order.cancellation_agreement> <div class=\"columns medium-6\"> <p class=c-description> <strong> The text displayed alongside the cancellation agreement checkbox. </strong> </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=cancellation_agreement_duration class=c-label> Cancellation Agreement Text </label> <input ng-model=$ctrl.details.order.cancellation_agreement_text ng-disabled=!$ctrl.details.order.cancellation_agreement type=text required/> </div> </div> </div> </section> <section ng-if=\"$ctrl.access.check('admin')\"> <label class=\"c-label c-label--large\">Payment</label> <hr/> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Allow usage of promo codes on the Payment step. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=allow_promos class=c-label>Allow Promo Codes</label> <switch id=allow_promos name=allow_promos ng-model=$ctrl.details.payment.allow_promos class=green /> </div> </div> </div> <section ng-if=!$ctrl.property.property_type> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Allow usage of open-value vouchers on the Payment step (Value is entered by the customer). </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=oevoucher class=c-label> Allow Open-value Vouchers </label> <switch id=oevoucher name=oevoucher ng-model=$ctrl.details.payment.oevoucher class=green /> </div> </div> </div> <div class=row ng-if=$ctrl.details.payment.oevoucher> <div class=\"columns medium-6\"> <p class=c-description> Allow customers to redeem multiple vouchers at the same time during the payment step of the checkout process. <br/>Requires open-value vouchers </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=multivoucher class=c-label> Allow Multiple Voucher Redemption </label> <switch id=multivoucher name=multivoucher ng-model=$ctrl.details.payment.multivoucher disabled=!$ctrl.details.payment.oevoucher class=green /> </div> </div> </div> <div class=row ng-if=$ctrl.details.payment.oevoucher> <div class=\"columns medium-6\"> <p class=c-description> Allow customers to enter a 'pin' (text field) while adding a voucher during the payment step of the checkout process. <br/>Requires open-value vouchers </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=voucher_pin class=c-label>Show Voucher Pin</label> <switch id=voucher_pin name=voucher_pin ng-model=$ctrl.details.payment.voucher_pin disabled=!$ctrl.details.payment.oevoucher class=green /> </div> </div> </div> </section> <section ng-if=!$ctrl.details.payment.oevoucher> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Allow usage of Gifted gift vouchers on the Payment step. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=gifted class=c-label> Allow Gifted gift Vouchers </label> <switch id=gifted name=gifted ng-model=$ctrl.details.payment.allow_gifted_vouchers class=green /> </div> </div> </div> </section> </section> <section ng-if=\"$ctrl.access.check('manager')\"> <label class=\"c-label c-label--large\">Promotions</label> <hr/> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Promote this category on the storefront. It will additionally appear in many places a customer is directed towards choosing an event type, such as Spa Days. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <select id=promoted_category_id name=promoted_category_id ng-model=$ctrl.details.promotion.promoted_category_id ng-options=\"category.id as category.name for category in $ctrl.categories\"> <option value=\"\">No Promoted Category</option> </select> </div> </div> </div> <div class=row ng-show=$ctrl.details.promotion.promoted_category_id> <div class=\"columns medium-6\"> <p class=c-description> If you would like an additional homepage carousel this determines in what order they will be displayed, based on where you would like the <strong>promoted category</strong> to appear. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <select id=promoted_category_position name=promoted_category_position ng-model=$ctrl.details.promotion.promoted_category_position> <option value=\"\">No carousel</option> <option value=first>First</option> <option value=middle>Middle</option> <option value=last>Last</option> </select> </div> </div> </div> </section> <section ng-if=\"$ctrl.access.check('manager')\"> <label class=\"c-label c-label--large\">Storefront List Views</label> <hr/> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Display a filter on the Treatment list view to filter by length of Treatment, e.g. <strong>30 minutes</strong>. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=treatment_durations class=c-label> Show Treatment Duration Filter </label> <switch id=treatment_durations name=treatment_durations ng-model=$ctrl.details.listView.treatment_durations class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Display a filter on the Spa Day list view to filter by length of Spa Day, e.g. <strong>Half Day</strong>. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=spaday_durations class=c-label> Show Spa Day Duration Filter </label> <switch id=spaday_durations name=spaday_durations ng-model=$ctrl.details.listView.spaday_durations class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Display a filter on a single Category list view to filter by length of Event, e.g. <strong>Half Day</strong> or <strong>30 minutes</strong>. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=category_durations class=c-label> Show Category Duration Filter </label> <switch id=category_durations name=category_durations ng-model=$ctrl.details.listView.category_durations class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Display a Treatment category listing page instead of a full Treatment listing page </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=treatment_categories class=c-label> Show Treatment Category List View </label> <switch id=treatment_categories name=treatment_categories ng-model=$ctrl.details.listView.treatment_categories class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Display a Spa Day category listing page instead of a full Spa Day listing page </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=spaday_categories class=c-label> Show Spa Day Category List View </label> <switch id=spaday_categories name=spaday_categories ng-model=$ctrl.details.listView.spaday_categories class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Stop availability calls on all list views when a user selects a date. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=stop_availability class=c-label> Stop list Availability Calls </label> <switch id=stop_availability name=stop_availability ng-model=$ctrl.details.listView.stop_availability class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description> Show Activities to all guests, not just logged in members. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=open_activities class=c-label> Open Activities to all guests </label> <switch id=open_activities name=open_activities ng-model=$ctrl.details.listView.open_activities class=green /> </div> </div> </div> </section> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Settings <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: __webpack_require__(637)
};

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <label class=\"c-label c-label--large\">Style Overrides</label> <hr> <div class=row> <div class=\"columns medium-6\"> <p class=c-description>Enforce specific text colour on elements with the primary brand colour as a background.</p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <select ng-model=$ctrl.details.primary_override> <option value=\"\">Default</option> <option value=white>White</option> <option value=black>Black</option> </select> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description>Change the navigation links colour from the default (brand primary) to a specific colour.</p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <select ng-model=$ctrl.details.navigation_links> <option value=\"\">Default</option> <option value=white>White</option> <option value=black>Black</option> <option value=primary>Primary brand colour</option> <option value=secondary>Secondary brand colour</option> <option value=tertiary>Tertiary brand colour</option> </select> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description>Change the text colour of primary buttons.</p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <select ng-model=$ctrl.details.primary_button_text> <option value=\"\">Default</option> <option value=white>White</option> <option value=black>Black</option> </select> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <p class=c-description>Prevent the property logo being shown in the header on pages after the homepage.</p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <label for=category_durations class=c-label>Hide Header Logo</label> <switch id=category_durations name=category_durations ng-model=$ctrl.details.hide_header_logo class=green /> </div> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Style <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    property: '<',
    formTab: '='
  },
  controller: 'propertyBrandFormController',
  template: __webpack_require__(639)
};

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <label class=\"c-label c-label--large\">Property Logo</label> <p class=c-description>Logo should be an SVG or transparent PNG.</p> <file-upload name=picture ng-model=$ctrl.property.brand.logo accept=image/png,image/svg+xml current-url=$ctrl.property.brand.logo_url dark-background=true form-field-errors></file-upload> <h2>Brand colours</h2> <div class=c-brand> <div class=c-brand__inner> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input colorpicker name=hex type=text class=c-form__input ng-model=$ctrl.property.brand.primary required ng-pattern=/^[0-9a-fA-F#]{7}$/ maxlength=7> <label class=c-form__label for=hex>Primary Hex Code</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-brand__colourblock ng-style=\"{ 'background-color': $ctrl.property.brand.primary }\"> <div class=c-brand__colourblock-label> Primary </div> </div> </div> </div> </div> <div class=c-brand__inner> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input colorpicker name=hex type=text class=c-form__input ng-model=$ctrl.property.brand.secondary required ng-pattern=/^[0-9a-fA-F#]{7}$/ maxlength=7> <label class=c-form__label for=hex>Secondary Hex Code</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-brand__colourblock ng-style=\"{ 'background-color': $ctrl.property.brand.secondary }\"> <div class=c-brand__colourblock-label> Secondary </div> </div> </div> </div> </div> <div class=c-brand__inner> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input colorpicker name=hex type=text class=c-form__input ng-model=$ctrl.property.brand.tertiary required ng-pattern=/^[0-9a-fA-F#]{7}$/ maxlength=7> <label class=c-form__label for=hex>Tertiary Hex Code</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-brand__colourblock ng-style=\"{ 'background-color': $ctrl.property.brand.tertiary }\"> <div class=c-brand__colourblock-label> Tertiary </div> </div> </div> </div> </div> </div> <hr> <label class=\"c-label c-label--large\">Fallback Hero Image</label> <p class=c-description>Image should be an PNG or JPG.</p> <file-upload name=picture ng-model=$ctrl.property.brand.hero accept=image/jpeg,image/png current-url=$ctrl.property.brand.hero_url form-field-errors></file-upload> <hr> <h2>Fonts</h2> <p class=c-description>Include apostrophes around font family names e.g. 'Alegreya', 'Open Sans', sans-serif</p> <div ng-repeat=\"type in ['header', 'body']\"> <label ng-bind=type.toUpperCase()></label> <select ng-model=\"$ctrl.property.brand[type+'_font_type']\" ng-change=$ctrl.wipeFontFields(type)> <option value=\"\">Select a font type</option> <option value=custom>Custom Font (Upload)</option> <option value=google>Google Font</option> <option value=typekit>Typekit Font</option> </select> <label class=c-label ng-if=\"$ctrl.property.brand[type+'_font_type'] && $ctrl.property.brand[type+'_font_type'] === 'custom'\">Uploaded fonts</label> <label class=c-label ng-if=\"$ctrl.property.brand[type+'_font_type'] && $ctrl.property.brand[type+'_font_type'] === 'google'\">Google Fonts</label> <label class=c-label ng-if=\"$ctrl.property.brand[type+'_font_type'] && $ctrl.property.brand[type+'_font_type'] === 'typekit'\">Typekit Fonts</label> <p class=c-description ng-if=\"$ctrl.property.brand[type+'_font_type'] && $ctrl.property.brand[type+'_font_type'] === 'custom'\">Uploaded font files should be one of: WOFF, EOT, TTF or SVG.</p> <p class=c-description ng-if=\"$ctrl.property.brand[type+'_font_type'] && $ctrl.property.brand[type+'_font_type'] === 'typekit'\">You can add multiple typekit IDs seperated by commas (,).</p> <div class=row ng-if=\"$ctrl.property.brand[type+'_font_type']\"> <div class=\"columns medium-6\" ng-if=\"$ctrl.property.brand[type+'_font_type'] === 'google'\"> <div class=c-form__field> <input name={{type.charAt(0)}}fontt type=text class=c-form__input ng-model=\"$ctrl.property.brand[type+'_font_path']\" ng-required=\"type === 'body'\"> <label class=c-form__label for={{type.charAt(0)}}fontt><span class=c-form__capitalise ng-bind=type></span> Google Font, e.g. Alegreya</label> </div> </div> <div class=\"columns medium-6\" ng-if=\"$ctrl.property.brand[type+'_font_type'] === 'typekit'\"> <div class=c-form__field> <input name={{type.charAt(0)}}tkid type=text class=c-form__input ng-model=\"$ctrl.property.brand[type+'_font_settings']\" ng-required=\"type === 'body'\"> <label class=c-form__label for={{type.charAt(0)}}tkid><span class=c-form__capitalise ng-bind=type></span> Typekit ID</label> </div> </div> <div class=\"columns medium-6\" ng-if=\"$ctrl.property.brand[type+'_font_type'] === 'custom'\"> <div class=c-form__field> <file-upload name=hfont ng-model=\"$ctrl.property.brand[type+'_font']\" no-preview=true current-url=\"$ctrl.property.brand[type+'_font_url']\" ng-required=\"!$ctrl.property.brand[type+'_font_url'] && type === 'body'\" form-field-errors></file-upload> <p ng-bind=\"$ctrl.property.brand[type+'_font']\"></p> </div> <span ng-if=\"$ctrl.property.brand[type+'_font_url']\" ng-bind=\"'Font found: '+$ctrl.property.brand[type+'_font_url'].split('/').pop()\"></span> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name={{type.charAt(0)}}fontf type=text class=c-form__input ng-model=\"$ctrl.property.brand[type+'_font_family']\"> <label class=c-form__label for={{type.charAt(0)}}fontf><span class=c-form__capitalise ng-bind=type></span> Font Family names</label> </div> </div> </div> <hr> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Brand <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyFinanceController',
    template: __webpack_require__(641)
};

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <h2>{{ $ctrl.displayPaymentGatewayName() }}</h2> <div class=row ng-show=\"$ctrl.access.check('admin')\"> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--select\"> <select class=c-form__select name=gateway id=gateway ng-model=$ctrl.details.payment_gateway ng-init=\"$ctrl.details.payment_gateway = $ctrl.details.payment_gateway || 'stripe';\"> <option value=stripe>Stripe</option> <option value=paysafe>Paysafe</option> <option value=none>No gateway, manual payments</option> </select> <label class=c-form__label for=gateway>Payment Gateway</label> </div> </div> </div> <div class=row ng-if=\"$ctrl.details.payment_gateway === 'paysafe'\"> <div class=\"columns small-12\"> <h2>Paysafe details</h2> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=paysafe_username type=password class=\"c-form__input c-form__input--hasDescription\" ng-model=$ctrl.details.paysafe_username autocomplete=off form-field-errors/> <label class=c-form__label for=paysafe_username> Paysafe API User </label> </div> <p class=c-description> This is your API key username, found under Settings->API Keys in Paysafe. </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=paysafe_password type=password class=\"c-form__input c-form__input--hasDescription\" ng-model=$ctrl.details.paysafe_password autocomplete=off form-field-errors/> <label class=c-form__label for=paysafe_password> Paysafe API Password </label> </div> <p class=c-description> This is your API key password, found under Settings->API Keys in Paysafe (should be a long alphanumeric string, do not Base 64 encode this). </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=paysafe_account_id type=text class=\"c-form__input c-form__input--hasDescription\" ng-model=$ctrl.details.paysafe_account_id autocomplete=off form-field-errors/> <label class=c-form__label for=paysafe_account_id> Paysafe Account ID </label> </div> <p class=c-description> This is your account ID (should be numeric, e.g. 101173770) </p> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=paysafe_api_key type=text class=\"c-form__input c-form__input--hasDescription\" ng-model=$ctrl.details.paysafe_api_key autocomplete=off form-field-errors/> <label class=c-form__label for=paysafe_api_key> Paysafe API Key </label> </div> <p class=c-description> This needs to be a combination of your Single-Use Token User name and Password seperated by a colon (:) and Base 64 encoded. E.g. username:password (then Base 64 encoded). </p> </div> </div> <div class=row ng-if=\"$ctrl.access.check('admin') && $ctrl.details.payment_gateway === 'stripe'\"> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=commission ng-model=$ctrl.details.commission decorate=percentage form-field-errors></money-input> <label class=c-form__label for=commission> Percentage Service Fee </label> </div> </div> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=fee ng-model=$ctrl.details.fee decorate=currency form-field-errors></money-input> <label class=c-form__label for=fee> Monetary Service Fee </label> </div> </div> <div class=\"columns medium-12\"> <div class=c-form__field> <input name=country_code type=text class=\"c-form__input c-form__input--hasDescription\" ng-model=$ctrl.details.country_code autocomplete=off form-field-errors required/> <label class=c-form__label for=country_code> Stripe Account Country Code </label> </div> <p class=c-description> The two-letter country code of your Stripe account (e.g., GB). </p> </div> </div> <div class=row ng-if=\"$ctrl.details.payment_gateway === 'stripe' && !$ctrl.updating && !$ctrl.stripeTestEnv\"> <div class=\"columns medium-6 text-center\"> <a class=\"button tertiary round\" href=\"{{ $ctrl.connectRedirectUrl }}\" ng-if=\"!$ctrl.isConnected('stripe')\"> Connect Stripe account </a> <a class=\"button warning round\" ng-click=\"$ctrl.disconnectFromGateway('stripe')\" ng-if=\"$ctrl.isConnected('stripe')\"> Disconnect Stripe Account </a> </div> <div class=\"columns medium-6 text-center\"> <span ng-if=\"$ctrl.isConnected('stripe')\"> Connected: <strong>{{ $ctrl.details.stripe_user_id }}</strong> &nbsp; </span> </div> </div> <div class=row ng-if=\"!$ctrl.updating && $ctrl.stripeTestEnv\"> <div class=\"columns medium-6 text-center\"> <a class=\"button tertiary round\" ng-click=$ctrl.setDummyStripe()> Connect test Stripe account </a> </div> <div class=\"columns medium-6 text-center\"> <span ng-if=\"$ctrl.isConnected('stripe') && !$ctrl.notSaved\"> <strong>Connected to test account</strong> </span> <span ng-if=\"$ctrl.isConnected('stripe') && $ctrl.notSaved\"> <strong>Save to connect test account</strong> </span> </div> </div> <div class=\"row align-center\" ng-if=$ctrl.updating> <spinner large=true /> </div> <form-buttons ng-if=\"$ctrl.access.check('admin') || $ctrl.details.payment_gateway === 'paysafe'\"> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Update Financial Details <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyIntegrationFormController',
    template: __webpack_require__(643)
};

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <section ng-if=\"$ctrl.property.property_type === 'concept'\"> <div class=row ng-show=\"$ctrl.access.check('admin')\"> <div class=\"columns medium-12\"> <h2>Connection</h2> <p class=c-description> The last recorded version of the API for this property is: {{$ctrl.details.api_version}} </p> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=url type=text class=c-form__input ng-model=$ctrl.details.url form-field-errors required/> <label class=c-form__label for=url>Concept Connection Url</label> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=username type=text class=c-form__input ng-model=$ctrl.details.username form-field-errors required/> <label class=c-form__label for=username>Token</label> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=site type=text class=c-form__input ng-model=$ctrl.details.location form-field-errors required/> <label class=c-form__label for=site>Property ID</label> </div> </div> </div> </section> <section ng-if=\"$ctrl.property.property_type === 'premier'\"> <div class=row ng-show=\"$ctrl.access.check('admin')\"> <div class=\"columns medium-12\"> <h2>Connection</h2> <p class=c-description> The last recorded version of the API for this property is: {{$ctrl.details.api_version}} </p> <h3>Headers</h3> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=api_key type=text class=c-form__input ng-model=$ctrl.details.api_key form-field-errors required/> <label class=c-form__label for=api_key>Premier API Key</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=api_secret type=text class=c-form__input ng-model=$ctrl.details.api_secret form-field-errors required/> <label class=c-form__label>Premier API Secret</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=url type=text class=c-form__input ng-model=$ctrl.details.url form-field-errors required/> <label class=c-form__label for=url>Premier API Url</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=environment type=text class=c-form__input ng-model=$ctrl.details.environment form-field-errors required/> <label class=c-form__label>Premier Environment</label> </div> </div> </div> <div class=row ng-show=\"$ctrl.access.check('admin')\"> <div class=\"columns medium-12\"> <h3>Body</h3> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=hostname type=text class=c-form__input ng-model=$ctrl.details.hostname form-field-errors required/> <label class=c-form__label for=hostname>Premier Hostname</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=username type=text class=c-form__input ng-model=$ctrl.details.username form-field-errors required/> <label class=c-form__label for=username>Username</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=password type=text class=c-form__input ng-model=$ctrl.details.password form-field-errors required/> <label class=c-form__label for=password>Password</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=location type=text class=c-form__input ng-model=$ctrl.details.location form-field-errors required/> <label class=c-form__label for=location>Location ID</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=site type=text class=c-form__input ng-model=$ctrl.details.site form-field-errors required/> <label class=c-form__label for=site>Site ID</label> </div> </div> </div> <div class=row ng-show=\"$ctrl.access.check('admin')\"> <div class=\"columns medium-12\"> <hr/> <h2>Booking</h2> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=till type=text class=c-form__input ng-model=$ctrl.details.till_id form-field-errors required/> <label class=c-form__label for=till>Till ID</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=till type=text class=c-form__input ng-model=$ctrl.details.payment_method_id form-field-errors/> <label class=c-form__label for=till>Payment Method ID</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=discount type=text class=c-form__input ng-model=$ctrl.details.core_discount_code form-field-errors required/> <label class=c-form__label for=discount>Core Discount Code</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=commission ng-model=$ctrl.details.commission ng-disabled=\"$ctrl.access.check('superadmin')\" decorate=percentage form-field-errors required></money-input> <label class=c-form__label for=commission>Premier Commission</label> </div> </div> </div> <div class=row ng-show=\"$ctrl.access.check('admin')\"> <div class=\"columns medium-12\"> <hr/> <h2>Accounting Details</h2> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=expected_go_live type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors ng-disabled=$ctrl.details.go_live ng-model=$ctrl.details.expected_go_live moment-picker=$ctrl.details.expected_go_live keyboard=true format=YYYY-MM-DD min-view=month max-view=hour set-on-select=true autocomplete=off validate=true /> <label class=c-form__label>Expected Go Live Date</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=go_live type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors ng-disabled=$ctrl.details.go_live ng-model=$ctrl.details.go_live moment-picker=$ctrl.details.go_live keyboard=true format=YYYY-MM-DD min-view=month max-view=hour set-on-select=true autocomplete=off validate=true /> <label class=c-form__label>Integration Go Live Date</label> </div> </div> <div class=\"columns medium-3\"> <div class=c-form__field> <input name=account type=text class=c-form__input ng-model=$ctrl.details.account_code form-field-errors/> <label class=c-form__label>Premier Account Code</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=monek ng-model=$ctrl.details.monek_amount form-field-errors></money-input> <label class=c-form__label for=monek>Monek Amount</label> </div> </div> </div> <div class=row ng-show=\"$ctrl.access.check('admin')\"> <div class=\"columns medium-12\"> <hr/> <h2>Features</h2> </div> </div> <div class=\"row text-center\"> <div class=\"columns medium-4\"> <label for=allow_time_constraining class=c-label>Allow Time Constraining</label> <switch id=allow_time_constraining name=allow_time_constraining ng-model=$ctrl.details.allow_time_constraining class=green /> </div> <div class=\"columns medium-8\"> <p class=text-left> Enabling this setting will allow integrated arrival times to be constrained to only show specific times if available, instead of all times returned via the API. These constraints can be set per event in RevSpa (e.g. navigate to Treatments->Treatment->Arrival Times, and choose specific times). If this setting is enabled and no times are selected for an event, any times returned via the API will still be displayed. </p> </div> </div> <div class=row> <div class=\"columns medium-12\"> <hr/> <h2>Membership</h2> </div> </div> <div class=\"row text-center\"> <div class=\"columns medium-3\"> <label for=login_allowed class=c-label>Login Allowed</label> <switch id=login_allowed name=login_allowed ng-model=$ctrl.details.login_allowed class=green /> </div> <div class=\"columns medium-3\" ng-if=$ctrl.details.login_allowed> <label for=login_required class=c-label>Login Required</label> <switch id=login_required name=login_required ng-model=$ctrl.details.login_required class=green /> </div> <div class=\"columns medium-6\" ng-if=$ctrl.details.login_allowed> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=login_text class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.details.login_text form-field-errors></textarea> <label class=c-form__label for=login_text>Login Form Text</label> </div> </div> </div> </section> <div class=\"row text-center\"> <div class=\"columns medium-4\" ng-if=$ctrl.details.created_at> <button type=button class=\"button tertiary round\" ng-click=$ctrl.testIntegration() ng-disabled=$ctrl.saving> Test Integration </button> </div> <div class=\"columns medium-4\" ng-if=$ctrl.details.created_at> <button type=button class=\"button tertiary round\" ng-click=$ctrl.getVersion() ng-disabled=$ctrl.saving> Check Version </button> </div> <div class=\"columns medium-4\" ng-if=\"$ctrl.access.check('manager') && $ctrl.property.integration\"> <button type=button class=\"button tertiary round\" ng-click=$ctrl.runImport() ng-disabled=$ctrl.saving> Run Import </button> </div> </div> <h2 ng-if=$ctrl.logs>Import Issues</h2> <table ng-if=$ctrl.logs> <tr> <th ng-show=\"$ctrl.access.check('admin')\">Time</th> <th>Event</th> <th>Message</th> </tr> <tr ng-repeat=\"log in $ctrl.logs\"> <td ng-show=\"$ctrl.access.check('admin')\">{{log.created_at}}</td> <td>{{log.event}}</td> <td>{{log.message}}</td> </tr> </table> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Update Integration Details <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    propertyGroup: '=',
    properties: '<'
  },
  controller: 'propertyGroupFormController',
  template: __webpack_require__(645)
};

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.propertyGroup.name form-field-errors required> <label class=c-form__label for=name>Property Group Name</label> </div> <label class=\"c-label c-label--large\">Properties</label> <property-select ng-model=$ctrl.propertyGroup.group_properties></property-select> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Property <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: __webpack_require__(647)
};

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=name type=text class=c-form__input ng-model=$ctrl.details.business_name form-field-errors required> <label class=c-form__label for=name>Registered Business Name</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=phone type=text class=c-form__input ng-model=$ctrl.details.company_number form-field-errors> <label class=c-form__label for=phone>Registered Company Number</label> </div> </div> <div class=\"columns medium-12\"> <div class=c-form__field> <input name=address type=text class=c-form__input ng-model=$ctrl.details.address form-field-errors required> <label class=c-form__label for=address>Registered Business Address</label> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=vat type=text class=c-form__input ng-model=$ctrl.details.vat_number required form-field-errors> <label class=c-form__label for=vat>VAT Number</label> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=vat_rate ng-model=$ctrl.details.vat_rate decorate=percentage ng-disabled=\"!$ctrl.access.check('admin')\" form-field-errors></money-input> <label class=c-form__label for=vat_rate>VAT Rate</label> </div> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=accounts type=text class=c-form__input ng-model=$ctrl.details.accounts_name form-field-errors> <label class=c-form__label for=accounts>Accounts Contact Name</label> </div> </div> </div> <div class=row> <div class=\"columns medium-12\"> <h2>Analytics</h2> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=gaid type=text class=c-form__input ng-model=$ctrl.details.gaid form-field-errors> <label class=c-form__label for=gaid>Google Tag Manager ID</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=google_analytics type=text class=\"c-form__input c-form__input--hasDescription\" ng-model=$ctrl.details.google_analytics autocomplete=off form-field-errors> <label class=c-form__label for=google_analytics>Google Analytics ID</label> </div> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Update Business Details <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: __webpack_require__(649)
};

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <h2>Meta Data</h2> <p class=c-desciption>This information is used when your site is shared to social media.</p> <div class=row> <div class=\"columns medium-12\"> <div class=c-form__field> <input name=name type=text class=c-form__input ng-model=$ctrl.details.title form-field-errors> <label class=c-form__label for=name>Property Title</label> </div> </div> <div class=\"columns medium-12\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.details.description form-field-errors></textarea> <label class=c-form__label for=description_in>Property Description (should be less than 320 characters)</label> </div> </div> <div class=\"columns medium-12\"> <label class=\"c-label c-label--large\">Social fallback Image</label> <p class=c-description>Logo should be a JPG or PNG. If no appropriate image is avaiable for a shared page, this image will be used instead.</p> <file-upload name=picture ng-model=$ctrl.details.image accept=image/png,image/jpg current-url=$ctrl.details.image_url form-field-errors></file-upload> </div> </div> <h2>External Social Media Links</h2> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=phone type=url class=c-form__input ng-model=$ctrl.details.twitter form-field-errors> <label class=c-form__label for=phone>Twitter URL</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=phone type=url class=c-form__input ng-model=$ctrl.details.facebook form-field-errors> <label class=c-form__label for=phone>Facebook URL</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=phone type=url class=c-form__input ng-model=$ctrl.details.instagram form-field-errors> <label class=c-form__label for=phone>Instagram URL</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=phone type=url class=c-form__input ng-model=$ctrl.details.google form-field-errors> <label class=c-form__label for=phone>Google+ URL</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=phone type=url class=c-form__input ng-model=$ctrl.details.pinterest form-field-errors> <label class=c-form__label for=phone>Pinterest URL</label> </div> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Update Property Social <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: __webpack_require__(651)
};

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=row> <div class=\"columns medium-8\"> <div class=c-form__field> <input name=support_email type=email class=c-form__input ng-model=$ctrl.details.support_email form-field-errors required> <label class=c-form__label for=support_email>Support Email</label> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <label for=support_email_vis class=c-label--small>Email Storefront Visibility</label> <switch id=support_email_vis name=support_email_vis ng-model=$ctrl.details.support_email_visible class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-8\"> <div class=c-form__field> <input name=support_phone type=text class=c-form__input ng-model=$ctrl.details.support_phone form-field-errors required> <label class=c-form__label for=support_phone>Support Telephone</label> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <label for=support_phone_vis class=c-label--small>Phone Storefront Visibility</label> <switch id=support_phone_vis name=support_phone_vis ng-model=$ctrl.details.support_phone_visible class=green /> </div> </div> </div> <div class=row> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=notification_email type=email class=c-form__input ng-model=$ctrl.details.notification_email form-field-errors required> <label class=c-form__label for=notification_email>Admin Notification Email</label> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=notification_bcc type=text class=c-form__input ng-model=$ctrl.details.notification_bcc form-field-errors> <label class=c-form__label for=notification_bcc>Admin Notification BCC</label> <i class=\"c-icon c-icon--help\" tooltip=\"This is a comma separated list of additional e-mail addresses\" tooltip-placement=left>?</i> </div> </div> <div class=\"columns medium-4\"> <div class=c-form__field> <input name=website type=url class=c-form__input ng-model=$ctrl.details.website form-field-errors> <label class=c-form__label for=website>Main Website Address</label> </div> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Update Contact Details <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    property: '=',
    title: '@'
  },
  controller: 'propertySaveController',
  template: __webpack_require__(653)
};

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.property.id>{{ $ctrl.property.name }} {{($ctrl.property.group ? '('+$ctrl.property.group.group.name+')' : '')}}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'property' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'property'\" ng-if=\"$ctrl.access.check('manager')\"> Property </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'business' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'business'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('manager')\"> Business </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'contact' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'contact'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('manager')\"> Contact </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'finance' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'finance'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('manager')\"> Finance </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'integration' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'integration'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('manager')\"> Integration </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'brand' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'brand'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('manager')\"> Brand </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'social' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'social'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('manager')\"> Social </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'setting' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'setting'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('manager')\"> Settings </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'style' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'style'\" ng-if=\"$ctrl.property.id && $ctrl.access.check('admin')\"> Style </button> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'property' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-form property=$ctrl.property> </property-form></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'business' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-business type=business property=$ctrl.property form-tab=$ctrl.activeTab> </property-business></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'contact' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-contact type=contact property=$ctrl.property form-tab=$ctrl.activeTab> </property-contact></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'finance' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-finance-form type=finance property=$ctrl.property form-tab=$ctrl.activeTab> </property-finance-form></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'integration' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-integration-form type=integration property=$ctrl.property form-tab=$ctrl.activeTab> </property-integration-form></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'brand' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-brand-form property=$ctrl.property form-tab=$ctrl.activeTab> </property-brand-form></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'social' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-social type=social property=$ctrl.property form-tab=$ctrl.activeTab> </property-social></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'setting' && $ctrl.access.check('manager')\"> <div class=row> <div class=\"small-12 columns\"> <property-settings type=setting property=$ctrl.property form-tab=$ctrl.activeTab categories=$ctrl.categories> </property-settings></div> </div> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'style' && $ctrl.access.check('admin')\"> <div class=row> <div class=\"small-12 columns\"> <property-style type=style property=$ctrl.property form-tab=$ctrl.activeTab> </property-style></div> </div> </div> </div> </main> ";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    propertyGroup: '=',
    properties: '<',
    title: '@'
  },
  controller: 'propertyGroupSaveController',
  template: __webpack_require__(655)
};

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.property.id>{{ $ctrl.propertyGroup.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'profile' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'profile'\"> Property Group </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'profile'\"> <div class=\"small-12 columns\"> <property-group-form property-group=$ctrl.propertyGroup , properties=$ctrl.properties> </property-group-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    currentProperty: '<',
    properties: '<'
  },
  controller: 'propertySelectorController',
  template: __webpack_require__(657)
};

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "<span class=c-property-select> <span class=c-property-select__welcome> <span class=c-property-select__welcome__welcome>Welcome /&nbsp;</span><a target=_blank href=\"//{{$ctrl.property.slug}}.{{ $ctrl.configService.get('domain') }}\"><span class=c-property-select__property>{{ $ctrl.property.name }}</span></a> <a ng-if=\"$ctrl.access.check('admin')\" ui-sref=\"app.admin.property-edit({property: $ctrl.property.id})\"><span class=c-property-select__welcome__welcome>(EDIT)</span></a> </span> <div class=c-property-select__select2 ng-if=\"$ctrl.propertylist.length > 1\"> <ui-select ng-model=$ctrl.$rootScope.currentProperty.id on-select=\"$ctrl.onSelect($item, $modal)\" uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match> Switch Property </ui-select-match> <ui-select-choices repeat=\"property.id as property in $ctrl.propertylist | filter: { name: $select.search } track by $index\"> <div ng-bind-html=\"property.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <spinner ng-if=$ctrl.saving></spinner> </div> </span> ";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  require: {
    ngModel: 'ngModel'
  },
  controller: 'propertiesSelectController',
  template: __webpack_require__(659)
};

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "<ui-select multiple=multiple ng-model=$ctrl.value uis-open-close=$ctrl.updateViewValue(isOpen) on-remove=\"$ctrl.setValue($item, $model)\"> <ui-select-match placeholder=Properties> {{ $item.name }} </ui-select-match> <ui-select-choices repeat=\"property in $ctrl.properties | filter: $select.search track by property.id\"> <span ng-bind=property.name></span> </ui-select-choices> </ui-select> ";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  require: {
    ngModel: 'ngModel'
  },
  controller: 'propertySingleSelectController',
  template: __webpack_require__(661)
};

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "<div class=c-property-select> <div class=c-property-select__list ng-if=$ctrl.properties ng-model=$ctrl.property> <ui-select ng-model=$ctrl.property uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=\"Property Selector\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"property.id as property in $ctrl.properties | filter: { name: $select.search } track by $index\"> <div ng-bind-html=\"property.name | highlight: $select.search\"></div> <small>{{ property.pod.name.toUpperCase() }}</small> </ui-select-choices> </ui-select> </div> </div>";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    propertylist: '<'
  },
  controller: 'propertySelectController',
  template: __webpack_require__(663)
};

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "<hr> <div class=c-single-select> <div class=c-single-select__list ng-if=$ctrl.properties ng-model=$ctrl.properties> <div class=\"row c-single-select__row\" ng-repeat=\"(key, property) in $ctrl.properties\"> <div class=\"column medium-10\"> <ui-select required ng-model=$ctrl.properties[key].property_id uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=Property> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"property.id as property in $ctrl.propertylist | filter: { name: $select.search } track by $index\" ui-disable-choice=$ctrl.disableProperty(property.id)> <div ng-bind-html=\"property.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> <div class=\"column medium-2\"> <a class=c-single-select__delete ng-click=$ctrl.delete(key)>&times;</a> </div> </div> </div> <a ng-click=$ctrl.properties.push({}) class=c-single-select__add><span class=icon>+</span> <span>Add new property</span></a> </div> ";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    code: '<',
    id: '<'
  },
  controller: 'paymentConnectController',
  template: __webpack_require__(665)
};

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "<div class=\"alert alert--info\" ng-if=!$ctrl.response> <p>Attempting to connect your Stripe account!</p> </div> <div ng-if=$ctrl.response class=\"alert alert--success\" ng-class=\"{ 'alert--fail' : $ctrl.error }\"> <p ng-bind=$ctrl.response></p> </div> <div class=\"row align-center\"> <a class=\"button button--large round\" ui-sref=\"app.admin.property-edit({property: $ctrl.id})\">Return to Property</a> </div>";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = '/api/properties';
var brandendpoint = function brandendpoint(property) {
  return '/api/' + property.id + '/brand' + (property.brand.id ? '/' + property.brand.id : '');
};

exports.default = ['api', function (api) {
  return {
    save: function save(property) {
      var url = property.id ? endpoint + '/' + property.id : endpoint;

      return api.upload(url, property).then(function (response) {
        return response.data;
      });
    },
    saveBrand: function saveBrand(property) {
      return api.upload(brandendpoint(property), property.brand).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint + '/' + id).then(function (response) {
        return response.data;
      }).catch(function (error) {
        // Presume this has failed due to access rights
        window.location = '/403';
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    },
    updateDetails: function updateDetails(data, id, type) {
      var dispatch = {
        'property_id': id,
        'data': data
      };

      return api.upload(endpoint + '/' + type + '/' + id, dispatch).then(function (response) {
        return response.data;
      });
    },
    import: function _import(csv) {
      return api.upload(endpoint + '/import', { file: csv }).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = '/api/properties/integration';

exports.default = ['api', 'currentPropertyService', function (api, currentPropertyService) {
    var integration = {};

    integration.logsEndpoint = function (propertyId, type) {
        return '/api/properties/' + propertyId + '/logs?source=' + type + '&type=Import';
    };
    integration.statusEndpoint = function (propertyId, type) {
        return '/api/' + propertyId + '/integration/status?type=' + type;
    };

    integration.testIntegration = function (propertyId) {
        return api.get(endpoint + '/' + propertyId + '/test').then(function (response) {
            return response.data;
        });
    };

    integration.getVersion = function (propertyId) {
        return api.get(endpoint + '/' + propertyId + '/version').then(function (response) {
            return response.data;
        });
    };

    integration.integrationImport = function (propertyId) {
        return api.get(endpoint + '/' + propertyId + '/import').then(function (response) {
            return response.data;
        }).catch(function () {
            //Integration not established
        });
    };

    integration.integrationTreatmentCollect = function (propertyId) {
        if (!integration.treatments) {
            return api.get(endpoint + '/' + propertyId + '/treatments').then(function (response) {
                integration.treatments = response.data;
                return response.data;
            }).catch(function () {
                //Integration not established
            });
        }

        return Promise.resolve(integration.treatments);
    };

    integration.integrationPackageCollect = function (propertyId) {
        if (!integration.spadays) {
            return api.get(endpoint + '/' + propertyId + '/spadays').then(function (response) {
                integration.spadays = response.data;
                return response.data;
            }).catch(function () {
                //Integration not established
            });
        }

        return Promise.resolve(integration.spadays);
    };

    integration.integrationSinglePackageCollect = function (propertyId, packageId) {
        if (!integration[packageId]) {
            return api.get(endpoint + '/' + propertyId + '/spadays/' + packageId).then(function (response) {
                integration[packageId] = response.data;
                return response.data;
            }).catch(function () {
                //Integration not established
            });
        }

        return Promise.resolve(integration[packageId]);
    };

    integration.integrationActivityCollect = function (propertyId) {
        if (!integration.activities) {
            return api.get(endpoint + '/' + propertyId + '/activities').then(function (response) {
                integration.activities = response.data;
                return response.data;
            }).catch(function () {
                //Integration not established
            });
        }

        return Promise.resolve(integration.activities);
    };

    integration.integrationExtraCollect = function (propertyId) {
        if (!integration.extras) {
            return api.get(endpoint + '/' + propertyId + '/extras').then(function (response) {
                integration.extras = response.data;
                return response.data;
            }).catch(function () {
                //Integration not established
            });
        }

        return Promise.resolve(integration.extras);
    };

    integration.getImportLogs = function (propertyId, type) {
        return api.get(integration.logsEndpoint(propertyId, type)).then(function (response) {
            return response.data;
        });
    };

    integration.getIntegrationStatus = function (type) {
        return api.get(integration.statusEndpoint(currentPropertyService.get().id, type)).then(function (response) {
            return response.data;
        });
    };

    integration.setEmailPasswords = function (csv) {
        return api.upload(endpoint + '/' + api.property() + '/importUsers', csv).then(function (response) {
            return response.data;
        });
    };

    integration.uploadContracts = function (csv) {
        return api.upload(endpoint + '/uploadContracts', csv).then(function (response) {
            return response.data;
        });
    };

    return integration;
}];

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$rootScope', 'access', function ($rootScope, access) {
    var hasIntegration = function hasIntegration() {
        return !!($rootScope.currentProperty && $rootScope.currentProperty.integration) && !access.check('admin');
    };

    var hasLinkedIntegration = function hasLinkedIntegration() {
        return !!($rootScope.currentProperty && $rootScope.currentProperty.integration);
    };

    var isNonRevspa = function isNonRevspa() {
        return !!($rootScope.currentProperty && $rootScope.currentProperty.property_type);
    };

    return {
        hasIntegration: hasIntegration,
        hasLinkedIntegration: hasLinkedIntegration,
        isNonRevspa: isNonRevspa
    };
}];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = '/api/properties';

exports.default = ['api', function (api) {
  return {
    save: function save(property) {
      var url = property.id ? endpoint + '/' + property.id : endpoint;

      return api.upload(url, property).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint + '/' + id).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = '/api/properties/groups';

exports.default = ['api', function (api) {
  return {
    save: function save(group) {
      var url = group.id ? endpoint + '/' + group.id : endpoint;

      return api.upload(url, group).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint + '/' + id).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$rootScope', '$stateParams', '$state', 'propertiesService', 'encryptService', function ($rootScope, $stateParams, $state, propertiesService, encryptService) {
    var properties = {};

    properties.list = undefined;

    properties.load = function () {
        return propertiesService.findAll(-1).then(function (response) {
            return properties.list = response;
        });
    };

    properties.find = function () {
        return new Promise(function (resolve, reject) {
            if (!properties.list) {
                return properties.load().then(function () {
                    if (!$rootScope.currentProperty) {
                        var propertyId = 0;
                        var propertyExists = {};

                        var storedProperty = localStorage.getItem('property');

                        if (!storedProperty || storedProperty && storedProperty.length <= 3) {

                            if (properties.list.length > 0) {
                                propertyExists = find(properties.list, { id: parseInt(propertyId) });
                                if (!propertyExists) {
                                    propertyId = properties.list[0].id;
                                }
                            }

                            if (propertyId) {
                                // Encrypt and set hotelId
                                return encryptService.encrypt(propertyId.toString()).then(function (encrypted) {
                                    localStorage.setItem('property', encrypted.data);
                                    return propertiesService.findById(propertyId).then(function (response) {
                                        $rootScope.currentProperty = response;
                                        resolve();
                                    });
                                });
                            }
                        } else if (storedProperty) {
                            return encryptService.decrypt(storedProperty.toString()).then(function (decrypted) {
                                propertyId = parseInt(decrypted.data.join(''), 10);

                                propertyExists = find(properties.list, { id: parseInt(propertyId) });

                                if (properties.length > 0 && !propertyExists) {
                                    propertyId = properties.list[0].id;
                                }

                                if (propertyId) {
                                    // Encrypt and set hotelId
                                    return encryptService.encrypt(propertyId.toString()).then(function (encrypted) {
                                        localStorage.setItem('property', encrypted.data);
                                        return propertiesService.findById(propertyId).then(function (response) {
                                            $rootScope.currentProperty = response;
                                            resolve();
                                        });
                                    });
                                }
                            });
                        }
                        reject();
                    } else {
                        resolve();
                    }
                });
            }
        });
    };

    return properties;
}];

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$rootScope', function ($rootScope) {
    var property = void 0;

    var get = function get(param) {
        if (!property) {
            property = $rootScope.currentProperty;
        }

        return getParameter(param);
    };

    var getParameter = function getParameter(param) {
        switch (param) {
            case 'loadStaff':
                return !!(property.setting && property.setting.core && property.setting.core.load_staff);
            case 'hasIntegration':
                return !!property.integration;
        }

        return property[param];
    };

    return {
        get: get
    };
}];

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _treatment = __webpack_require__(674);

var _treatment2 = _interopRequireDefault(_treatment);

var _treatmentSave = __webpack_require__(675);

var _treatmentSave2 = _interopRequireDefault(_treatmentSave);

var _treatmentForm = __webpack_require__(676);

var _treatmentForm2 = _interopRequireDefault(_treatmentForm);

var _treatmentList = __webpack_require__(677);

var _treatmentList2 = _interopRequireDefault(_treatmentList);

var _treatmentsSelect = __webpack_require__(678);

var _treatmentsSelect2 = _interopRequireDefault(_treatmentsSelect);

var _treatmentSingleSelect = __webpack_require__(679);

var _treatmentSingleSelect2 = _interopRequireDefault(_treatmentSingleSelect);

var _treatmentList3 = __webpack_require__(680);

var _treatmentList4 = _interopRequireDefault(_treatmentList3);

var _treatmentForm3 = __webpack_require__(682);

var _treatmentForm4 = _interopRequireDefault(_treatmentForm3);

var _treatmentSave3 = __webpack_require__(684);

var _treatmentSave4 = _interopRequireDefault(_treatmentSave3);

var _treatmentsSelect3 = __webpack_require__(686);

var _treatmentsSelect4 = _interopRequireDefault(_treatmentsSelect3);

var _treatmentSingleSelect3 = __webpack_require__(688);

var _treatmentSingleSelect4 = _interopRequireDefault(_treatmentSingleSelect3);

var _treatments = __webpack_require__(690);

var _treatments2 = _interopRequireDefault(_treatments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var treatmentModule = angular.module('spabooker.treatment', ['spabooker.base']).config(_treatment2.default).controller('treatmentSaveController', _treatmentSave2.default).controller('treatmentFormController', _treatmentForm2.default).controller('treatmentListController', _treatmentList2.default).controller('treatmentsSelectController', _treatmentsSelect2.default).controller('treatmentSingleSelectController', _treatmentSingleSelect2.default).component('treatmentList', _treatmentList4.default).component('treatmentForm', _treatmentForm4.default).component('treatmentSave', _treatmentSave4.default).component('treatmentsSelect', _treatmentsSelect4.default).component('treatmentSingleSelect', _treatmentSingleSelect4.default).factory('treatmentsService', _treatments2.default);

exports.default = treatmentModule.name;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _treatments = __webpack_require__(326);

var _categories = __webpack_require__(22);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.treatments', {
        url: '/events/treatments?:filtertext',
        component: 'treatmentList',
        resolve: {
            treatments: (0, _treatments.resolveTreatments)(),
            categories: (0, _categories.resolveNestedCategories)('flatten')
        },
        roles: ['manager']
    }).state('app.admin.deletedtreatments', {
        url: '/events/treatments/deleted',
        component: 'treatmentList',
        resolve: {
            treatments: (0, _treatments.resolveTreatments)(1, 20, 'deleted')
        },
        roles: ['admin']
    }).state('app.admin.treatment-add', {
        url: '/events/treatments/create',
        component: 'treatmentSave',
        resolve: {
            title: function title() {
                return 'Create a Treatment';
            },
            treatment: (0, _treatments.resolveTreatment)()
        },
        roles: ['manager']
    }).state('app.admin.treatment-edit', {
        url: '/events/treatments/:treatment/update?tab',
        component: 'treatmentSave',
        resolve: {
            title: function title() {
                return 'Update a Treatment';
            },
            treatment: (0, _treatments.resolveTreatment)()
        },
        roles: ['manager']
    });
}];

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreatmentSaveController = function () {
    function TreatmentSaveController($rootScope, $stateParams, access, integrationService, currentPropertyService) {
        _classCallCheck(this, TreatmentSaveController);

        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
        this.integrationService = integrationService;
        this.currentProperty = currentPropertyService;
    }

    _createClass(TreatmentSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = this.$stateParams.tab || 'treatment';
        }
    }, {
        key: 'canShow',
        value: function canShow() {
            var integration = this.currentProperty.get('integration');
            return !!this.treatment.id && (this.access.check('manager') || integration && integration.allow_time_constraining);
        }
    }]);

    return TreatmentSaveController;
}();

TreatmentSaveController.$inject = ['$rootScope', '$stateParams', 'access', 'integrationService', 'currentPropertyService'];

exports.default = TreatmentSaveController;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreatmentFormController = function () {
    function TreatmentFormController($rootScope, $scope, $state, treatmentsService, integrationApiService, messageService, markdownService, configService, access) {
        _classCallCheck(this, TreatmentFormController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.integrationApiService = integrationApiService;
        this.treatmentsService = treatmentsService;
        this.messageService = messageService;
        this.marked = markdownService;
        this.configService = configService;
        this.access = access;
    }

    _createClass(TreatmentFormController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.treatment.track_quantity === undefined) {
                this.treatment.track_quantity = this.$rootScope.currentProperty.track_quantity;
            }
            this.treatment = this.treatment || {
                description: ''
            };
            this.isAdmin = this.access.check('admin');
            this.treatment.selectedcategories = this.treatment.categories || [];
            this.treatment.property_id = this.treatment.property_id || this.$rootScope.currentProperty.id;
            this.currentPropertyName = this.$rootScope.currentProperty.name;
            this.currencySymbol = this.$rootScope.currentProperty.currency_symbol;
            this.treatment.event_status_id = this.treatment.event_status_id ? this.treatment.event_status_id.toString() : '0';
            this.hasIntegration = !!this.$rootScope.currentProperty.integration;
            if (this.hasIntegration) {
                this.integrationApiService.integrationTreatmentCollect(this.$rootScope.currentProperty.id).then(function (response) {

                    _this.importedTreatments = response.map(function (treatment) {
                        if (treatment.integration_location) {
                            treatment.name = treatment.name + ' @ ' + treatment.integration_location_name;
                        }
                        return treatment;
                    });
                });
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this2 = this;

            if (!(0, _lodash.find)(this.treatment.selectedcategories, { id: this.treatment.primary_category })) {
                this.messageService.failure('You must select at least 1 category and set a primary category to continue');
                this.messageService.push();
                this.saving = undefined;
                return Promise.reject({});
            }

            this.messageService.reset();

            this.treatment.categories = (0, _lodash.map)(this.treatment.selectedcategories, 'id');

            var tempCats = this.treatment.selectedcategories;
            var tempPrimaryCat = this.treatment.primary_category;
            delete this.treatment.selectedcategories;

            delete this.treatment.extras;
            delete this.treatment.options;
            delete this.treatment.related;
            delete this.treatment.times;
            delete this.treatment.upgrades;
            delete this.treatment.days;

            return this.treatmentsService.save(this.treatment).then(function (response) {
                if (_this2.treatment.id) {
                    _this2.messageService.success('The treatment <strong>' + _this2.treatment.name + '</strong> was successfully updated!', ['app.admin.treatment-edit({ \'treatment\' : ' + _this2.treatment.id + '})', 'Treatment']);
                    _this2.$state.go('app.admin.treatments');
                } else {
                    _this2.treatment.selectedcategories = tempCats;
                    _this2.treatment.primary_category = tempPrimaryCat;
                    _this2.messageService.success('The Treatment <strong>' + _this2.treatment.name + '</strong> was successfully created. Please edit the start times.');
                    _this2.$state.go('app.admin.treatment-edit', { treatment: response.id, tab: 'times' });
                }
            }).catch(function (error) {
                error.data = error.data.original || error.data;
                _this2.form.$api.setErrors(error.data);

                _this2.treatment.selectedcategories = tempCats;
                _this2.treatment.primary_category = tempPrimaryCat;

                var sourceElement = Object.keys(error.data);
                var verb = 'created';
                if (_this2.treatment.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    var errors = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var element = _step.value;

                            errors += '<li>' + _this2.messageService.formatError(element, error.data[element]) + '</li>';
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.messageService.failure('The Treatment <strong>' + _this2.treatment.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
                } else {
                    _this2.messageService.failure('The Treatment <strong>' + _this2.treatment.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
                }
                _this2.messageService.push();
            });
        }
    }, {
        key: 'initialSlug',
        value: function initialSlug() {
            if (!this.treatment.id && this.$scope.$ctrl.form.slug.$untouched) {
                this.treatment.slug = this.treatment.name ? this.treatment.name.replace(/[^a-zA-Z\d\s]+/g, '').replace(/[ ]+/g, '-').replace(/--+/g, '-').toLowerCase() : '';
            }
        }
    }]);

    return TreatmentFormController;
}();

TreatmentFormController.$inject = ['$rootScope', '$scope', '$state', 'treatmentsService', 'integrationApiService', 'messageService', 'markdownService', 'configService', 'access'];

exports.default = TreatmentFormController;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreatmentListController = function () {
    function TreatmentListController($rootScope, $stateParams, $scope, $state, $timeout, treatmentsService, messageService, access, configService) {
        _classCallCheck(this, TreatmentListController);

        this.$scope = $scope;
        this.$state = $state;
        this.treatmentsService = treatmentsService;
        this.messageService = messageService;
        this.access = access;
        this.configService = configService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        $scope.treeOptions = {
            dropped: function dropped(sourceNodeScope) {
                $timeout(function () {
                    return sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure();
                });
            }
        };
    }

    _createClass(TreatmentListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.filtertext = this.$stateParams.filtertext || null;
            if (this.filtertext) {
                this.isFiltered = true;
            }

            if (this.treatments) {
                this.activeTab = 'list';
            }

            this.updatePaging();
            this.$scope.$watch(function (scope) {
                return scope.current_page;
            }, function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.treatments = undefined;
                        scope.$ctrl.treatmentsService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
                            scope.$ctrl.treatments = response;
                            scope.$ctrl.loading = false;
                        });
                    } else {
                        scope.$ctrl.treatmentsService.findAll(newVal, scope.per_page).then(function (list) {
                            return scope.$ctrl.treatments = list;
                        });
                    }
                }
            });
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            this.$scope.per_page = this.treatments.per_page;
            this.$scope.current_page = this.treatments.current_page;
            this.$scope.total = this.treatments.total;
        }
    }, {
        key: 'onDelete',
        value: function onDelete(treatment) {
            var _this = this;

            return this.treatmentsService.delete(treatment.id).then(function () {
                _this.messageService.success('The treatment <strong>' + treatment.name + '</strong> was successfully deleted.');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure('The treatment <strong>' + treatment.name + '</strong> could not be successfully deleted: ' + error.statusText);
                _this.messageService.push();
            }).then(function () {
                var page = _this.treatments.current_page;
                _this.treatments = [];
                _this.loading = true;
                return _this.treatmentsService.findAll(page).then(function (response) {
                    _this.treatments = response;
                    _this.loading = false;
                });
            });
        }
    }, {
        key: 'saveStructure',
        value: function saveStructure() {
            var _this2 = this;

            this.treatmentsService.reconstruct((0, _lodash.map)(this.treatments.tree, 'id')).then(function () {
                _this2.messageService.success('This event order has been successfully saved.');
                _this2.messageService.push();
                _this2.messageService.autoClear();
            }).catch(function () {
                _this2.messageService.failure('This event order could not be successfully saved: ' + error.statusText);
                _this2.messageService.push();
            });
        }
    }, {
        key: 'toggleActive',
        value: function toggleActive(treatment) {
            var _this3 = this;

            this.treatmentsService.toggleActive(treatment.id).catch(function (error) {
                _this3.messageService.failure('The treatment <strong>' + treatment.name + '</strong> could not be successfully toggled (active): ' + error.statusText);
                _this3.messageService.push();
            }).then(function () {
                return treatment.status = !treatment.status;
            });
        }
    }, {
        key: 'toggleVisible',
        value: function toggleVisible(treatment) {
            var _this4 = this;

            this.treatmentsService.toggleVisible(treatment.id).catch(function (error) {
                _this4.messageService.failure('The treatment <strong>' + treatment.name + '</strong> could not be successfully toggled (visibility): ' + error.statusText);
                _this4.messageService.push();
            }).then(function () {
                return treatment.secret = !treatment.secret;
            });
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this5 = this;

            if (!this.loading && this.filtertext) {
                this.startFilter();
                this.treatmentsService.search(this.filtertype, this.filtertext).then(function (response) {
                    _this5.isFiltered = true;
                    _this5.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this6 = this;

            if (this.isFiltered) {
                this.startFilter();
                this.treatmentsService.findAll(1, 20).then(function (response) {
                    _this6.isFiltered = false;
                    _this6.endFilter(response);
                });
            }
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            switch (this.filtertype) {
                case 'cat':
                    this.filtertext = this.categories.flat[0].id;
                    break;
                case 'status':
                    this.filtertext = '1';
                    break;
                case 'secret':
                    this.filtertext = '0';
                    break;
                default:
                    this.filtertext = '';
                    break;
            }
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this.treatments = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this.treatments = response;
            this.updatePaging();
            this.loading = false;
        }
    }, {
        key: 'updatePriority',
        value: function updatePriority(event) {
            if (!event || event.priority === '' || event.priority > 999 || event.priority === undefined) {
                return false;
            }
            this.updateWait(event);
        }
    }, {
        key: 'updateWait',
        value: function updateWait(item) {
            var _this7 = this;

            if (item.priority.match(/[^0-9]+/g)) return;
            item.updating = false;
            clearTimeout(item.trigger);
            item.trigger = setTimeout(function () {
                _this7.trigger(item);
            }, 1000);
        }
    }, {
        key: 'update',
        value: function update(item) {
            this.trigger(item);
        }
    }, {
        key: 'trigger',
        value: function trigger(item) {
            item.trigger = undefined;
            item.updating = true;

            this.treatmentsService.updatePriority(item).then(function () {
                item.updating = false;
            });
        }
    }]);

    return TreatmentListController;
}();

TreatmentListController.$inject = ['$rootScope', '$stateParams', '$scope', '$state', '$timeout', 'treatmentsService', 'messageService', 'access', 'configService'];

exports.default = TreatmentListController;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreatmentsSelectController = function () {
    function TreatmentsSelectController(treatmentsService, messageService) {
        _classCallCheck(this, TreatmentsSelectController);

        this.treatmentsService = treatmentsService;
        this.messageService = messageService;
    }

    _createClass(TreatmentsSelectController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.placeholder = this.placeholder || 'Treatments';
            this.value = this.value || [];
            this.treatmentsService.findAll(-1).then(function (treatments) {
                _this.treatments = treatments;
                if (_this.value.length) {
                    for (var i in _this.value) {
                        _this.value[i] = (0, _lodash.find)(_this.treatments, { 'id': _this.value[i].treatment_id });
                    }
                }
            }).catch(function (errors) {
                _this.messageService.failure(errors);
                _this.messageService.push();
            });
        }
    }]);

    return TreatmentsSelectController;
}();

TreatmentsSelectController.$inject = ['treatmentsService', 'messageService'];

exports.default = TreatmentsSelectController;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreatmentSingleSelectController = function () {
  function TreatmentSingleSelectController(treatmentsService) {
    _classCallCheck(this, TreatmentSingleSelectController);

    this.treatmentsService = treatmentsService;
  }

  _createClass(TreatmentSingleSelectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (!this.treatments) {
        this.treatmentsService.findAll(-1).then(function (result) {
          _this.treatments = result;
          _this.treatments.unshift({ id: '', name: 'None', category: 'Select no Treatment' });
        });
      }
    }
  }]);

  return TreatmentSingleSelectController;
}();

TreatmentSingleSelectController.$inject = ['treatmentsService'];

exports.default = TreatmentSingleSelectController;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        treatments: '<',
        categories: '<'
    },
    controller: 'treatmentListController',
    template: __webpack_require__(681)
};

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Treatments</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.treatment-add class=c-button--action> <icon icon=treatment></icon> Create a Treatment </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.treatments class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedtreatments class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <message closable=true></message> <div class=c-tabs> <div class=c-tabs__content> <div class=row> <div class=\"columns c-list__tab-inner\"> <form class=\"row c-list__search c-list__search--tab c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=cat>Categories</option> <option value=name>Name</option> <option value=status>Status</option> <option value=vis>Visibility</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'cat'\" ng-options=\"category.id as category.name for category in $ctrl.categories.flat\"> </select> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'vis'\"> <option value=0>Public</option> <option value=1>Private</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.treatments.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No treatments have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No treatments match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.treatments.data.length > 0\"> <thead> <tr> <th class=c-table__lights></th> <th>Name</th> <th class=c-table__cats>Priority</th> <th class=c-table__cats>Category</th> <th>Visibility</th> <th></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"treatment in $ctrl.treatments.data\" class=\"c-list {{ treatment.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-table__lights ng-click=\"$ctrl.access.check('manager') && $ctrl.toggleActive(treatment)\"> <span ng-class=\"(treatment.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (treatment.status)? 'This treatment is active' : 'This treatment is not active' }}\"></span> </td> <td>{{ treatment.name }}</td> <td class=c-table__inline-input> <span tooltip=\"The priority of this event will be updated automatically when changed\"> <input ng-model=treatment.priority type=text maxlength=3 ng-disabled=treatment.updating ng-change=$ctrl.updatePriority(treatment)> </span> <spinner tiny=true ng-if=treatment.updating /> </td> <td class=c-table__cats><span tooltip=\"{{ (treatment.category_names.length) ? treatment.category_names.join(', ') : null }}\">{{ treatment.primary_category_name || 'No Primary' }}</span></td> <td class=c-table__lights ng-click=\"$ctrl.access.check('manager') && $ctrl.toggleVisible(treatment)\"> <span ng-if=treatment.secret tooltip=\"This treatment is only available via direct URL\">Private</span> <span ng-if=!treatment.secret tooltip=\"This treatment is available in public listings\">Public</span> </td> <td class=c-list__action> <a ng-if=!treatment.status href=\"//{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/treatment/{{ treatment.slug }}?preview=true\" target=_blank>Preview</a> <a ng-if=treatment.status href=\"//{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/treatment/{{ treatment.slug }}\" target=_blank>View</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.treatment-edit({ treatment: treatment.id })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(treatment) confirm=\"Are you sure you want to delete {{ treatment.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </div> </main> ";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    treatment: '=',
    formTab: '=',
    activeDay: '&'
  },
  controller: 'treatmentFormController',
  template: __webpack_require__(683)
};

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.treatment.name form-field-errors required ng-change=$ctrl.initialSlug()> <label class=c-form__label for=name>Name</label> </div> <div class=c-form__url> <label class=c-form__url__label> https://{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/treatment/ </label> <div class=c-form__url__field> <input name=slug type=text class=inline ng-model=$ctrl.treatment.slug form-field-errors required ng-pattern=/^[a-zA-Z0-9-]+$/ > </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.treatment.description form-field-errors></textarea> <label class=c-form__label for=description_in>Description</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.treatment.description name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.treatment.description)></div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <label class=\"c-label c-label--large\">Image</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.treatment.image accept=image/jpeg,image/png current-url=$ctrl.treatment.own_image_url form-field-errors></file-upload> </div> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=base_price ng-model=$ctrl.treatment.base_price form-field-errors></money-input> <label class=c-form__label for=base_price>Price (base)</label> </div> <div class=c-form__field> <input name=duration type=number class=c-form__input ng-model=$ctrl.treatment.duration form-field-errors required ng-disabled=$ctrl.hasIntegration> <label class=c-form__label for=duration>Treatment Duration (mins)</label> </div> <div class=c-form__field ng-if=$ctrl.hasIntegration> <input name=duration type=number class=c-form__input ng-model=$ctrl.treatment.display_duration form-field-errors> <label class=c-form__label for=duration>Display Duration (mins)</label> </div> <div class=c-form__field> <input name=minimum_guests type=number class=c-form__input ng-model=$ctrl.treatment.minimum_guests form-field-errors min=1> <label class=c-form__label for=minimum_guests>Minimum Guests</label> </div> <div class=c-form__field> <input name=maximum_guests type=number class=c-form__input ng-model=$ctrl.treatment.maximum_guests form-field-errors min={{$ctrl.treatment.minimum_guests}}> <label class=c-form__label for=maximum_guests>Maximum Guests</label> </div> </div> </div> <div class=row> <div class=\"column medium-8\"> <label for=categories class=c-label>Categories</label> <categories-select name=categories value=$ctrl.treatment.selectedcategories></categories-select> </div> <div class=\"column medium-4\"> <div class=c-form__field> <label for=primary_category class=c-label>Primary Category</label> <select ng-model=$ctrl.treatment.primary_category ng-options=\"category.id as category.name for category in $ctrl.treatment.selectedcategories\" required parent-select class=c-form__select> <option value=\"\" disabled=disabled>Please select a category...</option> </select> </div> </div> </div> <div class=row> <div class=\"columns medium-4\"> <label for=special_status class=c-label>Special Status</label> <label class=c-label for=special_status> <select name=special_status ng-init=\"$ctrl.treatment.event_status_id = $ctrl.treatment.event_status_id.toString() || ''\" ng-model=$ctrl.treatment.event_status_id> <option value=0> None </option> <option value=1> Phone booking only </option> <option value=2> Online only </option> </select> </label> </div> <div class=\"columns medium-4\"> <label for=gender class=c-label>Guest Gender</label> <label class=c-label for=gender> <select name=gender ng-model=$ctrl.treatment.gender> <option value=\"\"> Any </option> <option value=M> Male only </option> <option value=F> Female only </option> </select> </label> </div> <div class=\"columns medium-4\"> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear integration link\" tooltip-placement=left ng-click=\"$ctrl.treatment.integration_identity = null\" ng-if=\"$ctrl.hasIntegration && $ctrl.isAdmin\">&times;</span> <label for=integration class=c-label>Integration Event</label> <ui-select ng-model=$ctrl.treatment.integration_identity name=integration form-field-errors ng-disabled=\"!$ctrl.hasIntegration || ($ctrl.hasIntegration && !$ctrl.isAdmin)\"> <ui-select-match placeholder=\"Integration ID\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.integration_identity.toString() as item in $ctrl.importedTreatments | filter: {name: $select.search} track by item.integration_identity+item.name\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> </div> <div class=c-form__field> <textarea name=description_in class=c-form__textarea type=text ng-model=$ctrl.treatment.terms form-field-errors></textarea> <label class=c-form__label for=description_in>Terms &amp; Conditions</label> </div> <p class=c-description>These terms will override the default terms set on the primary category.</p> <hr> <div class=row ng-if=!$ctrl.hasIntegration> <div class=\"column medium-8\"> <label for=track_quantity class=c-label>Track Quantity</label> <p class=c-description>If enabled, this treatment will automatically decrease the available quantity as it is purchased.</p> <switch id=track_quantity name=track_quantity ng-model=$ctrl.treatment.track_quantity class=green></switch> </div> <div class=\"column medium-4\"> <label for=base_quantity class=c-label>Quantity</label> <div class=c-form__field> <input name=base_quantity type=number class=c-form__input ng-model=$ctrl.treatment.base_quantity form-field-errors> <label class=c-form__label for=base_quantity>Base Quantity per Day</label> </div> </div> </div> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this treatment will be active and accessible on the website. If the toggle is not enabled this treatment will not be accessible to the public at all.</p> <switch id=status name=status ng-model=$ctrl.treatment.status class=green></switch> <label for=secret class=c-label>Secret</label> <p class=c-description>If enabled, this treatment will only be accessible via a direct URL, it will not show in public listings. Relies on the above status being enabled.</p> <p>Direct URL: https://{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/treatment/{{ $ctrl.treatment.slug }}</p> <switch id=secret name=secret ng-model=$ctrl.treatment.secret class=green></switch> <div class=c-preview ng-if=\"!$ctrl.treatment.own_image_url && !$ctrl.treatment.image\"> <hr> <h4 style=color:red> You have not selected an image for this event, it will use the following fallback image. </h4> <img class=c-preview__thumbnail ng-src=\"{{ $ctrl.treatment.image_url }}\"> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Treatment <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    treatment: '=',
    title: '@'
  },
  controller: 'treatmentSaveController',
  template: __webpack_require__(685)
};

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help-area> <button class=c-help-area__button ng-click=\"$ctrl.help = !$ctrl.help;\"> <span class=c-help-area__button-icon>?</span> Help </button> <div class=\"c-help-area__content {{$ctrl.help ? 'open': ''}}\"> <help-area helptype=markdown></help-area> </div> </div> <header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.treatment.id>{{ $ctrl.treatment.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button ng-if=\"$ctrl.access.check('manager')\" class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'treatment' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'treatment'\"> Treatment </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'times' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'times'\" ng-if=$ctrl.canShow()> Arrival Times </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'upgrade' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'upgrade'\" ng-if=\"$ctrl.treatment.id && $ctrl.access.check('manager')\"> Upgrade </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'related' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'related'\" ng-if=\"$ctrl.treatment.id && $ctrl.access.check('manager')\"> Related Events </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'cross' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'cross'\" ng-if=\"$ctrl.treatment.id && $ctrl.$rootScope.currentProperty.group_property && $ctrl.access.check('manager')\"> Cross Sell </button> </div> <div class=c-tabs__content> <div class=row ng-show=\"$ctrl.activeTab === 'treatment'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <treatment-form treatment=$ctrl.treatment form-tab=$ctrl.activeTab> </treatment-form></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'times'\" ng-if=$ctrl.canShow()> <div class=\"small-12 columns\"> <start-times source=$ctrl.treatment active-day=$ctrl.activeDay(day) form-tab=$ctrl.activeTab times=$ctrl.treatment.times> </start-times></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'upgrade'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <upgrade-form source=$ctrl.treatment form-tab=$ctrl.activeTab> </upgrade-form></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'related'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <related-form source=$ctrl.treatment type=Treatment form-tab=$ctrl.activeTab> </related-form></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'cross'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <cross-form source=$ctrl.treatment type=Treatment form-tab=$ctrl.activeTab> </cross-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    value: '=',
    placeholder: '@'
  },
  controller: 'treatmentsSelectController',
  template: __webpack_require__(687)
};

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "<ui-select multiple=multiple ng-model=$ctrl.value uis-open-close=$ctrl.updateValue(isOpen) close-on-select=false> <ui-select-match placeholder=\"{{ $ctrl.placeholder }}\" allow-clear=true> {{ $item.name }} </ui-select-match> <ui-select-choices repeat=\"treatment in $ctrl.treatments | filter: $select.search track by treatment.id\"> <span ng-bind=treatment.name></span> <small ng-bind=treatment.category></small> </ui-select-choices> </ui-select> ";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    treatments: '<'
  },
  controller: 'treatmentSingleSelectController',
  template: __webpack_require__(689)
};

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "<div class=c-treatment-select> <div class=c-treatment-select__list ng-if=$ctrl.treatments ng-model=$ctrl.treatment> <ui-select ng-model=$ctrl.treatment uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=\"Treatment Selector\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"treatment.id as treatment in $ctrl.treatments | filter: $select.search track by $index\"> <div ng-bind-html=\"treatment.name | highlight: $select.search\"></div> <small>{{ treatment.category }}</small> </ui-select-choices> </ui-select> </div> </div>";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = function endpoint(property) {
  return '/api/' + property + '/events/treatments';
};

exports.default = ['api', '$rootScope', function (api, $rootScope) {
  return {
    save: function save(treatment) {
      var url = treatment.id ? endpoint(api.property()) + '/' + treatment.id : endpoint(api.property());

      return api.upload(url, treatment).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint(api.property()) + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
        return response.data;
      });
    },
    toggleActive: function toggleActive(id) {
      return api.get(endpoint(api.property()) + '/status/' + id).then(function (response) {
        return response.data;
      });
    },
    toggleVisible: function toggleVisible(id) {
      return api.get(endpoint(api.property()) + '/visible/' + id).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    },
    reconstruct: function reconstruct(order) {
      return api.post(endpoint(api.property()) + '/reconstruct', order).then(function (response) {
        return response.data;
      });
    },
    updatePriority: function updatePriority(treatment) {
      return api.post(endpoint(api.property()) + '/' + treatment.id + '/priority?priority=' + treatment.priority);
    }
  };
}];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _day = __webpack_require__(692);

var _day2 = _interopRequireDefault(_day);

var _daySave = __webpack_require__(693);

var _daySave2 = _interopRequireDefault(_daySave);

var _dayForm = __webpack_require__(694);

var _dayForm2 = _interopRequireDefault(_dayForm);

var _dayList = __webpack_require__(695);

var _dayList2 = _interopRequireDefault(_dayList);

var _daySelect = __webpack_require__(696);

var _daySelect2 = _interopRequireDefault(_daySelect);

var _daySingleSelect = __webpack_require__(697);

var _daySingleSelect2 = _interopRequireDefault(_daySingleSelect);

var _dayList3 = __webpack_require__(698);

var _dayList4 = _interopRequireDefault(_dayList3);

var _dayForm3 = __webpack_require__(700);

var _dayForm4 = _interopRequireDefault(_dayForm3);

var _daySave3 = __webpack_require__(702);

var _daySave4 = _interopRequireDefault(_daySave3);

var _daySelect3 = __webpack_require__(704);

var _daySelect4 = _interopRequireDefault(_daySelect3);

var _daySingleSelect3 = __webpack_require__(706);

var _daySingleSelect4 = _interopRequireDefault(_daySingleSelect3);

var _day3 = __webpack_require__(708);

var _day4 = _interopRequireDefault(_day3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daysModule = angular.module('spabooker.day', ['spabooker.base', 'spabooker.event']).config(_day2.default).controller('daySaveController', _daySave2.default).controller('dayFormController', _dayForm2.default).controller('dayListController', _dayList2.default).controller('daySelectController', _daySelect2.default).controller('daySingleSelectController', _daySingleSelect2.default).component('dayList', _dayList4.default).component('dayForm', _dayForm4.default).component('daySave', _daySave4.default).component('daySelect', _daySelect4.default).component('daySingleSelect', _daySingleSelect4.default).factory('dayService', _day4.default);

exports.default = daysModule.name;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _day = __webpack_require__(327);

var _categories = __webpack_require__(22);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.days', {
        url: '/events/days?:filtertext',
        component: 'dayList',
        resolve: {
            days: (0, _day.resolveDays)(),
            categories: (0, _categories.resolveNestedCategories)('flatten')
        },
        roles: ['manager']
    }).state('app.admin.deleteddays', {
        url: '/events/days/deleted',
        component: 'dayList',
        resolve: {
            days: (0, _day.resolveDays)(1, 20, 'deleted')
        },
        roles: ['admin']
    }).state('app.admin.day-add', {
        url: '/events/days/create',
        component: 'daySave',
        resolve: {
            title: function title() {
                return 'Create a Spa Day';
            },
            day: (0, _day.resolveDay)()
        },
        roles: ['manager']
    }).state('app.admin.day-edit', {
        url: '/events/days/:day/update?tab',
        component: 'daySave',
        resolve: {
            title: function title() {
                return 'Update a Spa Day';
            },
            day: (0, _day.resolveDay)()
        },
        roles: ['manager']
    });
}];

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DaySaveController = function () {
    function DaySaveController($rootScope, $state, $stateParams, access, integrationService, currentPropertyService) {
        _classCallCheck(this, DaySaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
        this.integrationService = integrationService;
        this.currentProperty = currentPropertyService;
    }

    _createClass(DaySaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = this.$stateParams.tab || 'day';
        }
    }, {
        key: 'canShow',
        value: function canShow() {
            var integration = this.currentProperty.get('integration');
            return !!this.day.id && (this.access.check('manager') || integration && integration.allow_time_constraining);
        }
    }]);

    return DaySaveController;
}();

DaySaveController.$inject = ['$rootScope', '$state', '$stateParams', 'access', 'integrationService', 'currentPropertyService'];

exports.default = DaySaveController;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DayFormController = function () {
  function DayFormController($rootScope, $scope, $state, dayService, messageService, markdownService, configService, integrationApiService, access) {
    _classCallCheck(this, DayFormController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.dayService = dayService;
    this.messageService = messageService;
    this.marked = markdownService;
    this.configService = configService;
    this.integrationApiService = integrationApiService;
    this.access = access;
  }

  _createClass(DayFormController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.creditAllowed = this.$rootScope.currentProperty.credit_spa_days;
      this.isAdmin = this.access.check('admin');

      if (this.day.track_quantity === undefined) this.day.track_quantity = this.$rootScope.currentProperty.track_quantity;
      this.day.description = this.day.description || '';
      this.day.selectedcategories = this.day.categories || [];
      this.day.treatmentstate = this.day.treatmentstate || !this.creditAllowed;
      this.day.days = this.day.days || [];
      this.day.status = this.day.status || false;
      this.day.secret = this.day.secret || false;
      this.day.special_status = this.day.special_status || '';
      this.day.property_id = this.day.property_id || this.$rootScope.currentProperty.id;
      this.day.start_time = this.day.start_time ? moment(this.day.start_time, 'HH:mm:ss') : '';
      this.day.event_status_id = this.day.event_status_id ? this.day.event_status_id.toString() : '0';
      this.currentPropertyName = this.$rootScope.currentProperty.name;
      this.currencySymbol = this.$rootScope.currentProperty.currency_symbol;

      if (!this.creditAllowed) {
        this.day.selectedtreatments = [];
      } else {
        this.day.selectedtreatments = this.day.treatmentstate ? this.day.additional_treatments : this.day.exclusions;
      }

      this.hasIntegration = !!this.$rootScope.currentProperty.integration;
      if (this.hasIntegration) {
        this.integrationApiService.integrationPackageCollect(this.$rootScope.currentProperty.id).then(function (response) {
          _this.importedPackages = response.map(function (spaday) {
            if (spaday.integration_location) {
              spaday.name = spaday.name + ' @ ' + spaday.integration_location_name;
            }
            return spaday;
          });
        });
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this2 = this;

      if (!(0, _lodash.find)(this.day.selectedcategories, { id: this.day.primary_category })) {
        this.messageService.failure('You must select at least 1 category and set a primary category to continue');
        this.messageService.push();
        this.saving = undefined;
        return Promise.reject({});
      }

      this.messageService.reset();

      this.day.treatments = [];
      this.day.options = [];

      if (this.day.treatmentstate) {
        this.day.additional_treatments = (0, _lodash.map)(this.day.selectedtreatments, 'id');
        this.day.exclusions = [];
      } else {
        this.day.exclusions = (0, _lodash.map)(this.day.selectedtreatments, 'id');
        this.day.additional_treatments = [];
      }

      this.day.categories = (0, _lodash.map)(this.day.selectedcategories, 'id');

      if (this.day.start_time) {
        this.day.start_time = this.day.start_time.format('HH:mm');
      }

      if (this.day.days) {
        this.day.days = (0, _lodash.map)(this.day.days, 'day');
      }

      var tempCats = this.day.selectedcategories;
      var tempPrimaryCat = this.day.primary_category;

      delete this.day.selectedtreatments;
      delete this.day.selectedcategories;
      delete this.day.upgrades;
      delete this.day.extras;
      delete this.day.days;
      delete this.day.extras;
      delete this.day.options;
      delete this.day.related;
      delete this.day.times;
      delete this.day.treatments;
      delete this.day.upgrades;

      return this.dayService.save(this.day).then(function (response) {
        if (_this2.day.id) {
          _this2.messageService.success('The Spa Day <strong>' + _this2.day.name + '</strong> was successfully updated!', ['app.admin.day-edit({ \'day\' : ' + _this2.day.id + '})', 'Spa Day']);
          _this2.$state.go('app.admin.days');
        } else {
          _this2.day.selectedcategories = tempCats;
          _this2.day.primary_category = tempPrimaryCat;
          _this2.messageService.success('The Spa Day <strong>' + _this2.day.name + '</strong> was successfully created. Please edit the start times.');
          _this2.$state.go('app.admin.day-edit', { day: response.id, tab: 'times' });
        }
      }).catch(function (error) {
        error.data = error.data.original || error.data;
        _this2.form.$api.setErrors(error.data);

        _this2.day.selectedcategories = tempCats;
        _this2.day.primary_category = tempPrimaryCat;

        var sourceElement = Object.keys(error.data);
        var verb = 'created';
        if (_this2.day.id) {
          verb = 'updated';
        }
        if (sourceElement.length > 0) {
          var errors = '';
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var element = _step.value;

              errors += '<li>' + _this2.messageService.formatError(element, error.data[element]) + '</li>';
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this2.messageService.failure('The Spa Day <strong>' + _this2.day.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
        } else {
          _this2.messageService.failure('The Spa Day <strong>' + _this2.day.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
        }
        _this2.messageService.push();
      });
    }
  }, {
    key: 'clearTreatments',
    value: function clearTreatments() {
      this.day.selectedtreatments = [];
    }
  }, {
    key: 'initialSlug',
    value: function initialSlug() {
      if (!this.day.id && document.getElementsByClassName('inline')[0].className.includes('untouched')) {
        this.day.slug = this.day.name ? this.day.name.replace(/[^a-zA-Z\d\s]+/g, '').replace(/[ ]+/g, '-').replace(/--+/g, '-').toLowerCase() : '';
      }
    }
  }]);

  return DayFormController;
}();

DayFormController.$inject = ['$rootScope', '$scope', '$state', 'dayService', 'messageService', 'markdownService', 'configService', 'integrationApiService', 'access'];

exports.default = DayFormController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DayListController = function () {
    function DayListController($rootScope, $stateParams, $scope, $state, $timeout, dayService, messageService, access, configService) {
        _classCallCheck(this, DayListController);

        this.$scope = $scope;
        this.$state = $state;
        this.dayService = dayService;
        this.messageService = messageService;
        this.access = access;
        this.configService = configService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        $scope.treeOptions = {
            dropped: function dropped(sourceNodeScope) {
                $timeout(function () {
                    return sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure();
                });
            }
        };
    }

    _createClass(DayListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.filtertext = this.$stateParams.filtertext || null;
            if (this.filtertext) {
                this.isFiltered = true;
            }

            if (this.days) {
                this.activeTab = 'list';
            }

            this.updatePaging();
            this.$scope.$watch(function (scope) {
                return scope.current_page;
            }, function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.days = undefined;
                        scope.$ctrl.dayService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
                            scope.$ctrl.days = response;
                            scope.$ctrl.loading = false;
                        });
                    } else {
                        scope.$ctrl.dayService.findAll(newVal, scope.per_page).then(function (list) {
                            return scope.$ctrl.days = list;
                        });
                    }
                }
            });
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            this.$scope.per_page = this.days.per_page;
            this.$scope.current_page = this.days.current_page;
            this.$scope.total = this.days.total;
        }
    }, {
        key: 'onDelete',
        value: function onDelete(day) {
            var _this = this;

            return this.dayService.delete(day.id).then(function () {
                _this.messageService.success('The day <strong>' + day.name + '</strong> was successfully deleted.');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure('The day <strong>' + day.name + '</strong> could not be successfully deleted: ' + error.statusText);
                _this.messageService.push();
            }).then(function () {
                var page = _this.days.current_page;
                _this.days = [];
                _this.loading = true;
                return _this.dayService.findAll(page).then(function (response) {
                    _this.days = response;
                    _this.loading = false;
                });
            });
        }
    }, {
        key: 'saveStructure',
        value: function saveStructure() {
            var _this2 = this;

            this.dayService.reconstruct((0, _lodash.map)(this.days.tree, 'id')).then(function () {
                _this2.messageService.success('This event order has been successfully saved.');
                _this2.messageService.push();
                _this2.messageService.autoClear();
            }).catch(function () {
                _this2.messageService.failure('This event order could not be successfully saved: ' + error.statusText);
                _this2.messageService.push();
            });
        }
    }, {
        key: 'toggleActive',
        value: function toggleActive(day) {
            var _this3 = this;

            this.dayService.toggleActive(day.id).catch(function (error) {
                _this3.messageService.failure('The day <strong>' + day.name + '</strong> could not be successfully toggled (active): ' + error.statusText);
                _this3.messageService.push();
            }).then(function () {
                return day.status = !day.status;
            });
        }
    }, {
        key: 'toggleVisible',
        value: function toggleVisible(day) {
            var _this4 = this;

            this.dayService.toggleVisible(day.id).catch(function (error) {
                _this4.messageService.failure('The day <strong>' + day.name + '</strong> could not be successfully toggled (visibility): ' + error.statusText);
                _this4.messageService.push();
            }).then(function () {
                return day.secret = !day.secret;
            });
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this5 = this;

            if (!this.loading && this.filtertext) {
                this.startFilter();
                this.dayService.search(this.filtertype, this.filtertext).then(function (response) {
                    _this5.isFiltered = true;
                    _this5.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this6 = this;

            if (this.isFiltered) {
                this.startFilter();
                this.dayService.findAll(1, 20).then(function (response) {
                    _this6.isFiltered = false;
                    _this6.endFilter(response);
                });
            }
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            switch (this.filtertype) {
                case 'cat':
                    this.filtertext = this.categories.flat[0].id;
                    break;
                case 'status':
                    this.filtertext = '1';
                    break;
                case 'secret':
                    this.filtertext = '0';
                    break;
                default:
                    this.filtertext = '';
                    break;
            }
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this.days = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this.days = response;
            this.updatePaging();
            this.loading = false;
        }
    }, {
        key: 'updatePriority',
        value: function updatePriority(event) {
            if (!event || event.priority === '' || event.priority > 999 || event.priority === undefined) {
                return false;
            }
            this.updateWait(event);
        }
    }, {
        key: 'updateWait',
        value: function updateWait(item) {
            var _this7 = this;

            if (item.priority.match(/[^0-9]+/g)) return;
            item.updating = false;
            clearTimeout(item.trigger);
            item.trigger = setTimeout(function () {
                _this7.trigger(item);
            }, 1000);
        }
    }, {
        key: 'update',
        value: function update(item) {
            this.trigger(item);
        }
    }, {
        key: 'trigger',
        value: function trigger(item) {
            item.trigger = undefined;
            item.updating = true;

            this.dayService.updatePriority(item).then(function () {
                item.updating = false;
            });
        }
    }]);

    return DayListController;
}();

DayListController.$inject = ['$rootScope', '$stateParams', '$scope', '$state', '$timeout', 'dayService', 'messageService', 'access', 'configService'];

exports.default = DayListController;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DaySelectController = function () {
    function DaySelectController(dayService, messageService) {
        _classCallCheck(this, DaySelectController);

        this.dayService = dayService;
        this.messageService = messageService;
    }

    _createClass(DaySelectController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.dayService.findAll(-1).then(function (day) {
                return _this.day = day;
            }).catch(function (errors) {
                _this.messageService.failure(errors);
                _this.messageService.push();
            });
        }
    }]);

    return DaySelectController;
}();

DaySelectController.$inject = ['dayService', 'messageService'];

exports.default = DaySelectController;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DaySingleSelectController = function () {
  function DaySingleSelectController(dayService) {
    _classCallCheck(this, DaySingleSelectController);

    this.dayService = dayService;
  }

  _createClass(DaySingleSelectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.dayService.findAll(-1).then(function (result) {
        _this.day = result;
        _this.day.unshift({ id: '', name: 'None', category: 'Select no Spa Day' });
      });
    }
  }]);

  return DaySingleSelectController;
}();

DaySingleSelectController.$inject = ['dayService'];

exports.default = DaySingleSelectController;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    days: '<',
    categories: '<'
  },
  controller: 'dayListController',
  template: __webpack_require__(699)
};

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Spa Days</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.day-add class=c-button--action> <icon icon=flip-flops></icon> Create a Spa Day </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.days class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deleteddays class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <message closable=true></message> <div class=c-tabs> <div class=c-tabs__content> <div class=row> <div class=\"columns c-list__tab-inner\"> <form class=\"row c-list__search c-list__search--tab c-list__search--day\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=cat>Categories</option> <option value=name>Name</option> <option value=status>Status</option> <option value=vis>Visibility</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'cat'\" ng-options=\"category.id as category.name for category in $ctrl.categories.flat\"> </select> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'vis'\"> <option value=0>Public</option> <option value=1>Private</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.days.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No spa days have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No spa days match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.days.data.length > 0\"> <thead> <tr> <th class=c-table__lights></th> <th>Name</th> <th class=c-table__cats>Priority</th> <th class=c-table__cats>Category</th> <th>Visibility</th> <th></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"day in $ctrl.days.data\" class=\"c-list {{ day.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-table__lights ng-click=\"$ctrl.access.check('manager') && $ctrl.toggleActive(day)\"> <span ng-class=\"(day.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (day.status)? 'This day is active' : 'This day is not active' }}\"></span> </td> <td>{{ day.name }}</td> <td class=c-table__inline-input> <span tooltip=\"The priority of this event will be updated automatically when changed\"> <input ng-model=day.priority type=text maxlength=3 ng-disabled=day.updating ng-change=$ctrl.updatePriority(day)> </span> <spinner tiny=true ng-if=day.updating /> </td> <td class=c-table__cats><span tooltip=\"{{ (day.category_names.length) ? day.category_names.join(', ') : null }}\">{{ day.primary_category_name || 'No Primary'}}</span></td> <td class=c-table__lights ng-click=\"$ctrl.access.check('manager') && $ctrl.toggleVisible(day)\"> <span ng-if=day.secret tooltip=\"This day is only available via direct URL\">Private</span> <span ng-if=!day.secret tooltip=\"This day is available in public listings\">Public</span> </td> <td class=c-list__action> <a ng-if=!day.status href=\"//{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/spa-day/{{ day.slug }}?preview=true\" target=_blank>Preview</a> <a ng-if=day.status href=\"//{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/spa-day/{{ day.slug }}\" target=_blank>View</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.day-edit({ day: day.id })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(day) confirm=\"Are you sure you want to delete {{ day.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <pagination ng-show=\"$ctrl.activeTab === 'list'\" total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </div> </main> ";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    day: '=',
    formTab: '=',
    activeDay: '&'
  },
  controller: 'dayFormController',
  template: __webpack_require__(701)
};

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.day.name form-field-errors required ng-change=$ctrl.initialSlug()> <label class=c-form__label for=name>Name</label> </div> <div class=c-form__url> <label class=c-form__url__label> https://{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/spa-day/ </label> <div class=c-form__url__field> <input name=slug type=text class=inline ng-model=$ctrl.day.slug form-field-errors required ng-pattern=/^[a-zA-Z0-9-]+$/ > </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.day.description form-field-errors required></textarea> <label class=c-form__label for=description_in>Description</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.day.description name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.day.description)></div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <label class=\"c-label c-label--large\">Image</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.day.image accept=image/jpeg,image/png current-url=$ctrl.day.own_image_url form-field-errors></file-upload> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <select name=duration ng-model=$ctrl.day.duration required> <option value=\"\" disabled=disabled>Duration</option> <option value=half>Half Day</option> <option value=full>Full Day</option> </select> </div> <div class=\"c-form__field c-form__field--money\"> <money-input name=base_price ng-model=$ctrl.day.base_price form-field-errors></money-input> <label class=c-form__label for=base_price>Price (base)</label> </div> <div class=\"c-form__field c-form__field--money\" ng-if=$ctrl.creditAllowed> <money-input name=credit ng-model=$ctrl.day.credit form-field-errors></money-input> <label class=c-form__label for=credit>Treatment Credit</label> </div> </div> </div> <div class=row ng-if=$ctrl.creditAllowed> <div class=columns> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear Treatments list\" tooltip-placement=left ng-click=$ctrl.clearTreatments()>&times;</span> <label class=c-form__switch> <input class=switch-input type=checkbox ng-model=$ctrl.day.treatmentstate /> <span class=switch-label data-on=\"INCLUDE TREATMENTS\" data-off=\"EXCLUDE TREATMENTS\"></span> <span class=switch-handle></span> </label> </div> </div> <treatments-select ng-if=$ctrl.creditAllowed name=treatments placeholder=\"Treatments to be added with credit\" value=$ctrl.day.selectedtreatments></treatments-select> <div class=row> <div class=\"column medium-8\"> <label for=categories class=c-label>Categories</label> <categories-select name=categories value=$ctrl.day.selectedcategories></categories-select> </div> <div class=\"column medium-4\"> <div class=c-form__field> <label for=primary_category class=c-label>Primary Category</label> <select ng-model=$ctrl.day.primary_category ng-options=\"category.id as category.name for category in $ctrl.day.selectedcategories\" required parent-select class=c-form__select> <option value=\"\" disabled=disabled>Please select a category...</option> </select> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=minimum_guests type=number class=c-form__input ng-model=$ctrl.day.minimum_guests form-field-errors min=1> <label class=c-form__label for=minimum_guests>Minimum Guests</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=maximum_guests type=number class=c-form__input ng-model=$ctrl.day.maximum_guests form-field-errors min={{$ctrl.day.minimum_guests}}> <label class=c-form__label for=maximum_guests>Maximum Guests</label> </div> </div> </div> <div class=row> <div class=\"columns medium-4\"> <label for=special_status class=c-label>Special Status</label> <label class=c-label for=special_status> <select name=special_status ng-init=\"$ctrl.day.event_status_id = $ctrl.day.event_status_id.toString() || ''\" ng-model=$ctrl.day.event_status_id> <option value=0> None </option> <option value=1> Phone booking only </option> <option value=2> Online only </option> </select> </label> </div> <div class=\"columns medium-4\"> <label for=gender class=c-label>Guest Gender</label> <label class=c-label for=gender> <select name=gender ng-model=$ctrl.day.gender> <option value=\"\"> Any </option> <option value=M> Male only </option> <option value=F> Female only </option> </select> </label> </div> <div class=\"columns medium-4\"> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear integration link\" tooltip-placement=left ng-click=\"$ctrl.day.integration_identity = null\" ng-if=\"$ctrl.hasIntegration && $ctrl.isAdmin\">&times;</span> <label for=integration class=c-label>Integration Event</label> <ui-select ng-model=$ctrl.day.integration_identity name=integration form-field-errors ng-disabled=\"!$ctrl.hasIntegration || ($ctrl.hasIntegration && !$ctrl.isAdmin)\"> <ui-select-match placeholder=\"Integration ID\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.integration_identity.toString() as item in $ctrl.importedPackages | filter: {name: $select.search} track by item.integration_identity+item.name\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> </div> <div class=c-form__field> <textarea name=description_in class=c-form__textarea type=text ng-model=$ctrl.day.terms form-field-errors></textarea> <label class=c-form__label for=description_in>Terms &amp; Conditions</label> </div> <p class=c-description>These terms will override the default terms set on the primary category.</p> <hr> <div class=row ng-if=!$ctrl.hasIntegration> <div class=\"column medium-8\"> <label for=track_quantity class=c-label>Track Quantity</label> <p class=c-description>If enabled, this Spa Day will automatically decrease the available quantity as it is purchased.</p> <switch id=track_quantity name=track_quantity ng-model=$ctrl.day.track_quantity class=green></switch> </div> <div class=\"column medium-4\"> <label for=base_quantity class=c-label>Quantity</label> <div class=c-form__field> <input name=base_quantity type=number class=c-form__input ng-model=$ctrl.day.base_quantity form-field-errors> <label class=c-form__label for=base_quantity>Base Quantity per Day</label> </div> </div> </div> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this spa day will be active and accessible on the website. If the toggle is not enabled this spa day will not be accessible to the public at all.</p> <switch id=status name=status ng-model=$ctrl.day.status class=green></switch> <label for=secret class=c-label>Secret</label> <p class=c-description>If enabled, this spa day will only be accessible via a direct URL, it will not show in public listings. Relies on the above status being enabled.</p> <p>Direct URL: https://{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/spa-day/{{ $ctrl.day.slug }}</p> <switch id=secret name=secret ng-model=$ctrl.day.secret class=green></switch> <div class=c-preview ng-if=\"!$ctrl.day.own_image_url && !$ctrl.day.image\"> <hr> <h4 style=color:red> You have not selected an image for this event, it will use the following fallback image. </h4> <img class=c-preview__thumbnail ng-src=\"{{ $ctrl.day.image_url }}\"> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save spa day <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    day: '=',
    title: '@'
  },
  controller: 'daySaveController',
  template: __webpack_require__(703)
};

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help-area> <button class=c-help-area__button ng-click=\"$ctrl.help = !$ctrl.help;\"> <span class=c-help-area__button-icon>?</span> Help </button> <div class=\"c-help-area__content {{$ctrl.help ? 'open': ''}}\"> <help-area helptype=markdown></help-area> </div> </div> <header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.day.id>{{ $ctrl.day.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button ng-if=\"$ctrl.access.check('manager')\" class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'day' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'day'\"> Spa Day </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'times' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'times'\" ng-if=$ctrl.canShow()> Arrival Times </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'upgrade' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'upgrade'\" ng-if=\"$ctrl.day.id && $ctrl.access.check('manager')\"> Upgrade </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'related' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'related'\" ng-if=\"$ctrl.day.id && $ctrl.access.check('manager')\"> Related Events </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'cross' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'cross'\" ng-if=\"$ctrl.day.id && $ctrl.$rootScope.currentProperty.group_property && $ctrl.access.check('manager')\"> Cross Sell </button> </div> <div class=c-tabs__content> <div class=row ng-show=\"$ctrl.activeTab === 'day'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <day-form day=$ctrl.day active-day=$ctrl.activeDay(day) form-tab=$ctrl.activeTab> </day-form></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'times'\" ng-if=$ctrl.canShow()> <div class=\"small-12 columns\"> <start-times source=$ctrl.day active-day=$ctrl.activeDay(day) form-tab=$ctrl.activeTab times=$ctrl.day.times> </start-times></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'upgrade'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <upgrade-form source=$ctrl.day form-tab=$ctrl.activeTab> </upgrade-form></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'related'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <related-form source=$ctrl.day type=SpaDay form-tab=$ctrl.activeTab> </related-form></div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'cross'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <cross-form source=$ctrl.day type=SpaDay form-tab=$ctrl.activeTab> </cross-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  require: {},
  controller: 'daySelectController',
  template: __webpack_require__(705)
};

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "<ui-select multiple=multiple ng-model=$ctrl.value uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=\"Spa Days\"> {{ $item.name }} </ui-select-match> <ui-select-choices repeat=\"day in $ctrl.days | filter: $select.search track by day.id\"> <span ng-bind=day.name></span> <small ng-bind=day.category></small> </ui-select-choices> </ui-select> ";

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  require: {},
  controller: 'daySingleSelectController',
  template: __webpack_require__(707)
};

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "<div class=c-day-select> <div class=c-day-select__list ng-if=$ctrl.days ng-model=$ctrl.day> <ui-select ng-model=$ctrl.day uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=\"Spa Day Selector\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"day.id as day in $ctrl.days | filter: $select.search track by $index\"> <div ng-bind-html=\"day.name | highlight: $select.search\"></div> <small>{{ day.category }}</small> </ui-select-choices> </ui-select> </div> </div>";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = function endpoint(property) {
  return '/api/' + property + '/events/days';
};

exports.default = ['api', function (api) {
  return {
    save: function save(day) {
      var url = day.id ? endpoint(api.property()) + '/' + day.id : endpoint(api.property());

      return api.upload(url, day).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint(api.property()) + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint(api.property()) + (!isNaN(page) ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
        return response.data;
      });
    },
    toggleActive: function toggleActive(id) {
      return api.get(endpoint(api.property()) + '/status/' + id).then(function (response) {
        return response.data;
      });
    },
    toggleVisible: function toggleVisible(id) {
      return api.get(endpoint(api.property()) + '/visible/' + id).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    },
    reconstruct: function reconstruct(order) {
      return api.post(endpoint(api.property()) + '/reconstruct', order).then(function (response) {
        return response.data;
      });
    },
    updatePriority: function updatePriority(spaday) {
      return api.post(endpoint(api.property()) + '/' + spaday.id + '/priority?priority=' + spaday.priority);
    }
  };
}];

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(710);

__webpack_require__(30);

var _event = __webpack_require__(713);

var _event2 = _interopRequireDefault(_event);

var _categorySave = __webpack_require__(717);

var _categorySave2 = _interopRequireDefault(_categorySave);

var _optionsSave = __webpack_require__(718);

var _optionsSave2 = _interopRequireDefault(_optionsSave);

var _categoryForm = __webpack_require__(719);

var _categoryForm2 = _interopRequireDefault(_categoryForm);

var _categoryList = __webpack_require__(720);

var _categoryList2 = _interopRequireDefault(_categoryList);

var _optionsList = __webpack_require__(721);

var _optionsList2 = _interopRequireDefault(_optionsList);

var _categoriesSelect = __webpack_require__(722);

var _categoriesSelect2 = _interopRequireDefault(_categoriesSelect);

var _categorySelect = __webpack_require__(723);

var _categorySelect2 = _interopRequireDefault(_categorySelect);

var _relatedForm = __webpack_require__(724);

var _relatedForm2 = _interopRequireDefault(_relatedForm);

var _crossForm = __webpack_require__(725);

var _crossForm2 = _interopRequireDefault(_crossForm);

var _extrasList = __webpack_require__(726);

var _extrasList2 = _interopRequireDefault(_extrasList);

var _extrasSave = __webpack_require__(727);

var _extrasSave2 = _interopRequireDefault(_extrasSave);

var _extrasForm = __webpack_require__(728);

var _extrasForm2 = _interopRequireDefault(_extrasForm);

var _startTimes = __webpack_require__(729);

var _startTimes2 = _interopRequireDefault(_startTimes);

var _eventMultiSelectForm = __webpack_require__(730);

var _eventMultiSelectForm2 = _interopRequireDefault(_eventMultiSelectForm);

var _optionsForm = __webpack_require__(731);

var _optionsForm2 = _interopRequireDefault(_optionsForm);

var _upgradesList = __webpack_require__(732);

var _upgradesList2 = _interopRequireDefault(_upgradesList);

var _categoryList3 = __webpack_require__(733);

var _categoryList4 = _interopRequireDefault(_categoryList3);

var _optionsList3 = __webpack_require__(735);

var _optionsList4 = _interopRequireDefault(_optionsList3);

var _categoryForm3 = __webpack_require__(737);

var _categoryForm4 = _interopRequireDefault(_categoryForm3);

var _categorySave3 = __webpack_require__(739);

var _categorySave4 = _interopRequireDefault(_categorySave3);

var _optionsSave3 = __webpack_require__(741);

var _optionsSave4 = _interopRequireDefault(_optionsSave3);

var _categoriesSelect3 = __webpack_require__(743);

var _categoriesSelect4 = _interopRequireDefault(_categoriesSelect3);

var _categorySelect3 = __webpack_require__(745);

var _categorySelect4 = _interopRequireDefault(_categorySelect3);

var _relatedForm3 = __webpack_require__(747);

var _relatedForm4 = _interopRequireDefault(_relatedForm3);

var _crossForm3 = __webpack_require__(749);

var _crossForm4 = _interopRequireDefault(_crossForm3);

var _startTimes3 = __webpack_require__(751);

var _startTimes4 = _interopRequireDefault(_startTimes3);

var _extrasList3 = __webpack_require__(753);

var _extrasList4 = _interopRequireDefault(_extrasList3);

var _extrasSave3 = __webpack_require__(755);

var _extrasSave4 = _interopRequireDefault(_extrasSave3);

var _extrasForm3 = __webpack_require__(757);

var _extrasForm4 = _interopRequireDefault(_extrasForm3);

var _eventMultiSelectForm3 = __webpack_require__(759);

var _eventMultiSelectForm4 = _interopRequireDefault(_eventMultiSelectForm3);

var _optionsForm3 = __webpack_require__(761);

var _optionsForm4 = _interopRequireDefault(_optionsForm3);

var _upgradesList3 = __webpack_require__(763);

var _upgradesList4 = _interopRequireDefault(_upgradesList3);

var _categories = __webpack_require__(765);

var _categories2 = _interopRequireDefault(_categories);

var _events = __webpack_require__(766);

var _events2 = _interopRequireDefault(_events);

var _extras = __webpack_require__(767);

var _extras2 = _interopRequireDefault(_extras);

var _options = __webpack_require__(768);

var _options2 = _interopRequireDefault(_options);

var _categoryAssignment = __webpack_require__(769);

var _categoryAssignment2 = _interopRequireDefault(_categoryAssignment);

var _categoriesTransformer = __webpack_require__(770);

var _categoriesTransformer2 = _interopRequireDefault(_categoriesTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventModule = angular.module('spabooker.event', ['spabooker.base', 'ui.tree', 'as.sortable']).config(_event2.default).controller('categorySaveController', _categorySave2.default).controller('optionsSaveController', _optionsSave2.default).controller('categoryFormController', _categoryForm2.default).controller('categoryListController', _categoryList2.default).controller('optionsListController', _optionsList2.default).controller('categoriesSelectController', _categoriesSelect2.default).controller('categorySelectController', _categorySelect2.default).controller('relatedFormController', _relatedForm2.default).controller('crossFormController', _crossForm2.default).controller('extrasListController', _extrasList2.default).controller('extrasSaveController', _extrasSave2.default).controller('extrasFormController', _extrasForm2.default).controller('startTimesController', _startTimes2.default).controller('eventMultiSelectFormController', _eventMultiSelectForm2.default).controller('optionsFormController', _optionsForm2.default).controller('upgradesListController', _upgradesList2.default).component('categoryList', _categoryList4.default).component('optionsList', _optionsList4.default).component('categoryForm', _categoryForm4.default).component('categorySave', _categorySave4.default).component('optionsSave', _optionsSave4.default).component('categoriesSelect', _categoriesSelect4.default).component('categorySelect', _categorySelect4.default).component('relatedForm', _relatedForm4.default).component('crossForm', _crossForm4.default).component('extrasList', _extrasList4.default).component('extrasSave', _extrasSave4.default).component('extrasForm', _extrasForm4.default).component('eventMultiSelectForm', _eventMultiSelectForm4.default).component('optionsForm', _optionsForm4.default).component('startTimes', _startTimes4.default).component('upgradesList', _upgradesList4.default).factory('categoriesService', _categories2.default).factory('eventsService', _events2.default).factory('extrasService', _extras2.default).factory('optionsService', _options2.default).factory('categoriesTransformer', _categoriesTransformer2.default).factory('categoryAssignService', _categoryAssignment2.default);

exports.default = eventModule.name;

/***/ }),
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(22);

var _options = __webpack_require__(714);

var _day = __webpack_require__(327);

var _extras = __webpack_require__(715);

var _treatments = __webpack_require__(326);

var _upgrades = __webpack_require__(716);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.categories', {
        url: '/category',
        component: 'categoryList',
        resolve: {
            categories: (0, _categories.resolveNestedCategories)(),
            pagedcategories: (0, _categories.resolveCategories)(1, 20)
        },
        roles: ['manager']
    }).state('app.admin.deletedcategories', {
        url: '/category/deleted',
        component: 'categoryList',
        resolve: {
            pagedcategories: (0, _categories.resolveCategories)(1, 20, 'deleted')
        },
        roles: ['admin']
    }).state('app.admin.category-add', {
        url: '/category/create',
        component: 'categorySave',
        resolve: {
            title: function title() {
                return 'Create a Category';
            },
            category: (0, _categories.resolveCategory)(),
            treatments: (0, _treatments.resolveTreatments)(-1),
            days: (0, _day.resolveDays)(-1),
            categories: (0, _categories.resolveNestedCategories)('flatten')
        },
        roles: ['manager']
    }).state('app.admin.category-edit', {
        url: '/category/:category/update',
        component: 'categorySave',
        resolve: {
            title: function title() {
                return 'Update a Category';
            },
            category: (0, _categories.resolveCategory)(),
            treatments: (0, _treatments.resolveTreatments)(-1),
            days: (0, _day.resolveDays)(-1),
            categories: (0, _categories.resolveNestedCategories)('flatten')
        },
        roles: ['manager']
    }).state('app.admin.extras', {
        url: '/extras?:filtertext',
        component: 'extrasList',
        resolve: {
            extras: (0, _extras.resolveExtras)(1, 20)
        },
        roles: ['manager']
    }).state('app.admin.deletedextras', {
        url: '/extras/deleted',
        component: 'extrasList',
        resolve: {
            extras: (0, _extras.resolveExtras)(1, 20, 'deleted')
        },
        roles: ['admin']
    }).state('app.admin.extra-add', {
        url: '/extras/create',
        component: 'extrasSave',
        resolve: {
            title: function title() {
                return 'Create an Extra';
            },
            extra: (0, _extras.resolveExtra)()
        },
        roles: ['manager']
    }).state('app.admin.extra-edit', {
        url: '/extras/:extra/update?tab',
        component: 'extrasSave',
        resolve: {
            title: function title() {
                return 'Update an Extra';
            },
            extra: (0, _extras.resolveExtra)()
        },
        roles: ['manager']
    }).state('app.admin.options', {
        url: '/option?:filtertext',
        component: 'optionsList',
        resolve: {
            options: (0, _options.resolveOptions)(1, 20)
        },
        roles: ['manager']
    }).state('app.admin.deletedoptions', {
        url: '/option/deleted',
        component: 'optionsList',
        resolve: {
            options: (0, _options.resolveOptions)(1, 20, 'deleted')
        },
        roles: ['admin']
    }).state('app.admin.option-add', {
        url: '/option/create',
        component: 'optionsSave',
        resolve: {
            title: function title() {
                return 'Create an Option';
            },
            option: (0, _options.resolveOption)(),
            treatments: (0, _treatments.resolveTreatments)(-1),
            days: (0, _day.resolveDays)(-1)
        },
        roles: ['manager']
    }).state('app.admin.option-edit', {
        url: '/option/:option/update?tab',
        component: 'optionsSave',
        resolve: {
            title: function title() {
                return 'Update an Option';
            },
            option: (0, _options.resolveOption)(),
            treatments: (0, _treatments.resolveTreatments)(-1),
            days: (0, _day.resolveDays)(-1)
        },
        roles: ['manager']
    }).state('app.admin.upgrades', {
        url: '/upgrades',
        component: 'upgradesList',
        resolve: {
            spadays: (0, _day.resolveDays)(-1),
            treatments: (0, _treatments.resolveTreatments)(-1),
            upgrades: (0, _upgrades.resolveUpgrades)()
        },
        roles: ['manager']
    });
}];

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveOptions = exports.resolveOptions = function resolveOptions() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    return ['$stateParams', 'optionsService', function ($stateParams, optionsService) {
        if (!$stateParams.filtertext) {
            return optionsService.findAll(page, perpage, deleted).then(function (list) {
                return list;
            });
        }

        return optionsService.search('name', $stateParams.filtertext, page).then(function (list) {
            return list;
        });
    }];
};
var resolveOption = exports.resolveOption = function resolveOption() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'option';

    return ['$stateParams', 'optionsService', function ($stateParams, optionsService) {
        return $stateParams[param] && $stateParams[param] > 0 ? optionsService.findById($stateParams[param]) : {};
    }];
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveExtras = exports.resolveExtras = function resolveExtras() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    return ['$stateParams', 'extrasService', function ($stateParams, extrasService) {
        if (!$stateParams.filtertext) {
            return extrasService.findAll(page, perpage, deleted).then(function (list) {
                return list;
            });
        }

        return extrasService.search('name', $stateParams.filtertext, page).then(function (list) {
            return list;
        });
    }];
};

var resolveExtra = exports.resolveExtra = function resolveExtra() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'extra';

    return ['$stateParams', 'extrasService', function ($stateParams, extrasService) {
        return $stateParams[param] && $stateParams[param] > 0 ? extrasService.findById($stateParams[param]) : {};
    }];
};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveUpgrades = exports.resolveUpgrades = function resolveUpgrades() {
    return ['eventsService', function (eventsService) {
        return eventsService.collectUpgrades().then(function (list) {
            return list;
        });
    }];
};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategorySaveController = function () {
    function CategorySaveController($rootScope, $state, access) {
        _classCallCheck(this, CategorySaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.access = access;
    }

    _createClass(CategorySaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = 'profile';
        }
    }]);

    return CategorySaveController;
}();

CategorySaveController.$inject = ['$rootScope', '$state', 'access'];

exports.default = CategorySaveController;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OptionsSaveController = function () {
    function OptionsSaveController($rootScope, $state, $stateParams, access) {
        _classCallCheck(this, OptionsSaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
    }

    _createClass(OptionsSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = this.$stateParams.tab || 'profile';
            if (!this.option || Object.keys(this.option).length === 0) {
                this.option = {
                    property_id: this.$rootScope.currentProperty.id
                };
            }
        }
    }]);

    return OptionsSaveController;
}();

OptionsSaveController.$inject = ['$rootScope', '$state', '$stateParams', 'access'];

exports.default = OptionsSaveController;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoryFormController = function () {
    function CategoryFormController($rootScope, $scope, $state, categoriesService, messageService, categoryAssignService, markdownService, configService) {
        _classCallCheck(this, CategoryFormController);

        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.categoriesService = categoriesService;
        this.categoryAssignService = categoryAssignService;
        this.messageService = messageService;
        this.configService = configService;
        this.marked = markdownService;
    }

    _createClass(CategoryFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.expand = true;

            this.category.parent = (0, _lodash.find)(this.categories.data, { 'id': parseInt(this.category.parent, 10) });

            this.category = this.category || {};

            this.category.spadays = this.category.spadays || [];
            this.category.treatments = this.category.treatments || [];

            this.sanitise();
            this.category.property_id = this.category.property_id || this.$rootScope.currentProperty.id;
            this.treatmentDrag = {
                accept: function accept(sourceItemHandleScope, destSortableScope) {
                    return !('day' in sourceItemHandleScope.itemScope.modelValue);
                },
                containment: '#treatmentlist',
                containerPositioning: 'relative',
                orderChanged: function orderChanged(event) {
                    if (event.source.sortableScope.$parent.$ctrl.category.id) {
                        event.source.sortableScope.$parent.$ctrl.saveTreatmentPosition();
                    }
                }
            };
            this.dayDrag = {
                accept: function accept(sourceItemHandleScope, destSortableScope) {
                    return !('treatment' in sourceItemHandleScope.itemScope.modelValue);
                },
                containment: '#daylist',
                containerPositioning: 'relative',
                orderChanged: function orderChanged(event) {
                    if (event.source.sortableScope.$parent.$ctrl.category.id) {
                        event.source.sortableScope.$parent.$ctrl.saveDayPosition();
                    }
                }
            };
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            if (this.category.id) {
                this.category.spadays = undefined;
                this.category.treatments = undefined;
            }
            if (this.category.parent) this.category.parent = { 'id': this.category.parent.id, 'level': this.category.parent.level };

            return this.categoriesService.save(this.category).then(function (response) {
                if (_this.category.updated_at) {
                    _this.messageService.success('The category <strong>' + _this.category.name + '</strong> was successfully updated!');
                } else {
                    _this.messageService.success('The category <strong>' + _this.category.name + '</strong> was successfully created.', ['app.admin.category-edit({ \'category\' : ' + response.id + '})', 'Category']);
                }
            }).then(function () {
                _this.messageService.clear();
                _this.$state.go('app.admin.categories');
            });
        }
    }, {
        key: 'unassignTreatment',
        value: function unassignTreatment(treatment) {
            var _this2 = this;

            this.categoryAssignService.unassignTreatment(treatment.id, this.category.id).catch(function (error) {
                _this2.messageService.failure('The treatment <strong>' + treatment.name + '</strong> could not be successfully removed: ' + error.statusText);
                _this2.messageService.push();
            }).then(function (response) {
                _this2.category.treatments.splice((0, _lodash.findKey)(_this2.category.treatments, function (assignment) {
                    return assignment.related_event.id === treatment.id;
                }), 1);
            });
        }
    }, {
        key: 'unassignDay',
        value: function unassignDay(day) {
            var _this3 = this;

            this.categoryAssignService.unassignDay(day.id, this.category.id).catch(function (error) {
                _this3.messageService.failure('The treatment <strong>' + day.name + '</strong> could not be successfully removed: ' + error.statusText);
                _this3.messageService.push();
            }).then(function (response) {
                _this3.category.spadays.splice((0, _lodash.findKey)(_this3.category.spadays, function (assignment) {
                    return assignment.related_event.id === day.id;
                }), 1);
            });
        }
    }, {
        key: 'validDays',
        value: function validDays(item) {
            return (0, _lodash.findKey)(this.category.spadays, function (innerday) {
                return innerday.related_event.id === item.id;
            });
        }
    }, {
        key: 'validTreatments',
        value: function validTreatments(item) {
            return (0, _lodash.findKey)(this.category.treatments, function (innertreatment) {
                return innertreatment.related_event.id === item.id;
            });
        }
    }, {
        key: 'validCategories',
        value: function validCategories() {
            var _this4 = this;

            return function (item) {
                return !(0, _lodash.findKey)(_this4.categories, function (innercategory) {
                    return innercategory.id === _this4.category.id;
                });
            };
        }
    }, {
        key: 'addDay',
        value: function addDay() {
            var _this5 = this;

            if (this.selectedday) {
                this.selectedday = this.selectedday.id;
                var _day = (0, _lodash.find)(this.days, { 'id': this.selectedday });
                this.category.spadays.push({ 'related_event_type': 'App\\SpaDay', 'related_event_id': _day.id, 'related_event': _day });
                if (this.category.id) {
                    this.categoryAssignService.assignDay(this.selectedday, this.category.id, this.forcePrimary).catch(function (error) {
                        _this5.messageService.failure('The treatment <strong>' + _day.name + '</strong> could not be successfully added: ' + error.statusText);
                        _this5.messageService.push();
                        _this5.category.spadays.splice((0, _lodash.findKey)(_this5.category.spadays, function (assignment) {
                            return assignment.day.id === _this5.selectedday;
                        }), 1);
                    }).then(function () {
                        return _this5.selectedday = '';
                    });
                } else {
                    this.selectedday = '';
                }
            }
        }
    }, {
        key: 'addTreatment',
        value: function addTreatment() {
            var _this6 = this;

            if (this.selectedtreatment) {
                this.selectedtreatment = this.selectedtreatment.id;
                var treatment = (0, _lodash.find)(this.treatments, { 'id': this.selectedtreatment });
                this.category.treatments.push({ 'related_event_type': 'App\\Treatment', 'related_event_id': treatment.id, 'related_event': treatment });
                if (this.category.id) {
                    this.categoryAssignService.assignTreatment(this.selectedtreatment, this.category.id, this.forcePrimary).catch(function (error) {
                        _this6.messageService.failure('The treatment <strong>' + day.name + '</strong> could not be successfully added: ' + error.statusText);
                        _this6.messageService.push();
                        _this6.category.treatments.splice((0, _lodash.findKey)(_this6.category.treatments, function (assignment) {
                            return assignment.treatment.id === _this6.selectedtreatment;
                        }), 1);
                    }).then(function () {
                        return _this6.selectedtreatment = '';
                    });
                } else {
                    this.selectedtreatment = '';
                }
            }
        }
    }, {
        key: 'saveTreatmentPosition',
        value: function saveTreatmentPosition() {
            var _this7 = this;

            this.categoryAssignService.reorderTreatments((0, _lodash.map)(this.category.treatments, function (treatment) {
                return treatment.related_event.id;
            }), this.category.id).catch(function (error) {
                _this7.messageService.failure('The treatment order could not be successfully saved: ' + error.statusText);
                _this7.messageService.push();
            });
        }
    }, {
        key: 'saveDayPosition',
        value: function saveDayPosition() {
            var _this8 = this;

            this.categoryAssignService.reorderDays((0, _lodash.map)(this.category.spadays, function (day) {
                return day.related_event.id;
            }), this.category.id).catch(function (error) {
                _this8.messageService.failure('The spa day order could not be successfully saved: ' + error.statusText);
                _this8.messageService.push();
            });
        }
    }, {
        key: 'sanitise',
        value: function sanitise() {
            this.category.spadays = (0, _lodash.filter)(this.category.spadays, { 'event_category_id': this.category.id });
            this.category.treatments = (0, _lodash.filter)(this.category.treatments, { 'event_category_id': this.category.id });
        }
    }, {
        key: 'initialSlug',
        value: function initialSlug() {
            if (!this.category.id && document.getElementsByClassName('inline')[0].className.includes('untouched')) {
                this.category.slug = this.category.name ? this.category.name.replace(/[^a-zA-Z\d\s]+/g, '').replace(/[ ]+/g, '-').replace(/--+/g, '-').toLowerCase() : '';
            }
        }
    }]);

    return CategoryFormController;
}();

CategoryFormController.$inject = ['$rootScope', '$scope', '$state', 'categoriesService', 'messageService', 'categoryAssignService', 'markdownService', 'configService'];

exports.default = CategoryFormController;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoryListController = function () {
  function CategoryListController($timeout, $scope, $state, categoriesService, messageService, access) {
    _classCallCheck(this, CategoryListController);

    this.$scope = $scope;
    this.$state = $state;
    this.categoriesService = categoriesService;
    this.messageService = messageService;
    this.access = access;
    $scope.treeOptions = {
      dropped: function dropped(sourceNodeScope, destNodesScope, destIndex) {
        $timeout(function () {
          return sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure();
        });
      }
    };
  }

  _createClass(CategoryListController, [{
    key: '$onInit',
    value: function $onInit() {
      if (this.categories) {
        this.activeTab = 'tree';
      } else {
        this.activeTab = 'list';
      }

      this.updatePaging();
      this.$scope.$watch(function (scope) {
        return scope.current_page;
      }, function (newVal, oldVal, scope) {
        if (newVal !== oldVal) {
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
            scope.$ctrl.pagedcategories = undefined;
            scope.$ctrl.categoriesService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal, 20).then(function (response) {
              scope.$ctrl.pagedcategories = response;
              scope.$ctrl.loading = false;
            });
          } else {
            scope.$ctrl.categoriesService.findAll(newVal, scope.per_page).then(function (list) {
              return scope.$ctrl.pagedcategories = list;
            });
          }
        }
      });
    }
  }, {
    key: 'updatePaging',
    value: function updatePaging() {
      this.$scope.per_page = this.pagedcategories.per_page;
      this.$scope.current_page = this.pagedcategories.current_page;
      this.$scope.total = this.pagedcategories.total;
    }
  }, {
    key: 'onDelete',
    value: function onDelete(category) {
      var _this = this;

      this.categoriesService.delete(category.id).then(function (list) {
        _this.messageService.success('The category <strong>' + category.name + '</strong> was successfully deleted.');
        _this.messageService.push();
      }).catch(function (error) {
        _this.messageService.failure('The category <strong>' + category.name + '</strong> could not be successfully deleted: ' + error.statusText);
        _this.messageService.push();
      }).then(function () {
        var page = _this.pagedcategories.current_page;
        _this.pagedcategories = [];
        _this.categories = [];
        return Promise.all([_this.categoriesService.findAll(page).then(function (response) {
          _this.pagedcategories = response;
        }), _this.categoriesService.hierarchyFind().then(function (response) {
          _this.categories = response;
        })]);
      });
    }
  }, {
    key: 'saveStructure',
    value: function saveStructure() {
      var _this2 = this;

      this.categoriesService.reconstruct(this.categories.tree).catch(function () {
        _this2.messageService.failure('This category structure could not be successfully saved: ' + error.statusText);
        _this2.messageService.push();
      }).then(function () {
        _this2.messageService.success('This category structure has been successfully saved.');
        _this2.messageService.push();
        _this2.messageService.autoClear();
      });
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this3 = this;

      if (!this.loading && this.filtertext) {
        this.startFilter();
        this.categoriesService.search(this.filtertype, this.filtertext, 1, 20).then(function (response) {
          _this3.isFiltered = true;
          _this3.endFilter(response);
        });
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      var _this4 = this;

      if (this.isFiltered) {
        this.startFilter();
        this.categoriesService.findAll().then(function (response) {
          _this4.isFiltered = false;
          _this4.endFilter(response);
        });
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        default:
          this.filtertext = '';
          break;
      }
    }
  }, {
    key: 'startFilter',
    value: function startFilter() {
      this.loading = true;
      this.pagedcategories = undefined;
    }
  }, {
    key: 'endFilter',
    value: function endFilter(response) {
      this.pagedcategories = response;
      this.updatePaging();
      this.loading = false;
    }
  }]);

  return CategoryListController;
}();

CategoryListController.$inject = ['$timeout', '$scope', '$state', 'categoriesService', 'messageService', 'access'];

exports.default = CategoryListController;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OptionListController = function () {
    function OptionListController($timeout, $scope, $state, optionsService, messageService, access, $stateParams) {
        _classCallCheck(this, OptionListController);

        this.$scope = $scope;
        this.$state = $state;
        this.optionsService = optionsService;
        this.messageService = messageService;
        this.access = access;
        this.$stateParams = $stateParams;
        $scope.treeOptions = {
            dropped: function dropped(sourceNodeScope) {
                $timeout(function () {
                    return sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure();
                });
            }
        };
    }

    _createClass(OptionListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.filtertext = this.$stateParams.filtertext || null;
            if (this.filtertext) {
                this.isFiltered = true;
            }

            this.activeTab = 'tree';
            this.updatePaging();
            this.$scope.$watch(function (scope) {
                return scope.current_page;
            }, function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.options = undefined;
                        scope.$ctrl.optionsService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
                            scope.$ctrl.options = response;
                            scope.$ctrl.loading = false;
                        });
                    } else {
                        scope.$ctrl.optionsService.findAll(newVal, scope.per_page).then(function (list) {
                            return scope.$ctrl.options = list;
                        });
                    }
                }
            });
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            this.$scope.per_page = this.options.per_page;
            this.$scope.current_page = this.options.current_page;
            this.$scope.total = this.options.total;
        }
    }, {
        key: 'onDelete',
        value: function onDelete(option) {
            var _this = this;

            this.optionsService.delete(option.id).then(function () {
                _this.messageService.success('The option <strong>' + option.name + '</strong> was successfully deleted.');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure('The option <strong>' + option.name + '</strong> could not be successfully deleted: ' + error.statusText);
                _this.messageService.push();
            }).then(function () {
                var page = _this.options.current_page;
                _this.options = [];
                _this.loading = true;
                return _this.optionsService.findAll(page).then(function (response) {
                    _this.options = response;
                    _this.loading = false;
                });
            });
        }
    }, {
        key: 'saveStructure',
        value: function saveStructure() {
            var _this2 = this;

            this.optionsService.reconstruct(this.options.tree).catch(function () {
                _this2.messageService.failure('This option structure could not be successfully saved: ' + error.statusText);
                _this2.messageService.push();
            }).then(function () {
                _this2.messageService.success('This option structure has been successfully saved.');
                _this2.messageService.push();
                _this2.messageService.autoClear();
            });
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this3 = this;

            if (!this.loading && this.filtertext) {
                this.startFilter();
                this.optionsService.search(this.filtertype, this.filtertext).then(function (response) {
                    _this3.isFiltered = true;
                    _this3.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this4 = this;

            if (this.isFiltered) {
                this.startFilter();
                this.optionsService.findAll().then(function (response) {
                    _this4.isFiltered = false;
                    _this4.endFilter(response);
                });
            }
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            switch (this.filtertype) {
                case 'status':
                    this.filtertext = '1';
                    break;
                default:
                    this.filtertext = '';
                    break;
            }
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this.options = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this.options = response;
            this.updatePaging();
            this.loading = false;
        }
    }]);

    return OptionListController;
}();

OptionListController.$inject = ['$timeout', '$scope', '$state', 'optionsService', 'messageService', 'access', '$stateParams'];

exports.default = OptionListController;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoriesSelectController = function () {
  function CategoriesSelectController(categoriesService, messageService) {
    _classCallCheck(this, CategoriesSelectController);

    this.categoriesService = categoriesService;
    this.messageService = messageService;
  }

  _createClass(CategoriesSelectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.value = this.value || [];
      this.categoriesService.hierarchyFind('flatten').then(function (categories) {
        _this.categories = _this.addParents(categories.flat);

        if (_this.value.length) {
          for (var i in _this.value) {
            _this.value[i] = (0, _lodash.find)(_this.categories, { 'id': _this.value[i].event_category_id });
          }
        }
      }).catch(function (errors) {
        _this.messageService.failure(errors);
        _this.messageService.push();
      });
    }
  }, {
    key: 'addParents',
    value: function addParents(categories) {
      for (var i = 0, l = categories.length; i < l; i++) {
        categories[i].displayname = categories[i].name;
        if (categories[i].parent) {
          categories[i].displayname += ' (Parent: ' + (0, _lodash.find)(categories, { 'id': parseInt(categories[i].parent, 10) }).name + ')';
        }
      }
      return categories;
    }
  }]);

  return CategoriesSelectController;
}();

CategoriesSelectController.$inject = ['categoriesService', 'messageService'];

exports.default = CategoriesSelectController;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategorySelectController = function () {
  function CategorySelectController(categoriesService) {
    _classCallCheck(this, CategorySelectController);

    this.categoriesService = categoriesService;
  }

  _createClass(CategorySelectController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.categoriesService.findAll(-1).then(function (result) {
        _this.categorylist = result;
        _this.categories = _this.ngModel.$viewValue && Object.keys(_this.ngModel.$viewValue).length ? _this.ngModel.$viewValue : [];
      });
    }
  }, {
    key: 'updateValue',
    value: function updateValue() {
      var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!isOpen) {
        this.ngModel.$setViewValue(this.categories);
        this.ngModel.$setTouched();
      }
    }
  }, {
    key: 'delete',
    value: function _delete(key) {
      if (Object.keys(this.categories).length === 1) {
        this.categories = [];
      } else {
        this.categories.splice(key, 1);
      }
      this.updateValue();
    }
  }, {
    key: 'disablecategory',
    value: function disablecategory(id) {
      return (0, _lodash.find)(this.categories, { 'category_id': id });
    }
  }]);

  return CategorySelectController;
}();

CategorySelectController.$inject = ['categoriesService'];

exports.default = CategorySelectController;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RelatedFormController = function () {
  function RelatedFormController($rootScope, eventsService, imgix, messageService) {
    _classCallCheck(this, RelatedFormController);

    this.$rootScope = $rootScope;
    this.eventsService = eventsService;
    this.imgix = imgix;
    this.messageService = messageService;
  }

  _createClass(RelatedFormController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.loading = true;
      this.activeEvents = [];
      if (!this.relatedCategories) {
        this.eventsService.collectCategories().then(function (response) {
          _this.relatedCategories = response;
          _this.loading = false;
        });
      } else {
        this.loading = false;
      }
      if (this.source.related) {
        if (this.source.related.length >= 3) {
          this.selections = this.source.related.slice(0, 3);
        } else {
          this.selections = this.source.related.concat(new Array(3 - this.source.related.length));
        }
        this.activeEvents = (0, _lodash.map)(this.source.related, function (event) {
          return {
            'related_event_id': event.related_event_id,
            'related_event_type': event.related_event_type
          };
        });
      }
      this.select = [];
      this.imgix.reload();
    }
  }, {
    key: 'deslug',
    value: function deslug(input) {
      if (input) {
        return input.split('\\')[1].replace(/([A-Z])/g, ' $1').trim();
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this2 = this;

      this.source.related = (0, _lodash.uniqBy)(this.selections.filter(function (selection) {
        return Object.keys(selection).length > 0;
      }), function (selection) {
        return selection.related_event_type + selection.related_event_id;
      });

      this.selections = this.source.related;
      var dispatch = {
        'origin_type': this.type,
        'origin_id': this.source.id,
        'related_events': (0, _lodash.map)(this.source.related, function (related) {
          if (related) return { 'related_event_type': related.related_event_type, 'related_event_id': related.related_event_id };
        })
      };
      return this.eventsService.updateRelated(dispatch).catch(function () {
        _this2.messageService.failure('The related events could not be updated');
        _this2.messageService.push();
      }).then(function () {
        _this2.messageService.success('The related events have been successfully updated');
        _this2.selections = _this2.source.related.concat(new Array(3 - _this2.source.related.length));
        switch (_this2.type) {
          case 'SpaDay':
            _this2.formTab = 'day';
            break;
          case 'Treatment':
            _this2.formTab = 'treatment';
            break;
        }
        _this2.messageService.push();
      });
    }
  }, {
    key: 'currentEvent',
    value: function currentEvent(key, event) {
      if (event.related_event_id === this.source.id && event.related_event_type === this.source.type_raw) {
        return true;
      }
      return false;
    }
  }, {
    key: 'removeEvent',
    value: function removeEvent(index) {
      this.selections.splice(index, 1);
      this.selections.push({});
    }
  }, {
    key: 'selectEvent',
    value: function selectEvent() {
      var _this3 = this;

      setTimeout(function () {
        _this3.imgix.reload();
      });
    }
  }, {
    key: 'parsePrice',
    value: function parsePrice(price) {
      var strip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (strip) {
        price = price.toString().split('.')[0];
      }
      return this.$rootScope.currentProperty.currency_symbol + price;
    }
  }]);

  return RelatedFormController;
}();

RelatedFormController.$inject = ['$rootScope', 'eventsService', 'imgix', 'messageService'];

exports.default = RelatedFormController;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CrossFormController = function () {
  function CrossFormController($rootScope, eventsService, messageService) {
    _classCallCheck(this, CrossFormController);

    this.$rootScope = $rootScope;
    this.eventsService = eventsService;
    this.messageService = messageService;
  }

  _createClass(CrossFormController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.loading = true;
      this.select = [];
      if (this.source.cross) this.selections = this.source.cross.concat(new Array(3 - this.source.cross.length));
      if (!this.crossEvents) {
        this.eventsService.collectCross(this.type).then(function (response) {
          _this.crossEvents = response;
          _this.properties = Object.keys(_this.crossEvents);
          _this.loading = false;
          if (_this.source.cross) {
            if (_this.source.cross.length > 3) {
              _this.selections = _this.source.cross.slice(0, 3);
            }
            for (var event in _this.source.cross) {
              _this.selections[event] = (0, _lodash.find)(_this.crossEvents[_this.source.cross[event].owning_property], { id: _this.source.cross[event].id });
              _this.select[event] = _this.source.cross[event].owning_property;
            }
          }
        });
      } else {
        this.loading = false;
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this2 = this;

      var dispatch = {
        'origin_type': this.type,
        'origin_id': this.source.id,
        'cross_sells': this.selections
      };

      return this.eventsService.updateCross(dispatch).then(function () {
        _this2.messageService.success('The cross-sell events have been successfully updated');
        switch (_this2.type) {
          case 'SpaDay':
            _this2.formTab = 'day';
            break;
          case 'Treatment':
            _this2.formTab = 'treatment';
            break;
        }
        _this2.messageService.push();
      }).catch(function () {
        _this2.messageService.failure('The cross-sell events could not be updated');
        _this2.messageService.push();
      });
    }
  }, {
    key: 'currentEvent',
    value: function currentEvent(key, event) {
      if (event.id === this.source.id) {
        return true;
      }
      return false;
    }
  }, {
    key: 'removeEvent',
    value: function removeEvent(index) {
      this.selections.splice(index, 1);
      this.selections.push({});
    }
  }]);

  return CrossFormController;
}();

CrossFormController.$inject = ['$rootScope', 'eventsService', 'messageService'];

exports.default = CrossFormController;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExtrasListController = function () {
    function ExtrasListController($scope, $state, extrasService, messageService, access, $stateParams) {
        _classCallCheck(this, ExtrasListController);

        this.$scope = $scope;
        this.$state = $state;
        this.extrasService = extrasService;
        this.messageService = messageService;
        this.access = access;
        this.$stateParams = $stateParams;
    }

    _createClass(ExtrasListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.filtertext = this.$stateParams.filtertext || null;

            if (this.filtertext) {
                this.isFiltered = true;
            }

            this.updatePaging();
            this.$scope.$watch(function (scope) {
                return scope.current_page;
            }, function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.extras = undefined;
                        scope.$ctrl.extrasService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
                            scope.$ctrl.extras = response;
                            scope.$ctrl.loading = false;
                        });
                    } else {
                        scope.$ctrl.extrasService.findAll(newVal, scope.per_page).then(function (list) {
                            return scope.$ctrl.extras = list;
                        });
                    }
                }
            });
        }
    }, {
        key: 'onDelete',
        value: function onDelete(extra) {
            var _this = this;

            this.extrasService.delete(extra.id).then(function () {
                _this.messageService.success('The extra <strong>' + extra.name + '</strong> was successfully deleted.');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure('The extra <strong>' + extra.name + '</strong> could not be successfully deleted: ' + error.statusText);
                _this.messageService.push();
            }).then(function () {
                var page = _this.extras.current_page;
                _this.extras = [];
                _this.loading = true;
                return _this.extrasService.findAll(page).then(function (response) {
                    _this.extras = response;
                    _this.loading = false;
                });
            });
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            this.$scope.per_page = this.extras.per_page;
            this.$scope.current_page = this.extras.current_page;
            this.$scope.total = this.extras.total;
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this2 = this;

            if (!this.loading && this.filtertext) {
                this.startFilter();
                this.extrasService.search(this.filtertype, this.filtertext).then(function (response) {
                    _this2.isFiltered = true;
                    _this2.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this3 = this;

            if (this.isFiltered) {
                this.startFilter();
                this.extrasService.findAll(1, 20).then(function (response) {
                    _this3.isFiltered = false;
                    _this3.endFilter(response);
                });
            }
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            switch (this.filtertype) {
                case 'featured':
                case 'status':
                    this.filtertext = '1';
                    break;
                default:
                    this.filtertext = '';
                    break;
            }
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this.extras = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this.extras = response;
            this.updatePaging();
            this.loading = false;
        }
    }]);

    return ExtrasListController;
}();

ExtrasListController.$inject = ['$scope', '$state', 'extrasService', 'messageService', 'access', '$stateParams'];

exports.default = ExtrasListController;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExtrasSaveController = function () {
    function ExtrasSaveController($rootScope, $state, $stateParams, access) {
        _classCallCheck(this, ExtrasSaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
    }

    _createClass(ExtrasSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = this.$stateParams.tab || 'extra';
        }
    }]);

    return ExtrasSaveController;
}();

ExtrasSaveController.$inject = ['$rootScope', '$state', '$stateParams', 'access'];

exports.default = ExtrasSaveController;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExtrasFormController = function () {
    function ExtrasFormController(currentPropertyService, $state, extrasService, messageService, treatmentsService, integrationApiService) {
        _classCallCheck(this, ExtrasFormController);

        this.currentProperty = currentPropertyService;
        this.$state = $state;
        this.extrasService = extrasService;
        this.messageService = messageService;
        this.treatmentsService = treatmentsService;
        this.integrationApiService = integrationApiService;
    }

    _createClass(ExtrasFormController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.property = this.currentProperty.get();
            this.extra = this.extra || {};
            this.extra.options = this.extra.options || [];
            this.extra.property_id = this.property.id;

            this.treatmentsService.findAll(-1).then(function (response) {
                _this.treatments = response;
            });

            this.hasIntegration = !!this.property.integration;
            if (this.hasIntegration) {
                this.integrationApiService.integrationExtraCollect(this.property.id).then(function (response) {
                    _this.importedExtras = response;
                });
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this2 = this;

            return this.extrasService.save(this.extra).then(function (response) {
                if (_this2.extra.id) {
                    _this2.messageService.success('The extra <strong>' + _this2.extra.name + '</strong> was successfully updated!', ['app.admin.extra-edit({ \'extra\' : ' + _this2.extra.id + '})', 'Extra']);
                    _this2.$state.go('app.admin.extras');
                } else {
                    _this2.messageService.success('The extra <strong>' + _this2.extra.name + '</strong> was successfully created.');
                    _this2.$state.go('app.admin.extra-edit', { extra: response.id, tab: 'visibility' });
                }
            }).catch(function (error) {
                error.data = error.data.original || error.data;
                _this2.form.$api.setErrors(error.data);

                var sourceElement = Object.keys(error.data);
                var verb = 'created';
                if (_this2.extra.id) {
                    verb = 'updated';
                }

                if (sourceElement.length > 0) {

                    var errors = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var element = _step.value;

                            errors += '<li>' + _this2.messageService.formatError(element, error.data[element]) + '</li>';
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.messageService.failure('The extra <strong>' + _this2.extra.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
                } else {
                    _this2.messageService.failure('The extra <strong>' + _this2.extra.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
                }
                _this2.messageService.push();
            });
        }
    }, {
        key: 'addOption',
        value: function addOption() {
            this.extra.options.push({});
        }
    }]);

    return ExtrasFormController;
}();

ExtrasFormController.$inject = ['currentPropertyService', '$state', 'extrasService', 'messageService', 'treatmentsService', 'integrationApiService'];

exports.default = ExtrasFormController;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StartTimesController = function () {
    function StartTimesController($rootScope, $state, $scope, eventsService, messageService) {
        _classCallCheck(this, StartTimesController);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$scope = $scope;
        this.eventsService = eventsService;
        this.messageService = messageService;
    }

    _createClass(StartTimesController, [{
        key: '$onInit',
        value: function $onInit() {
            this.source.days = this.source.days || [];
            this.times = this.source.times || [];
            var timegap = 60 / this.$rootScope.currentProperty.start_time_interval;
            this.timegaps = ['00:00'];
            for (var i = 1; i < timegap; i++) {
                this.timegaps.push(this.$rootScope.currentProperty.start_time_interval * i + ':00');
            }
            this.timerange = [];

            var starttime = this.$rootScope.currentProperty.property_day_start.split(':')[0];
            var endtime = this.$rootScope.currentProperty.property_day_end.split(':')[0];

            for (var _i = starttime; _i < endtime; _i++) {
                var time = _i.toString().padStart(2, '0');
                this.timerange.push(time);
            }

            if (this.source.event_days) {
                this.transformDays(this.source);
            }
            this.toggles = [];
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            return this.eventsService.updateTimes(this.source, this.times).then(function () {
                switch (_this.source.type_name) {
                    case 'SpaDay':
                        _this.messageService.success('The start times for <strong>' + _this.source.name + '</strong> were successfully updated!', ['app.admin.day-edit({ \'day\' : ' + _this.source.id + '})', 'Spa Day']);
                        _this.$state.go('app.admin.days');
                        break;
                    case 'Treatment':
                        _this.messageService.success('The start times for <strong>' + _this.source.name + '</strong> were successfully updated!', ['app.admin.treatment-edit({ \'treatment\' : ' + _this.source.id + '})', 'Treatment']);
                        _this.$state.go('app.admin.treatments');
                        break;
                }
            }).catch(function () {
                _this.messageService.failure('The start times could not be successfully updated!');
            });
        }
    }, {
        key: 'addDay',
        value: function addDay(day) {
            if (!this.checkDay(day)) {
                this.source.days.push({ 'day': day.toString() });
            } else {
                (0, _lodash.pullAllBy)(this.source.days, [{ 'day': day.toString() }], 'day');
            }
        }
    }, {
        key: 'activeday',
        value: function activeday(day) {
            return (0, _lodash.find)(this.source.days, { 'day': day.toString() });
        }
    }, {
        key: 'activeTime',
        value: function activeTime(day, time) {
            if (this.activeday(day) && day in this.times) {
                if (this.times[day].indexOf(time) > -1) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }, {
        key: 'activeToggle',
        value: function activeToggle(time) {
            return this.toggles.indexOf(time) > -1;
        }
    }, {
        key: 'toggleTime',
        value: function toggleTime(day, time) {
            if (this.activeday(day)) {
                if (!(day in this.times)) this.times[day] = [];
                var current = this.times[day].indexOf(time);
                if (current > -1) {
                    this.times[day].splice(current, 1);
                } else {
                    if (!this.activeTime(day, time)) this.times[day].push(time);
                }
            }
        }
    }, {
        key: 'massToggleTime',
        value: function massToggleTime(time) {
            var toggled = this.toggles.indexOf(time);
            if (toggled === -1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.source.days[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var day = _step.value;

                        if (!(day.day in this.times)) this.times[day.day] = [];
                        if (!this.activeTime(day.day, time)) this.times[day.day].push(time);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.toggles.push(time);
            } else {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = this.source.days[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _day = _step2.value;

                        if (!(_day.day in this.times)) this.times[_day.day] = [];
                        var current = this.times[_day.day].indexOf(time);
                        this.times[_day.day].splice(current, 1);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                this.toggles.splice(toggled, 1);
            }
        }
    }, {
        key: 'finalTime',
        value: function finalTime() {
            return Number(this.timerange.slice(-1)[0]) + 1 + ':00:00';
        }
    }, {
        key: 'validateTime',
        value: function validateTime(day) {
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (this.timeRange) {
                if (this.timeRange.hasOwnProperty(day)) {
                    if (time) {
                        if (this.timeRange[day] && this.timeRange[day].start) {
                            if (time < this.timeRange[day].start) {
                                return false;
                            }
                        }
                        if (this.timeRange[day] && this.timeRange[day].end) {
                            if (time > this.timeRange[day].end) {
                                return false;
                            }
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    }, {
        key: 'reformatDay',
        value: function reformatDay(date) {
            if (date.format) {
                var day = parseInt(date.format('d'));
                return day === 0 ? 6 : day - 1;
            }
            return date;
        }
    }, {
        key: 'checkDay',
        value: function checkDay(day) {
            if (!(0, _lodash.find)(this.source.days, { 'day': day.toString() })) {
                return false;
            } else {
                return true;
            }
        }
    }, {
        key: 'transformDays',
        value: function transformDays(availability) {
            availability.days = [];
            availability.times = {};
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = availability.event_days[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var day = _step3.value;

                    availability.days.push(day);
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = day.event_start_times[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var times = _step4.value;

                            if (!availability.times[day.day]) availability.times[day.day] = [];
                            availability.times[day.day].push(times.start);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            delete availability.event_days;
            return availability;
        }
    }]);

    return StartTimesController;
}();

StartTimesController.$inject = ['$rootScope', '$state', '$scope', 'eventsService', 'messageService'];

exports.default = StartTimesController;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventMultiSelectFormController = function () {
    function EventMultiSelectFormController($scope, $state, messageService, eventsService) {
        _classCallCheck(this, EventMultiSelectFormController);

        this.$scope = $scope;
        this.$state = $state;
        this.messageService = messageService;
        this.eventsService = eventsService;
    }

    _createClass(EventMultiSelectFormController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            switch (this.formType) {
                case 'exclude':
                    this.prefix = 'excluded_';
                    this.container = 'exclusions';
                    this.preposition = 'from';
                    break;
                case 'include':
                    this.prefix = 'included_';
                    this.container = 'inclusions';
                    this.preposition = 'in';
                    break;
                case 'effect':
                    this.prefix = 'effected_';
                    this.container = 'events';
                    this.preposition = 'by';
                    break;
                case 'visibility':
                    this.prefix = '';
                    this.container = 'visibility';
                    this.preposition = 'for';
                    this.visibility = this.item.visibility;
                    break;
            }

            switch (this.names.single) {
                case 'offer':
                    this.saveFunc = 'updateOffer';
                    break;
                case 'discount':
                    this.saveFunc = 'updateDiscount';
                    break;
                case 'option':
                    this.saveFunc = 'updateOptionVisibility';
                    break;
                case 'extra':
                    this.saveFunc = 'updateExtraVisibility';
                    break;
            }

            this.existingEvents = this.existingEvents || {};

            if (Object.keys(this.existingEvents).length) {
                this.grouped_events = this.existingEvents;
                this.grouped_events.SpaDay = this.grouped_events.SpaDay || [];
                this.grouped_events.Treatment = this.grouped_events.Treatment || [];

                if (this.all) {
                    for (var group in this.grouped_events) {
                        var allsearch = this.search(null, group);
                        if (allsearch) this.grouped_events[group][0][this.prefix + 'event'] = this.allEvent(group);
                    }
                }
            } else {
                this.grouped_events = { 'SpaDay': [], 'Treatment': [] };
            }

            if (this.all) {
                this.internalDays = [this.allEvent('SpaDay'), this.divider()];
                this.internalTreatments = [this.allEvent('Treatment'), this.divider()];
            } else {
                this.internalDays = [];
                this.internalTreatments = [];
            }

            if (this.days || this.treatments) {
                this.internalDays = this.internalDays.concat((0, _lodash.cloneDeep)(this.days));
                this.internalTreatments = this.internalTreatments.concat((0, _lodash.cloneDeep)(this.treatments));
            } else {
                if (this.events) {
                    return this.events.then(function (response) {
                        _this.internalDays = _this.internalDays.concat(response.SpaDay);
                        _this.internalTreatments = _this.internalTreatments.concat(response.Treatment);
                    });
                } else {
                    return this.eventsService.collectGrouped().then(function (response) {
                        _this.internalDays = _this.internalDays.concat(response.SpaDay);
                        _this.internalTreatments = _this.internalTreatments.concat(response.Treatment);
                    });
                }
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this2 = this;

            var dispatch = [];

            for (var group in this.grouped_events) {
                dispatch = dispatch.concat(this.grouped_events[group]);
            }

            if (this.formType === 'visibility') {
                //temporary until all converted
                dispatch = {
                    events: dispatch
                };
                dispatch.visibility = this.visibility;
            }

            return this.eventsService[this.saveFunc](this.item.id, dispatch, this.container).then(function (response) {
                if (!response.error) {
                    _this2.messageService.success('The ' + _this2.names.single + ' was successfully updated!', ['app.admin.' + _this2.names.single + '-edit({ ' + _this2.names.single + ' : ' + _this2.item.id + '})', _this2.names.single.charAt(0).toUpperCase() + _this2.names.single.slice(1)]);
                    _this2.$state.go('app.admin.' + _this2.names.plural, {});
                } else {
                    var errorlist = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = response.error[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var error = _step.value;

                            errorlist += '<li><strong>' + error.event + '</strong> has a conflicting offer for the same time period; <strong>' + error.offer + '</strong></li>';
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.messageService.failure('The ' + _this2.names.single + ' was only partially updated, the following events were not saved:\n<ul>' + errorlist + '</ul>');
                    _this2.messageService.push();
                }
            }).catch(function (error) {
                _this2.messageService.failure('The ' + _this2.names.single + ' could not be successfully updated!');
                _this2.messageService.push();
            });
        }
    }, {
        key: 'addEvent',
        value: function addEvent(event) {
            var temp = {};
            if (event.id === 0) {
                this.grouped_events[event.type_name] = [];
                temp[this.prefix + 'event_type'] = 'App\\' + event.type_name;
                temp[this.prefix + 'event_id'] = 0;
            } else {
                temp[this.prefix + 'event_type'] = event.type_raw;
                temp[this.prefix + 'event_id'] = event.id;
            }
            temp[this.prefix + 'event'] = event;
            this.grouped_events[event.type_name].push(temp);
        }
    }, {
        key: 'listing',
        value: function listing(type) {
            switch (type) {
                case 'SpaDay':
                    return this.days;
                case 'Treatment':
                    return this.treatments;
            }
        }
    }, {
        key: 'selected',
        value: function selected(event) {
            var search = this.search(event);
            var typeSearch = this.search(null, event.type_name);
            return typeSearch && typeSearch > -1 || search && search > -1 || event.id === 'divider';
        }
    }, {
        key: 'unassignEvent',
        value: function unassignEvent(event) {
            var search = this.search(event);
            if (search) this.grouped_events[event.type_name].splice(search, 1);
        }
    }, {
        key: 'search',
        value: function search(event) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return (0, _lodash.findKey)(this.grouped_events[event ? event.type_name : type], _defineProperty({}, this.prefix + 'event_id', event ? event.id : 0));
        }
    }, {
        key: 'allEvent',
        value: function allEvent(type) {
            switch (type) {
                case 'SpaDay':
                    return { id: 0, name: 'All Spa Days', type_name: 'SpaDay' };

                case 'Treatment':
                    return { id: 0, name: 'All Treatments', type_name: 'Treatment' };
            }
        }
    }, {
        key: 'divider',
        value: function divider() {
            return { id: 'divider', name: '──────────' };
        }
    }, {
        key: 'hasEvents',
        value: function hasEvents() {
            return !!this.existingEvents && Object.keys(this.existingEvents).length > 0 && (Object.keys(this.existingEvents.Treatment).length > 0 || Object.keys(this.existingEvents.SpaDay).length > 0);
        }
    }]);

    return EventMultiSelectFormController;
}();

EventMultiSelectFormController.$inject = ['$scope', '$state', 'messageService', 'eventsService'];

exports.default = EventMultiSelectFormController;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OptionsFormController = function () {
    function OptionsFormController($timeout, $state, optionsService, imgix, messageService, access, currentPropertyService, integrationApiService) {
        _classCallCheck(this, OptionsFormController);

        this.$timeout = $timeout;
        this.$state = $state;
        this.optionsService = optionsService;
        this.imgix = imgix;
        this.messageService = messageService;
        this.access = access;
        this.currentPropertyService = currentPropertyService;
        this.integrationApiService = integrationApiService;
    }

    _createClass(OptionsFormController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.messageService.clear();

            this.isAdmin = this.access.check('admin');
            this.hasIntegration = !!this.currentPropertyService.get().integration;

            if (!this.option.option_group || !this.option.option_group.length) {
                this.option.option_group = [{ 'option_id': undefined, 'option_type': undefined }, { 'option_id': undefined, 'option_type': undefined }];
            }
            this.option.selections = this.option.selections || 1;

            this.imgix.reload();

            if (this.hasIntegration) {
                return this.integrationApiService.integrationPackageCollect(this.currentPropertyService.get().id).then(function (response) {
                    _this.importedPackages = response.filter(function (spaday) {
                        return spaday.options && Object.keys(spaday.options).length > 0;
                    });
                }).then(function () {
                    if (_this.option.integration_owner_identity) {
                        _this.loadOptions();
                    }
                });
            }
        }
    }, {
        key: 'deslug',
        value: function deslug(input) {
            if (input) {
                return input.split('\\')[1].replace(/([A-Z])/g, ' $1').trim();
            }
        }
    }, {
        key: 'addOption',
        value: function addOption() {
            this.option.option_group.push({ 'option_id': undefined, 'option_type': undefined });
        }
    }, {
        key: 'optionList',
        value: function optionList(type) {
            switch (type) {
                case 'App\\Treatment':
                    return this.treatments;
            }
        }
    }, {
        key: 'finditem',
        value: function finditem(option) {
            switch (option.option_type) {
                case 'App\\Treatment':
                    return (0, _lodash.find)(this.treatments, { id: option.option_id });
            }
        }
    }, {
        key: 'clearInputs',
        value: function clearInputs(option) {
            option.override_name = '';
            option.override_description = '';
            option.override_image = '';
        }
    }, {
        key: 'removeOption',
        value: function removeOption(key) {
            this.option.option_group.splice(key, 1);

            var maxLength = this.option.option_group.length - 1;
            if (this.option.selections > maxLength) {
                this.option.selections = maxLength;
            }
        }
    }, {
        key: 'loadOptions',
        value: function loadOptions() {
            var _this2 = this;

            this.optionsLoading = true;
            return this.integrationApiService.integrationSinglePackageCollect(this.currentPropertyService.get().id, this.option.integration_owner_identity).then(function (response) {
                _this2.importedOptions = _this2.sortOptions(response.options);
                _this2.optionsLoading = false;
            });
        }
    }, {
        key: 'sortOptions',
        value: function sortOptions(optionList) {
            if (!optionList) {
                return [{
                    integration_identity: null,
                    name: 'None available',
                    disabled: true
                }];
            }

            return Object.values(optionList).map(function (optionGroup) {
                if (optionGroup.selections === 1) {
                    return {
                        integration_identity: optionGroup.integration_identity,
                        name: 'Choose ' + optionGroup.selections + '; ' + optionGroup.options.map(function (option) {
                            return option.name;
                        }).join('/').trim('/')
                    };
                }
            }).filter(Boolean);
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this3 = this;

            for (var i in this.option.option_group) {
                if (this.option.option_group[i].option) {

                    this.option.option_group[i].option_id = this.option.option_group[i].option.id;
                    this.option.option_group[i].option = undefined;
                }

                if (!this.option.option_group[i].upgradeable) {
                    delete this.option.option_group[i].upgrade_name;
                    delete this.option.option_group[i].upgrade_description;
                    delete this.option.option_group[i].upgrade_value;
                    delete this.option.option_group[i].upgrade_image_path;
                    delete this.option.option_group[i].upgrade_image_url;
                }
            }

            delete this.option.grouped_visibility;

            return this.optionsService.save(this.option).then(function (response) {
                var name = _this3.option.name || 'unnamed';
                if (_this3.option.id) {
                    _this3.messageService.success('The option group <strong>' + name + '</strong> was successfully updated! Please update the exclusion rules if necessary.', ['app.admin.option-edit({ option : ' + _this3.option.id + '})', 'Option']);
                    _this3.$state.go('app.admin.options');
                } else {
                    _this3.messageService.success('The option group <strong>' + name + '</strong> was successfully created. Please create exclusion rules.');
                    _this3.option = response;
                    _this3.$state.go('app.admin.option-edit', { option: _this3.option.id, tab: 'visibility' });
                }
            }).catch(function (error) {
                error.data = error.data.original || error.data;
                _this3.form.$api.setErrors(error.data);

                var sourceElement = Object.keys(error.data);
                var verb = 'created';
                if (_this3.option.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    var errors = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var element = _step.value;

                            errors += '<li>' + _this3.messageService.formatError(element, error.data[element]) + '</li>';
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this3.messageService.failure('The option <strong>' + _this3.option.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
                } else {
                    _this3.messageService.failure('The option <strong>' + _this3.option.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
                }
                _this3.messageService.push();
            });
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            return this.option.option_group;
        }
    }, {
        key: 'setSelections',
        value: function setSelections(number) {
            this.option.selections = number;
        }
    }, {
        key: 'hasSelections',
        value: function hasSelections(number) {
            return this.option.selections === number;
        }
    }]);

    return OptionsFormController;
}();

OptionsFormController.$inject = ['$timeout', '$state', 'optionsService', 'imgix', 'messageService', 'access', 'currentPropertyService', 'integrationApiService'];

exports.default = OptionsFormController;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UpgradesListController = function () {
    function UpgradesListController($state, access, messageService) {
        _classCallCheck(this, UpgradesListController);

        this.$state = $state;
        this.access = access;
        this.messageService = messageService;
    }

    _createClass(UpgradesListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.matchEvents();
        }
    }, {
        key: 'matchEvents',
        value: function matchEvents() {
            var _this = this;

            this.matches = {
                treatment: [],
                spaday: []
            };
            this.upgrades.forEach(function (upgrade) {
                _this.matches[upgrade.origin.type].push({
                    originType: upgrade.origin.type,
                    origin: _this[upgrade.origin.type + 's'].find(function (event) {
                        return event.id === upgrade.origin.id;
                    }),
                    upgradeType: upgrade.upgrade.type,
                    upgrade: _this[upgrade.upgrade.type + 's'].find(function (event) {
                        return event.id === upgrade.upgrade.id;
                    })
                });
            });
        }
    }, {
        key: 'createUpgrade',
        value: function createUpgrade() {
            if (!this.createEvent) {
                this.messageService.failure('Please select an event before creating an upgrade');
                this.messageService.push();
            }

            var name = this.createEvent.type_name.toLowerCase();
            if (name === 'treatment') {
                this.loading = true;
                return this.$state.go('app.admin.treatment-edit', { treatment: this.createEvent.id, tab: 'upgrade' });
            }
            if (name === 'spaday') {
                this.loading = true;
                return this.$state.go('app.admin.spaday-edit', { spaday: this.createEvent.id, tab: 'upgrade' });
            }

            this.messageService.failure('Could not create an upgrade for that event');
            this.messageService.push();
        }
    }]);

    return UpgradesListController;
}();

UpgradesListController.$inject = ['$state', 'access', 'messageService'];

exports.default = UpgradesListController;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    categories: '<',
    pagedcategories: '<'
  },
  controller: 'categoryListController',
  template: __webpack_require__(734)
};

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Categories</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.category-add class=c-button--action> <icon icon=category></icon> Create a Category </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.categories class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedcategories class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <message closable=true></message> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'tree' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'tree'\" ng-if=$ctrl.categories.data.length> Hierarchy </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'list' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'list'\" ng-if=$ctrl.pagedcategories.data.length> List </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'tree'\"> <div class=columns ng-if=\"$ctrl.categories.tree.length === 0\"> <div class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text>No categories have been created yet.</p> </div> </div> </div> <div ui-tree=treeOptions data-max-depth=3 ng-if=$ctrl.categories.tree.length> <ol ui-tree-nodes=\"\" ng-model=$ctrl.categories.tree> <li ng-repeat=\"item in $ctrl.categories.tree\" ui-tree-node> <div ui-tree-handle> {{item.name}} <a data-nodrag class=c-drag-tree__button ng-click=$ctrl.onDelete(item) ng-if=\"$ctrl.access.check('manager')\" confirm=\"Are you sure you want to delete {{ item.name }}?\">Delete</a> <a data-nodrag class=c-drag-tree__button ui-sref=\"app.admin.category-edit({ category: item.id })\">Edit</a> </div> <ol ui-tree-nodes=\"\" ng-model=item.children> <li ng-repeat=\"item in item.children\" ui-tree-node> <div ui-tree-handle> {{item.name}} <a data-nodrag class=c-drag-tree__button ng-click=$ctrl.onDelete(item) ng-if=\"$ctrl.access.check('manager')\" confirm=\"Are you sure you want to delete {{ item.name }}?\">Delete</a> <a data-nodrag class=c-drag-tree__button ui-sref=\"app.admin.category-edit({ category: item.id })\">Edit</a> </div> <ol ui-tree-nodes=\"\" ng-model=item.children> <li ng-repeat=\"item in item.children\" ui-tree-node> <div ui-tree-handle> {{item.name}} <a data-nodrag class=c-drag-tree__button ng-click=$ctrl.onDelete(item) ng-if=\"$ctrl.access.check('manager')\" confirm=\"Are you sure you want to delete {{ item.name }}?\">Delete</a> <a data-nodrag class=c-drag-tree__button ui-sref=\"app.admin.category-edit({ category: item.id })\">Edit</a> </div> </li> </ol> </li> </ol> </li> </ol> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'list'\"> <div class=\"columns c-list__tab-inner\"> <form class=\"row c-list__search c-list__search--tab\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.pagedcategories.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text>No categories have been created yet.</p> </div> </div> <table ng-if=\"$ctrl.pagedcategories.data.length > 0\"> <thead> <tr> <th>Name</th> <th ng-if=\"$ctrl.access.check('manager')\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"category in $ctrl.pagedcategories.data\" class=\"c-list {{ category.deleted_at ? 'c-list__deleted' : ''}}\"> <td>{{ category.name }}</td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.category-edit({ category: category.id })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(category) confirm=\"Are you sure you want to delete {{ category.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <pagination ng-show=\"$ctrl.activeTab === 'list'\" total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </div> </main> ";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    options: '<'
  },
  controller: 'optionsListController',
  template: __webpack_require__(736)
};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Options</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.option-add class=c-button--action> <icon icon=option></icon> Create an Option </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.options class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedoptions class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <form class=\"row c-list__search c-list__search--tab\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> <option value=status>Status</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.options.data.length === 0\" class=\"c-empty c-empty--only\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text>No options have been created yet.</p> </div> </div> <table ng-if=\"$ctrl.options.data.length > 0\"> <thead> <tr> <th class=c-table__lights></th> <th>Name</th> <th ng-if=\"$ctrl.access.check('manager')\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"option in $ctrl.options.data\" class=\"c-list {{ option.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-table__lights> <span ng-class=\"(option.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (option.status)? 'This option is active' : 'This option is not active' }}\"></span> </td> <td>{{ option.name }}</td> <td class=c-list__action> <a ui-sref=\"app.admin.option-edit({ option: option.id })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(option) confirm=\"Are you sure you want to delete {{ option.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    category: '=',
    treatments: '<',
    days: '<',
    categories: '<'
  },
  controller: 'categoryFormController',
  template: __webpack_require__(738)
};

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.category.name ng-change=$ctrl.initialSlug() form-field-errors required> <label class=c-form__label for=name>Category Name</label> </div> <div class=c-form__url> <label class=c-form__url__label> https://{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/category/ </label> <div class=c-form__url__field> <input name=slug type=text class=inline ng-model=$ctrl.category.slug form-field-errors required ng-pattern=/^[a-zA-Z0-9-]+$/ > </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.category.description form-field-errors></textarea> <label class=c-form__label for=description_in>Description</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.category.description name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.category.description)></div> </div> </div> <div class=row> <div class=\"column medium-12\"> <label for=parent_select>Parent Category:</label> <select name=parent_select ng-model=$ctrl.category.parent ng-options=\"category as category.name disable when (category.id === $ctrl.category.id || category.level > 1 || ($ctrl.category.id && category.parent === $ctrl.category.id)) for category in $ctrl.categories.flat\" parent-select> <option value=\"\">None</option> </select> </div> </div> <label class=\"c-label c-label--large\">Category Image</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.category.image accept=image/jpeg,image/png current-url=$ctrl.category.image_url form-field-errors></file-upload> <label for=secret class=c-label>Secret</label> <p class=c-description>If enabled, this category, any included events and any child categories will be hidden from the storefront. This category and events contained within will still appear as credit-value Treatments if applicable.</p> <p>Direct URL: https://{{$ctrl.$rootScope.currentProperty.slug}}.{{ $ctrl.configService.get('domain') }}/category/{{ $ctrl.category.slug }}</p> <switch id=secret name=secret ng-model=$ctrl.category.secret class=green></switch> <fieldset ng-if=$ctrl.category.id> <ul class=c-accordion ng-class=\"{ 'c-accordion--active': $ctrl.expand}\"> <li class=c-accordion__item> <label ng-click=\"$ctrl.expand = !$ctrl.expand\" class=c-accordion__handle>Assigned Events</label> <div class=c-accordion__content> <div class=\"row columns\"> <p class=c-description>Adding, deleting or reordering items in these lists will update automatically in the background.</p> </div> <div class=\"row columns\"> <input type=checkbox id=forcePrimary ng-model=$ctrl.forcePrimary> <label for=forcePrimary>Force Primary Category assignment</label> </div> <div class=c-select-list> <div class=row> <div class=\"columns medium-6 c-select-list-left\"> <label class=c-select-list__label>Treatments</label> <div class=c-select-list__container data-ng-model=$ctrl.category.treatments data-as-sortable=$ctrl.treatmentDrag id=treatmentlist> <ul class=c-select-list__list> <li class=c-select-list__item ng-repeat=\"treatment in $ctrl.category.treatments\" data-as-sortable-item> {{treatment.related_event.name}} <div data-as-sortable-item-handle class=\"c-select-list__handle c-select-list__action\" tooltip=\"Reorder this treatment in this category\"> <icon icon=resize></icon> </div> <a class=\"c-select-list__delete c-select-list__action\" ng-click=$ctrl.unassignTreatment(treatment.related_event) tooltip=\"Remove this treatment from this category\"> <icon icon=cross></icon> </a> <a class=\"c-select-list__edit c-select-list__action\" ui-sref=\"app.admin.treatment-edit({ 'treatment': treatment.related_event.id})\" tooltip=\"Edit this treatment\"> <icon icon=edit></icon> </a> </li> </ul> </div> <div class=\"row c-select-list__row\"> <div class=\"columns medium-10\"> <ui-select ng-model=$ctrl.selectedtreatment uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=\"Add treatment...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"treatment in $ctrl.treatments | filter: $select.search track by treatment.id\" ui-disable-choice=$ctrl.validTreatments(treatment)> <span ng-bind=treatment.name></span> </ui-select-choices> </ui-select> </div> <div class=\"columns medium-2\"> <div class=c-select-list__add ng-show=$ctrl.selectedtreatment> <a ng-click=$ctrl.addTreatment() tooltip=\"Add this treatment to this category\"><span class=icon>+</span></a> </div> </div> </div> </div> <div class=\"columns medium-6\"> <label class=c-select-list__label>Spa Days</label> <div class=c-select-list__container data-ng-model=$ctrl.category.spadays data-as-sortable=$ctrl.dayDrag id=daylist> <ul class=c-select-list__list> <li class=c-select-list__item ng-repeat=\"day in $ctrl.category.spadays\" data-as-sortable-item> {{day.related_event.name}} <div width=10px data-as-sortable-item-handle class=\"c-select-list__handle c-select-list__action\" tooltip=\"Reorder this spa day in this category\"> <icon icon=resize></icon> </div> <a class=\"c-select-list__delete c-select-list__action\" ng-click=$ctrl.unassignDay(day.related_event) tooltip=\"Remove this spa day from this category\"> <icon icon=cross></icon> </a> <a class=\"c-select-list__edit c-select-list__action\" ui-sref=\"app.admin.day-edit({ 'day': day.related_event.id})\" tooltip=\"Edit this spa day\"> <icon icon=edit></icon> </a> </li> </ul> </div> <div class=\"row c-select-list__row\"> <div class=\"columns medium-10\"> <ui-select ng-model=$ctrl.selectedday uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=\"Add spa day...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"day in $ctrl.days | filter: $select.search track by day.id\" ui-disable-choice=$ctrl.validDays(day)> <span ng-bind=day.name></span> </ui-select-choices> </ui-select> </div> <div class=\"columns medium-2\"> <div class=c-select-list__add ng-show=$ctrl.selectedday> <a ng-click=$ctrl.addDay() tooltip=\"Add this spa day to this category\"><span class=icon>+</span></a> </div> </div> </div> </div> </div> </div> </div> </li> </ul> </fieldset> <hr> <label class=c-label for=terms>Terms &amp; Conditions</label> <p class=c-description>These terms will appear for all treatments and spa days with this category as primary unless overrides are set on an individual event.</p> <div class=c-form__field> <textarea name=terms class=c-form__textarea type=text ng-model=$ctrl.category.terms form-field-errors required></textarea> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Category <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    category: '=',
    treatments: '<',
    days: '<',
    categories: '<',
    title: '@'
  },
  controller: 'categorySaveController',
  template: __webpack_require__(740)
};

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.category.id>{{ $ctrl.category.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'profile' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'profile'\" ng-if=\"$ctrl.access.check('manager')\"> Category </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'profile'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <category-form category=$ctrl.category treatments=$ctrl.treatments days=$ctrl.days categories=$ctrl.categories> </category-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    option: '=',
    treatments: '<',
    days: '<',
    title: '@'
  },
  controller: 'optionsSaveController',
  template: __webpack_require__(742)
};

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.option.id>{{ $ctrl.option.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'profile' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'profile'\" ng-if=\"$ctrl.access.check('manager')\"> Option </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'visibility' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'visibility'\" ng-if=\"$ctrl.option.id && $ctrl.access.check('manager')\"> Visibility </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'profile'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <options-form option=$ctrl.option treatments=$ctrl.treatments> </options-form></div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'visibility' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.option existing-events=$ctrl.option.grouped_visibility form-type=visibility names=\"{'single': 'option', 'plural': 'options'}\" form-tab=$ctrl.activeTab all=true></event-multi-select-form> </div> </div> </div> </div> </main> ";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    value: '='
  },
  controller: 'categoriesSelectController',
  template: __webpack_require__(744)
};

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "<ui-select multiple=multiple ng-model=$ctrl.value uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=Categories allow-clear=true> {{ $item.name }} </ui-select-match> <ui-select-choices repeat=\"category in $ctrl.categories | filter: $select.search track by category.id\"> <span ng-bind=category.displayname></span> </ui-select-choices> </ui-select> ";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    categorylist: '<'
  },
  controller: 'categorySelectController',
  template: __webpack_require__(746)
};

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "<hr> <div class=c-single-select> <div class=c-single-select__list ng-if=$ctrl.categories ng-model=$ctrl.categories> <div class=\"row c-single-select__row\" ng-repeat=\"(key, category) in $ctrl.categories\"> <div class=\"column medium-10\"> <ui-select required ng-model=$ctrl.categories[key].category_id uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=Category> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"category.id as category in $ctrl.categorylist | filter: { name: $select.search } track by $index\" ui-disable-choice=$ctrl.disableCategory(category.id)> <div ng-bind-html=\"category.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> <div class=\"column medium-2\"> <a class=c-single-select__delete ng-click=$ctrl.delete(key)>&times;</a> </div> </div> </div> <a ng-click=$ctrl.categories.push({}) class=c-single-select__add><span class=icon>+</span> <span>Add new category</span></a> </div>";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        source: '<',
        type: '@',
        formTab: '='
    },
    controller: 'relatedFormController',
    template: __webpack_require__(748)
};

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-related> <div class=c-related__event ng-repeat=\"(key, i) in $ctrl.selections track by $index\"> <div class=row> <div class=\"columns medium-6\"> <h3 ng-if=!i.related_event>Add a related event</h3> <h3 ng-if=i.related_event>Update a related event</h3> <div class=row> <div class=\"columns medium-6\"> <div class=c-related__field> <select ng-model=$ctrl.select[key].cat ng-options=\"category.name for category in $ctrl.relatedCategories\" ng-disabled=$ctrl.loading> <option value=\"\" disabled=disabled>Select a Category...</option> </select> <spinner ng-if=$ctrl.loading></spinner> </div> </div> <div class=\"columns medium-6\"> <select ng-model=$ctrl.selections[key] ng-show=$ctrl.select[key].cat ng-options=\"event.related_event.name group by event.related_event.type_display disable when $ctrl.currentEvent(key, event) for event in $ctrl.select[key].cat.events | orderBy:'related_event.name'\" ng-change=$ctrl.selectEvent()> <option value=\"\" disabled=disabled>Select an Event...</option> </select> </div> </div> <div class=c-related__preview__info ng-if=i.related_event> <table> <tr> <td>Event name</td> <td>{{i.related_event.name}}</td> </tr> <tr> <td>Event Type</td> <td>{{$ctrl.deslug(i.related_event_type)}}</td> </tr> <tr> <td>Price</td> <td> <money amount=i.related_event.base_price decorate=true></money> </td> </tr> </table> <div class=c-slab--info ng-if=!i.related_event.status> <p><strong>Not Enabled</strong><br> This event will not be shown to the public as it is currently not active.</p> </div> <div class=c-slab--info ng-if=i.related_event.secret> <p><strong>Secret</strong><br> This event will not be shown to the public as it is currently secret. It can only be accessed via a direct URL.</p> </div> <div class=c-related__actions> <a href=/admin/events/treatments/{{i.related_event.id}}/update target=_blank title=\"Edit related event\" ng-if=\"$ctrl.deslug(i.related_event_type) === 'Treatment'\">Edit this related event</a> <a href=/admin/events/days/{{i.related_event.id}}/update target=_blank title=\"Edit related event\" ng-if=\"$ctrl.deslug(i.related_event_type) === 'Spa Day'\">Edit this related event</a> </div> </div> </div> <div class=\"columns medium-6\"> <div class=c-related__preview ng-if=i.related_event imgix-refresh> <div class=c-related__previewslide> <div class=c-related__previewslide__image> <div imgix-src=\"{{ i.related_event.image_url }}\" data-fit=fit></div> <div class=c-related__previewslide__price>From <money amount=i.related_event.base_price decorate=true round=true></money> </div> </div> <div class=c-related__previewslide__headings> <p class=c-related__previewslide__preheading> PRIMARY CATEGORY </p> <h3 class=c-related__previewslide__heading> {{ i.related_event.name }} </h3> </div> </div> <span class=c-close ng-click=$ctrl.removeEvent($index) tooltip=\"Remove this related event\" tooltip-placement=left><span>&times;</span></span> </div> <div class=c-related__preview--empty ng-if=!i.related_event> </div> </div> </div> <hr ng-if=!$last> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Related Events <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        source: '<',
        type: '@',
        formTab: '='
    },
    controller: 'crossFormController',
    template: __webpack_require__(750)
};

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <p class=c-description>This form allows you to set equivalent events from other properties. This will be used to suggest alternative venues for events, if applicable.</p> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-related> <div class=c-related__event ng-repeat=\"(key, i) in $ctrl.selections track by $index\"> <div class=row> <div class=\"columns medium-12\"> <h3 ng-if=!i.id>Add a cross sell</h3> <h3 ng-if=i.id>Update a cross sell</h3> <div class=row style=position:relative> <div class=\"columns medium-4\"> <div class=c-related__field> <select ng-model=$ctrl.select[key] ng-disabled=$ctrl.loading> <option value=\"\" disabled=disabled>Select a Property...</option> <option ng-repeat=\"property in $ctrl.properties\">{{property}}</option> </select> <spinner ng-if=$ctrl.loading></spinner> </div> </div> <div class=\"columns medium-4\"> <select ng-model=$ctrl.selections[key] ng-show=$ctrl.select[key] ng-options=\"event.name disable when $ctrl.currentEvent(key, event) for event in $ctrl.crossEvents[$ctrl.select[key]] | orderBy:'cross_sell.name'\"> <option value=\"\" disabled=disabled>Select an Event...</option> </select> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns medium-6\"> <div class=c-related__cell__body>{{($ctrl.selections[key] ? ($ctrl.selections[key].status ? 'Active' : 'Inactive') : 'N/A')}}</div> </div> <div class=\"columns medium-6\"> <div class=c-related__cell__body>{{($ctrl.selections[key] ? ($ctrl.selections[key].secret ? 'Private' : 'Public') : 'N/A')}}</div> </div> </div> </div> <span class=c-close ng-click=$ctrl.removeEvent($index) tooltip=\"Remove this related event\" tooltip-placement=left><span>&times;</span></span> </div> </div> </div> <hr ng-if=!$last> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Cross Sells <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form>";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        activeDay: '&',
        source: '<',
        embed: '<',
        times: '=',
        noMessage: '<'
    },
    controller: 'startTimesController',
    template: __webpack_require__(752)
};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "<message closable=true ng-if=!$ctrl.noMessage></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-start-times__list> <div class=c-start-times__day> <div class=c-start-times__day__header>&nbsp;</div> <div class=c-start-times__hour ng-repeat=\"hour in $ctrl.timerange\"> <div ng-repeat=\"interval in $ctrl.timegaps\" class=c-start-times__time ng-click=\"$ctrl.massToggleTime(hour+':'+interval)\" ng-class=\"{ active : $ctrl.activeToggle(hour+':'+interval)}\"> <div>{{hour}}:{{interval}}</div> </div> </div> </div> <div class=c-start-times__day ng-repeat=\"(dkey, day) in ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']\" ng-class=\"{ disabled: !$ctrl.activeday($index)}\"> <div class=c-start-times__day__header ng-class=\"{ 'day-active' : $ctrl.activeday(dkey) }\" class=c-form__horizontal-list__button ng-click=\"$ctrl.validateTime(dkey) && $ctrl.addDay(dkey)\">{{day}}</div> <div class=c-start-times__hour ng-repeat=\"hour in $ctrl.timerange\"> <div ng-repeat=\"interval in $ctrl.timegaps\" class=c-start-times__time ng-click=\"$ctrl.validateTime(dkey, hour+':'+interval) && $ctrl.toggleTime(dkey, hour+':'+interval)\" ng-class=\"{ active : $ctrl.activeTime(dkey, hour+':'+interval), disabled : !$ctrl.validateTime(dkey, hour+':'+interval)}\"> <div>{{hour}}:{{interval}}</div> </div> </div> </div> </div> <form-buttons ng-if=!$ctrl.embed> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Arrival Times <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    extras: '<'
  },
  controller: 'extrasListController',
  template: __webpack_require__(754)
};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Extras</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.extra-add class=c-button--action> <icon icon=extra></icon> Create an Extra </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.extras class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedextras class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <form class=\"row c-list__search c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> <option value=status>Status</option> <option value=featured>Featured</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'featured'\"> <option value=1>Yes</option> <option value=0>No</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.extras.data.length === 0\" class=\"c-empty c-empty--only\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No extras have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No extras match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.extras.data.length > 0\"> <thead> <tr> <th class=c-table__lights></th> <th>Name</th> <th>Featured</th> <th ng-if=\"$ctrl.access.check('manager')\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"extra in $ctrl.extras.data\" class=\"c-list {{ extra.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-table__lights> <span ng-class=\"(extra.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (extra.status)? 'This extra is active' : 'This extra is not active' }}\"></span> </td> <td>{{ extra.name }}</td> <td class=c-table__lights>{{ extra.featured === true ? 'Yes' : 'No' }}</td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.extra-edit({ extra: extra.id })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(extra) confirm=\"Are you sure you want to delete {{ extra.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    extra: '=',
    title: '@'
  },
  controller: 'extrasSaveController',
  template: __webpack_require__(756)
};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.extras.id>{{ $ctrl.extras.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button ng-if=\"$ctrl.access.check('manager')\" class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'extra' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'extra'\"> Extra </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'visibility' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'visibility'\" ng-if=\"$ctrl.extra.id && $ctrl.access.check('manager')\"> Visibility </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'extra'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <extras-form extra=$ctrl.extra></extras-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'visibility'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.extra existing-events=$ctrl.extra.grouped_visibility form-type=visibility names=\"{'single': 'extra', 'plural': 'extras'}\" form-tab=$ctrl.activeTab all=true></event-multi-select-form> </div> </div> </div> </div> </main> ";

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        extra: '='
    },
    controller: 'extrasFormController',
    template: __webpack_require__(758)
};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.extra.name form-field-errors required> <label class=c-form__label for=name>Name</label> </div> <label class=\"c-label c-label--large\">Image</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.extra.image accept=image/jpeg,image/png current-url=$ctrl.extra.image_url form-field-errors></file-upload> <div class=row> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=base_price ng-model=$ctrl.extra.base_price form-field-errors></money-input> <label class=c-form__label for=price>Price</label> </div> <div class=c-form__field ng-if=!$ctrl.$rootScope.currentProperty.integration> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear treatment link\" tooltip-placement=left ng-click=\"$ctrl.extra.treatment_id = null\" ng-if=!$ctrl.$rootScope.currentProperty.integration>&times;</span> <label for=treatment class=c-label>Treatment Equivalent</label> <ui-select ng-model=$ctrl.extra.treatment_id name=treatment form-field-errors> <ui-select-match placeholder=Treatment> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"treatment.id as treatment in $ctrl.treatments | filter: {name: $select.search} track by treatment.id\"> <span ng-bind=treatment.name></span> </ui-select-choices> </ui-select> </div> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear integration link\" tooltip-placement=left ng-click=\"$ctrl.extra.integration_identity = null\" ng-if=$ctrl.hasIntegration>&times;</span> <label for=integration class=c-label>Integration Event</label> <ui-select ng-model=$ctrl.extra.integration_identity name=integration form-field-errors ng-disabled=!$ctrl.hasIntegration> <ui-select-match placeholder=\"Integration ID\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.integration_identity.toString() as item in $ctrl.importedExtras | filter: {name: $select.search} track by item.integration_identity\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.extra.description form-field-errors></textarea> <label class=c-form__label for=description_in>Description</label> </div> </div> </div> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this extra will appear for events on the checkout it is valid for.</p> <switch id=status name=status ng-model=$ctrl.extra.status class=green></switch> <label for=featured class=c-label>Featured Status</label> <p class=c-description>If enabled, this extra will feature more prominently on events it is valid for.</p> <switch id=status name=status ng-model=$ctrl.extra.featured class=green></switch> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Extra <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        item: '<',
        existingEvents: '<',
        names: '<',
        all: '<',
        formType: '@',
        formTab: '=',
        description: '@',
        events: '<'
    },
    controller: 'eventMultiSelectFormController',
    template: __webpack_require__(760)
};

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-event-multi-select> <h3>Current {{ $ctrl.container }}</h3> <div class=\"alert alert--info\" ng-if=\"$ctrl.formType === 'exclude' && !$ctrl.hasEvents() && ($ctrl.names.single !== 'offer' && $ctrl.names.single !== 'discount')\"> Currently, this {{ $ctrl.names.single }} will show for all Treatments and Spa Days on the checkout, please add some {{ $ctrl.container }} rules below to limit its appearance. </div> <div class=\"row columns\"> <p class=c-description ng-if=$ctrl.description ng-bind-html=$ctrl.description></p> <p class=c-description>This list <strong>will not</strong> auto-update in the background. Please add events then save the list to set {{ $ctrl.container }} for this {{ $ctrl.names.single }}.</p> </div> <div class=\"row align-center\" ng-if=\"$ctrl.formType === 'visibility'\"> <div class=\"columns medium-12 text-center\"> <h4 class=c-description>This {{ $ctrl.names.single }} will be</h4> </div> <div class=\"columns medium-5 text-right\" ng-class=\"{'u-muted-text': $ctrl.visibility}\"> <h4>NOT VISIBLE</h4> </div> <div class=\"columns medium-2\"> <label class=c-form__switch> <input class=switch-input type=checkbox ng-model=$ctrl.visibility /> <span class=switch-label></span> <span class=switch-handle></span> </label> </div> <div class=\"columns medium-5 text-left\"> <h4 ng-class=\"{'u-muted-text': !$ctrl.visibility}\">VISIBLE</h4> </div> <div class=\"columns medium-12 text-center\"> <h4 class=c-description>for the following events:</h4> </div> </div> <div class=c-select-list> <div class=row> <div class=\"columns medium-6 c-select-list-left\"> <label class=c-select-list__label>Treatments</label> <div class=\"row c-select-list__row\"> <div class=\"columns medium-12\"> <ui-select ng-model=$ctrl.selectedtreatment on-select=$ctrl.addEvent($ctrl.selectedtreatment) reset-search-input> <ui-select-match placeholder=\"Add treatment...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"treatment in $ctrl.internalTreatments | filter: $select.search track by treatment.id\" ui-disable-choice=$ctrl.selected(treatment)> <span ng-bind=treatment.name></span> </ui-select-choices> </ui-select> </div> </div> <ul class=c-select-list__list> <li class=c-select-list__item ng-repeat=\"treatment in $ctrl.grouped_events['Treatment']\"> {{treatment[$ctrl.prefix + 'event'].name}} <a class=\"c-select-list__delete c-select-list__action\" ng-click=\"$ctrl.unassignEvent(treatment[$ctrl.prefix + 'event'])\" tooltip=\"Remove this treatment\"> <icon icon=cross></icon> </a> </li> </ul> </div> <div class=\"columns medium-6\"> <label class=c-select-list__label>Spa Days</label> <div class=\"row c-select-list__row\"> <div class=\"columns medium-12\"> <ui-select ng-model=$ctrl.selectedday on-select=$ctrl.addEvent($ctrl.selectedday) reset-search-input> <ui-select-match placeholder=\"Add spa day...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"day in $ctrl.internalDays | filter: $select.search track by day.id\" ui-disable-choice=$ctrl.selected(day)> <span ng-bind=day.name></span> </ui-select-choices> </ui-select> </div> </div> <ul class=c-select-list__list> <li class=c-select-list__item ng-repeat=\"day in $ctrl.grouped_events['SpaDay']\"> {{day[$ctrl.prefix + 'event'].name}} <a class=\"c-select-list__delete c-select-list__action\" ng-click=\"$ctrl.unassignEvent(day[$ctrl.prefix + 'event'])\" tooltip=\"Remove this spa day\"> <icon icon=cross></icon> </a> </li> </ul> </div> </div> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save {{ $ctrl.names.single }} <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        option: '<',
        treatments: '<',
        formTab: '='
    },
    controller: 'optionsFormController',
    template: __webpack_require__(762)
};

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.option.name required form-field-errors> <label class=c-form__label for=name>Name</label> </div> <div class=row> <div class=\"columns medium-4\"> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this option group will be visible during the checkout process for relevant events.</p> <switch id=status name=status ng-model=$ctrl.option.status class=green ng-init=\"$ctrl.option.status = $ctrl.option.status || false\"></switch> </div> <div class=\"columns medium-4\" ng-show=$ctrl.hasIntegration> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear integration link\" tooltip-placement=left ng-click=\"$ctrl.option.integration_owner_identity = null\" ng-if=\"$ctrl.hasIntegration && $ctrl.isAdmin\" ng-show=!$ctrl.option.integration_identity>&times;</span> <label for=packages class=c-label>Integration Package</label> <ui-select ng-model=$ctrl.option.integration_owner_identity name=packages ng-change=\"$ctrl.loadOptions(); $ctrl.option.integration_identity = null\" form-field-errors ng-disabled=\"!$ctrl.hasIntegration || ($ctrl.hasIntegration && !$ctrl.isAdmin)\"> <ui-select-match placeholder=Package> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.integration_identity.toString() as item in $ctrl.importedPackages | filter: {name: $select.search} track by item.integration_identity\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> <div class=\"columns medium-4\" ng-show=\"$ctrl.hasIntegration && $ctrl.option.integration_owner_identity\"> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear integration link\" tooltip-placement=left ng-click=\"$ctrl.option.integration_identity = null\" ng-if=\"$ctrl.hasIntegration && $ctrl.isAdmin\">&times;</span> <label for=options class=c-label>Integration Selection Group</label> <ui-select ng-model=$ctrl.option.integration_identity name=options form-field-errors ng-disabled=\"!$ctrl.hasIntegration || ($ctrl.hasIntegration && !$ctrl.isAdmin) || $ctrl.optionsLoading\"> <ui-select-match placeholder=\"Selection Group\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.integration_identity.toString() as item in $ctrl.importedOptions | filter: {name: $select.search} track by item.integration_identity\" ui-disable-choice=item.disabled> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> </div> <hr> <p>An option group is a mandatory choice for the user as part of the checkout process, the user <strong>must</strong> choose from the choices created below.</p> <div class=button-group> <button type=button class=\"button round\" ng-class=\"{ 'button--hollow': !$ctrl.hasSelections(1) }\" ng-click=$ctrl.setSelections(1)>Choose 1</button> <button type=button ng-repeat=\"option in $ctrl.getOptions() track by $index\" class=\"button round\" ng-class=\"{ 'button--hollow': !$ctrl.hasSelections($index + 2) }\" ng-click=\"$ctrl.setSelections($index + 2)\" ng-if=\"$index + 2 < $ctrl.getOptions().length\">Choose {{ $index + 2 }}</button> </div> <h3>Choices</h3> <div class=row> <div class=\"columns medium-12\"> <div class=c-options__option ng-repeat=\"(okey, option) in $ctrl.option.option_group\"> <div class=row> <div class=\"c-options__selector columns medium-3\"> <div class=c-form__field> <select ng-model=option.option_type required ng-change=$ctrl.clearInputs(option)> <option value=\"\" disabled=disabled>Select an option type...</option> <option value=App\\Treatment>Treatment</option> <option value=Custom>Custom Option</option> </select> </div> <div ng-if=\"option.option_type === 'Custom'\"> <label for=upgradeable class=c-label>Upgradeable</label> <switch id=upgradeable name=upgradeable ng-model=option.upgradeable class=green ng-init=\"option.upgradeable = (!!option.upgrade_value || !!option.upgrade_name || !!option.upgrade_description)\"></switch> </div> </div> <div class=\"c-options__selector columns medium-8\"> <div class=c-form__field ng-if=\"option.option_type && option.option_type !== 'Custom'\"> <ui-select ng-model=option.option ng-change=$ctrl.previewUpdate(option) required> <ui-select-match placeholder=\"Select treatment...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"treatment in $ctrl.treatments | filter: $select.search track by treatment.id\" ui-disable-choice=$ctrl.isDisabled(treatment)> <span ng-bind=treatment.name></span> </ui-select-choices> </ui-select> </div> <div class=row ng-if=option.option_type> <div class=\"columns medium-6\"> <div class=c-form__field> <input ng-model=option.override_name type=text class=\"c-input c-form__input\" form-field-errors ng-required=\"option.option_type === 'Custom'\"/> <label class=c-form__label for=name><span ng-if=\"option.option_type !== 'Custom'\">Override </span>Name</label> </div> <div class=c-form__field> <textarea ng-model=option.override_description class=\"c-input c-form__textarea\" form-field-errors></textarea> <label class=c-form__label for=name><span ng-if=\"option.option_type !== 'Custom'\">Override </span>Description</label> </div> </div> <div class=\"columns medium-6\"> <label class=\"c-label c-label--large\"><span ng-if=\"option.option_type !== 'Custom'\">Override </span>Image</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=option.override_image accept=image/jpeg,image/png current-url=option.override_image_url form-field-errors></file-upload> </div> </div> <div class=row ng-if=option.upgradeable> <div class=\"columns medium-6\"> <div class=c-form__field> <input ng-model=option.upgrade_name type=text class=\"c-input c-form__input\" form-field-errors ng-required=option.upgradeable /> <label class=c-form__label for=upgrade_name>Upgrade Name</label> </div> <div class=\"c-form__field c-form__field--money\"> <money-input name=upgrade_value ng-model=option.upgrade_value form-field-errors></money-input> <label class=c-form__label for=price>Upgrade Value</label> </div> <div class=c-form__field> <textarea ng-model=option.upgrade_description class=\"c-input c-form__textarea\" form-field-errors></textarea> <label class=c-form__label for=upgrade_description>Upgrade Description</label> </div> </div> <div class=\"columns medium-6\"> <label class=\"c-label c-label--large\">Upgrade Image</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=option.upgrade_image accept=image/jpeg,image/png current-url=option.upgrade_image_url form-field-errors></file-upload> </div> </div> </div> <a ng-if=\"$ctrl.option.option_group.length > 2\" class=c-options__delete--option ng-click=$ctrl.removeOption(okey)>&times;</a> </div> </div> <a class=c-options__add ng-click=$ctrl.addOption(key)><span>&plus;</span>Add New Option</a> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Option Group <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    spadays: '<',
    treatments: '<',
    upgrades: '<'
  },
  controller: 'upgradesListController',
  template: __webpack_require__(764)
};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Upgrades</h1> <div class=row> <div class=\"columns medium-2\"></div> <div class=\"small-12 columns medium-8\"> <h2>Create an Upgrade</h2> <div class=row> <div class=\"medium-6 columns\"> <select ng-model=$ctrl.createEvent ng-disabled=$ctrl.loading> <option disabled=disabled value=\"\">Select an event to upgrade...</option> <optgroup label=Treatments> <option ng-repeat=\"event in $ctrl.treatments\" ng-value=event>{{ event.name }}</option> </optgroup> <optgroup label=\"Spa Days\"> <option ng-repeat=\"event in $ctrl.spadays\" ng-value=event>{{ event.name }}</option> </optgroup> </select> </div> <div class=\"medium-6 columns / text-left\"> <button class=\"button button--input\" ng-click=$ctrl.createUpgrade() ng-disabled=$ctrl.loading>Create Upgrade</button> </div> </div> </div> </div> </header> <main class=s-main> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <h2 class=text-center>Current Upgrades</h2> <spinner ng-if=$ctrl.loading></spinner> <div ng-if=!$ctrl.loading> <div ng-if=\"$ctrl.matches.spadays.length === 0 || $ctrl.matches.treatments.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text>No upgrades found</p> </div> </div> <div ng-repeat=\"(matchType, matches) in $ctrl.matches\" ng-if=\"$ctrl.matches[matchType].length > 0\"> <h3>{{matches[0].origin.type_display}}s</h3> <table class=\"c-list c-list--upgrades\"> <thead> <tr> <th> <h4>Original Event</h4> </th> <th> <h4>Upgrade</h4> </th> </tr> </thead> <tbody> <tr ng-repeat=\" match in matches\"> <td> <a ng-if=\"$ctrl.access.check('manager') && match.originType === 'spaday'\" ui-sref=\"app.admin.day-edit({ day: match.origin.id, tab: 'upgrade' })\">{{match.origin.name}}</a> <a ng-if=\"$ctrl.access.check('manager') && match.originType === 'treatment'\" ui-sref=\"app.admin.treatment-edit({ treatment: match.origin.id, tab: 'upgrade' })\">{{match.origin.name}}</a> <span ng-if=\"!$ctrl.access.check('manager')\">{{match.origin.name}}</span> </td> <td> <span>{{match.upgrade.name}}</span> </td> </tr> </tbody> </table> </div> </div> </div> </div> </main> ";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

var endpoint = function endpoint(property) {
    return '/api/' + property + '/events/categories';
};
var reconstruct = function reconstruct(property) {
    return '/api/' + property + '/events/reconstruct/categories';
};

exports.default = ['api', '$rootScope', 'categoriesTransformer', function (api, $rootScope, categoriesTransformer) {
    return {
        save: function save(category) {
            var url = category.id ? endpoint(api.property()) + '/' + category.id : endpoint(api.property());

            var submit = (0, _lodash.clone)(category);
            if (!submit.id) {
                if (submit.days && submit.days.length) submit.days = (0, _lodash.map)(submit.days, function (day) {
                    return day.day.id;
                });
                if (submit.treatments && submit.treatments.length) submit.treatments = (0, _lodash.map)(submit.treatments, function (treatment) {
                    return treatment.treatment.id;
                });
            }

            return api.upload(url, submit).then(function (response) {
                return response.data;
            });
        },
        delete: function _delete(id) {
            return api.delete(endpoint(api.property()) + '/' + id);
        },
        findAll: function findAll() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
                return response.data;
            });
        },
        findRelated: function findRelated() {
            return api.get(endpoint(api.property()) + '?page=-1&related=true').then(function (response) {
                return response.data;
            });
        },
        hierarchyFind: function hierarchyFind() {
            var flatten = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return api.get(endpoint(api.property()) + '?page=-1').then(function (response) {
                return categoriesTransformer.restructure(response.data, flatten);
            });
        },
        findById: function findById(id) {
            return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
                return response.data;
            });
        },
        reconstruct: function reconstruct(categories) {
            return api.post(endpoint(api.property()) + '/reconstruct', categories).then(function (response) {
                return response.data;
            });
        },
        search: function search(type, text) {
            var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var perpage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            return api.get('' + endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + ('&type=' + type + '&text=' + text)).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

var endpoint = function endpoint(property, event) {
    return '/api/' + property + '/events/collect';
};
var activeendpoint = function activeendpoint(property, event) {
    return '/api/' + property + '/events/collect/active';
};
var groupedendpoint = function groupedendpoint(property) {
    return '/api/' + property + '/events/collect/group';
};
var crossendpoint = function crossendpoint(property) {
    return '/api/' + property + '/events/collect/cross';
};
var categoryendpoint = function categoryendpoint(property) {
    return '/api/' + property + '/events/collect/categories';
};
var categoryFlatendpoint = function categoryFlatendpoint(property) {
    return '/api/' + property + '/events/collect/categories/flat';
};
var relationendpoint = function relationendpoint(property) {
    return '/api/' + property + '/events/relation/update';
};
var crossupdateendpoint = function crossupdateendpoint(property) {
    return '/api/' + property + '/events/cross/update';
};
var timesendpoint = function timesendpoint(property) {
    return '/api/' + property + '/events/times';
};
var upgradesendpoint = function upgradesendpoint(property) {
    return '/api/' + property + '/events/collect/upgrades';
};
var exclusionendpoint = function exclusionendpoint(property, name, id) {
    return '/api/' + property + '/events/' + name + '/' + id + '/exclusions';
};
var visibilityendpoint = function visibilityendpoint(property, name, id) {
    return '/api/' + property + '/events/' + name + '/' + id + '/visibility';
};
var offerendpoint = function offerendpoint(property, name, id) {
    return '/api/' + property + '/offer/' + id + '/' + name;
};
var discountendpoint = function discountendpoint(property, name, id) {
    return '/api/' + property + '/discount/' + id + '/' + name;
};
var optionsendpoint = function optionsendpoint(property) {
    return '/api/' + property + '/events/options/update';
};

exports.default = ['api', '$rootScope', 'availabilityApiService', function (api, $rootScope, availabilityApiService) {
    return {
        collectAll: function collectAll() {
            return api.get('' + endpoint(api.property())).then(function (response) {
                return response.data;
            });
        },
        collectActive: function collectActive() {
            var withCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var url = '' + activeendpoint(api.property());

            if (withCategories) {
                url += '?withCategories=true';
            }

            return api.get(url).then(function (response) {
                return response.data;
            });
        },
        collectGrouped: function collectGrouped() {
            return api.get('' + groupedendpoint(api.property())).then(function (response) {
                return response.data;
            });
        },
        collectCategories: function collectCategories() {
            return api.get('' + categoryendpoint(api.property())).then(function (response) {
                return response.data;
            });
        },
        collectCategoriesFlat: function collectCategoriesFlat() {
            return api.get('' + categoryFlatendpoint(api.property())).then(function (response) {
                return response.data;
            });
        },
        collectCross: function collectCross(type) {
            return api.get(crossendpoint(api.property()) + '/' + type.toLowerCase()).then(function (response) {
                return response.data;
            });
        },
        updateOptions: function updateOptions(dispatch) {
            return api.post('' + optionsendpoint(api.property()), dispatch).then(function (response) {
                return response.data;
            });
        },
        updateRelated: function updateRelated(dispatch) {
            return api.post('' + relationendpoint(api.property()), dispatch).then(function (response) {
                return response.data;
            });
        },
        updateCross: function updateCross(dispatch) {
            return api.post('' + crossupdateendpoint(api.property()), dispatch).then(function (response) {
                return response.data;
            });
        },
        collectUpgrades: function collectUpgrades() {
            return api.get('' + upgradesendpoint(api.property())).then(function (response) {
                return response.data;
            });
        },
        updateTimes: function updateTimes(source, times) {
            var dispatch = {
                'event_id': source.id,
                'event_type': source.type_raw,
                'days': (0, _lodash.map)(source.days, 'day'),
                'times': times
            };
            return api.post('' + timesendpoint(api.property()), dispatch).then(function (response) {
                return response.data;
            });
        },
        updateExclusions: function updateExclusions(id, data, name) {
            return api.post('' + exclusionendpoint(api.property(), name, id), data).then(function (response) {
                return response.data;
            });
        },
        updateOptionVisibility: function updateOptionVisibility(id, data) {
            return api.post('' + visibilityendpoint(api.property(), 'options', id), data).then(function (response) {
                return response.data;
            });
        },
        updateExtraVisibility: function updateExtraVisibility(id, data) {
            return api.post('' + visibilityendpoint(api.property(), 'extras', id), data).then(function (response) {
                return response.data;
            });
        },
        updateOffer: function updateOffer(id, data, name) {
            return api.post('' + offerendpoint(api.property(), name, id), data).then(function (response) {
                return response.data;
            });
        },
        updateDiscount: function updateDiscount(id, data, name) {
            return api.post('' + discountendpoint(api.property(), name, id), data).then(function (response) {
                return response.data;
            });
        },
        collectCustomisations: function collectCustomisations(eventType, eventId) {
            return api.get('/api/' + api.property() + '/' + availabilityApiService.switchEventType(eventType) + '/' + eventId + '/customisations').then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var endpoint = function endpoint(property) {
  return '/api/' + property + '/events/extras';
};

exports.default = ['api', '$rootScope', 'categoriesTransformer', function (api, $rootScope, categoriesTransformer) {
  return {
    save: function save(extra) {
      var url = extra.id ? endpoint(api.property()) + '/' + extra.id : endpoint(api.property());

      return api.upload(url, extra).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint(api.property()) + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var endpoint = function endpoint(property) {
  return '/api/' + property + '/events/options';
};

exports.default = ['api', '$rootScope', function (api, $rootScope) {
  return {
    save: function save(option) {
      var url = option.id ? endpoint(api.property()) + '/' + option.id : endpoint(api.property());

      return api.upload(url, option).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint(api.property()) + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var assignendpoint = function assignendpoint(property, category) {
    return '/api/' + property + '/events/categories/' + category + '/assign';
};
var unassignendpoint = function unassignendpoint(property, category) {
    return '/api/' + property + '/events/categories/' + category + '/unassign';
};
var reorderendpoint = function reorderendpoint(property, category) {
    return '/api/' + property + '/events/categories/' + category + '/reorder';
};

exports.default = ['api', '$rootScope', function (api, $rootScope) {
    return {
        unassignDay: function unassignDay(id, cat) {
            return api.get(unassignendpoint(api.property(), cat) + '/day/' + id).then(function (response) {
                return response.data;
            });
        },
        unassignTreatment: function unassignTreatment(id, cat) {
            return api.get(unassignendpoint(api.property(), cat) + '/treatment/' + id).then(function (response) {
                return response.data;
            });
        },
        assignDay: function assignDay(id, cat, forcePrimary) {
            if (forcePrimary) {
                forcePrimary = '?forcePrimary=true';
            }
            return api.get(assignendpoint(api.property(), cat) + '/day/' + id + (forcePrimary || '')).then(function (response) {
                return response.data;
            });
        },
        assignTreatment: function assignTreatment(id, cat, forcePrimary) {
            if (forcePrimary) {
                forcePrimary = '?forcePrimary=true';
            }
            return api.get(assignendpoint(api.property(), cat) + '/treatment/' + id + (forcePrimary || '')).then(function (response) {
                return response.data;
            });
        },
        reorderTreatments: function reorderTreatments(ids, cat) {
            return api.post(reorderendpoint(api.property(), cat) + '/treatments', ids).then(function (response) {
                return response.data;
            });
        },
        reorderDays: function reorderDays(ids, cat) {
            return api.post(reorderendpoint(api.property(), cat) + '/days', ids).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

exports.default = [function () {
    var restructure = function restructure(input) {
        var flatten = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        for (var i = 0; i < input.length; i++) {
            if (!('children' in input[i])) {
                input[i].children = [];
            }
            if (parseInt(input[i].parent, 10) > 0) {
                var parent = input[(0, _lodash.findKey)(input, { 'id': parseInt(input[i].parent, 10) })];
                if (parent) {
                    if (!('children' in parent)) {
                        parent.children = [input[i]];
                    } else {
                        parent.children.push(input[i]);
                    }
                }
            }
        }

        var result = (0, _lodash.filter)(input, function (item) {
            return !item.parent;
        });

        var collection = [];

        if (flatten) {
            var extract = function extract(arr) {
                for (var _i = 0; _i < arr.length; _i++) {
                    collection.push(arr[_i]);
                    if (arr[_i].level) arr[_i].name = '-'.repeat(arr[_i].level) + ' ' + arr[_i].name;
                    extract(arr[_i].children);
                }
            };

            extract(result);
        }

        return {
            'total': 0,
            'per_page': 20,
            'current_page': 1,
            'data': input,
            'tree': result,
            'flat': collection
        };
    };

    return {
        restructure: restructure
    };
}];

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _integration = __webpack_require__(772);

var _integration2 = _interopRequireDefault(_integration);

var _integrationStatus = __webpack_require__(773);

var _integrationStatus2 = _interopRequireDefault(_integrationStatus);

var _integrationTable = __webpack_require__(775);

var _integrationTable2 = _interopRequireDefault(_integrationTable);

var _integrationStatus3 = __webpack_require__(777);

var _integrationStatus4 = _interopRequireDefault(_integrationStatus3);

var _integrationTable3 = __webpack_require__(778);

var _integrationTable4 = _interopRequireDefault(_integrationTable3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var integrationModule = angular.module('spabooker.integration', ['spabooker.base']).config(_integration2.default).controller('integrationStatusController', _integrationStatus4.default).controller('integrationTableController', _integrationTable4.default).component('integrationStatus', _integrationStatus2.default).component('integrationTable', _integrationTable2.default);

exports.default = integrationModule.name;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.integration_status', {
        url: '/integration',
        component: 'integrationStatus',
        roles: ['manager']
    });
}];

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {},
  controller: 'integrationStatusController',
  template: __webpack_require__(774)
};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Integration Status</h1> </header> <main> <div class=c-tabs> <div class=c-tabs__content> <div class=row> <div class=\"small-12 columns c-integration-table\"> <label for=unlinked class=c-label>Show only unlinked items</label> <switch id=unlinked name=unlinked ng-model=$ctrl.onlyUnlinked class=green></switch> <integration-table tag=$ctrl.tags.spadays events=$ctrl.events.spadays only-unlinked=$ctrl.onlyUnlinked is-loading=\"$ctrl.isLoading('spadays')\"></integration-table> <hr> <integration-table tag=$ctrl.tags.treatments events=$ctrl.events.treatments only-unlinked=$ctrl.onlyUnlinked is-loading=\"$ctrl.isLoading('treatments')\"></integration-table> <hr> <integration-table tag=$ctrl.tags.extras events=$ctrl.events.extras only-unlinked=$ctrl.onlyUnlinked is-loading=\"$ctrl.isLoading('extras')\"></integration-table> </div> </div> </div> </div> </main> ";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        tag: '<',
        events: '<',
        onlyUnlinked: '<',
        isLoading: '<'
    },
    controller: 'integrationTableController',
    template: __webpack_require__(776)
};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "<section> <h2>{{ $ctrl.tag }}</h2> <spinner ng-if=$ctrl.isLoading></spinner> <div class=row ng-if=!$ctrl.isLoading> <div class=\"columns medium-8 vertical-divider\"> <h3>RevSpa</h3> <section class=c-integration-table--revspa ng-repeat=\"event in $ctrl.events.revspa\"> <div class=row ng-show=$ctrl.shouldShowEvent(event.linked)> <div class=\"columns medium-5 c-integration-table__section revspa\" tooltip={{event.name}}> <span class=textbox>{{ event.name }}</span> </div> <div ng-show=event.linked class=\"columns medium-2 c-integration-table__section linked text-center\"> <span class=\"textbox linked\"> linked to </span> </div> <div ng-show=!event.linked class=\"columns medium-2 c-integration-table__section unlinked text-center\"> <span class=textbox> not linked</span> </div> <div class=\"columns medium-5 c-integration-table__section core\" tooltip={{event.linked}}> <span ng-show=event.linked class=textbox> {{event.linked}} </span> </div> </div> </section> </div> <div class=\"columns medium-4\"> <h3>Core</h3> <section class=c-integration-table--core ng-repeat=\"event in $ctrl.events.core\"> <div class=row ng-show=$ctrl.shouldShowEvent(event.linked)> <div class=\"columns medium-8 c-integration-table__section core\" tooltip={{event.name}}> <span class=textbox> {{ event.name }} </span> </div> <div ng-show=event.linked class=\"columns medium-4 c-integration-table__section linked\"> <span class=textbox> Linked! </span> </div> </div> </section> </div> </div> </section> ";

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IntegrationStatusController = function () {
    function IntegrationStatusController(integrationApiService) {
        _classCallCheck(this, IntegrationStatusController);

        this.integrationApiService = integrationApiService;
    }

    _createClass(IntegrationStatusController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = ['spadays', 'treatments', 'extras'];

            this.events = {};

            this.tags = {
                'spadays': 'Spa Days/Packages',
                'treatments': 'Treatments/Appointments',
                'extras': 'Event Extras/Non-Stock Items'
            };

            this.onlyUnlinked = false;

            return Promise.all([this.getSpadays(), this.getTreatments(), this.getExtras()]);
        }
    }, {
        key: 'mapLinks',
        value: function mapLinks(data) {
            data.revspa.map(function (event) {
                if (event.integration_identity) {
                    var integrationEvent = data.integration.find(function (integrationEvent) {
                        return parseInt(integrationEvent.integration_identity) === parseInt(event.integration_identity);
                    });
                    if (integrationEvent) {
                        event.linked = integrationEvent.name;
                        integrationEvent.linked = true;
                    }
                }
                return event;
            });

            return data;
        }
    }, {
        key: 'getSpadays',
        value: function getSpadays() {
            var _this = this;

            return this.integrationApiService.getIntegrationStatus('spadays').then(function (data) {
                if (data.revspa.length || data.integration.length) {
                    _this.events.spadays = _this.mapLinks(data);
                }
                _this.stopLoading('spadays');
            });
        }
    }, {
        key: 'getTreatments',
        value: function getTreatments() {
            var _this2 = this;

            return this.integrationApiService.getIntegrationStatus('treatments').then(function (data) {
                if (data.revspa.length || data.integration.length) {
                    _this2.events.treatments = _this2.mapLinks(data);
                }
                _this2.stopLoading('treatments');
            });
        }
    }, {
        key: 'getExtras',
        value: function getExtras() {
            var _this3 = this;

            return this.integrationApiService.getIntegrationStatus('extras').then(function (data) {
                if (data.revspa.length || data.integration.length) {
                    _this3.events.extras = _this3.mapLinks(data);
                }
                _this3.stopLoading('extras');
            });
        }
    }, {
        key: 'stopLoading',
        value: function stopLoading(tag) {
            var index = this.loading.indexOf(tag);
            if (index > -1) {
                this.loading.splice(index, 1);
            }
        }
    }, {
        key: 'isLoading',
        value: function isLoading(tag) {
            return this.loading.indexOf(tag) > -1;
        }
    }]);

    return IntegrationStatusController;
}();

IntegrationStatusController.$inject = ['integrationApiService'];

exports.default = IntegrationStatusController;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IntegrationTableController = function () {
    function IntegrationTableController() {
        _classCallCheck(this, IntegrationTableController);
    }

    _createClass(IntegrationTableController, [{
        key: "shouldShowEvent",
        value: function shouldShowEvent(isLinked) {
            return !this.onlyUnlinked || this.onlyUnlinked && !isLinked;
        }
    }]);

    return IntegrationTableController;
}();

IntegrationTableController.$inject = [];

exports.default = IntegrationTableController;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(30);

var _periods = __webpack_require__(780);

var _periods2 = _interopRequireDefault(_periods);

var _periodsSave = __webpack_require__(782);

var _periodsSave2 = _interopRequireDefault(_periodsSave);

var _periodsForm = __webpack_require__(783);

var _periodsForm2 = _interopRequireDefault(_periodsForm);

var _pricingForm = __webpack_require__(784);

var _pricingForm2 = _interopRequireDefault(_pricingForm);

var _periodsList = __webpack_require__(785);

var _periodsList2 = _interopRequireDefault(_periodsList);

var _periodsList3 = __webpack_require__(786);

var _periodsList4 = _interopRequireDefault(_periodsList3);

var _periodsForm3 = __webpack_require__(788);

var _periodsForm4 = _interopRequireDefault(_periodsForm3);

var _pricingForm3 = __webpack_require__(790);

var _pricingForm4 = _interopRequireDefault(_pricingForm3);

var _periodsSave3 = __webpack_require__(792);

var _periodsSave4 = _interopRequireDefault(_periodsSave3);

var _periods3 = __webpack_require__(794);

var _periods4 = _interopRequireDefault(_periods3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var periodsModule = angular.module('spabooker.periods', ['spabooker.base', 'as.sortable']).config(_periods2.default).controller('periodsSaveController', _periodsSave2.default).controller('periodsFormController', _periodsForm2.default).controller('pricingFormController', _pricingForm2.default).controller('periodsListController', _periodsList2.default).component('periodsList', _periodsList4.default).component('periodsForm', _periodsForm4.default).component('pricingForm', _pricingForm4.default).component('periodsSave', _periodsSave4.default).factory('periodsService', _periods4.default);

exports.default = periodsModule.name;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _periods = __webpack_require__(781);

exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin.periods', {
    url: '/periods',
    component: 'periodsList',
    resolve: {
      periods: (0, _periods.resolvePeriods)(-1)
    },
    roles: ['manager']
  }).state('app.admin.deletedperiods', {
    url: '/periods/deleted',
    component: 'periodsList',
    resolve: {
      periods: (0, _periods.resolvePeriods)(-1, 0, 'deleted')
    },
    roles: ['admin']
  }).state('app.admin.period-add', {
    url: '/periods/create',
    component: 'periodsSave',
    resolve: {
      title: function title() {
        return 'Create a Period';
      }
    },
    roles: ['manager']
  }).state('app.admin.period-edit', {
    url: '/periods/:period/update?tab',
    component: 'periodsSave',
    resolve: {
      title: function title() {
        return 'Update a Period';
      },
      period: (0, _periods.resolvePeriod)()
    },
    roles: ['manager']
  });
}];

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvePeriod = exports.resolvePeriods = undefined;

var _lodash = __webpack_require__(2);

var resolvePeriods = exports.resolvePeriods = function resolvePeriods() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return ['periodsService', function (periodsService) {
    return periodsService.findAll(page, perpage, deleted).then(function (list) {
      return list;
    });
  }];
};

var resolvePeriod = exports.resolvePeriod = function resolvePeriod() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'period';

  return ['$stateParams', 'periodsService', function ($stateParams, periodsService) {
    return $stateParams[param] && $stateParams[param] > 0 ? periodsService.findById($stateParams[param]) : {};
  }];
};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PeriodSaveController = function () {
    function PeriodSaveController($rootScope, $state, $stateParams, access) {
        _classCallCheck(this, PeriodSaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
    }

    _createClass(PeriodSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = this.$stateParams.tab || 'period';
        }
    }]);

    return PeriodSaveController;
}();

PeriodSaveController.$inject = ['$rootScope', '$state', '$stateParams', 'access'];

exports.default = PeriodSaveController;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PeriodsFormController = function () {
  function PeriodsFormController($rootScope, $scope, $state, periodsService, messageService) {
    _classCallCheck(this, PeriodsFormController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.periodsService = periodsService;
    this.messageService = messageService;
  }

  _createClass(PeriodsFormController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.period = this.period || { pricing: [] };
      this.period.start = this.period.start ? (0, _moment2.default)(this.period.start, 'YYYY-MM-DD') : '';
      this.period.end = this.period.end ? (0, _moment2.default)(this.period.end, 'YYYY-MM-DD') : '';
      this.period.property_id = this.$rootScope.currentProperty.id;

      this.$scope.$watch(function () {
        return _this.period.start;
      }, function (newVal, oldVal, $scope) {
        if (newVal !== oldVal && (typeof newVal === 'undefined' ? 'undefined' : _typeof(newVal)) === 'object') {
          $scope.$ctrl.autoName();
        }
      }, true);
      this.$scope.$watch(function () {
        return _this.period.end;
      }, function (newVal, oldVal, $scope) {
        if (newVal !== oldVal && (typeof newVal === 'undefined' ? 'undefined' : _typeof(newVal)) === 'object') {
          $scope.$ctrl.autoName();
        }
      }, true);
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this2 = this;

      if (this.period.start) {
        this.period.start = this.period.start.format('YYYY-MM-DD');
      }

      if (this.period.end && typeof this.period.end !== 'boolean') {
        this.period.end = this.period.end.format('YYYY-MM-DD');
      }

      return this.periodsService.save(this.period).then(function (response) {
        if (_this2.period.id) {
          _this2.messageService.success('The period <strong>' + _this2.period.name + '</strong> was successfully updated!', ['app.admin.period-edit({ \'period\' : ' + _this2.period.id + '})', 'Period']);
          _this2.$state.go('app.admin.periods');
        } else {
          _this2.messageService.success('The period <strong>' + response.name + '</strong> was successfully created.');
          _this2.$state.go('app.admin.period-edit', { period: response.id, tab: 'pricing' });
        }
      }).catch(function (error) {
        error.data = error.data.original || error.data;
        _this2.form.$api.setErrors(error.data);

        var sourceElement = Object.keys(error.data);
        var verb = 'created';
        if (_this2.period.id) {
          verb = 'updated';
        }
        if (sourceElement.length > 0) {
          var errors = '';
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var element = _step.value;

              errors += '<li>' + _this2.messageService.formatError(element, error.data[element]) + '</li>';
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this2.messageService.failure('The period <strong>' + _this2.period.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
        } else {
          _this2.messageService.failure('The period <strong>' + _this2.period.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
        }
        _this2.messageService.push();
      });
    }
  }, {
    key: 'autoName',
    value: function autoName() {
      if (!this.period.custom_name) {
        if (_typeof(this.period.start) === 'object') {
          this.period.name = this.period.start.format('Do MMMM (YYYY)') + ' to ';

          if (_typeof(this.period.end) === 'object' || !this.period.end) {
            if (this.period.end && this.period.end.isValid()) {
              this.period.name += this.period.end.format('Do MMMM (YYYY)');
            } else {
              this.period.name += 'indefinite';
            }
          }
        } else {
          this.period.name = '';
        }
      }
    }
  }, {
    key: 'toggleAutoName',
    value: function toggleAutoName() {
      if (!this.period.custom_name) {
        this.autoName();
      }
    }
  }, {
    key: 'clearDate',
    value: function clearDate(model) {
      model = undefined;
      this.autoName();
    }
  }]);

  return PeriodsFormController;
}();

PeriodsFormController.$inject = ['$rootScope', '$scope', '$state', 'periodsService', 'messageService'];

exports.default = PeriodsFormController;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PricingFormController = function () {
    function PricingFormController($state, periodsService, eventsService, messageService, moneyService) {
        _classCallCheck(this, PricingFormController);

        this.$state = $state;
        this.periodsService = periodsService;
        this.eventsService = eventsService;
        this.messageService = messageService;
        this.moneyService = moneyService;
    }

    _createClass(PricingFormController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.open = [];
            this.loading = true;
            this.eventpopulation = this.eventsService.collectAll().then(function (response) {
                _this.events = response;
                _this.loading = false;
            });

            this.currency = this.moneyService.getCurrencyDetails();

            if (this.period.pricing.length > 0) {
                this.period.pricing = this.period.pricing;
                if (this.period.pricing.length === 1) {
                    this.open.push(0);
                }
            } else {
                this.addRule();
            }
            if (this.period.pricing) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.period.pricing[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var pricing = _step.value;
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = pricing.events[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var event = _step2.value;

                                if (event.days && event.days.length) {
                                    event.individual = true;
                                    var tempdays = {};
                                    for (var day in event.days) {
                                        tempdays[event.days[day].day] = event.days[day].pricing_value;
                                    }
                                    event.days = tempdays;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this2 = this;

            for (var rule in this.period.pricing) {
                for (var event in this.period.pricing[rule].events) {
                    this.period.pricing[rule].events[event].event = undefined;
                }
            }

            return this.periodsService.savePricing(this.period).then(function (response) {
                _this2.$state.go('app.admin.periods');
                _this2.messageService.success('The pricing for period <strong>' + _this2.period.name + '</strong> was successfully updated!');
            }).catch(function (error) {
                error.data = error.data.original || error.data;
                _this2.form.$api.setErrors(error.data);

                var sourceElement = Object.keys(error.data);
                var verb = 'created';
                if (_this2.period.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    var errors = '';
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = sourceElement[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var element = _step3.value;

                            errors += '<li>' + _this2.messageService.formatError(element, error.data[element]) + '</li>';
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    _this2.messageService.failure('The pricing <strong>' + _this2.period.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
                } else {
                    _this2.messageService.failure('The pricing <strong>' + _this2.period.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
                }
                _this2.messageService.push();
            });
        }
    }, {
        key: 'openList',
        value: function openList(key) {
            var location = this.open.indexOf(key);
            if (location > -1) {
                this.open.splice(location, 1);
            } else {
                this.open.push(key);
            }
        }
    }, {
        key: 'assignEvent',
        value: function assignEvent(event) {
            if (event.event) {
                event.event_type = event.event.type_raw;
                event.event_id = event.event.id;
                event.event.disabled = !event.event.disabled;
            }
        }
    }, {
        key: 'applyPricing',
        value: function applyPricing(event, rule) {
            var inputvalue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var value = event.individual && !rule.pricing_value ? inputvalue : rule.pricing_value || event.pricing_value;
            if (event.event) {
                if (value) {
                    if (rule.pricing_type && rule.pricing_value) {
                        return this.applyDiscount(rule.pricing_type, value, event.event.base_price);
                    } else if (rule.pricing_type && event.pricing_value) {
                        return this.applyDiscount(rule.pricing_type, value, event.event.base_price);
                    } else if (event.pricing_type && event.pricing_value) {
                        return this.applyDiscount(event.pricing_type, value, event.event.base_price);
                    } else if ((rule.pricing_type || event.pricing_type) && event.individual) {
                        return this.applyDiscount(rule.pricing_type || event.pricing_type, value, event.event.base_price);
                    }
                }
                return event.individual ? event.event.base_price : 'N/A';
            }
        }
    }, {
        key: 'applyDiscount',
        value: function applyDiscount(type, val, amount) {
            var returnval = void 0;
            switch (type) {
                case '#':
                    returnval = (amount + parseFloat(val)).toFixed(this.currency.decimals);
                    return returnval >= 0 ? returnval : 0;
                case '%':
                    returnval = (amount * ((100 + parseFloat(val / this.currency.magnitude)) / 100)).toFixed(this.currency.decimals);
                    return returnval >= 0 ? returnval : 0;
                case '=':
                    return val >= 0 ? parseFloat(val).toFixed(this.currency.decimals) : 0;
            }
        }
    }, {
        key: 'findEvent',
        value: function findEvent(event) {
            var _this3 = this;

            this.eventpopulation.then(function () {
                return event.event = (0, _lodash.find)(_this3.events, { id: event.event_id, type_raw: event.event_type });
            });
        }
    }, {
        key: 'showInput',
        value: function showInput(event, rule, type) {
            return rule.pricing_type && rule.pricing_type === type && rule.pricing_value > 0 || rule.pricing_type && !rule.pricing_value && rule.pricing_type === type || !rule.pricing_type && !rule.pricing_value && event.pricing_type && event.pricing_type === type;
        }
    }, {
        key: 'nullGlobal',
        value: function nullGlobal(rule) {
            if (!rule.pricing_type) {
                rule.pricing_value = undefined;
            }
        }
    }, {
        key: 'groupBy',
        value: function groupBy(item) {
            return item.type_display;
        }
    }, {
        key: 'addRule',
        value: function addRule() {
            this.open.push(this.period.pricing.push({ events: [{}] }) - 1);
        }
    }]);

    return PricingFormController;
}();

PricingFormController.$inject = ['$state', 'periodsService', 'eventsService', 'messageService', 'moneyService'];

exports.default = PricingFormController;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PeriodsListController = function () {
  function PeriodsListController($scope, $state, periodsService, messageService, access) {
    _classCallCheck(this, PeriodsListController);

    this.$scope = $scope;
    this.$state = $state;
    this.periodsService = periodsService;
    this.messageService = messageService;
    this.access = access;
  }

  _createClass(PeriodsListController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updatePaging();
      this.$scope.$watch(function (scope) {
        return scope.current_page;
      }, function (newVal, oldVal, scope) {
        if (newVal !== oldVal) {
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
            scope.$ctrl.periods = undefined;
            scope.$ctrl.periodsService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
              scope.$ctrl.periods = response;
              scope.$ctrl.loading = false;
            });
          } else {
            scope.$ctrl.periodsService.findAll(newVal, scope.per_page).then(function (list) {
              return scope.$ctrl.periods = list;
            });
          }
        }
      });
      this.dragControlListeners = {
        accept: function accept(sourceItemHandleScope, destSortableScope) {
          return true;
        },
        containment: '#list',
        containerPositioning: 'relative',
        orderChanged: function orderChanged(event) {
          event.source.sortableScope.$parent.$parent.$ctrl.savePosition();
        }
      };
    }
  }, {
    key: 'updatePaging',
    value: function updatePaging() {
      this.$scope.per_page = this.periods.per_page;
      this.$scope.current_page = this.periods.current_page;
      this.$scope.total = this.periods.total;
    }
  }, {
    key: 'onDelete',
    value: function onDelete(period) {
      var _this = this;

      this.periodsService.delete(period.id).then(function () {
        _this.messageService.success('The period <strong>' + period.name + '</strong> was successfully deleted.');
        _this.messageService.push();
      }).catch(function (error) {
        _this.messageService.failure('The period <strong>' + period.name + '</strong> could not be successfully deleted: ' + error.statusText);
        _this.messageService.push();
      }).then(function () {
        var page = _this.periods.current_page;
        _this.periods = [];
        _this.loading = true;
        return _this.periodsService.findAll(page).then(function (response) {
          _this.periods = response;
          _this.loading = false;
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this2 = this;

      if (!this.loading && this.filtertext) {
        this.isFiltered = true;
        this.periods = undefined;
        this.loading = true;
        this.periodsService.search(this.filtertype, this.filtertext).then(function (response) {
          _this2.periods = response;
          _this2.updatePaging();
          _this2.loading = false;
        });
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      var _this3 = this;

      if (this.isFiltered) {
        this.isFiltered = false;
        this.periods = undefined;
        this.loading = true;
        this.periodsService.findAll(-1).then(function (response) {
          _this3.periods = response;
          _this3.$scope.current_page = 1;
          _this3.$scope.total = response.total;
          _this3.loading = false;
        });
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        case 'cat':
          this.filtertext = this.categories.flat[0].id;
          break;
        case 'status':
          this.filtertext = '1';
          break;
        default:
          this.filtertext = '';
          break;
      }
    }
  }, {
    key: 'savePosition',
    value: function savePosition() {
      var _this4 = this;

      var periods = '';

      for (var i = 0; i < this.periods.length; i++) {
        periods += this.periods[i].id;
        if (i + 1 !== this.periods.length) {
          periods += ',';
        }
      }
      this.periodsService.updateList(periods).then(function () {
        _this4.messageService.success('The period priority order has been successfully updated');
        _this4.messageService.push();
        _this4.messageService.autoClear();
      }).catch(function (error) {
        _this4.messageService.failure('The period priority order could not be successfully updated: ' + error.statusText);
        _this4.messageService.push();
        _this4.messageService.autoClear();
      });
    }
  }]);

  return PeriodsListController;
}();

PeriodsListController.$inject = ['$scope', '$state', 'periodsService', 'messageService', 'access'];

exports.default = PeriodsListController;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    periods: '<'
  },
  controller: 'periodsListController',
  template: __webpack_require__(787)
};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Pricing Periods</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.period-add class=c-button--action> <icon icon=calendar></icon> Create a Pricing Period </a> </div> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.periods class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedperiods class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <form class=\"row c-list__search c-list__search--period\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> <option value=status>Status</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=\"row c-list--period\"> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.periods.length === 0 && !$ctrl.loading\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No periods have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No periods match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <div ng-if=\"$ctrl.periods.length > 0\" id=list data-as-sortable=$ctrl.dragControlListeners data-ng-model=$ctrl.periods class=\"c-table / c-periods-list__container\"> <div class=c-table__head> <div class=\"c-table__cell c-table__lights-cell\"></div> <div class=\"c-table__cell c-table__cell--name\">Name</div> <div class=\"c-table__cell c-table__cell__edit\" ng-if=\"$ctrl.access.check('manager')\"></div> <div class=\"c-table__cell c-table__cell__delete\" ng-if=\"$ctrl.access.check('manager')\"></div> <div class=\"c-table__cell c-table__cell__handle\" ng-if=\"$ctrl.access.check('manager')\"></div> </div> <div class=c-table__body> <div data-ng-repeat=\"period in $ctrl.periods\" class=\"c-table__row / c-list c-periods-list__drag {{ period.deleted_at ? 'c-list__deleted' : ''}}\" data-as-sortable-item> <div class=\"c-table__cell c-table__lights-cell\"><span ng-class=\"(period.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (period.status)? 'This period is active' : 'This period is not active' }}\"></span></div> <div class=\"c-table__cell c-table__cell--name\">{{ period.name }}</div> <div class=\"c-table__cell / c-list__action\" ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.period-edit({ period: period.id })\">Edit</a> </div> <div class=\"c-table__cell / c-list__action\" ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(period) confirm=\"Are you sure you want to delete {{ period.name }}?\">Delete</a> </div> <div width=10px data-as-sortable-item-handle class=\"c-table__cell / c-periods-list__handle\" ng-if=\"$ctrl.access.check('manager') && !period.deleted_at && !$ctrl.isFiltered\"> <icon icon=resize></icon> </div> </div> </div> </div> </div> </div> </main> ";

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    period: '='
  },
  controller: 'periodsFormController',
  template: __webpack_require__(789)
};

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=row> <div class=\"columns medium-10\"> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.period.name form-field-errors ng-disabled=!$ctrl.period.custom_name> <label class=c-form__label for=name>Name</label> <i class=\"c-icon c-icon--help\" tooltip=\"If left blank the name will be generated based on the dates provided\" tooltip-placement=left>?</i> <i class=\"c-icon c-icon--clear\" ng-click=\"$ctrl.period.name = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-2\"> <label for=custom_name class=c-label>Custom Name</label> <label class=\"c-label c-label--checkbox\" for=custom_name> <input type=checkbox name=custom_name id=custom_name ng-model=$ctrl.period.custom_name ng-change=$ctrl.toggleAutoName()> </label> </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=c-form__field> <input name=start_time type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly form-field-errors required ng-model=$ctrl.period.start moment-picker=$ctrl.period.start keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off> <label class=c-form__label for=start_time>Start Date</label> <i class=\"c-icon c-icon--clear-small\" ng-click=\"$ctrl.period.start = undefined; $ctrl.autoName()\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"column medium-6\"> <div class=c-form__field> <input name=end_time type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly form-field-errors ng-model=$ctrl.period.end moment-picker=$ctrl.period.end keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off min-date=$ctrl.period.start> <label class=c-form__label for=end_time>End Date</label> <i class=\"c-icon c-icon--clear-small\" ng-click=\"$ctrl.period.end = undefined; $ctrl.autoName()\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> </div> <label for=status class=c-label>Period Status</label> <p class=c-description>If enabled, rules assigned to this period will be applied.</p> <switch id=status name=status ng-model=$ctrl.period.status class=green></switch> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Time Period <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        period: '<',
        formTab: '='
    },
    controller: 'pricingFormController',
    template: __webpack_require__(791)
};

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <h2>Pricing Rules</h2> <div ng-repeat=\"(key, rule) in $ctrl.period.pricing\" class=c-period__pricing> <div class=row> <div class=\"columns medium-6\"> <label class=c-period__heading>Pricing Rule Identifier</label> <div class=c-form__field> <input name=name class=\"c-input / c-form__input c-form__input--icon-right\" type=text ng-model=rule.name form-field-errors> <label class=c-form__label for=name>Name</label> <i class=\"c-icon c-icon--help\" tooltip=\"If left blank the name will be generated based on the global rule\" tooltip-placement=bottom>?</i> <i class=\"c-icon c-icon--clear\" ng-click=\"rule.name = undefined\" tooltip=\"Clear this field\" tooltip-placement=bottom>&times;</i> </div> </div> <div class=\"columns medium-3\"> <label class=c-period__heading>Pricing Rule Type</label> <select ng-model=rule.pricing_type ng-change=$ctrl.nullGlobal(rule)> <option value=\"\">N/A</option> <option value=\"=\">New Price</option> <option value=#>+/- Value</option> <option value=%>+/- Percent</option> </select> </div> <div class=\"columns medium-3\"> <label class=c-period__heading>Pricing Rule Value</label> <div class=\"c-form__field c-form__field--money\" ng-if=\"rule.pricing_type === '#' || rule.pricing_type === '=' || !rule.pricing_type\"> <money-input name=pricing_value ng-disabled=!rule.pricing_type ng-model=rule.pricing_value form-field-errors></money-input> <label class=c-form__label for=price>+/- Value</label> </div> <div class=\"c-form__field c-form__field--money c-form__field--percentage\" ng-if=\"rule.pricing_type === '%'\"> <money-input name=pricing_value ng-disabled=!rule.pricing_type decorate=percentage ng-model=rule.pricing_value form-field-errors></money-input> <label class=c-form__label for=price>+/- Percent</label> </div> </div> <a class=c-period__pricing__remove ng-click=\"$ctrl.period.pricing.splice(key, 1)\">&times;</a> </div> <label ng-click=$ctrl.openList(key) class=c-period__expand ng-class=\"{ 'expanded' : $ctrl.open.indexOf(key) > -1}\">Events</label> <div class=c-period__pricing__events ng-class=\"{ 'expanded' : $ctrl.open.indexOf(key) > -1}\"> <div class=c-period__pricing__event ng-repeat=\"(ekey, event) in rule.events\"> <div class=row> <div class=\"columns medium-6 / c-period__selector\"> <label class=c-period__heading>Event</label> <ui-select ng-model=event.event ng-init=$ctrl.findEvent(event) uis-open-close=$ctrl.assignEvent(event) ng-disabled=$ctrl.loading required> <ui-select-match placeholder=\"Add event...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices group-by=$ctrl.groupBy repeat=\"item in $ctrl.events | filter: { name: $select.search } track by $index\" ui-disable-choice=item.disabled> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> <spinner class=c-period__loader ng-if=$ctrl.loading /> </div> <div class=\"columns medium-3\"> <div ng-if=!rule.pricing_type> <label class=c-period__heading>Event Pricing Type</label> <select ng-model=event.pricing_type ng-disabled=rule.pricing_type> <option value=\"\">N/A</option> <option value=\"=\">New Price</option> <option value=#>+/- Value</option> <option value=%>+/- Percent</option> </select> </div> <div ng-if=rule.pricing_value> <label class=c-period__heading>New Value</label> <money class=c-period__pricing__value ng-if=event.event amount=\"$ctrl.applyPricing(event, rule)\" decorate=true></money> </div> </div> <div class=\"columns medium-3\"> <label class=c-period__heading>Base Value</label> <money class=\"c-period__pricing__value c-period__pricing__value--base\" ng-if=event.event amount=event.event.base_price decorate=true></money> </div> </div> <div ng-if=!rule.pricing_value> <label class=\"c-label c-label--checkbox\"> <input type=checkbox name=individual id=individual ng-model=event.individual><span>Assign separate pricing for each day?</span> </label> </div> <div class=\"row align-right\"> <div ng-if=\"!event.individual || rule.pricing_value\" class=\"columns medium-6\"></div> <div class=\"columns {{event.individual ? 'medium-12' : 'medium-3' }}\"> <div ng-if=\"(!event.individual) && ((rule.pricing_type && !rule.pricing_value) || (event.pricing_type && !rule.pricing_type))\"> <label class=c-period__heading>Event Pricing Value</label> <div class=\"c-form__field c-form__field--money\" ng-if=\"$ctrl.showInput(event, rule, '#')\"> <money-input name=pricing_value ng-model=event.pricing_value form-field-errors></money-input> <label class=c-form__label for=price>+/- Value</label> </div> <div class=\"c-form__field c-form__field--money\" ng-if=\"$ctrl.showInput(event, rule, '=')\"> <money-input name=event_pricing_value ng-model=event.pricing_value form-field-errors></money-input> <label class=c-form__label for=price>Value</label> </div> <div class=\"c-form__field c-form__field--money\" ng-if=\"$ctrl.showInput(event, rule, '%')\"> <money-input name=event_pricing_value ng-model=event.pricing_value form-field-errors></money-input> <label class=c-form__label for=price>+/- Percent</label> </div> </div> <div ng-if=\"event.individual && !rule.pricing_value\"> <div class=row> <div class=\"columns medium-6 / c-period__day-block\" ng-repeat=\"day in ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']\"> <div class=row> <div class=\"columns medium-6\"> <span class=c-period__day-block__day>{{day}}</span> <div class=\"c-form__field c-form__field--money c-period__day-block__value\" ng-if=\"$ctrl.showInput(event, rule, '#')\"> <money-input name=day_pricing_value ng-disabled=\"rule.pricing_value || (!event.pricing_type && !rule.pricing_type)\" ng-model=event.days[$index] form-field-errors></money-input> </div> <div class=\"c-form__field c-form__field--money c-period__day-block__value\" ng-if=\"$ctrl.showInput(event, rule, '=')\"> <money-input name=day_pricing_value ng-disabled=\"rule.pricing_value || (!event.pricing_type && !rule.pricing_type)\" ng-model=event.days[$index] form-field-errors></money-input> </div> <div class=\"c-form__field c-form__field--money c-period__day-block__value\" ng-if=\"$ctrl.showInput(event, rule, '%')\"> <money-input name=day_pricing_value ng-disabled=\"rule.pricing_value || (!event.pricing_type && !rule.pricing_type)\" ng-model=event.days[$index] form-field-errors></money-input> <label class=c-form__label for=price>+/- Percent</label> </div> </div> <div class=\"columns medium-6\"> <span class=c-period__day-block__day>New value</span> <money class=c-period__pricing__value amount=\"$ctrl.applyPricing(event, rule, event.days[$index])\" decorate=true></money> </div> </div> </div> </div> </div> </div> <div ng-if=\"!event.individual && !rule.pricing_value\" class=\"columns medium-3\"> <label class=c-period__heading>New Value</label> <money class=c-period__pricing__value ng-if=event.event amount=\"$ctrl.applyPricing(event, rule)\" decorate=true></money> </div> <a ng-if=\"rule.events.length > 1\" class=c-period__pricing__remove ng-click=\"rule.events.splice(ekey, 1)\">&times;</a> </div> </div> <a class=c-period__add ng-click=rule.events.push({})> <span>+</span> Add new event </a> </div> </div> <a class=c-period__add ng-click=$ctrl.addRule()> <span>+</span> Add another pricing rule </a> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Pricing <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    period: '=',
    title: '@'
  },
  controller: 'periodsSaveController',
  template: __webpack_require__(793)
};

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help-area> <button class=c-help-area__button ng-click=\"$ctrl.help = !$ctrl.help;\"> <span class=c-help-area__button-icon>?</span> Help </button> <div class=\"c-help-area__content {{$ctrl.help ? 'open': ''}}\"> <help-area helptype=period></help-area> </div> </div> <header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=\"$ctrl.period.id && $ctrl.activeTab != 'period'\">{{ $ctrl.period.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'period' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'period'\" ng-if=\"$ctrl.access.check('manager')\"> Period </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'pricing' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'pricing'\" ng-if=\"$ctrl.access.check('manager') && $ctrl.period.start !== ''\"> Pricing </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.access.check('manager') && $ctrl.activeTab === 'period'\"> <div class=\"small-12 columns\"> <periods-form period=$ctrl.period></periods-form> </div> </div> <div class=row ng-if=\"$ctrl.access.check('manager') &&$ctrl.activeTab === 'pricing'\"> <div class=\"small-12 columns\"> <pricing-form period=$ctrl.period form-tab=$ctrl.activeTab></pricing-form> </div> </div> </div> </div> </main> ";

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = function endpoint(property) {
  return '/api/' + property + '/events/periods';
};
var pricingendpoint = function pricingendpoint(property, id) {
  return endpoint(property) + '/' + id + '/pricing';
};

exports.default = ['api', '$rootScope', function (api, $rootScope) {
  return {
    save: function save(period) {
      var url = period.id ? endpoint(api.property()) + '/' + period.id : endpoint(api.property());

      return api.upload(url, period).then(function (response) {
        return response.data;
      });
    },
    savePricing: function savePricing(period) {
      var url = period.id ? '' + pricingendpoint(api.property(), period.id) : pricingendpoint(api.property(), 0);

      return api.post(url, period).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint(api.property()) + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
        return response.data;
      });
    },
    toggleActive: function toggleActive(id) {
      return api.get(endpoint(api.property()) + '/status/' + id).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    },
    updateList: function updateList(periods) {
      return api.get(endpoint(api.property()) + '/priority/' + periods).then(function (response) {
        return response;
      });
    }
  };
}];

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pageContent = __webpack_require__(796);

var _pageContent2 = _interopRequireDefault(_pageContent);

var _pageContentSave = __webpack_require__(798);

var _pageContentSave2 = _interopRequireDefault(_pageContentSave);

var _pageContentForm = __webpack_require__(799);

var _pageContentForm2 = _interopRequireDefault(_pageContentForm);

var _pageContentList = __webpack_require__(800);

var _pageContentList2 = _interopRequireDefault(_pageContentList);

var _pageContentHome = __webpack_require__(801);

var _pageContentHome2 = _interopRequireDefault(_pageContentHome);

var _pageContentSpadays = __webpack_require__(802);

var _pageContentSpadays2 = _interopRequireDefault(_pageContentSpadays);

var _pageContentGeneric = __webpack_require__(803);

var _pageContentGeneric2 = _interopRequireDefault(_pageContentGeneric);

var _pageContentSave3 = __webpack_require__(804);

var _pageContentSave4 = _interopRequireDefault(_pageContentSave3);

var _pageContentForm3 = __webpack_require__(806);

var _pageContentForm4 = _interopRequireDefault(_pageContentForm3);

var _pageContentList3 = __webpack_require__(808);

var _pageContentList4 = _interopRequireDefault(_pageContentList3);

var _pageContentHome3 = __webpack_require__(810);

var _pageContentHome4 = _interopRequireDefault(_pageContentHome3);

var _pageContentTreatments = __webpack_require__(812);

var _pageContentTreatments2 = _interopRequireDefault(_pageContentTreatments);

var _pageContentSpadays3 = __webpack_require__(814);

var _pageContentSpadays4 = _interopRequireDefault(_pageContentSpadays3);

var _pageContentHeroText = __webpack_require__(816);

var _pageContentHeroText2 = _interopRequireDefault(_pageContentHeroText);

var _pageContentSingleText = __webpack_require__(818);

var _pageContentSingleText2 = _interopRequireDefault(_pageContentSingleText);

var _pageContentConfirmation = __webpack_require__(820);

var _pageContentConfirmation2 = _interopRequireDefault(_pageContentConfirmation);

var _pageContentCheckout = __webpack_require__(822);

var _pageContentCheckout2 = _interopRequireDefault(_pageContentCheckout);

var _pageContentEmail = __webpack_require__(824);

var _pageContentEmail2 = _interopRequireDefault(_pageContentEmail);

var _pageContent3 = __webpack_require__(826);

var _pageContent4 = _interopRequireDefault(_pageContent3);

var _pageContentTransformer = __webpack_require__(827);

var _pageContentTransformer2 = _interopRequireDefault(_pageContentTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageContentModule = angular.module('spabooker.pageContent', []).config(_pageContent2.default).controller('pageContentSaveController', _pageContentSave2.default).controller('pageContentFormController', _pageContentForm2.default).controller('pageContentListController', _pageContentList2.default).controller('pageContentHomeController', _pageContentHome2.default).controller('pageContentSpadaysController', _pageContentSpadays2.default).controller('pageContentGenericController', _pageContentGeneric2.default).component('pageContentSave', _pageContentSave4.default).component('pageContentForm', _pageContentForm4.default).component('pageContentList', _pageContentList4.default).component('pageContentHome', _pageContentHome4.default).component('pageContentTreatments', _pageContentTreatments2.default).component('pageContentSpadays', _pageContentSpadays4.default).component('pageContentSingleText', _pageContentSingleText2.default).component('pageContentConfirmation', _pageContentConfirmation2.default).component('pageContentCheckout', _pageContentCheckout2.default).component('pageContentEmail', _pageContentEmail2.default).component('pageContentHeroText', _pageContentHeroText2.default).factory('pageContentService', _pageContent4.default).factory('pageContentTransformer', _pageContentTransformer2.default);

exports.default = pageContentModule.name;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pageContent = __webpack_require__(797);

exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin.pageContent', {
    url: '/page-content',
    component: 'pageContentList',
    resolve: {
      pages: (0, _pageContent.resolvePageList)()
    },
    roles: ['manager']
  }).state('app.admin.emailPageContent', {
    url: '/email-content',
    component: 'pageContentList',
    resolve: {
      pages: (0, _pageContent.resolveEmailPageList)(),
      type: function type() {
        return 'email';
      }
    },
    roles: ['manager']
  }).state('app.admin.globalPageContent', {
    url: '/admin-page-content',
    component: 'pageContentList',
    resolve: {
      pages: (0, _pageContent.resolveAdminPageList)(),
      type: function type() {
        return 'global';
      }
    },
    roles: ['admin']
  }).state('app.admin.pageContent-edit', {
    url: '/page-content/:page',
    component: 'pageContentSave',
    resolve: {
      title: function title() {
        return 'Update a Page';
      },
      page: (0, _pageContent.resolvePageContent)()
    },
    roles: ['manager']
  }).state('app.admin.emailPageContent-edit', {
    url: '/email-content/:page',
    component: 'pageContentSave',
    resolve: {
      title: function title() {
        return 'Update Email Content';
      },
      page: (0, _pageContent.resolvePageContent)(),
      type: function type() {
        return 'email';
      }
    },
    roles: ['manager']
  }).state('app.admin.globalPageContent-edit', {
    url: '/admin-page-content/:page',
    component: 'pageContentSave',
    resolve: {
      title: function title() {
        return 'Update a Page';
      },
      page: (0, _pageContent.resolveAdminPageContent)(),
      type: function type() {
        return 'admin';
      }
    },
    roles: ['admin']
  });
}];

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolvePageList = exports.resolvePageList = function resolvePageList() {
  return ['pageContentService', function (pageContentService) {
    return pageContentService.list();
  }];
};

var resolveAdminPageList = exports.resolveAdminPageList = function resolveAdminPageList() {
  return ['pageContentService', function (pageContentService) {
    return pageContentService.adminList();
  }];
};

var resolveEmailPageList = exports.resolveEmailPageList = function resolveEmailPageList() {
  return ['pageContentService', function (pageContentService) {
    return pageContentService.emailList();
  }];
};

var resolvePageContent = exports.resolvePageContent = function resolvePageContent() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'page';

  return ['$stateParams', 'pageContentService', function ($stateParams, pageContentService) {
    return pageContentService.find($stateParams[param]);
  }];
};
var resolveAdminPageContent = exports.resolveAdminPageContent = function resolveAdminPageContent() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'page';

  return ['$stateParams', 'pageContentService', function ($stateParams, pageContentService) {
    return pageContentService.findAdmin($stateParams[param]);
  }];
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageContentSaveController = function () {
    function PageContentSaveController($rootScope, $state, $stateParams, pageContentService) {
        _classCallCheck(this, PageContentSaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.pageContentService = pageContentService;
    }

    _createClass(PageContentSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = 'content';
            if (this.type === 'admin') {
                this.pageDetails = this.pageContentService.globalPageDetails(this.$stateParams.page);
            } else {
                this.pageDetails = this.pageContentService.pageDetails(this.$stateParams.page);
            }

            if (!this.page || Object.keys(this.page).length === 0) {
                this.page = {
                    'property_id': this.admin ? 0 : this.$rootScope.currentProperty.id,
                    'page': this.pageDetails.slug
                };
            }
        }
    }]);

    return PageContentSaveController;
}();

PageContentSaveController.$inject = ['$rootScope', '$state', '$stateParams', 'pageContentService'];

exports.default = PageContentSaveController;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pageFormController = function () {
  function pageFormController($scope, $state, pageContentService, pageContentTransformer, messageService, access) {
    _classCallCheck(this, pageFormController);

    this.$scope = $scope;
    this.$state = $state;
    this.pageContentService = pageContentService;
    this.pageContentTransformer = pageContentTransformer;
    this.messageService = messageService;
    this.access = access;
  }

  _createClass(pageFormController, [{
    key: '$onInit',
    value: function $onInit() {
      if (this.page.sections && this.page.sections.options) {
        if (this.page.sections.options.active && this.page.sections.options.active === 'true') {
          this.page.sections.options.active = 1;
        } else {
          this.page.sections.options.active = 0;
        }
      }
    }
  }, {
    key: 'isSingleTextPageAdmin',
    value: function isSingleTextPageAdmin() {
      return this.access.check('admin') && ['privacy', 'terms', 'defaultcheckoutdays', 'defaultoptions', 'defaultsuggestions', 'defaultpayment', 'defaultreview', 'defaultconfirmation'].indexOf(this.pageDetails.slug) > -1;
    }
  }, {
    key: 'isSingleTextPageManager',
    value: function isSingleTextPageManager() {
      return ['payment', 'review', 'announcement', 'checkoutdays', 'options', 'confirmation', 'suggestions', 'manage-booking'].indexOf(this.pageDetails.slug) > -1;
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this = this;

      return this.pageContentService.save(this.pageContentTransformer.fromJson(this.page)).then(function () {
        var target = (_this.type ? 'app.admin.globalPageContent-edit' : 'app.admin.pageContent-edit') + ('({ \'page\' : \'' + _this.pageDetails.slug + '\'})');
        if (_this.page.updated_at) {
          _this.messageService.success('The <strong>' + _this.pageDetails.name + '</strong> content was successfully updated!', [target, 'page']);
        } else {
          _this.messageService.success('The <strong>' + _this.pageDetails.name + '</strong> content was successfully created.', [target, 'page']);
        }
      }).then(function () {
        _this.messageService.clear();
        if (_this.type) {
          switch (_this.type) {
            case 'global':
            case 'admin':
              _this.$state.go('app.admin.globalPageContent');
              return;
            case 'email':
              _this.$state.go('app.admin.emailPageContent');
              return;
          }
        } else {
          _this.$state.go('app.admin.pageContent');
        }
      }).catch(function (error) {
        _this.messageService.failure('The page <strong>' + _this.page.name + '</strong> could not be successfully created: ' + error.statusText);
        _this.messageService.push();
        var sourceElement = Object.keys(error.data)[0];
        if (sourceElement > 0) {
          _this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
        } else {
          _this.$scope.$ctrl.form.$setValidity(sourceElement, false);
        }
      });
    }
  }]);

  return pageFormController;
}();

pageFormController.$inject = ['$scope', '$state', 'pageContentService', 'pageContentTransformer', 'messageService', 'access'];

exports.default = pageFormController;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pageListController = function () {
  function pageListController($scope, $state, pageContentService, messageService, access) {
    _classCallCheck(this, pageListController);

    this.$scope = $scope;
    this.$state = $state;
    this.pageContentService = pageContentService;
    this.messageService = messageService;
    this.access = access;
  }

  _createClass(pageListController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: 'filter',
    value: function filter() {
      if (!this.loading && this.filtertext) {
        this.isFiltered = true;
        this.loading = true;
        this.pages = this.pageContentService.search(this.filtertype, this.filtertext);
        this.loading = false;
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      if (this.isFiltered) {
        this.isFiltered = false;
        this.loading = true;
        this.pages = this.pageContentService.list();
        this.loading = false;
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        default:
          this.filtertext = '';
          break;
      }
    }
  }, {
    key: 'editLink',
    value: function editLink(slug) {
      this.$state.go('app.admin.' + (this.type ? this.type + 'P' : 'p') + 'ageContent-edit', { page: slug });
    }
  }]);

  return pageListController;
}();

pageListController.$inject = ['$scope', '$state', 'pageContentService', 'messageService', 'access'];

exports.default = pageListController;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageContentHomeController = function () {
    function PageContentHomeController($state, markdownService, eventsService) {
        _classCallCheck(this, PageContentHomeController);

        this.$state = $state;
        this.marked = markdownService;
        this.eventsService = eventsService;
    }

    _createClass(PageContentHomeController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;
            this.eventsService.collectAll(-1).then(function (response) {
                _this.loading = false;
                _this.events = response.filter(function (event) {
                    return event.base_price > 0;
                });
            });
        }
    }, {
        key: 'groupEvents',
        value: function groupEvents(item) {
            return item.type_display;
        }
    }]);

    return PageContentHomeController;
}();

PageContentHomeController.$inject = ['$state', 'markdownService', 'eventsService'];

exports.default = PageContentHomeController;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageContentSpadaysController = function () {
    function PageContentSpadaysController($state, markdownService, eventsService) {
        _classCallCheck(this, PageContentSpadaysController);

        this.$state = $state;
        this.marked = markdownService;
        this.eventsService = eventsService;
    }

    _createClass(PageContentSpadaysController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;
            this.eventsService.collectAll(-1).then(function (response) {
                _this.loading = false;
                _this.events = response.filter(function (event) {
                    return event.base_price > 0;
                });
            });
        }
    }, {
        key: 'groupEvents',
        value: function groupEvents(item) {
            return item.type_display;
        }
    }]);

    return PageContentSpadaysController;
}();

PageContentSpadaysController.$inject = ['$state', 'markdownService', 'eventsService'];

exports.default = PageContentSpadaysController;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageContentGenericController = function () {
    function PageContentGenericController(markdownService) {
        _classCallCheck(this, PageContentGenericController);

        this.marked = markdownService;
    }

    _createClass(PageContentGenericController, [{
        key: '$onInit',
        value: function $onInit() {
            this.pageHasText();
        }
    }, {
        key: 'pageHasText',
        value: function pageHasText() {
            if (['register'].indexOf(this.page.page) > -1) {
                this.textFields = [{
                    field: 'text',
                    description: 'Email text'
                }];
            }
            if (['bookingconfirm'].indexOf(this.page.page) > -1) {
                this.textFields = [{
                    field: 'pre-detail',
                    description: 'Pre-detail text'
                }, {
                    field: 'post-detail',
                    description: 'Post-detail text'
                }];
            }
        }
    }]);

    return PageContentGenericController;
}();

PageContentGenericController.$inject = ['markdownService'];

exports.default = PageContentGenericController;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '=',
    title: '@',
    type: '<'
  },
  controller: 'pageContentSaveController',
  template: __webpack_require__(805)
};

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help-area> <button class=c-help-area__button ng-click=\"$ctrl.help = !$ctrl.help;\"> <span class=c-help-area__button-icon>?</span> Help </button> <div class=\"c-help-area__content {{$ctrl.help ? 'open': ''}}\"> <help-area helptype=markdown></help-area> </div> </div> <header class=c-page-head> <h1>{{ $ctrl.pageDetails.name }}</h1> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'content' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'content'\"> Content </button> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'content'\"> <div class=row> <div class=\"small-12 columns\"> <page-content-form page=$ctrl.page page-details=$ctrl.pageDetails type=$ctrl.type> </page-content-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '=',
    pageDetails: '<',
    type: '<'
  },
  controller: 'pageContentFormController',
  template: __webpack_require__(807)
};

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <page-content-home page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'home'\"></page-content-home> <page-content-treatments page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'treatments'\"></page-content-treatments> <page-content-spadays page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'spadays'\"></page-content-spadays> <page-content-hero-text page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'treatment' || $ctrl.pageDetails.slug === 'spaday' || $ctrl.pageDetails.slug === 'defaultspaday'\"></page-content-hero-text> <page-content-email page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'bookingconfirm'\"></page-content-email> <page-content-email page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'booking'\"></page-content-email> <page-content-email page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'pendingpayment'\"></page-content-email> <page-content-email page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'register'\"></page-content-email> <page-content-checkout page=$ctrl.page ng-if=\"$ctrl.pageDetails.slug === 'checkout'\"></page-content-checkout> <page-content-single-text page=$ctrl.page ng-if=$ctrl.isSingleTextPageManager()></page-content-single-text> <page-content-single-text page=$ctrl.page ng-if=$ctrl.isSingleTextPageAdmin()></page-content-single-text> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Page <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    pages: '<',
    type: '<'
  },
  controller: 'pageContentListController',
  template: __webpack_require__(809)
};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Page Content</h1> </header> <main class=s-main> <form class=\"row c-list__search c-list__search--page\" ng-if=!$ctrl.admin> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <table> <thead> <tr> <th>Name</th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"page in $ctrl.pages\" class=c-list> <td>{{ page.name }}</td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.editLink(page.slug)>Edit</a> </td> </tr> </tbody> </table> </div> </div> </main> ";

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentHomeController',
  template: __webpack_require__(811)
};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--home\"> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Hero Content</h2> <div class=c-form__image> <label class=c-label>Hero Logo</label> <p class=c-description>Images must be PNG or SVG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.hero.logo.image accept=image/svg+xml,image/png current-url=$ctrl.page.sections.hero.logo.image_url form-field-errors/>  </div> <div class=c-form__image> <label class=c-label>Hero Background</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.hero.background.image accept=image/jpeg,image/png current-url=$ctrl.page.sections.hero.background.image_url form-field-errors ng-required=\"!$ctrl.page.sections.hero.background.image_url || $ctrl.page.sections.hero.background.image\"/>  </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Unavailable Message</h2> <div class=c-form__field> <input name=overlay-content class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.overlay.treatment_overlay_content form-field-errors/> <label class=c-form__label for=treatment-overlay-content>Treatment Overlay Content</label> </div> <div class=c-form__field> <input name=overlay-content class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.overlay.spaday_overlay_content form-field-errors/> <label class=c-form__label for=spaday-overlay-content>Spa Day Overlay Content</label> </div> <div class=c-form__field> <input name=button-content class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.overlay.button_content form-field-errors/> <label class=c-form__label for=button-content>Button Content</label> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Lede Content</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.lede.heading form-field-errors/> <label class=c-form__label for=name>Lede Heading</label> </div> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.lede.text form-field-errors></textarea> <label class=c-form__label for=description_in>Lede Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.lede.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.lede.text)></div> </div> </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>CTA Interjection Content</h2> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.interjection.text form-field-errors></textarea> <label class=c-form__label for=description_in>Interjection Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.interjection.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.interjection.text)></div> </div> </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Image Slider</h2> <div class=\"\" ng-repeat=\"(key, value) in ['image_1','image_2','image_3','image_4','image_5','image_6','image_7','image_8','image_9','image_10'] track by $index\"> <div class=c-form__image> <label class=c-label>Image {{ key + 1 }}</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.slider[value].image accept=image/jpeg,image/png current-url=$ctrl.page.sections.slider[value].image_url form-field-errors/>  </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Event Promotion</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.promotion.heading form-field-errors/> <label class=c-form__label for=name>Promotion Heading</label> </div> <div class=\"\" ng-repeat=\"key in [1,2,3] track by $index\"> <label for=name>Event {{ key }} <span class=c-form__inline-remove ng-if=$ctrl.page.sections.promotion[key] ng-click=\"$ctrl.page.sections.promotion[key] = undefined\">Remove</span> </label> <ui-select ng-model=$ctrl.page.sections.promotion[key] ng-disabled=$ctrl.loading> <ui-select-match placeholder=\"Add event...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices group-by=$ctrl.groupEvents repeat=\"event.type_raw + '|' + event.id as event in $ctrl.events | filter: $select.search track by event.type_raw + '|' + event.id\"> <span ng-bind=event.name></span> </ui-select-choices> </ui-select> </div> </div> </div> ";

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: __webpack_require__(813)
};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--treatments\"> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Hero Content</h2> <div class=c-form__image> <label class=c-label>Hero Background</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.hero.background.image accept=image/jpeg,image/png current-url=$ctrl.page.sections.hero.background.image_url form-field-errors ng-required=\"!$ctrl.page.sections.hero.background.image_url || $ctrl.page.sections.hero.background.image\"/> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.hero.preheading form-field-errors/> <label class=c-form__label for=name>Hero Preheading</label> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.hero.heading form-field-errors/> <label class=c-form__label for=name>Hero Heading</label> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Unavailable Message</h2> <div class=c-form__field> <input name=overlay-content class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.overlay.overlay_content form-field-errors/> <label class=c-form__label for=overlay-content>Overlay Content</label> </div> <div class=c-form__field> <input name=button-content class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.overlay.button_content form-field-errors/> <label class=c-form__label for=button-content>Button Content</label> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Lede Content</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.lede.heading form-field-errors/> <label class=c-form__label for=name>Lede Heading</label> </div> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.lede.text form-field-errors></textarea> <label class=c-form__label for=description_in>Lede Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.lede.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.lede.text)></div> </div> </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Breaker CTA Content</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.preheading form-field-errors/> <label class=c-form__label for=name>CTA Preheading</label> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.heading form-field-errors/> <label class=c-form__label for=name>CTA Heading</label> </div> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.cta.text form-field-errors></textarea> <label class=c-form__label for=description_in>CTA Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.cta.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.cta.text)></div> </div> </div> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.button_url form-field-errors/> <label class=c-form__label for=name>CTA Button URL</label> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.button_text form-field-errors/> <label class=c-form__label for=name>CTA Button Text</label> </div> <div class=c-form__image> <label class=c-label>CTA Background</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.cta.background.image accept=image/jpeg,image/png current-url=$ctrl.page.sections.cta.background.image_url form-field-errors/> </div> </div> </div> ";

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentSpadaysController',
  template: __webpack_require__(815)
};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--spadays\"> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Hero Content</h2> <div class=c-form__image> <label class=c-label>Hero Background</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.hero.background.image accept=image/jpeg,image/png current-url=$ctrl.page.sections.hero.background.image_url form-field-errors ng-required=\"!$ctrl.page.sections.hero.background.image_url || $ctrl.page.sections.hero.background.image\"/>  </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.hero.preheading form-field-errors/> <label class=c-form__label for=name>Hero Preheading</label> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.hero.heading form-field-errors/> <label class=c-form__label for=name>Hero Heading</label> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Unavailable Message</h2> <div class=c-form__field> <input name=overlay-content class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.overlay.overlay_content form-field-errors/> <label class=c-form__label for=overlay-content>Overlay Content</label> </div> <div class=c-form__field> <input name=button-content class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.overlay.button_content form-field-errors/> <label class=c-form__label for=button-content>Button Content</label> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Lede Content</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.lede.heading form-field-errors/> <label class=c-form__label for=name>Lede Heading</label> </div> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.lede.text form-field-errors></textarea> <label class=c-form__label for=description_in>Lede Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.lede.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.lede.text)></div> </div> </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>CTA Interjection Content</h2> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.interjection.text form-field-errors></textarea> <label class=c-form__label for=description_in>Interjection Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.interjection.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.interjection.text)></div> </div> </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Breaker CTA Content</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.preheading form-field-errors/> <label class=c-form__label for=name>CTA Preheading</label> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.heading form-field-errors/> <label class=c-form__label for=name>CTA Heading</label> </div> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.cta.text form-field-errors></textarea> <label class=c-form__label for=description_in>CTA Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.cta.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.cta.text)></div> </div> </div> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.button_url form-field-errors/> <label class=c-form__label for=name>CTA Button URL</label> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.cta.button_text form-field-errors/> <label class=c-form__label for=name>CTA Button Text</label> </div> <div class=c-form__image> <label class=c-label>CTA Background</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.cta.background.image accept=image/jpeg,image/png current-url=$ctrl.page.sections.cta.background.image_url form-field-errors/>  </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Event Promotion</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.promotion.heading form-field-errors/> <label class=c-form__label for=name>Promotion Heading</label> </div> <div class=\"\" ng-repeat=\"key in [1,2,3] track by $index\"> <label for=name>Event {{ key }} <span class=c-form__inline-remove ng-if=$ctrl.page.sections.promotion[key] ng-click=\"$ctrl.page.sections.promotion[key] = undefined\">Remove</span> </label> <ui-select ng-model=$ctrl.page.sections.promotion[key] ng-disabled=$ctrl.loading> <ui-select-match placeholder=\"Add event...\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices group-by=$ctrl.groupEvents repeat=\"event.type_raw + '|' + event.id as event in $ctrl.events | filter: $select.search track by event.type_raw + '|' + event.id\"> <span ng-bind=event.name></span> </ui-select-choices> </ui-select> </div> </div> ";

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: __webpack_require__(817)
};

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--hero\"> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Hero Content</h2> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.hero.preheading form-field-errors/> <label class=c-form__label for=name>Hero Preheading</label> </div> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.hero.heading form-field-errors/> <label class=c-form__label for=name>Hero Heading</label> </div> </div> </div>";

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: __webpack_require__(819)
};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--single-text\"> <div class=c-form__fieldset ng-if=\"$ctrl.page.page === 'announcement'\"> <h2 class=c-form__fieldset__heading>Page Details</h2> <div class=row> <div class=\"columns medium-12\"> <div class=c-form__field> <label for=active class=c-label>Active</label> <switch id=active name=active ng-model=$ctrl.page.sections.options.active class=green /> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=title class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.heading.title form-field-errors required/> <label class=c-form__label for=title>Title</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=short_description class=\"c-input / c-form__input\" type=text ng-model=$ctrl.page.sections.body.short_text form-field-errors required/> <label class=c-form__label for=short_description> Short Description for popup </label> </div> </div> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Body Content</h2> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.body.text form-field-errors></textarea> <label class=c-form__label for=description_in>Body Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.body.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.body.text)></div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: __webpack_require__(821)
};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--confirmation\"> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Body Content</h2> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.body.text form-field-errors></textarea> <label class=c-form__label for=description_in>Body Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.body.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.body.text)></div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: __webpack_require__(823)
};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--checkout\"> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Hero Content</h2> <div class=c-form__image> <label class=c-label>Hero Background</label> <p class=c-description>Images must be PNG or JPG files.</p> <file-upload name=picture ng-model=$ctrl.page.sections.hero.background.image accept=image/jpeg,image/png current-url=$ctrl.page.sections.hero.background.image_url form-field-errors/> </div> </div> <div class=c-form__fieldset> <h2 class=c-form__fieldset__heading>Announcement Banner</h2> <div class=c-form__field> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.banner.text form-field-errors></textarea> <label class=c-form__label for=description_in>Banner Text</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.banner.text name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.banner.text)></div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: __webpack_require__(825)
};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-page-content c-page-content--email\"> <div class=c-form__fieldset> <div class=c-form__image> <label class=c-label>Hero Image</label> <p class=c-description>Image must be a PNG or JPG file. Image should be at least 580px wide.</p> <file-upload name=picture ng-model=$ctrl.page.sections.hero.header.image accept=image/jpeg,image/png current-url=$ctrl.page.sections.hero.header.image_url form-field-errors/> </div> <div class=row ng-if=$ctrl.textFields ng-repeat=\"textField in $ctrl.textFields\"> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name={{textField.field}} class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.page.sections.email[textField.field] form-field-errors></textarea> <label class=c-form__label for={{textField.field}}>{{textField.description}}</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.page.sections.email[textField.field] name={{textField.field}} class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.page.sections.email[textField.field])></div> </div> </div> <h2 class=c-form__fieldset__heading>Footer Links</h2> <div class=\"\" ng-repeat=\"(key, value) in ['link_1','link_2','link_3','link_4'] track by $index\"> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=\"{{value+'_text'}}\" type=text class=c-form__input ng-model=\"$ctrl.page.sections.footer[value+'_text']\" form-field-errors> <label class=c-form__label for=\"{{value+'_text'}}\">Link {{key+1}} Text</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=\"{{value+'_url'}}\" type=url class=c-form__input ng-model=\"$ctrl.page.sections.footer[value+'_url']\" form-field-errors> <label class=c-form__label for=\"{{value+'_url'}}\">Link {{key+1}} Location</label> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(2);

var endpoint = function endpoint(property) {
    return '/api/' + property + '/page-content';
};

var pages = [{
    'slug': 'home',
    'name': 'Home page'
}, {
    'slug': 'treatments',
    'name': 'Treatments Listing Page'
}, {
    'slug': 'treatment',
    'name': 'Individual Treatment Page'
}, {
    'slug': 'spadays',
    'name': 'Spa Days Listing Page'
}, {
    'slug': 'spaday',
    'name': 'Individual Spa Day Page'
}, {
    'slug': 'checkoutdays',
    'name': 'Checkout - Spa Day Step'
}, {
    'slug': 'options',
    'name': 'Checkout - Options Step'
}, {
    'slug': 'suggestions',
    'name': 'Checkout - Suggestions Step'
}, {
    'slug': 'payment',
    'name': 'Checkout - Payment Step'
}, {
    'slug': 'review',
    'name': 'Checkout - Review Step'
}, {
    'slug': 'confirmation',
    'name': 'Confirmation Page'
}, {
    'slug': 'announcement',
    'name': 'Announcement Page'
}, {
    'slug': 'manage-booking',
    'name': 'Manage Booking Page'
}];

var adminPages = [{
    'slug': 'defaultspaday',
    'name': 'Individual Spa Day',
    'admin': true
}, {
    'slug': 'privacy',
    'name': 'Privacy Policy',
    'admin': true
}, {
    'slug': 'terms',
    'name': 'Terms',
    'admin': true
}, {
    'slug': 'defaultcheckoutdays',
    'name': 'Checkout - Spa Day Step',
    'admin': true
}, {
    'slug': 'defaultoptions',
    'name': 'Checkout - Options Step',
    'admin': true
}, {
    'slug': 'defaultsuggestions',
    'name': 'Checkout - Suggestions Step',
    'admin': true
}, {
    'slug': 'defaultpayment',
    'name': 'Checkout - Payment Step',
    'admin': true
}, {
    'slug': 'defaultreview',
    'name': 'Checkout - Review Step',
    'admin': true
}, {
    'slug': 'defaultconfirmation',
    'name': 'Confirmation Page',
    'admin': true
}];

var emailPages = [{
    'slug': 'bookingconfirm',
    'name': 'Confirmation Email'
}, {
    'slug': 'register',
    'name': 'Registration Email'
}, {
    'slug': 'booking',
    'name': 'Order Received Email'
}, {
    'slug': 'pendingpayment',
    'name': 'Pending Payment Email'
}];

exports.default = ['api', 'pageContentTransformer', function (api, pageContentTransformer) {
    return {
        list: function list() {
            return pages;
        },
        adminList: function adminList() {
            return adminPages;
        },
        emailList: function emailList() {
            return emailPages;
        },
        save: function save(page) {
            return api.upload(endpoint(api.property()) + '/' + page.page, page).then(function (response) {
                return response.data;
            });
        },
        find: function find(page) {
            return api.get(endpoint(api.property()) + '/' + page).then(function (response) {
                return pageContentTransformer.toJson(response.data);
            });
        },
        findAdmin: function findAdmin(page) {
            return api.get(endpoint(0) + '/' + page).then(function (response) {
                return pageContentTransformer.toJson(response.data);
            });
        },
        search: function search(type, text) {
            return pages.filter(function (page) {
                return page.name.toLowerCase().includes(text.toLowerCase());
            });
        },
        pageDetails: function pageDetails(slug) {
            return (0, _lodash.find)(pages, { 'slug': slug }) || (0, _lodash.find)(emailPages, { 'slug': slug });
        },
        globalPageDetails: function globalPageDetails(slug) {
            return (0, _lodash.find)(adminPages, { 'slug': slug });
        }
    };
}];

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', '$rootScope', function (api, $rootScope) {
    return {
        toJson: function toJson(data) {
            if (data.sections) {
                var newSections = {};
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = data.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var section = _step.value;

                        newSections[section.section] = {};
                        if (section.elements) {
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = section.elements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var element = _step2.value;

                                    if (element.type === 'image') {
                                        newSections[section.section][element.element] = { 'image_url': element.value };
                                    } else {
                                        newSections[section.section][element.element] = element.value;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                data.sections = newSections;
                data.id = null;
            }

            return data;
        },

        fromJson: function fromJson(data) {
            if (data.sections) {
                for (var sectionKey in data.sections) {
                    for (var elementKey in data.sections[sectionKey]) {
                        if (data.sections[sectionKey][elementKey] && data.sections[sectionKey][elementKey].type_raw) {
                            data.sections[sectionKey][elementKey] = data.sections[sectionKey][elementKey].type_raw + '|' + data.sections[sectionKey][elementKey].id;
                        }
                    }
                }
            }

            return data;
        }
    };
}];

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _upgradeForm = __webpack_require__(829);

var _upgradeForm2 = _interopRequireDefault(_upgradeForm);

var _upgradeForm3 = __webpack_require__(830);

var _upgradeForm4 = _interopRequireDefault(_upgradeForm3);

var _upgrade = __webpack_require__(832);

var _upgrade2 = _interopRequireDefault(_upgrade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var upgradeModule = angular.module('spabooker.upgrade', []).controller('upgradeFormController', _upgradeForm2.default).component('upgradeForm', _upgradeForm4.default).factory('upgradeService', _upgrade2.default);

exports.default = upgradeModule.name;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UpgradeFormController = function () {
  function UpgradeFormController($rootScope, eventsService, upgradeService, imgix, messageService) {
    _classCallCheck(this, UpgradeFormController);

    this.$rootScope = $rootScope;
    this.eventsService = eventsService;
    this.upgradeService = upgradeService;
    this.imgix = imgix;
    this.messageService = messageService;
  }

  _createClass(UpgradeFormController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.loading = true;
      if (!this.collection) {
        this.eventsService.collectGrouped().then(function (response) {
          _this.collection = response;
          _this.loading = false;
          if (_this.source.upgrades && _this.source.upgrades[0]) {
            _this.source.upgrades[0].upgrade = (0, _lodash.find)(_this.collection[_this.source.type_name], { id: _this.source.upgrades[0].upgrade_id });
          }
        });
      } else {
        this.loading = false;
      }
      this.imgix.reload();
    }
  }, {
    key: 'upgradeSelected',
    value: function upgradeSelected() {
      return this.source.upgrades[0].upgrade;
    }
  }, {
    key: 'upgradeIsSpaDay',
    value: function upgradeIsSpaDay() {
      if (this.upgradeSelected()) {
        return this.source.upgrades[0].upgrade.type_name === 'SpaDay';
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this2 = this;

      var dispatch = {
        'origin_type': this.source.type_raw,
        'origin_id': this.source.id,
        'upgrades': (0, _lodash.map)(this.source.upgrades, function (upgrade) {
          return { 'id': upgrade.id || undefined, 'upgrade_type': upgrade.upgrade.type_raw, 'upgrade_id': upgrade.upgrade.id };
        })
      };

      return this.upgradeService.save(dispatch).catch(function () {
        _this2.messageService.failure('The upgrade could not be updated');
        _this2.messageService.push();
      }).then(function () {
        _this2.messageService.success('The upgrade has been successfully updated');
        switch (_this2.source.type_name) {
          case 'SpaDay':
            _this2.formTab = 'day';
            break;
          case 'Treatment':
            _this2.formTab = 'treatment';
            break;
        }
        _this2.messageService.push();
      });
    }
  }, {
    key: 'removeUpgrade',
    value: function removeUpgrade() {
      this.source.upgrades = [];
    }
  }, {
    key: 'selectEvent',
    value: function selectEvent() {
      var _this3 = this;

      setTimeout(function () {
        _this3.imgix.reload();
      });
    }
  }, {
    key: 'price',
    value: function price() {
      return Math.floor(this.source.upgrades[0].upgrade.base_price);
    }
  }]);

  return UpgradeFormController;
}();

UpgradeFormController.$inject = ['$rootScope', 'eventsService', 'upgradeService', 'imgix', 'messageService'];

exports.default = UpgradeFormController;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    source: '<',
    formTab: '='
  },
  controller: 'upgradeFormController',
  template: __webpack_require__(831)
};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-related> <div class=row> <div class=\"columns medium-6\"> <h3 ng-if=!$ctrl.source.upgrades[0].upgrade>Add an upgrade</h3> <h3 ng-if=$ctrl.source.upgrades[0].upgrade>Update an upgrade</h3> <div class=row> <div class=\"columns medium-12\"> <div class=c-related__field> <select ng-model=$ctrl.source.upgrades[0].upgrade ng-options=\"event.name disable when event.id === $ctrl.source.id for event in $ctrl.collection[$ctrl.source.type_name] | orderBy:'name'\" ng-change=$ctrl.selectEvent() ng-disabled=$ctrl.loading> <option value=\"\" disabled=disabled>Select an Event...</option> </select> <spinner ng-if=$ctrl.loading></spinner> </div> </div> </div> <div class=c-related__preview__info ng-if=$ctrl.source.upgrades[0].upgrade> <table> <tr> <td>Upgrade name</td> <td>{{$ctrl.source.upgrades[0].upgrade.name}}</td> </tr> <tr> <td>Upgrade Type</td> <td>{{$ctrl.source.upgrades[0].upgrade.type_display}}</td> </tr> <tr> <td>Price</td> <td> <money amount=$ctrl.source.upgrades[0].upgrade.base_price decorate=true></money> </td> </tr> <tr ng-if=$ctrl.source.upgrades[0].upgrade.credit> <td>Upgrade Credit</td> <td> <money amount=$ctrl.source.upgrades[0].upgrade.credit decorate=true></money> </td> </tr> </table> <div class=c-slab--info ng-if=!$ctrl.source.upgrades[0].upgrade.status> <p><strong>Not Enabled</strong><br> This upgrade will not be shown as it is currently not active.</p> </div> <div class=c-slab--info ng-if=\"$ctrl.source.upgrades[0].upgrade.minimum_guests !== $ctrl.source.minimum_guests\"> <p><strong>Minimum Guests</strong><br> This upgrade may not be shown as the minimum guests are not equal to the original event.</p> </div> <div class=c-slab--info ng-if=\"$ctrl.source.upgrades[0].upgrade.maximum_guests !== $ctrl.source.maximum_guests\"> <p><strong>Maximum Guests</strong><br> This upgrade may not be shown as the maximum guests are not equal to the original event.</p> </div> <h3>Rules for showing an upgrade to a customer:</h3> <p>These are worked out when a customer reaches the Suggestions step of the checkout.</p> <ul ng-if=$ctrl.upgradeSelected()> <li> The upgrade must be enabled. </li> <li> The upgrade must have the same arrival time selected, and have availability for the selected date of the original event. </li> <li> The selected number of guests must be greater than the minimum amount on the upgrade. </li> <li> The selected number of guests must be less than the maximum amount on the upgrade. </li> <li> The upgrade may be secret - this allows upgrades to include otherwise hidden events. </li> <li> The upgrade must have any selected extras on the original event. </li> <li ng-if=$ctrl.upgradeIsSpaDay()> The upgrade must also have any selected attached Treatments on the original event. </li> </ul> <div class=c-related__actions> <a href=/admin/events/treatments/{{$ctrl.source.upgrades[0].upgrade.id}}/update target=_blank title=\"Edit related event\" ng-if=\"$ctrl.source.upgrades[0].upgrade.type_name === 'Treatment'\">Edit this upgrade</a> <a href=/admin/events/days/{{$ctrl.source.upgrades[0].id}}/update target=_blank title=\"Edit related event\" ng-if=\"$ctrl.source.upgrades[0].type_name === 'SpaDay'\">Edit this upgrade</a> </div> </div> </div> <div class=\"columns medium-6\"> <div class=c-related__preview ng-if=$ctrl.source.upgrades[0].upgrade> <div class=c-related__previewslide> <div class=c-related__previewslide__image> <div imgix-src=\"{{ $ctrl.source.upgrades[0].upgrade.image_url }}\" data-fit=fit imgix-refresh></div> <div class=c-related__previewslide__price>From <money amount=$ctrl.price() decorate=true round=true></money> </div> </div> <div class=c-related__previewslide__headings> <p class=c-related__previewslide__preheading> PRIMARY CATEGORY </p> <h3 class=c-related__previewslide__heading> {{ $ctrl.source.upgrades[0].upgrade.name }} </h3> </div> </div> <span class=c-close ng-click=$ctrl.removeUpgrade() tooltip=\"Remove this upgrade\" tooltip-placement=left><span>&times;</span></span> </div> </div> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Upgrade <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property) {
    return '/api/' + property;
};

exports.default = ['api', 'basketApiService', 'basket', 'storeService', function (api, basketApiService, basket, storeService) {
    var save = function save(upgrades) {
        return api.post(endpoint(api.property()) + '/upgrades', upgrades).then(function (response) {
            return response.data;
        });
    };

    var upgrade = function upgrade(events) {
        return callUpgradeApi({
            'guest_items': events.map(function (event) {
                return event.id;
            })
        }, {
            message: 'Error upgrading events'
        });
    };

    var callUpgradeApi = function callUpgradeApi(payload, error) {
        basket.saving = true;
        var basketCode = storeService.get('basket');
        return api.post(endpoint(api.property()) + '/basket/' + basketCode + '/upgrade', payload).then(function () {
            return basketApiService.retrieveBasket(basketCode, true).then(function (response) {
                basket.contents = response;

                basket.saving = false;
            });
        }).catch(function () {
            basket.saving = false;
            throw error;
        });
    };

    return {
        save: save,
        upgrade: upgrade
    };
}];

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _availability = __webpack_require__(834);

var _availability2 = _interopRequireDefault(_availability);

var _availabilitySave = __webpack_require__(838);

var _availabilitySave2 = _interopRequireDefault(_availabilitySave);

var _availabilityForm = __webpack_require__(839);

var _availabilityForm2 = _interopRequireDefault(_availabilityForm);

var _availabilityList = __webpack_require__(840);

var _availabilityList2 = _interopRequireDefault(_availabilityList);

var _stockList = __webpack_require__(841);

var _stockList2 = _interopRequireDefault(_stockList);

var _stockForm = __webpack_require__(842);

var _stockForm2 = _interopRequireDefault(_stockForm);

var _availabilityBlock = __webpack_require__(843);

var _availabilityBlock2 = _interopRequireDefault(_availabilityBlock);

var _availabilityList3 = __webpack_require__(844);

var _availabilityList4 = _interopRequireDefault(_availabilityList3);

var _availabilityForm3 = __webpack_require__(846);

var _availabilityForm4 = _interopRequireDefault(_availabilityForm3);

var _availabilitySave3 = __webpack_require__(848);

var _availabilitySave4 = _interopRequireDefault(_availabilitySave3);

var _stockList3 = __webpack_require__(850);

var _stockList4 = _interopRequireDefault(_stockList3);

var _stockForm3 = __webpack_require__(852);

var _stockForm4 = _interopRequireDefault(_stockForm3);

var _availabilityBlock3 = __webpack_require__(854);

var _availabilityBlock4 = _interopRequireDefault(_availabilityBlock3);

var _availability3 = __webpack_require__(856);

var _availability4 = _interopRequireDefault(_availability3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var availabilityModule = angular.module('spabooker.availability', ['spabooker.base']).config(_availability2.default).controller('availabilitySaveController', _availabilitySave2.default).controller('availabilityFormController', _availabilityForm2.default).controller('availabilityListController', _availabilityList2.default).controller('stockListController', _stockList2.default).controller('stockFormController', _stockForm2.default).controller('availabilityBlockController', _availabilityBlock2.default).component('availabilityList', _availabilityList4.default).component('availabilityForm', _availabilityForm4.default).component('availabilitySave', _availabilitySave4.default).component('stockList', _stockList4.default).component('stockForm', _stockForm4.default).component('availabilityBlock', _availabilityBlock4.default).factory('availabilityModelService', _availability4.default);

exports.default = availabilityModule.name;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _availability = __webpack_require__(835);

var _stock = __webpack_require__(836);

var _events = __webpack_require__(837);

var _categories = __webpack_require__(22);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.availability', {
        url: '/availability',
        component: 'availabilityList',
        resolve: {
            exclusion: (0, _availability.resolveAllAvailability)(undefined, undefined, undefined, 'exclusion'),
            inclusion: (0, _availability.resolveAllAvailability)(undefined, undefined, undefined, 'inclusion')
        },
        roles: []
    }).state('app.admin.availability-add', {
        url: '/availability/create?:tab',
        component: 'availabilitySave',
        resolve: {
            title: function title() {
                return 'Create an Availability Rule';
            },
            availability: (0, _availability.resolveAvailability)(),
            categories: (0, _categories.resolveCategories)(-1),
            events: (0, _events.resolveGroupedEvents)()
        },
        roles: []
    }).state('app.admin.availability-block', {
        url: '/availability/quick-block',
        component: 'availabilityBlock',
        resolve: {
            title: function title() {
                return 'Block a Day';
            }
        },
        roles: []
    }).state('app.admin.availability-edit', {
        url: '/availability/:availability/:type/update',
        component: 'availabilitySave',
        resolve: {
            title: function title() {
                return 'Update an Availability Rule';
            },
            availability: (0, _availability.resolveAvailability)(),
            categories: (0, _categories.resolveCategories)(-1),
            events: (0, _events.resolveGroupedEvents)()
        },
        roles: []
    }).state('app.admin.stock', {
        url: '/stock',
        component: 'stockList',
        resolve: {
            stock: (0, _stock.resolveStock)()
        },
        roles: ['manager', 'stock']
    }).state('app.admin.stock-add', {
        url: '/stock/create',
        component: 'stockForm',
        resolve: {
            availability: (0, _availability.resolveAvailability)(),
            categories: (0, _categories.resolveCategoriesEvents)(-1),
            events: (0, _events.resolveGroupedEvents)()
        },
        roles: ['manager', 'stock']
    }).state('app.admin.stock-update', {
        url: '/stock/update/:stock',
        component: 'stockForm',
        resolve: {
            stock: (0, _stock.resolveSingleStock)(),
            events: (0, _events.resolveGroupedEvents)()
        },
        roles: ['manager', 'stock']
    });
}];

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveAllAvailability = exports.resolveAllAvailability = function resolveAllAvailability() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var type = arguments[3];

    return ['availabilityModelService', function (availabilityModelService) {
        return availabilityModelService.findAll({
            page: page,
            per_page: perpage,
            deleted: deleted,
            ruletype: type
        }).then(function (list) {
            return list;
        });
    }];
};

var resolveAvailability = exports.resolveAvailability = function resolveAvailability() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'availability';

    return ['$stateParams', 'availabilityModelService', function ($stateParams, availabilityModelService) {
        return $stateParams[param] && $stateParams[param] > 0 ? availabilityModelService.findById($stateParams[param], {
            ruletype: $stateParams.type
        }) : {};
    }];
};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveStock = exports.resolveStock = function resolveStock() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    return ['availabilityModelService', function (availabilityModelService) {
        return availabilityModelService.findStock({
            page: page,
            per_page: perpage
        }).then(function (list) {
            return list;
        });
    }];
};

var resolveSingleStock = exports.resolveSingleStock = function resolveSingleStock() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stock';

    return ['$stateParams', 'availabilityModelService', function ($stateParams, availabilityModelService) {
        return $stateParams[param] && $stateParams[param] > 0 ? availabilityModelService.findSingleStock($stateParams[param]) : {};
    }];
};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveAllEvents = exports.resolveAllEvents = function resolveAllEvents() {
  return ['eventsService', function (eventsService) {
    return eventsService.collectAll().then(function (list) {
      return list;
    });
  }];
};

var resolveGroupedEvents = exports.resolveGroupedEvents = function resolveGroupedEvents() {
  return ['eventsService', function (eventsService) {
    return eventsService.collectGrouped().then(function (list) {
      return list;
    });
  }];
};

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvailabilitySaveController = function () {
    function AvailabilitySaveController($state, integrationService) {
        _classCallCheck(this, AvailabilitySaveController);

        this.$state = $state;
        this.integrationService = integrationService;
    }

    _createClass(AvailabilitySaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = this.$state.params.tab || (this.availability.hasOwnProperty('inclusion_type') ? 'inclusion' : 'exclusion');
        }
    }, {
        key: 'hasIntegration',
        value: function hasIntegration() {
            return this.integrationService.hasIntegration();
        }
    }]);

    return AvailabilitySaveController;
}();

AvailabilitySaveController.$inject = ['$state', 'integrationService'];

exports.default = AvailabilitySaveController;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvailabilityFormController = function () {
    function AvailabilityFormController($scope, $state, availabilityModelService, messageService) {
        _classCallCheck(this, AvailabilityFormController);

        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
    }

    _createClass(AvailabilityFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.availability = this.availability || {};
            this.availability.start = this.availability.start ? (0, _moment2.default)(this.availability.start, 'YYYY-MM-DD HH:mm:ss') : '';
            this.availability.end = this.availability.end ? (0, _moment2.default)(this.availability.end, 'YYYY-MM-DD HH:mm:ss') : '';
            this.availability.type = this.availability.exclusion_type || this.availability.inclusion_type || '';

            this.availability.event = this.availability[this.type];

            if (this.availability.exclusion_id || this.availability.inclusion_id && this.determineList()) {
                this.availability.event = (0, _lodash.find)(this.determineList(), { id: this.availability.exclusion_id || this.availability.inclusion_id });
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            if (this.availability.start) {
                this.availability.start = this.availability.start.format('YYYY-MM-DD HH:mm:00');
            }

            if (this.availability.end) {
                this.availability.end = this.availability.end.format('YYYY-MM-DD HH:mm:00');
            }

            if (!this.availability.type) {
                this.availability[this.type + '_type'] = undefined;
            } else {
                this.availability[this.type + '_type'] = this.availability.type;
            }

            if (this.availability.event) {
                switch (this.availability.type) {
                    case 'App\\Treatment':
                    case 'App\\SpaDay':
                    case 'App\\EventCategory':
                        this.assignItem();
                        break;
                }
            }

            if (this.availability.days) {
                this.availability.days = (0, _lodash.map)(this.availability.days, 'day');
            }

            this.availability.type = undefined;
            this.availability.event = undefined;

            return this.availabilityModelService.save(this.availability, this.type).then(function (response) {
                if (_this.availability.id) {
                    _this.messageService.success('The availability rule was successfully updated!', ['app.admin.availability-edit({ \'availability\' : ' + _this.availability.id + ', \'type\': \'' + _this.type + '\'})', 'Rule']);
                    _this.$state.go('app.admin.availability');
                } else {
                    _this.messageService.success('The availability rule was successfully created.', ['app.admin.availability-edit({ \'availability\' : ' + response.id + ', \'type\': \'' + _this.type + '\'})', 'Rule']);
                    _this.$state.go('app.admin.availability');
                }
            }).catch(function (error) {
                var sourceElement = Object.keys(error.data);
                var verb = 'created';
                if (_this.availability.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    var errors = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var element = _step.value;

                            errors += '<li>' + _this.messageService.formatError(element, error.data[element]) + '</li>';
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this.messageService.failure('The availability rule could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
                } else {
                    _this.messageService.failure('The availability rule could not be successfully ' + verb + ': ' + error.statusText);
                }
                _this.messageService.push();
            });
        }
    }, {
        key: 'assignItem',
        value: function assignItem() {
            this.availability[this.type + '_type'] = this.availability.event.type_raw;
            this.availability[this.type + '_id'] = this.availability.event.id;
        }
    }, {
        key: 'selector',
        value: function selector() {
            switch (this.availability.type) {
                case 'App\\EventCategory':
                case 'App\\SpaDay':
                case 'App\\Treatment':
                    return true;
            }
        }
    }, {
        key: 'setTime',
        value: function setTime(time) {
            switch (time) {
                case 0:
                    if (this.availability.start) {
                        this.availability.start.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                    }
                    break;

                case 1:
                    if (this.availability.end) {
                        this.availability.end.set({ hour: 23, minute: 59, second: 59, millisecond: 59 });
                    }
                    break;
            }
        }
    }, {
        key: 'determineList',
        value: function determineList() {
            switch (this.availability.type) {
                case 'App\\EventCategory':
                    return this.categories;
                case 'App\\SpaDay':
                    return this.events.SpaDay;
                case 'App\\Treatment':
                    return this.events.Treatment;
            }
        }
    }]);

    return AvailabilityFormController;
}();

AvailabilityFormController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService'];

exports.default = AvailabilityFormController;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvailabilityListController = function () {
    function AvailabilityListController($scope, $state, availabilityModelService, messageService, access, integrationService) {
        _classCallCheck(this, AvailabilityListController);

        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
        this.access = access;
        this.integrationService = integrationService;
    }

    _createClass(AvailabilityListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = 'exclusion';
            this.sort_start = false;
            this.sort_end = false;

            this.updatePaging();
            this.$scope.$watch(function (scope) {
                return scope.current_page;
            }, function (newVal, oldVal, scope) {
                if (newVal && newVal !== oldVal) {
                    scope.$ctrl[scope.$ctrl.activeTab] = undefined;
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        var filter = {};
                        filter[scope.$ctrl.filtertype] = scope.$ctrl.filtertext;
                        filter.page = newVal;
                        filter.perpage = scope.$ctrl.per_page;
                        filter.ruletype = scope.$ctrl.activeTab;

                        filter = scope.$ctrl.sortFilter(filter);

                        scope.$ctrl.availabilityModelService.search(filter).then(function (response) {
                            scope.$ctrl[scope.$ctrl.activeTab] = response;
                            scope.$ctrl.loading = false;
                        });
                    } else {
                        var _filter = {};
                        _filter.page = newVal;
                        _filter.perpage = scope.per_page;
                        _filter.ruletype = scope.$ctrl.activeTab;

                        _filter = scope.$ctrl.sortFilter(_filter);

                        scope.$ctrl.availabilityModelService.findAll(_filter).then(function (list) {
                            return scope.$ctrl[scope.$ctrl.activeTab] = list;
                        });
                    }
                }
            });
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            this.$scope.per_page = this[this.activeTab].per_page;
            this.$scope.current_page = this[this.activeTab].current_page;
            this.$scope.total = this[this.activeTab].total;
        }
    }, {
        key: 'onDelete',
        value: function onDelete(availability, type) {
            var _this = this;

            this.availabilityModelService.delete(availability.id, {
                ruletype: type
            }).then(function () {
                _this.messageService.success('The availability <strong>' + availability.human_start + '</strong> to <strong>' + availability.human_end + '</strong> was successfully deleted.');
                _this.messageService.push();
            }).catch(function (error) {
                _this.messageService.failure('The availability <strong>' + availability.human_start + '</strong> to <strong>' + availability.human_end + '</strong> could not be successfully deleted: ' + error.statusText);
                _this.messageService.push();
            }).then(function () {
                return _this.reloadList();
            });
        }
    }, {
        key: 'reloadList',
        value: function reloadList() {
            var _this2 = this;

            var filter = {};
            filter.page = this[this.activeTab].current_page;
            filter.perpage = this[this.activeTab].per_page;
            filter.ruletype = this.activeTab;

            filter = this.sortFilter(filter);

            this[this.activeTab] = [];
            this.loading = true;
            return this.availabilityModelService.findAll(filter).then(function (response) {
                _this2[_this2.activeTab] = response;
                _this2.loading = false;
            });
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this3 = this;

            if (!this.loading) {
                var filter = {};
                if (this.filtertype) {
                    var filtertext = this.filtertext;
                    if (this.filtertype === 'time') {
                        if (this.filtertext) {
                            filtertext = filtertext.format('YYYY-MM-DD HH:mm:00');
                        }
                    }
                    filter[this.filtertype] = filtertext;
                }
                filter.page = this.$scope.page;
                filter.perpage = this.$scope.per_page;
                filter.ruletype = this.activeTab;

                filter = this.sortFilter(filter);

                this.startFilter();
                this.availabilityModelService.search(filter).then(function (response) {
                    _this3.isFiltered = true;
                    _this3.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this4 = this;

            if (this.isFiltered) {
                this.startFilter();
                this.sort_start = false;
                this.sort_end = false;
                this.availabilityModelService.findAll({
                    ruletype: this.activeTab
                }).then(function (response) {
                    _this4.isFiltered = false;
                    _this4.endFilter(response);
                });
            }
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            switch (this.filtertype) {
                default:
                    this.filtertext = '';
                    break;
                case 'status':
                    this.filtertext = '1';
                    break;
            }
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this[this.activeTab] = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this[this.activeTab] = response;
            this.updatePaging();
            this.loading = false;
        }
    }, {
        key: 'sort',
        value: function sort(type) {
            switch (type) {
                case 'start':
                    this.sort_end = false;
                    if (!this.sort_start || this.sort_start === 'asc') {
                        this.sort_start = 'desc';
                    } else {
                        this.sort_start = 'asc';
                    }
                    break;

                case 'end':
                    this.sort_start = false;
                    if (!this.sort_end || this.sort_end === 'asc') {
                        this.sort_end = 'desc';
                    } else {
                        this.sort_end = 'asc';
                    }
                    break;
            }

            this.filter();
        }
    }, {
        key: 'sortFilter',
        value: function sortFilter(filter) {
            if (this.sort_start) {
                filter.order_by = 'start';
                filter.direction = this.sort_start;
            } else if (this.sort_end) {
                filter.order_by = 'end';
                filter.direction = this.sort_end;
            }
            return filter;
        }
    }, {
        key: 'hasIntegration',
        value: function hasIntegration() {
            return this.integrationService.hasIntegration();
        }
    }, {
        key: 'availabilityTypes',
        value: function availabilityTypes() {
            var types = ['exclusion'];

            if (!this.hasIntegration()) {
                types.push('inclusion');
            }

            return types;
        }
    }]);

    return AvailabilityListController;
}();

AvailabilityListController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService', 'access', 'integrationService'];

exports.default = AvailabilityListController;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StockListController = function () {
    function StockListController($scope, $state, availabilityModelService, messageService, access, time) {
        _classCallCheck(this, StockListController);

        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
        this.access = access;
        this.time = time;
    }

    _createClass(StockListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sort_date = false;

            this.updatePaging();
            this.$scope.$watch(function (scope) {
                return scope.current_page;
            }, function (newVal, oldVal, scope) {
                if (newVal && newVal !== oldVal) {
                    scope.$ctrl.stock = undefined;
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        var filter = {};
                        filter[scope.$ctrl.filtertype] = scope.$ctrl.filtertext;
                        filter.page = newVal;
                        filter.perpage = scope.$ctrl.per_page;

                        filter = scope.$ctrl.sortFilter(filter);

                        scope.$ctrl.availabilityModelService.searchStock(filter).then(function (response) {
                            scope.$ctrl.stock = response;
                            scope.$ctrl.loading = false;
                        });
                    } else {
                        var _filter = {};
                        _filter.page = newVal;
                        _filter.perpage = scope.per_page;

                        _filter = scope.$ctrl.sortFilter(_filter);

                        scope.$ctrl.availabilityModelService.getStock(_filter).then(function (list) {
                            return scope.$ctrl.stock = list;
                        });
                    }
                }
            });
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            this.$scope.per_page = this.stock.per_page;
            this.$scope.current_page = this.stock.current_page;
            this.$scope.total = this.stock.total;
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this = this;

            if (!this.loading) {
                var filter = {};
                if (this.filtertype) {
                    var filtertext = this.filtertext;
                    if (this.filtertype === 'date') {
                        if (this.filtertext) {
                            filtertext = filtertext.format('YYYY-MM-DD');
                        }
                    }
                    filter[this.filtertype] = filtertext;
                }
                filter.page = this.$scope.page;
                filter.perpage = this.$scope.per_page;

                filter = this.sortFilter(filter);

                this.startFilter();
                this.availabilityModelService.searchStock(filter).then(function (response) {
                    _this.isFiltered = true;
                    _this.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this2 = this;

            if (this.isFiltered) {
                this.startFilter();
                this.sort_date = false;
                this.sort_end = false;
                this.availabilityModelService.getStock().then(function (response) {
                    _this2.isFiltered = false;
                    _this2.endFilter(response);
                });
            }
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            switch (this.filtertype) {
                default:
                    this.filtertext = '';
                    break;
                case 'event_type':
                    this.filtertext = 'spaday';
                    break;
                case 'date':
                    this.filtertext = undefined;
                    break;
            }
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this.stock = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this.stock = response;
            this.updatePaging();
            this.loading = false;
        }
    }, {
        key: 'sort',
        value: function sort(type) {
            switch (type) {
                case 'date':
                    if (!this.sort_date || this.sort_date === 'asc') {
                        this.sort_date = 'desc';
                    } else {
                        this.sort_date = 'asc';
                    }
                    break;
            }

            this.filter();
        }
    }, {
        key: 'sortFilter',
        value: function sortFilter(filter) {
            if (this.sort_date) {
                filter.order_by = 'date';
                filter.direction = this.sort_date;
            }
            return filter;
        }
    }]);

    return StockListController;
}();

StockListController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService', 'access', 'time'];

exports.default = StockListController;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StockFormController = function () {
    function StockFormController($scope, $state, availabilityModelService, messageService, time, currentPropertyService) {
        _classCallCheck(this, StockFormController);

        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
        this.time = time;
        this.currentPropertyService = currentPropertyService;
    }

    _createClass(StockFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.quantity = this.stock || [];

            this.property = this.currentPropertyService.get();
            this.eventTypes = [{
                id: 0,
                name: 'Spa Days',
                type_name: 'spadays',
                search: 'SpaDay',
                disabled: !(this.events.SpaDay && this.events.SpaDay.length)
            }, {
                id: 0,
                name: 'Treatments',
                type_name: 'treatments',
                search: 'Treatment',
                disabled: !(this.events.Treatment && this.events.Treatment.length)
            }];

            this.today = moment();

            this.categories = (0, _lodash.filter)(this.categories, function (item) {
                return item.spadays.length || item.treatments.length;
            });
            if (!this.categories.length) this.categories = [{
                id: -1,
                name: 'No Valid Categories',
                type_name: 'na'
            }];

            if (this.stock) {
                this.event_type = 'App\\Event';
                if (this.events) {
                    this.event = (0, _lodash.find)(this.determineList(), { id: this.stock[0].event_id, type_raw: this.stock[0].event_type });
                    this.start = moment(this.stock[0].date) || this.today;
                }
            }
        }
    }, {
        key: 'determineList',
        value: function determineList() {
            switch (this.event_type) {
                case 'App\\EventCategory':
                    return this.categories;

                case 'App\\Event':
                    if (this.events.SpaDay) {
                        return this.events.SpaDay.concat(this.events.Treatment);
                    }
                    return this.events.Treatment;

                case 'App\\EventType':
                    return this.eventTypes;
            }
        }
    }, {
        key: 'noPrevious',
        value: function noPrevious() {
            if (this.today && this.start) {
                return this.today.format('YYYY-MM-DD') >= this.start.format('YYYY-MM-DD');
            }
        }
    }, {
        key: 'groupBy',
        value: function groupBy(item) {
            return item.type_display;
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this = this;

            if (this.start) {
                var event = this.event ? {
                    type: this.event.type_name.toLowerCase(),
                    id: this.event.id,
                    date: this.start.format('YYYY-MM-DD')
                } : {
                    type: '*',
                    date: this.start.format('YYYY-MM-DD')
                };

                this.loading = true;
                this.quantity = [];
                this.availabilityModelService.getStock(event).then(function (response) {
                    _this.createList();
                    _this.blocks = response.blocks;
                    response = response.events;
                    for (var i = 0, l = response.length; i < l; i++) {
                        var found = event.type === '*' ? 0 : (0, _lodash.findKey)(_this.quantity, { event_id: response[i].event_id, event_type: response[i].event_type });
                        if (found !== undefined) {
                            _this.quantity[found].quantity = response[i].quantity;
                            _this.quantity[found].limited = response[i].limited;
                        }
                    }
                    _this.loading = false;
                });
            }
        }
    }, {
        key: 'updateWait',
        value: function updateWait(item) {
            var _this2 = this;

            if (item.quantity.match(/[^0-9]+/g)) return;
            item.updating = false;
            clearTimeout(item.trigger);
            item.trigger = setTimeout(function () {
                _this2.trigger(item);
            }, 500);
        }
    }, {
        key: 'update',
        value: function update(item) {
            this.trigger(item);
        }
    }, {
        key: 'trigger',
        value: function trigger(item) {
            item.trigger = undefined;
            item.updating = true;

            var date = this.start || moment(this.stock[0].date);
            this.availabilityModelService.updateStock(item, date.format('YYYY-MM-DD')).then(function () {
                item.updating = false;
            });
        }
    }, {
        key: 'traverseDays',
        value: function traverseDays(modifier) {
            this.start.add(modifier, "days");
        }
    }, {
        key: 'createList',
        value: function createList() {
            var items = [];
            switch (this.event_type) {
                case '*':
                    this.quantity = [{
                        event_id: undefined,
                        event_type: undefined,
                        name: 'Global Quantity',
                        type: undefined,
                        base_quantity: this.property.global_quantity,
                        quantity: this.property.global_quantity,
                        track_quantity: true
                    }];
                    break;

                case 'App\\EventCategory':
                    items = this.event.spadays.concat(this.event.treatments).map(function (element) {
                        var item = {
                            event_id: element.related_event.id,
                            event_type: element.related_event.type_raw,
                            name: element.related_event.name,
                            type: element.related_event.type_display,
                            base_quantity: element.related_event.base_quantity,
                            track_quantity: element.related_event.track_quantity
                        };
                        return item;
                    });
                    this.quantity = items;
                    break;

                case 'App\\Event':
                    this.quantity = [{
                        event_id: this.event.id,
                        event_type: this.event.type_raw,
                        name: this.event.name,
                        type: this.event.type_display,
                        base_quantity: this.event.base_quantity,
                        track_quantity: this.event.track_quantity
                    }];
                    break;

                case 'App\\EventType':
                    items = this.events[this.event.search].map(function (element) {
                        var item = {
                            event_id: element.id,
                            event_type: element.type_raw,
                            name: element.name,
                            type: element.type_display,
                            base_quantity: element.base_quantity,
                            track_quantity: element.track_quantity
                        };
                        return item;
                    });
                    this.quantity = items;
            }
        }
    }]);

    return StockFormController;
}();

StockFormController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService', 'time', 'currentPropertyService'];

exports.default = StockFormController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvailabilityBlockController = function () {
    function AvailabilityBlockController(availabilityModelService, messageService) {
        _classCallCheck(this, AvailabilityBlockController);

        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
    }

    _createClass(AvailabilityBlockController, [{
        key: '$onInit',
        value: function $onInit() {
            this.buttonText = 'Add Block';
            this.today = (0, _moment2.default)().format('YYYY-MM-DD');
            this.invalid = true;
        }
    }, {
        key: 'onDateSelect',
        value: function onDateSelect() {
            var _this = this;

            this.message = null;
            this.invalid = false;
            this.saving = true;
            this.buttonText = 'Add Block';

            return this.availabilityModelService.dateStatus(this.date.format('YYYY-MM-DD')).then(function (response) {
                _this.saving = false;

                if (response && response.status && _this.date.format('YYYY-MM-DD') === response.date) {
                    var dateFormatted = (0, _moment2.default)(response.date).format('LL');

                    switch (response.status) {
                        case 'closed':
                            _this.message = dateFormatted + ' is already blocked, if you save, it will remove the block';
                            _this.buttonText = 'Remove Block';
                            break;
                        case 'other':
                            _this.message = dateFormatted + ' is already blocked, please use the list view to remove the block if required';
                            _this.invalid = true;
                            break;
                    }
                }
            });
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            if (!this.date) {
                this.message = 'Please select a date before saving';
                return Promise.resolve();
            }

            return this.availabilityModelService.dateToggle(this.date.format('YYYY-MM-DD'));
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess(response) {
            if (response && response.status) {
                this.message = null;

                switch (response.status) {
                    case 'open':
                        this.messageService.success('Block successfully removed');
                        this.messageService.push();
                        this.buttonText = 'Add Block';
                        break;
                    case 'closed':
                        this.messageService.success('Block successfully added');
                        this.messageService.push();
                        this.buttonText = 'Remove Block';
                        break;
                }
            }
        }
    }, {
        key: 'onError',
        value: function onError() {
            this.messageService.failure('An error occurred, please try again or contact RevSpa for assistance');
            this.messageService.push();
        }
    }]);

    return AvailabilityBlockController;
}();

AvailabilityBlockController.$inject = ['availabilityModelService', 'messageService'];

exports.default = AvailabilityBlockController;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    exclusion: '<',
    inclusion: '<'
  },
  controller: 'availabilityListController',
  template: __webpack_require__(845)
};

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Availability Rules</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('stock')\"> <a ui-sref=\"app.admin.availability-add({ tab: $ctrl.activeTab })\" class=c-button--action> <icon icon=calendar-cross></icon> Create an Availability Rule </a> <a ui-sref=app.admin.availability-block() class=c-button--action> <icon icon=cross></icon> Block a Day </a> </div> </header> <message closable=true></message> <main class=s-main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'exclusion' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'exclusion'; $ctrl.updatePaging()\"> Exclusions </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'inclusion' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'inclusion'; $ctrl.updatePaging()\" ng-if=!$ctrl.hasIntegration()> Inclusions </button> </div> <div class=c-tabs__content> <div class=row ng-repeat=\"type in $ctrl.availabilityTypes()\"> <div class=\"columns c-list__tab-inner\" ng-if=\"$ctrl.activeTab === type\"> <form class=\"row c-list__search c-list__search--tab\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'time'\" ng-change=$ctrl.filtertypeChange()> <option value=time>Affecting Date or Time</option> <option value=rule>Affected Events</option> <option value=status>Status</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <div class=c-form__field ng-show=\"$ctrl.filtertype === 'time'\"> <input name=start_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors ng-model=$ctrl.filtertext moment-picker=$ctrl.filtertext keyboard=true format=\"YYYY-MM-DD HH:mm\" min-view=month max-view=minute set-on-select=true autocomplete=off validate=true> <label class=c-form__label for=start_time>Date</label> </div> <select ng-model=$ctrl.filtertext ng-show=\"$ctrl.filtertype === 'rule'\"> <option value=\"\" disabled=disabled>Event Rule...</option> <option value=*>All Events</option> <option value=All\\SpaDay>All Spa Days</option> <option value=Full\\SpaDay>&nbsp;-&nbsp;Full Spa Days</option> <option value=Half\\SpaDay>&nbsp;-&nbsp;Half Spa Days</option> <option value=All\\Treatment>All Treatments</option> <option value=App\\EventCategory>Category</option> <option value=App\\SpaDay>Single Spa Day</option> <option value=App\\Treatment>Single Treatment</option> </select> <select ng-model=$ctrl.filtertext ng-show=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <div ng-if=\"$ctrl[type].data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No availability rules have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No availability rules match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl[type].data.length > 0\"> <thead> <tr> <th class=c-table__lights></th> <th> <a class=c-table__sort ng-click=\"$ctrl.sort('start')\"> Start Time <icon ng-if=\"$ctrl.sort_start === 'asc' || !$ctrl.sort_start\" icon=chevron-down></icon> <icon ng-if=\"$ctrl.sort_start === 'desc'\" icon=chevron-up></icon> </a> </th> <th> <a class=c-table__sort ng-click=\"$ctrl.sort('end')\"> End Time <icon ng-if=\"$ctrl.sort_end === 'asc' || !$ctrl.sort_end\" icon=chevron-down></icon> <icon ng-if=\"$ctrl.sort_end === 'desc'\" icon=chevron-up></icon> </a> </th> <th>Rule</th> <th ng-if=\"$ctrl.access.check('stock')\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"availability in $ctrl[type].data\" class=\"c-list {{ availability.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-table__lights> <span ng-class=\"(availability.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (availability.status)? 'This '+type+' is active' : 'This '+type+' is not active' }}\"></span> </td> <td><abbr title={{availability.start}}>{{availability.human_start}}</abbr></td> <td><abbr title={{availability.end}}>{{availability.human_end}}</abbr></td> <td>{{availability.rule}}</td> <td class=c-list__action ng-if=\"$ctrl.access.check('stock')\"> <a ui-sref=\"app.admin.availability-edit({ availability: availability.id, type: type })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=\"$ctrl.onDelete(availability, $ctrl.activeTab)\" confirm=\"Are you sure you want to delete {{ availability.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    availability: '=',
    categories: '<',
    events: '<',
    type: '<'
  },
  controller: 'availabilityFormController',
  template: __webpack_require__(847)
};

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = " <message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=row> <div class=\"column medium-12\"> <p class=c-description> This form allows you to select a <strong>date</strong> and <strong>time</strong> range to <span ng-if=\"$ctrl.type === 'exclusion'\">block</span><span ng-if=\"$ctrl.type === 'inclusion'\">open</span> availability for an event or a set of events.<span ng-if=\"$ctrl.type === 'inclusion'\"> The times selected here will override any normally available times for the period selected.</span> </p> </div> <div class=\"column medium-6\"> <select ng-model=$ctrl.availability.type ng-disabled=$ctrl.availability.id> <option value=\"\">All Events</option> <option value=All\\SpaDay>All Spa Days</option> <option value=Full\\SpaDay>&nbsp;-&nbsp;Full Spa Days</option> <option value=Half\\SpaDay>&nbsp;-&nbsp;Half Spa Days</option> <option value=All\\Treatment>All Treatments</option> <option value=App\\EventCategory>Category</option> <option value=App\\SpaDay>Single Spa Day</option> <option value=App\\Treatment>Single Treatment</option> </select> </div> <div class=\"column medium-6\" ng-if=$ctrl.selector()> <div class=c-form__field> <ui-select ng-model=$ctrl.availability.event ng-disabled=$ctrl.availability.id required> <ui-select-match placeholder=Select...> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item in $ctrl.determineList() | filter: { name: $select.search } track by $index\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=c-form__field> <input name=start_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors required ng-model=$ctrl.availability.start moment-picker=$ctrl.availability.start keyboard=true format=\"YYYY-MM-DD HH:mm\" min-view=month max-view=hour set-on-select=true autocomplete=off validate=true> <label class=c-form__label for=start_time>Start Date</label> </div> <div class=\"button round\" ng-click=$ctrl.setTime(0)>Start of day</div> </div> <div class=\"column medium-6\"> <div class=c-form__field> <input name=end_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors required ng-model=$ctrl.availability.end moment-picker=$ctrl.availability.end keyboard=true format=\"YYYY-MM-DD HH:mm\" min-view=month max-view=hour validate=true set-on-select=true autocomplete=off min-date=$ctrl.availability.start> <label class=c-form__label for=end_time>End Date</label> </div> <div class=\"button round\" ng-click=$ctrl.setTime(1)>End of day</div> </div> </div> <div class=row> <div class=\"column medium-6\"> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this availability rule will be active and <span ng-if=\"$ctrl.type === 'exclusion'\">affected events will be blocked and/or have their quantities reduced.</span><span ng-if=\"$ctrl.type === 'inclusion'\">affected events will have their times overridden as indicated below.</span></p> <switch id=status name=status ng-model=$ctrl.availability.status class=green></switch> </div> </div> <div class=row ng-if=\"$ctrl.type === 'inclusion'\"> <div class=\"column medium-12\"> <start-times source=$ctrl.availability form-tab=$ctrl.activeTab times=$ctrl.availability.times embed=true no-message=true></start-times> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Availability Rule<spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    availability: '=',
    title: '@',
    events: '<',
    categories: '<'
  },
  controller: 'availabilitySaveController',
  template: __webpack_require__(849)
};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p>{{ $ctrl.activeTab.charAt(0).toUpperCase()+ $ctrl.activeTab.slice(1) }} Rule</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'exclusion' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'exclusion'; $ctrl.availability = {}\" ng-disabled=\"$ctrl.activeTab === 'exclusion'\" ng-show=!$ctrl.availability.id> Exclusion </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'inclusion' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'inclusion'; $ctrl.availability = {}\" ng-disabled=\"$ctrl.activeTab === 'inclusion'\" ng-show=!$ctrl.availability.id ng-if=!$ctrl.hasIntegration()> Inclusion </button> </div> <div class=c-tabs__content ng-if=\"$ctrl.activeTab === 'exclusion' || $ctrl.activeTab === 'inclusion'\"> <div class=row> <div class=\"small-12 columns\"> <availability-form availability=$ctrl.availability categories=$ctrl.categories events=$ctrl.events type=$ctrl.activeTab> </availability-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    stock: '<'
  },
  controller: 'stockListController',
  template: __webpack_require__(851)
};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Stock</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('stock')\"> <a ui-sref=app.admin.stock-add class=c-button--action> <icon icon=tick></icon> Alter Stock Rules </a> </div> </header> <main class=s-main> <form class=\"row c-list__search c-list__search--tab\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'date'\" ng-change=$ctrl.filtertypeChange()> <option value=date>Affecting Date</option> <option value=event_type>Event Type</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <div class=c-form__field ng-show=\"$ctrl.filtertype === 'date'\"> <input name=start_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors ng-model=$ctrl.filtertext moment-picker=$ctrl.filtertext keyboard=true format=\"dddd, MMMM Do YYYY\" min-view=month max-view=day set-on-select=true autocomplete=off validate=true> <label class=c-form__label for=start_time>Date</label> </div> <select ng-model=$ctrl.filtertext ng-show=\"$ctrl.filtertype === 'event_type'\"> <option value=spaday>Spa Day</option> <option value=treatment>Treatment</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.stock.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>There are no custom stock alterations for the future.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No custom stock alterations match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.stock.data.length > 0\"> <thead> <tr> <th> <a class=c-table__sort ng-click=\"$ctrl.sort('date')\"> Date <icon ng-if=\"$ctrl.sort_date === 'asc' || !$ctrl.sort_date\" icon=chevron-down></icon> <icon ng-if=\"$ctrl.sort_date === 'desc'\" icon=chevron-up></icon> </a> </th> <th>Event Name</th> <th>Event Type</th> <th>Telephone Only</th> <th>Tracked</th> <th>Quantity</th> <th>Last Updated</th> <th ng-if=\"$ctrl.access.check('stock')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"stock in $ctrl.stock.data\" class=c-list ng-class=\"{ 'c-list__disabled' : !stock.event }\"> <td>{{ $ctrl.time.readableDate(stock.date) }}</td> <td>{{ stock.event_id ? stock.event.name || 'Event removed' : 'Global' }}</td> <td>{{ stock.event.type_display || 'N/A' }}</td> <td class=c-list__action> <icon class=c-form__icon ng-show=stock.limited icon=tick></icon> <icon class=c-form__icon ng-show=!stock.limited icon=cross></icon> </td> <td class=c-list__action> <icon class=c-form__icon ng-show=stock.event.track_quantity icon=tick></icon> <icon class=c-form__icon ng-show=!stock.event.track_quantity icon=cross></icon> </td> <td>{{ stock.quantity }}</td> <td>{{ $ctrl.time.shortTime(stock.updated_at) }}</td> <td class=c-list__action ng-if=\"$ctrl.access.check('stock')\"> <a ng-show=stock.event ui-sref=\"app.admin.stock-update({ stock: stock.id })\">Edit</a> <span ng-show=!stock.event>&nbsp;</span> </td> </tr> </tbody> </table> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    availability: '<',
    categories: '<',
    events: '<',
    stock: '<'
  },
  controller: 'stockFormController',
  template: __webpack_require__(853)
};

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Event Stock</h1> </header> <main class=\"s-main c-form--stock\"> <div class=row> <div class=\"columns medium-12 o-block-container--no-padding-bottom\"> <div class=c-slab--info> <p> Note: Status and quantities will be updated automatically as changed. </p> </div> <div class=row ng-show=!$ctrl.stock> <div class=\"column medium-6\"> <select ng-model=$ctrl.event_type ng-disabled=$ctrl.stock ng-change=\"$ctrl.event = undefined; $ctrl.quantity = [];\"> <option value=\"\" disabled=disabled>Select event group</option> <option value=* ng-if=$ctrl.property.global_quantity>Global</option> <option value=App\\EventType ng-if=!$ctrl.property.global_quantity>Event Type</option> <option value=App\\EventCategory ng-if=!$ctrl.property.global_quantity>Category</option> <option value=App\\Event ng-if=!$ctrl.property.global_quantity>Single Event</option> </select> </div> <div class=\"column medium-6\" ng-if=\"$ctrl.event_type && $ctrl.event_type !== '*'\"> <ui-select ng-model=$ctrl.event ng-disabled=$ctrl.stock ng-change=$ctrl.filter()> <ui-select-match placeholder=Select...> {{ $select.selected.name }} </ui-select-match> <ui-select-choices group-by=$ctrl.groupBy repeat=\"item in $ctrl.determineList() | filter: { name: $select.search } track by $index\" ui-disable-choice=\"item.id < 0 || item.disabled\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> </div> <div class=row ng-if=\"$ctrl.event || $ctrl.event_type === '*'\"> <div class=\"columns medium-3 c-form__button\"> <div class=\"button round\" ng-disabled=$ctrl.noPrevious() ng-click=\"$ctrl.traverseDays(-1); $ctrl.filter()\" ng-if=$ctrl.start>Previous Day</div> </div> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--date\"> <input name=start_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly ng-model=$ctrl.start moment-picker=$ctrl.start keyboard=true format=\"dddd, MMMM Do YYYY\" min-view=month max-view=hour min-date=$ctrl.today set-on-select=true autocomplete=off validate=true change=$ctrl.filter()> <label class=c-form__label for=start_time>Date</label> <icon icon=calendar> </icon></div> </div> <div class=\"columns medium-3 c-form__button\"> <div class=\"button round\" ng-click=\"$ctrl.traverseDays(1); $ctrl.filter()\" ng-if=$ctrl.start>Next Day</div> </div> </div> </div> </div> <div class=max-width> <div class=c-slab--info ng-if=$ctrl.blocks.length> <strong> <p> The current blocked availability periods are active on this date: </p> </strong> <ul> <li ng-repeat=\"block in $ctrl.blocks\"> {{block.rule}} </li> </ul> </div> </div> <div class=row ng-show=\"$ctrl.quantity.length > 10\"> <div class=\"columns medium-10\"> <label for=name class=c-label>Search by name</label> <div class=c-form__field> <input name=name class=\"c-form__input c-form__input--no-margin\" type=text autocomplete=off ng-model=$ctrl.namefilter> <label class=c-form__label for=name>Filter events</label> </div> </div> <div class=\"columns medium-2\"> <label for=status class=c-label>Tracked</label> <switch id=status name=status ng-model=$ctrl.trackedonly class=green></switch> </div> </div> <div class=row ng-if=\"$ctrl.quantity.length || $ctrl.loading\"> <div class=\"columns medium-12\"> <table class=c-table--availability> <thead> <tr> <td>Event Name</td> <td>Event Type</td> <td>Telephone Only</td> <td>Tracked</td> <td>Quantity</td> <td></td> </tr> </thead> <tr ng-repeat=\"item in $ctrl.quantity | filter: {name: $ctrl.namefilter}\" ng-show=\"($ctrl.trackedonly && item.track_quantity) || !$ctrl.trackedonly\"> <td>{{item.name}}</td> <td>{{item.type}}</td> <td><switch id=limited name=limited ng-model=item.limited ng-disabled=item.updating class=green ng-change=$ctrl.update(item)></switch></td> <td class=c-list__action> <icon class=c-form__icon ng-show=item.track_quantity icon=tick></icon> <icon class=c-form__icon ng-show=!item.track_quantity icon=cross></icon> </td> <td> <div class=c-form__field> <input name=quant type=text class=c-form__input ng-model=item.quantity autocomplete=off ng-change=$ctrl.updateWait(item) ng-pattern=/^[0-9]+$/ ng-disabled=item.updating> <label class=c-form__label for=price>Base: {{(item.base_quantity || 'Unknown')}}</label> </div> </td> <td class=c-form__button> <spinner ng-show=item.updating></spinner> <icon class=c-form__icon--fade-out ng-show=!item.updating icon=tick></icon> </td> </tr> </table> </div> <div class=c-form__overlay-spinner ng-if=$ctrl.loading> <spinner/> </div> </div> </main>";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        title: '@'
    },
    controller: 'availabilityBlockController',
    template: __webpack_require__(855)
};

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> </header> <main class=c-quick-block> <api-form on-save=$ctrl.onSave() on-success=$ctrl.onSuccess(result) on-error=$ctrl.onError() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=row> <div class=\"columns medium-2\">&nbsp;</div> <div class=\"columns medium-8\"> <message closable=true></message> <p><a ui-sref=app.admin.availability>&larr; Back to Availability</a></p> <div ng-model=$ctrl.date moment-picker=$ctrl.dateString keyboard=true format=YYYY-MM-DD min-view=month max-view=month set-on-select=true autocomplete=off autoclose=false validate=true change=$ctrl.onDateSelect() inline=true min-date=$ctrl.today></div> <div class=c-quick-block__message ng-if=$ctrl.message ng-bind-html=$ctrl.message></div> </div> </div> <div class=\"columns medium-2\">&nbsp;</div>  <form-buttons> <button class=\"button round\" ng-disabled=\"$ctrl.saving || $ctrl.form.invalid || $ctrl.invalid\"> {{ $ctrl.buttonText }} <spinner ng-if=$ctrl.saving></spinner> </button> </form-buttons> </api-form> </main> ";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property) {
    return '/api/' + property + '/events/availability';
};
var stockendpoint = function stockendpoint(property) {
    return '/api/' + property + '/events/quantity';
};
var blockendpoint = function blockendpoint(property, date) {
    return '/api/' + property + '/events/blocks/' + date;
};

exports.default = ['$rootScope', 'api', function ($rootScope, api) {
    var toQueryString = function toQueryString(obj) {
        var queryString = [];
        for (var param in obj) {
            if (obj[param]) {
                queryString.push(encodeURIComponent(param) + '=' + encodeURIComponent(obj[param]));
            }
        }
        if (queryString.length) {
            return '?' + queryString.join('&');
        } else {
            return '';
        }
    };

    return {
        save: function save(availability, type) {
            var url = availability.id ? endpoint(api.property()) + '/' + availability.id : endpoint(api.property());

            availability.property_id = api.property();

            return api.upload(url + ('?ruletype=' + type), availability).then(function (response) {
                return response.data;
            });
        },
        delete: function _delete(id, filter) {
            return api.delete(endpoint(api.property()) + '/' + id + toQueryString(filter));
        },
        findAll: function findAll(filter) {
            return api.get(endpoint(api.property()) + toQueryString(filter)).then(function (response) {
                return response.data;
            });
        },
        findById: function findById(id, filter) {
            return api.get(endpoint(api.property()) + '/' + id + toQueryString(filter)).then(function (response) {
                return response.data;
            });
        },
        search: function search(filter) {
            return api.get(endpoint(api.property()) + toQueryString(filter)).then(function (response) {
                return response.data;
            });
        },
        updateStock: function updateStock(item, date) {
            item.date = date;
            return api.post('' + stockendpoint(api.property()), item).then(function (response) {
                return response;
            });
        },
        getStock: function getStock(filter) {
            return api.get('' + stockendpoint(api.property()) + toQueryString(filter)).then(function (response) {
                return response.data;
            });
        },
        findStock: function findStock(filter) {
            return api.get(stockendpoint(api.property()) + toQueryString(filter)).then(function (response) {
                return response.data;
            });
        },
        searchStock: function searchStock(filter) {
            return api.get(stockendpoint(api.property()) + toQueryString(filter)).then(function (response) {
                return response.data;
            });
        },
        findSingleStock: function findSingleStock(id) {
            return api.get(stockendpoint(api.property()) + '/' + id).then(function (response) {
                return [response.data];
            });
        },
        dateStatus: function dateStatus(date) {
            return api.get(endpoint(api.property()) + '/' + date + '/status').then(function (response) {
                return response.data;
            });
        },
        dateToggle: function dateToggle(date) {
            return api.post(endpoint(api.property()) + '/' + date + '/toggle').then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(30);

var _offer = __webpack_require__(858);

var _offer2 = _interopRequireDefault(_offer);

var _offerList = __webpack_require__(860);

var _offerList2 = _interopRequireDefault(_offerList);

var _offerSave = __webpack_require__(861);

var _offerSave2 = _interopRequireDefault(_offerSave);

var _offerForm = __webpack_require__(862);

var _offerForm2 = _interopRequireDefault(_offerForm);

var _offerPeriodForm = __webpack_require__(863);

var _offerPeriodForm2 = _interopRequireDefault(_offerPeriodForm);

var _offerList3 = __webpack_require__(864);

var _offerList4 = _interopRequireDefault(_offerList3);

var _offerSave3 = __webpack_require__(866);

var _offerSave4 = _interopRequireDefault(_offerSave3);

var _offerForm3 = __webpack_require__(868);

var _offerForm4 = _interopRequireDefault(_offerForm3);

var _offerPeriodForm3 = __webpack_require__(870);

var _offerPeriodForm4 = _interopRequireDefault(_offerPeriodForm3);

var _offer3 = __webpack_require__(872);

var _offer4 = _interopRequireDefault(_offer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var offerModule = angular.module('spabooker.offer', ['spabooker.base', 'as.sortable']).config(_offer2.default).controller('offerListController', _offerList2.default).controller('offerSaveController', _offerSave2.default).controller('offerFormController', _offerForm2.default).controller('offerPeriodFormController', _offerPeriodForm2.default).component('offerList', _offerList4.default).component('offerSave', _offerSave4.default).component('offerForm', _offerForm4.default).component('offerPeriodForm', _offerPeriodForm4.default).factory('offerService', _offer4.default);

exports.default = offerModule.name;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _offer = __webpack_require__(859);

exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin.offers', {
    url: '/offers',
    component: 'offerList',
    resolve: {
      offers: (0, _offer.resolveOffers)(1, 20)
    },
    roles: ['manager']
  }).state('app.admin.offer-add', {
    url: '/offers/create',
    component: 'offerSave',
    resolve: {
      title: function title() {
        return 'Create an offer';
      }
    },
    roles: ['manager']
  }).state('app.admin.offer-edit', {
    url: '/offers/:offer/update?tab',
    component: 'offerSave',
    resolve: {
      title: function title() {
        return 'Update an offer';
      },
      offer: (0, _offer.resolveOffer)()
    },
    roles: ['manager']
  });
}];

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveOffer = exports.resolveOffers = undefined;

var _lodash = __webpack_require__(2);

var resolveOffers = exports.resolveOffers = function resolveOffers() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return ['offerService', function (offerService) {
    return offerService.findAll(page, perpage, deleted).then(function (list) {
      return list;
    });
  }];
};

var resolveOffer = exports.resolveOffer = function resolveOffer() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'offer';

  return ['$stateParams', 'offerService', function ($stateParams, offerService) {
    return $stateParams[param] && $stateParams[param] > 0 ? offerService.findById($stateParams[param]) : {};
  }];
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OffersListController = function () {
  function OffersListController($scope, $state, offerService, messageService, access) {
    _classCallCheck(this, OffersListController);

    this.$scope = $scope;
    this.$state = $state;
    this.offerService = offerService;
    this.messageService = messageService;
    this.access = access;
  }

  _createClass(OffersListController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updatePaging();
      this.$scope.$watch(function (scope) {
        return scope.current_page;
      }, function (newVal, oldVal, scope) {
        if (newVal !== oldVal) {
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
            scope.$ctrl.offers = undefined;
            scope.$ctrl.offerService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
              scope.$ctrl.offers = response;
              scope.$ctrl.loading = false;
            });
          } else {
            scope.$ctrl.offerService.findAll(newVal, scope.per_page).then(function (list) {
              return scope.$ctrl.offers = list;
            });
          }
        }
      });
    }
  }, {
    key: 'updatePaging',
    value: function updatePaging() {
      this.$scope.per_page = this.offers.per_page;
      this.$scope.current_page = this.offers.current_page;
      this.$scope.total = this.offers.total;
    }
  }, {
    key: 'onDelete',
    value: function onDelete(offer) {
      var _this = this;

      this.offerService.delete(offer.id).then(function () {
        _this.messageService.success('The special offer <strong>' + offer.name + '</strong> was successfully deleted.');
        _this.messageService.push();
      }).catch(function (error) {
        _this.messageService.failure('The special offer <strong>' + offer.name + '</strong> could not be successfully deleted: ' + error.statusText);
        _this.messageService.push();
      }).then(function () {
        var page = _this.offers.current_page;
        _this.offers = [];
        _this.loading = true;
        return _this.offerService.findAll(page).then(function (response) {
          _this.offers = response;
          _this.loading = false;
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this2 = this;

      if (!this.loading && this.filtertext) {
        this.isFiltered = true;
        this.offers = undefined;
        this.loading = true;
        this.offerService.search(this.filtertype, this.filtertext).then(function (response) {
          _this2.offers = response;
          _this2.updatePaging();
          _this2.loading = false;
        });
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      var _this3 = this;

      if (this.isFiltered) {
        this.isFiltered = false;
        this.loading = true;
        this.offerService.findAll(1, 20).then(function (response) {
          _this3.offers = response;
          _this3.$scope.current_page = 1;
          _this3.$scope.total = response.total;
          _this3.loading = false;
        });
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        case 'status':
          this.filtertext = '1';
          break;
        default:
          this.filtertext = '';
          break;
      }
    }
  }]);

  return OffersListController;
}();

OffersListController.$inject = ['$scope', '$state', 'offerService', 'messageService', 'access'];

exports.default = OffersListController;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferSaveController = function () {
    function OfferSaveController($rootScope, $state, $stateParams, eventsService, access) {
        _classCallCheck(this, OfferSaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.eventsService = eventsService;
        this.access = access;
    }

    _createClass(OfferSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.activeTab = this.$stateParams.tab || 'offer';
            if (!this.days || !this.treatments) {
                this.days = [];
                this.treatments = [];

                this.eventpromise = this.eventsService.collectGrouped().then(function (response) {
                    _this.days = _this.days.concat(response.SpaDay);
                    _this.treatments = _this.treatments.concat(response.Treatment);
                    return response;
                });
            }
        }
    }]);

    return OfferSaveController;
}();

OfferSaveController.$inject = ['$rootScope', '$state', '$stateParams', 'eventsService', 'access'];

exports.default = OfferSaveController;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferFormController = function () {
    function OfferFormController($rootScope, $scope, $state, offerService, messageService) {
        _classCallCheck(this, OfferFormController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.offerService = offerService;
        this.messageService = messageService;
    }

    _createClass(OfferFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.offer = this.offer || {};
            this.offer.property_id = this.$rootScope.currentProperty.id;
            this.offer.pricing_value = this.offer.pricing_type === '%' ? parseInt(this.offer.pricing_value) : this.offer.pricing_value || 0;

            if (this.offer.publish_at) {
                this.offer.publish_at = this.offer.publish_at ? (0, _moment2.default)(this.offer.publish_at, 'YYYY-MM-DD HH:mm:ss') : '';
            }
            if (this.offer.unpublish_at) {
                this.offer.unpublish_at = this.offer.unpublish_at ? (0, _moment2.default)(this.offer.unpublish_at, 'YYYY-MM-DD HH:mm:ss') : '';
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            delete this.offer.grouped_events;
            delete this.offer.grouped_exclusions;
            delete this.offer.grouped_inclusions;

            if (this.offer.publish_at) {
                this.offer.publish_at = this.offer.publish_at.format('YYYY-MM-DD HH:mm:ss');
            }
            if (this.offer.unpublish_at) {
                this.offer.unpublish_at = this.offer.unpublish_at.format('YYYY-MM-DD HH:mm:ss');
            }

            return this.offerService.save(this.offer).then(function (response) {
                if (_this.offer.id) {
                    if (!response.error) {
                        _this.messageService.success('The special offer <strong>' + _this.offer.name + '</strong> was successfully updated!', ['app.admin.offer-edit({ \'offer\' : ' + _this.offer.id + '})', 'Offer']);
                        _this.$state.go('app.admin.offers');
                    }
                } else {
                    _this.messageService.success('The special offer <strong>' + response.name + '</strong> was successfully created.');
                    _this.$state.go('app.admin.offer-edit', { offer: response.id, tab: 'period' });
                }
            }).catch(function (error) {
                if (error.data.error.length && (0, _lodash.head)(error.data.error).offer) {
                    var verb = _this.offer.id ? 'updated' : 'created';
                    if (error.data.error.length) {
                        var errorList = '';
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = error.data.error[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var errorLine = _step.value;

                                errorList += '<li>Conflicting offer period <strong>' + errorLine.period.start + '</strong> - <strong>' + errorLine.period.end + '</strong> for <strong>' + errorLine.event + '</strong> due to offer <strong>' + errorLine.offer + '</strong></li>';
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this.messageService.failure('The offer <strong>' + _this.offer.name + '</strong> could not be successfully ' + verb + ': <ul>' + errorList + '</ul>');
                    } else {
                        _this.messageService.failure('The offer <strong>' + _this.offer.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
                    }

                    _this.messageService.push();
                } else {
                    error.data = error.data.original || error.data;
                    _this.form.$api.setErrors(error.data);
                }
            });
        }
    }, {
        key: 'currentDate',
        value: function currentDate() {
            return (0, _moment2.default)().format('LL');
        }
    }, {
        key: 'setTime',
        value: function setTime() {
            var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (start) {
                return this.offer.publish_at && this.offer.publish_at.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            }
            return this.offer.unpublish_at && this.offer.unpublish_at.set({ hour: 23, minute: 59, second: 59, millisecond: 59 });
        }
    }]);

    return OfferFormController;
}();

OfferFormController.$inject = ['$rootScope', '$scope', '$state', 'offerService', 'messageService'];

exports.default = OfferFormController;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferPeriodFormController = function () {
    function OfferPeriodFormController($rootScope, $scope, $state, offerService, messageService) {
        _classCallCheck(this, OfferPeriodFormController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.offerService = offerService;
        this.messageService = messageService;
    }

    _createClass(OfferPeriodFormController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.offer.periods.length > 0) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.offer.periods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var period = _step.value;

                        period.start = period.start ? moment(period.start, 'YYYY-MM-DD') : '';
                        period.end = period.end ? moment(period.end, 'YYYY-MM-DD') : '';
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                this.offer.periods = [{ start: '' }];
            }
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            var periodclone = (0, _lodash.cloneDeep)(this.offer.periods);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.offer.periods[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var period = _step2.value;

                    if (period.start) {
                        period.start = period.start.format('YYYY-MM-DD');
                    }
                    if (period.end && typeof period.end !== 'boolean') {
                        period.end = period.end.format('YYYY-MM-DD');
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return this.offerService.savePeriods(this.offer.periods, this.offer.id).then(function (response) {
                if (!response.error) {
                    if (!_this.offer.events) {
                        _this.messageService.success('The special offer <strong>' + _this.offer.name + '</strong> was successfully updated!');
                        _this.$state.go('app.admin.offer-edit', { offer: _this.offer.id, tab: 'events' });
                    } else {
                        _this.messageService.success('The special offer <strong>' + response.name + '</strong> was successfully updated.', ['app.admin.offer-edit({ \'offer\' : ' + _this.offer.id + '})', 'Offer']);
                        _this.$state.go('app.admin.offers');
                    }
                } else {
                    var errorlist = '';
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = response.error[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var error = _step3.value;

                            errorlist += '<li>Conflicting offer period <strong>' + error.period.start + '</strong> - <strong>' + error.period.end + '</strong> due to <strong>' + error.event + '</strong> on offer <strong>' + error.offer + '</strong></li>';
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    _this.messageService.failure('The offer periods could not be successfully updated:\n<ul>' + errorlist + '</ul>');
                    _this.messageService.push();
                }
                _this.offer.periods = periodclone;
            }).catch(function (error) {
                _this.messageService.failure('The offer <strong>' + _this.offer.name + '</strong> could not be successfully created: ' + error.statusText);
                _this.messageService.push();
                var sourceElement = Object.keys(error.data)[0];
                if (sourceElement > 0) {
                    _this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
                } else {
                    _this.$scope.$ctrl.form.$setValidity(sourceElement, false);
                }
            });
        }
    }]);

    return OfferPeriodFormController;
}();

OfferPeriodFormController.$inject = ['$rootScope', '$scope', '$state', 'offerService', 'messageService'];

exports.default = OfferPeriodFormController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    offers: '<'
  },
  controller: 'offerListController',
  template: __webpack_require__(865)
};

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Special Offers</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.offer-add class=c-button--action> <icon icon=medal></icon> Create a Special Offer </a> </div> </header> <main class=s-main> <form class=\"row c-list__search c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> <option value=status>Status</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.offers.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No special offers have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No special offers match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <div ng-if=\"$ctrl.offers.data.length > 0\" id=list data-as-sortable=$ctrl.dragControlListeners data-ng-model=$ctrl.offers.data class=\"c-table / c-offers-list__container\"> <div class=c-table__head> <div class=\"c-table__cell c-table__lights-cell\"></div> <div class=c-table__cell>Name</div> <div class=\"c-table__cell c-table__cell__edit\" ng-if=\"$ctrl.access.check('manager')\"></div> <div class=\"c-table__cell c-table__cell__delete\" ng-if=\"$ctrl.access.check('manager')\"></div> </div> <div class=c-table__body> <div data-ng-repeat=\"offer in $ctrl.offers.data\" class=\"c-table__row / c-list c-offers-list__drag {{ offer.deleted_at ? 'c-list__deleted' : ''}}\" data-as-sortable-item> <div class=\"c-table__cell c-table__lights-cell\"><span ng-class=\"(offer.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (offer.status)? 'This offer is active' : 'This offer is not active' }}\"></span></div> <div class=c-table__cell>{{ offer.name }}</div> <div class=\"c-table__cell / c-list__action c-table__cell__edit\" ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.offer-edit({ offer: offer.id })\">Edit</a> </div> <div class=\"c-table__cell / c-list__action c-table__cell__delete\" ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(offer) confirm=\"Are you sure you want to delete {{ offer.name }}?\">Delete</a> </div> </div> </div> </div> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    offer: '=',
    title: '@',
    formTab: '='
  },
  controller: 'offerSaveController',
  template: __webpack_require__(867)
};

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=\"$ctrl.period.id && $ctrl.activeTab != 'period'\">{{ $ctrl.period.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'offer' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'offer'\" ng-if=\"$ctrl.access.check('manager')\"> Offer </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'period' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'period'\" ng-if=\"$ctrl.offer.id && $ctrl.access.check('manager')\"> Period </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'events' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'events'\" ng-if=\"$ctrl.offer.id && $ctrl.access.check('manager')\"> Affected Events </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'included' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'included'\" ng-if=\"$ctrl.offer.id && $ctrl.access.check('manager')\"> Basket Included </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'excluded' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'excluded'\" ng-if=\"$ctrl.offer.id && $ctrl.access.check('manager')\"> Basket Excluded </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'offer' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <offer-form offer=$ctrl.offer form-tab=$ctrl.activeTab></offer-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'period' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <offer-period-form offer=$ctrl.offer></offer-period-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'events' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.offer existing-events=$ctrl.offer.grouped_events form-type=effect names=\"{'single': 'offer', 'plural': 'offers'}\" form-tab=$ctrl.activeTab all=true description=\"These events will receive the discount applied by this offer. Only one offer should ever be available for and offer at a time (as only the first offer the system encounters will be applied)\" events=$ctrl.eventpromise></event-multi-select-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'included' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.offer existing-events=$ctrl.offer.grouped_inclusions form-type=include names=\"{'single': 'offer', 'plural': 'offers'}\" form-tab=$ctrl.activeTab description=\"This offer will only be valid when any of the following events are present in the basket.\" events=$ctrl.eventpromise all=true></event-multi-select-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'excluded' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.offer existing-events=$ctrl.offer.grouped_exclusions form-type=exclude names=\"{'single': 'offer', 'plural': 'offers'}\" form-tab=$ctrl.activeTab description=\"The presence of any of the following events in the basket will void this offer.\" events=$ctrl.eventpromise all=true></event-multi-select-form> </div> </div> </div> </div> </main> ";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    offer: '='
  },
  controller: 'offerFormController',
  template: __webpack_require__(869)
};

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.offer.name form-field-errors required> <label class=c-form__label for=name>Name</label> </div> <h2>Pricing Rules</h2> <p class=c-description>All affected events will have this pricing rule applied.</p> <div class=row> <div class=\"columns medium-6\"> <label class=c-period__heading>Pricing Type</label> <div class=c-form__field> <select ng-model=$ctrl.offer.pricing_type ng-change=$ctrl.nullGlobal(rule) required> <option value=\"\" disabled=disabled>N/A</option> <option value=\"=\">New Price</option> <option value=#>+/- Value</option> <option value=%>+/- Percent</option> </select> </div> </div> <div class=\"columns medium-6\"> <label class=c-period__heading>Pricing Value</label> <div class=\"c-form__field c-form__field--money\" ng-if=\"$ctrl.offer.pricing_type === '#' || $ctrl.offer.pricing_type === '=' || !$ctrl.offer.pricing_type\"> <money-input name=pricing_value ng-disabled=!$ctrl.offer.pricing_type ng-model=$ctrl.offer.pricing_value form-field-errors></money-input> <label class=c-form__label for=price><span ng-if=\"$ctrl.offer.pricing_type === '#'\">+/- </span>Value</label> </div> <div class=\"c-form__field c-form__field--money c-form__field--percentage\" ng-if=\"$ctrl.offer.pricing_type === '%'\"> <money-input name=pricing_value ng-disabled=!$ctrl.offer.pricing_type ng-model=$ctrl.offer.pricing_value decorate=percentage form-field-errors></money-input> <label class=c-form__label for=price>+/- Percent</label> </div> </div> </div> <h2>Basket Conditions</h2> <div class=row> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=minimum_spend ng-model=$ctrl.offer.minimum_spend form-field-errors></money-input> <label class=c-form__label for=price>Minimum Spend</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=price type=number class=c-form__input ng-model=$ctrl.offer.quantity form-field-errors ng-pattern=/^[0-9]+$/ autocomplete=off> <label class=c-form__label for=price>Additional Events in Basket</label> <i class=\"c-icon c-icon--help\" tooltip=\"This field can only contain numbers (0-9)\" tooltip-placement=left>?</i> </div> </div> </div> <h2>Publish Dates</h2> <p class=c-description>Select the time range you want the offer to be visible on the storefront.</p> <div class=row> <div class=\"column medium-6\"> <div class=c-form__field> <input name=start_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors ng-model=$ctrl.offer.publish_at moment-picker=$ctrl.offer.publish_at keyboard=true format=\"YYYY-MM-DD HH:mm\" min-view=month max-view=hour set-on-select=true autocomplete=off validate=true> <label class=c-form__label for=start_time>Start Date</label> </div> <div class=\"button round\" ng-click=$ctrl.setTime(1)>Start of day</div> </div> <div class=\"column medium-6\"> <div class=c-form__field> <input name=end_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors ng-model=$ctrl.offer.unpublish_at moment-picker=$ctrl.offer.unpublish_at keyboard=true format=\"YYYY-MM-DD HH:mm\" min-view=month max-view=hour validate=true set-on-select=true autocomplete=off min-date=$ctrl.offer.publish_at> <label class=c-form__label for=end_time>End Date</label> </div> <div class=\"button round\" ng-click=$ctrl.setTime()>End of day</div> </div> </div> <h2>Terms</h2> <p class=c-description>These terms will override any set on the primary category or event for all affected events.</p> <div class=c-form__field> <textarea name=description_in class=c-form__textarea type=text ng-model=$ctrl.offer.terms form-field-errors></textarea> <label class=c-form__label for=description_in>Terms &amp; Conditions</label> </div> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this offer will be active and accessible on the website.</p> <switch id=status name=status ng-model=$ctrl.offer.status class=green></switch> <label for=status class=c-label>Upsell Only</label> <p class=c-description>If enabled, this offer will only be shown during the suggestions portion of the checkout.</p> <switch id=status name=status ng-model=$ctrl.offer.upsell class=green></switch> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Offer <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        offer: '<',
        formTab: '='
    },
    controller: 'offerPeriodFormController',
    template: __webpack_require__(871)
};

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <h2>Arrival Date Periods</h2> <p class=c-description>Select the date range you want the offer to be active on the storefront.</p> <div class=\"c-period__pricing / c-offer__period\" ng-repeat=\"(key, period) in $ctrl.offer.periods track by $index\"> <div class=row> <div class=\"column medium-6\"> <div class=c-form__field> <input name=start_time type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly form-field-errors required ng-model=period.start moment-picker=period.start keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off> <label class=c-form__label for=start_time>Start Date</label> <i class=\"c-icon c-icon--clear-small\" ng-click=\"period.start = undefined;\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"column medium-6\"> <div class=c-form__field> <input name=end_time type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly form-field-errors required ng-model=period.end moment-picker=period.end keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off min-date=period.start> <label class=c-form__label for=end_time>End Date</label> <i class=\"c-icon c-icon--clear-small\" ng-click=\"period.end = undefined;\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> </div> <a class=c-period__pricing__remove ng-if=\"$ctrl.offer.periods.length > 1\" ng-click=\"$ctrl.offer.periods.splice(key, 1)\">&times;</a> </div> <a class=c-period__add ng-click=$ctrl.offer.periods.push({})> <span>+</span> Add new date period </a> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Offer Date Periods <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property) {
    return '/api/' + property + '/offer';
};
var periodsendpoint = function periodsendpoint(property, id) {
    return '/api/' + property + '/offer/' + id + '/periods';
};

exports.default = ['api', '$rootScope', function (api, $rootScope) {
    var getById = function getById(offerId) {
        return api.get(endpoint(api.property()) + '/' + offerId).then(function (response) {
            return response.data;
        });
    };

    return {
        save: function save(offer) {
            var url = offer.id ? endpoint(api.property()) + '/' + offer.id : endpoint(api.property());

            return api.upload(url, offer).then(function (response) {
                return response.data;
            });
        },
        savePeriods: function savePeriods(data, offerId) {
            return api.post(periodsendpoint(api.property(), offerId), data).then(function (response) {
                return response.data;
            });
        },
        delete: function _delete(offerId) {
            return api.delete(endpoint(api.property()) + '/' + offerId);
        },
        findAll: function findAll() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
                return response.data;
            });
        },
        findById: function findById(offerId) {
            return getById(offerId);
        },
        toggleActive: function toggleActive(offerId) {
            return api.get(endpoint(api.property()) + '/status/' + offerId).then(function (response) {
                return response.data;
            });
        },
        search: function search(type, text) {
            var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
                return response.data;
            });
        },
        getDetails: function getDetails(offerId) {
            return getById(offerId);
        }
    };
}];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _order = __webpack_require__(874);

var _order2 = _interopRequireDefault(_order);

var _orderSave = __webpack_require__(876);

var _orderSave2 = _interopRequireDefault(_orderSave);

var _orderForm = __webpack_require__(877);

var _orderForm2 = _interopRequireDefault(_orderForm);

var _orderRefund = __webpack_require__(878);

var _orderRefund2 = _interopRequireDefault(_orderRefund);

var _orderSummary = __webpack_require__(879);

var _orderSummary2 = _interopRequireDefault(_orderSummary);

var _orderList = __webpack_require__(880);

var _orderList2 = _interopRequireDefault(_orderList);

var _orderNotes = __webpack_require__(881);

var _orderNotes2 = _interopRequireDefault(_orderNotes);

var _refundHistory = __webpack_require__(882);

var _refundHistory2 = _interopRequireDefault(_refundHistory);

var _statuses = __webpack_require__(883);

var _statuses2 = _interopRequireDefault(_statuses);

var _adminPaymentErrors = __webpack_require__(884);

var _adminPaymentErrors2 = _interopRequireDefault(_adminPaymentErrors);

var _orderEmails = __webpack_require__(885);

var _orderEmails2 = _interopRequireDefault(_orderEmails);

var _emailView = __webpack_require__(886);

var _emailView2 = _interopRequireDefault(_emailView);

var _orderSave3 = __webpack_require__(887);

var _orderSave4 = _interopRequireDefault(_orderSave3);

var _orderForm3 = __webpack_require__(889);

var _orderForm4 = _interopRequireDefault(_orderForm3);

var _orderRefund3 = __webpack_require__(891);

var _orderRefund4 = _interopRequireDefault(_orderRefund3);

var _orderSummary3 = __webpack_require__(893);

var _orderSummary4 = _interopRequireDefault(_orderSummary3);

var _orderList3 = __webpack_require__(895);

var _orderList4 = _interopRequireDefault(_orderList3);

var _orderNotes3 = __webpack_require__(897);

var _orderNotes4 = _interopRequireDefault(_orderNotes3);

var _refundHistory3 = __webpack_require__(899);

var _refundHistory4 = _interopRequireDefault(_refundHistory3);

var _orderStatuses = __webpack_require__(901);

var _orderStatuses2 = _interopRequireDefault(_orderStatuses);

var _paymentStatuses = __webpack_require__(903);

var _paymentStatuses2 = _interopRequireDefault(_paymentStatuses);

var _adminPaymentErrors3 = __webpack_require__(905);

var _adminPaymentErrors4 = _interopRequireDefault(_adminPaymentErrors3);

var _emailView3 = __webpack_require__(907);

var _emailView4 = _interopRequireDefault(_emailView3);

var _orderEmails3 = __webpack_require__(909);

var _orderEmails4 = _interopRequireDefault(_orderEmails3);

var _ordersApi = __webpack_require__(911);

var _ordersApi2 = _interopRequireDefault(_ordersApi);

var _refund = __webpack_require__(912);

var _refund2 = _interopRequireDefault(_refund);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderModule = angular.module('spabooker.order', ['spabooker.base']).config(_order2.default).controller('orderSaveController', _orderSave2.default).controller('orderFormController', _orderForm2.default).controller('orderRefundController', _orderRefund2.default).controller('orderSummaryController', _orderSummary2.default).controller('orderListController', _orderList2.default).controller('orderNotesController', _orderNotes2.default).controller('refundHistoryController', _refundHistory2.default).controller('statusesController', _statuses2.default).controller('adminPaymentErrorsController', _adminPaymentErrors2.default).controller('orderEmailsController', _orderEmails2.default).controller('emailViewController', _emailView2.default).component('orderSave', _orderSave4.default).component('orderForm', _orderForm4.default).component('orderRefund', _orderRefund4.default).component('orderSummary', _orderSummary4.default).component('orderList', _orderList4.default).component('orderNotes', _orderNotes4.default).component('refundHistory', _refundHistory4.default).component('orderStatuses', _orderStatuses2.default).component('paymentStatuses', _paymentStatuses2.default).component('adminPaymentErrors', _adminPaymentErrors4.default).component('emailView', _emailView4.default).component('orderEmails', _orderEmails4.default).factory('ordersApiService', _ordersApi2.default).factory('refundService', _refund2.default);

exports.default = orderModule.name;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _orders = __webpack_require__(875);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.orders', {
        url: '/events/orders?:filtertype&:filtertext',
        component: 'orderList',
        resolve: {
            orders: (0, _orders.resolveOrders)()
        },
        roles: ['manager', 'stock', 'orders']
    }).state('app.admin.deletedorders', {
        url: '/events/orders/deleted',
        component: 'orderList',
        resolve: {
            deleted: function deleted() {
                return true;
            }
        },
        roles: ['admin']
    }).state('app.admin.order-create', {
        url: '/baskets/create',
        component: 'basketCreate',
        resolve: {
            title: function title() {
                return 'Create an Order';
            }
        },
        roles: ['manager', 'orders']
    }).state('app.admin.order-edit', {
        url: '/events/orders/:order/update?tab',
        component: 'orderSave',
        resolve: {
            order: (0, _orders.resolveOrder)()
        },
        roles: ['manager', 'stock', 'orders']
    }).state('app.admin.email-view', {
        url: '/events/orders/:order/email?template',
        component: 'emailView',
        resolve: {
            emailContent: (0, _orders.resolveEmailContent)()
        },
        roles: ['manager', 'orders']
    });
}];

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveOrders = exports.resolveOrders = function resolveOrders() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    return ['$stateParams', 'ordersApiService', function ($stateParams, ordersApiService) {
        if (!$stateParams.filtertype && !$stateParams.filtertext) {
            return ordersApiService.findPayment(page, perpage).then(function (list) {
                return list;
            });
        }

        return ordersApiService.search($stateParams.filtertype, $stateParams.filtertext, page).then(function (list) {
            return list;
        });
    }];
};

var resolveOrder = exports.resolveOrder = function resolveOrder() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'order';

    return ['$stateParams', 'ordersApiService', function ($stateParams, ordersApiService) {
        return $stateParams[param] && $stateParams[param] > 0 ? ordersApiService.findById($stateParams[param]) : {};
    }];
};

var resolveEmailContent = exports.resolveEmailContent = function resolveEmailContent() {
    return ['$stateParams', 'ordersApiService', function ($stateParams, ordersApiService) {
        return ordersApiService.getEmailContent($stateParams['order'], $stateParams['template']).then(function (response) {
            return response.data;
        });
    }];
};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSaveController = function () {
    function OrderSaveController($stateParams, ordersApiService, access) {
        _classCallCheck(this, OrderSaveController);

        this.$stateParams = $stateParams;
        this.ordersApiService = ordersApiService;
        this.access = access;
    }

    _createClass(OrderSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.activeTab = this.$stateParams.tab || 'summary';
            this.preventEditing = ['Failed', 'Cancelled', 'Disputed'].indexOf(this.order.order_status) > -1;

            return Promise.all([this.ordersApiService.getOrderStatuses().then(function (response) {
                _this.order_statuses = response.filter(function (status) {
                    return !status.private || status.id === _this.order.order_status_id;
                });
            }), this.ordersApiService.getPaymentStatuses().then(function (response) {
                _this.payment_statuses = response;
            })]);
        }
    }, {
        key: 'formatTime',
        value: function formatTime() {
            return moment(this.order.created_at + '+00:00').format('LLLL');
        }
    }, {
        key: 'orderProgress',
        value: function orderProgress(state) {
            switch (state) {
                case 'pendingPayment':
                    return ['Pending payment', 'Awaiting Confirmation', 'Paid', 'Confirmed'].indexOf(this.order.order_status) > -1;
                case 'pendingConfirmation':
                    return ['Awaiting Confirmation', 'Paid', 'Confirmed'].indexOf(this.order.order_status) > -1;
                case 'confirmed':
                    return this.order.order_status === 'Confirmed';
                case 'cancelled':
                    return ['Failed', 'Cancelled'].indexOf(this.order.order_status) > -1;
                case 'disputed':
                    return this.order.order_status === 'Disputed';
            }
        }
    }]);

    return OrderSaveController;
}();

OrderSaveController.$inject = ['$stateParams', 'ordersApiService', 'access'];

exports.default = OrderSaveController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderFormController = function () {
    function OrderFormController($state, ordersApiService, messageService) {
        _classCallCheck(this, OrderFormController);

        this.$state = $state;
        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
    }

    _createClass(OrderFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.items = {};
            if (!this.order) {
                this.order = {};
            }
            if (this.order.customer && this.order.customer.marketing === 1) {
                this.order.customer.marketing = true;
            }

            this.originalTotal = (0, _lodash.clone)(this.order.total);
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            var ordercopy = (0, _lodash.cloneDeep)(this.order);

            delete this.order.basket;

            var displayitems = (0, _lodash.cloneDeep)(this.order.item);
            var items = (0, _lodash.cloneDeep)(this.items);
            for (var guest in items) {
                for (var item in items[guest]) {
                    items[guest][item].date = items[guest][item].date.format('YYYY-MM-DD');
                }
            }

            this.order.item = items;
            return this.ordersApiService.save(this.order).then(function (response) {
                if (_this.order.deleted_at !== null) {
                    _this.messageService.success('The order <strong>' + _this.order.order_reference + '</strong> was successfully revived!', ['app.admin.order - edit({ \'order\': ' + _this.order.id + '})', 'Order']);
                    return;
                } else if (_this.order.id) {
                    _this.messageService.success('The order <strong>' + _this.order.order_reference + '</strong> was successfully updated!');
                }
                _this.order = ordercopy;
                _this.order.item = displayitems;
                _this.messageService.push();
                _this.formTab = 'summary';

                return response;
            }).catch(function (error) {
                _this.messageService.failure('The order <strong> ' + _this.order.order_reference + '</strong > could not be successfully created: ' + error.statusText + ' ');
                _this.messageService.push();
            });
        }
    }, {
        key: 'findItems',
        value: function findItems(guestid) {
            if (this.items[guestid]) return this.items[guestid];
            this.items[guestid] = (0, _lodash.filter)(this.order.item, { 'guest_id': guestid }).map(function (item) {
                if (item.date) item.date = moment(item.date);
                return {
                    'date': item.date,
                    'time': item.preferred_time,
                    'id': item.id,
                    'name': item.name
                };
            });
            return this.items[guestid];
        }
    }, {
        key: 'updateTime',
        value: function updateTime(item) {
            var orderItem = (0, _lodash.find)(this.order.item, { 'id': item.id });
            if (orderItem) orderItem.preferred_time = item.time;
        }
    }, {
        key: 'isDisputed',
        value: function isDisputed() {
            return this.order.order_status === 'Disputed';
        }
    }]);

    return OrderFormController;
}();

OrderFormController.$inject = ['$state', 'ordersApiService', 'messageService'];

exports.default = OrderFormController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderRefundController = function () {
    function OrderRefundController(moneyService, refundService, messageService) {
        _classCallCheck(this, OrderRefundController);

        this.moneyService = moneyService;
        this.refundService = refundService;
        this.messageService = messageService;
    }

    _createClass(OrderRefundController, [{
        key: '$onInit',
        value: function $onInit() {
            this.refundAmount = this.order.refundable_amount;
            this.transformHistory(this.order.refund);
            this.manualRefund = false;

            this.reason = this.reason || "";
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            this.messageService.clear();
            this.error = '';
            this.refundedAmount = this.order.refundable_amount;

            if (!this.validate()) {
                this.messageService.failure(this.error);
                this.messageService.push();
                this.saving = false;
                return Promise.reject({ data: {} });
            }

            var reason = this.reason;
            if (reason === 'Other') {
                reason = this.customReason;
            }

            this.refundedAmount = (0, _lodash.clone)(parseInt(this.refundAmount));

            reason = 'Refunded ' + this.moneyService.reduce(this.refundAmount, this.order.currency_code) + '. ' + reason;

            return this.refundService.save(this.order, {
                amount: parseInt(this.refundAmount),
                reason: reason,
                manual_refund: this.manualRefund
            });
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess() {
            var _this = this;

            this.clearInputs();

            return this.refundService.getHistory(this.order).then(function (response) {
                _this.messageService.success('Amount refunded successfully.');
                _this.messageService.push();

                _this.transformHistory(response);
            });
        }
    }, {
        key: 'onError',
        value: function onError() {
            var _this2 = this;

            return this.refundService.getHistory(this.order).then(function (response) {
                _this2.messageService.failure('Refund was unsuccessful.');
                _this2.messageService.push();

                _this2.transformHistory(response);
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            if (this.refundAmount > this.order.refundable_amount) {
                this.error = 'The refund amount must be less than or equal to the remaining Order total.';
                return false;
            }

            if (this.refundAmount < 1) {
                this.error = 'The refund amount must greater than 0.';
                return false;
            }

            if (!this.reason || this.reason === 'Other' && !this.customReason) {
                this.error = 'You must specify a reason for this refund.';
                return false;
            }

            return true;
        }
    }, {
        key: 'validateAmount',
        value: function validateAmount() {
            this.amountError = false;
            if (this.refundAmount > this.order.refundable_amount) {
                this.amountError = true;
            }
        }
    }, {
        key: 'clearReason',
        value: function clearReason() {
            this.customReason = '';
        }
    }, {
        key: 'clearInputs',
        value: function clearInputs() {
            this.order.refundable_amount -= this.refundedAmount;
            this.refundAmount = this.order.refundable_amount;
            this.reason = '';
            this.customReason = '';
        }
    }, {
        key: 'transformHistory',
        value: function transformHistory(transactions) {
            var paidTransaction = this.order.transaction.find(function (transaction) {
                return transaction.code === '200';
            });
            if (paidTransaction && paidTransaction.details) {
                paidTransaction.notes = ['Payment taken successfully for ' + this.moneyService.reduce(paidTransaction.details.amount, this.order.currency_code)];
                transactions.push(paidTransaction);
            }
            this.refundHistory = (0, _lodash.groupBy)(transactions, function (transaction) {
                return transaction.created_at.substring(0, 10);
            });
        }
    }, {
        key: 'showRefunds',
        value: function showRefunds() {
            return [4, 15, 16, 17, 18, 20, 21, 22, 23].indexOf(this.order.payment_status_id) > -1;
        }
    }, {
        key: 'disableRefundForm',
        value: function disableRefundForm() {
            return [20, 22, 23].indexOf(this.order.payment_status_id) > -1;
        }
    }, {
        key: 'disabledReason',
        value: function disabledReason() {
            switch (this.order.payment_status_id) {
                case 20:
                    return 'There is an open payment dispute which must be resolved before refunds can be made.';
                case 22:
                    return 'A payment dispute was lost and the total value has already been automatically refunded to the customer.';
                case 23:
                    return 'A previous refund attempt to this card has failed. The purchaser will need to contact their card issuer but may also contact you.';
            }
        }
    }, {
        key: 'cannotRefund',
        value: function cannotRefund() {
            return this.order.refundable_amount <= 0 && Object.keys(this.refundHistory).length === 0;
        }
    }, {
        key: 'alreadyRefunded',
        value: function alreadyRefunded() {
            return this.order.refundable_amount <= 0 && Object.keys(this.refundHistory).length > 0;
        }
    }, {
        key: 'canRefund',
        value: function canRefund() {
            return this.order.refundable_amount > 0;
        }
    }]);

    return OrderRefundController;
}();

OrderRefundController.$inject = ['moneyService', 'refundService', 'messageService'];

exports.default = OrderRefundController;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSummaryController = function () {
    function OrderSummaryController($rootScope, $state, $stateParams, ordersApiService, messageService, access, propertyService) {
        _classCallCheck(this, OrderSummaryController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
        this.access = access;
        this.propertyService = propertyService;
    }

    _createClass(OrderSummaryController, [{
        key: '$onInit',
        value: function $onInit() {
            this.orderStatusId = (0, _lodash.clone)(this.order.order_status_id);

            if (this.order.item.length && this.order.basket.guest_details.length) {
                for (var key in this.order.basket.guest_details) {
                    this.order.basket.guest_details[key].total = (0, _lodash.sum)((0, _lodash.map)((0, _lodash.filter)(this.order.item, { 'guest_id': this.order.basket.guest_details[key].id }), function (item) {
                        return parseFloat(item.price);
                    }));
                }
            }

            if (this.order.vouchers.length) this.sumVouchers();

            this.setState();
        }
    }, {
        key: 'setState',
        value: function setState() {
            this.paymentId = this.paymentID();
            this.paymentGateway = this.propertyService.get('finance').payment_gateway;
        }
    }, {
        key: 'boolean',
        value: function boolean(bool) {
            if (bool === 1 || bool === true) {
                return 'Yes';
            }

            return 'No';
        }
    }, {
        key: 'guestItems',
        value: function guestItems(id) {
            return (0, _lodash.filter)(this.order.item, { 'guest_id': id, 'item_parent': null });
        }
    }, {
        key: 'findPaidTransaction',
        value: function findPaidTransaction() {
            return (0, _lodash.find)(this.order.transaction, { 'code': '200', 'payment_status_id': 4 });
        }
    }, {
        key: 'paymentDate',
        value: function paymentDate() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return log.created_at;
            }
            return '';
        }
    }, {
        key: 'paymentID',
        value: function paymentID() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return log.details.transaction_id;
            }
            return '';
        }
    }, {
        key: 'paymentType',
        value: function paymentType() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return log.details.card_type;
            }
            return 'Unknown';
        }
    }, {
        key: 'paymentDigits',
        value: function paymentDigits() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return '**** **** **** ' + log.details.card_last_4;
            }
            return '';
        }
    }, {
        key: 'paymentExpiry',
        value: function paymentExpiry() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return log.details.card_expiry;
            }
            return '';
        }
    }, {
        key: 'paymentReceived',
        value: function paymentReceived() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return log.details.amount;
            }
            return '';
        }
    }, {
        key: 'paysafeOrderRef',
        value: function paysafeOrderRef() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return log.details.merchant_reference;
            }
            return '';
        }
    }, {
        key: 'destinationPayment',
        value: function destinationPayment() {
            var log = this.findPaidTransaction();
            if (log && log.details) {
                return log.details.destination_payment;
            }
            return '';
        }
    }, {
        key: 'guestPrice',
        value: function guestPrice(guest) {
            var total = 0;

            var guestItems = this.guestItems(guest);

            if (guest && guestItems) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = guestItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        if (item.price) {
                            total += this.totalItem(item);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return total;
        }
    }, {
        key: 'onSave',
        value: function onSave() {
            var _this = this;

            var ordercopy = (0, _lodash.cloneDeep)(this.order);

            delete this.order.basket;
            delete this.order.item;
            delete this.order.customer;

            return this.ordersApiService.save(this.order).then(function (response) {
                if (_this.order.deleted_at !== null) {
                    _this.messageService.success('The order <strong>' + _this.order.order_reference + '</strong> was successfully revived!', ['app.admin.order-edit({ \'order\' : ' + _this.order.id + '})', 'Order']);
                    _this.$state.go('app.admin.orders');
                } else if (_this.order.id) {
                    _this.messageService.success('The order <strong>' + _this.order.order_reference + '</strong> was successfully updated!');
                    _this.messageService.push();
                    _this.$state.go('app.admin.order-edit', { order: _this.order.id });
                } else {
                    _this.messageService.success('The Order <strong>' + _this.order.order_reference + '</strong> was successfully created. Please edit the start times.', ['app.admin.order-edit({ \'order\' : ' + response.id + '})', 'Order']);
                    _this.$state.go('app.admin.order-edit', { order: response.id });
                }
                _this.order = ordercopy;
            }).catch(function (error) {
                // this.messageService.failure(`The order <strong>${this.order.name}</strong> could not be successfully created: ${error.statusText}`);
                // this.messageService.push();
            });
        }
    }, {
        key: 'totalItem',
        value: function totalItem(item) {
            var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            total += parseFloat(item.price);
            if (item.children.length) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = item.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var child = _step2.value;

                        if (child.price > 0) {
                            total += parseFloat(child.price);
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            return total;
        }
    }, {
        key: 'sumVouchers',
        value: function sumVouchers() {
            this.vouchertotal = 0;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this.order.vouchers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var voucher = _step3.value;

                    this.vouchertotal += voucher.codevalue;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: 'isDisputed',
        value: function isDisputed() {
            return this.order.order_status === 'Disputed';
        }
    }, {
        key: 'displayGatewayFee',
        value: function displayGatewayFee() {
            if (this.order.refundable_amount === 0) {
                return 0;
            }

            return this.order.gateway_fee;
        }
    }, {
        key: 'displayApplicationFee',
        value: function displayApplicationFee() {
            if (this.order.refundable_amount === 0) {
                return 0;
            }

            return this.order.application_fee;
        }
    }, {
        key: 'stripeId',
        value: function stripeId() {
            var finance = this.propertyService.get('finance');
            if (finance) {
                return finance.stripe_user_id;
            }
        }
    }]);

    return OrderSummaryController;
}();

OrderSummaryController.$inject = ['$rootScope', '$state', '$stateParams', 'ordersApiService', 'messageService', 'access', 'propertyService'];

exports.default = OrderSummaryController;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderListController = function () {
    function OrderListController($rootScope, $scope, $state, ordersApiService, messageService, access, reportsService, $stateParams) {
        _classCallCheck(this, OrderListController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
        this.access = access;
        this.reports = reportsService;
        this.$stateParams = $stateParams;
    }

    _createClass(OrderListController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.filtertype = this.$stateParams.filtertype || 'id';
            this.filtertext = this.$stateParams.filtertext || null;

            if (this.filtertext) {
                this.isFiltered = true;
            }

            this.updatePaging();
            this.$scope.$watch(function (scope) {
                return scope.current_page;
            }, function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.orders = undefined;
                        scope.$ctrl.ordersApiService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
                            scope.$ctrl.orders = response;
                            scope.$ctrl.loading = false;
                        });
                    } else {
                        scope.$ctrl.ordersApiService.findPayment(newVal, scope.per_page).then(function (list) {
                            return scope.$ctrl.orders = list;
                        });
                    }
                }
            });

            this.ordersApiService.getOrderStatuses().then(function (response) {
                _this.order_statuses = response;
            });

            this.ordersApiService.getPaymentStatuses().then(function (response) {
                _this.payment_statuses = response;
            });
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            if (this.orders) {
                this.$scope.per_page = this.orders.per_page;
                this.$scope.current_page = this.orders.current_page;
                this.$scope.total = this.orders.total;
            }
        }
    }, {
        key: 'onDelete',
        value: function onDelete(order) {
            var _this2 = this;

            var orderReference = order.order_reference;

            return this.ordersApiService.delete(order.id).then(function () {
                _this2.messageService.success('The order <strong>' + orderReference + '</strong> was successfully deleted.');
                _this2.messageService.push();
            }).catch(function (error) {
                _this2.messageService.failure('The order <strong>' + orderReference + '</strong> could not be successfully deleted: ' + error.statusText);
                _this2.messageService.push();
            }).then(function () {
                var page = _this2.orders.current_page;
                _this2.orders = [];
                _this2.loading = true;
                return _this2.ordersApiService.findAll(page).then(function (response) {
                    _this2.orders = response;
                    _this2.loading = false;
                });
            });
        }
    }, {
        key: 'formatTime',
        value: function formatTime(dateTime) {
            return moment(dateTime + '+00:00').format('LLLL');
        }
    }, {
        key: 'humanTime',
        value: function humanTime(dateTime) {
            return moment(dateTime + '+00:00').fromNow();
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this3 = this;

            if (!this.loading && this.filtertext) {
                this.startFilter();
                this.ordersApiService.search(this.filtertype, this.filtertext, this.deleted).then(function (response) {
                    _this3.isFiltered = true;
                    _this3.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this4 = this;

            this.startFilter();
            this.ordersApiService.findAll(1, 20).then(function (response) {
                _this4.isFiltered = false;
                _this4.endFilter(response);
            });
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            this.isFiltered = false;
            switch (this.filtertype) {
                case 'order_status_id':
                    this.filtertext = 'processing';
                    break;
                case 'payment_status_id':
                    this.filtertext = '200';
                    break;
                default:
                    this.filtertext = '';
                    break;
            }
        }
    }, {
        key: 'displayFiltertype',
        value: function displayFiltertype() {
            return this.filtertype.replace(/[._]/, ' ');
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this.download = undefined;
            this.orders = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this.orders = response;
            this.updatePaging();
            this.loading = false;
        }
    }, {
        key: 'generateReport',
        value: function generateReport() {
            var _this5 = this;

            this.generating = true;

            var query = {
                type: 'order'
            };

            switch (this.filtertype) {
                case 'id':
                    query.order = this.filtertext;
                    break;
                case 'customer.name':
                    query.name = this.filtertext;
                    break;
                case 'customer.email':
                    query.email = this.filtertext;
                    break;
                case 'order_status_id':
                    query.status = this.filtertext;
                    break;
                case 'payment_status_id':
                    query.payment = this.filtertext;
                    break;
                case 'created_at':
                    query.datecreated = this.filtertext ? this.filtertext.format('YYYY-MM-DD') : undefined;
                    break;
                case 'reference':
                    query.external = this.filtertext;
                    break;
            }

            this.reports.generate(query).then(function (response) {
                _this5.download = response.link;
                _this5.filename = response.name;
                _this5.generating = false;
            }).catch(function () {
                _this5.messageService.failure('Unfortunately that report could not be generated, please try again.');
                _this5.messageService.push();
                _this5.messageService.autoClear();
                _this5.generating = false;
            });
        }
    }]);

    return OrderListController;
}();

OrderListController.$inject = ['$rootScope', '$scope', '$state', 'ordersApiService', 'messageService', 'access', 'reportsService', '$stateParams'];

exports.default = OrderListController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderNotesController = function () {
  function OrderNotesController() {
    _classCallCheck(this, OrderNotesController);
  }

  _createClass(OrderNotesController, [{
    key: 'transformTransactions',
    value: function transformTransactions() {
      return (0, _lodash.groupBy)(this.order.transaction, function (transaction) {
        return transaction.created_at.substring(0, 10);
      });
    }
  }, {
    key: 'getTransactions',
    value: function getTransactions() {
      if (!this.transactions) {
        this.transactions = this.transformTransactions();
      }

      return this.transactions;
    }
  }, {
    key: 'isErrorCode',
    value: function isErrorCode(code) {
      switch (code) {
        case null:
        case '200':
        case 'token':
        case 'attempt_payment':
        case 'adjustment':
        case 'refund':
        case 'integration_confirmed':
        case 'redeem_gifted_success':
          return false;
      }

      return true;
    }
  }, {
    key: 'isTotalAdjustment',
    value: function isTotalAdjustment(code) {
      switch (code) {
        case 'adjustment':
        case 'refund':
          return true;
      }

      return false;
    }
  }, {
    key: 'formatTime',
    value: function formatTime(utcTime) {
      return (0, _moment2.default)(utcTime + '+00:00').format('LLLL');
    }
  }, {
    key: 'isManual',
    value: function isManual(log) {
      return !!log.details && log.details.transaction_id === 'Manual Refund';
    }
  }, {
    key: 'showTick',
    value: function showTick(log) {
      return log.code === '200' || log.code === 'integration_confirmed' || log.code === 'redeem_gifted_success';
    }
  }]);

  return OrderNotesController;
}();

OrderNotesController.$inject = [];

exports.default = OrderNotesController;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RefundHistoryController = function () {
    function RefundHistoryController() {
        _classCallCheck(this, RefundHistoryController);
    }

    _createClass(RefundHistoryController, [{
        key: 'isErrorCode',
        value: function isErrorCode(code) {
            switch (code) {
                case '200':
                case 'refund':
                    return false;
            }

            return true;
        }
    }, {
        key: 'hasTransactions',
        value: function hasTransactions() {
            return this.transactions && Object.keys(this.transactions).length > 0;
        }
    }, {
        key: 'formatTime',
        value: function formatTime(utcTime) {
            var utc = moment.utc(utcTime);
            return utc.tz('Europe/London').format('LLLL');
        }
    }, {
        key: 'isManual',
        value: function isManual(log) {
            return !!log.details && log.details.transaction_id === 'Manual Refund';
        }
    }]);

    return RefundHistoryController;
}();

RefundHistoryController.$inject = [];

exports.default = RefundHistoryController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StatusesController = function () {
    function StatusesController($scope, $timeout) {
        _classCallCheck(this, StatusesController);

        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    _createClass(StatusesController, [{
        key: '$onInit',
        value: function $onInit() {
            this.orderStatuses = [{
                key: 'payment',
                value: 'Payment step',
                group: 'Active'
            }, {
                key: 'review',
                value: 'Review step',
                group: 'Active'
            }, {
                key: 'pending_payment',
                value: 'Pending payment',
                group: 'Active'
            }, {
                key: 'processing',
                value: 'Awaiting confirmation',
                group: 'Active'
            }, {
                key: 'confirmed',
                value: 'Confirmed',
                group: 'Active'
            }, {
                key: 'failed',
                value: 'Failed',
                group: 'Active'
            }, {
                key: 'cancelled',
                value: 'Cancelled',
                group: 'Active'
            }, {
                key: 'on_hold',
                value: 'On hold (Deprecated)',
                group: 'Deprecated'
            }, {
                key: 'paid',
                value: 'Paid (Deprecated)',
                group: 'Deprecated'
            }, {
                key: 'refunded',
                value: 'Refunded (Deprecated)',
                group: 'Deprecated'
            }];

            this.paymentStatuses = [{
                key: '200',
                value: 'Payment successfully taken',
                group: 'Success'
            }, {
                key: 'partial_refund',
                value: 'Payment partially refunded',
                group: 'Success'
            }, {
                key: 'refunded',
                value: 'Payment fully refunded',
                group: 'Success'
            }, {
                key: 'token',
                value: 'Checkout token was created successfully',
                group: 'Success'
            },
            // {
            //     key: 'manual_payment',
            //     value: 'Manual payment',
            //     group: 'Success'
            // },
            {
                key: 'token_error',
                value: 'Checkout token not created successfully',
                group: 'Error'
            }, {
                key: '400',
                value: 'Bad request (400)',
                group: 'Error'
            }, {
                key: '402',
                value: 'Request failed (402)',
                group: 'Error'
            }, {
                key: '500',
                value: 'Payment gateway - internal error (500)',
                group: 'Error'
            }, {
                key: '502',
                value: 'Payment gateway - bad gateway (502)',
                group: 'Error'
            }, {
                key: '503',
                value: 'Payment gateway - service unavailable (503)',
                group: 'Error'
            }, {
                key: '504',
                value: 'Payment gateway - timeout (504)',
                group: 'Error'
            }];

            this.watchDisable();
        }
    }, {
        key: 'watchDisable',
        value: function watchDisable() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.disable;
            }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _this.$timeout(function () {
                        _this.$scope.$digest();
                    }, 50);
                }
            });
        }
    }, {
        key: 'groupStatus',
        value: function groupStatus(item) {
            return item.group;
        }
    }]);

    return StatusesController;
}();

StatusesController.$inject = ['$scope', '$timeout'];

exports.default = StatusesController;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminPaymentErrorsController = function () {
    function AdminPaymentErrorsController() {
        _classCallCheck(this, AdminPaymentErrorsController);
    }

    _createClass(AdminPaymentErrorsController, [{
        key: "$onInit",
        value: function $onInit() {
            this.errorDisplay = {};
            this.errorDisplay[this.error] = true;
            this.error = this.errorDisplay;
        }
    }]);

    return AdminPaymentErrorsController;
}();

AdminPaymentErrorsController.$inject = [];

exports.default = AdminPaymentErrorsController;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderEmailsController = function () {
    function OrderEmailsController(ordersApiService, messageService) {
        _classCallCheck(this, OrderEmailsController);

        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
    }

    _createClass(OrderEmailsController, [{
        key: 'emailButtonDisabled',
        value: function emailButtonDisabled() {
            return this.saving || [10, 4, 3].indexOf(this.order.order_status_id) === -1;
        }
    }, {
        key: 'sendEmail',
        value: function sendEmail() {
            var _this = this;

            var sendTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'customer';

            this.saving = true;

            var message = this.determineEmailMessage(sendTo);

            return this.ordersApiService.sendEmail(this.order.id, sendTo).then(function () {
                _this.messageService.success(message);
            }).catch(function () {
                _this.messageService.failure('There was an error sending the ' + sendTo + ' email');
            }).then(function () {
                _this.messageService.push();
                _this.saving = false;
            });
        }
    }, {
        key: 'determineEmailMessage',
        value: function determineEmailMessage(sendTo) {
            var destination = '';
            var type = '';

            switch (sendTo) {
                case 'customer':
                    type = ' customer';
                    destination = this.order.customer.email;
                    break;
                case 'admin':
                    type = 'n admin';
                    destination = 'your property';
                    break;
                case 'invoice':
                    type = ' customer invoice';
                    destination = this.order.customer.email;
                    break;
            }

            return 'A' + type + ' email has been sent to ' + destination + '.';
        }
    }]);

    return OrderEmailsController;
}();

OrderEmailsController.$inject = ['ordersApiService', 'messageService'];

exports.default = OrderEmailsController;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EmailViewController = function () {
    function EmailViewController($sce) {
        _classCallCheck(this, EmailViewController);

        this.$sce = $sce;
    }

    _createClass(EmailViewController, [{
        key: 'loadContent',
        value: function loadContent() {
            return this.$sce.trustAsHtml(this.emailContent);
        }
    }]);

    return EmailViewController;
}();

EmailViewController.$inject = ['$sce'];

exports.default = EmailViewController;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        order: '=',
        title: '@'
    },
    controller: 'orderSaveController',
    template: __webpack_require__(888)
};

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Order {{ $ctrl.order.order_reference }}</h1> <p ng-if=$ctrl.order.id>{{ $ctrl.formatTime() }}</p> <div class=c-page-head__refund ng-if=\"$ctrl.order.total > $ctrl.order.refundable_amount\"> <icon icon=refund large=true></icon> <p ng-if=\"$ctrl.order.refundable_amount > 0\">This order has been partially refunded.</p> <p ng-if=\"$ctrl.order.refundable_amount <= 0\">This order has been fully refunded.</p> </div> <div class=\"c-page-head__order-status c-order-status\"> <ol class=c-order-status__progress> <li class=c-order-status__step ng-class=\"{'c-order-status__step--active': $ctrl.orderProgress('pendingPayment')}\"> <div class=c-order-status__icon> <icon icon=tick></icon> </div> <span class=c-order-status__text>Awaiting Payment</span> </li> <li class=c-order-status__step ng-class=\"{'c-order-status__step--active': $ctrl.orderProgress('pendingConfirmation')}\"> <div class=c-order-status__icon> <icon icon=tick></icon> </div> <span class=c-order-status__text>Paid & Awaiting Confirmation</span> </li> <li class=c-order-status__step ng-class=\"{'c-order-status__step--active': $ctrl.orderProgress('confirmed')}\"> <div class=c-order-status__icon> <icon icon=tick></icon> </div> <span class=c-order-status__text>Confirmed</span> </li> </ol> <div class=c-order-status__cancelled ng-if=\"$ctrl.orderProgress('cancelled')\"> <span class=c-order-status__text>{{ $ctrl.order.order_status }}</span> </div> <div class=c-order-status__disputed ng-if=\"$ctrl.orderProgress('disputed')\"> <span class=c-order-status__text>Payment Disputed</span> </div> </div> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'summary' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'summary'\"> Summary </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'emails' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'emails'\" ng-if=\"!$ctrl.preventEditing && $ctrl.access.check('orders')\"> Email Actions </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'refund' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'refund'\" ng-if=\"$ctrl.access.check('manager')\"> Refunds </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'order' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'order'\" ng-if=\"!$ctrl.preventEditing && $ctrl.access.check('orders')\"> Edit Order </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'audit' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'audit'\" ng-if=\"$ctrl.access.check('manager')\"> Auditing </button> </div> <div class=c-tabs__content> <div class=row ng-show=\"$ctrl.activeTab === 'summary'\"> <div class=\"small-12 columns\"> <order-summary order=$ctrl.order form-tab=$ctrl.activeTab order-statuses=$ctrl.order_statuses payment-statuses=$ctrl.payment_statuses></order-summary> </div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'emails'\" ng-if=!$ctrl.preventEditing> <div class=\"small-12 columns\"> <order-emails order=$ctrl.order form-tab=$ctrl.activeTab></order-emails> </div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'refund' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <order-refund order=$ctrl.order form-tab=$ctrl.activeTab></order-refund> </div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'order'\" ng-if=!$ctrl.preventEditing> <div class=\"small-12 columns\"> <order-form order=$ctrl.order form-tab=$ctrl.activeTab order-statuses=$ctrl.order_statuses payment-statuses=$ctrl.payment_statuses></order-form> </div> </div> <div class=row ng-show=\"$ctrl.activeTab === 'audit'\"> <div class=\"small-12 columns\"> <audits class=Order id=$ctrl.order.id></audits> </div> </div> </div> </div> </main> ";

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    order: '=',
    formTab: '=',
    orderStatuses: '<',
    paymentStatuses: '<'
  },
  controller: 'orderFormController',
  template: __webpack_require__(890)
};

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=\"c-form c-order\"> <h2>Order</h2> <p class=c-description> Any changes made to the order, customer, guests or guest order items will <strong>not</strong> be saved unless the form is submitted. </p> <div class=row> <div class=\"columns medium-6\"> <label>Order status</label> <select ng-model=$ctrl.order.order_status_id ng-options=\"status.id as status.name disable when status.private for status in $ctrl.orderStatuses\" ng-disabled=$ctrl.isDisputed()> </select> </div> <div class=\"columns medium-6\"> <label>Payment status</label> <p class=c-order__text ng-bind=$ctrl.order.payment_status></p> </div> </div> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=total type=text class=c-form__input ng-model=$ctrl.order.reference> <label class=c-form__label for=total>External reference</label> </div> </div> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--money\"> <span ng-if=\"$ctrl.originalTotal === $ctrl.order.refundable_amount\"> <money-input name=order_total ng-model=$ctrl.order.total currency-code=$ctrl.order.currency_code form-field-errors ng-change=\"$ctrl.order.totalChanged = true\" disabled=$ctrl.isDisputed()></money-input> <label class=c-form__label for=total>Total</label> </span> <p class=c-order__text ng-if=\"$ctrl.originalTotal !== $ctrl.order.refundable_amount\" tooltip=\"You may not change the Order total as a refund has been made.\"> <money amount=$ctrl.order.total decorate=true currency-code=$ctrl.order.currency_code></money> </p> </div> </div> </div> <div class=row ng-if=!$ctrl.order.totalChanged> <div class=\"columns medium-12\"> <label>Customer Notes</label> <textarea ng-model=$ctrl.order.notes></textarea> </div> </div> <div class=row ng-if=$ctrl.order.totalChanged> <div class=\"columns medium-12\"> <p class=\"c-description / text-center\">Please note! Changing the Order total here <strong>will not</strong> refund the customer.</p> </div> <div class=\"columns medium-6\"> <label>Customer Notes</label> <textarea ng-model=$ctrl.order.notes></textarea> </div> <div class=\"columns medium-6\"> <label>Total Value Change Reason</label> <div class=\"c-form__field c-form__field--textarea\"> <textarea required ng-model=$ctrl.order.changeReason></textarea> </div> </div> </div> <fieldset> <h2>Guest details</h2> <div class=c-review__guests> <div class=c-review__guest ng-repeat=\"guest in $ctrl.order.basket.guest_details track by $index\"> <div class=c-review__guest__edit> <div class=\"row / c-review__guest__name\"> <div class=\"columns medium-2\"> <div class=\"c-form__field c-form__field--select\"> <select name=title class=c-form__select ng-model=guest.title form-field-errors required=\"\"> <option>Mr.</option> <option>Mrs.</option> <option>Miss</option> <option>Ms.</option> <option>Dr.</option> <option>Rev.</option> <select> <label class=c-form__label for=title>Title</label> </select></select></div> </div> <div class=\"columns medium-5\"> <div class=c-form__field> <input type=text class=c-form__input name=fname ng-model=guest.first_name required=\"\" form-field-errors/> <label class=c-form__label for=fname>First name</label> </div> </div> <div class=\"columns medium-5\"> <div class=c-form__field> <input type=text class=c-form__input name=lname ng-model=guest.last_name /> <label class=c-form__label for=fname>Last name</label> </div> </div> </div> </div> <div ng-repeat=\"item in $ctrl.findItems(guest.id)\"> <div class=c-form__subform> <div class=row> <div class=\"column medium-4\"> <span class=c-form__subform__header> {{item.name}} </span> </div> <div class=\"column medium-4\"> <div class=c-form__field> <input name=item_date type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly form-field-errors ng-model=item.date moment-picker=item.date keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off> <label class=c-form__label for=item_date>Arrival Date</label> </div> </div> <div class=\"column medium-4\"> <div class=c-form__field> <input class=c-form__input name=arrival type=text ng-model=item.time ng-change=$ctrl.updateTime(item) form-field-errors ng-pattern=/[0-9]{1,2}:{1}[0-9]{1,2}:?[0-9]{1,2}/ /> <label class=c-form__label for=arrival>Arrival Time</label> </div> </div> </div> </div> </div> </div> </div> </fieldset> <fieldset> <h2>Customer payment details</h2> <div class=c-review__guest> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.order.customer.first_name form-field-errors> <label class=c-form__label for=name>First Name</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=last_name class=\"c-input / c-form__input\" type=text ng-model=$ctrl.order.customer.last_name form-field-errors> <label class=c-form__label for=last_name>Last Name</label> </div> </div> </div> <div class=row> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=email class=\"c-input / c-form__input\" type=text ng-model=$ctrl.order.customer.email form-field-errors ng-required=$ctrl.order.customer.marketing> <label class=c-form__label for=email>Email address</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=phone class=\"c-input / c-form__input\" type=text ng-model=$ctrl.order.customer.phone form-field-errors> <label class=c-form__label for=phone>Telephone</label> </div> </div> </div> <div class=row> <div class=\"columns medium-12\"> <label>Marketing</label> <label class=c-form__checkbox> <input name=marketing id=marketing class=\"c-input / c-form__input\" type=checkbox ng-model=$ctrl.order.customer.marketing> <span>{{ $ctrl.order.customer.title+' '+$ctrl.order.customer.first_name+' '+$ctrl.order.customer.last_name }} would like to receive exclusive offers and updates via email from {{ $ctrl.order.basket.property.name }}.</span> </label> </div> </div> </div> </fieldset> <order-notes order=$ctrl.order></order-notes> <hr> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Update order <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        order: '=',
        formTab: '='
    },
    controller: 'orderRefundController',
    template: __webpack_require__(892)
};

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() on-success=$ctrl.onSuccess() on-error=$ctrl.onError() form=$ctrl.form saving=$ctrl.saving class=\"c-form c-order / c-refund\"> <h2 class=text-center>Refunds</h2> <div ng-if=!$ctrl.showRefunds() class=row> <div class=columns> <div class=\"c-empty c-empty__content\"> <icon icon=cross></icon> <p class=c-empty__text>You cannot refund this order.</p> </div> </div> </div> <div ng-if=$ctrl.showRefunds() class=row> <div class=\"columns medium-12\" ng-if=$ctrl.order.uses_manual_refund> <p class=\"text-center / c-description\">Because payment was not taken through Stripe, this form will not automatically refund the customer. You can, however, use form to keep track of any manual refunds made to the customer.</p> </div> <div class=\"columns medium-6\"> <h3 class=\"c-form__heading / text-center\">Refund Timeline</h3> <refund-history transactions=$ctrl.refundHistory></refund-history> </div> <div class=\"columns medium-6\"> <h3 class=\"c-form__heading / text-center\">Make a Refund</h3> <div ng-if=$ctrl.alreadyRefunded()> <div class=\"c-empty c-empty__content\"> <icon icon=refund></icon> <p class=c-empty__text>The full amount for this order has been refunded.</p> </div> </div> <div ng-if=$ctrl.cannotRefund()> <div class=\"c-empty c-empty__content\"> <icon icon=cross></icon> <p class=c-empty__text>This order cannot be refunded.</p> </div> </div> <div ng-if=$ctrl.canRefund()> <p class=text-center>Original Order total: <money decorate=\"{{ $ctrl.order.currency_code }}\" amount=$ctrl.order.total></money> </p> <div class=c-form__field> <div class=\"c-form__field c-form__field--money\" ng-class=\"{'c-form__field--error': $ctrl.amountError }\"> <money-input name=amount ng-model=$ctrl.refundAmount currency-code=$ctrl.order.currency_code ng-change=$ctrl.validateAmount() disabled=\"$ctrl.saving || $ctrl.disableRefundForm()\" form-field-errors required></money-input> <label class=c-form__label for=amount>Amount to Refund</label> </div> <p class=c-error ng-if=$ctrl.amountError>The value you have entered is more than the remaining order amount (<money decorate=\"{{ $ctrl.order.currency_code }}\" amount=$ctrl.order.refundable_amount></money>). Please enter the same value or lower.</p> <div ng-if=!$ctrl.disableRefundForm()> <div class=c-form__field> <label for=reason>Reason for Refund</label> <select name=reason ng-model=$ctrl.reason ng-change=$ctrl.clearReason() ng-disabled=$ctrl.saving form-field-errors required> <option value=\"\" disabled=disabled>-- Please select a reason --</option> <option>Guest illness / injury</option> <option>Guest cannot attend</option> <option>Complaint</option> <option>No remaining availability</option> <option>Unwanted add-on/extra</option> <option>Other</option> </select> </div> <div class=c-form__field ng-if=\"$ctrl.reason === 'Other'\"> <input name=custom_reason type=text ng-model=$ctrl.customReason class=c-form__input ng-disabled=$ctrl.saving required/> <label class=c-form__label for=custom_reason>Custom reason for Refund</label> </div> <div ng-if=!$ctrl.order.uses_manual_refund> <label for=manualRefund class=c-label>Manual Refund</label> <p> If this is enabled the refund will be recorded but will <strong>not</strong> be processed through the payment gateway (no money will be transferred to the customer's card). </p> <switch id=manualRefund name=manualRefund ng-model=$ctrl.manualRefund class=green></switch> </div> <div class=text-center> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Submit Refund <spinner ng-if=$ctrl.saving /> </button> </div> </div> <p class=\"c-error / text-center\" ng-if=$ctrl.disableRefundForm()> {{ $ctrl.disabledReason() }} </p> </div> </div> </div> </div> <form-buttons></form-buttons> </api-form> ";

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    order: '=',
    formTab: '=',
    orderStatuses: '<',
    paymentStatuses: '<'
  },
  controller: 'orderSummaryController',
  template: __webpack_require__(894)
};

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=\"c-form c-order\"> <h2>Order</h2> <div class=row> <div class=\"columns medium-6\"> <label>Order status</label> <select ng-model=$ctrl.order.order_status_id ng-options=\"status.id as status.name disable when status.private for status in $ctrl.orderStatuses\" ng-disabled=$ctrl.isDisputed()> </select> </div> <div class=\"columns medium-6\"> <label>Payment status</label> <p class=c-order__text ng-bind=$ctrl.order.payment_status></p> </div> </div> <div class=row> <div class=\"columns medium-6\"> <label for=promo_details>Voucher details:</label> <span ng-repeat=\"voucher in $ctrl.order.vouchers\"> {{ voucher.codetype }}: {{ voucher.code }} @ <money amount=voucher.codevalue decorate=true currency-code=$ctrl.order.currency_code></money><span ng-if=voucher.pin>. Pin: {{ voucher.pin }}</span> </span> <div ng-if=$ctrl.vouchertotal> <strong>Voucher total:</strong> <money amount=$ctrl.vouchertotal decorate=true currency-code=$ctrl.order.currency_code></money> </div> </div> <div class=\"columns medium-6\"> <label for=promo_details>Promotional code</label> <p class=c-order__text ng-bind=$ctrl.order.promo_details></p> </div> </div> <div class=row> <div class=\"columns medium-6\"> <div> <label for=total>External reference</label> <input name=total type=text ng-model=$ctrl.order.reference /> </div> </div> <div class=\"columns medium-6\"> <label for=total>Total</label> <p class=c-order__text> <s ng-if=\"$ctrl.order.original_total !== $ctrl.order.total\"> <money amount=$ctrl.order.original_total decorate=true currency-code=$ctrl.order.currency_code></money> </s> <money amount=$ctrl.order.total decorate=true currency-code=$ctrl.order.currency_code></money> </p> </div> </div> <div class=row> <div class=columns> <h2>Customer Notes</h2> <div class=c-order__customer-notes> <p ng-if=$ctrl.order.notes ng-bind-html=$ctrl.order.notes></p> <p ng-if=!$ctrl.order.notes class=u-muted-text> <em>--No notes added--</em> </p> </div> </div> </div> <fieldset> <div class=c-order__guests> <h2>Guests</h2> <div class=\"c-order__guest c-guest\" ng-repeat=\"guest in $ctrl.order.basket.guest_details track by $index\"> <div class=c-guest__header> <div class=row> <div class=\"columns small-10 / c-guest__name\"> {{ guest.title }} {{ guest.first_name }} {{ guest.last_name }} </div> <div class=\"columns small-2 / c-guest__total\"> <money amount=$ctrl.guestPrice(guest.id) decorate=true currency-code=$ctrl.order.currency_code></money> </div> </div> </div> <div class=c-guest__events> <div ng-repeat=\"item in $ctrl.guestItems(guest.id)\" class=c-guest__event> <div class=c-guest__event__header> <span class=c-guest__event__name>{{ item.name }}</span> <div class=row> <div class=\"columns medium-10\"> <span class=c-guest__event__date> {{ item.date.format('D MMMM, YYYY') }}{{ item.preferred_time ? ' @ '+item.preferred_time: ''}} </span> </div> <div class=\"columns medium-2\"> <span class=c-guest__event__price> <s ng-if=\"item.price !== item.original_price\"> <money amount=item.original_price decorate=true currency-code=$ctrl.order.currency_code></money> </s> <money amount=item.price decorate=true currency-code=$ctrl.order.currency_code></money> </span> </div> </div> </div> <div class=c-guest__event__details> <div class=c-guest__event__header ng-repeat=\"child in item.children track by $index\"> <div class=row> <div class=\"columns medium-10\"> <span class=c-guest__event__name><span ng-if=\"child.price > 0\">+</span> {{ child.name }}</span> </div> <div class=\"columns medium-2\"> <span class=c-guest__event__price ng-if=\"child.price > 0\"> + <money amount=child.price decorate=true currency-code=$ctrl.order.currency_code></money> </span> </div> </div> </div> </div> </div> </div> </div> </div> </fieldset> <fieldset class=c-order__payment> <h2>Payment details</h2> <div class=row> <div class=\"columns medium-6\"> <div class=c-order__customer> <h3>Customer</h3> <table> <tr> <td>Name:</td> <td> {{ $ctrl.order.customer.first_name + \" \" + $ctrl.order.customer.last_name }} </td> </tr> <tr> <td> Telephone: </td> <td> {{ $ctrl.order.customer.phone }} </td> </tr> <tr> <td> Email address: </td> <td> <a href=\"mailto:{{ $ctrl.order.customer.email }}\">{{ $ctrl.order.customer.email }}</a> </td> </tr> <tr> <td> Opted into email marketing: </td> <td> {{ $ctrl.boolean($ctrl.order.customer.marketing) }} </td> </tr> <tr ng-if=\"$ctrl.order.cancellation_agreement !== null\"> <td> Signed cancellation agreement: </td> <td> {{ $ctrl.boolean($ctrl.order.cancellation_agreement) }} </td> </tr> </table> </div> </div> <div class=\"columns medium-6\"> <div class=c-order__customer> <h3>Gateway</h3> <table> <tr> <td>Gateway:</td> <td> {{ $ctrl.paymentGateway[0].toUpperCase() + $ctrl.paymentGateway.substring(1) }} </td> </tr> <tr> <td>Date:</td> <td>{{ $ctrl.paymentDate() }}</td> </tr> <tr> <td>Transaction ID:</td> <td> <a target=_blank href=\"https://dashboard.stripe.com/payments/{{ $ctrl.paymentId }}\" ng-if=\"$ctrl.access.check('admin') && $ctrl.paymentGateway === 'stripe'\">{{ $ctrl.paymentId }}</a> <span ng-if=\"!$ctrl.access.check('admin') || $ctrl.paymentGateway !== 'stripe'\">{{ $ctrl.paymentId }}</span> </td> </tr> <tr ng-if=$ctrl.paysafeOrderRef()> <td>Order Reference:</td> <td>{{ $ctrl.paysafeOrderRef() }}</td> </tr> <tr ng-if=$ctrl.destinationPayment()> <td>Payment Reference:</td> <td> <a target=_blank href=\"https://dashboard.stripe.com/{{ $ctrl.stripeId() }}/payments/{{ $ctrl.destinationPayment() }}\" ng-if=\"$ctrl.access.check('admin')\">{{ $ctrl.destinationPayment() }}</a> <a target=_blank href=\"https://dashboard.stripe.com/payments/{{ $ctrl.destinationPayment() }}\" ng-if=\"!$ctrl.access.check('admin')\">{{ $ctrl.destinationPayment() }}</a> </td> </tr> <tr> <td>Card Type:</td> <td>{{ $ctrl.paymentType() }}</td> </tr> <tr> <td>Card Digits:</td> <td>{{ $ctrl.paymentDigits() }}</td> </tr> <tr> <td>Card Expiry:</td> <td>{{ $ctrl.paymentExpiry() }}</td> </tr> <tr ng-if=$ctrl.order.gateway_fee> <td>Gateway Fee:</td> <td> <money amount=$ctrl.displayGatewayFee() decorate=true currency-code=$ctrl.order.currency_code></money> </td> </tr> <tr ng-if=$ctrl.order.application_fee> <td>RevSpa Fee:</td> <td> <money amount=$ctrl.displayApplicationFee() decorate=true currency-code=$ctrl.order.currency_code></money> </td> </tr> </table> </div> </div> </div> </fieldset> <order-notes order=$ctrl.order></order-notes> <hr/> <form-buttons ng-if=\"$ctrl.access.check('orders')\"> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Update order <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        orders: '<',
        deleted: '<'
    },
    controller: 'orderListController',
    template: __webpack_require__(896)
};

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Orders</h1> <div class=\"c-page-head__actions c-page-head__actions--small\" ng-if=\"$ctrl.access.check('reporting')\"> <div ng-show=$ctrl.generating class=c-page-head__actions__overlay> <spinner large=true /> </div> <a ng-click=\"$ctrl.isFiltered && $ctrl.generateReport()\" class=c-button--action ng-class=\"{'disabled' : !$ctrl.isFiltered}\"> <icon icon=reports></icon> Generate Report </a> <a ng-href={{$ctrl.download}} target=_blank class=c-button--action ng-class=\"{'disabled' : !$ctrl.download, 'c-button--success': $ctrl.download}\" ng-disabled=\"!$ctrl.download || $ctrl.generating\"> <icon icon=reports-down></icon> Download Report </a> </div> <p class=\"c-description c-description--large\" ng-if=$ctrl.download> Report generated: {{$ctrl.filename}} </p> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.orders class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedorders class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <form class=\"row c-list__search c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'id'\" ng-change=$ctrl.filtertypeChange()> <option value=id>Order ID</option> <option value=customer.name>Customer Name</option> <option value=customer.email>Customer Email</option> <option value=order_status_id>Order Status</option> <option value=payment_status_id>Payment Status</option> <option value=created_at>Date created</option> <option value=reference>External Reference</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'id' || $ctrl.filtertype === 'customer.name' || $ctrl.filtertype === 'customer.email' || $ctrl.filtertype === 'reference'\" placeholder=\"Filter by {{ $ctrl.displayFiltertype() }}...\"/> <order-statuses link=$ctrl.filtertext ng-show=\"$ctrl.filtertype === 'order_status_id'\"></order-statuses> <payment-statuses link=$ctrl.filtertext ng-show=\"$ctrl.filtertype === 'payment_status_id'\"></payment-statuses> <div class=c-form__field ng-show=\"$ctrl.filtertype === 'created_at'\"> <input name=start_time type=text class=\"c-form__input c-form__input--date\" readonly=readonly form-field-errors ng-model=$ctrl.filtertext moment-picker=$ctrl.filtertext keyboard=true format=YYYY-MM-DD min-view=month max-view=minute set-on-select=true autocomplete=off validate=true> <label class=c-form__label for=start_time>Date</label> </div> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"!$ctrl.loading && !$ctrl.orders\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text>Please filter for deleted orders</p> </div> </div> <div ng-if=\"$ctrl.orders.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No orders have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No orders match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.orders.data.length > 0\"> <thead> <tr> <th>Order ID</th> <th>Order Status</th> <th>Items</th> <th>Total</th> <th>Customer Name</th> <th>Updated</th> <th ng-if=\"$ctrl.access.check(['orders', 'stock'])\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"order in $ctrl.orders.data\" class=\"c-list {{ order.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-list__indicators> <div class=c-order__indicators> <span class=\"c-order__status c-order__status--completed\" ng-if=\"order.order_status === 'Confirmed'\"></span> <span class=\"c-order__status c-order__status--failed\" ng-if=\"order.order_status === 'Failed' || order.order_status === 'Cancelled'\"></span> <span class=\"c-order__status c-order__status--refunded\" ng-if=\"order.payment_status === 'Partial Refund' || order.payment_status === 'Refunded' || order.payment_status === 'Failed Refund'\"></span> <span class=\"c-order__status c-order__status--disputed\" ng-if=\"order.payment_status === 'Dispute Pending' || order.payment_status === 'Dispute Lost'\"></span> <span title=\"Created at: {{ order.created_at }} UTC\">{{ order.order_reference }}</span> </div> </td> <td>{{ order.order_status }}</td> <td>{{ order.item_count }}</td> <td> <div class=c-list__order-total> <div class=c-dashboard__tooltip-trigger> <ul class=c-dashboard__tooltip> <li class=c-dashboard__tip>Paid total: <money amount=order.total decorate=true currency-code=order.currency_code></money> </li> <li class=c-dashboard__tip>Refunded value: <money amount=\"order.total - order.refundable_amount\" decorate=true currency-code=order.currency_code></money> </li> <li class=c-dashboard__tip>Original order total: <money amount=order.original_total decorate=true currency-code=order.currency_code></money> </li> </ul> <money amount=order.refundable_amount decorate=true currency-code=order.currency_code></money> </div> </div> </td> <td>{{ order.customer.first_name + ' ' + order.customer.last_name }}</td> <td><abbr title=\"{{ $ctrl.formatTime(order.updated_at) }}\">{{ $ctrl.humanTime(order.updated_at) }}</abbr></td> <td class=c-list__action ng-if=\"$ctrl.access.check(['stock', 'orders'])\"> <a ui-sref=\"app.admin.order-edit({ order: order.id })\">Edit</a> </td> <td class=\"c-list__action c-list__action--delete\" ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(order) confirm=\"Are you sure you want to delete {{ order.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> <div class=\"row row--clean\"> <div class=\"small-12 columns\"> <ul class=c-order__key> <li><span class=\"c-order__key__colour c-order__status--completed\"></span> Confirmed</li> <li><span class=\"c-order__key__colour c-order__status--failed\"></span> Failed/Cancelled</li> <li><span class=\"c-order__key__colour c-order__status--refunded\"></span> Partial/Full Refund</li> <li><span class=\"c-order__key__colour c-order__status--disputed\"></span> Dispute Pending/Lost</li> </ul> </div> </div> </main> ";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    order: '='
  },
  controller: 'orderNotesController',
  template: __webpack_require__(898)
};

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "<fieldset> <h2>Order Timeline</h2> <div class=row> <div class=\"columns medium-8\"> <div ng-repeat=\"(date, logs) in $ctrl.getTransactions()\" class=c-order__transactions> <h3 class=c-order__transactions__heading> {{ date.replace(' ', 'T') | date:\"EEEE, d MMMM, y\" }} </h3> <div ng-repeat=\"log in logs\" class=c-transaction ng-class=\"{\n                    'c-transaction--auto': !log.user.id,\n                    'c-transaction--success': $ctrl.showTick(log),\n                    'c-transaction--error': $ctrl.isErrorCode(log.code),\n                    'c-transaction--adjustment': $ctrl.isTotalAdjustment(log.code)\n                }\"> <div class=c-transaction__card> <p class=c-transaction__card__log> <icon icon=tick ng-if=$ctrl.showTick(log)></icon> <icon icon=refund ng-if=\"log.code === 'refund'\"></icon> {{ log.notes[0] }}<span ng-if=log.notes[1]> : ({{log.notes[1]}}) <admin-payment-errors error=log.notes[1]> </admin-payment-errors> </span> <span ng-if=$ctrl.isManual(log)> <br/> <small> This was a manual refund, the customer's card was not credited. </small> </span> </p> <span class=c-transaction__card__data> Order status: {{ log.order_status }} </span> <span class=c-transaction__card__data> Payment status: {{ log.payment_status }} </span> <span class=c-transaction__card__data> Date: {{ $ctrl.formatTime(log.created_at) }} </span> <span class=c-transaction__card__user ng-class=\"{'hide': log.user.id}\"> Created by: {{ log.user.id || \"RevSpa\" }} </span> </div> </div> </div> </div> <div class=\"columns medium-4\"> Add a new internal note...(you may have to refresh the page after saving) <textarea name=\"\" ng-model=$ctrl.order.note id=\"\" cols=30 rows=10></textarea> </div> </div> </fieldset> ";

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        transactions: '='
    },
    controller: 'refundHistoryController',
    template: __webpack_require__(900)
};

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=!$ctrl.hasTransactions()> <div class=\"c-empty c-empty__content\"> <icon icon=cross></icon> <p class=c-empty__text>No previous refunds have been made.</p> </div> </div> <div ng-if=$ctrl.hasTransactions() ng-repeat=\"(date, logs) in $ctrl.transactions\" class=c-order__transactions> <h3 class=c-order__transactions__heading>{{ date.replace(' ', 'T') | date:\"EEEE, d MMMM, y\" }}</h3> <div ng-repeat=\"log in logs\" class=c-transaction ng-class=\"{\n            'c-transaction--success': log.code === 'refund' && !$ctrl.isManual(log),\n            'c-transaction--error': $ctrl.isErrorCode(log.code),\n            'c-transaction--adjustment': $ctrl.isManual(log)\n        }\"> <div class=c-transaction__card> <p class=c-transaction__card__log> <icon icon=refund ng-if=\"log.code === 'refund'\"></icon> {{ log.notes[0] }}<span ng-if=log.notes[1]>: ({{log.notes[1]}})<admin-payment-errors error=log.notes[1]></admin-payment-errors></span> <span ng-if=$ctrl.isManual(log)><br><small>This was a manual refund, the customer's card was not credited.</small></span> </p> <span class=c-transaction__card__data> Order status: {{ log.order_status }} </span> <span class=c-transaction__card__data> Payment status: {{ log.payment_status }} </span> <span class=c-transaction__card__data> Date: {{ $ctrl.formatTime(log.created_at) }} </span> <span class=c-transaction__card__user ng-if=log.user> Refunded by: {{ log.user.id }} </span> </div> </div> </div> ";

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        link: '=',
        disable: '=',
        multiSelect: '<'
    },
    controller: 'statusesController',
    template: __webpack_require__(902)
};

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "<ui-select multiple=multiple close-on-select=false ng-model=$ctrl.link ng-disabled=$ctrl.disable search-enabled=false ng-if=$ctrl.multiSelect> <ui-select-match placeholder=\"Any Order status\" allow-clear=true> {{ $item.value }} </ui-select-match> <ui-select-choices repeat=\"status.key as status in $ctrl.orderStatuses | filter: status track by $index\" group-by=$ctrl.groupStatus> <div ng-bind-html=status.value></div> </ui-select-choices> </ui-select> <select ng-model=$ctrl.link ng-disabled=$ctrl.disable ng-if=!$ctrl.multiSelect> <option value=\"\">Any</option> <option ng-repeat=\"status in $ctrl.orderStatuses\" value=\"{{ status.key }}\">{{ status.value }}</option> </select> ";

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        link: '=',
        disable: '=',
        multiSelect: '<'
    },
    controller: 'statusesController',
    template: __webpack_require__(904)
};

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "<ui-select multiple=multiple close-on-select=false ng-model=$ctrl.link ng-disabled=$ctrl.disable search-enabled=false ng-if=$ctrl.multiSelect> <ui-select-match placeholder=\"Any Payment status\" allow-clear=true> {{ $item.value }} </ui-select-match> <ui-select-choices repeat=\"status.key as status in $ctrl.paymentStatuses | filter: status track by $index\" group-by=$ctrl.groupStatus> <div ng-bind-html=status.value></div> </ui-select-choices> </ui-select> <select ng-model=$ctrl.link ng-disabled=$ctrl.disable ng-if=!$ctrl.multiSelect> <option value=\"\">Any</option> <option ng-repeat=\"status in $ctrl.paymentStatuses\" value=\"{{ status.key }}\">{{ status.value }}</option> </select> ";

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        error: '<'
    },
    controller: 'adminPaymentErrorsController',
    template: __webpack_require__(906)
};

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=$ctrl.error ng-messages=$ctrl.error> <div ng-message=journey_error> There was an issue with your payment gateway integration, please contact Journey. </div> <div ng-message=charge_expired_for_capture> The customer's token expired before the order was completed. The customer should try again. </div> <div ng-message=incorrect_number>The card number is incorrect.</div> <div ng-message=postal_code_invalid>The ZIP/Postal code is incorrect.</div> <div ng-message=processing_error> An error occurred while processing the card. The customer should try again. </div> <div ng-message=reenter_transaction> An unknown issue has occured. The customer should try again. </div> <div ng-message=incorrect_cvc>The CVC number is incorrect.</div> <div ng-message=expired_card> The card has expired. The customer should use another card. </div> <div ng-message=incorrect_address>The AVS fields are incorrect.</div> <div ng-message=card_not_supported> The card does not support this type of purchase. The customer needs to contact their card issuer to make sure their card can be used to make this type of purchase. </div> <div ng-message=not_permitted> The payment is not permitted.The customer needs to contact their card issuer for more information. </div> <div ng-message=call_issuer> The card has been declined for an unknown reason. The customer needs to contact their card issuer for more information. </div> <div ng-message=insufficient_funds> The card has insufficient funds to complete the purchase. The customer needs to contact their card issuer for more information. </div> <div ng-message=resource_already_exists> This order or an order with this transaction ID has already been completed. </div> <div ng-message=charge_disputed> This charge has been disputed by the customer. </div> <div ng-message=fraudulent> The payment has been declined as Stripe suspects it is fraudulent. </div> <div ng-message=refresh_order> An unknown issue has occured. The customer should try again. </div> <div ng-message=generic_decline> The card has been declined for an unknown reason. The customer needs to contact their card issuer for more information. </div> </div> ";

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        emailContent: '<'
    },
    controller: 'emailViewController',
    template: __webpack_require__(908)
};

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "<div class=c-email> <div class=c-email__wrapper> <div ng-bind-html=$ctrl.loadContent()></div> </div> </div> ";

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        order: '<',
        formTab: '='
    },
    controller: 'orderEmailsController',
    template: __webpack_require__(910)
};

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <div class=\"c-form c-order\"> <h2>Email Actions</h2> <div class=row> <div class=\"columns large-7\"> <h3>Customer Emails</h3> <div class=row> <div class=\"columns medium-6\"> <button type=button class=\"button / c-order__button\" ng-disabled=$ctrl.emailButtonDisabled() ng-click=$ctrl.sendEmail()>Re-send confirmation email</button> </div> <div class=\"columns medium-6\"> <a ui-sref=\"app.admin.email-view({ order: $ctrl.order.id, template: 'bookingconfirm' })\" target=_blank class=\"button button--hollow / c-order__button\" ng-disabled=$ctrl.emailButtonDisabled()>View customer confirmation email</a> </div> </div> <div class=row> <div class=\"columns medium-6\"> <button type=button class=\"button / c-order__button\" ng-disabled=$ctrl.emailButtonDisabled() ng-click=\"$ctrl.sendEmail('invoice')\">Send sales invoice email</button> </div> <div class=\"columns medium-6\"> <a ui-sref=\"app.admin.email-view({ order: $ctrl.order.id, template: 'orderinvoice' })\" target=_blank class=\"button button--hollow / c-order__button\" ng-disabled=$ctrl.emailButtonDisabled()>View sales invoice email</a> </div> </div> </div> </div> <div class=row> <div class=\"columns large-7\"> <h3>Admin Emails</h3> <div class=row> <div class=\"columns medium-6\"> <button type=button class=\"button / c-order__button\" ng-disabled=$ctrl.emailButtonDisabled() ng-click=\"$ctrl.sendEmail('admin')\">Re-send confirmation email</button> </div> <div class=\"columns medium-6\"> <a ui-sref=\"app.admin.email-view({ order: $ctrl.order.id, template: 'bookingadmin' })\" target=_blank class=\"button button--hollow / c-order__button\" ng-disabled=$ctrl.emailButtonDisabled()>View admin confirmation email</a> </div> </div> </div> </div> <form-buttons> </form-buttons> </div> ";

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property) {
    return '/api/' + property + '/orders';
};
var statusEndpoint = function statusEndpoint(property) {
    return '/api/' + property + '/statuses';
};

exports.default = ['api', function (api) {
    return {
        save: function save(order) {
            var url = order.id ? endpoint(api.property()) + '/' + order.id : endpoint(api.property());

            return api.upload(url, order).then(function (response) {
                return response.data;
            });
        },
        delete: function _delete(id) {
            return api.delete(endpoint(api.property()) + '/' + id);
        },
        findAll: function findAll() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
                return response.data;
            });
        },
        findPayment: function findPayment() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            return api.get(endpoint(api.property()) + '?notCheckout=true' + (page ? '&page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '')).then(function (response) {
                return response.data;
            });
        },
        findById: function findById(id) {
            return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
                return response.data;
            });
        },
        search: function search(type, text) {
            var viewDeleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + '&viewDeleted=' + viewDeleted).then(function (response) {
                return response.data;
            });
        },
        getOrderStatuses: function getOrderStatuses() {
            return api.get(statusEndpoint(api.property()) + '/orders').then(function (response) {
                return response.data;
            });
        },
        getPaymentStatuses: function getPaymentStatuses() {
            return api.get(statusEndpoint(api.property()) + '/payments').then(function (response) {
                return response.data;
            });
        },
        sendEmail: function sendEmail(orderId, sendTo) {
            return api.post(endpoint(api.property()) + '/' + orderId + '/email', {
                emailType: sendTo,
                noAdmin: sendTo === 'customer' ? true : undefined
            });
        },
        getEmailContent: function getEmailContent(orderId, template) {
            return api.get(endpoint(api.property()) + '/' + orderId + '/email/view?template=' + template);
        },
        generateOrder: function generateOrder(basketCode) {
            return api.get(endpoint(api.property()) + '/generate/' + basketCode);
        }
    };
}];

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(propertyId, orderId) {
    return '/api/' + propertyId + '/orders/' + orderId + '/refund';
};

exports.default = ['api', function (api) {
    return {
        save: function save(order, refund) {
            return api.post(endpoint(api.property(), order.id), refund).then(function (response) {
                return response.data;
            });
        },
        getHistory: function getHistory(order) {
            return api.get(endpoint(api.property(), order.id)).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reports = __webpack_require__(914);

var _reports2 = _interopRequireDefault(_reports);

var _reportsList = __webpack_require__(915);

var _reportsList2 = _interopRequireDefault(_reportsList);

var _reportsList3 = __webpack_require__(916);

var _reportsList4 = _interopRequireDefault(_reportsList3);

var _reports3 = __webpack_require__(918);

var _reports4 = _interopRequireDefault(_reports3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportModule = angular.module('spabooker.report', ['spabooker.base']).config(_reports2.default).controller('reportListController', _reportsList2.default).component('reportList', _reportsList4.default).factory('reportsService', _reports4.default);

exports.default = reportModule.name;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin.reports', {
    url: '/reports',
    component: 'reportList',
    roles: ['manager', 'reporting']
  });
}];

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportListController = function () {
    function ReportListController(messageService, reportsService, access) {
        _classCallCheck(this, ReportListController);

        this.reports = reportsService;
        this.messageService = messageService;
        this.access = access;
    }

    _createClass(ReportListController, [{
        key: 'generateReport',
        value: function generateReport() {
            var _this = this;

            this.generating = true;

            if (this.reportFields()) {
                this.reports.generate({
                    'type': this.type,
                    'status': this.status,
                    'payment': this.payment,
                    'datefrom': this.datefrom ? this.datefrom.format('YYYY-MM-DD') : undefined,
                    'dateto': this.dateto ? this.dateto.format('YYYY-MM-DD') : undefined,
                    'date': this.date ? this.date.format('YYYY-MM') : undefined,
                    'bookedfor': this.bookedfor ? this.bookedfor.format('YYYY-MM-DD') : undefined,
                    'event': this.event,
                    'offer': this.offer,
                    'voucher': this.voucher,
                    'promo': this.promo
                }).then(function (response) {
                    _this.download = response.link;
                    _this.filename = response.name;
                    _this.generating = false;
                }).catch(function (response) {
                    _this.messageService.failure('Unfortunately that report could not be generated, please try again.');
                    _this.messageService.push();
                    _this.messageService.autoClear();
                    _this.generating = false;
                });
            } else {
                this.generating = false;
            }
        }
    }, {
        key: 'reportFields',
        value: function reportFields() {
            switch (this.type) {
                case 'order':
                case 'item':
                    if (!this.datefrom) {
                        this.messageService.failure("Please select an 'Orders created, starting from' date to report on.");
                        this.messageService.push();
                        this.messageService.autoClear();
                        return false;
                    } else {
                        return true;
                    }

                case 'guest':
                    if (!this.bookedfor) {
                        this.messageService.failure("Please select a 'Booked for' date to report on.");
                        this.messageService.push();
                        this.messageService.autoClear();
                        return false;
                    } else {
                        return true;
                    }

                case 'marketing':
                    return true;

                case 'finance':
                    if (!this.date) {
                        this.messageService.failure("Please select a date to report on.");
                        this.messageService.push();
                        this.messageService.autoClear();
                        return false;
                    } else {
                        return true;
                    }

                default:
                    this.messageService.failure('Please select a report type.');
                    this.messageService.push();
                    this.messageService.autoClear();
                    return false;
            }
        }
    }, {
        key: 'invalidType',
        value: function invalidType(field) {
            var validityRules = {
                'status': ['order', 'item', 'guest'],
                'payment': ['order', 'item', 'guest'],
                'datefrom': ['order', 'item'],
                'date': ['finance'],
                'dateto': ['order', 'item'],
                'bookedfor': ['guest'],
                'event': ['order', 'item'],
                'offer': ['item'],
                'voucher': ['order'],
                'promo': ['order']
            };
            return validityRules[field].indexOf(this.type) === -1;
        }
    }, {
        key: 'clearForm',
        value: function clearForm() {
            if (this.invalidType('status')) this.status = '';
            if (this.invalidType('payment')) this.payment = '';
            if (this.invalidType('datefrom')) this.datefrom = '';
            if (this.invalidType('dateto')) this.dateto = '';
            if (this.invalidType('date')) this.date = '';
            if (this.invalidType('bookedfor')) this.bookedfor = '';
            if (this.invalidType('event')) this.event = '';
            if (this.invalidType('offer')) this.offer = '';
            if (this.invalidType('voucher')) this.voucher = '';
            if (this.invalidType('promo')) this.promo = '';
        }
    }, {
        key: 'selectType',
        value: function selectType(type) {
            this.type = type;
            this.clearForm();
        }
    }]);

    return ReportListController;
}();

ReportListController.$inject = ['messageService', 'reportsService', 'access'];

exports.default = ReportListController;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'reportListController',
    template: __webpack_require__(917)
};

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Reports</h1> <p class=c-description>Select fields below for the required report, then generate the report (this may take some time depending on the number of items over the requested period of time). Once generated, you can download the report.</p> <p class=c-description>Unless the \"marketing\" report is selected, you may not use any details within these reports to contact individuals with promotions/marketing.</p> </header> <main class=s-main> <message closable=true></message> <div class=row> <div class=columns> <div class=row> <div class=\"columns medium-12\"> <label class=c-label>Report Type</label> <div class=button-group> <button class=\"button round\" ng-click=\"$ctrl.selectType('item')\" ng-class=\"{'button--hollow': $ctrl.type !== 'item'}\">Order Items</button> <button class=\"button round\" ng-click=\"$ctrl.selectType('order')\" ng-class=\"{'button--hollow': $ctrl.type !== 'order'}\">Order Summary</button> <button class=\"button round\" ng-click=\"$ctrl.selectType('finance')\" ng-class=\"{'button--hollow': $ctrl.type !== 'finance'}\">Finance Report</button> <button class=\"button round\" ng-click=\"$ctrl.selectType('guest')\" ng-class=\"{'button--hollow': $ctrl.type !== 'guest'}\">Guests</button> || <button class=\"button round\" ng-click=\"$ctrl.selectType('marketing')\" ng-class=\"{'button--hollow': $ctrl.type !== 'marketing'}\">Marketing</button> </div> </div> </div> <div class=row> <div class=\"columns medium-8\" ng-if=\"$ctrl.type !== 'finance'\"> <div class=row> <div class=\"columns medium-6\"> <label class=c-label>Order Status</label> <order-statuses link=$ctrl.status disable=\"$ctrl.invalidType('status')\" multi-select=true></order-statuses> </div> <div class=\"columns medium-6\"> <label class=c-label>Payment Status</label> <payment-statuses link=$ctrl.payment disable=\"$ctrl.invalidType('payment')\" multi-select=true></payment-statuses> </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=c-form__field> <label for=datefrom>Orders created, starting on</label> <input name=datefrom type=text class=c-form__input--date maxlength=10 readonly=readonly ng-disabled=\"$ctrl.invalidType('datefrom')\" ng-model=$ctrl.datefrom moment-picker=$ctrl.datefrom keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off placeholder=\"Select a start date\"> <i class=\"c-icon c-icon--clear-small\" ng-click=\"$ctrl.datefrom = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"column medium-6\"> <div class=c-form__field> <label for=dateto>Orders created, ending on</label> <input name=dateto type=text class=c-form__input--date maxlength=10 readonly=readonly ng-disabled=\"$ctrl.invalidType('dateto')\" min-date=$ctrl.datefrom ng-model=$ctrl.dateto moment-picker=$ctrl.dateto keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off placeholder=\"Select an end date\"> <i class=\"c-icon c-icon--clear-small\" ng-click=\"$ctrl.dateto = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=c-form__field> <label for=bookedfor>Booked for</label> <input name=bookedfor type=text class=c-form__input--date maxlength=10 readonly=readonly ng-disabled=\"$ctrl.invalidType('bookedfor')\" ng-model=$ctrl.bookedfor moment-picker=$ctrl.bookedfor keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off placeholder=\"Select a booked date\"> <i class=\"c-icon c-icon--clear-small\" ng-click=\"$ctrl.bookedfor = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"columns medium-6\"> <label class=c-label>Event Type</label> <select ng-model=$ctrl.event ng-disabled=\"$ctrl.invalidType('event')\"> <option value=\"\">Any</option> <option value=day>Spa Days</option> <option value=treatment>Treatments</option> </select> </div> </div> </div> <div class=\"columns medium-8\" ng-if=\"$ctrl.type === 'finance'\"> <div class=\"column medium-6\"> <div class=c-form__field> <label for=date>Transactions during</label> <input name=date type=text class=c-form__input--date maxlength=7 readonly=readonly ng-disabled=\"$ctrl.invalidType('date')\" ng-model=$ctrl.date moment-picker=$ctrl.date keyboard=true format=YYYY-MM min-view=year max-view=year validate=true set-on-select=true autocomplete=off placeholder=\"Select a month\"> <i class=\"c-icon c-icon--clear-small\" ng-click=\"$ctrl.date = undefined\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> </div> <div class=\"columns medium-4\"> <div ng-if=\"$ctrl.type === 'item'\"> <h3>Order Items Report</h3> <p>This report contains details of individual events/items that customers have bought, and includes details about offers applied to specific events.</p> <p><em>You cannot use personal details within this report for marketing purposes.</em></p> </div> <div ng-if=\"$ctrl.type === 'order'\"> <h3>Order Summary Report</h3> <p>This report contains details of orders but not specific items/events within them, and includes details of vouchers or promo codes that have been applied.</p> <p>This report also includes details of any refunds made against specific orders.</p> <p><em>You cannot use personal details within this report for marketing purposes.</em></p> </div> <div ng-if=\"$ctrl.type === 'finance'\"> <h3>Finance Report</h3> <p>This report contains details of transactions within the time period</p> </div> <div ng-if=\"$ctrl.type === 'guest'\"> <h3>Guest Arrival Report</h3> <p>This report can be used to view which guests are arriving on a given date. It includes details about the guest and which items/events they have purchased.</p> <p><em>You cannot use personal details within this report for marketing purposes.</em></p> </div> <div ng-if=\"$ctrl.type === 'marketing'\"> <h3>Customer Marketing Report</h3> <p>Contains contact details for customers who opted in at the checkout to receive special offers and other marketing messages by email.</p> <p><em>This is the only report that can be used to market to your customers.</em></p> </div> </div> </div> <div class=row> <div class=\"columns medium-12\"> <p class=\"c-description c-description--large text-center\" ng-if=$ctrl.download> Report generated: {{$ctrl.filename}} </p> </div> <div class=\"columns medium-12\"> <div class=\"c-page-head text-center\" ng-if=\"$ctrl.access.check('manager')\"> <div ng-show=$ctrl.generating class=c-page-head__actions__overlay> <spinner large=true /> </div> <a ng-click=$ctrl.generateReport() class=c-button--action ng-class=\"{'disabled' : !$ctrl.type}\" ng-disabled=!$ctrl.type> <icon icon=reports></icon> Generate this report </a> <a ng-href={{$ctrl.download}} target=_blank class=c-button--action ng-class=\"{'disabled' : !$ctrl.download, 'c-button--success': $ctrl.download}\" ng-disabled=\"!$ctrl.download || $ctrl.generating\"> <icon icon=reports-down></icon> Download this report </a> </div> </div> </div> </div> </div> </main> ";

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property) {
    return "/api/" + property + "/report";
};
var integrationEndpoint = function integrationEndpoint(property) {
    return "/api/" + property + "/integrationReport";
};

exports.default = ['api', function (api) {
    return {
        generate: function generate(query) {
            var str = [];
            for (var param in query) {
                if (query.hasOwnProperty(param) && query[param]) {
                    str.push(encodeURIComponent(param) + "=" + encodeURIComponent(query[param]));
                }
            }str = "?" + str.join("&");

            return api.get("" + endpoint(api.property()) + str).then(function (response) {
                return response.data;
            });
        },
        generateIntegration: function generateIntegration(query) {
            var str = [];
            for (var param in query) {
                if (query.hasOwnProperty(param) && query[param]) {
                    str.push(encodeURIComponent(param) + "=" + encodeURIComponent(query[param]));
                }
            }str = "?" + str.join("&");

            return api.get("" + integrationEndpoint(api.property()) + str).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(30);

var _discount = __webpack_require__(920);

var _discount2 = _interopRequireDefault(_discount);

var _discountList = __webpack_require__(922);

var _discountList2 = _interopRequireDefault(_discountList);

var _discountSave = __webpack_require__(923);

var _discountSave2 = _interopRequireDefault(_discountSave);

var _discountForm = __webpack_require__(924);

var _discountForm2 = _interopRequireDefault(_discountForm);

var _discountPeriodForm = __webpack_require__(925);

var _discountPeriodForm2 = _interopRequireDefault(_discountPeriodForm);

var _membershipDiscount = __webpack_require__(926);

var _membershipDiscount2 = _interopRequireDefault(_membershipDiscount);

var _discountList3 = __webpack_require__(927);

var _discountList4 = _interopRequireDefault(_discountList3);

var _discountSave3 = __webpack_require__(929);

var _discountSave4 = _interopRequireDefault(_discountSave3);

var _discountForm3 = __webpack_require__(931);

var _discountForm4 = _interopRequireDefault(_discountForm3);

var _discountPeriodForm3 = __webpack_require__(933);

var _discountPeriodForm4 = _interopRequireDefault(_discountPeriodForm3);

var _membershipDiscount3 = __webpack_require__(935);

var _membershipDiscount4 = _interopRequireDefault(_membershipDiscount3);

var _discount3 = __webpack_require__(937);

var _discount4 = _interopRequireDefault(_discount3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var discountModule = angular.module('spabooker.discount', ['spabooker.base', 'as.sortable']).config(_discount2.default).controller('discountListController', _discountList2.default).controller('discountSaveController', _discountSave2.default).controller('discountFormController', _discountForm2.default).controller('discountPeriodFormController', _discountPeriodForm2.default).controller('membershipDiscountController', _membershipDiscount2.default).component('discountList', _discountList4.default).component('discountSave', _discountSave4.default).component('discountForm', _discountForm4.default).component('discountPeriodForm', _discountPeriodForm4.default).component('membershipDiscount', _membershipDiscount4.default).factory('discountService', _discount4.default);

exports.default = discountModule.name;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _discount = __webpack_require__(921);

exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin.discounts', {
    url: '/discounts',
    component: 'discountList',
    resolve: {
      discounts: (0, _discount.resolveDiscounts)(1, 20)
    },
    roles: ['manager']
  }).state('app.admin.discount-add', {
    url: '/discounts/create',
    component: 'discountSave',
    resolve: {
      title: function title() {
        return 'Create a promo code';
      }
    },
    roles: ['manager']
  }).state('app.admin.discount-edit', {
    url: '/discounts/:discount/update?tab',
    component: 'discountSave',
    resolve: {
      title: function title() {
        return 'Update a promo code';
      },
      discount: (0, _discount.resolveDiscount)()
    },
    roles: ['manager']
  }).state('app.admin.membershipDiscount', {
    url: '/membership-discounts',
    component: 'membershipDiscount',
    resolve: {
      title: function title() {
        return 'Membership Discount';
      },
      details: (0, _discount.resolveMembershipDiscount)()
    },
    roles: ['manager']
  });
}];

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveMembershipDiscount = exports.resolveDiscount = exports.resolveDiscounts = undefined;

var _lodash = __webpack_require__(2);

var resolveDiscounts = exports.resolveDiscounts = function resolveDiscounts() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return ['discountService', function (discountService) {
    return discountService.findAll(page, perpage, deleted).then(function (list) {
      return list;
    });
  }];
};

var resolveDiscount = exports.resolveDiscount = function resolveDiscount() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'discount';

  return ['$stateParams', 'discountService', function ($stateParams, discountService) {
    return $stateParams[param] && $stateParams[param] > 0 ? discountService.findById($stateParams[param]) : {};
  }];
};

var resolveMembershipDiscount = exports.resolveMembershipDiscount = function resolveMembershipDiscount() {
  return ['discountService', function (discountService) {
    return discountService.findMembershipDiscount();
  }];
};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiscountsListController = function () {
  function DiscountsListController($scope, $state, discountService, messageService, access) {
    _classCallCheck(this, DiscountsListController);

    this.$scope = $scope;
    this.$state = $state;
    this.discountService = discountService;
    this.messageService = messageService;
    this.access = access;
  }

  _createClass(DiscountsListController, [{
    key: '$onInit',
    value: function $onInit() {
      this.updatePaging();
      this.$scope.$watch(function (scope) {
        return scope.current_page;
      }, function (newVal, oldVal, scope) {
        if (newVal !== oldVal) {
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
            scope.$ctrl.discounts = undefined;
            scope.$ctrl.discountService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(function (response) {
              scope.$ctrl.discounts = response;
              scope.$ctrl.loading = false;
            });
          } else {
            scope.$ctrl.discountService.findAll(newVal, scope.per_page).then(function (list) {
              return scope.$ctrl.discounts = list;
            });
          }
        }
      });
    }
  }, {
    key: 'updatePaging',
    value: function updatePaging() {
      this.$scope.per_page = this.discounts.per_page;
      this.$scope.current_page = this.discounts.current_page;
      this.$scope.total = this.discounts.total;
    }
  }, {
    key: 'onDelete',
    value: function onDelete(discount) {
      var _this = this;

      this.discountService.delete(discount.id).then(function () {
        _this.messageService.success('The discount <strong>' + discount.code + '</strong> was successfully deleted.');
        _this.messageService.push();
      }).catch(function (error) {
        _this.messageService.failure('The discount <strong>' + discount.code + '</strong> could not be successfully deleted: ' + error.statusText);
        _this.messageService.push();
      }).then(function () {
        var page = _this.discounts.current_page;
        _this.discounts = [];
        _this.loading = true;
        return _this.discountService.findAll(page).then(function (response) {
          _this.discounts = response;
          _this.loading = false;
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this2 = this;

      if (!this.loading && this.filtertext) {
        this.isFiltered = true;
        this.discounts = undefined;
        this.loading = true;
        this.discountService.search(this.filtertype, this.filtertext).then(function (response) {
          _this2.discounts = response;
          _this2.updatePaging();
          _this2.loading = false;
        });
      }
    }
  }, {
    key: 'clearfilter',
    value: function clearfilter() {
      var _this3 = this;

      if (this.isFiltered) {
        this.isFiltered = false;
        this.loading = true;
        this.discountService.findAll(1, 20).then(function (response) {
          _this3.discounts = response;
          _this3.$scope.current_page = 1;
          _this3.$scope.total = response.total;
          _this3.loading = false;
        });
      }
    }
  }, {
    key: 'filtertypeChange',
    value: function filtertypeChange() {
      switch (this.filtertype) {
        case 'status':
          this.filtertext = '1';
          break;
        default:
          this.filtertext = '';
          break;
      }
    }
  }]);

  return DiscountsListController;
}();

DiscountsListController.$inject = ['$scope', '$state', 'discountService', 'messageService', 'access'];

exports.default = DiscountsListController;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiscountSaveController = function () {
    function DiscountSaveController($rootScope, $state, $stateParams, eventsService, access) {
        _classCallCheck(this, DiscountSaveController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.eventsService = eventsService;
        this.access = access;
    }

    _createClass(DiscountSaveController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.activeTab = this.$stateParams.tab || 'discount';
            if (!this.days || !this.treatments) {
                this.days = [];
                this.treatments = [];

                this.eventpromise = this.eventsService.collectGrouped().then(function (response) {
                    _this.days = _this.days.concat(response.SpaDay);
                    _this.treatments = _this.treatments.concat(response.Treatment);
                    return response;
                });
            }
        }
    }]);

    return DiscountSaveController;
}();

DiscountSaveController.$inject = ['$rootScope', '$state', '$stateParams', 'eventsService', 'access'];

exports.default = DiscountSaveController;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiscountFormController = function () {
  function DiscountFormController($rootScope, $scope, $state, discountService, messageService) {
    _classCallCheck(this, DiscountFormController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.discountService = discountService;
    this.messageService = messageService;
  }

  _createClass(DiscountFormController, [{
    key: '$onInit',
    value: function $onInit() {
      this.discount = this.discount || {};
      this.discount.days = this.discount.days || [];
      this.discount.property_id = this.$rootScope.currentProperty.id;
      this.discount.pricing_value = this.discount.pricing_type === '%' ? parseInt(this.discount.pricing_value) : this.discount.pricing_value || 0;
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this = this;

      delete this.discount.grouped_events;
      delete this.discount.grouped_exclusions;
      delete this.discount.grouped_inclusions;

      return this.discountService.save(this.discount).then(function (response) {
        if (_this.discount.id) {
          _this.messageService.success('The discount <strong>' + _this.discount.code + '</strong> was successfully updated!', ['app.admin.discount-edit({ \'discount\' : ' + _this.discount.id + '})', 'Discount']);
          _this.$state.go('app.admin.discounts');
        } else {
          _this.messageService.success('The discount <strong>' + response.code + '</strong> was successfully created.');
          _this.$state.go('app.admin.discount-edit', { discount: response.id, tab: 'period' });
        }
      }).catch(function (error) {
        error.data = error.data.original || error.data;
        _this.form.$api.setErrors(error.data);

        var sourceElement = Object.keys(error.data);
        var verb = 'created';
        if (_this.discount.id) {
          verb = 'updated';
        }
        if (sourceElement.length > 0) {
          var errors = '';
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var element = _step.value;

              errors += '<li>' + _this.messageService.formatError(element, error.data[element]) + '</li>';
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.messageService.failure('The discount <strong>' + _this.discount.code + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
        } else {
          _this.messageService.failure('The discount <strong>' + _this.discount.code + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
        }
        _this.messageService.push();
      });
    }
  }, {
    key: 'addDay',
    value: function addDay(day) {
      if (!(0, _lodash.find)(this.discount.days, { 'day': day.toString() })) {
        this.discount.days.push({ 'day': day.toString() });
      } else {
        (0, _lodash.pullAllBy)(this.discount.days, [{ 'day': day.toString() }], 'day');
      }
    }
  }, {
    key: 'activeDay',
    value: function activeDay(day) {
      if ((0, _lodash.find)(this.discount.days, { 'day': day.toString() })) {
        return 'day-active';
      }
    }
  }]);

  return DiscountFormController;
}();

DiscountFormController.$inject = ['$rootScope', '$scope', '$state', 'discountService', 'messageService'];

exports.default = DiscountFormController;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiscountPeriodFormController = function () {
  function DiscountPeriodFormController($rootScope, $scope, $state, discountService, messageService) {
    _classCallCheck(this, DiscountPeriodFormController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.discountService = discountService;
    this.messageService = messageService;
  }

  _createClass(DiscountPeriodFormController, [{
    key: '$onInit',
    value: function $onInit() {
      if (this.discount.periods.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.discount.periods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var period = _step.value;

            period.start = period.start ? moment(period.start, 'YYYY-MM-DD') : '';
            period.end = period.end ? moment(period.end, 'YYYY-MM-DD') : '';
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        this.discount.periods = [{ start: '' }];
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this = this;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.discount.periods[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var period = _step2.value;

          if (period.start) {
            period.start = period.start.format('YYYY-MM-DD');
          }
          if (period.end && typeof period.end !== 'boolean') {
            period.end = period.end.format('YYYY-MM-DD');
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.discountService.savePeriods(this.discount.periods, this.discount.id).then(function (response) {
        if (!_this.discount.events) {
          _this.messageService.success('The discount <strong>' + _this.discount.code + '</strong> was successfully updated!');
          _this.$state.go('app.admin.discount-edit', { discount: _this.discount.id, tab: 'events' });
        } else {
          _this.messageService.success('The discount <strong>' + response.code + '</strong> was successfully updated.', ['app.admin.discount-edit({ \'discount\' : ' + _this.discount.id + '})', 'Discount']);
          _this.$state.go('app.admin.discounts');
        }
      }).catch(function (error) {
        _this.messageService.failure('The discount <strong>' + _this.discount.code + '</strong> could not be successfully created: ' + error.statusText);
        _this.messageService.push();
        var sourceElement = Object.keys(error.data)[0];
        if (sourceElement > 0) {
          _this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
        } else {
          _this.$scope.$ctrl.form.$setValidity(sourceElement, false);
        }
      });
    }
  }, {
    key: 'clearDate',
    value: function clearDate(model) {
      model = undefined;
    }
  }]);

  return DiscountPeriodFormController;
}();

DiscountPeriodFormController.$inject = ['$rootScope', '$scope', '$state', 'discountService', 'messageService'];

exports.default = DiscountPeriodFormController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MembershipDiscountFormController = function () {
  function MembershipDiscountFormController(discountService, messageService, access) {
    _classCallCheck(this, MembershipDiscountFormController);

    this.discountService = discountService;
    this.messageService = messageService;
    this.access = access;
  }

  _createClass(MembershipDiscountFormController, [{
    key: 'onSave',
    value: function onSave() {
      var _this = this;

      return this.discountService.saveMembershipDiscount(this.details).then(function (response) {
        _this.messageService.success('The membership discount has been successfully updated!');
        _this.messageService.push();
        _this.messageService.autoClear();
      }).catch(function (error) {
        _this.messageService.failure('The membership discount has not been successfully updated!');
        _this.messageService.push();
        _this.messageService.autoClear();
      });
    }
  }]);

  return MembershipDiscountFormController;
}();

MembershipDiscountFormController.$inject = ['discountService', 'messageService', 'access'];

exports.default = MembershipDiscountFormController;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    discounts: '<'
  },
  controller: 'discountListController',
  template: __webpack_require__(928)
};

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Promo Codes</h1> <div class=c-page-head__actions ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=app.admin.discount-add class=c-button--action> <icon icon=discount></icon> Create a Promo Code </a> </div> </header> <main class=s-main> <form class=\"row c-list__search c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=name>Name</option> <option value=status>Status</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.discounts.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No promo codes have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No promo codes match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <div ng-if=\"$ctrl.discounts.data.length > 0\" id=list data-as-sortable=$ctrl.dragControlListeners data-ng-model=$ctrl.discounts.data class=\"c-table / c-discounts-list__container\"> <div class=c-table__head> <div class=\"c-table__cell c-table__lights-cell\"></div> <div class=c-table__cell>Code</div> <div class=\"c-table__cell c-table__cell__edit\" ng-if=\"$ctrl.access.check('manager')\"></div> <div class=\"c-table__cell c-table__cell__delete\" ng-if=\"$ctrl.access.check('manager')\"></div> </div> <div class=c-table__body> <div data-ng-repeat=\"discount in $ctrl.discounts.data\" class=\"c-table__row / c-list c-discounts-list__drag {{ discount.deleted_at ? 'c-list__deleted' : ''}}\" data-as-sortable-item> <div class=\"c-table__cell c-table__lights-cell\"><span ng-class=\"(discount.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (discount.status)? 'This discount is active' : 'This discount is not active' }}\"></span></div> <div class=c-table__cell>{{ discount.code }}</div> <div class=\"c-table__cell / c-list__action c-table__cell__edit\" ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.discount-edit({ discount: discount.id })\">Edit</a> </div> <div class=\"c-table__cell / c-list__action c-table__cell__delete\" ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(discount) confirm=\"Are you sure you want to delete {{ discount.name }}?\">Delete</a> </div> </div> </div> </div> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </main> ";

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    discount: '=',
    title: '@',
    formTab: '='
  },
  controller: 'discountSaveController',
  template: __webpack_require__(930)
};

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=\"$ctrl.period.id && $ctrl.activeTab != 'period'\">{{ $ctrl.period.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__handles> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'discount' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'discount'\" ng-if=\"$ctrl.access.check('manager')\"> Promo Code </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'period' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'period'\" ng-if=\"$ctrl.discount.id && $ctrl.access.check('manager')\"> Period </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'events' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'events'\" ng-if=\"$ctrl.discount.id && $ctrl.access.check('manager')\"> Effected Events </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'included' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'included'\" ng-if=\"$ctrl.discount.id && $ctrl.access.check('manager')\"> Basket Included </button> <button class=c-tabs__handle ng-class=\"$ctrl.activeTab === 'excluded' ? ' active' : ''\" ng-click=\"$ctrl.activeTab = 'excluded'\" ng-if=\"$ctrl.discount.id && $ctrl.access.check('manager')\"> Basket Excluded </button> </div> <div class=c-tabs__content> <div class=row ng-if=\"$ctrl.activeTab === 'discount' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <discount-form discount=$ctrl.discount form-tab=$ctrl.activeTab></discount-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'period' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <discount-period-form discount=$ctrl.discount></discount-period-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'events' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.discount existing-events=$ctrl.discount.grouped_events form-type=effect names=\"{'single': 'discount', 'plural': 'discounts'}\" form-tab=$ctrl.activeTab all=true description=\"These events will receive the discount applied by this code at the checkout.\" events=$ctrl.eventpromise></event-multi-select-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'included' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.discount existing-events=$ctrl.discount.grouped_inclusions form-type=include names=\"{'single': 'discount', 'plural': 'discounts'}\" form-tab=$ctrl.activeTab description=\"This discount will only be valid when any of the following events are present in the basket.\" events=$ctrl.eventpromise all=true></event-multi-select-form> </div> </div> <div class=row ng-if=\"$ctrl.activeTab === 'excluded' && $ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <event-multi-select-form item=$ctrl.discount existing-events=$ctrl.discount.grouped_exclusions form-type=exclude names=\"{'single': 'discount', 'plural': 'discounts'}\" form-tab=$ctrl.activeTab description=\"The presence of any of the following events in the basket will void this discount.\" events=$ctrl.eventpromise all=true></event-multi-select-form> </div> </div> </div> </div> </main> ";

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    discount: '='
  },
  controller: 'discountFormController',
  template: __webpack_require__(932)
};

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=row> <div class=\"columns medium-8\"> <div class=c-form__field> <input name=code class=\"c-input--large / c-form__input\" type=text ng-pattern=/^[a-zA-Z0-9-]+$/ ng-model=$ctrl.discount.code form-field-errors required> <i class=\"c-icon c-icon--help\" tooltip=\"This field can only contain a minus symbol (-), numbers (0-9) and letters\" tooltip-placement=left>?</i> <label class=\"c-form__label c-form__label--large\" for=code>Code</label> </div> </div> <div class=\"columns medium-4\"> <label>Booking Days for Event dates:</label> <ul class=c-form__horizontal-list> <li ng-class=$ctrl.activeDay(0) class=c-form__horizontal-list__button ng-click=$ctrl.addDay(0) tooltip=Monday> M </li> <li ng-class=$ctrl.activeDay(1) class=c-form__horizontal-list__button ng-click=$ctrl.addDay(1) tooltip=Tuesday> T </li> <li ng-class=$ctrl.activeDay(2) class=c-form__horizontal-list__button ng-click=$ctrl.addDay(2) tooltip=Wednesday> W </li> <li ng-class=$ctrl.activeDay(3) class=c-form__horizontal-list__button ng-click=$ctrl.addDay(3) tooltip=Thursday> T </li> <li ng-class=$ctrl.activeDay(4) class=c-form__horizontal-list__button ng-click=$ctrl.addDay(4) tooltip=Friday> F </li> <li ng-class=$ctrl.activeDay(5) class=c-form__horizontal-list__button ng-click=$ctrl.addDay(5) tooltip=Saturday> S </li> <li ng-class=$ctrl.activeDay(6) class=c-form__horizontal-list__button ng-click=$ctrl.addDay(6) tooltip=Sunday> S </li> </ul> <p class=c-description>No selections means active week round.</p> </div> </div> <h2>Pricing Rules</h2> <p class=c-description>Pricing values entered below will be applied to each effected event individually. e.g. <strong>-10%</strong> added here on 2 Effected Treatments, would reduce both of their prices by 10%, not 10% off the basket total.</p> <div class=row> <div class=\"columns medium-6\"> <label class=c-period__heading>Pricing Type</label> <div class=c-form__field> <select ng-model=$ctrl.discount.pricing_type ng-change=$ctrl.nullGlobal(rule) required> <option value=\"\" disabled=disabled>N/A</option> <option value=\"=\">New Price</option> <option value=#>+/- Value</option> <option value=%>+/- Percent</option> </select> </div> </div> <div class=\"columns medium-6\"> <label class=c-period__heading>Pricing Value</label> <div class=\"c-form__field c-form__field--money\" ng-if=\"$ctrl.discount.pricing_type === '#' || $ctrl.discount.pricing_type === '=' || !$ctrl.discount.pricing_type\"> <money-input name=pricing_value ng-disabled=!$ctrl.discount.pricing_type ng-model=$ctrl.discount.pricing_value form-field-errors></money-input> <label class=c-form__label for=price><span ng-if=\"$ctrl.discount.pricing_type === '#'\">+/- </span>Value</label> </div> <div class=\"c-form__field c-form__field--money c-form__field--percentage\" ng-if=\"$ctrl.discount.pricing_type === '%'\"> <money-input name=pricing_value ng-disabled=!$ctrl.discount.pricing_type decorate=percentage ng-model=$ctrl.discount.pricing_value form-field-errors></money-input> <label class=c-form__label for=price>+/- Percent</label> </div> </div> </div> <h2>Basket Conditions</h2> <div class=row> <div class=\"columns medium-6\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=minimum_spend ng-model=$ctrl.discount.minimum_spend form-field-errors></money-input> <label class=c-form__label for=price>Minimum Spend</label> </div> </div> <div class=\"columns medium-6\"> <div class=c-form__field> <input name=price type=number class=c-form__input ng-model=$ctrl.discount.quantity form-field-errors ng-pattern=/^[0-9]+$/ autocomplete=off> <label class=c-form__label for=price>Additional Events in Basket</label> <i class=\"c-icon c-icon--help\" tooltip=\"This field can only contain numbers (0-9)\" tooltip-placement=left>?</i> </div> </div> </div> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this promo code will be active and accessible on the website.</p> <switch id=status name=status ng-model=$ctrl.discount.status class=green></switch> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Promo Code <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        discount: '<',
        formTab: '='
    },
    controller: 'discountPeriodFormController',
    template: __webpack_require__(934)
};

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <h2>Time Periods</h2> <div class=\"c-period__pricing / c-discount__period\" ng-repeat=\"(key, period) in $ctrl.discount.periods track by $index\"> <div class=row> <div class=\"column medium-4\"> <select ng-model=period.type required> <option disabled=disabled value=\"\">Select a period type</option> <option value=0>Booking Date</option> <option value=1>Purchase Date</option> </select> </div> <div class=\"column medium-4\"> <div class=c-form__field> <input name=start_time type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly form-field-errors required ng-model=period.start moment-picker=period.start keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off> <label class=c-form__label for=start_time>Start Date</label> <i class=\"c-icon c-icon--clear-small\" ng-click=\"period.start = undefined; $ctrl.autoName()\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> <div class=\"column medium-4\"> <div class=c-form__field> <input name=end_time type=text class=\"c-form__input c-form__input--date\" maxlength=10 readonly=readonly form-field-errors required ng-model=period.end moment-picker=period.end keyboard=true format=YYYY-MM-DD min-view=month max-view=day validate=true set-on-select=true autocomplete=off min-date=period.start> <label class=c-form__label for=end_time>End Date</label> <i class=\"c-icon c-icon--clear-small\" ng-click=\"period.end = undefined; $ctrl.autoName()\" tooltip=\"Clear this field\" tooltip-placement=left>&times;</i> </div> </div> </div> <a class=c-period__pricing__remove ng-if=\"$ctrl.discount.periods.length > 1\" ng-click=\"$ctrl.discount.periods.splice(key, 1)\">&times;</a> </div> <a class=c-period__add ng-click=$ctrl.discount.periods.push({})> <span>+</span> Add new time period </a> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Discount Time Period <spinner ng-if=$ctrl.saving /> </button> </form-buttons>  </api-form>";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    details: '<'
  },
  controller: 'membershipDiscountController',
  template: __webpack_require__(936)
};

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Membership Discount</h1> </header> <main class=s-main> <message closable=true></message> <div class=row> <div class=\"small-12 columns\"> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=row> <div class=\"small-12 columns\"> <section ng-if=\"$ctrl.access.check('manager')\"> <div class=row> <div class=\"columns medium-6 text-right\"> <p class=c-description>Enable/Disable Membership Discounts</p> </div> <div class=\"columns medium-6 text-left\"> <switch id=active name=active ng-model=$ctrl.details.status class=green /> </div> </div> <section ng-if=$ctrl.details.status> <p class=c-description>Determines which items the Membership Discount is valid on.</p> <div class=row> <div class=\"columns medium-3\"> <label for=treatments class=c-label>Treatments</label> <switch id=treatments name=treatments ng-model=$ctrl.details.treatments class=green /> </div> <div class=\"columns medium-3\"> <label for=spa_days class=c-label>Spa Days</label> <switch id=spa_days name=spa_days ng-model=$ctrl.details.spa_days class=green /> </div> <div class=\"columns medium-3\"> <label for=classes class=c-label>Classes</label> <switch id=classes name=classes ng-model=$ctrl.details.classes class=green /> </div> <div class=\"columns medium-3\"> <label for=extras class=c-label>Extras</label> <switch id=extras name=extras ng-model=$ctrl.details.extras class=green /> </div> </div> </section> <section ng-if=$ctrl.details.status> <p class=c-description>Determines the Membership Discount amount on specific days.</p> <div class=row> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=mon_discount ng-model=$ctrl.details.mon_discount decorate=percentage form-field-errors></money-input> <label for=mon_discount class=c-form__label>Monday</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=tue_discount ng-model=$ctrl.details.tue_discount decorate=percentage form-field-errors></money-input> <label for=tue_discount class=c-form__label>Tuesday</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=wed_discount ng-model=$ctrl.details.wed_discount decorate=percentage form-field-errors></money-input> <label for=wed_discount class=c-form__label>Wednesday</label> </div> </div> <div class=\"columns medium-3\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=thu_discount ng-model=$ctrl.details.thu_discount decorate=percentage form-field-errors></money-input> <label for=thu_discount class=c-form__label>Thursday</label> </div> </div> <div class=\"columns medium-4\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=fri_discount ng-model=$ctrl.details.fri_discount decorate=percentage form-field-errors></money-input> <label for=fri_discount class=c-form__label>Friday</label> </div> </div> <div class=\"columns medium-4\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=sat_discount ng-model=$ctrl.details.sat_discount decorate=percentage form-field-errors></money-input> <label for=sat_discount class=c-form__label>Saturday</label> </div> </div> <div class=\"columns medium-4\"> <div class=\"c-form__field c-form__field--money c-form__field--percentage\"> <money-input name=sun_discount ng-model=$ctrl.details.sun_discount decorate=percentage form-field-errors></money-input> <label for=sun_discount class=c-form__label>Sunday</label> </div> </div> </div> </section> <section> </section> </section> </div> </div> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Membership Discount <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> </div> </div> </main> ";

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = function endpoint(property) {
  return '/api/' + property + '/discount';
};
var membershipEndpoint = function membershipEndpoint(property) {
  return '/api/' + property + '/membership-discount';
};
var periodsendpoint = function periodsendpoint(property, id) {
  return '/api/' + property + '/discount/' + id + '/periods';
};

exports.default = ['api', '$rootScope', function (api, $rootScope) {
  return {
    save: function save(discount) {
      var url = discount.id ? endpoint(api.property()) + '/' + discount.id : endpoint(api.property());

      return api.upload(url, discount).then(function (response) {
        return response.data;
      });
    },
    savePeriods: function savePeriods(data, id) {
      return api.post(periodsendpoint(api.property(), id), data).then(function (response) {
        return response.data;
      });
    },
    delete: function _delete(id) {
      return api.delete(endpoint(api.property()) + '/' + id);
    },
    findAll: function findAll() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
        return response.data;
      });
    },
    findById: function findById(id) {
      return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
        return response.data;
      });
    },
    findMembershipDiscount: function findMembershipDiscount() {
      return api.get('' + membershipEndpoint(api.property())).then(function (response) {
        return response.data;
      });
    },
    saveMembershipDiscount: function saveMembershipDiscount(details) {
      return api.post('' + membershipEndpoint(api.property()), details).then(function (response) {
        return response.data;
      });
    },
    toggleActive: function toggleActive(id) {
      return api.get(endpoint(api.property()) + '/status/' + id).then(function (response) {
        return response.data;
      });
    },
    search: function search(type, text) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _basket = __webpack_require__(939);

var _basket2 = _interopRequireDefault(_basket);

var _availabilitySlider = __webpack_require__(940);

var _availabilitySlider2 = _interopRequireDefault(_availabilitySlider);

var _guestsAdd = __webpack_require__(942);

var _guestsAdd2 = _interopRequireDefault(_guestsAdd);

var _selectOptions = __webpack_require__(944);

var _selectOptions2 = _interopRequireDefault(_selectOptions);

var _selectExtras = __webpack_require__(946);

var _selectExtras2 = _interopRequireDefault(_selectExtras);

var _selectEvent = __webpack_require__(948);

var _selectEvent2 = _interopRequireDefault(_selectEvent);

var _basketAdd = __webpack_require__(950);

var _basketAdd2 = _interopRequireDefault(_basketAdd);

var _basketItems = __webpack_require__(952);

var _basketItems2 = _interopRequireDefault(_basketItems);

var _basketCreate = __webpack_require__(954);

var _basketCreate2 = _interopRequireDefault(_basketCreate);

var _basketCreateTabs = __webpack_require__(956);

var _basketCreateTabs2 = _interopRequireDefault(_basketCreateTabs);

var _availabilitySlider3 = __webpack_require__(958);

var _availabilitySlider4 = _interopRequireDefault(_availabilitySlider3);

var _guestsAdd3 = __webpack_require__(959);

var _guestsAdd4 = _interopRequireDefault(_guestsAdd3);

var _selectOptions3 = __webpack_require__(960);

var _selectOptions4 = _interopRequireDefault(_selectOptions3);

var _selectExtras3 = __webpack_require__(961);

var _selectExtras4 = _interopRequireDefault(_selectExtras3);

var _selectEvent3 = __webpack_require__(962);

var _selectEvent4 = _interopRequireDefault(_selectEvent3);

var _basketAdd3 = __webpack_require__(963);

var _basketAdd4 = _interopRequireDefault(_basketAdd3);

var _basketItems3 = __webpack_require__(964);

var _basketItems4 = _interopRequireDefault(_basketItems3);

var _basketCreate3 = __webpack_require__(965);

var _basketCreate4 = _interopRequireDefault(_basketCreate3);

var _basket3 = __webpack_require__(966);

var _basket4 = _interopRequireDefault(_basket3);

var _basketApi = __webpack_require__(967);

var _basketApi2 = _interopRequireDefault(_basketApi);

var _availabilityApi = __webpack_require__(968);

var _availabilityApi2 = _interopRequireDefault(_availabilityApi);

var _quantityApi = __webpack_require__(969);

var _quantityApi2 = _interopRequireDefault(_quantityApi);

var _startTimeApi = __webpack_require__(970);

var _startTimeApi2 = _interopRequireDefault(_startTimeApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basketModule = angular.module('spabooker.basket', ['spabooker.base', 'spabooker.shared.base', 'angular-flatpickr']).config(_basket2.default).component('availabilitySlider', _availabilitySlider2.default).component('addGuests', _guestsAdd2.default).component('selectOptions', _selectOptions2.default).component('selectExtras', _selectExtras2.default).component('selectEvent', _selectEvent2.default).component('addToBasket', _basketAdd2.default).component('basketItems', _basketItems2.default).component('basketCreate', _basketCreate2.default).component('basketCreateTabs', _basketCreateTabs2.default).controller('availabilitySliderController', _availabilitySlider4.default).controller('addGuestsController', _guestsAdd4.default).controller('selectOptionsController', _selectOptions4.default).controller('selectExtrasController', _selectExtras4.default).controller('selectEventController', _selectEvent4.default).controller('addToBasketController', _basketAdd4.default).controller('basketItemsController', _basketItems4.default).controller('basketCreateController', _basketCreate4.default).factory('basket', _basket4.default).factory('basketApiService', _basketApi2.default).factory('availabilityApiService', _availabilityApi2.default).factory('quantityApiService', _quantityApi2.default).factory('startTimeApiService', _startTimeApi2.default);

exports.default = basketModule.name;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.basket-create', {
        url: '/baskets/create',
        component: 'basketCreate',
        resolve: {
            title: function title() {
                return 'Create a Basket';
            }
        },
        roles: ['manager']
    });
}];

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'availability': '=',
        'loading': '<',
        'basket': '<',
        'eventType': '<',
        'getQuantity': '&',
        'staff': '='
    },
    controller: 'availabilitySliderController',
    template: __webpack_require__(941)
};

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "<div class=c-avail-slider> <div class=c-avail-slider__header> <div class=row> <div class=\"columns small-8\"> <span class=\"c-avail-slider__header__text c-avail-slider__header__monthyear\" ng-bind-html=$ctrl.monthYear()></span> <div class=\"c-avail-slider__header__text c-guest__info\">Unavailable dates are displayed in dark grey</div> </div> <div class=\"columns small-4 text-right\"> <div class=c-avail-slider__datepicker> <ng-flatpickr ng-model=$ctrl.item.date fp-opts=$ctrl.flatpickrOptions fp-on-setup=\"$ctrl.setFlatpickrInstance({ fpItem: fpItem })\"> <icon icon=datepicker></icon> <span class=c-avail-slider__tooltip ng-class=\"{'isVisible': $ctrl.isSearching}\">Select a date</span> </ng-flatpickr> </div> </div> </div> </div> <div class=\"c-avail-slider__slider c-date-slider\" ng-class=\"{'c-date-slider--previous': $ctrl.travelPrevious, 'c-date-slider--next': $ctrl.travelNext}\"> <div class=c-date-slider__row> <div class=\"c-date-slider__cell shrink\"> <button type=button class=\"c-date-slider__travel c-date-slider__travel--back button button--shrink\" ng-disabled=\"!$ctrl.isNextDateValid('previous')\" ng-click=$ctrl.previousAvailability()> <icon icon=chevron-left></icon> <span class=show-for-sr>Previous week</span> </button> </div> <div class=\"c-date-slider__cell auto / c-date-slider__days__error\" ng-if=$ctrl.error> <p> An error has occurred trying to retrieve availability. </p> <button type=button class=\"button button--large\" ng-disabled=$ctrl.loading ng-click=$ctrl.goToToday()> Return to Today </button> </div> <div class=\"c-date-slider__cell auto / c-date-slider__days\" ng-if=!$ctrl.error> <div class=c-date-slider__days__internal> <div class=c-date-slider__day-container ng-repeat=\"day in $ctrl.setupDays()\"> <button type=button class=c-date-slider__day ng-class=\"{'c-date-slider__day--selected': $ctrl.isDateSelected(day)}\" ng-click=$ctrl.selectDay(day) ng-disabled=!day.available> <div class=c-date-slider__day__name>{{ day.name }}</div> <div class=c-date-slider__day__number>{{ day.number }}</div> <div class=c-date-slider__day__price-old> <s> <money ng-if=$ctrl.displayOriginalPrice(day) amount=\"day.original_price * $ctrl.item.minimum_guests\" decorate=true> </money></s> </div> <div class=c-date-slider__day__price> <span ng-if=day.available> <money amount=\"day.price * $ctrl.item.minimum_guests\" decorate=true> </money></span> <span ng-if=!day.available>-</span> </div> <span class=c-date-slider__day__loading ng-if=$ctrl.loading> <div class=c-date-slider__day__loading__spinner> <spinner></spinner> </div> </span> </button> </div> <div class=c-date-slider__day-container ng-repeat=\"i in [1,2,3,4,5,6,7]\" ng-if=$ctrl.loading> <button type=button class=c-date-slider__day disabled=disabled> <div class=c-date-slider__day__name>DAY</div> <div class=c-date-slider__day__number>00</div> <div class=c-date-slider__day__price>£00.00</div> <span class=c-date-slider__day__loading> <div class=c-date-slider__day__loading__spinner> <spinner></spinner> </div> </span> </button> </div> </div> </div> <div class=\"c-date-slider__cell shrink\"> <button type=button class=\"c-date-slider__travel c-date-slider__travel--forward button button--shrink\" ng-click=$ctrl.nextAvailability() ng-disabled=\"!$ctrl.isNextDateValid('next')\"> <icon icon=chevron-right></icon> <span class=show-for-sr>Next week</span> </button> </div> </div> </div> </div> ";

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guests: '=',
        staff: '<',
        loading: '=',
        customisations: '<'
    },
    controller: 'addGuestsController',
    template: __webpack_require__(943)
};

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "<div class=c-add-guests> <p ng-if=$ctrl.notEnoughGuests() ng-bind-html=$ctrl.error></p> <div ng-if=!$ctrl.error> <p>{{ $ctrl.displayMinMaxGuests() }}</p> <div class=c-guest ng-repeat=\"guest in $ctrl.guests track by $index\" ng-class=\"{'is-closed': guest.closed, 'can-remove': $ctrl.showRemoveButton()}\"> <div class=section-anchor id=\"guest-{{ $index }}\"></div> <label class=c-guest__label ng-click=\"guest.closed = !guest.closed\"> <icon icon=chevron-down ng-if=!guest.closed></icon> <icon icon=chevron-right ng-if=guest.closed></icon> {{ $ctrl.addGuestService.guestNameOrPlaceholder(guest) }} <span class=c-guest__label__total> <money amount=$ctrl.sumGuest(guest) decorate=true></money> </span> </label> <div class=c-guest__details> <div class=row> <div class=\"columns large-4\" ng-if=$ctrl.addGuestService.showTitle(guest)> <div class=\"c-form__field c-form__field--select\"> <select class=\"c-form__select / c-guest__select\" name=title autocomplete=title ng-model=guest.title ng-options=\"title for title in $ctrl.titles\" form-field-errors required ng-change=$ctrl.addGuestService.guessGender(guest) ng-disabled=guest.imported> <option value=\"\" disabled=disabled>Select...</option> </select> <label class=\"c-form__label t-text--secondary\" for=title>Title</label> </div> </div> <div class=\"columns small-6 large-4\"> <div class=c-form__field> <input name=first_name class=\"c-form__input / c-guest__input c-guest__firstname\" type=text autocomplete=fname ng-model=guest.first_name form-field-errors required ng-disabled=guest.imported> <label class=\"c-form__label t-text--secondary\" for=first_name>First Name</label> </div> </div> <div class=\"columns small-6 large-4\"> <div class=c-form__field> <input name=last_name class=\"c-form__input / c-guest__input c-guest__lastname\" type=text autocomplete=lname ng-model=guest.last_name form-field-errors required ng-disabled=guest.imported> <label class=\"c-form__label t-text--secondary\" for=last_name>Last Name</label> </div> </div> </div> <div class=row> <div class=\"columns large-6\" ng-if=$ctrl.addGuestService.showGenderSelection(guest)> <div class=\"c-form__field--select c-form__field--radio c-form__field--gender\"> <span class=c-form__required></span> <button type=button ng-model=guest.gender ng-click=\"guest.gender = 'F'\" class=c-form__radio ng-class=\"{'active': guest.gender === 'F'}\">Female</button> <button type=button ng-model=guest.gender ng-click=\"guest.gender = 'M'\" class=c-form__radio ng-class=\"{'active': guest.gender === 'M'}\">Male</button> <label class=\"c-form__label / t-text--secondary\">Gender</label> </div> </div> <div class=\"columns large-6\" ng-if=$ctrl.canLoadStaff()> <staff-picker guest=guest staff=$ctrl.staff ng-if=$ctrl.canDisplayStaff() append-to-body=true></staff-picker> </div> </div> <div class=row ng-if=$ctrl.customisations> <div class=columns> <select-options guest=guest options=$ctrl.customisations.options item=$ctrl.item></select-options> <select-extras guest=guest options=$ctrl.customisations.extras></select-extras> </div> </div> <div class=c-basket__overlay ng-if=\"$ctrl.loading.length > 0\"> <div class=c-basket__overlay__centre> <spinner></spinner> </div> </div> </div> <a ng-if=$ctrl.showRemoveButton() class=c-guest__remove ng-click=$ctrl.addGuestService.removeGuest(guest) title=\"Remove this guest\">&times;</a> </div> <div class=\"c-add-guests__more / row\"> <div class=\"columns medium-6\"> <button type=button ng-if=$ctrl.addGuestService.canAddGuest() ng-click=$ctrl.addGuestService.addEmptyGuests() class=c-guest__button title=\"Add guests\"> <span class=\"c-guest__button-icon t-background--secondary\"><span>+</span></span><span class=c-guest__button-text>Add {{ $ctrl.addGuestService.digitToWord($ctrl.item.minimum_guests) }} more Guest<span ng-if=\"$ctrl.item.minimum_guests > 1\">s</span></span> </button> </div> <div class=\"columns medium-6\" ng-if=\"$ctrl.existingGuests.length > 0\"> <select class=\"c-add-guests__existing / c-form__select\" ng-model=existingGuestId ng-options=\"guest.id as $ctrl.guestnameService.format(guest) disable when guest.disabled for guest in $ctrl.existingGuests\" ng-disabled=$ctrl.addGuestService.maxGuestsAdded() ng-change=$ctrl.addGuestService.addExistingGuest(existingGuestId)> <option value=\"\" disabled=disabled>-- Add existing guest --</option> </select> </div> </div> </div> </div> ";

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guest: '=',
        item: '=',
        options: '<'
    },
    controller: 'selectOptionsController',
    template: __webpack_require__(945)
};

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-guest__options / c-customise / c-accordion\" ng-class=\"{'c-accordion--active': !$ctrl.hideOptions}\" ng-if=$ctrl.options> <hr> <h4 class=c-accordion__toggle ng-click=\"$ctrl.toggle('hideOptions')\"> <icon icon=chevron-down ng-if=!$ctrl.hideOptions></icon> <icon icon=chevron-right ng-if=$ctrl.hideOptions></icon> Select Option<span ng-if=\"$ctrl.options.length > 1\">s</span> <span class=c-guest__options__valid> {{ $ctrl.optionsSelected() }} / {{ $ctrl.options.length }} Selected </span> </h4> <div class=c-accordion__content> <div ng-repeat=\"group in $ctrl.options\"> <span class=c-customise__header>{{ group.name }}</span> <ul> <li ng-repeat=\"option in group.group_options\"> <div class=\"row / c-customise__row\" ng-class=\"{'c-customise__row--active': $ctrl[option.group_id +'-'+ option.id]}\"> <div class=\"columns medium-9\"> <span class=\"c-customise__name / c-customise__row__toggle\" ng-click=\"$ctrl.toggle(option.group_id +'-'+ option.id)\"> <icon icon=chevron-down ng-if=\"$ctrl[option.group_id +'-'+ option.id]\"></icon> <icon icon=chevron-right ng-if=\"!$ctrl[option.group_id +'-'+ option.id]\"></icon> {{ option.name }} </span> <div class=c-customise__row__content> <p>{{ option.description }}</p> </div> </div> <div class=\"columns medium-3 / c-customise__buttons / text-right\"> <button type=button class=button ng-class=\"{'button--hollow': !$ctrl.optionSelected(option)}\" ng-click=$ctrl.selectOption(option)> <span ng-if=!$ctrl.optionSelected(option)>Select</span> <span ng-if=$ctrl.optionSelected(option)>Selected</span> </button> </div> </div> </li> </ul> </div> </div> </div> ";

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guest: '=',
        options: '<'
    },
    controller: 'selectExtrasController',
    template: __webpack_require__(947)
};

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-guest__options / c-customise / c-accordion\" ng-class=\"{'c-accordion--active': $ctrl.showOptions}\" ng-if=$ctrl.extras> <hr> <h4 class=c-accordion__toggle ng-click=\"$ctrl.toggle('showOptions')\"> <icon icon=chevron-down ng-if=$ctrl.showOptions></icon> <icon icon=chevron-right ng-if=!$ctrl.showOptions></icon> Select Extras <span class=c-guest__options__valid> {{ $ctrl.optionsSelected() }} Selected </span> </h4> <div class=c-accordion__content> <div class=c-customise__extras__selected> <div class=\"row / c-customise__row\" ng-repeat=\"extra in $ctrl.guestExtras()\" ng-class=\"{'c-customise__row--active': $ctrl[extra.id]}\"> <div class=\"columns medium-9\"> <div class=\"c-customise__name / c-customise__row__toggle\" ng-click=$ctrl.toggle(extra.id)> <div class=row> <div class=\"columns medium-9\"> <icon icon=chevron-down ng-if=$ctrl[extra.id]></icon> <icon icon=chevron-right ng-if=!$ctrl[extra.id]></icon> {{ extra.name }} <div class=c-customise__row__content> <p>{{ extra.description }}</p> </div> </div> <div class=\"columns medium-3 / text-right\"> <money amount=extra.price.price decorate=true></money> </div> </div> </div> </div> <div class=\"columns medium-3 / c-customise__buttons / text-right\"> <button type=button class=\"button button--hollow\" ng-click=$ctrl.removeExtra(extra)>Remove</button> </div> </div> </div> <ui-select class=c-quick__search ng-model=$ctrl.extra on-select=$ctrl.selectExtra($item) append-to-body=true reset-search-input=true> <ui-select-match placeholder=\"- Select an Extra -\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"extra as extra in $ctrl.extras | filter: { name: $select.search } track by $index\" group-by=$ctrl.groupBy ui-disable-choice=$ctrl.extraSelected(event)> <div class=row> <div class=\"columns small-8 medium-10\"> <span class=c-customise__extras__name ng-bind-html=\"extra.name | highlight: $select.search\"></span> <span ng-if=extra.disabled>(Selected)</span> </div> <div class=\"columns small-4 medium-2 / text-right\"> <money class=c-customise__extras__price amount=extra.base_price decorate=true></money> </div> </div> </ui-select-choices> <ui-select-no-choice> <div class=c-customise__extras__none> No extras match that search term... </div> </ui-select-no-choice> </ui-select> </div> </div> ";

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        loading: '=',
        data: '<',
        selectedEvent: '=',
        customisations: "=",
        eventFilters: '=',
        activeEvents: '=',
        noEvents: '<',
        filterEvents: '&',
        resetFilters: '&',
        resetAvailability: '&'
    },
    controller: 'selectEventController',
    template: __webpack_require__(949)
};

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = "<div class=c-quick__filter ng-if=showFilters> <div class=row> <div class=\"columns medium-6\"> <button type=button ng-click=\"$ctrl.filter('treatments')\" class=\"button button--large / c-quick__filter__button\" ng-class=\"{'button--hollow': !$ctrl.eventFilters.treatments}\"> Treatments <icon icon=tick class=c-quick__filter__button__icon ng-if=$ctrl.eventFilters.treatments></icon> </button> </div> <div class=\"columns medium-6\"> <button type=button ng-click=\"$ctrl.filter('spadays')\" class=\"button button--large / c-quick__filter__button\" ng-class=\"{'button--hollow': !$ctrl.eventFilters.spaDays}\"> Spa Days <icon icon=tick class=c-quick__filter__button__icon ng-if=$ctrl.eventFilters.spaDays></icon> </button> </div> </div> <div class=row> <div class=\"columns medium-6\"> <select ng-model=$ctrl.eventFilters.category class=c-quick__filter__select ng-change=$ctrl.filter()> <option value=\"\">All Categories</option> <optgroup label=Treatments ng-if=$ctrl.eventFilters.treatments> <option ng-repeat=\"category in $ctrl.data.categories.Treatment\" value=\"{{ category.id }}\">{{ category.name }}</option> </optgroup> <optgroup label=\"Spa Days\" ng-if=$ctrl.eventFilters.spaDays> <option ng-repeat=\"category in $ctrl.data.categories.SpaDay\" value=\"{{ category.id }}\">{{ category.name }}</option> </optgroup> </select> </div> <div class=\"columns medium-6\"> <select ng-model=$ctrl.eventFilters.duration class=c-quick__filter__select ng-change=$ctrl.filter()> <option value=\"\">All Durations</option> <optgroup label=Treatments ng-if=$ctrl.eventFilters.treatments> <option ng-repeat=\"duration in $ctrl.data.durations.Treatment\" value=\"{{ duration }}\">{{ duration }} minutes</option> </optgroup> <optgroup label=\"Spa Days\" ng-if=$ctrl.eventFilters.spaDays> <option ng-repeat=\"duration in $ctrl.data.durations.SpaDay\" value=\"{{ duration }}\">{{ duration.charAt(0).toUpperCase() + duration.slice(1) }} day</option> </optgroup> </select> </div> </div> </div> <div class=c-quick__search> <div class=\"row collapse\"> <div class=\"columns small-8 medium-10 large-11 / c-quick__search__input\"> <ui-select class=c-quick__search__select ng-model=$ctrl.selectedEvent ng-disabled=$ctrl.loadingService.isLoading() input-id=quick-search on-select=$ctrl.selectEvent($item)> <ui-select-match placeholder=\"{{ $ctrl.placeholder() }}\"> <span>{{ $select.selected.name }}</span> <button tooltip=\"Clear event\" type=button class=c-quick__search__clear ng-click=\"$ctrl.clearEvent($event, $select)\">&times;</button> </ui-select-match> <ui-select-choices repeat=\"event.name as event in $ctrl.data.events | filter: { name: $select.search } track by $index\" group-by=$ctrl.groupEvents> <div ng-bind-html=\"event.name | highlight: $select.search\"></div> </ui-select-choices> <ui-select-no-choice> No events match that search term... </ui-select-no-choice> </ui-select> <div class=c-quick__no-events ng-if=$ctrl.noEvents> No events match those filters. <span ng-click=$ctrl.resetFilters()>Reset filters</span> </div> <spinner ng-if=\"$ctrl.loadingService.isLoading('events')\" class=c-quick__search__spinner></spinner> </div> <div class=\"columns small-4 medium-2 large-1\"> <button type=button ng-click=\"showFilters = !showFilters\" class=\"c-button--hollow c-quick__filter-toggle\" ng-class=\"{'is-active': showFilters}\" ng-disabled=\"$ctrl.loadingService.isLoading('events')\"> <icon icon=filter large=true></icon> </button> </div> </div> </div> ";

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        item: '<',
        guests: '=',
        loading: '=',
        valid: '=',
        callback: '&'
    },
    controller: 'addToBasketController',
    template: __webpack_require__(951)
};

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.item && $ctrl.item.preferred_time && $ctrl.guests\"> <button type=button class=\"button button--wide / c-basket-add\" ng-click=$ctrl.addToBasket() ng-disabled=$ctrl.buttonDisabled()> Add to basket <spinner ng-if=$ctrl.buttonDisabled()></spinner> </button> </div> ";

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        loading: "=",
        noDelete: '<'
    },
    controller: 'basketItemsController',
    template: __webpack_require__(953)
};

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports = "<div class=c-basket> <ul class=c-basket__guests> <li ng-repeat=\"guest in $ctrl.basket.contents.guest_details\" ng-if=\"guest.item_details.length > 0\" class=c-basket__guest> <span class=c-basket__name> {{ $ctrl.guestnameService.format(guest) }} </span> <div class=c-basket__actions> <money amount=$ctrl.sumGuest(guest) decorate=true></money> <button type=button confirm=\"Remove {{ $ctrl.guestnameService.format(guest) }}?\" ng-click=$ctrl.removeGuest(guest) tooltip=\"Remove guest\" ng-if=$ctrl.canDelete()> <icon icon=bin></icon> </button> </div> <ul class=c-basket__items> <li ng-repeat=\"item in guest.item_details\" class=c-basket__item> <span class=c-basket__name>{{ item.item_summary.name }}</span> <div class=c-basket__actions> <s ng-if=$ctrl.priceDifference(item)> <money amount=item.item_summary.price.original_price decorate=true></money> </s> <money amount=item.item_summary.price.price decorate=true ng-if=$ctrl.guestHasMultipleItems(guest)></money> <button type=button confirm=\"Remove {{ item.item_summary.name }}?\" ng-click=\"$ctrl.removeItem(item, guest)\" tooltip=\"Remove item\" ng-if=$ctrl.canDelete()> <icon icon=bin></icon> </button> </div> <span class=c-basket__item__details> {{ item.date.replace(' ','T') | date:'EEEE d MMMM, y' }} <span ng-if=item.preferred_time> at {{ $ctrl.displayTime(item) }} </span> <span ng-if=item.integration_staff_name> with {{ $ctrl.displayStaff(item) }} </span> </span> <ul ng-if=\"item.item_children.length > 0\" class=c-basket__children> <li ng-repeat=\"child in item.item_children\" class=c-basket__child> <span class=c-basket__name>{{ child.item_summary.name }}</span> <div class=c-basket__actions> <money amount=child.item_summary.price.price decorate=true></money> <button type=button confirm=\"Remove {{ child.item_summary.name }}?\" ng-click=\"$ctrl.removeChild(child, item)\" tooltip=\"Remove item\" ng-if=\"child.item_summary.type_name === 'EventExtra' && $ctrl.canDelete()\"> <icon icon=bin></icon> </button> </div> </li> </ul> </li> </ul> </li> </ul> <div class=c-basket__overlay ng-if=\"$ctrl.loading.length > 0\"> <div class=c-basket__overlay__centre> <spinner></spinner> </div> </div> </div> ";

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        title: '@'
    },
    controller: 'basketCreateController',
    template: __webpack_require__(955)
};

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form form=$ctrl.form saving=$ctrl.saving class=\"c-form c-order-create\"> <header> <h2 class=text-center>{{ $ctrl.title }}</h2> </header> <main class=\"row / c-quick\"> <nav class=\"columns medium-4 large-3 / c-order-create__nav\"> <basket-create-tabs guests=$ctrl.guests></basket-create-tabs> <div ng-if=$ctrl.basket.contents.expires_at> Basket valid until: <br> {{ $ctrl.basketValidUntil() }} </div> </nav> <div class=\"columns medium-8 large-9 / c-order-create__main\"> <section> <div class=section-anchor id=select-item></div> <select-event data=$ctrl.data selected-event=$ctrl.selectedEvent event-filters=$ctrl.eventFilters customisations=$ctrl.customisations no-events=$ctrl.noEvents active-events=$ctrl.activeEvents filter-events=$ctrl.filterEvents(resetEvent) reset-filters=$ctrl.resetFilters() reset-availability=\"$ctrl.resetAvailability(resetEvent, resetGuests)\"></select-event> <div class=c-quick__availability ng-show=$ctrl.itemService.hasItem()> <availability-slider loading=\"$ctrl.loadingService.isLoading('availability')\" get-quantity=$ctrl.getQuantity() staff=$ctrl.staff></availability-slider> <div class=row> <div class=\"columns medium-6\"> <preferred-time class=c-preferred-time ng-if=$ctrl.itemService.getItem().available loading=\"$ctrl.loadingService.isLoading('availability')\" get-quantity=$ctrl.getQuantity(numberOfGuests) reset-staff=$ctrl.resetStaff()></preferred-time> </div> </div> </div> </section> <section ng-if=$ctrl.canDisplayGuests()> <div class=section-anchor id=guests></div> <hr> <h3>Guests</h3> <spinner ng-if=\"$ctrl.loadingService.isLoading('quantity')\"></spinner> <add-guests ng-if=\"!$ctrl.loadingService.isLoading('quantity')\" guests=$ctrl.guests staff=$ctrl.staff customisations=$ctrl.customisations></add-guests> <add-to-basket ng-if=\"!$ctrl.loadingService.isLoading('quantity')\" guests=$ctrl.guests callback=$ctrl.itemAddedToBasket()></add-to-basket> </section> <section ng-if=$ctrl.basket.contents.has_suggestions> <div class=section-anchor id=suggestions></div> <hr> <div class=c-accordion ng-class=\"{ 'c-accordion--active': $ctrl.showSuggestions }\"> <div class=c-accordion__handle ng-click=\"$ctrl.showSuggestions = !$ctrl.showSuggestions\"> <h3> Suggestions <spinner ng-if=\"$ctrl.loadingService.isLoading('suggestions')\"></spinner> </h3> </div> <div class=c-accordion__content> <display-suggestions is-admin=true can-load-staff=\"$ctrl.propertyService.get('loadStaff')\" select-event=\"$ctrl.selectEvent(type, eventId)\"></display-suggestions> </div> </div> </section> <section ng-if=$ctrl.displayReview()> <div class=section-anchor id=review></div> <hr> <div class=c-accordion ng-class=\"{ 'c-accordion--active': !hideReview }\"> <div class=c-accordion__handle ng-click=\"hideReview = !hideReview\"> <h3>Review</h3> </div> <div class=c-accordion__content> <basket-items></basket-items> </div> </div> </section> <section ng-if=$ctrl.displayNextActions()> <div class=section-anchor id=actions></div> <hr> <button class=\"button round\" type=submit ng-disabled=$ctrl.loadingService.isLoading() ng-click=$ctrl.createOrder()>Proceed to Payment</button> <button class=\"button button--hollow round\" type=button ng-disabled=$ctrl.loadingService.isLoading()>Save for Later</button> </section> </div> </main> <form-buttons> </form-buttons> </api-form> ";

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        loading: '<',
        guests: '<'
    },
    controller: 'orderCreateTabsController',
    template: __webpack_require__(957)
};

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "<ul class=c-side-tabs> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('select-item')\">Select Item</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('select-item')\" ng-if=\"$ctrl.canShow('select-item')\">Select Item</a> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('guests')\">Add & Customise Guests</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('guests')\" ng-if=\"$ctrl.canShow('guests')\">Add & Customise Guests</a> <ul ng-if=\"$ctrl.canShow('guests') && $ctrl.guests\"> <li ng-repeat=\"guest in $ctrl.guests track by $index\"> <a ng-click=\"$ctrl.scrollTo('guest-' + $index)\">{{ $ctrl.guestnameService.format(guest) || 'New Guest' }}</a> </li> </ul> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('suggestions')\">Suggestions</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('suggestions')\" ng-if=\"$ctrl.canShow('suggestions')\">Suggestions</a> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('review')\">Review Basket</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('review')\" ng-if=\"$ctrl.canShow('review')\">Review Basket</a> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('next-actions')\">Next Actions</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('next-actions')\" ng-if=\"$ctrl.canShow('next-actions')\">Next Actions</a> </li> </ul> ";

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvailabilitySliderController = function () {
    function AvailabilitySliderController(availabilityService, availabilityApiService, dateService, itemService, storeService) {
        _classCallCheck(this, AvailabilitySliderController);

        this.availabilityService = availabilityService;
        this.availabilityApiService = availabilityApiService;
        this.dateService = dateService;
        this.itemService = itemService;
        this.storeService = storeService;
    }

    _createClass(AvailabilitySliderController, [{
        key: '$onInit',
        value: function $onInit() {
            this.travelNext = null;
            this.travelPrevious = null;
            this.loading = true;
            this.today = (0, _moment2.default)();
            this.startDate = null;
            this.endDate = null;
            this.error = false;
            this.isSearching = false;

            this.setOptions();

            this.item = this.itemService.getItem();

            this.availabilityService.resetSingleDays();
        }
    }, {
        key: 'setupDays',
        value: function setupDays() {
            if (!this.loading && this.availabilityService.hasAvailability()) {
                if (!this.availabilityService.hasSingleDays()) {
                    this.setDays();
                }

                return this.availabilityService.getSingleDays();
            }
        }
    }, {
        key: 'setDays',
        value: function setDays() {
            var _this = this;

            this.availabilityService.resetSingleDays();
            var days = [];

            this.availabilityService.getAvailability().forEach(function (availability) {
                var day = (0, _moment2.default)(availability.date);

                days.push((0, _lodash.merge)({
                    name: day.format('ddd'),
                    number: day.format('DD')
                }, availability));
            });

            this.availabilityService.setSingleDays(days);

            return this.itemService.setupItemAvailability(this.availabilityService.getAvailability(), this.startDate).then(function (response) {
                _this.getQuantity();
            });
        }
    }, {
        key: 'monthYear',
        value: function monthYear() {
            if (this.availabilityService.hasAvailability()) {
                var availability = this.availabilityService.getAvailability();
                this.startDate = (0, _moment2.default)((0, _lodash.head)(availability).date, 'YYYY-MM-DD');
                this.endDate = (0, _moment2.default)((0, _lodash.last)(availability).date, 'YYYY-MM-DD');

                if (this.startDate.isSame(this.endDate, 'month')) {
                    return this.startDate.format('MMMM YYYY');
                }

                if (this.startDate.isSame(this.endDate, 'year')) {
                    return this.startDate.format('MMM') + '\u2013' + this.endDate.format('MMM YYYY');
                }

                return this.startDate.format('MMM YYYY') + '\u2013' + this.endDate.format('MMM YYYY');
            }

            var searchDate = this.storeService.get('searchDate');
            if (searchDate) {
                return (0, _moment2.default)(searchDate).format('MMMM YYYY');
            }

            return this.today.format('MMMM YYYY');
        }
    }, {
        key: 'selectDay',
        value: function selectDay(availableDay) {
            var _this2 = this;

            if (!this.isDateSelected(availableDay)) {
                this.staff = undefined;

                return this.itemService.updateAvailability(availableDay).then(function () {
                    _this2.item = _this2.itemService.getItem();
                    _this2.item.interacted = true;
                    _this2.itemService.setItem(_this2.item);

                    _this2.getQuantity();
                });
            }
        }
    }, {
        key: 'isDateSelected',
        value: function isDateSelected(day) {
            if (this.itemService.hasItem()) {
                if (!this.item) {
                    this.item = this.itemService.getItem();
                }
                return this.item.date === day.date;
            }
        }
    }, {
        key: 'isNextDateValid',
        value: function isNextDateValid() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!this.loading && !this.error && this.availabilityService.hasAvailability()) {
                if (direction === 'previous') {
                    return !this.startDate.isSame(this.today, 'day');
                }

                return !(0, _moment2.default)(this.endDate).add(1, 'days').diff(this.today, 'years') > 0;
            }

            return false;
        }
    }, {
        key: 'nextAvailability',
        value: function nextAvailability() {
            var _this3 = this;

            this.travelNext = true;
            this.isSearching = true;

            return this.updateAvailability('next').then(function () {
                _this3.travelNext = null;
            });
        }
    }, {
        key: 'previousAvailability',
        value: function previousAvailability() {
            var _this4 = this;

            this.travelPrevious = true;
            this.isSearching = true;

            return this.updateAvailability('previous').then(function () {
                _this4.travelPrevious = null;
            });
        }
    }, {
        key: 'updateAvailability',
        value: function updateAvailability() {
            var _this5 = this;

            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

            this.loading = true;
            this.error = false;
            this.availabilityService.resetSingleDays();
            this.availabilityService.resetSingleTimes();

            this.setStartEndDates(direction);

            if (this.basket && this.basket.store_offer) {
                this.item.offer = {
                    id: this.basket.store_offer
                };
                this.itemService.setItem(this.item);
            }

            var offer = this.item.offer ? this.item.offer.id : 'storefront';

            return this.availabilityApiService.requestAvailability(this.startDate.format('YYYY-MM-DD'), this.endDate.format('YYYY-MM-DD'), this.item.event_type || this.item.type_name, this.item.id, offer).then(function (response) {
                _this5.availabilityService.setAvailability(response);

                return _this5.setupDays(false);
            }).catch(function () {
                _this5.error = true;
            }).then(function () {
                _this5.loading = false;
            });
        }
    }, {
        key: 'setStartEndDates',
        value: function setStartEndDates(direction) {
            var start = null;
            var end = null;

            switch (direction) {
                case 'next':
                    start = (0, _moment2.default)(this.endDate.add(1, 'days'));
                    end = this.endDate.add(6, 'days');
                    break;
                case 'previous':
                    end = (0, _moment2.default)(this.startDate.subtract(1, 'days'));
                    start = this.startDate.subtract(6, 'days');
                    break;
                default:
                    start = (0, _moment2.default)(this.startDate);
                    end = this.startDate.add(6, 'days');
                    this.isSearching = false;
            }

            this.startDate = this.dateService.checkMaxDate(start, true);
            this.endDate = this.dateService.checkMaxDate(end);

            if (!this.dateService.verifyDateGteToday(this.startDate)) {
                this.startDate = (0, _moment2.default)();
                this.endDate = (0, _moment2.default)().add(6, 'days');
            }
            this.storeService.set('searchDate', this.startDate.format('YYYY-MM-DD'));
        }
    }, {
        key: 'goToToday',
        value: function goToToday() {
            this.startDate = (0, _moment2.default)();
            return this.updateAvailability();
        }
    }, {
        key: 'updateDate',
        value: function updateDate(date) {
            if (date && date[0] && !this.isDateSelected({ date: date[0] })) {
                this.staff = undefined;

                this.startDate = this.dateService.checkDate(date[0], true);
                this.item.date = this.startDate.format('YYYY-MM-DD');

                return this.updateAvailability();
            }
        }
    }, {
        key: 'displayOriginalPrice',
        value: function displayOriginalPrice(day) {
            return !!(day.available && day.original_price !== day.price);
        }
    }, {
        key: 'hasLoaded',
        value: function hasLoaded() {
            return !!(!this.loading && this.availabilityService.hasAvailability());
        }
    }, {
        key: 'setOptions',
        value: function setOptions() {
            var _this6 = this;

            var minDate = 'today';
            var maxDate = (0, _moment2.default)().add(1, 'year').format('YYYY-MM-DD');

            var startDate = this.storeService.get('start_date');
            if (startDate) {
                minDate = (0, _moment2.default)(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
                maxDate = (0, _moment2.default)(this.storeService.get('end_date'), 'YYYY-MM-DD').format('YYYY-MM-DD');
            }

            this.flatpickrOptions = {
                placeholder: null,
                minDate: minDate,
                maxDate: maxDate,
                disableMobile: "true",
                onChange: function onChange(date) {
                    _this6.updateDate(date);
                }
            };
        }
    }, {
        key: 'setFlatpickrInstance',
        value: function setFlatpickrInstance(fpItem) {
            this.flatpickr = fpItem;
        }
    }]);

    return AvailabilitySliderController;
}();

AvailabilitySliderController.$inject = ['availabilityService', 'availabilityApiService', 'dateService', 'itemService', 'storeService'];

exports.default = AvailabilitySliderController;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddGuestsController = function () {
    function AddGuestsController(basket, addGuestService, propertyService, guestnameService, itemService, loadingService) {
        _classCallCheck(this, AddGuestsController);

        this.basket = basket;
        this.addGuestService = addGuestService;
        this.propertyService = propertyService;
        this.guestnameService = guestnameService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    _createClass(AddGuestsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.item = this.itemService.getItem();

            this.titles = this.addGuestService.buildTitlesList();
            this.existingGuests = this.addGuestService.filterGuestsByGender(this.basket.contents.guest_details);

            this.guests = this.addGuestService.setInitialGuests(this.addGuestService.getGuests());
        }
    }, {
        key: 'canLoadStaff',
        value: function canLoadStaff() {
            return this.propertyService.get('loadStaff');
        }
    }, {
        key: 'canDisplayStaff',
        value: function canDisplayStaff() {
            return !!(this.canLoadStaff() && !this.loadingService.isLoading() && this.staff && this.staff.length);
        }
    }, {
        key: 'displayMinMaxGuests',
        value: function displayMinMaxGuests() {
            var string = 'This ' + this.item.type_display + ' can be booked for ' + this.numberOfGuests() + '.';

            if (this.item.gender) {
                var gender = this.item.gender === 'M' ? 'male' : 'female';
                string += ' It is only available to ' + gender + ' guests.';
            }

            return string;
        }
    }, {
        key: 'numberOfGuests',
        value: function numberOfGuests() {
            if (!this.propertyService.get('hasIntegration') && this.item.quantity > this.item.maximum_guests) {
                this.item.quantity = this.item.maximum_guests;
                this.itemService.setItem(this.item);
            }

            if (parseInt(this.item.minimum_guests) !== parseInt(this.item.quantity)) {
                return this.item.minimum_guests + ' to ' + this.item.quantity + ' guests';
            }

            if (this.item.quantity > 1) {
                return this.item.quantity + ' guests';
            }

            return this.item.quantity + ' guest';
        }
    }, {
        key: 'notEnoughGuests',
        value: function notEnoughGuests() {
            this.error = null;
            if (this.item.quantity && parseInt(this.item.minimum_guests) > parseInt(this.item.quantity)) {
                this.error = '<em>Sorry, there is currently no availability for the selected time.</em>';
                return true;
            }

            return false;
        }
    }, {
        key: 'sumGuest',
        value: function sumGuest(guest) {
            var custom = guest.item_children.reduce(function (acc, curr) {
                var price = 0;
                if (curr && curr.price) {
                    price = curr.price.price;
                }

                return acc + price;
            }, 0);

            return parseInt(this.item.price) + parseInt(custom);
        }
    }, {
        key: 'showRemoveButton',
        value: function showRemoveButton() {
            return this.guests.length > this.item.minimum_guests;
        }
    }]);

    return AddGuestsController;
}();

AddGuestsController.$inject = ['basket', 'addGuestService', 'propertyService', 'guestnameService', 'itemService', 'loadingService'];

exports.default = AddGuestsController;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectOptionsController = function () {
    function SelectOptionsController() {
        _classCallCheck(this, SelectOptionsController);
    }

    _createClass(SelectOptionsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.guest.validOptions = false;
            this.item.requiredOptions = 0;
            if (this.options) {
                this.options.forEach(function (group) {
                    _this.item.requiredOptions += group.selections;
                });
            }
        }
    }, {
        key: 'toggle',
        value: function toggle(param) {
            this[param] = !this[param];
        }
    }, {
        key: 'selectOption',
        value: function selectOption(option) {
            if (!this.optionSelected(option)) {
                this.removeGroupOption(option);

                this.guest.item_children.push(option);

                this.checkValidity();
            }
        }
    }, {
        key: 'removeGroupOption',
        value: function removeGroupOption(option) {
            var index = this.guest.item_children.findIndex(function (item) {
                return item.group_id === option.group_id;
            });

            if (index > -1) {
                this.guest.item_children.splice(index, 1);
            }
        }
    }, {
        key: 'optionSelected',
        value: function optionSelected(option) {
            return !!this.guest.item_children.find(function (item) {
                return item.group_id === option.group_id && item.id === option.id;
            });
        }
    }, {
        key: 'checkValidity',
        value: function checkValidity() {
            if (this.optionsSelected === this.item.requiredOptions) {
                this.guest.validOptions = true;
                return;
            }

            this.guest.validOptions = false;
        }
    }, {
        key: 'optionsSelected',
        value: function optionsSelected() {
            return this.guest.item_children.filter(function (item) {
                return item.type_name === 'OptionGroupOption';
            }).length || 0;
        }
    }]);

    return SelectOptionsController;
}();

SelectOptionsController.$inject = [];

exports.default = SelectOptionsController;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectExtrasController = function () {
    function SelectExtrasController() {
        _classCallCheck(this, SelectExtrasController);
    }

    _createClass(SelectExtrasController, [{
        key: '$onInit',
        value: function $onInit() {
            var free = (0, _lodash.cloneDeep)(this.options.free) || [];
            var paid = (0, _lodash.cloneDeep)(this.options.paid) || [];
            this.extras = free.concat(paid);
        }
    }, {
        key: 'toggle',
        value: function toggle(param) {
            this[param] = !this[param];
        }
    }, {
        key: 'groupBy',
        value: function groupBy(item) {
            return item.base_price > 0 ? 'Paid' : 'Free';
        }
    }, {
        key: 'removeExtra',
        value: function removeExtra(extra) {
            var index = this.guest.item_children.findIndex(function (item) {
                if (item.type_name === 'EventExtra' && item.id === extra.id) {
                    return true;
                }
            });

            if (index > -1) {
                this.guest.item_children.splice(index, 1);
            }
        }
    }, {
        key: 'selectExtra',
        value: function selectExtra(extra) {
            if (!this.extraSelected(extra)) {
                this.guest.item_children.push(extra);
            }

            this.extra = null;
        }
    }, {
        key: 'extraSelected',
        value: function extraSelected(extra) {
            if (!extra || !extra.id) {
                return false;
            }

            return !!this.guest.item_children.find(function (item) {
                return item.type_name === 'EventExtra' && item.id === extra.id;
            });
        }
    }, {
        key: 'optionsSelected',
        value: function optionsSelected() {
            return this.guestExtras().length || 0;
        }
    }, {
        key: 'guestExtras',
        value: function guestExtras() {
            return this.guest.item_children.filter(function (item) {
                return item.type_name === 'EventExtra';
            });
        }
    }]);

    return SelectExtrasController;
}();

SelectExtrasController.$inject = [];

exports.default = SelectExtrasController;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(0);

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectEventController = function () {
    function SelectEventController($scope, basket, availabilityApiService, eventsService, addGuestService, dateService, availabilityService, itemService, loadingService) {
        _classCallCheck(this, SelectEventController);

        this.$scope = $scope;
        this.basket = basket;
        this.availabilityApiService = availabilityApiService;
        this.eventsService = eventsService;
        this.addGuestService = addGuestService;
        this.dateService = dateService;
        this.availabilityService = availabilityService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    _createClass(SelectEventController, [{
        key: '$onInit',
        value: function $onInit() {
            this.watchSelectedEvent();
        }
    }, {
        key: 'groupEvents',
        value: function groupEvents(item) {
            return item.type_display;
        }
    }, {
        key: 'filter',
        value: function filter(param) {
            switch (param) {
                case 'treatments':
                    this.eventFilters.treatments = !this.eventFilters.treatments;
                    break;
                case 'spadays':
                    this.eventFilters.spaDays = !this.eventFilters.spaDays;
                    break;
                case 'activities':
                    this.eventFilters.activities = !this.eventFilters.activities;
                    break;
            }

            this.filterEvents();
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            if (this.loadingService.isLoading('events')) {
                return 'Loading...';
            }

            var string = 'Search';
            var types = [];

            if (this.activeEvents.treatments) {
                types.push('Treatments');
            }

            if (this.activeEvents.spaDays) {
                types.push('Spa Days');
            }

            if (this.activeEvents.activities) {
                types.push('Activities');
            }

            return string + ' ' + types.join(' and ') + '...';
        }
    }, {
        key: 'selectEvent',
        value: function selectEvent(event) {
            if (!event) {
                return false;
            }
            this.resetAvailability({ resetEvent: false, resetGuests: false });

            this.loadingService.startLoading('availability');

            var item = (0, _lodash.cloneDeep)(event);
            item.preferred_time = undefined;
            item.date = this.dateService.checkStoredDate();

            this.itemService.setItem(item);

            this.basket.contents.guest_details.map(function (guest) {
                guest.disabled = false;

                return guest;
            });

            this.addGuestService.setState({
                existingGuests: this.basket.contents.guest_details,
                gender: item.gender,
                maximumGuests: item.maximum_guests,
                minimumGuests: item.minimum_guests,
                guests: []
            });

            return Promise.all([this.getCustomisations(), this.getAvailability(item)]);
        }
    }, {
        key: 'clearEvent',
        value: function clearEvent($event, $select) {
            $event.stopPropagation();
            $select.selected = '';
            $select.search = null;

            this.resetAvailability({ resetEvent: true, resetGuests: true });
        }
    }, {
        key: 'getAvailability',
        value: function getAvailability(item) {
            var _this = this;

            var toDate = moment(item.date).add(6, 'days').format('YYYY-MM-DD');

            return this.availabilityApiService.requestAvailability(item.date, toDate, item.type_name, item.id, item.offer).then(function (response) {
                _this.loadingService.stopLoading('availability');
                _this.availabilityService.setAvailability(response);
            });
        }
    }, {
        key: 'getCustomisations',
        value: function getCustomisations() {
            var _this2 = this;

            this.customisations = null;

            return new Promise(function (resolve) {
                var item = _this2.itemService.getItem();
                if (item) {
                    _this2.loadingService.startLoading('customise');

                    return _this2.eventsService.collectCustomisations(item.type_name, item.id).then(function (response) {
                        _this2.loadingService.stopLoading('customise');
                        _this2.customisations = response;

                        resolve();
                    });
                }

                resolve();
            });
        }
    }, {
        key: 'watchSelectedEvent',
        value: function watchSelectedEvent() {
            var _this3 = this;

            this.$scope.$watch(function () {
                return _this3.selectedEvent;
            }, function (newVal, oldVal) {
                if (newVal && (typeof newVal === 'undefined' ? 'undefined' : _typeof(newVal)) === 'object') {
                    _this3.selectEvent(newVal);
                }
            }, true);
        }
    }]);

    return SelectEventController;
}();

SelectEventController.$inject = ['$scope', 'basket', 'availabilityApiService', 'eventsService', 'addGuestService', 'dateService', 'availabilityService', 'itemService', 'loadingService'];

exports.default = SelectEventController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddToBasketController = function () {
    function AddToBasketController(basket, validateService, messageService, itemService, loadingService) {
        _classCallCheck(this, AddToBasketController);

        this.basket = basket;
        this.validateService = validateService;
        this.messageService = messageService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    _createClass(AddToBasketController, [{
        key: '$onInit',
        value: function $onInit() {
            this.item = this.itemService.getItem();
        }
    }, {
        key: 'buttonDisabled',
        value: function buttonDisabled() {
            return this.loadingService.isLoading() || !this.item.available || this.item.phone_only;
        }
    }, {
        key: 'addToBasket',
        value: function addToBasket() {
            var _this = this;

            this.messageService.clear();
            if (!this.validate()) {
                return false;
            }

            this.loadingService.startLoading('addToBasket');

            return this.basket.addToBasket(this.guests, this.item).then(function () {
                _this.loadingService.stopLoading('addToBasket');

                _this.callback();
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            var error = this.validateService.itemError(this.item);

            if (!error) {
                error = this.validateService.guestInputCustomiseError(this.guests, this.item);
            }

            if (error) {
                this.messageService.failure(error);
                this.messageService.push();
                return false;
            }

            return true;
        }
    }]);

    return AddToBasketController;
}();

AddToBasketController.$inject = ['basket', 'validateService', 'messageService', 'itemService', 'loadingService'];

exports.default = AddToBasketController;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasketItemsController = function () {
    function BasketItemsController(basket, guestnameService, messageService, loadingService) {
        _classCallCheck(this, BasketItemsController);

        this.basket = basket;
        this.guestnameService = guestnameService;
        this.messageService = messageService;
        this.loadingService = loadingService;
    }

    _createClass(BasketItemsController, [{
        key: 'sumGuest',
        value: function sumGuest(guest) {
            var total = 0;

            guest.item_details.forEach(function (item) {
                if (item.item_summary) {
                    total += item.item_summary.price.price;

                    if (item.item_children && item.item_children.length > 0) {
                        item.item_children.forEach(function (child) {
                            total += child.item_summary.price.price;
                        });
                    }
                }
            });

            return total;
        }
    }, {
        key: 'priceDifference',
        value: function priceDifference(item) {
            if (item && item.item_summary) {
                return item.item_summary.price.price !== item.item_summary.price.original_price;
            }

            return false;
        }
    }, {
        key: 'displayTime',
        value: function displayTime(item) {
            return item.preferred_time.substr(0, 5);
        }
    }, {
        key: 'displayStaff',
        value: function displayStaff(item) {
            if (item.integration_staff) {
                return item.integration_staff_name;
            }

            return item.integration_staff_name[0].toLowerCase() + item.integration_staff_name.substr(1);
        }
    }, {
        key: 'removeGuest',
        value: function removeGuest(guest) {
            var _this = this;

            if (this.loadingService.isLoading()) {
                return;
            }

            guest.item_details.forEach(function (item) {
                if (item.item_summary.minimum_guests > 1) {
                    _this.removeItem(item, guest, false);
                }
            });

            var index = this.basket.contents.guest_details.findIndex(function (basketGuest) {
                return basketGuest.id === guest.id;
            });
            if (index > -1) {
                this.basket.contents.guest_details.splice(index, 1);
            }

            return this.submitBasket(index > -1, 'Could not remove that guest');
        }
    }, {
        key: 'removeItem',
        value: function removeItem(item, guest) {
            var shouldSubmit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (this.loadingService.isLoading()) {
                return;
            }

            var index = -1;

            if (item.item_summary.minimum_guests > 1) {
                var reference = item.reference;
                this.basket.contents.guest_details.forEach(function (guest) {
                    index = guest.item_details.findIndex(function (guestItem) {
                        return guestItem.reference === reference;
                    });
                    if (index > -1) {
                        guest.item_details.splice(index, 1);
                    }
                });
            } else {
                index = guest.item_details.findIndex(function (guestItem) {
                    return guestItem.id === item.id;
                });
                if (index > -1) {
                    guest.item_details.splice(index, 1);
                }
            }

            if (shouldSubmit) {
                return this.submitBasket(index > -1, 'Could not remove that item');
            }
        }
    }, {
        key: 'removeChild',
        value: function removeChild(child, parent) {
            if (this.loadingService.isLoading()) {
                return;
            }

            var index = parent.item_children.findIndex(function (item) {
                return item.id === child.id;
            });
            if (index > -1) {
                parent.item_children.splice(index, 1);
            }

            return this.submitBasket(index > -1, 'Could not remove that item');
        }
    }, {
        key: 'submitBasket',
        value: function submitBasket(shouldSubmit, errorMessage) {
            var _this2 = this;

            if (shouldSubmit) {
                this.loadingService.startLoading('submitBasket');

                this.basket.contents.option = 'reset_steps';

                return this.basket.submit('remove').then(function () {
                    _this2.loadingService.stopLoading('submitBasket');
                });
            }

            this.messageService.failure(errorMessage);
            this.messageService.push();
            this.messageService.autoClear();
        }
    }, {
        key: 'canDelete',
        value: function canDelete() {
            return !this.noDelete;
        }
    }]);

    return BasketItemsController;
}();

BasketItemsController.$inject = ['basket', 'guestnameService', 'messageService', 'loadingService'];

exports.default = BasketItemsController;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasketCreateController = function () {
    function BasketCreateController($state, eventsService, basket, messageService, availabilityService, quantityService, propertyService, addGuestService, suggestionsService, itemService, loadingService) {
        _classCallCheck(this, BasketCreateController);

        this.$state = $state;
        this.eventsService = eventsService;
        this.basket = basket;
        this.messageService = messageService;
        this.availabilityService = availabilityService;
        this.quantityService = quantityService;
        this.propertyService = propertyService;
        this.addGuestService = addGuestService;
        this.suggestionsService = suggestionsService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    _createClass(BasketCreateController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loadingService.startLoading(['basket', 'events', 'categories']);

            this.initEventFilters();

            this.activeEvents = {
                treatments: false,
                spaDays: false,
                activities: false
            };

            this.originalData = {};

            return Promise.all([this.getBasket(), this.getAllEvents(), this.getCategories()]).then(function () {
                _this.filterEvents();
            });
        }
    }, {
        key: 'getBasket',
        value: function getBasket() {
            var _this2 = this;

            return this.basket.get().then(function (response) {
                _this2.loadingService.stopLoading('basket');
            });
        }
    }, {
        key: 'getAllEvents',
        value: function getAllEvents() {
            var _this3 = this;

            return this.eventsService.collectActive(true).then(function (response) {
                _this3.originalData.events = response;
                _this3.collectDurations();
            }).catch(function (error) {
                return _this3.displayError(error);
            }).then(function () {
                _this3.loadingService.stopLoading('events');
            });
        }
    }, {
        key: 'getCategories',
        value: function getCategories() {
            var _this4 = this;

            return this.eventsService.collectCategoriesFlat().then(function (response) {
                _this4.originalData.categories = response;
            }).catch(function (error) {
                return _this4.displayError(error);
            }).then(function () {
                _this4.loadingService.stopLoading('categories');
            });
        }
    }, {
        key: 'collectDurations',
        value: function collectDurations() {
            var _this5 = this;

            this.originalData.durations = {
                Treatment: [],
                SpaDay: []
            };

            this.originalData.events.forEach(function (event) {
                var duration = event.duration;
                var container = _this5.originalData.durations[event.type_name];

                if (event.display_duration) {
                    duration = event.display_duration;
                }

                if (container && container.indexOf(duration) === -1) {
                    container.push(duration);
                }
            });

            this.originalData.durations.Treatment.sort(function (a, b) {
                return a - b;
            });
            this.originalData.durations.SpaDay.sort(function (a, b) {
                return a - b;
            });
        }
    }, {
        key: 'filterEvents',
        value: function filterEvents() {
            var _this6 = this;

            var resetSelectedEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.resetAvailability(resetSelectedEvent);

            if (!this.originalData) {
                return;
            }

            this.data = (0, _lodash.cloneDeep)(this.originalData);
            this.data.events = this.data.events.filter(function (event) {
                if (event.type_name === 'Treatment' && !_this6.eventFilters.treatments) {
                    return false;
                }

                if (event.type_name === 'SpaDay' && !_this6.eventFilters.spaDays) {
                    return false;
                }

                if (event.type_name === 'Activity' && !_this6.eventFilters.activities) {
                    return false;
                }

                if (_this6.eventFilters.category && (!event.categories || event.categories.indexOf(parseInt(_this6.eventFilters.category))) === -1) {
                    return false;
                }

                if (_this6.eventFilters.duration && (event.display_duration && '' + event.display_duration !== '' + _this6.eventFilters.duration || !event.display_duration && '' + event.duration !== '' + _this6.eventFilters.duration)) {
                    return false;
                }

                switch (event.type_name) {
                    case 'Treatment':
                        _this6.activeEvents.treatments = true;
                        break;
                    case 'SpaDay':
                        _this6.activeEvents.spaDays = true;
                        break;
                    case 'Activity':
                        _this6.activeEvents.acitivies = true;
                        break;
                }

                return true;
            });

            if (!this.data.events.length) {
                this.noEvents = true;
            }
        }
    }, {
        key: 'resetFilters',
        value: function resetFilters() {
            this.initEventFilters();
            this.noEvents = false;

            this.filterEvents();
        }
    }, {
        key: 'initEventFilters',
        value: function initEventFilters() {
            this.eventFilters = {
                treatments: true,
                spaDays: true,
                activities: false,
                category: '',
                duration: ''
            };
        }
    }, {
        key: 'resetAvailability',
        value: function resetAvailability() {
            var resetEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var resetGuests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.itemService.setItem(null);
            this.staff = undefined;
            this.noEvents = false;

            this.availabilityService.resetAvailability();
            this.availabilityService.resetSingleDays();
            this.availabilityService.resetSingleTimes();

            if (resetEvent) {
                this.selectedEvent = '';
            }

            if (resetGuests) {
                this.guests = [];
            }
        }
    }, {
        key: 'displayError',
        value: function displayError(error) {
            this.messageService.failure(error);
            this.messageService.push();
            this.messageService.autoClear();
        }
    }, {
        key: 'getQuantity',
        value: function getQuantity() {
            var _this7 = this;

            var numberOfGuests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

            var item = this.itemService.getItem();

            if (item) {
                item.quantity = undefined;

                if (item.preferred_time) {
                    this.loadingService.startLoading('quantity');
                    this.resetStaff();

                    return this.quantityService.getQuantity(item, numberOfGuests).then(function (response) {
                        _this7.addGuestService.setState(response.quantity, 'maximumGuests');

                        item.quantity = response.quantity;
                        _this7.itemService.setItem(item);

                        _this7.setStaff(response.staff);

                        _this7.loadingService.stopLoading('quantity');
                    });
                }
            }
        }
    }, {
        key: 'setStaff',
        value: function setStaff(staff) {
            this.staff = undefined;

            if (this.canDisplayStaff()) {
                this.staff = (0, _lodash.map)(staff, function (staffId, staffName) {
                    return {
                        id: staffId,
                        label: staffName
                    };
                });
            }

            this.addGuestService.setState(this.staff, 'staff');
        }
    }, {
        key: 'resetStaff',
        value: function resetStaff() {
            var item = this.itemService.getItem();
            delete item.staff;
            this.itemService.setItem(item);

            if (this.staff) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.staff[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var staff = _step.value;

                        delete staff.disabled;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: 'canDisplayStaff',
        value: function canDisplayStaff() {
            return this.propertyService.get('loadStaff');
        }
    }, {
        key: 'canDisplayGuests',
        value: function canDisplayGuests() {
            return !!(this.availabilityService.hasSingleTimes() && this.itemService.hasItem() && this.itemService.getItem().preferred_time);
        }
    }, {
        key: 'displayReview',
        value: function displayReview() {
            return !!(this.basket && this.basket.contents && this.basket.contents.guest_details && this.basket.contents.guest_details.find(function (guest) {
                return guest.id && guest.item_details.length > 0;
            }));
        }
    }, {
        key: 'basketValidUntil',
        value: function basketValidUntil() {
            if (this.basket.contents.expires_at) {
                return (0, _moment2.default)(this.basket.contents.expires_at + '+00:00').format('LLLL');
            }
        }
    }, {
        key: 'displayNextActions',
        value: function displayNextActions() {
            return !!((!this.guests || this.guests && this.guests.length === 0) && this.displayReview());
        }
    }, {
        key: 'createOrder',
        value: function createOrder() {
            this.loadingService.startLoading('order');
            this.saving = true;

            this.$state.go('app.admin.order-create');
        }
    }, {
        key: 'itemAddedToBasket',
        value: function itemAddedToBasket() {
            this.resetAvailability(true, true);

            return this.suggestionsService.getSuggestions();
        }
    }, {
        key: 'selectEvent',
        value: function selectEvent(type, eventId) {
            this.showSuggestions = false;
            this.selectedEvent = this.data.events.find(function (event) {
                return event.type_name === type && event.id === eventId;
            });
        }
    }]);

    return BasketCreateController;
}();

BasketCreateController.$inject = ['$state', 'eventsService', 'basket', 'messageService', 'availabilityService', 'quantityService', 'propertyService', 'addGuestService', 'suggestionsService', 'itemService', 'loadingService'];

exports.default = BasketCreateController;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(2);

exports.default = ['basketApiService', 'storeService', 'messageService', function (basketApiService, storeService, messageService) {
    var basket = {
        contents: {},
        saving: false
    };

    basket.promise = Promise.resolve();

    basket.get = function () {
        var basketCode = storeService.get('basket');
        basket.saving = true;

        if (basketCode === 'undefined' || basketCode === 'null') {
            basketCode = null;
            storeService.set('basket', '');
        }

        if (basketCode) {
            return getExistingBasket(basketCode);
        }

        return getNewBasket();
    };

    basket.referenceGenerator = function () {
        var instanceref = '';
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var index = 0; index < 16; index++) {
            instanceref += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return instanceref;
    };

    basket.addToBasket = function (guests, item) {
        basket.success = false;
        basket.saving = false;
        basket.contents.option = 'delete_orders';

        basket.mergeGuests(guests, item);

        return basket.submit();
    };

    basket.mergeGuests = function (guests, item) {
        if (!guests.length || !item) {
            return false;
        }

        item.reference = basket.referenceGenerator();

        guests.forEach(function (guest) {
            var existingGuest = -1;
            var guestItem = buildGuestItem(item, guest.staff);
            if (guest.item_children) {
                guest.item_children.forEach(function (child) {
                    guestItem.item_children.push(buildGuestItem(child));
                });
            }

            if (basket.contents.guest_details.length > 0) {
                existingGuest = basket.contents.guest_details.findIndex(function (basketGuest) {
                    if (guest.id) {
                        return basketGuest.id === guest.id;
                    }

                    return (basketGuest.title ? basketGuest.title === guest.title : true) && basketGuest.first_name === guest.first_name && basketGuest.last_name === guest.last_name;
                });
            }

            if (existingGuest > -1) {
                if (!guest.imported) {
                    basket.contents.guest_details[existingGuest].title = guest.title;
                    basket.contents.guest_details[existingGuest].first_name = guest.first_name;
                    basket.contents.guest_details[existingGuest].last_name = guest.last_name;
                }

                basket.contents.guest_details[existingGuest].item_details.push(guestItem);
                return;
            }

            guest.item_details = [guestItem];
            basket.contents.guest_details.push(guest);
        });
    };

    basket.submit = function () {
        var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'add';

        return basketApiService.submitBasket(basket.contents).then(function (response) {
            if (response.basket_status && response.basket_status !== '-1') {
                basket.contents = response;

                if (response.errors && response.errors.length) {
                    basket.success = false;
                    errorHandler({}, action);
                    return;
                }

                basket.success = true;
                return;
            }

            basket.success = false;
        }).catch(function (error) {
            basket.success = false;

            if (error.status === 404) {
                errorHandler(error, 'get', true);

                return basket.get();
            }

            errorHandler(error, action);
        }).then(function () {
            basket.saving = false;
        });
    };

    basket.isEmpty = function () {
        return !!(basket.contents.guest_details && !basket.contents.guest_details.find(function (guest) {
            return guest.item_details.length > 0;
        }));
    };

    var getExistingBasket = function getExistingBasket(basketCode) {
        return basketApiService.retrieveBasket(basketCode).then(function (response) {
            if (response) {
                basket.contents = response;
            }

            basket.saving = false;
        }).catch(function (error) {
            storeService.set('basket', '');

            if (error.status === 410) {
                errorHandler(error, 'complete');
            }

            if (error.status === 400 || error.status === 404) {
                errorHandler(error, 'get', true);
            }

            return basket.get();
        });
    };

    var getNewBasket = function getNewBasket() {
        return basketApiService.generateBasket().then(function (response) {
            if (response && response.id && response.basket) {
                storeService.set('basket', response.id);
                basket.contents = response.basket;
            }

            basket.saving = false;
        }).catch(function (error) {
            errorHandler(error, 'create');

            return basket.get();
        });
    };

    var errorHandler = function errorHandler(error, callType) {
        var checkData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var errorMessages = {
            add: 'There was a problem adding that item to the basket',
            complete: 'Your previous basket is already completed, starting a fresh one',
            create: 'There was an error creating the basket, starting a fresh one',
            expired: 'Sorry, your previous basket has expired, starting a fresh one',
            get: 'There was an error retrieving the basket, starting a fresh one',
            remove: 'There was a problem removing that, please try again'
        };

        var errorMessage = errorMessages[callType];

        if (checkData) {
            switch (error.data) {
                case 'expired':
                    errorMessage = errorMessages.expired;
                    break;
                case 'not_found':
                    errorMessage = errorMessages.get;
                    break;
                case 'basket_ordered':
                    errorMessage = errorMessages.complete;
                    break;
            }
        }

        messageService.failure(errorMessage);
        if (basket.contents.errors && basket.contents.errors.length > 0) {
            basket.contents.errors.forEach(function (error) {
                messageService.failure(error);
            });
        }
        messageService.push();

        if (checkData && error.data !== 'expired') {
            messageService.autoClear();
        }
    };

    var buildGuestItem = function buildGuestItem(item, staff) {
        if (_typeof(item.price) === 'object') {
            item.original_price = item.price.original_price;
            item.price = item.price.price;
        }

        if (item.offer && _typeof(item.offer) === 'object') {
            item.offer_id = item.offer.id;
        }

        var guestItem = Object.assign({}, item, {
            id: null,
            reference: item.reference || basket.referenceGenerator(),
            item_id: item.id,
            name: item.name.replace('/\\/g', ''),
            price: item.price || 0,
            original_price: item.original_price || 0,
            currency: basket.contents.currency,
            upgraded: item.upgraded || 0,
            item_type: item.type_raw || 'App\\' + item.type_name,
            item_children: []
        });

        if (staff) {
            guestItem.integration_staff = staff.id;
            guestItem.integration_staff_name = staff.label;
        }

        if (item.group_id) {
            guestItem.item = {
                'option_group_id': item.group_id,
                'option_type': item.option_type,
                'option_id': item.option_id
            };
        }

        return guestItem;
    };

    return basket;
}];

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property) {
    return '/api/' + property + '/basket';
};

exports.default = ['api', function (api) {
    return {
        generateBasket: function generateBasket() {
            return api.get(endpoint(api.property())).then(function (response) {
                return response.data;
            });
        },
        retrieveBasket: function retrieveBasket(basketCode) {
            return api.get(endpoint(api.property()) + '/' + basketCode + '?items=true').then(function (response) {
                return response.data;
            });
        },
        submitBasket: function submitBasket(basket) {
            return api.post(endpoint(api.property()), basket).then(function (response) {
                return response.data;
            });
        },
        deleteBasket: function deleteBasket(basketCode) {
            return api.delete(endpoint(api.property()) + '/' + basketCode).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = ['api', 'availabilityCacheService', function (api, availabilityCacheService) {
    var switchEventType = function switchEventType(eventType) {
        switch (eventType.toLowerCase()) {
            case 'treatment':
                return 'treatments';
            case 'day':
            case 'spaday':
            case 'spa day':
                return 'spa-days';
            default:
                return null;
        }
    };

    var uncacheDate = function uncacheDate(eventType, eventId, date) {
        return availabilityCacheService.uncacheDate(eventType, eventId, date);
    };

    var requestAvailability = function requestAvailability(fromDate, toDate, eventType, eventId) {
        var offerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        var cached = availabilityCacheService.datesCached(eventType, eventId, fromDate, toDate);

        if (cached.length) {
            return Promise.resolve(cached);
        }

        var url = '/api/' + api.property() + '/' + switchEventType(eventType) + '/' + eventId + '/availability?from_date=' + fromDate + '&to_date=' + toDate;

        if (offerId) {
            if ((typeof offerId === 'undefined' ? 'undefined' : _typeof(offerId)) === 'object') {
                offerId = offerId.id;
            }
            url += '&offer_id=' + offerId;
        }

        return api.get(url).then(function (response) {
            availabilityCacheService.updateCache(eventType, eventId, response.data);
            return response.data;
        });
    };

    var requestAvailabilityList = function requestAvailabilityList(date, eventType) {
        var eventIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var offerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        var url = '/api/' + api.property() + '/' + switchEventType(eventType) + '/availability?date=' + date;

        if (eventIds) {
            url += '&event_ids=' + eventIds.join(',');
        }

        if (offerId) {
            url += '&offer_id=' + offerId;
        }

        return api.get(url).then(function (response) {
            return response.data;
        });
    };

    return {
        switchEventType: switchEventType,
        uncacheDate: uncacheDate,
        requestAvailability: requestAvailability,
        requestAvailabilityList: requestAvailabilityList
    };
}];

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: function find(date, eventType, eventId, time) {
            var numberOfGuests = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            if (numberOfGuests) {
                numberOfGuests = '&guests=' + numberOfGuests;
            }

            return api.get('/api/' + api.property() + '/' + availabilityApiService.switchEventType(eventType) + '/' + eventId + '/quantity?date=' + date + '&time=' + time + numberOfGuests).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: function find(date, eventType, eventId) {
            return api.get('/api/' + api.property() + '/' + availabilityApiService.switchEventType(eventType) + '/' + eventId + '/start-times?date=' + date).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _orderCreate = __webpack_require__(972);

var _orderCreate2 = _interopRequireDefault(_orderCreate);

var _orderCreateTabs = __webpack_require__(974);

var _orderCreateTabs2 = _interopRequireDefault(_orderCreateTabs);

var _orderCreate3 = __webpack_require__(976);

var _orderCreate4 = _interopRequireDefault(_orderCreate3);

var _orderCreateTabs3 = __webpack_require__(977);

var _orderCreateTabs4 = _interopRequireDefault(_orderCreateTabs3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderCreationModule = angular.module('spabooker.order.create', ['spabooker.base']).component('orderCreate', _orderCreate2.default).component('orderCreateTabs', _orderCreateTabs2.default).controller('orderCreateController', _orderCreate4.default).controller('orderCreateTabsController', _orderCreateTabs4.default).run(['configService', 'paymentGatewayService', function (configService, paymentGatewayService) {
    var config = configService.get('gateways');

    if (paymentGatewayService && config) {
        paymentGatewayService.load(config);
    }
}]);

exports.default = orderCreationModule.name;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'orderCreateController',
    template: __webpack_require__(973)
};

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() on-success=$ctrl.onSuccess() on-error=$ctrl.onError() form=$ctrl.form saving=$ctrl.saving class=\"c-form c-order-create\"> <header> <h2 class=text-center>Create an Order</h2> </header> <main class=\"row / c-quick\"> <nav class=\"columns medium-4 large-3 / c-order-create__nav\"> <order-create-tabs order=$ctrl.order loading=$ctrl.loading></order-create-tabs> <div ng-if=$ctrl.basket.contents.expires_at> Basket valid until: <br> {{ $ctrl.basketValidUntil() }} </div> </nav> <div class=\"columns medium-8 large-9 / c-order-create__main\"> <section ng-if=$ctrl.displayPayment()> <div class=section-anchor id=payment></div> <hr> <div class=c-accordion ng-class=\"{ 'c-accordion--active': !this.hidePayment }\"> <div class=c-accordion__handle ng-click=\"this.hidePayment = !this.hidePayment\"> <h3>Payment Details</h3> </div> <div class=c-accordion__content> <div> Payment form here </div> </div> </div> </section> <section ng-if=$ctrl.displayPayment()> <div class=section-anchor id=review></div> <hr> <div class=c-accordion ng-class=\"{ 'c-accordion--active': !showReview }\"> <div class=c-accordion__handle ng-click=\"showReview = !showReview\"> <h3>Review</h3> </div> <div class=c-accordion__content> <basket-items loading=$ctrl.loading no-delete=true></basket-items> </div> </div> </section> <section ng-if=$ctrl.displayFinalActions()> <div class=section-anchor id=final-actions></div> <hr> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\">Create Order</button> <button class=\"button button--hollow round\" type=button ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\">Save for later</button> </section> </div> </main> <form-buttons> </form-buttons> </api-form> ";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        item: '<',
        loading: '<',
        guests: '<'
    },
    controller: 'orderCreateTabsController',
    template: __webpack_require__(975)
};

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "<ul class=c-side-tabs> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('select-item')\">Select Item</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('select-item')\" ng-if=\"$ctrl.canShow('select-item')\">Select Item</a> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('guests')\">Add & Customise Guests</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('guests')\" ng-if=\"$ctrl.canShow('guests')\">Add & Customise Guests</a> <ul ng-if=\"$ctrl.canShow('guests') && $ctrl.guests\"> <li ng-repeat=\"guest in $ctrl.guests track by $index\"> <a ng-click=\"$ctrl.scrollTo('guest-' + $index)\">{{ $ctrl.guestnameService.format(guest) || 'New Guest' }}</a> </li> </ul> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('suggestions')\">Suggestions</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('suggestions')\" ng-if=\"$ctrl.canShow('suggestions')\">Suggestions</a> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('payment')\">Payment</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('payment')\" ng-if=\"$ctrl.canShow('payment')\">Payment</a> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('review')\">Review</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('review')\" ng-if=\"$ctrl.canShow('review')\">Review</a> </li> <li class=c-side-tabs__tab> <span class=c-side-tabs__tab--disabled ng-if=\"!$ctrl.canShow('actions')\">Final Actions</span> <a class=c-side-tabs__tab--enabled ng-click=\"$ctrl.scrollTo('actions')\" ng-if=\"$ctrl.canShow('actions')\">Final Actions</a> </li> </ul> ";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderCreateController = function () {
    function OrderCreateController($window, $state, basket, messageService, propertyService, ordersApiService) {
        _classCallCheck(this, OrderCreateController);

        this.$window = $window;
        this.$state = $state;
        this.basket = basket;
        this.messageService = messageService;
        this.propertyService = propertyService;
        this.ordersApiService = ordersApiService;
    }

    _createClass(OrderCreateController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = ['basket', 'order'];

            return this.getBasket();
        }
    }, {
        key: 'getBasket',
        value: function getBasket() {
            var _this = this;

            return this.basket.get().then(function (response) {
                if (!_this.basket.isEmpty()) {
                    _this.stopLoading('basket');
                    return _this.generateOrder();
                }

                return _this.$state.go('app.admin.basket-create');
            });
        }
    }, {
        key: 'generateOrder',
        value: function generateOrder() {
            // return this.ordersApiService.generateOrder(this.basket.contents.identity_code)
            //     .then(response => {
            //         this.order = response;
            //     })
            //     .catch(error => {
            //         this.displayError(error);
            //     })
            //     .then(() => {
            //         this.stopLoading('order');
            //     });
        }
    }, {
        key: 'displayError',
        value: function displayError(error) {
            this.messageService.failure(error);
            this.messageService.push();
            this.messageService.autoClear();
        }
    }, {
        key: 'stopLoading',
        value: function stopLoading(param) {
            var index = this.loading.indexOf(param);
            if (index > -1) {
                this.loading.splice(index, 1);
            }
        }
    }, {
        key: 'isLoading',
        value: function isLoading(param) {
            if (param) {
                return this.loading.indexOf(param) > -1;
            }

            return this.loading.length > 0;
        }
    }, {
        key: 'displayPayment',
        value: function displayPayment() {
            return !!(this.basket && this.basket.contents && this.basket.contents.guest_details && this.basket.contents.guest_details.find(function (guest) {
                return guest.id && guest.item_details.length > 0;
            }));
        }
    }, {
        key: 'basketValidUntil',
        value: function basketValidUntil() {
            if (this.basket.contents.expires_at) {
                return (0, _moment2.default)(this.basket.contents.expires_at + '+00:00').format('LLLL');
            }
        }
    }, {
        key: 'displayFinalActions',
        value: function displayFinalActions() {}
    }, {
        key: 'onSave',
        value: function onSave() {}
    }, {
        key: 'onSuccess',
        value: function onSuccess() {}
    }, {
        key: 'onError',
        value: function onError() {}
    }]);

    return OrderCreateController;
}();

OrderCreateController.$inject = ['$window', '$state', 'basket', 'messageService', 'propertyService', 'ordersApiService'];

exports.default = OrderCreateController;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderCreateTabsController = function () {
    function OrderCreateTabsController($window, basket, guestnameService, itemService, loadingService) {
        _classCallCheck(this, OrderCreateTabsController);

        this.$window = $window;
        this.basket = basket;
        this.guestnameService = guestnameService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    _createClass(OrderCreateTabsController, [{
        key: 'canShow',
        value: function canShow(param) {
            var basketHasGuests = !!(this.basket && this.basket.contents && this.basket.contents.guest_details && this.basket.contents.guest_details.length > 0);

            switch (param) {
                case 'select-item':
                    return !this.loadingService.isLoading('events');
                case 'guests':
                    return !!(this.itemService.hasItem() && this.itemService.getItem().quantity !== undefined);
                    break;
                case 'suggestions':
                    return !!(this.basket && this.basket.contents && this.basket.contents.has_suggestions);
                case 'review':
                    return basketHasGuests;
                case 'payment':
                    return !!this.order;
                case 'next-actions':
                    return !!(basketHasGuests && (!this.guests || this.guests && this.guests.length === 0));
                case 'final-actions':
                    return !!(basketHasGuests && this.order && this.order.payment_details.length > 0);
            }

            return false;
        }
    }, {
        key: 'scrollTo',
        value: function scrollTo(param) {
            var element = this.$window.document.getElementById(param);

            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }]);

    return OrderCreateTabsController;
}();

OrderCreateTabsController.$inject = ['$window', 'basket', 'guestnameService', 'itemService', 'loadingService'];

exports.default = OrderCreateTabsController;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _guests = __webpack_require__(979);

var _guests2 = _interopRequireDefault(_guests);

var _arrivalDashboard = __webpack_require__(980);

var _arrivalDashboard2 = _interopRequireDefault(_arrivalDashboard);

var _arrivalList = __webpack_require__(982);

var _arrivalList2 = _interopRequireDefault(_arrivalList);

var _arrivalDashboard3 = __webpack_require__(984);

var _arrivalDashboard4 = _interopRequireDefault(_arrivalDashboard3);

var _arrivalList3 = __webpack_require__(985);

var _arrivalList4 = _interopRequireDefault(_arrivalList3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var guestsModule = angular.module('spabooker.guests', ['spabooker.base']).config(_guests2.default).controller('arrivalDashboardController', _arrivalDashboard4.default).controller('arrivalListController', _arrivalList4.default).component('arrivalDashboard', _arrivalDashboard2.default).component('arrivalList', _arrivalList2.default);

exports.default = guestsModule.name;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.arrivals', {
        url: '/arrivals',
        component: 'arrivalDashboard',
        roles: ['manager']
    });
}];

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {},
    controller: 'arrivalDashboardController',
    template: __webpack_require__(981)
};

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "<message></message> <div class=\"c-dashboard--arrivals c-arrivals\"> <header class=c-page-head> <div class=c-dashboard__welcome> <h2>Guest Arrivals</h2> </div> </header> <main> <div class=row> <div class=\"small-12 columns\"> <arrival-list arrivals=$ctrl.today date=today></arrival-list> <arrival-list arrivals=$ctrl.tomorrow date=tomorrow></arrival-list> </div> </div> </main> </div> ";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        arrivals: '<',
        loading: '<',
        date: '@'
    },
    controller: 'arrivalListController',
    template: __webpack_require__(983)
};

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = "<div class=c-arrivals__list> <h3>{{ $ctrl.displayDate }}</h3> <spinner ng-if=$ctrl.isLoading()></spinner> <div ng-if=!$ctrl.isLoading()> <div ng-if=\"$ctrl.arrivals.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text>There are no arrivals {{ $ctrl.date }}.</p> </div> </div> <table ng-if=\"$ctrl.arrivals.length > 0\"> <thead> <tr> <td>Arrival Time</td> <td>Event Name</td> <td>Guest Name</td> <td>Order</td> </tr> </thead> <tbody> <tr ng-repeat=\"arrival in $ctrl.arrivals\" class=c-list> <td>{{ $ctrl.displayTime(arrival.time) }}</td> <td>{{ arrival.event }}</td> <td>{{ arrival.guest }}</td> <td><a ui-sref=\"app.admin.order-edit({ order: arrival.order_id })\">{{ arrival.order_reference }}</a></td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArrivalDashboardController = function () {
    function ArrivalDashboardController(dataApiService, loadingService) {
        _classCallCheck(this, ArrivalDashboardController);

        this.dataApiService = dataApiService;
        this.loadingService = loadingService;
    }

    _createClass(ArrivalDashboardController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loadingService.startLoading(['today', 'tomorrow']);

            return this.getArrivals();
        }
    }, {
        key: 'getArrivals',
        value: function getArrivals() {
            var _this = this;

            return Promise.all([this.getData('today').then(function (response) {
                _this.loadingService.stopLoading('today');
                _this.today = response;
            }), this.getData('tomorrow').then(function (response) {
                _this.loadingService.stopLoading('tomorrow');
                _this.tomorrow = response;
            })]);
        }
    }, {
        key: 'getData',
        value: function getData(scope) {
            var date = (0, _moment2.default)();

            if (scope === 'tomorrow') {
                date = date.add(1, 'day');
            }

            return this.dataApiService.getData('arrivals', date.format('YYYY-MM-DD'));
        }
    }]);

    return ArrivalDashboardController;
}();

ArrivalDashboardController.$inject = ['dataApiService', 'loadingService'];

exports.default = ArrivalDashboardController;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArrivalListController = function () {
    function ArrivalListController(time, loadingService) {
        _classCallCheck(this, ArrivalListController);

        this.time = time;
        this.loadingService = loadingService;
    }

    _createClass(ArrivalListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.momentDate = (0, _moment2.default)();

            if (this.date === 'tomorrow') {
                this.momentDate.add(1, 'day');
            }

            this.displayDate = '' + this.date[0].toUpperCase() + this.date.substr(1) + ': ' + this.momentDate.format('dddd LL');
        }
    }, {
        key: 'displayTime',
        value: function displayTime(time) {
            return _moment2.default.utc(this.momentDate.format('YYYY-MM-DD') + ' ' + time).format('h:mm A');
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            return this.loadingService.isLoading(this.date);
        }
    }]);

    return ArrivalListController;
}();

ArrivalListController.$inject = ['time', 'loadingService'];

exports.default = ArrivalListController;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _checkout = __webpack_require__(987);

var _checkout2 = _interopRequireDefault(_checkout);

var _suggestionsApi = __webpack_require__(988);

var _suggestionsApi2 = _interopRequireDefault(_suggestionsApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkoutModule = angular.module('spabooker.admin.checkout', ['spabooker.basket', 'spabooker.shared.checkout']).factory('checkout', _checkout2.default).factory('suggestionsApiService', _suggestionsApi2.default);

exports.default = checkoutModule.name;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [function () {
    return {};
}];

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        find: function find(basketCode) {
            return api.get('/api/' + api.property() + '/basket/suggestions/' + basketCode).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _activity = __webpack_require__(990);

var _activity2 = _interopRequireDefault(_activity);

var _activitySave = __webpack_require__(992);

var _activitySave2 = _interopRequireDefault(_activitySave);

var _activityForm = __webpack_require__(993);

var _activityForm2 = _interopRequireDefault(_activityForm);

var _activityList = __webpack_require__(994);

var _activityList2 = _interopRequireDefault(_activityList);

var _activityList3 = __webpack_require__(995);

var _activityList4 = _interopRequireDefault(_activityList3);

var _activityForm3 = __webpack_require__(997);

var _activityForm4 = _interopRequireDefault(_activityForm3);

var _activitySave3 = __webpack_require__(999);

var _activitySave4 = _interopRequireDefault(_activitySave3);

var _activities = __webpack_require__(1001);

var _activities2 = _interopRequireDefault(_activities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activityModule = angular.module('spabooker.activity', ['spabooker.base']).config(_activity2.default).controller('activitySaveController', _activitySave2.default).controller('activityFormController', _activityForm2.default).controller('activityListController', _activityList2.default).component('activityList', _activityList4.default).component('activityForm', _activityForm4.default).component('activitySave', _activitySave4.default).factory('activitiesService', _activities2.default);

exports.default = activityModule.name;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _activities = __webpack_require__(991);

var _categories = __webpack_require__(22);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.classes', {
        url: '/events/classes?:filtertext',
        component: 'activityList',
        resolve: {
            activities: (0, _activities.resolveActivities)(),
            categories: (0, _categories.resolveNestedCategories)('flatten')
        },
        roles: ['manager']
    }).state('app.admin.deletedclasses', {
        url: '/events/classes/deleted',
        component: 'activityList',
        resolve: {
            activities: (0, _activities.resolveActivities)(1, 20, 'deleted')
        },
        roles: ['admin']
    }).state('app.admin.class-edit', {
        url: '/events/classes/:activity/update?tab',
        component: 'activitySave',
        resolve: {
            title: function title() {
                return 'Update a Class';
            },
            activity: (0, _activities.resolveActivity)()
        },
        roles: ['manager']
    });
}];

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var resolveActivities = exports.resolveActivities = function resolveActivities() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    return ['$stateParams', 'activitiesService', function ($stateParams, activitiesService) {
        if (!$stateParams.filtertext) {
            return activitiesService.findAll(page, perpage, deleted).then(function (list) {
                return list;
            });
        }

        return activitiesService.search('name', $stateParams.filtertext, page).then(function (list) {
            return list;
        });
    }];
};

var resolveActivity = exports.resolveActivity = function resolveActivity() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'activity';

    return ['$stateParams', 'activitiesService', function ($stateParams, activitiesService) {
        return $stateParams[param] && $stateParams[param] > 0 ? activitiesService.findById($stateParams[param]) : {};
    }];
};

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActivitySaveController = function () {
    function ActivitySaveController($stateParams, access) {
        _classCallCheck(this, ActivitySaveController);

        this.$stateParams = $stateParams;
        this.access = access;
    }

    _createClass(ActivitySaveController, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeTab = this.$stateParams.tab || 'activity';
        }
    }, {
        key: 'canShow',
        value: function canShow() {
            return this.access.check('manager') && !!this.activity.id;
        }
    }]);

    return ActivitySaveController;
}();

ActivitySaveController.$inject = ['$stateParams', 'access'];

exports.default = ActivitySaveController;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActivityFormController = function () {
  function ActivityFormController(currentPropertyService, $scope, $state, activitiesService, integrationApiService, messageService, markdownService, access) {
    _classCallCheck(this, ActivityFormController);

    this.currentProperty = currentPropertyService;
    this.$scope = $scope;
    this.$state = $state;
    this.activitiesService = activitiesService;
    this.integrationApiService = integrationApiService;
    this.messageService = messageService;
    this.marked = markdownService;
    this.access = access;
  }

  _createClass(ActivityFormController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.property = this.currentProperty.get();
      this.isAdmin = this.access.check('admin');

      this.activity = this.activity || {
        description: ''
      };

      this.activity.selectedcategories = this.activity.categories || [];
      this.activity.property_id = this.activity.property_id || this.property.id;
      this.currencySymbol = this.property.currency_symbol;
      this.activity.event_status_id = this.activity.event_status_id ? this.activity.event_status_id.toString() : '0';
      this.hasIntegration = !!this.property.integration;

      if (this.hasIntegration) {
        return this.integrationApiService.integrationActivityCollect(this.property.id).then(function (response) {
          _this.importedActivities = response.map(function (activity) {
            if (activity.integration_location) {
              activity.name = activity.name + ' @ ' + activity.integration_location_name;
            }
            return activity;
          });
        });
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var _this2 = this;

      if (!(0, _lodash.find)(this.activity.selectedcategories, { id: this.activity.primary_category })) {
        this.messageService.failure('You must select at least 1 category and set a primary category to continue');
        this.messageService.push();
        this.saving = undefined;
        return Promise.reject({});
      }

      this.messageService.reset();

      this.activity.categories = (0, _lodash.map)(this.activity.selectedcategories, 'id');

      var tempCats = this.activity.selectedcategories;
      var tempPrimaryCat = this.activity.primary_category;
      delete this.activity.selectedcategories;

      delete this.activity.upgrades;
      delete this.activity.days;

      return this.activitiesService.save(this.activity).then(function (response) {
        if (_this2.activity.id) {
          _this2.messageService.success('The class <strong>' + _this2.activity.name + '</strong> was successfully updated!', ['app.admin.class-edit({ \'activity\' : ' + _this2.activity.id + '})']);
          _this2.$state.go('app.admin.classes');
          return;
        }

        _this2.activity.selectedcategories = tempCats;
        _this2.activity.primary_category = tempPrimaryCat;
        _this2.messageService.success('The class <strong>' + _this2.activity.name + '</strong> was successfully created.');
        _this2.$state.go('app.admin.class-edit', { activity: response.id });
        return;
      }).catch(function (error) {
        error.data = error.data && error.data.original || error.data;
        _this2.form.$api.setErrors(error.data);

        _this2.activity.selectedcategories = tempCats;
        _this2.activity.primary_category = tempPrimaryCat;

        var sourceElement = Object.keys(error.data);
        var verb = 'created';
        if (_this2.activity.id) {
          verb = 'updated';
        }

        if (sourceElement.length > 0) {
          var errors = '';
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = sourceElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var element = _step.value;

              errors += '<li>' + _this2.messageService.formatError(element, error.data[element]) + '</li>';
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this2.messageService.failure('The class <strong>' + _this2.activity.name + '</strong> could not be successfully ' + verb + ': <ul>' + errors + '</ul>');
        } else {
          _this2.messageService.failure('The class <strong>' + _this2.activity.name + '</strong> could not be successfully ' + verb + ': ' + error.statusText);
        }
        _this2.messageService.push();
      });
    }
  }, {
    key: 'initialSlug',
    value: function initialSlug() {
      if (!this.activity.id && this.$scope.$ctrl.form.slug.$untouched) {
        this.activity.slug = this.activity.name ? this.activity.name.replace(/[^a-zA-Z\d\s]+/g, '').replace(/[ ]+/g, '-').replace(/--+/g, '-').toLowerCase() : '';
      }
    }
  }]);

  return ActivityFormController;
}();

ActivityFormController.$inject = ['currentPropertyService', '$scope', '$state', 'activitiesService', 'integrationApiService', 'messageService', 'markdownService', 'access'];

exports.default = ActivityFormController;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActivityListController = function () {
    function ActivityListController($stateParams, $scope, $timeout, activitiesService, messageService, access) {
        _classCallCheck(this, ActivityListController);

        this.$scope = $scope;
        this.activitiesService = activitiesService;
        this.messageService = messageService;
        this.access = access;
        this.$stateParams = $stateParams;
    }

    _createClass(ActivityListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.filtertext = this.$stateParams.filtertext || null;
            if (this.filtertext) {
                this.isFiltered = true;
            }

            this.updatePaging();

            this.watchCurrentPage();
        }
    }, {
        key: 'updatePaging',
        value: function updatePaging() {
            this.$scope.per_page = this.activities.per_page;
            this.$scope.current_page = this.activities.current_page;
            this.$scope.total = this.activities.total;
        }
    }, {
        key: 'watchCurrentPage',
        value: function watchCurrentPage() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.$scope.current_page;
            }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (_this.filtertext && _this.filtertype && _this.isFiltered) {
                        _this.activities = undefined;
                        _this.loading = true;
                        return _this.activitiesService.search(_this.filtertype, _this.filtertext, newVal).then(function (response) {
                            _this.activities = response;
                            _this.loading = false;
                        });
                    } else {
                        _this.activitiesService.findAll(newVal, _this.$scope.per_page).then(function (list) {
                            return _this.activities = list;
                        });
                    }
                }
            });
        }
    }, {
        key: 'onDelete',
        value: function onDelete(activity) {
            var _this2 = this;

            return this.activitiesService.delete(activity.id).then(function () {
                _this2.messageService.success('The activity <strong>' + activity.name + '</strong> was successfully deleted.');
                _this2.messageService.push();
            }).catch(function (error) {
                _this2.messageService.failure('The activity <strong>' + activity.name + '</strong> could not be successfully deleted: ' + error.statusText);
                _this2.messageService.push();
            }).then(function () {
                var page = _this2.activities.current_page;
                _this2.activities = [];
                _this2.loading = true;
                return _this2.activitiesService.findAll(page).then(function (response) {
                    _this2.activities = response;
                    _this2.loading = false;
                });
            });
        }
    }, {
        key: 'toggleActive',
        value: function toggleActive(activity) {
            var _this3 = this;

            this.activitiesService.toggleActive(activity.id).catch(function (error) {
                _this3.messageService.failure('The activity <strong>' + activity.name + '</strong> could not be successfully toggled (active): ' + error.statusText);
                _this3.messageService.push();
            }).then(function () {
                return activity.status = !activity.status;
            });
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this4 = this;

            if (!this.loading && this.filtertext) {
                this.startFilter();
                this.activitiesService.search(this.filtertype, this.filtertext).then(function (response) {
                    _this4.isFiltered = true;
                    _this4.endFilter(response);
                });
            }
        }
    }, {
        key: 'clearfilter',
        value: function clearfilter() {
            var _this5 = this;

            if (this.isFiltered) {
                this.startFilter();
                this.activitiesService.findAll(1, 20).then(function (response) {
                    _this5.isFiltered = false;
                    _this5.endFilter(response);
                });
            }
        }
    }, {
        key: 'filtertypeChange',
        value: function filtertypeChange() {
            switch (this.filtertype) {
                case 'cat':
                    this.filtertext = this.categories.flat[0].id;
                    break;
                case 'status':
                    this.filtertext = '1';
                    break;
                default:
                    this.filtertext = '';
                    break;
            }
        }
    }, {
        key: 'startFilter',
        value: function startFilter() {
            this.activities = undefined;
            this.loading = true;
        }
    }, {
        key: 'endFilter',
        value: function endFilter(response) {
            this.activities = response;
            this.updatePaging();
            this.loading = false;
        }
    }, {
        key: 'updatePriority',
        value: function updatePriority(oldPriority, event) {
            if (!event || !event.priority || oldPriority === 'loading') {
                return false;
            }
            this.updateWait(event);
        }
    }, {
        key: 'updateWait',
        value: function updateWait(item) {
            var _this6 = this;

            if (item.priority.match(/[^0-9]+/g)) return;
            item.updating = false;
            clearTimeout(item.trigger);
            item.trigger = setTimeout(function () {
                _this6.trigger(item);
            }, 1000);
        }
    }, {
        key: 'update',
        value: function update(item) {
            this.trigger(item);
        }
    }, {
        key: 'trigger',
        value: function trigger(item) {
            item.trigger = undefined;
            item.updating = true;

            this.activitiesService.updatePriority(item).then(function () {
                item.updating = false;
            });
        }
    }]);

    return ActivityListController;
}();

ActivityListController.$inject = ['$stateParams', '$scope', '$timeout', 'activitiesService', 'messageService', 'access'];

exports.default = ActivityListController;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        activities: '<',
        categories: '<'
    },
    controller: 'activityListController',
    template: __webpack_require__(996)
};

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports = "<header class=c-page-head> <h1>Classes</h1> </header> <main class=s-main> <ul class=\"c-super-actions c-super-actions--delete-switch\" ng-if=\"$ctrl.access.check('admin')\"> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.classes class=c-super-actions__icon tooltip=\"Show non-deleted items\" tooltip-placement=bottom> <icon icon=files></icon> </a> </li> <li ui-sref-active=active class=c-super-actions__list-item> <a ui-sref=app.admin.deletedclasses class=c-super-actions__icon tooltip=\"Show deleted items\" tooltip-placement=bottom> <icon icon=bin></icon> </a> </li> </ul> <message closable=true></message> <div class=c-tabs> <div class=c-tabs__content> <div class=row> <div class=\"columns c-list__tab-inner\"> <form class=\"row c-list__search c-list__search--tab c-list__search--user\"> <div class=\"columns medium-4\"> <select ng-model=$ctrl.filtertype ng-init=\"$ctrl.filtertype = $ctrl.filtertype || 'name'\" ng-change=$ctrl.filtertypeChange()> <option value=cat>Categories</option> <option value=name>Name</option> <option value=status>Status</option> </select> </div> <div class=\"columns medium-5\"> <div class=c-list__search__fields> <input class=c-list__search__input type=text ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'name'\" placeholder=\"Filter by {{ $ctrl.filtertype }}...\"/> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'cat'\" ng-options=\"category.id as category.name for category in $ctrl.categories.flat\"> </select> <select ng-model=$ctrl.filtertext ng-if=\"$ctrl.filtertype === 'status'\"> <option value=1>Active</option> <option value=0>Inactive</option> </select> <spinner ng-if=$ctrl.loading /> </div> </div> <div class=\"columns medium-3\"> <div class=row> <div class=\"columns large-8\"> <button class=\"c-list__search__button button round\" ng-click=$ctrl.filter()>Search</button> </div> <div class=\"columns large-4\"> <span class=\"c-list__search__button secondary\" ng-click=$ctrl.clearfilter()>Clear</span> </div> </div> </div> </form> <div class=row> <div class=\"small-12 columns\"> <div ng-if=\"$ctrl.activities.data.length === 0\" class=\"c-empty c-empty--alone\"> <div class=c-empty__content> <icon icon=cross></icon> <p class=c-empty__text ng-if=!$ctrl.isFiltered>No classes have been created yet.</p> <div class=c-empty__filter ng-if=$ctrl.isFiltered> <p class=c-empty__text>No classes match that filter.</p> <button class=\"button round\" ng-click=$ctrl.clearfilter()>Clear filter</button> </div> </div> </div> <table ng-if=\"$ctrl.activities.data.length > 0\"> <thead> <tr> <th class=c-table__lights></th> <th>Name</th> <th class=c-table__cats>Priority</th> <th class=c-table__cats>Category</th> <th ng-if=\"$ctrl.access.check('manager')\"></th> <th ng-if=\"$ctrl.access.check('manager')\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"activity in $ctrl.activities.data\" class=\"c-list {{ activity.deleted_at ? 'c-list__deleted' : ''}}\"> <td class=c-table__lights ng-click=\"$ctrl.access.check('manager') && $ctrl.toggleActive(activity)\"> <span ng-class=\"(activity.status)? 'c-trafficlight--green' : ''\" class=c-trafficlight tooltip=\"{{ (activity.status)? 'This activity is active' : 'This activity is not active' }}\"></span> </td> <td>{{ activity.name }}</td> <td class=c-table__inline-input> <span tooltip=\"The priority of this event will be updated automatically when changed\"> <input ng-model=activity.priority type=text maxlength=3 ng-disabled=activity.updating ng-change=\"$ctrl.updatePriority('{{activity.priority || 'loading'}}', activity)\"> </span> <spinner tiny=true ng-if=activity.updating /> </td> <td class=c-table__cats><span tooltip=\"{{ (activity.category_names.length) ? activity.category_names.join(', ') : null }}\">{{ activity.primary_category_name || 'No Primary' }}</span></td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ui-sref=\"app.admin.class-edit({ activity: activity.id })\">Edit</a> </td> <td class=c-list__action ng-if=\"$ctrl.access.check('manager')\"> <a ng-click=$ctrl.onDelete(activity) confirm=\"Are you sure you want to delete {{ activity.name }}?\">Delete</a> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <pagination total-items=total page=current_page max-size=9 class=pagination rotate=false num-pages=num_pages items-per-page=per_page></pagination> </div> </main> ";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        activity: '=',
        formTab: '=',
        activeDay: '&'
    },
    controller: 'activityFormController',
    template: __webpack_require__(998)
};

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "<message closable=true></message> <api-form on-save=$ctrl.onSave() form=$ctrl.form saving=$ctrl.saving class=c-form> <div class=c-form__field> <input name=name class=\"c-input--large / c-form__input\" type=text ng-model=$ctrl.activity.name form-field-errors required ng-change=$ctrl.initialSlug()> <label class=c-form__label for=name>Name</label> </div> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--textarea\"> <textarea name=description_in class=\"marked-input / c-form__textarea\" type=text ng-model=$ctrl.activity.description form-field-errors></textarea> <label class=c-form__label for=description_in>Description</label> </div> </div> <div class=\"column medium-6\"> <div ng-if=$ctrl.activity.description name=description_out class=\"marked-output / c-form__textarea-marked\" ng-bind-html=$ctrl.marked.translate($ctrl.activity.description)></div> </div> </div> <div class=row> <div class=\"column medium-6\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=base_price ng-model=$ctrl.activity.base_price form-field-errors></money-input> <label class=c-form__label for=base_price>Price (base)</label> </div> </div> <div class=\"column medium-6\"> <div class=c-form__field> <input name=maximum_pre_book type=number class=c-form__input ng-model=$ctrl.activity.maximum_pre_book form-field-errors min=1> <label class=c-form__label for=maximum_pre_book>Advanced Booking Limitation (Days)</label> <i class=\"c-icon c-icon--help\" tooltip=\"The event can only be booked, at most, this many days prior to the date on which it occurs\" tooltip-placement=left>?</i> </div> </div> <div class=\"column medium-8\"> <label for=categories class=c-label>Categories</label> <categories-select name=categories value=$ctrl.activity.selectedcategories></categories-select> </div> <div class=\"column medium-4\"> <div class=c-form__field> <label for=primary_category class=c-label>Primary Category</label> <select ng-model=$ctrl.activity.primary_category ng-options=\"category.id as category.name for category in $ctrl.activity.selectedcategories\" required parent-select class=c-form__select> <option value=\"\" disabled=disabled>Please select a category...</option> </select> </div> </div> </div> <div class=row> <div class=\"columns medium-4\"> <label for=special_status class=c-label>Special Status</label> <label class=c-label for=special_status> <select name=special_status ng-init=\"$ctrl.activity.event_status_id = $ctrl.activity.event_status_id.toString() || ''\" ng-model=$ctrl.activity.event_status_id> <option value=0> None </option> <option value=1> Phone booking only </option> <option value=2> Online only </option> </select> </label> </div> <div class=\"columns medium-4\"> <label for=gender class=c-label>Guest Gender</label> <label class=c-label for=gender> <select name=gender ng-model=$ctrl.activity.gender> <option value=\"\"> Any </option> <option value=M> Male only </option> <option value=F> Female only </option> </select> </label> </div> <div class=\"columns medium-4\"> <span class=\"c-form__clear c-form__clear--right\" tooltip=\"Clear integration link\" tooltip-placement=left ng-click=\"$ctrl.activity.integration_identity = null\" ng-if=\"$ctrl.hasIntegration && $ctrl.isAdmin\">&times;</span> <label for=integration class=c-label>Integration Event</label> <ui-select ng-model=$ctrl.activity.integration_identity name=integration form-field-errors ng-disabled=\"!$ctrl.hasIntegration || ($ctrl.hasIntegration && !$ctrl.isAdmin)\"> <ui-select-match placeholder=\"Integration ID\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.integration_identity.toString() as item in $ctrl.importedActivities | filter: {name: $select.search} track by item.integration_identity+item.name\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select> </div> </div> <hr> <label for=status class=c-label>Enabled Status</label> <p class=c-description>If enabled, this activity will be active and accessible on the website. If the toggle is not enabled this activity will not be accessible to the public at all.</p> <switch id=status name=status ng-model=$ctrl.activity.status class=green></switch> <form-buttons> <button class=\"button round\" type=submit ng-disabled=\"$ctrl.saving || $ctrl.form.$invalid\"> Save Activity <spinner ng-if=$ctrl.saving /> </button> </form-buttons> </api-form> ";

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        activity: '=',
        title: '@'
    },
    controller: 'activitySaveController',
    template: __webpack_require__(1000)
};

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help-area> <button class=c-help-area__button ng-click=\"$ctrl.help = !$ctrl.help;\"> <span class=c-help-area__button-icon>?</span> Help </button> <div class=\"c-help-area__content {{$ctrl.help ? 'open': ''}}\"> <help-area helptype=markdown></help-area> </div> </div> <header class=c-page-head> <h1>{{ $ctrl.title }}</h1> <p ng-if=$ctrl.activity.id>{{ $ctrl.activity.name }}</p> </header> <main> <div class=c-tabs> <div class=c-tabs__content> <div class=row ng-show=\"$ctrl.activeTab === 'activity'\" ng-if=\"$ctrl.access.check('manager')\"> <div class=\"small-12 columns\"> <activity-form activity=$ctrl.activity form-tab=$ctrl.activeTab> </activity-form></div> </div> </div> </div> </main> ";

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = function endpoint(property) {
    return '/api/' + property + '/events/activities';
};

exports.default = ['api', function (api) {
    return {
        save: function save(activity) {
            var url = activity.id ? endpoint(api.property()) + '/' + activity.id : endpoint(api.property());

            return api.upload(url, activity).then(function (response) {
                return response.data;
            });
        },
        delete: function _delete(id) {
            return api.delete(endpoint(api.property()) + '/' + id);
        },
        findAll: function findAll() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var perpage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var deleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            return api.get(endpoint(api.property()) + (page ? '?page=' + page + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).then(function (response) {
                return response.data;
            });
        },
        findById: function findById(id) {
            return api.get(endpoint(api.property()) + '/' + id).then(function (response) {
                return response.data;
            });
        },
        toggleActive: function toggleActive(id) {
            return api.get(endpoint(api.property()) + '/status/' + id).then(function (response) {
                return response.data;
            });
        },
        search: function search(type, text) {
            var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return api.get(endpoint(api.property()) + '?type=' + type + '&text=' + text + (page ? '&page=' + page : '')).then(function (response) {
                return response.data;
            });
        },
        updatePriority: function updatePriority(activity) {
            return api.post(endpoint(api.property()) + '/' + activity.id + '/priority?priority=' + activity.priority);
        }
    };
}];

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vendor = __webpack_require__(1003);

var _authStorage = __webpack_require__(1042);

var _authStorage2 = _interopRequireDefault(_authStorage);

var _auth = __webpack_require__(1043);

var _auth2 = _interopRequireDefault(_auth);

var _auth3 = __webpack_require__(1044);

var _auth4 = _interopRequireDefault(_auth3);

var _authTransitions = __webpack_require__(1045);

var _authTransitions2 = _interopRequireDefault(_authTransitions);

var _auth0ClientFactory = __webpack_require__(1046);

var _auth0ClientFactory2 = _interopRequireDefault(_auth0ClientFactory);

var _auth5 = __webpack_require__(1047);

var _auth6 = _interopRequireDefault(_auth5);

var _tokenHandler = __webpack_require__(1048);

var _tokenHandler2 = _interopRequireDefault(_tokenHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var authModule = angular.module('journey-ui.auth', [].concat(_toConsumableArray(_vendor.vendor))).factory('authStorageService', _authStorage2.default).factory('authService', _auth2.default).factory('authInterceptor', _auth4.default).factory('authTransitionsService', _authTransitions2.default).factory('auth0ClientFactory', _auth0ClientFactory2.default).factory('auth0Service', _auth6.default).factory('tokenHandlerService', _tokenHandler2.default).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('authInterceptor');
}]).run(['authTransitionsService', function (authTransitionsService) {
  authTransitionsService.init();
}]);

exports.default = authModule.name;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendor = undefined;

__webpack_require__(324);

__webpack_require__(1004);

var vendor = exports.vendor = ['ui.router', 'journey-ui.shared.core', 'journey-ui.shared.error'];

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _error = __webpack_require__(1005);

var _error2 = _interopRequireDefault(_error);

var _exceptionHandler = __webpack_require__(1006);

var _exceptionHandler2 = _interopRequireDefault(_exceptionHandler);

var _errorMessages = __webpack_require__(1038);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _httpError = __webpack_require__(1040);

var _httpError2 = _interopRequireDefault(_httpError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorModule = angular.module('journey-ui.shared.error', []).config(_error2.default).config(_exceptionHandler2.default).component('errorMessages', _errorMessages2.default).component('httpError', _httpError2.default);

exports.default = errorModule.name;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('404', {
    url: '',
    component: 'httpError',
    auth: false,
    resolve: {
      statusCode: function statusCode() {
        return 404;
      },
      error: function error() {
        return 'Not found';
      }
    }
  }).state('403', {
    url: '',
    component: 'httpError',
    auth: false,
    resolve: {
      statusCode: function statusCode() {
        return 403;
      },
      error: function error() {
        return 'Forbidden';
      }
    }
  }).state('401', {
    url: '',
    component: 'httpError',
    resolve: {
      statusCode: function statusCode() {
        return 401;
      },
      error: function error() {
        return 'Unauthorized';
      }
    }
  }).state('500', {
    url: '',
    component: 'httpError',
    auth: false,
    resolve: {
      statusCode: function statusCode() {
        return 500;
      },
      error: function error() {
        return 'Internal error';
      }
    }
  });
}];

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1007);

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = ['$provide', function ($provide) {
  var errorDelegation = function errorDelegation($delegate) {
    /* global SENTRY_DSN */
    var sentryDsn = SENTRY_DSN;

    if (sentryDsn) {
      try {
        Sentry.init({ dsn: sentryDsn });
      } catch (error) {
        sentryDsn = undefined;
      }
    }

    return function (exception, cause) {
      if (sentryDsn) {
        Sentry.captureException(exception, { cause: cause });
      }
      $delegate(exception, cause);
    };
  };
  $provide.decorator('$exceptionHandler', ['$delegate', errorDelegation]);
}];

/***/ }),
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    errors: '<'
  },
  template: __webpack_require__(1039)
};

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help-text ng-messages=$ctrl.errors> <div ng-message=\"email, api.email\" class=c-form__field__error>Please enter a valid email address</div> <div ng-message=\"url, api.url\" class=c-form__field__error>Please enter a valid URL</div> <div ng-message=\"required, api.required\" class=c-form__field__error>Please enter a value</div> <div ng-message=\"passwordMatch, api.password, api.passwordMatch\" class=c-form__field__error>Password and confirmation do not match</div> <div ng-message=\"mimetypes, api.validation.mimetypes\" class=c-form__field__error>Please select a valid file type</div> <div ng-message=pattern class=c-form__field__error>Please enter a valid pattern</div> <div ng-message=\"slug, api.unique\" class=c-form__field__error>That URL has already been taken, please enter a unique value.</div> <div ng-message=\"maximum, api.maximum\" class=c-form__field__error>Please enter a value less than the maximum value</div> <div ng-message=\"minimum, api.minimum\" class=c-form__field__error>Please enter a value greater than the minimum value</div> <div ng-message=\"unique, api.unique\" class=c-form__field__error>Please enter a unique value</div> <div ng-message=\"maxlength, api.validation.max.string\" class=c-form__field__error>Please enter a shorter value</div> </div> ";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    error: '@',
    statusCode: '@'
  },
  template: __webpack_require__(1041)
};

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = "<main> <div class=c-error-page> <h1 class=c-error-page__status-code>{{$ctrl.statusCode}}</h1> <h3 class=c-error-page__error>{{$ctrl.error}}</h3> </div> </main>";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var authStorageService = function authStorageService() {

  var setAccessToken = function setAccessToken(accessToken) {
    return localStorage.setItem('access_token', accessToken);
  };
  var getAccessToken = function getAccessToken() {
    return localStorage.getItem('access_token');
  };
  var resetAccessToken = function resetAccessToken() {
    return localStorage.removeItem('access_token');
  };

  var setProfile = function setProfile(profile) {
    return localStorage.setItem('profile', JSON.stringify(profile));
  };
  var getProfile = function getProfile() {
    return JSON.parse(localStorage.getItem('profile'));
  };
  var resetProfile = function resetProfile() {
    return localStorage.removeItem('profile');
  };

  var resetAll = function resetAll() {
    resetAccessToken();
    resetProfile();
  };

  return {
    setAccessToken: setAccessToken,
    getAccessToken: getAccessToken,
    resetAccessToken: resetAccessToken,
    setProfile: setProfile,
    getProfile: getProfile,
    resetProfile: resetProfile,
    resetAll: resetAll
  };
};

authStorageService.$inject = [];

exports.default = authStorageService;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var authService = function authService(auth0Service, authStorageService, tokenHandlerService) {
  var logout = function logout() {
    authStorageService.resetAll();

    return auth0Service.logout();
  };

  var forceLogin = function forceLogin() {
    authStorageService.resetAll();

    return auth0Service.authorize();
  };

  var checkLoggedIn = function checkLoggedIn() {
    return auth0Service.checkSession().then(tokenHandlerService.handleTokens).catch(forceLogin);
  };

  var getAccessToken = function getAccessToken() {
    return authStorageService.getAccessToken();
  };
  var getProfile = function getProfile() {
    return authStorageService.getProfile();
  };
  var handleTokensHash = function handleTokensHash() {
    return tokenHandlerService.handleTokensHash();
  };

  return {
    logout: logout,
    forceLogin: forceLogin,
    checkLoggedIn: checkLoggedIn,
    getAccessToken: getAccessToken,
    getProfile: getProfile,
    handleTokensHash: handleTokensHash
  };
};

authService.$inject = ['auth0Service', 'authStorageService', 'tokenHandlerService'];

exports.default = authService;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AuthInterceptor = function AuthInterceptor($state, authService) {
  return {
    request: function request(_request) {
      var token = authService.getAccessToken();

      if (token) {
        _request.headers = _request.headers || {};
        _request.headers.Authorization = 'Bearer ' + token;
      }

      return _request;
    },
    responseError: function responseError(error) {
      switch (error.status) {
        case 403:
          return $state.go('403', {}, { location: false });
        case 401:
          return authService.forceLogin();
        default:
          throw error;
      }
    }
  };
};

AuthInterceptor.$inject = ['$state', 'authService'];

exports.default = AuthInterceptor;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var authTransitionsService = function authTransitionsService($transitions, authService) {
  return {
    init: function init() {
      $transitions.onStart({}, function (transition) {
        if (transition.to().auth !== false) {
          return authService.checkLoggedIn();
        }
      });
    }
  };
};

authTransitionsService.$inject = ['$transitions', 'authService'];

exports.default = authTransitionsService;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth0Js = __webpack_require__(74);

var _auth0Js2 = _interopRequireDefault(_auth0Js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auth0ClientFactory = function auth0ClientFactory(configService) {
  return {
    build: function build() {
      return configService.load().then(function () {
        var config = {
          clientID: configService.get('auth0.clientId'),
          domain: configService.get('auth0.domain'),
          audience: configService.get('appUrl') + '/api',
          scope: 'openid profile email',
          responseType: 'token id_token',
          redirectUri: configService.get('appUrl') + '/loading'
        };

        return new _auth0Js2.default.WebAuth(config);
      });
    }
  };
};

auth0ClientFactory.$inject = ['configService'];

exports.default = auth0ClientFactory;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Wrapper for auth0-js
 * 
 * Exposes the relevant methods needed for authentication and makes sure promises 
 * are returned.
 */
var auth0Service = function auth0Service(auth0ClientFactory) {
  return {
    checkSession: function checkSession() {
      return auth0ClientFactory.build().then(function (auth0) {
        return new Promise(function (resolve, reject) {
          auth0.checkSession({}, function (error, result) {
            return error ? reject(error) : resolve(result);
          });
        });
      });
    },
    authorize: function authorize() {
      return auth0ClientFactory.build().then(function (auth0) {
        return auth0.authorize();
      });
    },
    logout: function logout() {
      return auth0ClientFactory.build().then(function (auth0) {
        return auth0.logout();
      });
    },
    changePassword: function changePassword(email) {
      var options = {
        connection: 'Username-Password-Authentication',
        email: email
      };

      return auth0ClientFactory.build().then(function (auth0) {
        return new Promise(function (resolve, reject) {
          return auth0.changePassword(options, function (error, result) {
            return error ? reject(error) : resolve(result);
          });
        });
      });
    },
    parseHash: function parseHash(options) {
      return auth0ClientFactory.build().then(function (auth0) {
        return new Promise(function (resolve, reject) {
          auth0.parseHash(options, function (error, result) {
            return error ? reject(error) : resolve(result);
          });
        });
      });
    }
  };
};

auth0Service.$inject = ['auth0ClientFactory'];

exports.default = auth0Service;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var tokenHandlerService = function tokenHandlerService($location, authStorageService, auth0Service) {

  var handleTokensHash = function handleTokensHash() {
    return auth0Service.parseHash({ hash: $location.hash() }).then(handleTokens);
  };

  var handleTokens = function handleTokens(result) {
    if (!result) {
      throw {
        error: 'missing_tokens',
        errorDescription: 'URL does not contain the access and ID tokens.'
      };
    }

    var profile = (0, _lodash.merge)(authStorageService.getProfile(), transformProfile(result.idTokenPayload));

    authStorageService.setAccessToken(result.accessToken);
    authStorageService.setProfile(profile);

    return profile;
  };

  var transformProfile = function transformProfile(idTokenPayload) {
    var propertyPrefix = 'https://www.lobby.travel/';

    var profile = {};

    (0, _lodash.forIn)(idTokenPayload, function (value, key) {
      key = key.startsWith(propertyPrefix) ? key.substring(propertyPrefix.length) : key;

      profile[key] = value;
    });

    return profile;
  };

  return {
    handleTokensHash: handleTokensHash,
    handleTokens: handleTokens
  };
};

tokenHandlerService.$inject = ['$location', 'authStorageService', 'auth0Service'];

exports.default = tokenHandlerService;

/***/ })
]),[341]);


// WEBPACK FOOTER //
// main-0accb6068f24c73a9719.js